import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  DateOnly: { input: any; output: any; }
  Any: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  ValidatePassword: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  /** Obtiene un item de acordeón filtrando por el ID del bloque padre y el subtype del item */
  accordionBlockItemBySubtype?: Maybe<PageAccordionBlockItem>;
  /** Obtiene todos los ancestros de un item de acordeón */
  accordionItemAncestors: Array<PageAccordionBlockItem>;
  /** Obtiene todos los descendientes de un item de acordeón */
  accordionItemDescendants: Array<PageAccordionBlockItem>;
  activeLoginSlides: Array<CarouselSlide>;
  activeSlidesByType: Array<CarouselSlide>;
  allCarouselSlides: Array<CarouselSlide>;
  allSeoMetadata: Array<SeoMetadata>;
  allSeoMetadataCount: MetadataPagination;
  /** Analiza documentos para migración entre listas, devolviendo información de schemas y sugerencias de mapeo */
  analyzeMigration: MigrationAnalysisResponse;
  approvalJwt: AuthResponse;
  audit: Audit;
  auditClient: AuditClient;
  auditClientData: AuditClientData;
  auditClientDataByObjectId: Array<AuditClientData>;
  audits: Array<Audit>;
  auditsClient: Array<AuditClientView>;
  auditsClientCount: MetadataPagination;
  auditsCount: MetadataPagination;
  auth0JWT: Auth0Response;
  auth0Url: Auth0Detail;
  cabinetBlockItems: Array<PageCabinetBlockItem>;
  cabinetBlockItemsCount: MetadataPagination;
  CabinetDetail: CabinetDetail;
  CabinetDetails: Array<CabinetDetail>;
  CabinetDetailsCount: MetadataPagination;
  canDependencyEditSchema: Scalars['Boolean']['output'];
  /** Verifica si el usuario actual tiene permisos para editar una página dinámica por ID o slug. Usado para mostrar botón de acceso rápido en vista pública. */
  canEditPageDynamic: CanEditPageDynamicResult;
  canUserAccessContentSchema: Scalars['Boolean']['output'];
  carouselSlideById?: Maybe<CarouselSlide>;
  /** Verifica si un slug está disponible */
  checkSlugAvailability: SlugAvailabilityResponse;
  childDocuments: Array<DocumentEntity>;
  cities: Array<City>;
  city: City;
  codeRecoverPassword: Scalars['String']['output'];
  /** Obtener un departamento por código DANE */
  colombiaDepartment?: Maybe<GeographicElementType>;
  /** Obtener todos los departamentos de Colombia */
  colombiaDepartments: Array<GeographicElementType>;
  /** Obtener municipios de un departamento específico */
  colombiaMunicipalities: Array<GeographicElementType>;
  /** retrieval of contentsearch record by id */
  content: ContentSearch;
  /** list of contentsearchs records */
  contents: Array<ContentSearch>;
  contentSchema: ContentSchema;
  contentSchemaDependencies: Array<ContentSchemaDependency>;
  contentSchemaDependenciesCount: MetadataPagination;
  contentSchemaDependency: ContentSchemaDependency;
  contentSchemaField: ContentSchemaField;
  contentSchemaFields: Array<ContentSchemaField>;
  contentSchemaFieldsCount: MetadataPagination;
  contentSchemas: Array<ContentSchema>;
  contentSchemasCount: MetadataPagination;
  contentSharing: ContentSharing;
  contentSharings: Array<ContentSharing>;
  contentSharingsCount: MetadataPagination;
  ContentTag: ContentTag;
  ContentTags: Array<ContentTag>;
  ContentTagsCount: MetadataPagination;
  countries: Array<Country>;
  country: Country;
  department: Department;
  departments: Array<Department>;
  dependencies: Array<Dependency>;
  dependenciesCount: MetadataPagination;
  dependenciesEnableByUserId: Array<Dependency>;
  dependency: Dependency;
  /** Diagnostica inconsistencias en orderIndex de bloques. Use dryRun=true para solo diagnosticar, dryRun=false para corregir. */
  diagnosePageBlockOrderIndexes: OrderIndexDiagnosticResult;
  document: DocumentEntity;
  documentMetadata: DocumentMetadata;
  documentMetadatas: Array<DocumentMetadata>;
  documentMetadatasCount: MetadataPagination;
  documents: Array<DocumentEntity>;
  documentsCount: MetadataPagination;
  documentType: DocumentType;
  documentTypes: Array<DocumentType>;
  documentTypesCount: MetadataPagination;
  documentWithChildren?: Maybe<DocumentEntity>;
  dummies: Array<Dummy>;
  dummiesCount: MetadataPagination;
  dummy: Dummy;
  editor: Editor;
  editors: Array<Editor>;
  /** Get the count of editors assigned to a specific PageDynamic */
  editorsCount: Scalars['Int']['output'];
  /** @deprecated Use subPageBlocks query instead */
  event: Array<SubPageUnionTypes>;
  eventsItem: EventsItem;
  /** Buscar evento por slug SEO */
  eventsItemBySlug?: Maybe<EventsItem>;
  eventsItems: Array<EventsItem>;
  eventsItemsByContentSchema: Array<EventsItem>;
  eventsItemsCount: MetadataPagination;
  /** Buscar eventos con filtros avanzados (dependencyId, contentSchemaId, tags, where, orderBy, pagination) */
  eventsItemsFiltered: Array<EventsItem>;
  eventTags: Array<Scalars['String']['output']>;
  exportTemplate: Scalars['String']['output'];
  file: FileInfo;
  findActiveContentSchemas: Array<ContentSchema>;
  findContentSchemasByType: Array<ContentSchema>;
  findDocumentsByFileType: Array<DocumentEntity>;
  findEventGroupSchemas: Array<ContentSchema>;
  findNewsGroupSchemas: Array<ContentSchema>;
  findPageAllBlocksEnum: Array<DefaultPageBlockModel>;
  findPageBlockByDynamic: Array<PageBlock>;
  findPageBlockByPageVersion: PageBlock;
  findPageBlockEnum: Array<DefaultPageBlockModel>;
  findSchemasByMultipleDependencies: Array<ContentSchema>;
  findTemplatesByUser: Array<UserTemplate>;
  footer: Array<FooterBlockUnion>;
  functionalities: Array<Functionality>;
  functionalitiesCount: MetadataPagination;
  functionalitiesTree: FunctionalityModel;
  functionality: Functionality;
  getAllDependenciesBySchema: Array<Dependency>;
  getAssignmentsByContentSchema: Array<UserContentSchemaAssignment>;
  getAssignmentsByUser: Array<UserContentSchemaAssignment>;
  /** Retrieves the raw JSON content from MongoDB GridFS for a specific history entries */
  getComparativeJsonFromHistory: Array<Scalars['String']['output']>;
  getContentSchemasByUserAndDependency: Array<ContentSchema>;
  /**
   * Get hierarchical document counts grouped by schema fields with isGroup flag
   * @deprecated This query is deprecated. Use getGroupingCountsFromDocuments instead, which provides better performance and more flexible filtering options.
   */
  getDocumentGroupingCounts: DocumentGroupingResult;
  /** Get hierarchical document counts grouped by schema fields with isGroup flag */
  getGroupingCountsFromDocuments: DocumentGroupingResult;
  /** Retrieves the raw JSON content from MongoDB GridFS for a specific history entries */
  getPageDynamicFromHistory: PageDynamic;
  getSchemasByDependency: Array<ContentSchema>;
  /** Get simple document counts for a single grouping field */
  getSimpleDocumentGroupCounts: Array<GroupedDocumentCount>;
  getTemplateUsers: Array<UserTemplate>;
  getUserProfile: User;
  /** Obtiene los usuarios que tienen y no tienen una dependencia específica */
  getUsersByDependency: UsersByDependencyModel;
  getUserTemplates: Array<UserTemplate>;
  getUserTemplatesForApplication: Array<PageDynamic>;
  group: Group;
  groups: Array<Group>;
  groupsCount: MetadataPagination;
  header: Array<HeaderBlockUnion>;
  hierarchicalDocuments: HierarchicalDocumentPagination;
  hierarchyStats: HierarchyStats;
  histories: Array<History>;
  historiesCount: MetadataPagination;
  history: History;
  /** @deprecated Use subPageBlocks query instead */
  institutionalProgram: Array<SubPageUnionTypes>;
  institutionalProgramsItem: InstitutionalProgramsItem;
  institutionalProgramsItems: Array<InstitutionalProgramsItem>;
  institutionalProgramsItemsCount: MetadataPagination;
  mainPage: Array<MainBlockUnion>;
  /** Obtiene los bloques de una página dinámica por ID o slug */
  mainPageDynamic: Array<PageBlockUnion>;
  /** Obtener un bloque de mapa por ID */
  mapBlock?: Maybe<PageMapBlock>;
  /** Obtener lista de bloques de mapa con filtros opcionales */
  mapBlocks: Array<PageMapBlock>;
  /** Agrupa y cuenta valores de metadata por esquema y campo específico */
  metadataValueGroups: MetadataValueGroupResponse;
  multiKeyRegister: MultikeyRegister;
  multiKeyRegisters: Array<MultikeyRegister>;
  multiKeyRegistersCount: MetadataPagination;
  mySharedContent: Array<ContentSharing>;
  mySharedContentCount: MetadataPagination;
  myTemplates: Array<PageDynamic>;
  myTemplatesCount: MetadataPagination;
  /** Obtiene todos los ancestros (padres, abuelos, etc.) de un item de navegación */
  navigationItemAncestors: Array<NavigationItem>;
  /** Obtiene todos los descendientes (hijos, nietos, etc.) de un item de navegación */
  navigationItemDescendants: Array<NavigationItem>;
  /** Obtiene todos los elementos de navegación que tienen GIF de lenguaje de señas */
  navigationItemsWithSignLanguage: Array<NavigationItem>;
  /** Obtiene el árbol completo de navegación en una sola query optimizada. Retorna items de primer nivel con children pre-poblados recursivamente. */
  navigationTree: Array<NavigationItem>;
  /** Obtiene el árbol completo de navegación incluyendo items inactivos (para administración). */
  navigationTreeAdmin: Array<NavigationItem>;
  navItem: NavigationItem;
  navItems: Array<NavigationItem>;
  navItemsCount: MetadataPagination;
  newsItem: NewsItem;
  /** Buscar noticia por slug SEO */
  newsItemBySlug?: Maybe<NewsItem>;
  newsItems: Array<NewsItem>;
  newsItemsByContentSchema: Array<NewsItem>;
  newsItemsCount: MetadataPagination;
  /** Filtrar noticias por dependencyId y/o contentSchemaId */
  newsItemsFiltered: Array<NewsItem>;
  newsTags: Array<Scalars['String']['output']>;
  notification: Notification;
  notificationConfig: NotificationConfig;
  notificationConfigs: Array<NotificationConfig>;
  notificationConfigsCount: MetadataPagination;
  NotificationGroup: NotificationGroup;
  NotificationGroups: Array<NotificationGroup>;
  NotificationGroupsCount: MetadataPagination;
  notifications: Array<Notification>;
  notificationsCount: MetadataPagination;
  objectTypesEnabled: Array<ObjectTypeInfo>;
  pageBlock: PageBlockUnion;
  pageBlockItem: PageBlockItemUnion;
  pageBlockItems: Array<PageBlockItemUnion>;
  pageBlocks: Array<PageBlockUnion>;
  pageBlockSimple: PageBlock;
  /** Obtiene una página dinámica por ID o slug */
  pageDynamic?: Maybe<PageDynamic>;
  /** Buscar página dinámica por slug SEO */
  pageDynamicBySlug?: Maybe<PageDynamic>;
  pageDynamicJsonTree: Scalars['String']['output'];
  pageDynamics: Array<PageDynamic>;
  pageDynamicsCount: MetadataPagination;
  pageLink: PageLink;
  pageLinks: Array<PageLink>;
  pageLinksCount: MetadataPagination;
  /** retrieval of pagestyledtableblockrow record by id */
  pageStyledTableBlockRow: PageStyledTableBlockRow;
  /** list of pagestyledtableblockrows records */
  pageStyledTableBlockRows: Array<PageStyledTableBlockRow>;
  pageVersion: PageVersion;
  pageVersions: Array<PageVersion>;
  pageVersionsCount: MetadataPagination;
  /** pagination of contentsearch */
  paginationContents: PaginationResult;
  /** pagination of pagestyledtableblockrow */
  paginationPageStyledTableBlockRows: PaginationResult;
  parameter: Parameter;
  parameterByCod: Parameter;
  parameters: Array<Parameter>;
  parametersCount: MetadataPagination;
  parametersDefault?: Maybe<Array<Parameter>>;
  parentDocuments: Array<DocumentEntity>;
  /** @deprecated Use subPageBlocks query instead */
  participate: Array<SubPageUnionTypes>;
  position: Position;
  positions: Array<Position>;
  positionsCount: MetadataPagination;
  /** @deprecated Use subPageBlocks query instead */
  pqrsdf: Array<SubPageUnionTypes>;
  /** @deprecated Use subPageBlocks query instead */
  pressroom: Array<SubPageUnionTypes>;
  procedure: Procedure;
  procedures: Array<Procedure>;
  proceduresCount: MetadataPagination;
  proceduresTags: Array<Scalars['String']['output']>;
  profile: Profile;
  profiles: Array<Profile>;
  profilesCount: MetadataPagination;
  quotationsWithItems: HierarchicalDocumentPagination;
  regulation: Regulation;
  /** Get aggregated counts of regulations grouped by Year, Month, or Dependency */
  regulationGroupedCounts: Array<AggregatedCountResult>;
  /** @deprecated Use regulationGroupedCounts with groupBy: MONTH instead */
  regulationMonths: Array<RegulationMonthsModel>;
  regulations: Array<Regulation>;
  regulationsCount: MetadataPagination;
  /** @deprecated Use regulationGroupedCounts with groupBy: YEAR/MONTH/DEPENDENCY instead */
  regulationTotals: Array<RegulationTotalsModel>;
  /** @deprecated Use regulationGroupedCounts with groupBy: YEAR instead */
  regulationYears: Array<RegulationYearsModel>;
  /** @deprecated Use regulationGroupedCounts with groupBy: YEAR and pagination instead */
  regulationYearsCount: MetadataPagination;
  revalidate: AuthResponse;
  role: Role;
  roleFx: RoleFx;
  roles: Array<Role>;
  rolesCount: MetadataPagination;
  rolesFx: Array<RoleFx>;
  rolesFxCount: MetadataPagination;
  sacConnection: Scalars['String']['output'];
  searchFunctionalities: Array<FunctionalityModel>;
  sentryTest: Scalars['String']['output'];
  /** Vista previa de entidades sin SEO (NewsItem, EventsItem, PageDynamic, DocumentEntity, Regulation). No realiza cambios. */
  seoBackfillPreview: SeoBackfillPreviewDto;
  seoMetadata: SeoMetadata;
  seoMetadataBySlug?: Maybe<SeoMetadata>;
  server: Server;
  servers: Array<Server>;
  serversCount: MetadataPagination;
  /** Obtener documentos compartidos con una dependencia específica */
  sharedDocumentsWithDependency: Array<DocumentEntity>;
  /** Obtener eventos compartidos con una dependencia específica */
  sharedEventsWithDependency: Array<EventsItem>;
  /** Obtener noticias compartidas con una dependencia específica */
  sharedNewsWithDependency: Array<NewsItem>;
  sharedTemplates: Array<PageDynamic>;
  sliderItem: SliderItem;
  sliderItems: Array<SliderItem>;
  sliderItemsCount: MetadataPagination;
  /** @deprecated Use subPageBlocks query instead */
  subPage: Array<SubPageUnionTypes>;
  subPageBlocks: Array<SubPageUnionTypes>;
  /** @deprecated Use subPageBlocks query instead */
  subpageprocedure: Array<SubPageUnionTypes>;
  /** @deprecated Use subPageBlocks query instead */
  subpageregulation: Array<SubPageUnionTypes>;
  templateFolders: Array<PageDynamic>;
  templates: Array<PageDynamic>;
  templatesByUser: Array<PageDynamic>;
  templateSharedUsers: Array<UserTemplate>;
  templatesInFolder: Array<PageDynamic>;
  templatesInFolderCount: MetadataPagination;
  /** @deprecated Use subPageBlocks query instead */
  transparency: Array<SubPageUnionTypes>;
  user: User;
  userContentSchemaAssignment: UserContentSchemaAssignment;
  userContentSchemaAssignments: Array<UserContentSchemaAssignment>;
  userContentSchemaAssignmentsCount: MetadataPagination;
  userDependencies: Array<UserDependency>;
  userDependenciesCount: MetadataPagination;
  userDependency: UserDependency;
  /** Get all PageDynamic pages that a user can edit */
  userEditablePages: Array<Editor>;
  userRequest: UserRequest;
  userRequests: Array<UserRequest>;
  userRequestsCount: MetadataPagination;
  users: Array<User>;
  usersCount: MetadataPagination;
  userTemplate: UserTemplate;
  userTemplates: Array<UserTemplate>;
  userTemplatesCount: MetadataPagination;
  validateClonePageVersion: ActionCloneVersion;
  /** Valida todos los items de navegación de un PageNavigationBar y retorna un reporte con errores y advertencias */
  validateNavigationBar: NavigationValidationReport;
  validateUserRequest?: Maybe<UserRequest>;
  validateUserToken: User;
  version: PageVersion;
};


export type QueryAccordionBlockItemBySubtypeArgs = {
  blockId: Scalars['ID']['input'];
  subtype: RegulationType;
};


export type QueryAccordionItemAncestorsArgs = {
  itemId: Scalars['ID']['input'];
};


export type QueryAccordionItemDescendantsArgs = {
  itemId: Scalars['ID']['input'];
};


export type QueryActiveSlidesByTypeArgs = {
  type: CarouselSlideType;
};


export type QueryAllCarouselSlidesArgs = {
  orderBy?: InputMaybe<Array<FindCarouselSlideOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindCarouselSlideWhere>;
};


export type QueryAllSeoMetadataArgs = {
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindSeoMetadataWhere>;
};


export type QueryAllSeoMetadataCountArgs = {
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindSeoMetadataWhere>;
};


export type QueryAnalyzeMigrationArgs = {
  input: MigrationAnalysisInput;
};


export type QueryApprovalJwtArgs = {
  approvalTokenInput: ApprovalTokenInput;
};


export type QueryAuditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditClientDataArgs = {
  auditClientDataInput: AuditClientDataInput;
};


export type QueryAuditClientDataByObjectIdArgs = {
  auditClientDataByOcjectIdInput: AuditClientDataByOcjectIdInput;
};


export type QueryAuditsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryAuditsClientArgs = {
  orderBy?: InputMaybe<Array<FindAuditClientsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindAuditClientsWhere>;
};


export type QueryAuditsClientCountArgs = {
  orderBy?: InputMaybe<Array<FindAuditClientsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindAuditClientsWhere>;
};


export type QueryAuditsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryAuth0JwtArgs = {
  Auth0Token: Scalars['String']['input'];
};


export type QueryAuth0UrlArgs = {
  params: UrlParamsInput;
};


export type QueryCabinetBlockItemsArgs = {
  orderBy?: InputMaybe<Array<FindCabinetItemOrderBy>>;
  pageBlockId: Scalars['ID']['input'];
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindCabinetItemWhere>;
};


export type QueryCabinetBlockItemsCountArgs = {
  orderBy?: InputMaybe<Array<FindCabinetItemOrderBy>>;
  pageBlockId: Scalars['ID']['input'];
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindCabinetItemWhere>;
};


export type QueryCabinetDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCabinetDetailsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryCabinetDetailsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryCanDependencyEditSchemaArgs = {
  dependencyId: Scalars['String']['input'];
  schemaId: Scalars['String']['input'];
};


export type QueryCanEditPageDynamicArgs = {
  pageDynamicId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanUserAccessContentSchemaArgs = {
  contentSchemaId: Scalars['String']['input'];
  dependencies: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryCarouselSlideByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckSlugAvailabilityArgs = {
  input: CheckSlugAvailabilityInput;
};


export type QueryChildDocumentsArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  parentId: Scalars['String']['input'];
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryCitiesArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<OrderTypes>;
};


export type QueryCityArgs = {
  departmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryCodeRecoverPasswordArgs = {
  codeRecoverPasswordInput: CodeRecoverPasswordInput;
};


export type QueryColombiaDepartmentArgs = {
  code: Scalars['String']['input'];
};


export type QueryColombiaMunicipalitiesArgs = {
  departmentCode: Scalars['String']['input'];
};


export type QueryContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentsArgs = {
  orderBy?: InputMaybe<Array<FindContentSearchOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSearchWhere>;
};


export type QueryContentSchemaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSchemaDependenciesArgs = {
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentSchemaDependencyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentSchemaDependencyWhere>;
};


export type QueryContentSchemaDependenciesCountArgs = {
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentSchemaDependencyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentSchemaDependencyWhere>;
};


export type QueryContentSchemaDependencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSchemaFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSchemaFieldsArgs = {
  orderBy?: InputMaybe<Array<FindContentSchemaFieldOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSchemaFieldWhere>;
};


export type QueryContentSchemaFieldsCountArgs = {
  orderBy?: InputMaybe<Array<FindContentSchemaFieldOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSchemaFieldWhere>;
};


export type QueryContentSchemasArgs = {
  contentTypeFilter?: InputMaybe<TypeContent>;
  dependencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyName?: InputMaybe<Scalars['String']['input']>;
  descriptionFilter?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindContentSchemaOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSchemaWhere>;
};


export type QueryContentSchemasCountArgs = {
  contentTypeFilter?: InputMaybe<TypeContent>;
  dependencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyName?: InputMaybe<Scalars['String']['input']>;
  descriptionFilter?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindContentSchemaOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSchemaWhere>;
};


export type QueryContentSharingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSharingsArgs = {
  orderBy?: InputMaybe<Array<FindContentSharingOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSharingWhere>;
};


export type QueryContentSharingsCountArgs = {
  orderBy?: InputMaybe<Array<FindContentSharingOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSharingWhere>;
};


export type QueryContentTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentTagsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryContentTagsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryCountriesArgs = {
  orderBy?: InputMaybe<OrderTypes>;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDepartmentArgs = {
  countryId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDepartmentsArgs = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<OrderTypes>;
};


export type QueryDependenciesArgs = {
  orderBy?: InputMaybe<Array<FindDependencyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindDependencyWhere>;
};


export type QueryDependenciesCountArgs = {
  orderBy?: InputMaybe<Array<FindDependencyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindDependencyWhere>;
};


export type QueryDependencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiagnosePageBlockOrderIndexesArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentMetadataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentMetadatasArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryDocumentMetadatasCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryDocumentsArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryDocumentsCountArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryDocumentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentTypesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryDocumentTypesCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryDocumentWithChildrenArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
};


export type QueryDummiesArgs = {
  orderBy?: InputMaybe<Array<FindDummyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindDummyWhere>;
};


export type QueryDummiesCountArgs = {
  orderBy?: InputMaybe<Array<FindDummyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindDummyWhere>;
};


export type QueryDummyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEditorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEditorsArgs = {
  orderBy?: InputMaybe<Array<FindEditorOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindEditorWhere>;
};


export type QueryEditorsCountArgs = {
  includeInactive?: Scalars['Boolean']['input'];
  pageDynamicId: Scalars['String']['input'];
};


export type QueryEventsItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventsItemBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEventsItemsArgs = {
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindEventOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindEventWhere>;
};


export type QueryEventsItemsByContentSchemaArgs = {
  contentSchemaId: Scalars['String']['input'];
};


export type QueryEventsItemsCountArgs = {
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindEventOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindEventWhere>;
};


export type QueryEventsItemsFilteredArgs = {
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<FilterEventOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<FilterEventWhere>;
};


export type QueryExportTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindContentSchemasByTypeArgs = {
  contentType: TypeContent;
  dependencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyName?: InputMaybe<Scalars['String']['input']>;
  descriptionFilter?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<ContentSchemaByTypeOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<ContentSchemaByTypeWhere>;
};


export type QueryFindDocumentsByFileTypeArgs = {
  mimeType: Scalars['String']['input'];
};


export type QueryFindPageAllBlocksEnumArgs = {
  blockLocations?: InputMaybe<Array<BlockLocation>>;
};


export type QueryFindPageBlockByDynamicArgs = {
  dynamicId: Scalars['ID']['input'];
};


export type QueryFindPageBlockByPageVersionArgs = {
  blockId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type QueryFindSchemasByMultipleDependenciesArgs = {
  dependencyIds: Array<Scalars['String']['input']>;
};


export type QueryFindTemplatesByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryFunctionalitiesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryFunctionalitiesCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryFunctionalityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllDependenciesBySchemaArgs = {
  schemaId: Scalars['String']['input'];
};


export type QueryGetAssignmentsByContentSchemaArgs = {
  contentSchemaId: Scalars['String']['input'];
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetAssignmentsByUserArgs = {
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};


export type QueryGetComparativeJsonFromHistoryArgs = {
  firstHistoryId: Scalars['String']['input'];
  secondHistoryId: Scalars['String']['input'];
};


export type QueryGetContentSchemasByUserAndDependencyArgs = {
  dependencies: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryGetDocumentGroupingCountsArgs = {
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  groupingSort?: InputMaybe<GroupingSort>;
  maxGroupingLevels?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataSearch?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  publishDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  schemaFieldId: Scalars['String']['input'];
  schemaFieldsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetGroupingCountsFromDocumentsArgs = {
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  groupingSort?: InputMaybe<GroupingSort>;
  maxGroupingLevels?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<Pagination>;
  schemaFieldId: Scalars['String']['input'];
  schemaFieldsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindDocumentGroupingWhereNormalized>;
};


export type QueryGetPageDynamicFromHistoryArgs = {
  historyId: Scalars['String']['input'];
  pageDynamicId: Scalars['String']['input'];
};


export type QueryGetSchemasByDependencyArgs = {
  dependencyId: Scalars['String']['input'];
};


export type QueryGetSimpleDocumentGroupCountsArgs = {
  filters?: InputMaybe<DocumentGroupingInput>;
  schemaFieldId: Scalars['String']['input'];
};


export type QueryGetTemplateUsersArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetUsersByDependencyArgs = {
  dependencyId: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGroupsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryHierarchicalDocumentsArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  expandAll?: InputMaybe<Scalars['Boolean']['input']>;
  flattenResult?: InputMaybe<Scalars['Boolean']['input']>;
  includeStats?: InputMaybe<Scalars['Boolean']['input']>;
  loadMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  maxChildrenCount?: InputMaybe<Scalars['Int']['input']>;
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  minChildrenCount?: InputMaybe<Scalars['Int']['input']>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  rootParentId?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  specificParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryHierarchyStatsArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryHistoriesArgs = {
  orderBy?: InputMaybe<Array<FindHistoryOrderBy>>;
  pageDynamicId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindHistoryWhere>;
};


export type QueryHistoriesCountArgs = {
  orderBy?: InputMaybe<Array<FindHistoryOrderBy>>;
  pageDynamicId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindHistoryWhere>;
};


export type QueryHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstitutionalProgramsItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstitutionalProgramsItemsArgs = {
  orderBy?: InputMaybe<Array<FindInstitutionalProgramsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindInstitutionalProgramsItemWhere>;
};


export type QueryInstitutionalProgramsItemsCountArgs = {
  orderBy?: InputMaybe<Array<FindInstitutionalProgramsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindInstitutionalProgramsItemWhere>;
};


export type QueryMainPageDynamicArgs = {
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapBlockArgs = {
  id: Scalars['String']['input'];
};


export type QueryMapBlocksArgs = {
  departmentCode?: InputMaybe<Scalars['String']['input']>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mapType?: InputMaybe<MapType>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMetadataValueGroupsArgs = {
  schemaFieldId: Scalars['String']['input'];
  schemaId: Scalars['String']['input'];
};


export type QueryMultiKeyRegisterArgs = {
  id: MultikeyRegisterIdInput;
};


export type QueryMultiKeyRegistersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryMultiKeyRegistersCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryMySharedContentArgs = {
  contentType: ContentType;
  orderBy?: InputMaybe<Array<FindMySharedContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindMySharedContentWhere>;
};


export type QueryMySharedContentCountArgs = {
  contentType: ContentType;
  orderBy?: InputMaybe<Array<FindMySharedContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindMySharedContentWhere>;
};


export type QueryMyTemplatesArgs = {
  orderBy?: InputMaybe<Array<FindMyTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindMyTemplatesWhere>;
};


export type QueryMyTemplatesCountArgs = {
  orderBy?: InputMaybe<Array<FindMyTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindMyTemplatesWhere>;
};


export type QueryNavigationItemAncestorsArgs = {
  itemId: Scalars['ID']['input'];
};


export type QueryNavigationItemDescendantsArgs = {
  itemId: Scalars['ID']['input'];
};


export type QueryNavigationTreeArgs = {
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  navigationBarId: Scalars['ID']['input'];
};


export type QueryNavigationTreeAdminArgs = {
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  navigationBarId: Scalars['ID']['input'];
};


export type QueryNavItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNavItemsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNavItemsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNewsItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsItemBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryNewsItemsArgs = {
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindNewsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<FindNewsWhere>;
};


export type QueryNewsItemsByContentSchemaArgs = {
  contentSchemaId: Scalars['String']['input'];
};


export type QueryNewsItemsCountArgs = {
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindNewsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<FindNewsWhere>;
};


export type QueryNewsItemsFilteredArgs = {
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<FilterNewsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  targetDependencyId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<FilterNewsWhere>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationConfigsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationConfigsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationGroupsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationGroupsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryObjectTypesEnabledArgs = {
  orderBy?: InputMaybe<ObjectTypesEnabledArgsOrderBy>;
  where?: InputMaybe<ObjectTypesEnabledArgsWhere>;
};


export type QueryPageBlockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageBlockItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageBlockItemsArgs = {
  orderBy?: InputMaybe<Array<FindPageBlockItemsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentId: Scalars['ID']['input'];
  positionOrder?: InputMaybe<OrderTypes>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<FindPageBlockItemsWhere>;
};


export type QueryPageBlocksArgs = {
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  locations: Array<BlockLocation>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  subPage?: InputMaybe<SubPages>;
  versionId: Scalars['ID']['input'];
};


export type QueryPageBlockSimpleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageDynamicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageDynamicBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPageDynamicJsonTreeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageDynamicsArgs = {
  orderBy?: InputMaybe<Array<FindPageDynamicsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPageDynamicsWhere>;
};


export type QueryPageDynamicsCountArgs = {
  orderBy?: InputMaybe<Array<FindPageDynamicsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPageDynamicsWhere>;
};


export type QueryPageLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageLinksArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryPageLinksCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryPageStyledTableBlockRowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageStyledTableBlockRowsArgs = {
  pagination?: InputMaybe<Pagination>;
  styledTableBlockId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PageStyledTableBlockRowWhere>;
};


export type QueryPageVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageVersionsArgs = {
  orderBy?: InputMaybe<Array<FindPageVersionsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPageVersionsWhere>;
};


export type QueryPageVersionsCountArgs = {
  orderBy?: InputMaybe<Array<FindPageVersionsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPageVersionsWhere>;
};


export type QueryPaginationContentsArgs = {
  orderBy?: InputMaybe<Array<FindContentSearchOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSearchWhere>;
};


export type QueryPaginationPageStyledTableBlockRowsArgs = {
  pagination?: InputMaybe<Pagination>;
  styledTableBlockId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PageStyledTableBlockRowWhere>;
};


export type QueryParameterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParameterByCodArgs = {
  code: Scalars['String']['input'];
};


export type QueryParametersArgs = {
  orderBy?: InputMaybe<Array<FindParametersOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindParametersWhere>;
};


export type QueryParametersCountArgs = {
  orderBy?: InputMaybe<Array<FindParametersOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindParametersWhere>;
};


export type QueryParentDocumentsArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryPositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPositionsArgs = {
  orderBy?: InputMaybe<Array<FindPositionOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPositionWhere>;
};


export type QueryPositionsCountArgs = {
  orderBy?: InputMaybe<Array<FindPositionOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPositionWhere>;
};


export type QueryProcedureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProceduresArgs = {
  orderBy?: InputMaybe<Array<FindProceduresOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<FindProceduresWhere>;
};


export type QueryProceduresCountArgs = {
  orderBy?: InputMaybe<Array<FindProceduresOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<FindProceduresWhere>;
};


export type QueryProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProfilesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryProfilesCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryQuotationsWithItemsArgs = {
  calculateTotals?: InputMaybe<Scalars['Boolean']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  expandAll?: InputMaybe<Scalars['Boolean']['input']>;
  flattenResult?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemDetails?: InputMaybe<Scalars['Boolean']['input']>;
  includeStats?: InputMaybe<Scalars['Boolean']['input']>;
  loadMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  maxChildrenCount?: InputMaybe<Scalars['Int']['input']>;
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  minChildrenCount?: InputMaybe<Scalars['Int']['input']>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  quotationNumber?: InputMaybe<Scalars['String']['input']>;
  quotationStatus?: InputMaybe<Scalars['String']['input']>;
  rootParentId?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  specificParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QueryRegulationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegulationGroupedCountsArgs = {
  args: RegulationAggregationArgs;
};


export type QueryRegulationMonthsArgs = {
  args?: InputMaybe<FindRegulationYearsArgs>;
};


export type QueryRegulationsArgs = {
  dependency?: InputMaybe<StringFilter>;
  month?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FindRegulationsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  types: Array<RegulationType>;
  where?: InputMaybe<FindRegulationsWhere>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRegulationsCountArgs = {
  dependency?: InputMaybe<StringFilter>;
  month?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FindRegulationsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  types: Array<RegulationType>;
  where?: InputMaybe<FindRegulationsWhere>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRegulationTotalsArgs = {
  args?: InputMaybe<FindRegulationYearsArgs>;
};


export type QueryRegulationYearsArgs = {
  args?: InputMaybe<FindRegulationYearsArgs>;
};


export type QueryRegulationYearsCountArgs = {
  args?: InputMaybe<FindRegulationYearsArgs>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoleFxArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  orderBy?: InputMaybe<Array<FindRolesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindRolesWhere>;
};


export type QueryRolesCountArgs = {
  orderBy?: InputMaybe<Array<FindRolesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindRolesWhere>;
};


export type QueryRolesFxArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryRolesFxCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QuerySearchFunctionalitiesArgs = {
  searchInput: SearchFunctionalityInput;
};


export type QuerySeoMetadataArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeoMetadataBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryServerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryServersCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QuerySharedDocumentsWithDependencyArgs = {
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy>>;
  onlyChildDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  onlyParentDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FindContentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentDocumentIdFilter?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['String']['input']>;
  publishDateTo?: InputMaybe<Scalars['String']['input']>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  userIdFilter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindContentWhere>;
};


export type QuerySharedEventsWithDependencyArgs = {
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindEventOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FindEventWhere>;
};


export type QuerySharedNewsWithDependencyArgs = {
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<FilterNewsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  targetDependencyId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<FilterNewsWhere>;
};


export type QuerySharedTemplatesArgs = {
  orderBy?: InputMaybe<Array<FindSharedTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindSharedTemplatesWhere>;
};


export type QuerySliderItemArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySliderItemsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QuerySliderItemsCountArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QuerySubPageArgs = {
  subPage: SubPages;
};


export type QuerySubPageBlocksArgs = {
  locations: Array<BlockLocation>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  subPage?: InputMaybe<SubPages>;
};


export type QueryTemplatesByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTemplateSharedUsersArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryTemplatesInFolderArgs = {
  folderId: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<FindMyTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindMyTemplatesWhere>;
};


export type QueryTemplatesInFolderCountArgs = {
  folderId: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<FindMyTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindMyTemplatesWhere>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserContentSchemaAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserContentSchemaAssignmentsArgs = {
  orderBy?: InputMaybe<Array<FindUserContentSchemaAssignmentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUserContentSchemaAssignmentWhere>;
};


export type QueryUserContentSchemaAssignmentsCountArgs = {
  orderBy?: InputMaybe<Array<FindUserContentSchemaAssignmentOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUserContentSchemaAssignmentWhere>;
};


export type QueryUserDependenciesArgs = {
  orderBy?: InputMaybe<Array<FindUserDependencyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUserDependencyWhere>;
};


export type QueryUserDependenciesCountArgs = {
  orderBy?: InputMaybe<Array<FindUserDependencyOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUserDependencyWhere>;
};


export type QueryUserDependencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserEditablePagesArgs = {
  activeOnly?: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type QueryUserRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserRequestsArgs = {
  orderBy?: InputMaybe<Array<FindUserRequestsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUserRequestsWhere>;
};


export type QueryUserRequestsCountArgs = {
  orderBy?: InputMaybe<Array<FindUserRequestsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUserRequestsWhere>;
};


export type QueryUsersArgs = {
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindUsersOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUsersWhere>;
};


export type QueryUsersCountArgs = {
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindUsersOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindUsersWhere>;
};


export type QueryUserTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTemplatesArgs = {
  orderBy?: InputMaybe<Array<FindUserTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  showCurrentUserTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FindUserTemplatesWhere>;
};


export type QueryUserTemplatesCountArgs = {
  orderBy?: InputMaybe<Array<FindUserTemplatesOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  showCurrentUserTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FindUserTemplatesWhere>;
};


export type QueryValidateClonePageVersionArgs = {
  createInput: ClonePageVersionInput;
};


export type QueryValidateNavigationBarArgs = {
  navigationBarId: Scalars['ID']['input'];
};


export type QueryValidateUserRequestArgs = {
  validateUserRequestInput: ValidateUserRequestInput;
};


export type QueryValidateUserTokenArgs = {
  validateTokenInput: ValidateTokenInput;
};

export enum RegulationType {
  Accountability = 'Accountability',
  Circular = 'Circular',
  Decree = 'Decree',
  InstitutionalAchievements = 'InstitutionalAchievements',
  Legal = 'Legal',
  Project = 'Project'
}

export type PageAccordionBlockItem = {
  __typename?: 'PageAccordionBlockItem';
  configJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['String']['output']>;
  indexTitle?: Maybe<Scalars['String']['output']>;
  lft?: Maybe<Scalars['Int']['output']>;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageAccordionBlock;
  previousVersion?: Maybe<PageBlockItem>;
  rgt?: Maybe<Scalars['Int']['output']>;
  schema?: Maybe<ContentSchema>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  subtype?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageLink = {
  __typename?: 'PageLink';
  arguments?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dynamicPageSlugs?: Maybe<Array<SeoMetadata>>;
  id: Scalars['ID']['output'];
  routeNavigation?: Maybe<SubPages>;
  routeType?: Maybe<RouterType>;
  target?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoMetadata = {
  __typename?: 'SeoMetadata';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  language: Language;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  seo: Seo;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Idiomas soportados para metadata SEO */
export enum Language {
  /** English */
  En = 'EN',
  /** Español */
  Es = 'ES'
}

export type Seo = {
  __typename?: 'Seo';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Documento asociado (solo una de estas cinco estará poblada) */
  document?: Maybe<DocumentEntity>;
  /** Evento asociado (solo una de estas cinco estará poblada) */
  eventItem?: Maybe<EventsItem>;
  id: Scalars['ID']['output'];
  metadata: Array<SeoMetadata>;
  /** Noticia asociada (solo una de estas cinco estará poblada) */
  newsItem?: Maybe<NewsItem>;
  /** Página dinámica asociada (solo una de estas cinco estará poblada) */
  pageDynamic?: Maybe<PageDynamic>;
  /** Regulación asociada (solo una de estas cinco estará poblada) */
  regulation?: Maybe<Regulation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentEntity = {
  __typename?: 'DocumentEntity';
  children: Array<DocumentEntity>;
  childrenCount: Scalars['Int']['output'];
  contentDate?: Maybe<Scalars['DateOnly']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  description?: Maybe<Scalars['String']['output']>;
  downloadCount?: Maybe<Scalars['String']['output']>;
  downloadText?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<FileInfo>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isParentDocument?: Maybe<Scalars['Boolean']['output']>;
  metadata: Array<DocumentMetadata>;
  migrationMetadata?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  nestingLevel?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<DocumentEntity>;
  publishDate?: Maybe<Scalars['DateOnly']['output']>;
  schema?: Maybe<ContentSchema>;
  /** Campo compilado con todos los metadatos para búsqueda full-text optimizada */
  searchableMetadata?: Maybe<Scalars['String']['output']>;
  /** Metadata SEO del documento (incluye slug) */
  seo?: Maybe<Seo>;
  sharedWith: Array<ContentSharing>;
  status: ContentStatus;
  tags?: Maybe<Array<ContentTag>>;
  thumbnailImage?: Maybe<FileInfo>;
  title: Scalars['String']['output'];
  type: TypeContent;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type Dependency = {
  __typename?: 'Dependency';
  countUser: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Field of the dependency name */
  name: Scalars['String']['output'];
  /** Field of the dependency status */
  status: DependencyStatus;
  /** Field of the dependency type */
  type: DependencyType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DependencyStatus {
  Active = 'Active',
  Canceled = 'Canceled'
}

export enum DependencyType {
  Main = 'Main',
  Secondary = 'Secondary'
}

export type FileInfo = {
  __typename?: 'FileInfo';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileExtension: Scalars['String']['output'];
  fileMode: FileModes;
  fileMongoId?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum FileModes {
  Buffer = 'buffer',
  Mongo = 'mongo',
  Url = 'url'
}

export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  document: DocumentEntity;
  id: Scalars['ID']['output'];
  jsonValue?: Maybe<Scalars['String']['output']>;
  schemaField: ContentSchemaField;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ContentSchemaField = {
  __typename?: 'ContentSchemaField';
  createdAt: Scalars['DateTime']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fieldLabel: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldType: FieldType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  isRequired: Scalars['Boolean']['output'];
  options?: Maybe<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  schema: ContentSchema;
  updatedAt: Scalars['DateTime']['output'];
  validationRules?: Maybe<Scalars['String']['output']>;
};

/** Tipos de campos disponibles para los esquemas de contenido */
export enum FieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  File = 'FILE',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Url = 'URL'
}

export type ContentSchema = {
  __typename?: 'ContentSchema';
  allDependencies: Array<Dependency>;
  allowChildren: Scalars['Boolean']['output'];
  childrenSchemas: Array<ContentSchema>;
  contentCount: Scalars['Int']['output'];
  contentType?: Maybe<TypeContent>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  dependencyCount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<ContentSchemaField>;
  hierarchyLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxNestingLevel: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentSchema?: Maybe<ContentSchema>;
  primaryDependency?: Maybe<Dependency>;
  schemaDependencies?: Maybe<Array<ContentSchemaDependency>>;
  updatedAt: Scalars['DateTime']['output'];
  userContentSchemaAssignments?: Maybe<Array<UserContentSchemaAssignment>>;
};

/** The content types available in the system */
export enum TypeContent {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Events = 'EVENTS',
  Image = 'IMAGE',
  News = 'NEWS',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type ContentSchemaDependency = {
  __typename?: 'ContentSchemaDependency';
  canEdit: Scalars['Boolean']['output'];
  contentSchema: ContentSchema;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency: Dependency;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserContentSchemaAssignment = {
  __typename?: 'UserContentSchemaAssignment';
  canAssociateAnyDependency: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  contentSchema: ContentSchema;
  contentSchemaId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependencies?: Maybe<Array<Scalars['String']['output']>>;
  dependency: Dependency;
  dependencyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['String']['output']>;
  attemptsCycles: Scalars['Float']['output'];
  city?: Maybe<City>;
  contents?: Maybe<Array<ContentEntity>>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  credentialsExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  dateIssue?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  dependencies: Array<Dependency>;
  email: Scalars['String']['output'];
  emailVerification: Scalars['Boolean']['output'];
  fullName: Scalars['String']['output'];
  hasExpiredCredentials: Scalars['Boolean']['output'];
  hasRural?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<UserDocumentTypes>;
  initials: Scalars['String']['output'];
  lastFailedAttemptDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalRepresentative?: Maybe<Scalars['String']['output']>;
  legalRepresentativeIdentificationNumber?: Maybe<Scalars['String']['output']>;
  legalRepresentativeIdentificationType?: Maybe<UserDocumentTypes>;
  loginAttempts: Scalars['Float']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passwordStatus: PasswordStatusTypes;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneVerification: Scalars['Boolean']['output'];
  position?: Maybe<Position>;
  profileImage?: Maybe<FileInfo>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  secondSurname?: Maybe<Scalars['String']['output']>;
  status: UserStatusTypes;
  temporalPassword?: Maybe<Scalars['Boolean']['output']>;
  type: UserTypes;
  updatedAt: Scalars['DateTime']['output'];
  userContentSchemaAssignments?: Maybe<Array<UserContentSchemaAssignment>>;
  userDependencies: Array<UserDependency>;
  userRoles?: Maybe<Array<UserRole>>;
};

export type City = {
  __typename?: 'City';
  code: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Department = {
  __typename?: 'Department';
  code: Scalars['Int']['output'];
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContentEntity = {
  __typename?: 'ContentEntity';
  contentDate?: Maybe<Scalars['DateOnly']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  migrationMetadata?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['DateOnly']['output']>;
  schema?: Maybe<ContentSchema>;
  /** Campo compilado con todos los metadatos para búsqueda full-text optimizada */
  searchableMetadata?: Maybe<Scalars['String']['output']>;
  status: ContentStatus;
  tags?: Maybe<Array<ContentTag>>;
  title: Scalars['String']['output'];
  type: TypeContent;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/** Estados disponibles para el contenido */
export enum ContentStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Published = 'PUBLISHED'
}

export type ContentTag = {
  __typename?: 'ContentTag';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum UserDocumentTypes {
  CitizenshipCard = 'CitizenshipCard',
  DiplomaticCard = 'DiplomaticCard',
  ForeignerIdentityCard = 'ForeignerIdentityCard',
  IdentityCard = 'IdentityCard',
  Nit = 'Nit',
  Passport = 'Passport',
  SafeConduct = 'SafeConduct',
  SpecialPermissionToStay = 'SpecialPermissionToStay',
  TemporaryProtectionPermit = 'TemporaryProtectionPermit'
}

export enum PasswordStatusTypes {
  Current = 'Current',
  Temporal = 'Temporal'
}

export type Position = {
  __typename?: 'Position';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime']['output'];
  defaultForType?: Maybe<UserTypes>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  roleFx: Array<RoleFx>;
  status: RoleStatusTypes;
  updatedAt: Scalars['DateTime']['output'];
  userRoles?: Maybe<Array<UserRole>>;
  users: Array<User>;
};

export enum UserTypes {
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  User = 'User'
}

export type RoleFx = {
  __typename?: 'RoleFx';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  permission: Scalars['String']['output'];
  role?: Maybe<Role>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RoleStatusTypes {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type UserRole = {
  __typename?: 'UserRole';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<Role>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export enum UserStatusTypes {
  Active = 'Active',
  Inactive = 'Inactive',
  PartlyActive = 'PartlyActive',
  PermanentlyInactive = 'PermanentlyInactive',
  TemporarilyInactive = 'TemporarilyInactive'
}

export type UserDependency = {
  __typename?: 'UserDependency';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency: Dependency;
  id: Scalars['ID']['output'];
  status: UserDependencyStatus;
  /** Field of the user dependency type */
  type?: Maybe<UserDependencyType>;
  /** Type name of the user dependency */
  typeName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export enum UserDependencyStatus {
  Active = 'Active',
  Canceled = 'Canceled'
}

/** Tipos de dependencia de usuario */
export enum UserDependencyType {
  Admin = 'Admin',
  Editor = 'Editor'
}

export type ContentSharing = {
  __typename?: 'ContentSharing';
  /** ID of the content being shared (computed from contentType) */
  contentId: Scalars['String']['output'];
  /** Type of content being shared */
  contentType: ContentType;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<DocumentEntity>;
  documentId?: Maybe<Scalars['String']['output']>;
  eventItem?: Maybe<EventsItem>;
  eventItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newsItem?: Maybe<NewsItem>;
  newsItemId?: Maybe<Scalars['String']['output']>;
  /** Date and time when the content was shared */
  sharedAt: Scalars['DateTime']['output'];
  /** User who shared the content */
  sharedBy: User;
  /** Optional notes about the sharing */
  sharingNotes?: Maybe<Scalars['String']['output']>;
  /** Dependency that receives the shared content */
  targetDependency?: Maybe<Dependency>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Types of content that can be shared between dependencies */
export enum ContentType {
  /** Documents that can be shared */
  Document = 'DOCUMENT',
  /** Events that can be shared */
  Event = 'EVENT',
  /** News items/articles that can be shared */
  News = 'NEWS'
}

export type EventsItem = {
  __typename?: 'EventsItem';
  address?: Maybe<Scalars['String']['output']>;
  alternativeText?: Maybe<Scalars['String']['output']>;
  contentSchema?: Maybe<ContentSchema>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  descriptionPlace?: Maybe<Scalars['String']['output']>;
  dynamicView?: Maybe<Scalars['Boolean']['output']>;
  emailEvent?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  eventItemDescription?: Maybe<Scalars['String']['output']>;
  eventItemTags: Array<Scalars['String']['output']>;
  eventItemTitle: Scalars['String']['output'];
  eventStatus?: Maybe<EventStates>;
  groupEvent?: Maybe<Scalars['String']['output']>;
  hasRecurring?: Maybe<PageEventFrequency>;
  hasShare?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  latitude?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  longitude?: Maybe<Scalars['String']['output']>;
  multimediaType?: Maybe<MultimediaTypes>;
  paymentTypeEvent?: Maybe<EventPaymentType>;
  phoneEvent?: Maybe<Scalars['String']['output']>;
  seeMore?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<Seo>;
  sharedWith: Array<ContentSharing>;
  shareIcon?: Maybe<FileInfo>;
  shareLink?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  typeEvent?: Maybe<EvenType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EventStates {
  Active = 'Active',
  Draft = 'Draft',
  Expired = 'Expired',
  Inactive = 'Inactive'
}

export enum PageEventFrequency {
  Eventual = 'Eventual',
  Indefinite = 'Indefinite',
  Recurrent = 'Recurrent'
}

export enum MultimediaTypes {
  Image = 'Image',
  SinMultimedia = 'SinMultimedia',
  Video = 'Video'
}

export enum EventPaymentType {
  Free = 'Free',
  Paid = 'Paid'
}

export enum EvenType {
  InPerson = 'InPerson',
  Virtual = 'Virtual'
}

export type NewsItem = {
  __typename?: 'NewsItem';
  alternativeText?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contentSchema?: Maybe<ContentSchema>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  /** @deprecated Campo deprecado */
  dateImages?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  expiredDate?: Maybe<Scalars['DateTime']['output']>;
  /** Indica si la noticia tiene fecha de vencimiento. true = vence, false = no vence (permanente) */
  hasExpirationDate: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  /** @deprecated Campo deprecado */
  imageLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Campo deprecado */
  link?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  multimediaType?: Maybe<MultimediaTypes>;
  newsItemTags: Array<Scalars['String']['output']>;
  newsStatus?: Maybe<VersionStates>;
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<Seo>;
  sharedWith: Array<ContentSharing>;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum VersionStates {
  Active = 'Active',
  Draft = 'Draft',
  Inactive = 'Inactive',
  Published = 'Published'
}

export type PageDynamic = {
  __typename?: 'PageDynamic';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['String']['output']>;
  blocks: Array<PageBlock>;
  children: Array<PageDynamic>;
  configJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  description?: Maybe<Scalars['String']['output']>;
  editors: Array<Editor>;
  histories: Array<History>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<PageDynamic>;
  seo?: Maybe<Seo>;
  sharedUsers?: Maybe<Array<UserTemplate>>;
  status: VersionStates;
  type: PageDynamicType;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Float']['output'];
};

export type PageBlock = {
  __typename?: 'PageBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export enum BlockLocation {
  Dynamic = 'Dynamic',
  Footer = 'Footer',
  Header = 'Header',
  Main = 'Main',
  Sub = 'Sub'
}

export enum PageBlockStyles {
  A = 'A',
  B = 'B',
  C = 'C'
}

export enum SubPages {
  Cabinet = 'Cabinet',
  Events = 'Events',
  Home = 'Home',
  InstitutionalPrograms = 'InstitutionalPrograms',
  Newsletter = 'Newsletter',
  Participate = 'Participate',
  Pqrsdf = 'Pqrsdf',
  PressRoom = 'PressRoom',
  Procedures = 'Procedures',
  Regulation = 'Regulation',
  Sns = 'Sns',
  Transparency = 'Transparency'
}

export type PageVersion = {
  __typename?: 'PageVersion';
  consecutive?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pageBlocks?: Maybe<Array<PageBlock>>;
  previousVersion?: Maybe<PageVersion>;
  state: VersionStates;
  theme: Theme;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export enum Theme {
  BlueDark = 'BlueDark',
  ElfGreen = 'ElfGreen',
  Gold = 'Gold',
  GreenDark = 'GreenDark',
  Marine = 'Marine',
  Orange = 'Orange',
  RadicalRed = 'RadicalRed',
  Shiraz = 'Shiraz'
}

export type Editor = {
  __typename?: 'Editor';
  /** Date and time when the user was assigned as editor */
  assignedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this editor assignment is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Optional notes about this editor assignment */
  notes?: Maybe<Scalars['String']['output']>;
  /** The PageDynamic page this user can edit */
  pageDynamic?: Maybe<PageDynamic>;
  updatedAt: Scalars['DateTime']['output'];
  /** The user assigned as editor for this page */
  user?: Maybe<User>;
};

export type History = {
  __typename?: 'History';
  /** The history entry this entry is based on */
  basedOn?: Maybe<History>;
  /** The user who made this change */
  changedBy?: Maybe<User>;
  /** Generated consecutive */
  consecutive?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** MongoDB ObjectId reference for JSON version data */
  dataId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** IP address from which the change was made */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** The PageDynamic page this history entry belongs to */
  pageDynamic: PageDynamic;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserTemplate = {
  __typename?: 'UserTemplate';
  accessType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  template: PageDynamic;
  templateId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export enum PageDynamicType {
  DynamicPage = 'DynamicPage',
  Microsite = 'Microsite',
  Template = 'Template',
  TemplateFolder = 'TemplateFolder'
}

export type Regulation = {
  __typename?: 'Regulation';
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use documentDate instead */
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  description: Scalars['String']['output'];
  /** Fecha de expedición del documento */
  documentDate: Scalars['DateOnly']['output'];
  downloadText?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FileInfo>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  linkItem?: Maybe<PageLink>;
  pageLinkDocument?: Maybe<PageLink>;
  /** Fecha de publicación del documento */
  publishDate?: Maybe<Scalars['DateOnly']['output']>;
  regulationStatus?: Maybe<VersionStates>;
  /** Metadata SEO de la regulación (incluye slug) */
  seo?: Maybe<Seo>;
  title: Scalars['String']['output'];
  type: RegulationType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RouterType {
  BpmWorkflow = 'BPMWorkflow',
  DynamicPage = 'DynamicPage',
  ExternalRoute = 'ExternalRoute',
  InternalRouteWithArguments = 'InternalRouteWithArguments',
  InternaltRoute = 'InternaltRoute',
  Microsite = 'Microsite',
  NoAction = 'NoAction'
}

export type PageAccordionBlock = {
  __typename?: 'PageAccordionBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  /** IDs de dependencias para filtrar el contenido del acordeón. Si está vacío o null, muestra contenido de todas las dependencias. */
  filterDependencyIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  /** Número de dígitos por nivel en el índice jerárquico (ej: 1, 2, 3). Nuevos bloques usan 3, legacy usa 2. */
  indexDigitLength?: Maybe<Scalars['Int']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageAccordionBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showDownloadButton?: Maybe<Scalars['Boolean']['output']>;
  showTitle: Scalars['Boolean']['output'];
  showViewButton?: Maybe<Scalars['Boolean']['output']>;
  subPages?: Maybe<Array<SubPages>>;
  subtype?: Maybe<TypeAccordion>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export enum TypeAccordion {
  DynamicList = 'DynamicList',
  Regulation = 'Regulation',
  Static = 'Static'
}

export type PageBlockItem = {
  __typename?: 'PageBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Estado de visibilidad del item */
export enum ItemStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type CarouselSlide = {
  __typename?: 'CarouselSlide';
  activeFrom: Scalars['DateTime']['output'];
  activeTo: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageFile?: Maybe<FileInfo>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAdminEnabled: Scalars['Boolean']['output'];
  slideId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CarouselSlideType;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

/** Tipos de carrusel disponibles en el sistema */
export enum CarouselSlideType {
  Dashboard = 'DASHBOARD',
  Login = 'LOGIN',
  Notification = 'NOTIFICATION'
}

export type FindCarouselSlideOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  displayOrder?: InputMaybe<OrderTypes>;
  slideId?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
  version?: InputMaybe<OrderTypes>;
};

export enum OrderTypes {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Pagination = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type FindCarouselSlideWhere = {
  _and?: InputMaybe<Array<FindCarouselSlideWhere>>;
  _or?: InputMaybe<Array<FindCarouselSlideWhere>>;
  activeFrom?: InputMaybe<DateFilter>;
  activeTo?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  isAdminEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slideId?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  version?: InputMaybe<StringFilter>;
};

export type DateFilter = {
  _between?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  _eq?: InputMaybe<Scalars['DateTime']['input']>;
  _gt?: InputMaybe<Scalars['DateTime']['input']>;
  _gte?: InputMaybe<Scalars['DateTime']['input']>;
  _in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  _lt?: InputMaybe<Scalars['DateTime']['input']>;
  _lte?: InputMaybe<Scalars['DateTime']['input']>;
  _neq?: InputMaybe<Scalars['DateTime']['input']>;
  _notbetween?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type StringFilter = {
  _contains?: InputMaybe<Scalars['String']['input']>;
  _endswith?: InputMaybe<Scalars['String']['input']>;
  _eq?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _notcontains?: InputMaybe<Scalars['String']['input']>;
  _notendswith?: InputMaybe<Scalars['String']['input']>;
  _notlike?: InputMaybe<Scalars['String']['input']>;
  _notstartswith?: InputMaybe<Scalars['String']['input']>;
  _startswith?: InputMaybe<Scalars['String']['input']>;
};

export type FindSeoMetadataWhere = {
  _and?: InputMaybe<Array<FindSeoMetadataWhere>>;
  _or?: InputMaybe<Array<FindSeoMetadataWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<StringFilter>;
  metaTitle?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type MetadataPagination = {
  __typename?: 'MetadataPagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type MigrationAnalysisInput = {
  /** Lista de documentos a analizar para migración */
  items: Array<MigrationAnalysisItemInput>;
};

export type MigrationAnalysisItemInput = {
  /** ID del documento a migrar (opcional si se proporciona fileId) */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** ID del archivo asociado al documento (opcional si se proporciona documentId) */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** ID del esquema (lista) origen */
  sourceSchemaId: Scalars['String']['input'];
  /** ID del esquema (lista) destino */
  targetSchemaId: Scalars['String']['input'];
};

export type MigrationAnalysisResponse = {
  __typename?: 'MigrationAnalysisResponse';
  message?: Maybe<Scalars['String']['output']>;
  results: Array<MigrationAnalysisResult>;
  success: Scalars['Boolean']['output'];
};

export type MigrationAnalysisResult = {
  __typename?: 'MigrationAnalysisResult';
  canMigrate: Scalars['Boolean']['output'];
  currentMetadata: Array<DocumentMetadataSummary>;
  document: DocumentSummary;
  sourceSchema: SchemaSummary;
  /** Sugerencias automáticas de mapeo basadas en nombres de campos */
  suggestedMappings?: Maybe<Array<FieldMappingSuggestion>>;
  targetSchema: SchemaSummary;
  /** Campos del esquema origen que no tienen correspondencia en destino */
  unmappedSourceFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Campos del esquema destino sin correspondencia (deberán quedar vacíos o usar default) */
  unmappedTargetFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Advertencias o problemas encontrados */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type DocumentMetadataSummary = {
  __typename?: 'DocumentMetadataSummary';
  fieldLabel: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  jsonValue?: Maybe<Scalars['String']['output']>;
  metadataId: Scalars['String']['output'];
  schemaFieldId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DocumentSummary = {
  __typename?: 'DocumentSummary';
  currentSchemaId?: Maybe<Scalars['String']['output']>;
  currentSchemaName?: Maybe<Scalars['String']['output']>;
  /** ID del archivo asociado (importante para preservar URL) */
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SchemaSummary = {
  __typename?: 'SchemaSummary';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<SchemaFieldSummary>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SchemaFieldSummary = {
  __typename?: 'SchemaFieldSummary';
  fieldLabel: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldType: FieldType;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** Opciones del campo (JSON) para SELECT/MULTISELECT */
  options?: Maybe<Scalars['String']['output']>;
};

export type FieldMappingSuggestion = {
  __typename?: 'FieldMappingSuggestion';
  /** Confianza del match (0-100) */
  confidence: Scalars['Float']['output'];
  /** Tipo de match: EXACT (mismo nombre), SIMILAR (nombre similar), MANUAL (sin sugerencia) */
  matchType: Scalars['String']['output'];
  sourceFieldId: Scalars['String']['output'];
  sourceFieldName: Scalars['String']['output'];
  targetFieldId: Scalars['String']['output'];
  targetFieldName: Scalars['String']['output'];
};

export type ApprovalTokenInput = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type Audit = {
  __typename?: 'Audit';
  action: StandardActions;
  auditClient?: Maybe<AuditClient>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  objectId?: Maybe<Scalars['ID']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  stackError?: Maybe<Scalars['String']['output']>;
  type: ActionTypeAudit;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  valueAfter?: Maybe<Scalars['String']['output']>;
  valueBefore?: Maybe<Scalars['String']['output']>;
};

export enum StandardActions {
  Auth = 'Auth',
  Cancel = 'Cancel',
  Create = 'Create',
  Error = 'Error',
  NotIdentified = 'NotIdentified',
  Read = 'Read',
  Remove = 'Remove',
  Report = 'Report',
  SoftRemove = 'SoftRemove',
  Update = 'Update'
}

export type AuditClient = {
  __typename?: 'AuditClient';
  actionType: StandardActions;
  audits?: Maybe<Array<Audit>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['ID']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  requestType: RequestType;
  status: StatusTypeAuditClient;
  type: TypeTypeAuditClient;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export enum RequestType {
  Graphql = 'Graphql',
  Http = 'Http',
  Rpc = 'Rpc',
  Ws = 'Ws'
}

export enum StatusTypeAuditClient {
  Error = 'Error',
  Succes = 'Succes'
}

export enum TypeTypeAuditClient {
  External = 'External',
  Internal = 'Internal'
}

export enum ActionTypeAudit {
  Error = 'Error',
  Log = 'Log'
}

export type AuditClientDataInput = {
  auditClientId: Scalars['ID']['input'];
};

export type AuditClientData = {
  __typename?: 'AuditClientData';
  auditClient: AuditClient;
  request: Scalars['Any']['output'];
  response?: Maybe<Scalars['Any']['output']>;
};

export type AuditClientDataByOcjectIdInput = {
  objectId: Scalars['ID']['input'];
};

export type FindAuditClientsOrderBy = {
  actionType?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  ip?: InputMaybe<OrderTypes>;
  message?: InputMaybe<OrderTypes>;
  objectId?: InputMaybe<OrderTypes>;
  objectType?: InputMaybe<OrderTypes>;
  requestType?: InputMaybe<OrderTypes>;
  status?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindAuditClientsWhere = {
  _and?: InputMaybe<Array<FindAuditClientsWhere>>;
  _or?: InputMaybe<Array<FindAuditClientsWhere>>;
  actionType?: InputMaybe<Array<StandardActions>>;
  createdAt?: InputMaybe<DateFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  ip?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  objectId?: InputMaybe<StringFilter>;
  objectType?: InputMaybe<StringFilter>;
  requestType?: InputMaybe<Array<RequestType>>;
  status?: InputMaybe<Array<StatusTypeAuditClient>>;
  type?: InputMaybe<Array<TypeTypeAuditClient>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type AuditClientView = {
  __typename?: 'AuditClientView';
  actionType: StandardActions;
  audits?: Maybe<Array<Audit>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  objectId?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  requestType: RequestType;
  status: StatusTypeAuditClient;
  type: TypeTypeAuditClient;
  updatedAt: Scalars['DateTime']['output'];
};

export type Auth0Response = {
  __typename?: 'Auth0Response';
  token?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UrlParamsInput = {
  redirectUri: Scalars['String']['input'];
  typeService: Auth0TypeService;
};

export enum Auth0TypeService {
  Apple = 'Apple',
  Github = 'Github',
  Google = 'Google',
  Microsoft = 'Microsoft'
}

export type Auth0Detail = {
  __typename?: 'Auth0Detail';
  auth0Token: Scalars['String']['output'];
};

export type FindCabinetItemOrderBy = {
  cabinetName?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
};

export type FindCabinetItemWhere = {
  _and?: InputMaybe<Array<FindCabinetItemWhere>>;
  _or?: InputMaybe<Array<FindCabinetItemWhere>>;
  cabinetName?: InputMaybe<StringFilter>;
};

export type PageCabinetBlockItem = {
  __typename?: 'PageCabinetBlockItem';
  alternativeText?: Maybe<Scalars['String']['output']>;
  cabinetDescription?: Maybe<Scalars['String']['output']>;
  cabinetDetails: Array<CabinetDetail>;
  cabinetEmail?: Maybe<Scalars['String']['output']>;
  cabinetImage?: Maybe<FileInfo>;
  /** @deprecated This field will now not be used */
  cabinetImageLink?: Maybe<Scalars['String']['output']>;
  cabinetName: Scalars['String']['output'];
  /** @deprecated This field will now not be used */
  cabinetOrder?: Maybe<Scalars['Int']['output']>;
  cabinetPhone?: Maybe<Scalars['String']['output']>;
  cabinetPosition?: Maybe<Position>;
  /** @deprecated This field will now not be used */
  cabinetStatus?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  curriculumVitaeLink?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageCabinetBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CabinetDetail = {
  __typename?: 'CabinetDetail';
  cabinetDetailImage?: Maybe<FileInfo>;
  cabinetDetailLink?: Maybe<PageLink>;
  cabinetDetailName?: Maybe<Scalars['String']['output']>;
  cabinetDetailStatus?: Maybe<VersionStates>;
  cabinetItem?: Maybe<PageCabinetBlockItem>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageCabinetBlock = {
  __typename?: 'PageCabinetBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  cabinetSeeMoreAction?: Maybe<Scalars['String']['output']>;
  cabinetSeeMoreActionLink?: Maybe<Scalars['String']['output']>;
  cabinetSubtitle?: Maybe<Scalars['String']['output']>;
  cabinetTitle: Scalars['String']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  extendedDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCarrousel?: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageCabinetBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

/** Resultado de verificación de permisos de edición para página dinámica */
export type CanEditPageDynamicResult = {
  __typename?: 'CanEditPageDynamicResult';
  canEdit: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type CheckSlugAvailabilityInput = {
  /** ID del contenido a excluir (para ediciones) */
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  /** Slug a verificar (será normalizado automáticamente) */
  slug: Scalars['String']['input'];
};

export type SlugAvailabilityResponse = {
  __typename?: 'SlugAvailabilityResponse';
  /** Información del contenido que ya usa este slug */
  conflict?: Maybe<SlugConflictInfo>;
  /** Si el slug está disponible o no */
  isAvailable: Scalars['Boolean']['output'];
  /** Slug normalizado que se usará en la URL */
  slug: Scalars['String']['output'];
};

export type SlugConflictInfo = {
  __typename?: 'SlugConflictInfo';
  /** ID del contenido en conflicto */
  contentId: Scalars['ID']['output'];
  /** Título del contenido en conflicto */
  contentTitle: Scalars['String']['output'];
  /** Tipo de contenido que usa el slug */
  contentType: SlugContentType;
  /** Fecha de creación del contenido en conflicto */
  createdAt: Scalars['DateTime']['output'];
  /** Nombre de la dependencia dueña del contenido */
  dependency?: Maybe<Scalars['String']['output']>;
  /** Idioma del contenido en conflicto */
  language: Language;
};

/** Tipos de contenido que pueden tener metadata SEO */
export enum SlugContentType {
  /** Documento */
  DocumentEntity = 'DocumentEntity',
  /** Evento */
  EventsItem = 'EventsItem',
  Microsite = 'Microsite',
  /** Noticia */
  NewsItem = 'NewsItem',
  /** Página dinámica */
  PageDynamic = 'PageDynamic'
}

export type MetadataFieldFilter = {
  /** ID del campo del schema */
  fieldId: Scalars['String']['input'];
  /** Valor a buscar en el metadata */
  metadataValue: Scalars['String']['input'];
  /** Lista de valores para búsqueda IN */
  metadataValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tipo de búsqueda a realizar (por defecto CONTAINS) */
  searchType?: InputMaybe<MetadataSearchType>;
};

/** Tipo de búsqueda para el metadata */
export enum MetadataSearchType {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Exact = 'EXACT',
  In = 'IN',
  StartsWith = 'STARTS_WITH'
}

export type MetadataFieldOrderBy = {
  /** ID del campo del schema */
  fieldId: Scalars['String']['input'];
  /** Tipo de ordenamiento ASC/DESC */
  order: OrderTypes;
  /** Prioridad del ordenamiento (menor número = mayor prioridad). Rango: 1-10 */
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type FindContentOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  description?: InputMaybe<OrderTypes>;
  publishDate?: InputMaybe<OrderTypes>;
  status?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindContentWhere = {
  _and?: InputMaybe<Array<FindContentWhere>>;
  _or?: InputMaybe<Array<FindContentWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  expirationDate?: InputMaybe<DateFilter>;
  includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  isParentDocument?: InputMaybe<Scalars['Boolean']['input']>;
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
  parentDocumentId?: InputMaybe<StringFilter>;
  publishDate?: InputMaybe<DateFilter>;
  schemaId?: InputMaybe<StringFilter>;
  /** Búsqueda optimizada en metadata compilada de documentos (soporta índices FULLTEXT) */
  searchableMetadata?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<ContentStatus>>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Array<TypeContent>>;
  updatedAt?: InputMaybe<DateFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CodeRecoverPasswordInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

/** Elemento geográfico (departamento o municipio) */
export type GeographicElementType = {
  __typename?: 'GeographicElementType';
  /** Punto central del elemento {lat, lng} (serializado) */
  centerPoint?: Maybe<Scalars['String']['output']>;
  /** Código DANE del elemento */
  code: Scalars['String']['output'];
  /** Geometría GeoJSON del elemento (serializada) */
  geometry?: Maybe<Scalars['String']['output']>;
  /** Nombre del elemento geográfico */
  name: Scalars['String']['output'];
};

export type ContentSearch = {
  __typename?: 'ContentSearch';
  createdAt: Scalars['DateTime']['output'];
  dependency?: Maybe<Dependency>;
  dependencyId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Fecha de publicación del contenido (startDate para eventos, publicationDate para noticias/trámites, publishDate para regulaciones/documentos) */
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Metadata compilada para búsqueda full-text (solo disponible para documentos) */
  searchableMetadata?: Maybe<Scalars['String']['output']>;
  /** Slug para redirección (solo disponible para eventos, noticias y páginas dinámicas) */
  slug?: Maybe<Scalars['String']['output']>;
  /** Estado del contenido (active, inactive, draft, published, expired, archived) */
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ContentSearchType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ContentSearchType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Dynamic = 'DYNAMIC',
  Event = 'EVENT',
  Image = 'IMAGE',
  New = 'NEW',
  Procedure = 'PROCEDURE',
  Regulation = 'REGULATION',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type FindContentSearchOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
};

export type FindContentSearchWhere = {
  _and?: InputMaybe<Array<FindContentSearchWhere>>;
  _or?: InputMaybe<Array<FindContentSearchWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  /** Filtro por ID de dependencia */
  dependencyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  /** Búsqueda global en title, description y searchableMetadata */
  globalSearch?: InputMaybe<Scalars['String']['input']>;
  metadataFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtro por fecha de publicación */
  publicationDate?: InputMaybe<DateFilter>;
  /** Búsqueda en metadata compilada de documentos (soporta FULLTEXT) */
  searchableMetadata?: InputMaybe<StringFilter>;
  /** Filtro por estado del contenido (Published, Draft, etc.) */
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type FindContentSchemaDependencyOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  isPrimary?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindContentSchemaDependencyWhere = {
  _and?: InputMaybe<Array<FindContentSchemaDependencyWhere>>;
  _or?: InputMaybe<Array<FindContentSchemaDependencyWhere>>;
  contentSchemaId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  dependencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FindContentSchemaFieldOrderBy = {
  fieldLabel?: InputMaybe<OrderTypes>;
  fieldName?: InputMaybe<OrderTypes>;
  fieldType?: InputMaybe<OrderTypes>;
  isActive?: InputMaybe<OrderTypes>;
  isGroup?: InputMaybe<OrderTypes>;
  isRequired?: InputMaybe<OrderTypes>;
  schemaId?: InputMaybe<OrderTypes>;
};

export type FindContentSchemaFieldWhere = {
  _and?: InputMaybe<Array<FindContentSchemaFieldWhere>>;
  _or?: InputMaybe<Array<FindContentSchemaFieldWhere>>;
  fieldLabel?: InputMaybe<StringFilter>;
  fieldName?: InputMaybe<StringFilter>;
  fieldType?: InputMaybe<FieldType>;
  isActive?: InputMaybe<NumberFilter>;
  isGroup?: InputMaybe<NumberFilter>;
  isRequired?: InputMaybe<NumberFilter>;
  schemaId?: InputMaybe<StringFilter>;
};

export type NumberFilter = {
  _between?: InputMaybe<Array<Scalars['Float']['input']>>;
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _notbetween?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FindContentSchemaOrderBy = {
  contentType?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindContentSchemaWhere = {
  _and?: InputMaybe<Array<FindContentSchemaWhere>>;
  _or?: InputMaybe<Array<FindContentSchemaWhere>>;
  contentType?: InputMaybe<Array<TypeContent>>;
  createdAt?: InputMaybe<DateFilter>;
  dependency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FindContentSharingOrderBy = {
  contentType?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  sharedAt?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindContentSharingWhere = {
  _and?: InputMaybe<Array<FindContentSharingWhere>>;
  _or?: InputMaybe<Array<FindContentSharingWhere>>;
  contentType?: InputMaybe<StringFilter>;
  documentId?: InputMaybe<StringFilter>;
  eventItemId?: InputMaybe<StringFilter>;
  newsItemId?: InputMaybe<StringFilter>;
  sharedById?: InputMaybe<StringFilter>;
  sharingNotes?: InputMaybe<StringFilter>;
  targetDependencyId?: InputMaybe<StringFilter>;
};

export type FindDependencyOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  status?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindDependencyWhere = {
  _and?: InputMaybe<Array<FindDependencyWhere>>;
  _or?: InputMaybe<Array<FindDependencyWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<DependencyStatus>>;
  type?: InputMaybe<Array<DependencyType>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type OrderIndexDiagnosticResult = {
  __typename?: 'OrderIndexDiagnosticResult';
  blocksAffected: Scalars['Int']['output'];
  details: Array<BlockGroupDiagnostic>;
  dryRun: Scalars['Boolean']['output'];
  groupsWithIssues: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  totalGroupsAnalyzed: Scalars['Int']['output'];
};

export type BlockGroupDiagnostic = {
  __typename?: 'BlockGroupDiagnostic';
  actualMaxIndex: Scalars['Int']['output'];
  currentIndexes: Array<Scalars['Int']['output']>;
  dynamicId?: Maybe<Scalars['String']['output']>;
  expectedMaxIndex: Scalars['Int']['output'];
  hasGaps: Scalars['Boolean']['output'];
  missingIndexes: Array<Scalars['Int']['output']>;
  totalBlocks: Scalars['Int']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  document: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FindDummyOrderBy = {
  firstField?: InputMaybe<OrderTypes>;
  secondField?: InputMaybe<OrderTypes>;
  thirdField?: InputMaybe<OrderTypes>;
};

export type FindDummyWhere = {
  _and?: InputMaybe<Array<FindDummyWhere>>;
  _or?: InputMaybe<Array<FindDummyWhere>>;
  firstField?: InputMaybe<StringFilter>;
  group?: InputMaybe<FindDummyGroupWhere>;
  secondField?: InputMaybe<DateFilter>;
  thirdField?: InputMaybe<NumberFilter>;
  type?: InputMaybe<FindDummyTypeWhere>;
};

export type FindDummyGroupWhere = {
  _and?: InputMaybe<Array<FindDummyGroupWhere>>;
  _or?: InputMaybe<Array<FindDummyGroupWhere>>;
  family?: InputMaybe<FindDummyFamilyWhere>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type FindDummyFamilyWhere = {
  _and?: InputMaybe<Array<FindDummyFamilyWhere>>;
  _or?: InputMaybe<Array<FindDummyFamilyWhere>>;
  description?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type FindDummyTypeWhere = {
  _and?: InputMaybe<Array<FindDummyTypeWhere>>;
  _or?: InputMaybe<Array<FindDummyTypeWhere>>;
  name?: InputMaybe<StringFilter>;
};

export type Dummy = {
  __typename?: 'Dummy';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstField: Scalars['String']['output'];
  group?: Maybe<DummyGroup>;
  id: Scalars['ID']['output'];
  items: Array<DummyItem>;
  notification?: Maybe<Notification>;
  phone: Scalars['String']['output'];
  secondField: Scalars['DateTime']['output'];
  thirdField: Scalars['Float']['output'];
  type?: Maybe<DummyType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DummyGroup = {
  __typename?: 'DummyGroup';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  family?: Maybe<DummyFamily>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DummyFamily = {
  __typename?: 'DummyFamily';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DummyItem = {
  __typename?: 'DummyItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dummy: Dummy;
  firstField: Scalars['String']['output'];
  fourthField: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  secondField: Scalars['DateTime']['output'];
  thirdField: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  externalMessage?: Maybe<Scalars['String']['output']>;
  hasPersistent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  notificationConfig: NotificationConfig;
  notificationGroup?: Maybe<NotificationGroup>;
  persistentExpiration?: Maybe<Scalars['DateTime']['output']>;
  stateNotification: StateNotification;
  statePersistent?: Maybe<StatePersistent>;
  type: TypeNotification;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type NotificationConfig = {
  __typename?: 'NotificationConfig';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailDuplicateCode?: Maybe<Scalars['ID']['output']>;
  emailPrincipalCode?: Maybe<Scalars['ID']['output']>;
  hasEmail: Scalars['Boolean']['output'];
  hasPersistent: Scalars['Boolean']['output'];
  hasPush: Scalars['Boolean']['output'];
  hasSms: Scalars['Boolean']['output'];
  hasTwoStepsEmail: Scalars['Boolean']['output'];
  hasTwoStepsPush: Scalars['Boolean']['output'];
  hasTwoStepsSms: Scalars['Boolean']['output'];
  hasTwoStepsWss: Scalars['Boolean']['output'];
  hasWss: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  persistentExpiration?: Maybe<Scalars['DateTime']['output']>;
  persistentHtml?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  smsBody?: Maybe<Scalars['String']['output']>;
  subtype: Scalars['String']['output'];
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
  wssCode?: Maybe<Scalars['ID']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  city: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  externalId: Scalars['ID']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  region: Scalars['Int']['output'];
  stateAws?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum NotificationType {
  Token = 'Token'
}

export type NotificationGroup = {
  __typename?: 'NotificationGroup';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  group: Group;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationConfig: NotificationConfig;
  stateNotificationGroup: StateNotificationGroup;
  typeNotificationGroup: TypeNotificationGroup;
  updatedAt: Scalars['DateTime']['output'];
};

export type Group = {
  __typename?: 'Group';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationConfig?: Maybe<NotificationConfig>;
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
};

export enum StateNotificationGroup {
  Complete = 'Complete',
  Draft = 'Draft',
  Error = 'Error',
  PartialComplete = 'PartialComplete',
  Process = 'Process'
}

export enum TypeNotificationGroup {
  Automatic = 'Automatic',
  Manual = 'Manual'
}

export enum StateNotification {
  Complete = 'Complete',
  Draft = 'Draft',
  Error = 'Error'
}

export enum StatePersistent {
  NoPersistent = 'NoPersistent',
  Open = 'Open',
  Receive = 'Receive',
  Send = 'Send'
}

export enum TypeNotification {
  Email = 'Email',
  Push = 'Push',
  Sms = 'Sms',
  Subscription = 'Subscription',
  Websocket = 'Websocket',
  Wss = 'Wss'
}

export type DummyType = {
  __typename?: 'DummyType';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FindEditorOrderBy = {
  /** Sort by assignment date */
  assignedAt?: InputMaybe<OrderTypes>;
  /** Sort by record creation date */
  createdAt?: InputMaybe<OrderTypes>;
  /** Sort by assignment active status */
  isActive?: InputMaybe<OrderTypes>;
  /** Sort by PageDynamic name */
  pageDynamicName?: InputMaybe<OrderTypes>;
  /** Sort by record last update date */
  updatedAt?: InputMaybe<OrderTypes>;
  /** Sort by user email */
  userEmail?: InputMaybe<OrderTypes>;
  /** Sort by user name */
  userName?: InputMaybe<OrderTypes>;
};

export type FindEditorWhere = {
  _and?: InputMaybe<Array<FindEditorWhere>>;
  _or?: InputMaybe<Array<FindEditorWhere>>;
  /** Filter by assignment date */
  assignedAt?: InputMaybe<DateFilter>;
  /** Filter by record creation date */
  createdAt?: InputMaybe<DateFilter>;
  /** Filter by assignment active status */
  isActive?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by assignment notes */
  notes?: InputMaybe<StringFilter>;
  /** Filter by PageDynamic ID */
  pageDynamic?: InputMaybe<StringFilter>;
  /** Filter by PageDynamic description */
  pageDynamicDescription?: InputMaybe<StringFilter>;
  /** Filter by PageDynamic name */
  pageDynamicName?: InputMaybe<StringFilter>;
  /** Filter by record last update date */
  updatedAt?: InputMaybe<DateFilter>;
  /** Filter by user email */
  userEmail?: InputMaybe<StringFilter>;
  /** Filter by user identification number */
  userIdentificationNumber?: InputMaybe<StringFilter>;
  /** Filter by user name */
  userName?: InputMaybe<StringFilter>;
};

export type SubPageUnionTypes = PageAccessibilityButton | PageAccordionBlock | PageAlertsBlock | PageAttentionLinesBlock | PageCabinetBlock | PageCustomBlock | PageEventsBlock | PageEventSliderBlock | PageInstitutionalProgramsSliderBlock | PageInstitutionalProgramsTypesBlock | PageMapBlock | PageNavigationBar | PageNewsletterBlock | PageParticipateDownloadBlock | PageParticipateElementBlock | PageParticipateHeaderBlock | PagePqrsdfActionBlock | PagePqrsdfConsultBlock | PagePressroomBlock | PageProcedureFeedbackBlock | PageProcedureHeaderBlock | PageProcedureMainBlock | PageProceduresBlock | PageQuickAccessBar | PageRegulationsBlock | PageSearchBlock | PageSliderBlock | PageSnsBlock | PageSocialNetworksBlock | PageStyledTableBlock | PageSubDownloadBlock | PageSubHeaderBlock | PageTaxesBlock | PageTransparencyBlock | PageTransparencyHeaderBlock;

/** Botones de accesibilidad flotantes */
export type PageAccessibilityButton = {
  __typename?: 'PageAccessibilityButton';
  blockTitle?: Maybe<Scalars['String']['output']>;
  /** Color del botón principal */
  buttonColor: Scalars['String']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  /** Estado de habilitación del bloque */
  isEnabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  /** Lista de botones de accesibilidad */
  items: Array<PageAccessibilityButtonItem>;
  location: BlockLocation;
  /** Máximo de items permitidos */
  maxItems: Scalars['Float']['output'];
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  /** Título del bloque de accesibilidad */
  title?: Maybe<Scalars['String']['output']>;
  /** Texto del tooltip al hacer hover */
  tooltipText?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageAccessibilityButtonItem = {
  __typename?: 'PageAccessibilityButtonItem';
  /** Texto alternativo para accesibilidad WCAG 2.1 */
  altText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Tipo de icono para el botón */
  iconType: AccessibilityIconType;
  id: Scalars['ID']['output'];
  /** Estado de activación del item */
  isActive: Scalars['Boolean']['output'];
  /** Configuración de enlace (RouterType + SubPages) */
  linkItem?: Maybe<PageLink>;
  /** Nombre descriptivo del enlace */
  linkName: Scalars['String']['output'];
  /** URL de respaldo (deprecated - usar linkItem) */
  linkUrl?: Maybe<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  parent: PageAccessibilityButton;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Tipos de iconos disponibles para botones de accesibilidad */
export enum AccessibilityIconType {
  Chart = 'CHART',
  Document = 'DOCUMENT',
  Email = 'EMAIL',
  Help = 'HELP',
  Home = 'HOME',
  Settings = 'SETTINGS',
  ThumbsUp = 'THUMBS_UP',
  User = 'USER'
}

/** Bloque de alertas informativas */
export type PageAlertsBlock = {
  __typename?: 'PageAlertsBlock';
  /** Tipo de acción del botón */
  actionType?: Maybe<ActionType>;
  /** Descripción detallada de la alerta (máximo 200 caracteres) */
  alertDescription?: Maybe<Scalars['String']['output']>;
  /** Estilo visual de la alerta */
  alertStyle: PageBlockStyles;
  /** Comportamiento del enlace */
  behaviorType?: Maybe<BehaviorType>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  /** Texto del botón de redirección (máximo 30 caracteres) */
  buttonTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  /** Frecuencia de visualización */
  displayFrequency: DisplayFrequency;
  dynamic?: Maybe<PageDynamic>;
  /** Plantilla HTML para renderizar la alerta */
  htmlTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Imagen de la alerta (SVG o PNG) */
  image?: Maybe<FileInfo>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  /** Enlace de redirección */
  linkItem?: Maybe<PageLink>;
  location: BlockLocation;
  /** Alto del modal (valor numérico) */
  modalHeight?: Maybe<Scalars['Int']['output']>;
  /** Unidad de medida para el tamaño del modal (px, vh, vw, %) */
  modalSizeUnit?: Maybe<ModalSizeUnit>;
  /** Ancho del modal (valor numérico) */
  modalWidth?: Maybe<Scalars['Int']['output']>;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  /** Título de la alerta (máximo 50 caracteres) */
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export enum ActionType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum BehaviorType {
  NewTab = 'NEW_TAB',
  SameTab = 'SAME_TAB'
}

export enum DisplayFrequency {
  Multiple = 'MULTIPLE',
  Once = 'ONCE'
}

/** Unidad de medida para el tamaño del modal */
export enum ModalSizeUnit {
  /** Porcentaje del contenedor padre */
  Percent = 'PERCENT',
  /** Píxeles */
  Px = 'PX',
  /** Porcentaje del viewport height */
  Vh = 'VH',
  /** Porcentaje del viewport width */
  Vw = 'VW'
}

export type PageAttentionLinesBlock = {
  __typename?: 'PageAttentionLinesBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageAttentionLinesBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageAttentionLinesBlockItem = {
  __typename?: 'PageAttentionLinesBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<FileInfo>;
  iconLink?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageAttentionLinesBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageCustomBlock = {
  __typename?: 'PageCustomBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageEventsBlock = {
  __typename?: 'PageEventsBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  contentSchema?: Maybe<ContentSchema>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  eventDescription?: Maybe<Scalars['String']['output']>;
  events: Array<EventsItem>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hasDependencyFilter?: Maybe<Scalars['Boolean']['output']>;
  hasScheduleInteractive?: Maybe<Scalars['Boolean']['output']>;
  hasSeeMore?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  includeSharedContent?: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  linkItem?: Maybe<PageLink>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  seeMoreLink?: Maybe<Scalars['String']['output']>;
  seeMoreText?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageEventSliderBlock = {
  __typename?: 'PageEventSliderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageEventSliderBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageEventSliderBlockItem = {
  __typename?: 'PageEventSliderBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: FileInfo;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageEventSliderBlock;
  previousVersion?: Maybe<PageBlockItem>;
  seeMoreAction: Scalars['String']['output'];
  seeMoreLink: Scalars['String']['output'];
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageInstitutionalProgramsSliderBlock = {
  __typename?: 'PageInstitutionalProgramsSliderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageInstitutionalProgramsSliderBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageInstitutionalProgramsSliderBlockItem = {
  __typename?: 'PageInstitutionalProgramsSliderBlockItem';
  alternativeText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: FileInfo;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageInstitutionalProgramsSliderBlock;
  previousVersion?: Maybe<PageBlockItem>;
  seeMoreAction: Scalars['String']['output'];
  seeMoreLink: Scalars['String']['output'];
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageInstitutionalProgramsTypesBlock = {
  __typename?: 'PageInstitutionalProgramsTypesBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageInstitutionalProgramsTypesBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageInstitutionalProgramsTypesBlockItem = {
  __typename?: 'PageInstitutionalProgramsTypesBlockItem';
  alternativeText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageInstitutionalProgramsTypesBlock;
  previousVersion?: Maybe<PageBlockItem>;
  programsType?: Maybe<ProgramsTypes>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProgramsTypes {
  Family = 'Family',
  Food = 'Food',
  Home = 'Home',
  Tourism = 'Tourism'
}

/** Mapa Interactivo */
export type PageMapBlock = {
  __typename?: 'PageMapBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  /** Coordenadas del centro del mapa en formato JSON: {lat: number, lng: number} */
  centerCoordinates?: Maybe<Scalars['String']['output']>;
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Color de borde por defecto para elementos del mapa (formato hex) */
  defaultBorderColor?: Maybe<Scalars['String']['output']>;
  /** Color de relleno por defecto para elementos del mapa (formato hex) */
  defaultFillColor?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Código DANE del departamento (requerido solo para mapas municipales) */
  departmentCode?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  /** Configuración de elementos del mapa en formato JSON (manejado por el cliente) */
  elementsConfig?: Maybe<Scalars['String']['output']>;
  /** Datos GeoJSON completos para mapas personalizados (validados en cliente) */
  geoJsonData?: Maybe<Scalars['String']['output']>;
  /** Altura del mapa en píxeles (mínimo 300, máximo 800) */
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Nivel de zoom inicial del mapa (1-18) */
  initialZoom: Scalars['Int']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  /** Tipo de mapa: DEPARTMENTAL, MUNICIPAL o CUSTOM */
  mapType: MapType;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

/** Tipo de mapa: Departamental (Colombia completa), Municipal (por departamento) o Personalizado (GeoJSON) */
export enum MapType {
  Custom = 'CUSTOM',
  Departmental = 'DEPARTMENTAL',
  Municipal = 'MUNICIPAL'
}

export type PageNavigationBar = {
  __typename?: 'PageNavigationBar';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  rootItem?: Maybe<NavigationItem>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  /** Todos los hijos directos del item (incluye inactivos, para admin) */
  allChildren: Array<NavigationItem>;
  /** Hijos directos visibles del item (filtra inactivos para público) */
  children: Array<NavigationItem>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  icon?: Maybe<FileInfo>;
  id: Scalars['ID']['output'];
  /** Indica si el item es visible en público (considera estado de ancestros) */
  isVisible: Scalars['Boolean']['output'];
  lft?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  name: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  pageNavigationBar?: Maybe<PageNavigationBar>;
  parent?: Maybe<NavigationItem>;
  previousVersion?: Maybe<NavigationItem>;
  rgt?: Maybe<Scalars['Int']['output']>;
  signLanguageDescription?: Maybe<Scalars['String']['output']>;
  signLanguageGif?: Maybe<FileInfo>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  type?: Maybe<NavigationItemType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum NavigationItemType {
  Default = 'Default',
  Principal = 'Principal',
  Section = 'Section'
}

export type PageNewsletterBlock = {
  __typename?: 'PageNewsletterBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  contentSchema?: Maybe<ContentSchema>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hasDependencyFilter?: Maybe<Scalars['Boolean']['output']>;
  hasSearchbarNewsletter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  includeSharedContent?: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  news: Array<NewsItem>;
  newsletterDescription?: Maybe<Scalars['String']['output']>;
  newsletterTags?: Maybe<Array<Scalars['String']['output']>>;
  newsletterTitle: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  tagStyle?: Maybe<PageBlockStyles>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageParticipateDownloadBlock = {
  __typename?: 'PageParticipateDownloadBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  regulations: Array<Regulation>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageParticipateElementBlock = {
  __typename?: 'PageParticipateElementBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageParticipateElementBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageParticipateElementBlockItem = {
  __typename?: 'PageParticipateElementBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  parent: PageParticipateElementBlock;
  participateElementImage?: Maybe<FileInfo>;
  participateElementTitle: Scalars['String']['output'];
  participateLinkAction?: Maybe<PageLink>;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageParticipateHeaderBlock = {
  __typename?: 'PageParticipateHeaderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  hasSearchbar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  participateDescription: Scalars['String']['output'];
  participateIntroduction?: Maybe<Scalars['String']['output']>;
  participateTitle: Scalars['String']['output'];
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PagePqrsdfActionBlock = {
  __typename?: 'PagePqrsdfActionBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PagePqrsdfConsultBlock = {
  __typename?: 'PagePqrsdfConsultBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PagePressroomBlock = {
  __typename?: 'PagePressroomBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  hasSearchbar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageProcedureFeedbackBlock = {
  __typename?: 'PageProcedureFeedbackBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageProcedureHeaderBlock = {
  __typename?: 'PageProcedureHeaderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  hasSearchbar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  procedureDescription: Scalars['String']['output'];
  procedureTitle: Scalars['String']['output'];
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageProcedureMainBlock = {
  __typename?: 'PageProcedureMainBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageProceduresBlock = {
  __typename?: 'PageProceduresBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  descriptionProcedures: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  procedures: Array<Procedure>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  seeMoreAction: Scalars['String']['output'];
  seeMoreActionLink: Scalars['String']['output'];
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  titleProcedures: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type Procedure = {
  __typename?: 'Procedure';
  action?: Maybe<Scalars['String']['output']>;
  actionLink?: Maybe<Scalars['String']['output']>;
  alternativeText?: Maybe<Scalars['String']['output']>;
  cost: CostTypes;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  duration?: Maybe<DurationTypes>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  gocvoLogoName?: Maybe<Scalars['String']['output']>;
  govcoImage?: Maybe<FileInfo>;
  govcoLink?: Maybe<PageLink>;
  id: Scalars['ID']['output'];
  linkItem?: Maybe<PageLink>;
  linkVideo?: Maybe<PageLink>;
  magnetoProcessUrl?: Maybe<Scalars['String']['output']>;
  modality: ModalityTypes;
  multimediaType?: Maybe<MultimediaTypes>;
  name: Scalars['ID']['output'];
  procedureDescription?: Maybe<Scalars['String']['output']>;
  procedureItemTags: Array<Scalars['String']['output']>;
  procedureStatus?: Maybe<VersionStates>;
  procedureTypes?: Maybe<ProcedureTypes>;
  /** This field is the references to the process at Magneto BPM but it's not a FK here */
  processDefinitionId?: Maybe<Scalars['String']['output']>;
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Controla la visibilidad del botón de GovCo */
  showGovcoButton: Scalars['Boolean']['output'];
  /** Controla la visibilidad del botón del trámite */
  showProcedureButton: Scalars['Boolean']['output'];
  /** @deprecated Este campo será reemplazado por tags, en el input se llamará proceduresItemTags */
  tagsProcedure?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CostTypes {
  ConCosto = 'ConCosto',
  SinCosto = 'SinCosto'
}

export enum DurationTypes {
  BusinessDays = 'BusinessDays',
  Immediate = 'Immediate',
  Undefined = 'Undefined',
  WorkingHours = 'WorkingHours'
}

export enum ModalityTypes {
  EnLinea = 'EnLinea',
  Presencial = 'Presencial',
  SemiPresencial = 'SemiPresencial'
}

export enum ProcedureTypes {
  InformationOfInterest = 'InformationOfInterest',
  Pqrsdf = 'Pqrsdf',
  Procedure = 'Procedure',
  Service = 'Service',
  Tax = 'Tax'
}

/** Acceso rápido */
export type PageQuickAccessBar = {
  __typename?: 'PageQuickAccessBar';
  /** Todos los items (incluye inactivos, para admin) */
  allItems: Array<PageQuickAccessBarItem>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isCarrousel?: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  /** Items visibles (filtra inactivos para público) */
  items: Array<PageQuickAccessBarItem>;
  itemsPerView?: Maybe<Scalars['Float']['output']>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  seeMoreLink?: Maybe<Scalars['String']['output']>;
  seeMoreTitle?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageQuickAccessBarItem = {
  __typename?: 'PageQuickAccessBarItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  link: Scalars['String']['output'];
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageQuickAccessBar;
  previousVersion?: Maybe<PageBlockItem>;
  quickAccessName?: Maybe<Scalars['String']['output']>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageRegulationsBlock = {
  __typename?: 'PageRegulationsBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  descriptionRegulation?: Maybe<Scalars['String']['output']>;
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageRegulationsBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  regulations: Array<Regulation>;
  seeMoreRegulations?: Maybe<Scalars['String']['output']>;
  seeMoreRegulationsLink?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  titleRegulation: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageRegulationsBlockItem = {
  __typename?: 'PageRegulationsBlockItem';
  /** Configuración JSON para ordenamiento y agrupación de normatividad */
  configJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemDescription?: Maybe<Scalars['String']['output']>;
  itemIcon?: Maybe<FileInfo>;
  itemName: Scalars['String']['output'];
  itemType: RegulationType;
  orderIndex: Scalars['Int']['output'];
  parent: PageRegulationsBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Bloque de búsqueda configurable para páginas */
export type PageSearchBlock = {
  __typename?: 'PageSearchBlock';
  /** Aplicar filtro automático por dependencia según contexto */
  autoFilterByDependency: Scalars['Boolean']['output'];
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contexto del bloque (se detecta automáticamente según la página) */
  contextType: SearchContextType;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  /** Incluir contenido de otras dependencias (solo para header de página principal) */
  includeOtherDependencies: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  /** Número máximo de resultados a mostrar */
  maxResults: Scalars['Float']['output'];
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  /** Texto placeholder del campo de búsqueda */
  placeholder?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  /** Fuentes de búsqueda habilitadas para este bloque */
  searchSources: Array<SearchSourceType>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

/** Contexto donde está ubicado el bloque de búsqueda */
export enum SearchContextType {
  DynamicPage = 'DYNAMIC_PAGE',
  Generic = 'GENERIC',
  MainPage = 'MAIN_PAGE'
}

/** Tipos de fuentes de contenido disponibles para búsqueda */
export enum SearchSourceType {
  Content = 'CONTENT',
  Documents = 'DOCUMENTS',
  Events = 'EVENTS',
  News = 'NEWS',
  Procedures = 'PROCEDURES',
  Regulations = 'REGULATIONS'
}

export type PageSliderBlock = {
  __typename?: 'PageSliderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  sliders?: Maybe<Array<SliderItem>>;
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type SliderItem = {
  __typename?: 'SliderItem';
  alternativeText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  link?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  orderIndex?: Maybe<Scalars['Int']['output']>;
  pageBlockStyle?: Maybe<PageBlockStyles>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageSnsBlock = {
  __typename?: 'PageSnsBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageSnsBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageSnsBlockItem = {
  __typename?: 'PageSnsBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemLink?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageSnsBlock;
  previousVersion?: Maybe<PageBlockItem>;
  snsSocialNetworkType?: Maybe<SocialNetworkType>;
  snsTitle: Scalars['String']['output'];
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SocialNetworkType {
  Discord = 'Discord',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Pinterest = 'Pinterest',
  Reddit = 'Reddit',
  Snapchat = 'Snapchat',
  Spotify = 'Spotify',
  Telegram = 'Telegram',
  TikTok = 'TikTok',
  Twitch = 'Twitch',
  Twitter = 'Twitter',
  WhatsApp = 'WhatsApp',
  YouTube = 'YouTube'
}

export type PageSocialNetworksBlock = {
  __typename?: 'PageSocialNetworksBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  leftItems: Array<PageSocialNetworksLeftBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  rightItems: Array<PageSocialNetworksRightBlockItem>;
  seeMoreAction?: Maybe<Scalars['String']['output']>;
  seeMoreLink?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageSocialNetworksLeftBlockItem = {
  __typename?: 'PageSocialNetworksLeftBlockItem';
  alternativeText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  imageLink?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageSocialNetworksBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageSocialNetworksRightBlockItem = {
  __typename?: 'PageSocialNetworksRightBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasRightItem?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageSocialNetworksBlock;
  previousVersion?: Maybe<PageBlockItem>;
  socialNetworkType?: Maybe<SocialNetworkType>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageStyledTableBlock = {
  __typename?: 'PageStyledTableBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  columns: Array<PageStyledTableBlockItem>;
  contentSchema?: Maybe<ContentSchema>;
  contentType?: Maybe<TableContentType>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  extendedDescription?: Maybe<Scalars['String']['output']>;
  externalEndpoint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  itemsPerPage?: Maybe<Scalars['Float']['output']>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  rows: Array<PageStyledTableBlockRow>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  tableStyle?: Maybe<TableStyleType>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageStyledTableBlockItem = {
  __typename?: 'PageStyledTableBlockItem';
  allowFilter?: Maybe<Scalars['Boolean']['output']>;
  allowSort?: Maybe<Scalars['Boolean']['output']>;
  columnName?: Maybe<Scalars['String']['output']>;
  columnWidth?: Maybe<Scalars['Float']['output']>;
  configJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataType?: Maybe<ColumnDataType>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mappedField?: Maybe<ContentSchemaField>;
  orderIndex: Scalars['Int']['output'];
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  styledTableBlock: PageStyledTableBlock;
  updatedAt: Scalars['DateTime']['output'];
};

/** Tipo de dato de la columna de tabla estilizada */
export enum ColumnDataType {
  /** Dirección física */
  Address = 'ADDRESS',
  /** Fecha */
  Date = 'DATE',
  /** Enlace a documento */
  Document = 'DOCUMENT',
  /** Dirección de correo electrónico */
  Email = 'EMAIL',
  /** Enlace web */
  Link = 'LINK',
  /** Número de teléfono */
  Phone = 'PHONE',
  /** Texto simple */
  Text = 'TEXT',
  /** Área de texto multilínea */
  Textarea = 'TEXTAREA',
  /** Imagen miniatura */
  Thumbnail = 'THUMBNAIL'
}

/** Tipo de contenido de la tabla estilizada */
export enum TableContentType {
  /** Contenido dinámico basado en esquemas de contenido */
  Dynamic = 'DYNAMIC',
  /** Contenido dinámico desde endpoint externo */
  DynamicExternal = 'DYNAMIC_EXTERNAL',
  /** Contenido estático configurado manualmente */
  Static = 'STATIC'
}

export type PageStyledTableBlockRow = {
  __typename?: 'PageStyledTableBlockRow';
  cellData?: Maybe<Array<PageStyledTableBlockRowData>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  styledTableBlock?: Maybe<PageStyledTableBlock>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageStyledTableBlockRowData = {
  __typename?: 'PageStyledTableBlockRowData';
  column?: Maybe<PageStyledTableBlockItem>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  extendedValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  row?: Maybe<PageStyledTableBlockRow>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Estilo visual de la tabla estilizada */
export enum TableStyleType {
  /** Tabla con bordes */
  Bordered = 'BORDERED',
  /** Tabla compacta */
  Compact = 'COMPACT',
  /** Tabla minimalista */
  Minimalist = 'MINIMALIST',
  /** Tabla zebra (filas alternadas) */
  Zebra = 'ZEBRA'
}

export type PageSubDownloadBlock = {
  __typename?: 'PageSubDownloadBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageSubDownloadBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subDownloadDescription?: Maybe<Scalars['String']['output']>;
  subDownloadPlaceholder?: Maybe<Scalars['String']['output']>;
  subDownloadSearchbar?: Maybe<Scalars['Boolean']['output']>;
  subDownloadTitle?: Maybe<Scalars['String']['output']>;
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageSubDownloadBlockItem = {
  __typename?: 'PageSubDownloadBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file: FileInfo;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  parent: PageSubDownloadBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageSubHeaderBlock = {
  __typename?: 'PageSubHeaderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDates?: Maybe<Scalars['Boolean']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subHeaderDescription?: Maybe<Scalars['String']['output']>;
  subHeaderIntroduction?: Maybe<Scalars['String']['output']>;
  subHeaderPlaceholder?: Maybe<Scalars['String']['output']>;
  subHeaderSearchbar?: Maybe<Scalars['Boolean']['output']>;
  subHeaderTitle?: Maybe<Scalars['String']['output']>;
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageTaxesBlock = {
  __typename?: 'PageTaxesBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageTaxesBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  taxSectionTitle: Scalars['String']['output'];
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageTaxesBlockItem = {
  __typename?: 'PageTaxesBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  link: Scalars['String']['output'];
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageTaxesBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  taxTitle: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageTransparencyBlock = {
  __typename?: 'PageTransparencyBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  hasLinkVideo?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageTransparencyBlockItem>;
  linkVideo?: Maybe<PageLink>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  transparencyContent?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageTransparencyBlockItem = {
  __typename?: 'PageTransparencyBlockItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemDescription?: Maybe<Scalars['String']['output']>;
  itemIcon?: Maybe<FileInfo>;
  itemTitle?: Maybe<Scalars['String']['output']>;
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageTransparencyBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageTransparencyHeaderBlock = {
  __typename?: 'PageTransparencyHeaderBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  hasSearchbar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  transparencyDescription?: Maybe<Scalars['String']['output']>;
  transparencyPlaceholder?: Maybe<Scalars['String']['output']>;
  transparencyTitle?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type FindEventOrderBy = {
  contentSchemaId?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  endDate?: InputMaybe<OrderTypes>;
  eventItemTitle?: InputMaybe<OrderTypes>;
  eventStatus?: InputMaybe<OrderTypes>;
  startDate?: InputMaybe<OrderTypes>;
};

export type FindEventWhere = {
  _and?: InputMaybe<Array<FindEventWhere>>;
  _or?: InputMaybe<Array<FindEventWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  endDate?: InputMaybe<DateFilter>;
  eventItemTitle?: InputMaybe<StringFilter>;
  eventStatus?: InputMaybe<Array<VersionStates>>;
  startDate?: InputMaybe<DateFilter>;
};

export type FilterEventOrderBy = {
  contentSchemaId?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  endDate?: InputMaybe<OrderTypes>;
  eventItemTitle?: InputMaybe<OrderTypes>;
  eventStatus?: InputMaybe<OrderTypes>;
  startDate?: InputMaybe<OrderTypes>;
};

export type FilterEventWhere = {
  _and?: InputMaybe<Array<FilterEventWhere>>;
  _or?: InputMaybe<Array<FilterEventWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  endDate?: InputMaybe<DateFilter>;
  eventItemTitle?: InputMaybe<StringFilter>;
  eventStatus?: InputMaybe<Array<VersionStates>>;
  startDate?: InputMaybe<DateFilter>;
};

export type ContentSchemaByTypeOrderBy = {
  contentType?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type ContentSchemaByTypeWhere = {
  _and?: InputMaybe<Array<ContentSchemaByTypeWhere>>;
  _or?: InputMaybe<Array<ContentSchemaByTypeWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  dependency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type DefaultPageBlockModel = {
  __typename?: 'DefaultPageBlockModel';
  block: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type FooterBlockUnion = PageAccessibilityBar | PageCorporateLogosBlock | PageFooterBar;

export type PageAccessibilityBar = {
  __typename?: 'PageAccessibilityBar';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageCorporateLogosBlock = {
  __typename?: 'PageCorporateLogosBlock';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageCorporateLogosBlockItem>;
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageCorporateLogosBlockItem = {
  __typename?: 'PageCorporateLogosBlockItem';
  alternativeText?: Maybe<Scalars['String']['output']>;
  corporateLogo?: Maybe<FileInfo>;
  corporateLogoLink?: Maybe<Scalars['String']['output']>;
  corporateLogoName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkItem?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  parent: PageCorporateLogosBlock;
  previousVersion?: Maybe<PageBlockItem>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PageFooterBar = {
  __typename?: 'PageFooterBar';
  /** @deprecated Este valor será reemplazado por un text area */
  address?: Maybe<Scalars['String']['output']>;
  administrationLogo?: Maybe<FileInfo>;
  administrationLogoLink?: Maybe<Scalars['String']['output']>;
  adminOtherLogo?: Maybe<FileInfo>;
  adminOtherLogoLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Este valor será reemplazado por un text area */
  antiCorruptionLine?: Maybe<Scalars['String']['output']>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  campusData?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  /** @deprecated Este valor será reemplazado por un text area */
  citizenLine?: Maybe<Scalars['String']['output']>;
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  /** @deprecated Este valor será reemplazado por un text area */
  fax?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Este valor será reemplazado por un text area */
  institutionalEmail?: Maybe<Scalars['String']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  items: Array<PageFooterBarItem>;
  /** @deprecated Este valor será reemplazado por un text area */
  judicialEmail?: Maybe<Scalars['String']['output']>;
  location: BlockLocation;
  logoImage?: Maybe<FileInfo>;
  logoLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Este valor será reemplazado por un text area */
  nit?: Maybe<Scalars['String']['output']>;
  /** @deprecated Este valor será reemplazado por un text area */
  openingHours?: Maybe<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  /** @deprecated Este valor será reemplazado por un text area */
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Este valor será reemplazado por un text area */
  postalCode?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageFooterBarItem = {
  __typename?: 'PageFooterBarItem';
  anotherCampusData?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  footerType?: Maybe<FooterItemType>;
  hasAnoterCampusData?: Maybe<Scalars['Boolean']['output']>;
  hasSocialNetworkIcon?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  pageDirectory?: Maybe<Scalars['String']['output']>;
  pageDirectoryLink?: Maybe<PageLink>;
  parent: PageFooterBar;
  previousVersion?: Maybe<PageBlockItem>;
  routeType?: Maybe<RouterType>;
  socialNetworkIcon?: Maybe<FileInfo>;
  socialNetworkLink?: Maybe<Scalars['String']['output']>;
  socialNetworkName?: Maybe<Scalars['String']['output']>;
  /** Estado del item: Active (visible) o Inactive (oculto) */
  status: ItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum FooterItemType {
  IsCampusData = 'IsCampusData',
  IsDirectory = 'IsDirectory',
  IsSocialNetwork = 'IsSocialNetwork'
}

export type Functionality = {
  __typename?: 'Functionality';
  children?: Maybe<Array<Functionality>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Functionality>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FunctionalityModel = {
  __typename?: 'FunctionalityModel';
  children?: Maybe<Array<FunctionalityModel>>;
  dependencyType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefixes?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<FunctionalityTag>>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum FunctionalityTag {
  Controller = 'CONTROLLER',
  Custom = 'CUSTOM',
  Method = 'METHOD',
  Module = 'MODULE',
  Parent = 'PARENT',
  Resolver = 'RESOLVER',
  Standard = 'STANDARD'
}

export type GroupingSort = {
  /** Sort configuration for each grouping level (index-based: [level0, level1, level2, ...]) */
  levelSorts?: InputMaybe<Array<GroupingLevelSort>>;
};

export type GroupingLevelSort = {
  /** Sort order: ASC or DESC */
  order: SortOrder;
  /** Field to sort by: fieldValue, count, fieldLabel */
  sortBy: Scalars['String']['input'];
};

/** Sort order: ASC or DESC */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type DocumentGroupingResult = {
  __typename?: 'DocumentGroupingResult';
  groups: Array<GroupedDocumentCount>;
  maxLevels: Scalars['Int']['output'];
  rootFieldName: Scalars['String']['output'];
  totalDocuments: Scalars['Int']['output'];
};

export type GroupedDocumentCount = {
  __typename?: 'GroupedDocumentCount';
  children?: Maybe<Array<GroupedDocumentCount>>;
  count: Scalars['Int']['output'];
  fieldLabel: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
  level: Scalars['Int']['output'];
};

export type FindDocumentGroupingWhereNormalized = {
  _and?: InputMaybe<Array<FindDocumentGroupingWhereNormalized>>;
  _or?: InputMaybe<Array<FindDocumentGroupingWhereNormalized>>;
  /** Filter by document description */
  description?: InputMaybe<StringFilter>;
  /** Filter by specific metadata fields */
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  /** Search in metadata values */
  metadataSearch?: InputMaybe<StringFilter>;
  /** Filter by publish date */
  publishDate?: InputMaybe<DateFilter>;
  /** Filter by tag IDs */
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by document title */
  title?: InputMaybe<StringFilter>;
};

export type DocumentGroupingInput = {
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  /** Sort configuration for each grouping level */
  groupingSort?: InputMaybe<GroupingSort>;
  maxGroupingLevels?: InputMaybe<Scalars['Int']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter>>;
  metadataSearch?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  publishDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  schemaFieldId: Scalars['String']['input'];
  schemaId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsersByDependencyModel = {
  __typename?: 'UsersByDependencyModel';
  /** Usuarios que tienen la dependencia */
  usersWithDependency: Array<UserDependency>;
  /** Usuarios que no tienen la dependencia */
  usersWithoutDependency: Array<User>;
};

export type HeaderBlockUnion = PageAccessibilityButton | PageAuthenticationBar | PageHeaderBar | PageHeaderOrganizationBar | PageNavigationBar | PageSearchBlock;

export type PageAuthenticationBar = {
  __typename?: 'PageAuthenticationBar';
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  /** @deprecated Este campo será trasladado a header bar */
  hasSignin?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Este campo será trasladado a header bar */
  hasSignup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageHeaderBar = {
  __typename?: 'PageHeaderBar';
  /** @deprecated this element will be moved to header organization */
  administrationLogo?: Maybe<FileInfo>;
  /** @deprecated this element will be moved to header organization */
  administrationLogoLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated this element will be moved to header organization */
  adminOtherLogo?: Maybe<FileInfo>;
  /** @deprecated this element will be moved to header organization */
  adminOtherLogoLink?: Maybe<Scalars['String']['output']>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  govcoLink?: Maybe<PageLink>;
  hasGovcoLogo?: Maybe<Scalars['Boolean']['output']>;
  hasLanguageIcon?: Maybe<Scalars['Boolean']['output']>;
  hasSearchbar: Scalars['Boolean']['output'];
  hasSignin?: Maybe<Scalars['Boolean']['output']>;
  hasSignup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  /** @deprecated this element will be moved to header organization */
  logoImage?: Maybe<FileInfo>;
  /** @deprecated this element will be moved to header organization */
  logoLink?: Maybe<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  placeholder?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  signinName?: Maybe<Scalars['String']['output']>;
  signupName?: Maybe<Scalars['String']['output']>;
  subPages?: Maybe<Array<SubPages>>;
  /** @deprecated this element will be moved to header organization */
  subtitle?: Maybe<Scalars['String']['output']>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  /** @deprecated this element will be moved to header organization */
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type PageHeaderOrganizationBar = {
  __typename?: 'PageHeaderOrganizationBar';
  adminAnotherLink?: Maybe<PageLink>;
  administrationLogo?: Maybe<FileInfo>;
  adminLogoLink?: Maybe<PageLink>;
  adminOtherLogo?: Maybe<FileInfo>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  canBeDisabled: Scalars['Boolean']['output'];
  clonedFromTemplateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dynamic?: Maybe<PageDynamic>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFromTemplate: Scalars['Boolean']['output'];
  location: BlockLocation;
  logoImage?: Maybe<FileInfo>;
  logoImageLink?: Maybe<PageLink>;
  orderIndex: Scalars['Int']['output'];
  pageBlockStyle?: Maybe<PageBlockStyles>;
  previousVersion?: Maybe<PageBlock>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  showDescription: Scalars['Boolean']['output'];
  showTitle: Scalars['Boolean']['output'];
  subPages?: Maybe<Array<SubPages>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  templateOriginId?: Maybe<Scalars['String']['output']>;
  templateOriginName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<PageVersion>;
};

export type HierarchicalDocumentPagination = {
  __typename?: 'HierarchicalDocumentPagination';
  hasMore: Scalars['Boolean']['output'];
  items: Array<HierarchicalDocument>;
  maxDepth: Scalars['Int']['output'];
  totalChildren: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalParents: Scalars['Int']['output'];
};

export type HierarchicalDocument = {
  __typename?: 'HierarchicalDocument';
  children: Array<HierarchicalDocument>;
  childrenCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  dependencyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadCount?: Maybe<Scalars['String']['output']>;
  downloadText?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  hierarchyPath: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isExpanded: Scalars['Boolean']['output'];
  isParentDocument: Scalars['Boolean']['output'];
  metadata: Array<DocumentMetadata>;
  mimeType?: Maybe<Scalars['String']['output']>;
  nestingLevel: Scalars['Int']['output'];
  parentDocumentId?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  schemaName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type HierarchyStats = {
  __typename?: 'HierarchyStats';
  avgChildrenPerParent: Scalars['Int']['output'];
  childDocuments: Scalars['Int']['output'];
  levelStats: Array<LevelStats>;
  maxNestingLevel: Scalars['Int']['output'];
  parentDocuments: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
};

export type LevelStats = {
  __typename?: 'LevelStats';
  count: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
};

export type FindHistoryOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
};

export type FindHistoryWhere = {
  _and?: InputMaybe<Array<FindHistoryWhere>>;
  _or?: InputMaybe<Array<FindHistoryWhere>>;
};

export type InstitutionalProgramsItem = {
  __typename?: 'InstitutionalProgramsItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dependency?: Maybe<Dependency>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  pageLink?: Maybe<PageLink>;
  programsStatus?: Maybe<VersionStates>;
  programsType?: Maybe<ProgramsTypes>;
  seeMoreAction: Scalars['String']['output'];
  seeMoreLink: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FindInstitutionalProgramsOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  programsType?: InputMaybe<OrderTypes>;
};

export type FindInstitutionalProgramsItemWhere = {
  _and?: InputMaybe<Array<FindInstitutionalProgramsItemWhere>>;
  _or?: InputMaybe<Array<FindInstitutionalProgramsItemWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  programsType?: InputMaybe<EnumInstitutionalItemFilter>;
};

export type EnumInstitutionalItemFilter = {
  _eq?: InputMaybe<ProgramsTypes>;
};

export type MainBlockUnion = PageAccessibilityButton | PageAccordionBlock | PageAlertsBlock | PageAttentionLinesBlock | PageCabinetBlock | PageCustomBlock | PageEventsBlock | PageEventSliderBlock | PageInstitutionalProgramsSliderBlock | PageInstitutionalProgramsTypesBlock | PageMapBlock | PageNavigationBar | PageNewsletterBlock | PageParticipateDownloadBlock | PageParticipateElementBlock | PageParticipateHeaderBlock | PagePqrsdfActionBlock | PagePqrsdfConsultBlock | PagePressroomBlock | PageProcedureFeedbackBlock | PageProcedureHeaderBlock | PageProcedureMainBlock | PageProceduresBlock | PageQuickAccessBar | PageRegulationsBlock | PageSearchBlock | PageSliderBlock | PageSnsBlock | PageSocialNetworksBlock | PageStyledTableBlock | PageSubDownloadBlock | PageSubHeaderBlock | PageTaxesBlock | PageTransparencyBlock | PageTransparencyHeaderBlock;

export type PageBlockUnion = PageAccessibilityBar | PageAccessibilityButton | PageAccordionBlock | PageAlertsBlock | PageAttentionLinesBlock | PageAuthenticationBar | PageCabinetBlock | PageCorporateLogosBlock | PageCustomBlock | PageEventsBlock | PageEventSliderBlock | PageFooterBar | PageHeaderBar | PageHeaderOrganizationBar | PageInstitutionalProgramsSliderBlock | PageInstitutionalProgramsTypesBlock | PageMapBlock | PageNavigationBar | PageNewsletterBlock | PageParticipateDownloadBlock | PageParticipateElementBlock | PageParticipateHeaderBlock | PagePqrsdfActionBlock | PagePqrsdfConsultBlock | PagePressroomBlock | PageProcedureFeedbackBlock | PageProcedureHeaderBlock | PageProcedureMainBlock | PageProceduresBlock | PageQuickAccessBar | PageRegulationsBlock | PageSearchBlock | PageSliderBlock | PageSnsBlock | PageSocialNetworksBlock | PageStyledTableBlock | PageSubDownloadBlock | PageSubHeaderBlock | PageTaxesBlock | PageTransparencyBlock | PageTransparencyHeaderBlock;

export type MetadataValueGroupResponse = {
  __typename?: 'MetadataValueGroupResponse';
  /** Lista de agrupaciones */
  groups: Array<MetadataValueGroup>;
  /** Total de documentos en todos los grupos */
  totalDocuments: Scalars['Int']['output'];
  /** Total de grupos únicos */
  totalGroups: Scalars['Int']['output'];
};

export type MetadataValueGroup = {
  __typename?: 'MetadataValueGroup';
  /** Cantidad de documentos con este valor */
  count: Scalars['Int']['output'];
  /** Etiqueta del campo del esquema */
  fieldLabel?: Maybe<Scalars['String']['output']>;
  /** Nombre del campo del esquema */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** ID del campo del esquema */
  schemaFieldId: Scalars['String']['output'];
  /** ID del esquema de contenido */
  schemaId: Scalars['String']['output'];
  /** Valor de la metadata (puede ser "SIN_VALOR" para valores nulos) */
  value?: Maybe<Scalars['String']['output']>;
};

export type MultikeyRegisterIdInput = {
  id: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type MultikeyRegister = {
  __typename?: 'MultikeyRegister';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: MultikeyRegisterId;
};

export type MultikeyRegisterId = {
  __typename?: 'MultikeyRegisterId';
  id: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type FindMySharedContentOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  sharedAt?: InputMaybe<OrderTypes>;
};

export type FindMySharedContentWhere = {
  _and?: InputMaybe<Array<FindMySharedContentWhere>>;
  _or?: InputMaybe<Array<FindMySharedContentWhere>>;
  contentType?: InputMaybe<ContentType>;
};

export type FindMyTemplatesOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  usageCount?: InputMaybe<OrderTypes>;
};

export type FindMyTemplatesWhere = {
  _and?: InputMaybe<Array<FindMyTemplatesWhere>>;
  _or?: InputMaybe<Array<FindMyTemplatesWhere>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<StringFilter>;
};

export type FindNewsOrderBy = {
  contentSchemaId?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  date?: InputMaybe<OrderTypes>;
  expiredDate?: InputMaybe<OrderTypes>;
  newsStatus?: InputMaybe<OrderTypes>;
  publicationDate?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
};

export type FindNewsWhere = {
  _and?: InputMaybe<Array<FindNewsWhere>>;
  _or?: InputMaybe<Array<FindNewsWhere>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  date?: InputMaybe<DateFilter>;
  expiredDate?: InputMaybe<DateFilter>;
  /** Filtrar por noticias con/sin fecha de vencimiento. true = solo noticias que vencen, false = solo noticias permanentes */
  hasExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  newsStatus?: InputMaybe<Array<VersionStates>>;
  publicationDate?: InputMaybe<DateFilter>;
  title?: InputMaybe<StringFilter>;
};

export type FilterNewsOrderBy = {
  contentSchemaId?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  date?: InputMaybe<OrderTypes>;
  expiredDate?: InputMaybe<OrderTypes>;
  newsStatus?: InputMaybe<OrderTypes>;
  publicationDate?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
};

export type FilterNewsWhere = {
  _and?: InputMaybe<Array<FilterNewsWhere>>;
  _or?: InputMaybe<Array<FilterNewsWhere>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  date?: InputMaybe<DateFilter>;
  expiredDate?: InputMaybe<DateFilter>;
  /** Filtrar por noticias con/sin fecha de vencimiento. true = solo noticias que vencen, false = solo noticias permanentes */
  hasExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  newsStatus?: InputMaybe<Array<VersionStates>>;
  publicationDate?: InputMaybe<DateFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ObjectTypesEnabledArgsOrderBy = {
  displayName?: InputMaybe<OrderTypes>;
};

export type ObjectTypesEnabledArgsWhere = {
  _contains?: InputMaybe<Scalars['String']['input']>;
};

export type ObjectTypeInfo = {
  __typename?: 'ObjectTypeInfo';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PageBlockItemUnion = PageAccessibilityButtonItem | PageAccordionBlockItem | PageAttentionLinesBlockItem | PageCabinetBlockItem | PageCorporateLogosBlockItem | PageEventSliderBlockItem | PageFooterBarItem | PageInstitutionalProgramsSliderBlockItem | PageInstitutionalProgramsTypesBlockItem | PageParticipateElementBlockItem | PageQuickAccessBarItem | PageRegulationsBlockItem | PageSnsBlockItem | PageSocialNetworksLeftBlockItem | PageSocialNetworksRightBlockItem | PageStyledTableBlockItem | PageStyledTableBlockRow | PageSubDownloadBlockItem | PageTaxesBlockItem | PageTransparencyBlockItem;

export type FindPageBlockItemsOrderBy = {
  cabinetName?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
};

export type FindPageBlockItemsWhere = {
  _and?: InputMaybe<Array<FindPageBlockItemsWhere>>;
  _or?: InputMaybe<Array<FindPageBlockItemsWhere>>;
  cabinetName?: InputMaybe<StringFilter>;
  cabinetStatus?: InputMaybe<EnumFilter>;
  createdAt?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
};

export type EnumFilter = {
  _eq?: InputMaybe<CabineStatus>;
};

export enum CabineStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type FindPageDynamicsOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  status?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindPageDynamicsWhere = {
  _and?: InputMaybe<Array<FindPageDynamicsWhere>>;
  _or?: InputMaybe<Array<FindPageDynamicsWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  dependency?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<VersionStates>>;
  type?: InputMaybe<PageDynamicType>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type PageStyledTableBlockRowWhere = {
  _and?: InputMaybe<Array<PageStyledTableBlockRowWhere>>;
  _or?: InputMaybe<Array<PageStyledTableBlockRowWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FindPageVersionsOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  state?: InputMaybe<OrderTypes>;
};

export type FindPageVersionsWhere = {
  _and?: InputMaybe<Array<FindPageVersionsWhere>>;
  _or?: InputMaybe<Array<FindPageVersionsWhere>>;
  consecutive?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  state?: InputMaybe<Array<VersionStates>>;
  theme?: InputMaybe<Array<Theme>>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Parameter = {
  __typename?: 'Parameter';
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  character?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<FileInfo>;
  json?: Maybe<Scalars['String']['output']>;
  longCharacter?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  type: TypeParameter;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TypeParameter {
  Boolean = 'Boolean',
  Character = 'Character',
  Date = 'Date',
  Image = 'Image',
  Json = 'Json',
  LongCharacter = 'LongCharacter',
  Number = 'Number'
}

export type FindParametersOrderBy = {
  code?: InputMaybe<OrderTypes>;
  description?: InputMaybe<OrderTypes>;
};

export type FindParametersWhere = {
  _and?: InputMaybe<Array<FindParametersWhere>>;
  _or?: InputMaybe<Array<FindParametersWhere>>;
  code?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
};

export type FindPositionOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindPositionWhere = {
  _and?: InputMaybe<Array<FindPositionWhere>>;
  _or?: InputMaybe<Array<FindPositionWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FindProceduresOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  procedureStatus?: InputMaybe<OrderTypes>;
  procedureTypes?: InputMaybe<OrderTypes>;
  publicationDate?: InputMaybe<OrderTypes>;
};

export type FindProceduresWhere = {
  _and?: InputMaybe<Array<FindProceduresWhere>>;
  _or?: InputMaybe<Array<FindProceduresWhere>>;
  cost?: InputMaybe<CostTypes>;
  createdAt?: InputMaybe<DateFilter>;
  duration?: InputMaybe<DurationTypes>;
  modality?: InputMaybe<ModalityTypes>;
  name?: InputMaybe<StringFilter>;
  procedureStatus?: InputMaybe<Array<VersionStates>>;
  procedureTypes?: InputMaybe<Array<ProcedureTypes>>;
  publicationDate?: InputMaybe<DateFilter>;
};

/** Arguments for regulation grouped counts query */
export type RegulationAggregationArgs = {
  /** Field to group regulations by */
  groupBy: RegulationGroupByField;
  /** Order by configuration. Defaults: Year=DESC, Month=ASC, Dependency=ASC by name */
  orderBy?: InputMaybe<RegulationAggregationOrderBy>;
  /** Pagination options */
  pagination?: InputMaybe<Pagination>;
  /** Filter conditions */
  where?: InputMaybe<RegulationAggregationWhere>;
};

/** Field to group regulations by for aggregated counts */
export enum RegulationGroupByField {
  Dependency = 'Dependency',
  Month = 'Month',
  Year = 'Year'
}

/** Order by options for regulation aggregation results */
export type RegulationAggregationOrderBy = {
  /** Order by count */
  count?: InputMaybe<OrderTypes>;
  /** Order by dependency name */
  dependencyName?: InputMaybe<OrderTypes>;
  /** Order by month (default: ASC - January to December) */
  month?: InputMaybe<OrderTypes>;
  /** Order by year (default: DESC) */
  year?: InputMaybe<OrderTypes>;
};

/** Where conditions for regulation aggregation */
export type RegulationAggregationWhere = {
  /** Filter by creation date */
  createdAt?: InputMaybe<DateFilter>;
  /** Filter by dependency IDs (supports _in operator for multiple dependencies) */
  dependency?: InputMaybe<StringFilter>;
  /** Filter by description */
  description?: InputMaybe<StringFilter>;
  /** Filter by document date (expedition date) */
  documentDate?: InputMaybe<DateFilter>;
  /** Filter by month (1-12, extracted from documentDate). Requires year filter when groupBy includes MONTH. */
  month?: InputMaybe<NumberFilter>;
  /** Filter by parent block ID */
  parentId?: InputMaybe<UuidLikeFilter>;
  /** Filter by publish date */
  publishDate?: InputMaybe<DateFilter>;
  /** Filter by regulation status (array of allowed states) */
  regulationStatus?: InputMaybe<Array<VersionStates>>;
  /** Filter by title */
  title?: InputMaybe<StringFilter>;
  /** Filter by regulation type */
  type?: InputMaybe<RegulationType>;
  /** Filter by year (extracted from documentDate) */
  year?: InputMaybe<NumberFilter>;
};

/** Filter for UUID-like fields with common operators */
export type UuidLikeFilter = {
  /** Equals */
  _eq?: InputMaybe<Scalars['String']['input']>;
  /** In array */
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equals */
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** Not in array */
  _notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of a grouped count aggregation for regulations */
export type AggregatedCountResult = {
  __typename?: 'AggregatedCountResult';
  /** Count of regulations in this group */
  count: Scalars['Int']['output'];
  /** Unique identifier for the group. Examples: "2024" (year), "uuid-xxx" (dependency), "3" (month) */
  groupKey: Scalars['String']['output'];
  /** Human-readable label for the group. Examples: "2024", "Ministerio de Salud", "Marzo" */
  groupLabel?: Maybe<Scalars['String']['output']>;
  /** The type of grouping this result represents */
  groupType: RegulationGroupByField;
};

export type FindRegulationYearsArgs = {
  dependency?: InputMaybe<StringFilter>;
  filtrationType?: InputMaybe<Array<FiltrationRegulationType>>;
  orderBy?: InputMaybe<Array<FindRegulationYearsOrderBy>>;
  pagination?: InputMaybe<Pagination>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  regulationStatus?: InputMaybe<VersionStates>;
  type?: InputMaybe<RegulationType>;
  where?: InputMaybe<FindRegulationYearsWhere>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Types of filtration for regulation grouping - DEPRECATED: Use RegulationGroupByField */
export enum FiltrationRegulationType {
  Dependency = 'Dependency',
  Month = 'Month',
  Year = 'Year'
}

export type FindRegulationYearsOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  documentDate?: InputMaybe<OrderTypes>;
  regulationStatus?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
};

export type FindRegulationYearsWhere = {
  createdAt?: InputMaybe<DateFilter>;
  dependency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  documentDate?: InputMaybe<DateFilter>;
  regulationStatus?: InputMaybe<Array<VersionStates>>;
  title?: InputMaybe<StringFilter>;
};

export type RegulationMonthsModel = {
  __typename?: 'RegulationMonthsModel';
  count: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type FindRegulationsOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  documentDate?: InputMaybe<OrderTypes>;
  publishDate?: InputMaybe<OrderTypes>;
  regulationStatus?: InputMaybe<OrderTypes>;
  title?: InputMaybe<OrderTypes>;
  type?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
};

export type FindRegulationsWhere = {
  _and?: InputMaybe<Array<FindRegulationsWhere>>;
  _or?: InputMaybe<Array<FindRegulationsWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  dependency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  documentDate?: InputMaybe<DateFilter>;
  regulationStatus?: InputMaybe<Array<VersionStates>>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type RegulationTotalsModel = {
  __typename?: 'RegulationTotalsModel';
  count?: Maybe<Scalars['Int']['output']>;
  dependencyId?: Maybe<Scalars['String']['output']>;
  dependencyName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Array<RegulationMonthsModel>>;
  year?: Maybe<Scalars['String']['output']>;
};

export type RegulationYearsModel = {
  __typename?: 'RegulationYearsModel';
  count: Scalars['Int']['output'];
  year: Scalars['String']['output'];
};

export type FindRolesOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
};

export type FindRolesWhere = {
  _and?: InputMaybe<Array<FindRolesWhere>>;
  _or?: InputMaybe<Array<FindRolesWhere>>;
  description?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<RoleStatusTypes>>;
};

export type SearchFunctionalityInput = {
  searchText: Scalars['String']['input'];
};

/** Vista previa de entidades sin SEO */
export type SeoBackfillPreviewDto = {
  __typename?: 'SeoBackfillPreviewDto';
  /** Total de DocumentEntity sin SEO */
  documentsWithoutSeo: Scalars['Int']['output'];
  /** Total de EventsItem sin SEO */
  eventsItemsWithoutSeo: Scalars['Int']['output'];
  /** Total de NewsItem sin SEO */
  newsItemsWithoutSeo: Scalars['Int']['output'];
  /** Total de PageDynamic sin SEO */
  pageDynamicsWithoutSeo: Scalars['Int']['output'];
  /** Muestra de las primeras 10 entidades por tipo */
  preview: OrphanPreviewByTypeDto;
  /** Total de Regulation sin SEO */
  regulationsWithoutSeo: Scalars['Int']['output'];
  /** Total general de entidades huérfanas */
  totalOrphans: Scalars['Int']['output'];
};

/** Muestra de entidades huérfanas por tipo */
export type OrphanPreviewByTypeDto = {
  __typename?: 'OrphanPreviewByTypeDto';
  documents: Array<OrphanPreviewItemDto>;
  eventsItems: Array<OrphanPreviewItemDto>;
  newsItems: Array<OrphanPreviewItemDto>;
  pageDynamics: Array<OrphanPreviewItemDto>;
  regulations: Array<OrphanPreviewItemDto>;
};

/** Preview de una entidad huérfana */
export type OrphanPreviewItemDto = {
  __typename?: 'OrphanPreviewItemDto';
  id: Scalars['String']['output'];
  proposedSlug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Server = {
  __typename?: 'Server';
  app: ServerApp;
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Extra information */
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  environment: ServerEnvironment;
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  port?: Maybe<Scalars['Int']['output']>;
  /** Has HTTPS? */
  secure: Scalars['Boolean']['output'];
  status: ServerStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ServerApp {
  Magneto = 'Magneto',
  Sac = 'SAC'
}

export enum ServerEnvironment {
  PreProduction = 'PreProduction',
  Production = 'Production'
}

export enum ServerStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type FindSharedTemplatesOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
  sharedAt?: InputMaybe<OrderTypes>;
};

export type FindSharedTemplatesWhere = {
  _and?: InputMaybe<Array<FindSharedTemplatesWhere>>;
  _or?: InputMaybe<Array<FindSharedTemplatesWhere>>;
  authorId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type FindUserContentSchemaAssignmentOrderBy = {
  canEdit?: InputMaybe<OrderTypes>;
  contentSchemaId?: InputMaybe<OrderTypes>;
  createdAt?: InputMaybe<OrderTypes>;
  dependencyId?: InputMaybe<OrderTypes>;
  isActive?: InputMaybe<OrderTypes>;
  updatedAt?: InputMaybe<OrderTypes>;
  userId?: InputMaybe<OrderTypes>;
};

export type FindUserContentSchemaAssignmentWhere = {
  _and?: InputMaybe<Array<FindUserContentSchemaAssignmentWhere>>;
  _or?: InputMaybe<Array<FindUserContentSchemaAssignmentWhere>>;
  contentSchemaId?: InputMaybe<StringFilter>;
  dependencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<StringFilter>;
};

export type FindUserDependencyOrderBy = {
  dependencyId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type FindUserDependencyWhere = {
  _and?: InputMaybe<Array<FindUserDependencyWhere>>;
  _or?: InputMaybe<Array<FindUserDependencyWhere>>;
  dependencyId?: InputMaybe<StringFilter>;
  status?: InputMaybe<UserDependencyStatus>;
  type?: InputMaybe<UserDependencyType>;
  userId?: InputMaybe<StringFilter>;
};

export type UserRequest = {
  __typename?: 'UserRequest';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  dateIssue?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  email: Scalars['String']['output'];
  hasRural?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<UserDocumentTypes>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalRepresentative?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  requestType: UserRequestType;
  secondSurname?: Maybe<Scalars['String']['output']>;
  status: UserRequestStatusTypes;
  updatedAt: Scalars['DateTime']['output'];
};

export enum UserRequestType {
  Complete = 'Complete',
  Partial = 'Partial'
}

export enum UserRequestStatusTypes {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type FindUserRequestsOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  email?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
};

export type FindUserRequestsWhere = {
  _and?: InputMaybe<Array<FindUserRequestsWhere>>;
  _or?: InputMaybe<Array<FindUserRequestsWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  identificationNumber?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  requestType?: InputMaybe<Array<UserRequestType>>;
  status?: InputMaybe<Array<UserRequestStatusTypes>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FindUsersOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
  email?: InputMaybe<OrderTypes>;
  name?: InputMaybe<OrderTypes>;
};

export type FindUsersWhere = {
  _and?: InputMaybe<Array<FindUsersWhere>>;
  _or?: InputMaybe<Array<FindUsersWhere>>;
  createdAt?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  identificationNumber?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<UserStatusTypes>>;
  type?: InputMaybe<Array<UserTypes>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FindUserTemplatesOrderBy = {
  createdAt?: InputMaybe<OrderTypes>;
};

export type FindUserTemplatesWhere = {
  _and?: InputMaybe<Array<FindUserTemplatesWhere>>;
  _or?: InputMaybe<Array<FindUserTemplatesWhere>>;
  templateId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ClonePageVersionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  typeVersion?: InputMaybe<TypeVersion>;
  versionId: Scalars['String']['input'];
};

export enum TypeVersion {
  Date = 'Date',
  Major = 'Major',
  Minor = 'Minor'
}

export enum ActionCloneVersion {
  Create = 'Create',
  Error = 'Error',
  Modify = 'Modify'
}

export type NavigationValidationReport = {
  __typename?: 'NavigationValidationReport';
  errorItems: Scalars['Float']['output'];
  items: Array<NavigationItemValidationResult>;
  navigationBarId: Scalars['String']['output'];
  totalItems: Scalars['Float']['output'];
  validItems: Scalars['Float']['output'];
  warningItems: Scalars['Float']['output'];
};

export type NavigationItemValidationResult = {
  __typename?: 'NavigationItemValidationResult';
  code?: Maybe<NavigationValidationCode>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  routeType?: Maybe<Scalars['String']['output']>;
  status: NavigationValidationStatus;
  targetValue?: Maybe<Scalars['String']['output']>;
};

export enum NavigationValidationCode {
  DynamicPageNoBlocks = 'DYNAMIC_PAGE_NO_BLOCKS',
  DynamicPageNotFound = 'DYNAMIC_PAGE_NOT_FOUND',
  DynamicPageNotPublished = 'DYNAMIC_PAGE_NOT_PUBLISHED',
  ExternalUrlInvalidFormat = 'EXTERNAL_URL_INVALID_FORMAT',
  ExternalUrlMissing = 'EXTERNAL_URL_MISSING',
  InternalRouteMissing = 'INTERNAL_ROUTE_MISSING',
  ItemHasChildrenAndLink = 'ITEM_HAS_CHILDREN_AND_LINK',
  LinkNotConfigured = 'LINK_NOT_CONFIGURED',
  MicrositeNotFound = 'MICROSITE_NOT_FOUND'
}

export enum NavigationValidationStatus {
  Error = 'ERROR',
  Valid = 'VALID',
  Warning = 'WARNING'
}

export type ValidateUserRequestInput = {
  email: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
};

export type ValidateTokenInput = {
  token: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDependenciesToSchema: Array<ContentSchemaDependency>;
  applyFullTemplate: PageDynamic;
  applyTemplateBlocks: PageDynamic;
  assignUsersToContentSchema: AssignUsersToContentSchemaResponse;
  auth0JWTUpdateUser: Auth0Response;
  /** Assign multiple users as editors to a PageDynamic */
  bulkAssignEditors: Array<Editor>;
  /** Actualiza masivamente valores de metadata en múltiples documentos */
  bulkUpdateMetadataValues: BulkUpdateMetadataResponse;
  checkUserRecord: Scalars['String']['output'];
  clonePageToTemplate: PageDynamic;
  clonePageVersion: PageVersion;
  cloneSharedTemplate: PageDynamic;
  cloneSliderByStyle: Array<SliderItem>;
  codeConfirmation: User;
  createCabinetDetailInput: CabinetDetail;
  createCarouselSlide: CarouselSlide;
  createChildDocument: DocumentEntity;
  createContentSchema: ContentSchema;
  createContentSchemaDependency: ContentSchemaDependency;
  createContentSchemaField: ContentSchemaField;
  createDefaultRoles: Array<Role>;
  createDependency: Dependency;
  createDocument: DocumentEntity;
  createDocumentMetadata: DocumentMetadata;
  createDocumentType: DocumentType;
  createDummiesX: Array<Dummy>;
  createDummy: Dummy;
  createEditor: Editor;
  createEventsItem: EventsItem;
  createGroup: Group;
  createHistory: History;
  createInstitutionalProgramsItem: InstitutionalProgramsItem;
  createMainDependency: Dependency;
  /** Crear un nuevo bloque de mapa interactivo */
  createMapBlock: PageMapBlock;
  createMultiKeyRegister: MultikeyRegister;
  /** Crea múltiples dependencias de usuario de una vez */
  createMultipleUserDependencies: CreateMultipleUserDependencyResponse;
  createNavItem: NavigationItem;
  createNewsItem: NewsItem;
  createNotification: Notification;
  createNotificationConfig: NotificationConfig;
  createNotificationGroup: NotificationGroup;
  createPageBlock: Array<PageBlockUnion>;
  createPageBlockDefault: PageBlock;
  createPageBlockItem: Array<PageBlockItemUnion>;
  createPageDynamic: PageDynamic;
  createPageLinkInput: PageLink;
  createPageVersion: PageVersion;
  createParameter: Parameter;
  createPartialUserRequest: UserRequest;
  createPosition: Position;
  createProcedure: Procedure;
  createProfile: Profile;
  createRegulation: Regulation;
  createRole: Role;
  createRoleAndPermissions: Role;
  createServer: Server;
  createSliderItem: SliderItem;
  createUser: User;
  createUserContentSchemaAssignment: UserContentSchemaAssignment;
  createUserDependency: UserDependency;
  createUserRequest: UserRequest;
  createUserTemplate: UserTemplate;
  /** Elimina un item de acordeón con estrategia para manejar hijos: mover al padre, mover a otro padre, o eliminar en cascada */
  deleteAccordionBlockItemWithStrategy: DeleteAccordionBlockItemResponse;
  /** Eliminar un bloque de mapa interactivo */
  deleteMapBlock: Scalars['Boolean']['output'];
  /** Elimina un item de navegación con estrategia: MOVE_CHILDREN_TO_PARENT, MOVE_CHILDREN_TO_OTHER_PARENT o DELETE_CASCADE */
  deleteNavigationItemWithStrategy: DeleteNavigationItemResponse;
  duplicatePageDynamic: PageDynamic;
  duplicateTemplate: PageDynamic;
  enableAndDisableDoubleVerification: Scalars['String']['output'];
  /** Crea SEO y SeoMetadata (español) para todas las entidades huérfanas. Slugs con conflicto reciben sufijo numérico. */
  executeSeoBackfill: SeoBackfillResponseDto;
  expireCredentials: Array<User>;
  forceRecoverPassword: Scalars['String']['output'];
  forceSyncCarouselSlides: Scalars['String']['output'];
  i18nTest: Scalars['String']['output'];
  incrementDocumentDownload: Scalars['Boolean']['output'];
  /** Migración masiva: reconstruye Nested Set para TODOS los PageNavigationBar existentes. Use dryRun=true para previsualizar. */
  migrateAllNavigationBarsToNestedSet: MigrationResultModel;
  /** Ejecuta migración de documentos entre listas con mapeo de campos configurado */
  migrateDocuments: DocumentMigrationResponse;
  /** Mueve un item de acordeón a una nueva posición usando Nested Set Model */
  moveAccordionBlockItem: PageAccordionBlockItem;
  /** Mueve un item de navegación a una nueva posición usando Nested Set Model (drag & drop optimizado) */
  moveNavigationItem: NavigationItem;
  reassignUserContentSchema: UserContentSchemaAssignment;
  /** Reconstruye el árbol Nested Set desde campos legacy */
  rebuildAccordionNestedSet: Scalars['String']['output'];
  /** Reconstruye el árbol Nested Set desde las relaciones parent/children existentes (migración). Use dryRun=true para previsualizar cambios sin aplicarlos. */
  rebuildNavigationNestedSet: RebuildNestedSetResultModel;
  /** Recompila el campo searchableMetadata para todos los documentos (útil para migraciones o mantenimiento) */
  recompileAllDocumentsMetadata: Scalars['Int']['output'];
  /** Recovers all blocks in a page dynamic to a specific point in history */
  recoverPageDynamic: Scalars['Boolean']['output'];
  /** Recovers all blocks in a page dynamic to a specific point in history */
  recoverPageDynamicVersion: Scalars['Boolean']['output'];
  recoverPassword: Scalars['String']['output'];
  removeCabinetDetail: CabinetDetail;
  removeContentSchema: ContentSchema;
  removeContentSchemaDependency: ContentSchemaDependency;
  removeContentSchemaField: ContentSchemaField;
  removeContentSharing: ContentSharing;
  removeDependenciesFromSchema: Array<ContentSchemaDependency>;
  removeDependency: Dependency;
  removeDocument: DocumentEntity;
  removeDocumentMetadata: DocumentMetadata;
  removeDocumentType: DocumentType;
  removeDummy: Dummy;
  removeEditor: Editor;
  removeEventsItem: EventsItem;
  removeFunctionality: Functionality;
  removeGroup: Group;
  removeHistory: History;
  removeInstitutionalProgramsItem: InstitutionalProgramsItem;
  removeMultiKeyRegister: MultikeyRegister;
  /** Elimina el GIF de lenguaje de señas de un elemento de navegación */
  removeNavigationItemSignLanguage: NavigationItem;
  removeNavItem: NavigationItem;
  removeNewsItem: NewsItem;
  removeNotification: Notification;
  removeNotificationConfig: NotificationConfig;
  removePageBlock: PageBlockUnion;
  removePageBlockItem: PageBlockItemUnion;
  removePageDynamic: PageDynamic;
  removePageLink: PageLink;
  removePageVersion: PageVersion;
  removeParameter: Parameter;
  removePosition: Position;
  removeProcedure: Procedure;
  removeProfile: Profile;
  removeRegulation: Regulation;
  removeRole: Role;
  removeServer: Server;
  removeSliderItem: SliderItem;
  removeUser: User;
  removeUserContentSchemaAssignment: UserContentSchemaAssignment;
  removeUserDependency: UserDependency;
  removeUserRequest: UserRequest;
  removeUserTemplate: UserTemplate;
  resendCodeConfirmation: Scalars['String']['output'];
  resendConfirmationCode: UserRequest;
  resetSuperAdmin: User;
  selectPageVersion: PageVersion;
  sendCodeDoubleVerification: Scalars['String']['output'];
  sentryTestMutation: Scalars['String']['output'];
  shareContent: Array<ContentSharing>;
  shareTemplate: Scalars['Boolean']['output'];
  signin: AuthResponse;
  signInAdmin: AuthResponse;
  SignInWithOAuth: AuthResponse;
  synchronizeFunctionalities: Scalars['String']['output'];
  synchronizePageBlocks: Scalars['String']['output'];
  toggleSlideState: CarouselSlide;
  unshareTemplate: Scalars['Boolean']['output'];
  updateAuditClient: AuditClient;
  updateCabinetDetailInput: CabinetDetail;
  updateCarouselSlide: CarouselSlide;
  updateContentSchema: ContentSchema;
  updateContentSchemaDependency: ContentSchemaDependency;
  updateContentSchemaField: ContentSchemaField;
  updateContentSharing: ContentSharing;
  updateDependency: Dependency;
  updateDocument: DocumentEntity;
  updateDocumentMetadata: DocumentMetadata;
  /** Actualiza el campo searchableMetadata para un documento específico */
  updateDocumentSearchableMetadata: Scalars['Boolean']['output'];
  updateDocumentType: DocumentType;
  updateDummy: Dummy;
  updateEditor: Editor;
  updateEventsItem: EventsItem;
  updateEventStatusToDraft: Scalars['String']['output'];
  updateFunctionality: Functionality;
  updateGroup: Group;
  updateHistory: History;
  updateInstitutionalProgramsItem: InstitutionalProgramsItem;
  updateInstitutionalProgramsSliderItemOrders: Array<PageInstitutionalProgramsSliderBlockItem>;
  updateInstitutionalProgramsStatusToDraft: Scalars['String']['output'];
  /** Actualizar un bloque de mapa interactivo existente */
  updateMapBlock: PageMapBlock;
  updateMultiKeyRegister: MultikeyRegister;
  /** Actualiza el campo searchableMetadata para múltiples documentos */
  updateMultipleDocumentsMetadata: Scalars['Boolean']['output'];
  updateNavigationItemOrders: Array<NavigationItem>;
  /** Actualiza el GIF de lenguaje de señas y su descripción para un elemento de navegación */
  updateNavigationItemSignLanguage: NavigationItem;
  updateNavItem: NavigationItem;
  updateNewsItem: NewsItem;
  updateNewsStatusToDraft: Scalars['String']['output'];
  updateNotification: Notification;
  updateNotificationConfig: NotificationConfig;
  updatePageBlock: Array<PageBlockUnion>;
  updatePageBlockItem: Array<PageBlockItemUnion>;
  updatePageBlockItemOrders: Array<PageBlockItem>;
  updatePageBlockOrders: Array<PageBlock>;
  updatePageDynamic: PageDynamic;
  updatePageLinkInput: PageLink;
  updatePageVersion: PageVersion;
  updateParameter: Parameter;
  updatePassword: User;
  updatePosition: Position;
  updateProcedure: Procedure;
  updateProcedureStatusToDraft: Scalars['String']['output'];
  updateProfile: Profile;
  updateRegulation: Regulation;
  updateRegulationStatusToDraft: Scalars['String']['output'];
  updateRole: Role;
  updateRoleAndPermissions: Role;
  updateServer: Server;
  updateSlideImage: CarouselSlide;
  updateSliderItemInput: SliderItem;
  updateSliderItemOrders: Array<SliderItem>;
  updateUser: User;
  updateUserContentSchemaAssignment: UserContentSchemaAssignment;
  updateUserDependency: UserDependency;
  updateUserInformation: User;
  updateUserPassword: User;
  updateUserProfile: User;
  updateUserRequest: UserRequest;
  updateUserTemplate: UserTemplate;
  validateCodeUserRequest: User;
};


export type MutationAddDependenciesToSchemaArgs = {
  input: BatchAddDependenciesInput;
};


export type MutationApplyFullTemplateArgs = {
  input: ApplyFullTemplateInput;
};


export type MutationApplyTemplateBlocksArgs = {
  input: ApplyTemplateBlocInput;
};


export type MutationAssignUsersToContentSchemaArgs = {
  input: AssignUsersToContentSchemaInput;
};


export type MutationAuth0JwtUpdateUserArgs = {
  Auth0Token: Scalars['String']['input'];
  UserInfo: UpdateStatusUserAuth0;
};


export type MutationBulkAssignEditorsArgs = {
  isActive?: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pageDynamicId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};


export type MutationBulkUpdateMetadataValuesArgs = {
  input: BulkUpdateMetadataInput;
};


export type MutationClonePageToTemplateArgs = {
  input: ClonePageToTemplateInput;
};


export type MutationClonePageVersionArgs = {
  createInput: ClonePageVersionInput;
};


export type MutationCloneSharedTemplateArgs = {
  input: CloneSharedTemplateInput;
};


export type MutationCloneSliderByStyleArgs = {
  cloneSliderStyleArg: CloneSliderStyleArg;
};


export type MutationCodeConfirmationArgs = {
  createInput: CodeConfirmationInput;
};


export type MutationCreateCabinetDetailInputArgs = {
  createInput: CreateCabinetDetailInput;
};


export type MutationCreateCarouselSlideArgs = {
  input: CreateCarouselSlideManualInput;
};


export type MutationCreateChildDocumentArgs = {
  createInput: CreateDocumentInput;
  parentId: Scalars['String']['input'];
};


export type MutationCreateContentSchemaArgs = {
  createInput: CreateContentSchemaInput;
};


export type MutationCreateContentSchemaDependencyArgs = {
  createInput: CreateContentSchemaDependencyInput;
};


export type MutationCreateContentSchemaFieldArgs = {
  createInput: CreateContentSchemaFieldInput;
};


export type MutationCreateDependencyArgs = {
  createInput: CreateDependencyInput;
};


export type MutationCreateDocumentArgs = {
  createInput: CreateDocumentInput;
};


export type MutationCreateDocumentMetadataArgs = {
  createInput: CreateDocumentMetadataInput;
};


export type MutationCreateDocumentTypeArgs = {
  createInput: CreateDocumentTypeInput;
};


export type MutationCreateDummyArgs = {
  createInput: CreateDummyInput;
};


export type MutationCreateEditorArgs = {
  createInput: CreateEditorInput;
};


export type MutationCreateEventsItemArgs = {
  createInput: CreateEventsItemInput;
};


export type MutationCreateGroupArgs = {
  createInput: CreateGroupInput;
};


export type MutationCreateHistoryArgs = {
  createInput: CreateHistoryInput;
};


export type MutationCreateInstitutionalProgramsItemArgs = {
  createInput: CreateInstitutionalProgramsItemInput;
};


export type MutationCreateMapBlockArgs = {
  input: CreatePageMapBlockInput;
};


export type MutationCreateMultiKeyRegisterArgs = {
  createInput: CreateMultikeyRegisterInput;
};


export type MutationCreateMultipleUserDependenciesArgs = {
  input: CreateMultipleUserDependencyInput;
};


export type MutationCreateNavItemArgs = {
  createInput: CreateNavigationItemInput;
};


export type MutationCreateNewsItemArgs = {
  createInput: CreateNewsItemInput;
};


export type MutationCreateNotificationArgs = {
  createInput: CreateNotificationInput;
};


export type MutationCreateNotificationConfigArgs = {
  createInput: CreateNotificationConfigInput;
};


export type MutationCreateNotificationGroupArgs = {
  createInput: CreateNotificationGroupInput;
};


export type MutationCreatePageBlockArgs = {
  input: CreatePageBlockInputUnion;
};


export type MutationCreatePageBlockDefaultArgs = {
  input: CreateDefaultPageBlockInput;
};


export type MutationCreatePageBlockItemArgs = {
  input: CreatePageBlockItemInputUnion;
};


export type MutationCreatePageDynamicArgs = {
  createInput: CreatePageDynamicInput;
};


export type MutationCreatePageLinkInputArgs = {
  createInput: CreatePageLinkInput;
};


export type MutationCreatePageVersionArgs = {
  createInput: CreatePageVersionInput;
};


export type MutationCreateParameterArgs = {
  createInput: CreateParameterInput;
};


export type MutationCreatePartialUserRequestArgs = {
  createPartialUserRequestInput: CreatePartialUserRequestInput;
};


export type MutationCreatePositionArgs = {
  createInput: CreatePositionInput;
};


export type MutationCreateProcedureArgs = {
  createInput: CreateProcedureInput;
};


export type MutationCreateProfileArgs = {
  createInput: CreateProfileInput;
};


export type MutationCreateRegulationArgs = {
  createInput: CreateRegulationInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRoleAndPermissionsArgs = {
  createRoleAndPermissionsInput: CreateRoleAndPermissionsInput;
};


export type MutationCreateServerArgs = {
  input: CreateServerInput;
};


export type MutationCreateSliderItemArgs = {
  createInput: CreateSliderItemInput;
};


export type MutationCreateUserArgs = {
  createInput: CreateUserInput;
};


export type MutationCreateUserContentSchemaAssignmentArgs = {
  createInput: CreateUserContentSchemaAssignmentInput;
};


export type MutationCreateUserDependencyArgs = {
  createInput: CreateUserDependencyInput;
};


export type MutationCreateUserRequestArgs = {
  createUserRequestInput: CreateUserRequestInput;
};


export type MutationCreateUserTemplateArgs = {
  createInput: CreateUserTemplateInput;
};


export type MutationDeleteAccordionBlockItemWithStrategyArgs = {
  input: DeleteAccordionBlockItemInput;
};


export type MutationDeleteMapBlockArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNavigationItemWithStrategyArgs = {
  input: DeleteNavigationItemInput;
};


export type MutationDuplicatePageDynamicArgs = {
  input: DuplicatePageDynamicInput;
};


export type MutationDuplicateTemplateArgs = {
  input: DuplicateTemplateInput;
};


export type MutationEnableAndDisableDoubleVerificationArgs = {
  doubleVerificationInput: DoubleVerificationInput;
};


export type MutationExpireCredentialsArgs = {
  expireCredentialsInput: ExpireCredentialsInput;
};


export type MutationForceRecoverPasswordArgs = {
  recoverPasswordInput: RecoverPasswordInput;
};


export type MutationIncrementDocumentDownloadArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationMigrateAllNavigationBarsToNestedSetArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationMigrateDocumentsArgs = {
  input: DocumentMigrationInput;
};


export type MutationMoveAccordionBlockItemArgs = {
  input: MoveAccordionBlockItemInput;
};


export type MutationMoveNavigationItemArgs = {
  input: MoveNavigationItemInput;
};


export type MutationReassignUserContentSchemaArgs = {
  dependencies: Array<Scalars['String']['input']>;
  newContentSchemaId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRebuildAccordionNestedSetArgs = {
  accordionBlockId: Scalars['ID']['input'];
};


export type MutationRebuildNavigationNestedSetArgs = {
  dryRun?: Scalars['Boolean']['input'];
  navigationBarId: Scalars['ID']['input'];
};


export type MutationRecompileAllDocumentsMetadataArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRecoverPageDynamicArgs = {
  historyId: Scalars['String']['input'];
  pageDynamicId: Scalars['String']['input'];
};


export type MutationRecoverPageDynamicVersionArgs = {
  historyId: Scalars['String']['input'];
  pageDynamicId: Scalars['String']['input'];
};


export type MutationRecoverPasswordArgs = {
  recoverPasswordInput: RecoverPasswordInput;
};


export type MutationRemoveCabinetDetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentSchemaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentSchemaDependencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentSchemaFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentSharingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDependenciesFromSchemaArgs = {
  dependencyIds: Array<Scalars['String']['input']>;
  schemaId: Scalars['String']['input'];
};


export type MutationRemoveDependencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDocumentMetadataArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDocumentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDummyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveEditorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveEventsItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFunctionalityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveInstitutionalProgramsItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMultiKeyRegisterArgs = {
  id: MultikeyRegisterIdInput;
};


export type MutationRemoveNavigationItemSignLanguageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveNavItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveNewsItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveNotificationConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePageBlockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePageBlockItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePageDynamicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePageLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePageVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveParameterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePositionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveProcedureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveRegulationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveServerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSliderItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserContentSchemaAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserDependencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendCodeConfirmationArgs = {
  resendCodeConfirmationInput: ResendCodeConfirmationInput;
};


export type MutationResendConfirmationCodeArgs = {
  resendConfirmationCodeInput: ResendConfirmationCodeInput;
};


export type MutationSelectPageVersionArgs = {
  selectPageVersionInput: SelectPageVersionInput;
};


export type MutationSendCodeDoubleVerificationArgs = {
  sendDoubleVerificationInput: SendDoubleVerificationInput;
};


export type MutationSentryTestMutationArgs = {
  dummySentryInput: DummySentryInput;
};


export type MutationShareContentArgs = {
  input: ShareContentInput;
};


export type MutationShareTemplateArgs = {
  input: ShareTemplateInput;
};


export type MutationSigninArgs = {
  signinInput: SigninInput;
};


export type MutationSignInAdminArgs = {
  signInAdminInput: SigninAdminInput;
};


export type MutationSignInWithOAuthArgs = {
  googleSigninInput: GoogleSigninInput;
};


export type MutationSynchronizePageBlocksArgs = {
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  locations: Array<BlockLocation>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  subPage?: InputMaybe<SubPages>;
  versionId: Scalars['ID']['input'];
};


export type MutationToggleSlideStateArgs = {
  isEnabled: Scalars['Boolean']['input'];
  slideId: Scalars['String']['input'];
};


export type MutationUnshareTemplateArgs = {
  input: UnshareTemplateInput;
};


export type MutationUpdateAuditClientArgs = {
  updateInput: UpdateAuditClientInput;
};


export type MutationUpdateCabinetDetailInputArgs = {
  updateInput: UpdateCabinetDetailInput;
};


export type MutationUpdateCarouselSlideArgs = {
  input: UpdateCarouselSlideInput;
};


export type MutationUpdateContentSchemaArgs = {
  updateInput: UpdateContentSchemaInput;
};


export type MutationUpdateContentSchemaDependencyArgs = {
  updateInput: UpdateContentSchemaDependencyInput;
};


export type MutationUpdateContentSchemaFieldArgs = {
  updateInput: UpdateContentSchemaFieldInput;
};


export type MutationUpdateContentSharingArgs = {
  updateInput: UpdateContentSharingInput;
};


export type MutationUpdateDependencyArgs = {
  updateInput: UpdateDependencyInput;
};


export type MutationUpdateDocumentArgs = {
  updateInput: UpdateDocumentInput;
};


export type MutationUpdateDocumentMetadataArgs = {
  updateInput: UpdateDocumentMetadataInput;
};


export type MutationUpdateDocumentSearchableMetadataArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationUpdateDocumentTypeArgs = {
  updateInput: UpdateDocumentTypeInput;
};


export type MutationUpdateDummyArgs = {
  updateInput: UpdateDummyInput;
};


export type MutationUpdateEditorArgs = {
  updateInput: UpdateEditorInput;
};


export type MutationUpdateEventsItemArgs = {
  updateInput: UpdateEventsItemInput;
};


export type MutationUpdateEventStatusToDraftArgs = {
  updateEventStatusToDraft: UpdateEventItemStatus;
};


export type MutationUpdateFunctionalityArgs = {
  updateInput: UpdateFunctionalityInput;
};


export type MutationUpdateGroupArgs = {
  updateInput: UpdateGroupInput;
};


export type MutationUpdateHistoryArgs = {
  updateInput: UpdateHistoryInput;
};


export type MutationUpdateInstitutionalProgramsItemArgs = {
  updateInput: UpdateInstitutionalProgramsItemInput;
};


export type MutationUpdateInstitutionalProgramsSliderItemOrdersArgs = {
  input: UpdateInstitutionalProgramsSliderItemsInput;
};


export type MutationUpdateInstitutionalProgramsStatusToDraftArgs = {
  updateInstitutionalProgramsItemStatus: UpdateInstitutionalProgramsItemStatus;
};


export type MutationUpdateMapBlockArgs = {
  input: UpdatePageMapBlockInput;
};


export type MutationUpdateMultiKeyRegisterArgs = {
  updateInput: UpdateMultikeyRegisterInput;
};


export type MutationUpdateMultipleDocumentsMetadataArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateNavigationItemOrdersArgs = {
  input: Array<UpdateNavigationItemInput>;
};


export type MutationUpdateNavigationItemSignLanguageArgs = {
  input: UpdateNavigationItemSignLanguageInput;
};


export type MutationUpdateNavItemArgs = {
  updateInput: UpdateNavigationItemInput;
};


export type MutationUpdateNewsItemArgs = {
  updateInput: UpdateNewsItemInput;
};


export type MutationUpdateNewsStatusToDraftArgs = {
  updateNewsStatusToDraft: UpdateNewsItemStatus;
};


export type MutationUpdateNotificationArgs = {
  updateInput: UpdateNotificationInput;
};


export type MutationUpdateNotificationConfigArgs = {
  updateInput: UpdateNotificationConfigInput;
};


export type MutationUpdatePageBlockArgs = {
  input: UpdatePageBlockInputUnion;
};


export type MutationUpdatePageBlockItemArgs = {
  input: UpdatePageBlockItemInputUnion;
};


export type MutationUpdatePageBlockItemOrdersArgs = {
  input: Array<UpdateOrderPageBlockItemInput>;
};


export type MutationUpdatePageBlockOrdersArgs = {
  input: Array<UpdateOrderPageBlockInput>;
};


export type MutationUpdatePageDynamicArgs = {
  updateInput: UpdatePageDynamicInput;
};


export type MutationUpdatePageLinkInputArgs = {
  updateInput: CreatePageLinkInput;
};


export type MutationUpdatePageVersionArgs = {
  updateInput: UpdatePageVersionInput;
};


export type MutationUpdateParameterArgs = {
  updateInput: UpdateParameterInput;
};


export type MutationUpdatePasswordArgs = {
  updatePasswordInput: UpdatePasswordInput;
};


export type MutationUpdatePositionArgs = {
  updateInput: UpdatePositionInput;
};


export type MutationUpdateProcedureArgs = {
  updateInput: UpdateProcedureInput;
};


export type MutationUpdateProcedureStatusToDraftArgs = {
  updateProcedureStatusToDraft: UpdateProcedureStatusToDraft;
};


export type MutationUpdateProfileArgs = {
  updateInput: UpdateProfileInput;
};


export type MutationUpdateRegulationArgs = {
  updateInput: UpdateRegulationInput;
};


export type MutationUpdateRegulationStatusToDraftArgs = {
  updateRegulationStatusToDraft: UpdateRegulationStatus;
};


export type MutationUpdateRoleArgs = {
  updateInput: UpdateRoleInput;
};


export type MutationUpdateRoleAndPermissionsArgs = {
  updateRoleAndPermissionsInput: UpdateRoleAndPermissionsInput;
};


export type MutationUpdateServerArgs = {
  input: UpdateServerInput;
};


export type MutationUpdateSlideImageArgs = {
  imageFileId: Scalars['String']['input'];
  slideId: Scalars['String']['input'];
};


export type MutationUpdateSliderItemInputArgs = {
  updateInput: UpdateSliderItemInput;
};


export type MutationUpdateSliderItemOrdersArgs = {
  input: UpdateSliderItemsInput;
};


export type MutationUpdateUserArgs = {
  updateInput: UpdateUserInput;
};


export type MutationUpdateUserContentSchemaAssignmentArgs = {
  updateInput: UpdateUserContentSchemaAssignmentInput;
};


export type MutationUpdateUserDependencyArgs = {
  updateInput: UpdateUserDependencyInput;
};


export type MutationUpdateUserInformationArgs = {
  updateUserInformationInput: UpdateUserInformationInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserPasswordInput: UpdateUserPasswordInput;
};


export type MutationUpdateUserProfileArgs = {
  updateUserInformationInput: UpdateUserInformationInput;
};


export type MutationUpdateUserRequestArgs = {
  updateInput: UpdateUserRequestInput;
};


export type MutationUpdateUserTemplateArgs = {
  updateInput: UpdateUserTemplateInput;
};


export type MutationValidateCodeUserRequestArgs = {
  validateUserCodeRequestInput: ValidateUserCodeRequestInput;
};

export type BatchAddDependenciesInput = {
  canEdit?: Scalars['Boolean']['input'];
  contentSchemaId: Scalars['String']['input'];
  dependencyIds: Array<Scalars['String']['input']>;
};

export type ApplyFullTemplateInput = {
  pageId: Scalars['ID']['input'];
  replaceBlocks: Scalars['Boolean']['input'];
  templateId: Scalars['ID']['input'];
};

export type ApplyTemplateBlocInput = {
  blockIds: Array<Scalars['ID']['input']>;
  pageId: Scalars['ID']['input'];
  replaceBlocks: Scalars['Boolean']['input'];
  templateId: Scalars['ID']['input'];
};

export type AssignUsersToContentSchemaInput = {
  contentSchemaId: Scalars['String']['input'];
  userIds: Array<AssignUserDependencyInput>;
};

export type AssignUserDependencyInput = {
  canAssociateAnyDependency?: InputMaybe<Scalars['Boolean']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type AssignUsersToContentSchemaResponse = {
  __typename?: 'AssignUsersToContentSchemaResponse';
  assignments: Array<UserContentSchemaAssignment>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  totalAssigned: Scalars['Float']['output'];
};

export type UpdateStatusUserAuth0 = {
  id: Scalars['String']['input'];
  identificationNumber: Scalars['String']['input'];
  identificationType: UserDocumentTypes;
  password: Scalars['String']['input'];
};

export type BulkUpdateMetadataInput = {
  /** Nuevo valor a asignar */
  newValue: Scalars['String']['input'];
  /** Valor antiguo a buscar. Usar "__EMPTY__" para actualizar valores nulos o vacíos. Campo obligatorio. */
  oldValue: Scalars['String']['input'];
  /** ID del campo del esquema */
  schemaFieldId: Scalars['String']['input'];
  /** ID del esquema de contenido */
  schemaId: Scalars['String']['input'];
};

export type BulkUpdateMetadataResponse = {
  __typename?: 'BulkUpdateMetadataResponse';
  /** IDs de los documentos afectados */
  affectedDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Mensaje descriptivo del resultado */
  message?: Maybe<Scalars['String']['output']>;
  /** Indica si la operación fue exitosa */
  success: Scalars['Boolean']['output'];
  /** Cantidad de registros actualizados */
  updatedCount: Scalars['Int']['output'];
};

export type ClonePageToTemplateInput = {
  /** Si se deben clonar los bloques */
  cloneBlocks?: Scalars['Boolean']['input'];
  /** ID de la dependencia para la nueva entidad */
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  /** Descripción para la nueva entidad */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nombre para la nueva entidad */
  name: Scalars['String']['input'];
  /** ID del padre para la nueva entidad */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** ID de la entidad fuente a clonar */
  sourceId: Scalars['ID']['input'];
  /** ID de la carpeta de plantillas donde ubicar la nueva plantilla */
  templateFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type CloneSharedTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  templateId: Scalars['ID']['input'];
};

export type CloneSliderStyleArg = {
  fromStyle: PageBlockStyles;
  pageBlockId: Scalars['ID']['input'];
  toStyle: PageBlockStyles;
};

export type CodeConfirmationInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type CreateCabinetDetailInput = {
  cabinetDetailImageId?: InputMaybe<Scalars['ID']['input']>;
  cabinetDetailLink?: InputMaybe<CreatePageLinkInput>;
  cabinetDetailName?: InputMaybe<Scalars['String']['input']>;
  cabinetDetailStatus?: InputMaybe<VersionStates>;
  cabinetItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePageLinkInput = {
  arguments?: InputMaybe<Array<Scalars['String']['input']>>;
  routeNavigation?: InputMaybe<SubPages>;
  routeType?: InputMaybe<RouterType>;
  target?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCarouselSlideManualInput = {
  activeFrom: Scalars['String']['input'];
  activeTo: Scalars['String']['input'];
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageFileId: Scalars['String']['input'];
  slideId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: CarouselSlideType;
  version: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  contentDate?: InputMaybe<Scalars['String']['input']>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  downloadText?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
  isParentDocument?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<CreateContentMetadataInput>>;
  parentDocumentId?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  schemaId: Scalars['String']['input'];
  /** Metadata SEO para motores de búsqueda */
  seoInput?: InputMaybe<CreateSeoInput>;
  status: ContentStatus;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailImageId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: TypeContent;
};

export type CreateContentMetadataInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  jsonValue?: InputMaybe<Scalars['String']['input']>;
  schemaFieldId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSeoInput = {
  /** Lista de metadata SEO por idioma. Al menos un idioma es requerido. */
  metadata: Array<CreateSeoMetadataInput>;
};

export type CreateSeoMetadataInput = {
  /** Idioma de la metadata SEO */
  language: Language;
  /** Descripción SEO para motores de búsqueda */
  metaDescription: Scalars['String']['input'];
  /** Título SEO para motores de búsqueda */
  metaTitle: Scalars['String']['input'];
  /** Slug único para la URL (se normalizará automáticamente) */
  slug: Scalars['String']['input'];
};

export type CreateContentSchemaInput = {
  allowChildren?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<TypeContent>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CreateContentSchemaFieldInput>>;
  hierarchyLabel?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isGroup?: Scalars['Boolean']['input'];
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  parentSchemaId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContentSchemaFieldInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  fieldLabel: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  fieldType: FieldType;
  isActive?: Scalars['Boolean']['input'];
  isGroup?: Scalars['Boolean']['input'];
  isRequired?: Scalars['Boolean']['input'];
  options?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: Scalars['Int']['input'];
  schemaId?: InputMaybe<Scalars['String']['input']>;
  validationRules?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContentSchemaDependencyInput = {
  canEdit?: Scalars['Boolean']['input'];
  contentSchemaId: Scalars['String']['input'];
  dependencyId: Scalars['String']['input'];
  isActive?: Scalars['Boolean']['input'];
  isPrimary?: Scalars['Boolean']['input'];
};

export type CreateDependencyInput = {
  name: Scalars['String']['input'];
  status: DependencyStatus;
  type: DependencyType;
};

export type CreateDocumentMetadataInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  jsonValue?: InputMaybe<Scalars['String']['input']>;
  schemaFieldId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDocumentTypeInput = {
  document: Scalars['String']['input'];
};

export type CreateDummyInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstField: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  secondField: Scalars['DateTime']['input'];
  thirdField: Scalars['Float']['input'];
};

export type CreateEditorInput = {
  /** Custom assignment date (defaults to current date if not provided) */
  assignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether this editor assignment should be active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional notes about this editor assignment */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the PageDynamic page */
  pageDynamicId: Scalars['ID']['input'];
  /** The unique identifier of the user to assign as editor */
  userId: Scalars['ID']['input'];
};

export type CreateEventsItemInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  descriptionPlace?: InputMaybe<Scalars['String']['input']>;
  dynamicView?: InputMaybe<Scalars['Boolean']['input']>;
  emailEvent?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  eventItemDescription: Scalars['String']['input'];
  eventItemTags?: InputMaybe<Array<Scalars['String']['input']>>;
  eventItemTitle: Scalars['String']['input'];
  eventStatus?: InputMaybe<EventStates>;
  groupEvent?: InputMaybe<Scalars['String']['input']>;
  hasRecurring?: InputMaybe<PageEventFrequency>;
  hasShare?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  multimediaType?: InputMaybe<MultimediaTypes>;
  parentId: Scalars['ID']['input'];
  paymentTypeEvent?: InputMaybe<EventPaymentType>;
  phoneEvent?: InputMaybe<Scalars['String']['input']>;
  seeMore?: InputMaybe<Scalars['String']['input']>;
  /** Metadata SEO para motores de búsqueda */
  seoInput?: InputMaybe<CreateSeoInput>;
  shareIconId?: InputMaybe<Scalars['ID']['input']>;
  shareLink?: InputMaybe<Scalars['String']['input']>;
  shareText?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeEvent?: InputMaybe<EvenType>;
};

export type CreateGroupInput = {
  name: Scalars['String']['input'];
  notificationConfigId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateHistoryInput = {
  /** The unique identifier of the user who made the change */
  changedById: Scalars['ID']['input'];
  /** MongoDB ObjectId reference for JSON version data */
  dataId?: InputMaybe<Scalars['String']['input']>;
  /** IP address from which the change was made */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the PageDynamic page */
  pageDynamicId: Scalars['ID']['input'];
};

export type CreateInstitutionalProgramsItemInput = {
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  pageLink?: InputMaybe<CreatePageLinkInput>;
  programsStatus?: InputMaybe<VersionStates>;
  programsType: ProgramsTypes;
  seeMoreAction: Scalars['String']['input'];
  seeMoreLink: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreatePageMapBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Coordenadas del centro en formato JSON: {lat, lng} */
  centerCoordinates?: InputMaybe<Scalars['String']['input']>;
  /** Color de borde por defecto (formato hex) */
  defaultBorderColor?: InputMaybe<Scalars['String']['input']>;
  /** Color de relleno por defecto (formato hex) */
  defaultFillColor?: InputMaybe<Scalars['String']['input']>;
  /** Código DANE del departamento (requerido para mapas municipales) */
  departmentCode?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  /** Configuración de los elementos del mapa en formato JSON */
  elementsConfig?: InputMaybe<Scalars['String']['input']>;
  /** Datos GeoJSON para mapas personalizados */
  geoJsonData?: InputMaybe<Scalars['String']['input']>;
  /** Altura del mapa en píxeles */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Nivel de zoom inicial (1-18) */
  initialZoom?: InputMaybe<Scalars['Int']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  /** Tipo de mapa: DEPARTMENTAL, MUNICIPAL o CUSTOM */
  mapType: MapType;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreateMultikeyRegisterInput = {
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id: MultikeyRegisterIdInput;
};

export type CreateMultipleUserDependencyInput = {
  dependencyId: Scalars['ID']['input'];
  status?: InputMaybe<UserDependencyStatus>;
  /** Array de usuarios con tipo */
  users: Array<UserIdWithTypeInput>;
};

export type UserIdWithTypeInput = {
  /** ID de usuario */
  id: Scalars['ID']['input'];
  /** Tipo de dependencia del usuario */
  type: UserDependencyType;
};

export type CreateMultipleUserDependencyResponse = {
  __typename?: 'CreateMultipleUserDependencyResponse';
  /** Indica si la operación fue exitosa */
  success: Scalars['Boolean']['output'];
};

export type CreateNavigationItemInput = {
  description: Scalars['String']['input'];
  iconId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  name: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  signLanguageDescription?: InputMaybe<Scalars['String']['input']>;
  signLanguageGifId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NavigationItemType>;
};

export type CreateNewsItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  expiredDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica si la noticia tiene fecha de vencimiento. true = vence, false = no vence (permanente) */
  hasExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imageLink?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  multimediaType?: InputMaybe<MultimediaTypes>;
  newsItemTags?: InputMaybe<Array<Scalars['String']['input']>>;
  newsStatus?: InputMaybe<VersionStates>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata SEO para motores de búsqueda */
  seoInput?: InputMaybe<CreateSeoInput>;
  summary: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateNotificationInput = {
  emailRecipients?: InputMaybe<Array<EmailRecipient>>;
  hasPersistent: Scalars['Boolean']['input'];
  metadata: Scalars['String']['input'];
  notificationGroupId?: InputMaybe<Scalars['ID']['input']>;
  notificationGroupName?: InputMaybe<Scalars['ID']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  smsRecipient?: InputMaybe<SmsRecipient>;
  stateNotification: StateNotification;
  statePersistent: StatePersistent;
  subtypeConfig?: InputMaybe<Scalars['String']['input']>;
  type: TypeNotification;
  typeConfig?: InputMaybe<NotificationType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  wssRecipient?: InputMaybe<WssRecipient>;
};

export type EmailRecipient = {
  email: Scalars['String']['input'];
  type: RecipientType;
};

export enum RecipientType {
  Bcc = 'Bcc',
  Cc = 'Cc',
  Destinatary = 'Destinatary'
}

export type SmsRecipient = {
  email?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type WssRecipient = {
  document?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phonePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNotificationConfigInput = {
  emailDuplicateCode?: InputMaybe<Scalars['String']['input']>;
  emailPrincipalCode?: InputMaybe<Scalars['String']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasPush?: InputMaybe<Scalars['Boolean']['input']>;
  hasSms?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsPush?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsSms?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsWss?: InputMaybe<Scalars['Boolean']['input']>;
  hasWss?: InputMaybe<Scalars['Boolean']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  smsBody?: InputMaybe<Scalars['String']['input']>;
  subtype: Scalars['String']['input'];
  type: NotificationType;
  wssCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNotificationGroupInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  metadata: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notificationConfigId: Scalars['ID']['input'];
};

export type CreatePageBlockInputUnion = {
  accessibilityBar?: InputMaybe<CreatePageAccessibilityBarInput>;
  accessibilityButton?: InputMaybe<CreatePageAccessibilityButtonInput>;
  accordionBlock?: InputMaybe<CreatePageAccordionBlockInput>;
  alertsBlock?: InputMaybe<CreatePageAlertsBlockInput>;
  attentionLinesBlock?: InputMaybe<CreatePageAttentionLinesBlockInput>;
  authenticationBar?: InputMaybe<CreatePageAuthenticationBarInput>;
  cabinetBlock?: InputMaybe<CreatePageCabinetBlockInput>;
  corporateLogosBlock?: InputMaybe<CreatePageCorporateLogosBlockInput>;
  customBlock?: InputMaybe<CreatePageCustomBlockInput>;
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  eventsBlock?: InputMaybe<CreatePageEventsBlockInput>;
  eventSliderBlock?: InputMaybe<CreatePageEventSliderBlockInput>;
  footerBar?: InputMaybe<CreatePageFooterBarInput>;
  headerBar?: InputMaybe<CreatePageHeaderBarInput>;
  headerOrganizationBar?: InputMaybe<CreatePageHeaderOrganizationBarInput>;
  institutionalProgramsSliderBlock?: InputMaybe<CreatePageInstitutionalProgramsSliderBlockInput>;
  institutionalProgramsTypesBlock?: InputMaybe<CreatePageInstitutionalProgramsTypesBlockInput>;
  mapBlock?: InputMaybe<CreatePageMapBlockInput>;
  navigationBar?: InputMaybe<CreatePageNavigationBarInput>;
  newsletterBlock?: InputMaybe<CreatePageNewsletterBlockInput>;
  participateDownloadBlock?: InputMaybe<CreatePageParticipateDownloadBlockInput>;
  participateElementBlock?: InputMaybe<CreatePageParticipateElementBlockInput>;
  participateHeaderBlock?: InputMaybe<CreatePageParticipateHeaderBlockInput>;
  pqrsdfActionBlock?: InputMaybe<CreatePagePqrsdfActionBlockInput>;
  pqrsdfConsultBlock?: InputMaybe<CreatePagePqrsdfConsultBlockInput>;
  pressroomBlock?: InputMaybe<CreatePagePressroomBlockInput>;
  procedureFeedbackBlock?: InputMaybe<CreatePageProcedureFeedbackBlockInput>;
  procedureHeaderBlock?: InputMaybe<CreatePageProcedureHeaderBlockInput>;
  procedureMainBlock?: InputMaybe<CreatePageProcedureMainBlockInput>;
  proceduresBlock?: InputMaybe<CreatePageProceduresBlockInput>;
  quickAccessBar?: InputMaybe<CreatePageQuickAccessBarInput>;
  regulationsBlock?: InputMaybe<CreatePageRegulationsBlockInput>;
  searchBlock?: InputMaybe<CreatePageSearchBlockInput>;
  sliderBlock?: InputMaybe<CreatePageSliderBlockInput>;
  snsBlock?: InputMaybe<CreatePageSnsBlockInput>;
  socialNetworksBlock?: InputMaybe<CreatePageSocialNetworkBlockInput>;
  styledTableBlock?: InputMaybe<CreatePageStyledTableBlockInput>;
  subDownloadBlock?: InputMaybe<CreatePageSubDownloadBlockInput>;
  subHeaderBlock?: InputMaybe<CreatePageSubHeaderBlockInput>;
  taxesBlock?: InputMaybe<CreatePageTaxesBlockInput>;
  transparencyBlock?: InputMaybe<CreatePageTransparencyBlockInput>;
  transparencyHeaderBlock?: InputMaybe<CreatePageTransparencyHeaderBlockInput>;
};

export type CreatePageAccessibilityBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageAccessibilityButtonInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Color del botón */
  buttonColor?: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Estado de habilitación */
  isEnabled?: Scalars['Boolean']['input'];
  location?: InputMaybe<BlockLocation>;
  /** Máximo de items */
  maxItems?: Scalars['Int']['input'];
  /** Índice de orden */
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Título del bloque */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Texto del tooltip */
  tooltipText?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageAccordionBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  /** IDs de dependencias para filtrar el contenido del acordeón. Si está vacío o null, muestra contenido de todas las dependencias. */
  filterDependencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Número de dígitos por nivel en el índice jerárquico (1-3). Ej: 2 → "01", "0101" */
  indexDigitLength?: InputMaybe<Scalars['Int']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showViewButton?: InputMaybe<Scalars['Boolean']['input']>;
  subtype: TypeAccordion;
  versionId: Scalars['ID']['input'];
};

export type CreatePageAlertsBlockInput = {
  /** Tipo de acción del botón */
  actionType?: InputMaybe<ActionType>;
  /** Descripción detallada de la alerta */
  alertDescription?: InputMaybe<Scalars['String']['input']>;
  /** Estilo visual de la alerta */
  alertStyle: PageBlockStyles;
  /** Comportamiento del enlace */
  behaviorType?: InputMaybe<BehaviorType>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Texto del botón de redirección */
  buttonTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  /** Frecuencia de visualización */
  displayFrequency: DisplayFrequency;
  /** Plantilla HTML para renderizar la alerta */
  htmlTemplate?: InputMaybe<Scalars['String']['input']>;
  /** ID de la imagen (SVG o PNG) */
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enlace de redirección */
  linkItem?: InputMaybe<CreatePageLinkInput>;
  location?: InputMaybe<BlockLocation>;
  /** Alto del modal (valor numérico) */
  modalHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Unidad de medida del tamaño del modal (px, vh, vw, %) */
  modalSizeUnit?: InputMaybe<ModalSizeUnit>;
  /** Ancho del modal (valor numérico) */
  modalWidth?: InputMaybe<Scalars['Int']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Título de la alerta */
  title: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageAttentionLinesBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageAuthenticationBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasSignin?: InputMaybe<Scalars['Boolean']['input']>;
  hasSignup?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageCabinetBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  cabinetSeeMoreAction: Scalars['String']['input'];
  cabinetSeeMoreActionLink: Scalars['String']['input'];
  cabinetSubtitle?: InputMaybe<Scalars['String']['input']>;
  cabinetTitle: Scalars['String']['input'];
  description: Scalars['String']['input'];
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  isCarrousel?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageCorporateLogosBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageCustomBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageEventsBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hasDependencyFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasScheduleInteractive?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeeMore?: InputMaybe<Scalars['Boolean']['input']>;
  includeSharedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkItemId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  seeMoreText?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageEventSliderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageFooterBarInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  administrationLogoId?: InputMaybe<Scalars['ID']['input']>;
  administrationLogoLink?: InputMaybe<Scalars['String']['input']>;
  adminOtherLogoId?: InputMaybe<Scalars['ID']['input']>;
  adminOtherLogoLink?: InputMaybe<Scalars['String']['input']>;
  antiCorruptionLine?: InputMaybe<Scalars['String']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  campusData?: InputMaybe<Scalars['String']['input']>;
  citizenLine?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  html: Scalars['String']['input'];
  institutionalEmail?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  judicialEmail?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<BlockLocation>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoLink?: InputMaybe<Scalars['String']['input']>;
  nit?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageHeaderBarInput = {
  administrationLogoId?: InputMaybe<Scalars['ID']['input']>;
  administrationLogoLink?: InputMaybe<Scalars['String']['input']>;
  adminOtherLogoId?: InputMaybe<Scalars['ID']['input']>;
  adminOtherLogoLink?: InputMaybe<Scalars['String']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  govcoLink?: InputMaybe<CreatePageLinkInput>;
  hasGovcoLogo: Scalars['Boolean']['input'];
  hasLanguageIcon: Scalars['Boolean']['input'];
  hasSearchbar: Scalars['Boolean']['input'];
  hasSignin: Scalars['Boolean']['input'];
  hasSignup: Scalars['Boolean']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoLink?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  placeholder: Scalars['String']['input'];
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  signinName?: InputMaybe<Scalars['String']['input']>;
  signupName?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageHeaderOrganizationBarInput = {
  adminAnotherLink?: InputMaybe<CreatePageLinkInput>;
  administrationLogoId?: InputMaybe<Scalars['ID']['input']>;
  adminLogoLink?: InputMaybe<CreatePageLinkInput>;
  adminOtherLogoId?: InputMaybe<Scalars['ID']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoImageLink?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageInstitutionalProgramsSliderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageInstitutionalProgramsTypesBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageNavigationBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageNewsletterBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hasDependencyFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasSearchbarNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  includeSharedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  newsletterDescription?: InputMaybe<Scalars['String']['input']>;
  newsletterTags?: InputMaybe<Array<Scalars['String']['input']>>;
  newsletterTitle: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  tagStyle?: InputMaybe<PageBlockStyles>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageParticipateDownloadBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageParticipateElementBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageParticipateHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  participateDescription: Scalars['String']['input'];
  participateIntroduction?: InputMaybe<Scalars['String']['input']>;
  participateTitle: Scalars['String']['input'];
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePagePqrsdfActionBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePagePqrsdfConsultBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePagePressroomBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageProcedureFeedbackBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageProcedureHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  procedureDescription: Scalars['String']['input'];
  procedureTitle: Scalars['String']['input'];
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageProcedureMainBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageProceduresBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  descriptionProcedures: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreAction: Scalars['String']['input'];
  seeMoreActionLink: Scalars['String']['input'];
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  titleProcedures: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageQuickAccessBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isCarrousel?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerView?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink: Scalars['String']['input'];
  seeMoreTitle: Scalars['String']['input'];
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageRegulationsBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  descriptionRegulation?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreRegulations?: InputMaybe<Scalars['String']['input']>;
  seeMoreRegulationsLink?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subPages?: InputMaybe<Array<SubPages>>;
  titleRegulation: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageSearchBlockInput = {
  /** Aplicar filtro automático por dependencia según contexto */
  autoFilterByDependency?: InputMaybe<Scalars['Boolean']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contexto del bloque */
  contextType?: InputMaybe<SearchContextType>;
  description: Scalars['String']['input'];
  /** Incluir contenido de otras dependencias (solo para header de página principal) */
  includeOtherDependencies?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  /** Número máximo de resultados a mostrar */
  maxResults?: InputMaybe<Scalars['Float']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  /** Texto placeholder del campo de búsqueda */
  placeholder?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  /** Fuentes de búsqueda habilitadas (debe seleccionar al menos una) */
  searchSources: Array<SearchSourceType>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageSliderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageSnsBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageSocialNetworkBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreAction: Scalars['String']['input'];
  seeMoreLink: Scalars['String']['input'];
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageStyledTableBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  contentType: TableContentType;
  description: Scalars['String']['input'];
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  externalEndpoint?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  tableStyle: TableStyleType;
  title: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageSubDownloadBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subDownloadDescription?: InputMaybe<Scalars['String']['input']>;
  subDownloadPlaceholder?: InputMaybe<Scalars['String']['input']>;
  subDownloadSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  subDownloadTitle: Scalars['String']['input'];
  subPages?: InputMaybe<Array<SubPages>>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageSubHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDates?: InputMaybe<Scalars['Boolean']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subHeaderDescription?: InputMaybe<Scalars['String']['input']>;
  subHeaderIntroduction?: InputMaybe<Scalars['String']['input']>;
  subHeaderPlaceholder?: InputMaybe<Scalars['String']['input']>;
  subHeaderSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  subHeaderTitle?: InputMaybe<Scalars['String']['input']>;
  subPages?: InputMaybe<Array<SubPages>>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageTaxesBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  taxSectionTitle: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};

export type CreatePageTransparencyBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasLinkVideo?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkVideo?: InputMaybe<CreatePageLinkInput>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  transparencyContent?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreatePageTransparencyHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  transparencyDescription?: InputMaybe<Scalars['String']['input']>;
  transparencyPlaceholder?: InputMaybe<Scalars['String']['input']>;
  transparencyTitle?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['ID']['input'];
};

export type CreateDefaultPageBlockInput = {
  description: Scalars['String']['input'];
  dynamicId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlock: PageBlockEnum;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  subPages?: InputMaybe<Array<SubPages>>;
  versionId: Scalars['String']['input'];
};

export enum PageBlockEnum {
  AccessibilityButton = 'accessibilityButton',
  AccordionBlock = 'accordionBlock',
  AlertsBlock = 'alertsBlock',
  CabinetBlock = 'cabinetBlock',
  CustomBlock = 'customBlock',
  EventsBlock = 'eventsBlock',
  EventSliderBlock = 'eventSliderBlock',
  InstitutionalProgramsSliderBlock = 'institutionalProgramsSliderBlock',
  InstitutionalProgramsTypesBlock = 'institutionalProgramsTypesBlock',
  MapBlock = 'mapBlock',
  NavigationBar = 'navigationBar',
  NewsletterBlock = 'newsletterBlock',
  ParticipateDownloadBlock = 'participateDownloadBlock',
  ParticipateElementBlock = 'participateElementBlock',
  ParticipateHeaderBlock = 'participateHeaderBlock',
  PqrsdfActionBlock = 'pqrsdfActionBlock',
  PqrsdfConsultBlock = 'pqrsdfConsultBlock',
  PressroomBlock = 'pressroomBlock',
  ProcedureFeedbackBlock = 'procedureFeedbackBlock',
  ProcedureHeaderBlock = 'procedureHeaderBlock',
  ProcedureMainBlock = 'procedureMainBlock',
  ProceduresBlock = 'proceduresBlock',
  QuickAccessBar = 'quickAccessBar',
  RegulationsBlock = 'regulationsBlock',
  SearchBlock = 'searchBlock',
  SliderBlock = 'sliderBlock',
  SnsBlock = 'snsBlock',
  SocialNetworksBlock = 'socialNetworksBlock',
  StyledTableBlock = 'styledTableBlock',
  SubDownloadBlock = 'subDownloadBlock',
  SubHeaderBlock = 'subHeaderBlock',
  TaxesBlock = 'taxesBlock',
  TransparencyBlock = 'transparencyBlock',
  TransparencyHeaderBlock = 'transparencyHeaderBlock'
}

export type CreatePageBlockItemInputUnion = {
  accessibilityButtonItem?: InputMaybe<CreatePageAccessibilityButtonItemInput>;
  accordionBlockItem?: InputMaybe<CreatePageAccordionBlockItemInput>;
  attentionLinesBlockItem?: InputMaybe<CreatePageAttentionLinesBlockItemInput>;
  cabinetBlockItem?: InputMaybe<CreatePageCabinetBlockItemInput>;
  corporateLogosBlockItem?: InputMaybe<CreatePageCorporateLogosBlockItemInput>;
  eventSliderBlockItem?: InputMaybe<CreatePageEventsSliderBlockItemInput>;
  footerBarItem?: InputMaybe<CreatePageFooterBarItemInput>;
  institutionalProgramsSliderBlockItem?: InputMaybe<CreatePageInstitutionalProgramsSliderBlockItemInput>;
  institutionalProgramsTypesBlockItem?: InputMaybe<CreatePageInstitutionalProgramsTypesBlockItemInput>;
  participateElementBlockItem?: InputMaybe<CreatePageParticipateElementBlockItemInput>;
  quickAccessBarItem?: InputMaybe<CreatePageQuickAccessBarItemInput>;
  regulationBlockItem?: InputMaybe<CreatePageRegulationsBlockItemInput>;
  snsBlockItem?: InputMaybe<CreatePageSnsBlockItemInput>;
  socialNetworksBlockLeftItem?: InputMaybe<CreatePageSocialNetworksBlockLeftItemInput>;
  socialNetworksBlockRightItem?: InputMaybe<CreatePageSocialNetworksBlockRightItemInput>;
  styledTableBlockItem?: InputMaybe<CreatePageStyledTableBlockItemInput>;
  styledTableBlockRow?: InputMaybe<CreatePageStyledTableBlockRowInput>;
  subDownloadBlockItem?: InputMaybe<CreateSubPageDownloadBlockItemInput>;
  taxesBlockItem?: InputMaybe<CreatePageTaxesBlockItemInput>;
  transparencyBlockItem?: InputMaybe<CreatePageTransparencyBlockItemInput>;
};

export type CreatePageAccessibilityButtonItemInput = {
  /** Texto alternativo para accesibilidad (max 100 caracteres) */
  altText: Scalars['String']['input'];
  description: Scalars['String']['input'];
  /** Orden de visualización (1-8) */
  displayOrder?: Scalars['Int']['input'];
  /** Tipo de icono */
  iconType: AccessibilityIconType;
  /** Estado de activación */
  isActive?: Scalars['Boolean']['input'];
  /** Configuración de enlace */
  linkItem?: InputMaybe<CreatePageLinkInput>;
  /** Nombre del enlace (max 50 caracteres) */
  linkName: Scalars['String']['input'];
  /** URL de respaldo (deprecated) */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageAccordionBlockItemInput = {
  configJson?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['String']['input']>;
  indexTitle?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  schemaId?: InputMaybe<Scalars['String']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  subtype?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePageAttentionLinesBlockItemInput = {
  description: Scalars['String']['input'];
  iconId?: InputMaybe<Scalars['ID']['input']>;
  iconLink?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageCabinetBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  cabinetDescription: Scalars['String']['input'];
  cabinetEmail?: InputMaybe<Scalars['String']['input']>;
  cabinetImageId?: InputMaybe<Scalars['ID']['input']>;
  cabinetImageLink?: InputMaybe<Scalars['String']['input']>;
  cabinetName: Scalars['String']['input'];
  cabinetOrder?: InputMaybe<Scalars['String']['input']>;
  cabinetPhone?: InputMaybe<Scalars['String']['input']>;
  cabinetPositionId?: InputMaybe<Scalars['ID']['input']>;
  cabinetStatus?: InputMaybe<Scalars['String']['input']>;
  curriculumVitaeLink?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageCorporateLogosBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  corporateLogoId?: InputMaybe<Scalars['ID']['input']>;
  corporateLogoLink?: InputMaybe<Scalars['String']['input']>;
  corporateLogoName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageEventsSliderBlockItemInput = {
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  seeMoreAction: Scalars['String']['input'];
  seeMoreLink: Scalars['String']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  title: Scalars['String']['input'];
};

export type CreatePageFooterBarItemInput = {
  anotherCampusData?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  footerType: FooterItemType;
  hasAnoterCampusData?: InputMaybe<Scalars['Boolean']['input']>;
  hasSocialNetworkIcon?: InputMaybe<Scalars['Boolean']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageDirectory?: InputMaybe<Scalars['String']['input']>;
  pageDirectoryLink?: InputMaybe<CreatePageLinkInput>;
  parentId: Scalars['ID']['input'];
  routeType: RouterType;
  socialNetworkIconId?: InputMaybe<Scalars['ID']['input']>;
  socialNetworkLink?: InputMaybe<Scalars['String']['input']>;
  socialNetworkName?: InputMaybe<Scalars['ID']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageInstitutionalProgramsSliderBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  seeMoreAction: Scalars['String']['input'];
  seeMoreLink: Scalars['String']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  tags: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePageInstitutionalProgramsTypesBlockItemInput = {
  alternativeText: Scalars['String']['input'];
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  programsType?: InputMaybe<ProgramsTypes>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  title: Scalars['String']['input'];
};

export type CreatePageParticipateElementBlockItemInput = {
  description: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  participateElementImageId: Scalars['ID']['input'];
  participateElementTitle: Scalars['String']['input'];
  participateLinkAction?: InputMaybe<CreatePageLinkInput>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageQuickAccessBarItemInput = {
  description: Scalars['String']['input'];
  imageId: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  quickAccessName: Scalars['String']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageRegulationsBlockItemInput = {
  /** Configuración JSON para ordenamiento y agrupación */
  configJson?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  itemDescription: Scalars['String']['input'];
  itemIconId?: InputMaybe<Scalars['ID']['input']>;
  itemName: Scalars['String']['input'];
  itemType: RegulationType;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageSnsBlockItemInput = {
  description: Scalars['String']['input'];
  itemLink?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  snsSocialNetworkType: SocialNetworkType;
  snsTitle: Scalars['String']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageSocialNetworksBlockLeftItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imageLink?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageSocialNetworksBlockRightItemInput = {
  description: Scalars['String']['input'];
  hasRightItem?: Scalars['Boolean']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  socialNetworkType?: InputMaybe<SocialNetworkType>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageStyledTableBlockItemInput = {
  allowFilter?: InputMaybe<Scalars['Boolean']['input']>;
  allowSort?: InputMaybe<Scalars['Boolean']['input']>;
  columnName?: InputMaybe<Scalars['String']['input']>;
  columnWidth?: InputMaybe<Scalars['Float']['input']>;
  configJson?: InputMaybe<Scalars['String']['input']>;
  contentSchemaFieldId?: InputMaybe<Scalars['String']['input']>;
  dataType?: InputMaybe<ColumnDataType>;
  description: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageStyledTableBlockRowInput = {
  cellData?: InputMaybe<Array<CreatePageStyledTableBlockRowDataInput>>;
  description: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageStyledTableBlockRowDataInput = {
  columnId?: InputMaybe<Scalars['String']['input']>;
  extendedValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubPageDownloadBlockItemInput = {
  description: Scalars['String']['input'];
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageTaxesBlockItemInput = {
  description: Scalars['String']['input'];
  image_id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  taxTitle: Scalars['String']['input'];
};

export type CreatePageTransparencyBlockItemInput = {
  description: Scalars['String']['input'];
  itemDescription: Scalars['String']['input'];
  itemIconId?: InputMaybe<Scalars['ID']['input']>;
  itemTitle: Scalars['String']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type CreatePageDynamicInput = {
  configJson?: InputMaybe<Scalars['String']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata SEO para motores de búsqueda */
  seoInput?: InputMaybe<CreateSeoInput>;
  type?: InputMaybe<PageDynamicType>;
};

export type CreatePageVersionInput = {
  description: Scalars['String']['input'];
  theme?: InputMaybe<Theme>;
};

export type CreateParameterInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  character?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  longCharacter?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  type: TypeParameter;
};

export type CreatePartialUserRequestInput = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreatePositionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProcedureInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actionLink?: InputMaybe<Scalars['String']['input']>;
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  cost: CostTypes;
  date?: InputMaybe<Scalars['String']['input']>;
  duration: DurationTypes;
  estimatedDuration?: InputMaybe<Scalars['Int']['input']>;
  gocvoLogoName: Scalars['String']['input'];
  govcoImageId?: InputMaybe<Scalars['ID']['input']>;
  govcoLink?: InputMaybe<CreatePageLinkInput>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  linkVideo?: InputMaybe<CreatePageLinkInput>;
  modality: ModalityTypes;
  multimediaType?: InputMaybe<MultimediaTypes>;
  name: Scalars['ID']['input'];
  procedureDescription: Scalars['String']['input'];
  procedureStatus?: InputMaybe<VersionStates>;
  procedureTags?: InputMaybe<Array<Scalars['String']['input']>>;
  procedureTypes?: InputMaybe<ProcedureTypes>;
  processDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Controla la visibilidad del botón de GovCo */
  showGovcoButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controla la visibilidad del botón del trámite */
  showProcedureButton?: InputMaybe<Scalars['Boolean']['input']>;
  tagsProcedure?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateProfileInput = {
  city: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  region: Scalars['Int']['input'];
};

export type CreateRegulationInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dependencyId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  documentDate: Scalars['DateTime']['input'];
  downloadText: Scalars['String']['input'];
  fileId: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  pageLinkDocument?: InputMaybe<CreatePageLinkInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulationStatus?: InputMaybe<VersionStates>;
  /** Metadata SEO para motores de búsqueda */
  seoInput?: InputMaybe<CreateSeoInput>;
  title: Scalars['String']['input'];
  type: RegulationType;
};

export type CreateRoleInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateRoleAndPermissionsInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type CreateServerInput = {
  app?: InputMaybe<ServerApp>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<ServerEnvironment>;
  host?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ServerStatus>;
};

export type CreateSliderItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle: PageBlockStyles;
  parentId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  credentialsExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateIssue?: InputMaybe<Scalars['DateTime']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  hasRural?: InputMaybe<Scalars['Boolean']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
  lastName: Scalars['String']['input'];
  legalRepresentative?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['ValidatePassword']['input']>;
  passwordStatus?: InputMaybe<PasswordStatusTypes>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rolesId?: InputMaybe<Array<Scalars['String']['input']>>;
  secondSurname?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserTypes>;
};

export type CreateUserContentSchemaAssignmentInput = {
  canAssociateAnyDependency?: InputMaybe<Scalars['Boolean']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  contentSchemaId: Scalars['String']['input'];
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateUserDependencyInput = {
  dependencyId: Scalars['ID']['input'];
  status?: InputMaybe<UserDependencyStatus>;
  /** Field of the user dependency type */
  type?: InputMaybe<UserDependencyType>;
  userId: Scalars['ID']['input'];
};

export type CreateUserRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  confirmationEmail: Scalars['String']['input'];
  confirmPassword?: InputMaybe<Scalars['ValidatePassword']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateIssue?: InputMaybe<Scalars['DateTime']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  hasRural?: InputMaybe<Scalars['Boolean']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
  lastName: Scalars['String']['input'];
  legalRepresentative?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['ValidatePassword']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  secondSurname?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserTemplateInput = {
  templateId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteAccordionBlockItemInput = {
  /** ID del item a eliminar */
  itemId: Scalars['ID']['input'];
  /** ID del nuevo padre para los hijos (requerido solo si strategy es MOVE_CHILDREN_TO_OTHER_PARENT) */
  newParentId?: InputMaybe<Scalars['ID']['input']>;
  /** Estrategia de eliminación: MOVE_CHILDREN_TO_PARENT, MOVE_CHILDREN_TO_OTHER_PARENT o DELETE_CASCADE */
  strategy: DeletionStrategy;
};

/** Estrategia de eliminación para items de acordeón */
export enum DeletionStrategy {
  DeleteCascade = 'DELETE_CASCADE',
  MoveChildrenToOtherParent = 'MOVE_CHILDREN_TO_OTHER_PARENT',
  MoveChildrenToParent = 'MOVE_CHILDREN_TO_PARENT'
}

export type DeleteAccordionBlockItemResponse = {
  __typename?: 'DeleteAccordionBlockItemResponse';
  /** IDs de todos los items eliminados */
  deletedItemIds: Array<Scalars['String']['output']>;
  /** Número total de items eliminados */
  deletedItemsCount: Scalars['Int']['output'];
  /** Mensaje descriptivo de la operación realizada */
  message: Scalars['String']['output'];
  /** IDs de los items movidos */
  movedItemIds: Array<Scalars['String']['output']>;
  /** Número de items que fueron movidos */
  movedItemsCount: Scalars['Int']['output'];
};

export type DeleteNavigationItemInput = {
  /** ID del item a eliminar */
  itemId: Scalars['ID']['input'];
  /** ID del nuevo padre para los hijos (requerido solo si strategy es MOVE_CHILDREN_TO_OTHER_PARENT) */
  newParentId?: InputMaybe<Scalars['ID']['input']>;
  /** Estrategia de eliminación: MOVE_CHILDREN_TO_PARENT, MOVE_CHILDREN_TO_OTHER_PARENT o DELETE_CASCADE */
  strategy: DeletionStrategy;
};

/** Respuesta de eliminación de item de navegación */
export type DeleteNavigationItemResponse = {
  __typename?: 'DeleteNavigationItemResponse';
  /** IDs de los items eliminados */
  deletedItemIds: Array<Scalars['String']['output']>;
  /** Cantidad de items eliminados */
  deletedItemsCount: Scalars['Int']['output'];
  /** Mensaje descriptivo del resultado */
  message: Scalars['String']['output'];
  /** IDs de los items movidos */
  movedItemIds: Array<Scalars['String']['output']>;
  /** Cantidad de items movidos (si aplica según estrategia) */
  movedItemsCount: Scalars['Int']['output'];
};

export type DuplicatePageDynamicInput = {
  /** Si se deben clonar los bloques */
  cloneBlocks?: Scalars['Boolean']['input'];
  /** ID de la dependencia para la nueva entidad */
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  /** Descripción para la nueva entidad */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Si mantener el mismo padre que la entidad original */
  keepSameParent?: Scalars['Boolean']['input'];
  /** Nombre para la nueva entidad */
  name: Scalars['String']['input'];
  /** ID del padre para la nueva entidad */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** ID de la entidad fuente a clonar */
  sourceId: Scalars['ID']['input'];
};

export type DuplicateTemplateInput = {
  /** Si se deben clonar los bloques */
  cloneBlocks?: Scalars['Boolean']['input'];
  /** ID de la dependencia para la nueva entidad */
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  /** Descripción para la nueva entidad */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Si mantener el mismo padre que la plantilla original */
  keepSameParent?: Scalars['Boolean']['input'];
  /** Nombre para la nueva entidad */
  name: Scalars['String']['input'];
  /** ID del padre para la nueva entidad */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** ID de la entidad fuente a clonar */
  sourceId: Scalars['ID']['input'];
  /** ID de la carpeta de plantillas donde ubicar la plantilla duplicada */
  templateFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type DoubleVerificationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  emailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  phoneVerification?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Respuesta del backfill de SEO */
export type SeoBackfillResponseDto = {
  __typename?: 'SeoBackfillResponseDto';
  /** Resultados para DocumentEntity */
  documents: EntityBackfillResultDto;
  /** Resultados para EventsItem */
  eventsItems: EntityBackfillResultDto;
  /** Tiempo total de ejecución en segundos */
  executionTimeSeconds: Scalars['Float']['output'];
  /** Mensaje resumen de la operación */
  message: Scalars['String']['output'];
  /** Resultados para NewsItem */
  newsItems: EntityBackfillResultDto;
  /** Resultados para PageDynamic */
  pageDynamics: EntityBackfillResultDto;
  /** Resultados para Regulation */
  regulations: EntityBackfillResultDto;
  /** Slugs que tuvieron conflictos y requirieron sufijo */
  slugConflicts: Array<SlugConflictDto>;
  /** Indica si la operación fue exitosa */
  success: Scalars['Boolean']['output'];
};

/** Resultado del backfill para un tipo de entidad */
export type EntityBackfillResultDto = {
  __typename?: 'EntityBackfillResultDto';
  /** Lista de IDs con error y mensaje */
  errorDetails: Array<EntityErrorDetailDto>;
  /** Total de entidades con errores */
  errors: Scalars['Int']['output'];
  /** Total de entidades procesadas exitosamente */
  processed: Scalars['Int']['output'];
  /** Total de entidades sin SEO encontradas */
  totalOrphans: Scalars['Int']['output'];
};

/** Detalle de error en una entidad */
export type EntityErrorDetailDto = {
  __typename?: 'EntityErrorDetailDto';
  entityId: Scalars['String']['output'];
  error: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Detalle de un conflicto de slug resuelto */
export type SlugConflictDto = {
  __typename?: 'SlugConflictDto';
  /** Número de intentos hasta encontrar slug disponible */
  attempts: Scalars['Int']['output'];
  /** ID de la entidad */
  entityId: Scalars['String']['output'];
  /** Tipo de entidad */
  entityType: Scalars['String']['output'];
  /** Slug final asignado (con sufijo) */
  finalSlug: Scalars['String']['output'];
  /** Slug original que generó conflicto */
  originalSlug: Scalars['String']['output'];
  /** Título original de la entidad */
  originalTitle: Scalars['String']['output'];
};

export type ExpireCredentialsInput = {
  credentialsExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Array<Scalars['String']['input']>;
};

export type RecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** Resultado de migración masiva de Nested Set */
export type MigrationResultModel = {
  __typename?: 'MigrationResultModel';
  /** Si fue ejecutado en modo dry run */
  dryRun: Scalars['Boolean']['output'];
  /** Cantidad de errores */
  errorCount: Scalars['Int']['output'];
  /** Resultados por NavigationBar */
  results: Array<MigrationBarResultModel>;
  /** Cantidad de migraciones exitosas */
  successCount: Scalars['Int']['output'];
  /** Total de items procesados */
  totalItemsProcessed: Scalars['Int']['output'];
  /** Total de items con cambios */
  totalItemsWithChanges: Scalars['Int']['output'];
  /** Total de NavigationBars procesadas */
  totalNavigationBars: Scalars['Int']['output'];
};

/** Resultado de migración de una NavigationBar individual */
export type MigrationBarResultModel = {
  __typename?: 'MigrationBarResultModel';
  error?: Maybe<Scalars['String']['output']>;
  itemsProcessed: Scalars['Int']['output'];
  itemsWithChanges: Scalars['Int']['output'];
  navigationBarId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DocumentMigrationInput = {
  /** Si es true, realiza la migración. Si es false, solo valida sin ejecutar (dry-run). */
  execute?: Scalars['Boolean']['input'];
  /** Lista de documentos a migrar con su configuración */
  items: Array<DocumentMigrationItemInput>;
};

export type DocumentMigrationItemInput = {
  /** ID del documento a migrar (opcional si se proporciona fileId) */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Mapeos de campos origen → destino. Solo incluir campos que deben mapearse. */
  fieldMappings?: InputMaybe<Array<FieldMappingInput>>;
  /** ID del archivo asociado al documento (opcional si se proporciona documentId). El fileId se preserva. */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** ID del esquema destino */
  targetSchemaId: Scalars['String']['input'];
  /** Transformaciones de valores. Se aplican sobre los campos mapeados. */
  valueTransforms?: InputMaybe<Array<ValueTransformInput>>;
};

export type FieldMappingInput = {
  /** ID del campo en el esquema origen (schemaFieldId actual) */
  sourceFieldId: Scalars['String']['input'];
  /** ID del campo en el esquema destino (nuevo schemaFieldId) */
  targetFieldId: Scalars['String']['input'];
};

export type ValueTransformInput = {
  /** Nuevo valor a asignar */
  newValue: Scalars['String']['input'];
  /** Valor actual a reemplazar */
  oldValue: Scalars['String']['input'];
  /** ID del campo origen donde aplicar la transformación */
  sourceFieldId: Scalars['String']['input'];
};

export type DocumentMigrationResponse = {
  __typename?: 'DocumentMigrationResponse';
  /** Indica si fue dry-run (sin ejecutar cambios) */
  dryRun: Scalars['Boolean']['output'];
  /** Documentos con error */
  errorCount: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  results: Array<DocumentMigrationResult>;
  success: Scalars['Boolean']['output'];
  /** Documentos migrados exitosamente */
  successCount: Scalars['Int']['output'];
  /** Total de documentos procesados */
  totalProcessed: Scalars['Int']['output'];
  /** ID de transacción para tracking/auditoría */
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type DocumentMigrationResult = {
  __typename?: 'DocumentMigrationResult';
  documentId: Scalars['String']['output'];
  documentTitle: Scalars['String']['output'];
  /** Mensaje de error si falló */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Metadatas que fueron migradas exitosamente */
  migratedMetadata?: Maybe<Array<MigratedMetadataDetail>>;
  /** Metadatas que fueron eliminadas (campos sin mapeo) */
  removedMetadata?: Maybe<Array<RemovedMetadataDetail>>;
  sourceSchemaId?: Maybe<Scalars['String']['output']>;
  sourceSchemaName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  targetSchemaId: Scalars['String']['output'];
  targetSchemaName: Scalars['String']['output'];
  /** Advertencias del proceso */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type MigratedMetadataDetail = {
  __typename?: 'MigratedMetadataDetail';
  metadataId: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  sourceFieldId: Scalars['String']['output'];
  sourceFieldName: Scalars['String']['output'];
  targetFieldId: Scalars['String']['output'];
  targetFieldName: Scalars['String']['output'];
  valueTransformed: Scalars['Boolean']['output'];
};

export type RemovedMetadataDetail = {
  __typename?: 'RemovedMetadataDetail';
  fieldId: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  metadataId: Scalars['String']['output'];
  /** Razón de eliminación */
  reason: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MoveAccordionBlockItemInput = {
  /** ID del item a mover */
  itemId: Scalars['ID']['input'];
  /** Posición donde colocar el item: before, after, first-child, last-child */
  position: MovePosition;
  /** ID del item de referencia (target) */
  targetItemId: Scalars['ID']['input'];
};

/** Posición relativa donde mover el item */
export enum MovePosition {
  After = 'After',
  Before = 'Before',
  FirstChild = 'FirstChild',
  LastChild = 'LastChild'
}

export type MoveNavigationItemInput = {
  /** ID del item a mover */
  itemId: Scalars['ID']['input'];
  /** Posición relativa al item destino: before, after, first-child, last-child */
  position: MovePosition;
  /** ID del item de referencia (destino) */
  targetItemId: Scalars['ID']['input'];
};

/** Resultado de rebuild Nested Set (con opción dry run) */
export type RebuildNestedSetResultModel = {
  __typename?: 'RebuildNestedSetResultModel';
  /** Si fue ejecutado en modo dry run (sin guardar cambios) */
  dryRun: Scalars['Boolean']['output'];
  /** Cantidad de items con cambios */
  itemsWithChanges: Scalars['Int']['output'];
  /** Previsualización de cambios por item */
  preview: Array<NestedSetPreviewItemModel>;
  /** Total de items en el árbol */
  totalItems: Scalars['Int']['output'];
};

/** Item de previsualización para rebuild Nested Set */
export type NestedSetPreviewItemModel = {
  __typename?: 'NestedSetPreviewItemModel';
  currentDepth?: Maybe<Scalars['Int']['output']>;
  currentLft?: Maybe<Scalars['Int']['output']>;
  currentRgt?: Maybe<Scalars['Int']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newDepth: Scalars['Int']['output'];
  newLft: Scalars['Int']['output'];
  newRgt: Scalars['Int']['output'];
};

export type ResendCodeConfirmationInput = {
  email: Scalars['String']['input'];
};

export type ResendConfirmationCodeInput = {
  userRequestId: Scalars['String']['input'];
};

export type SelectPageVersionInput = {
  versionId: Scalars['String']['input'];
};

export type SendDoubleVerificationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type DummySentryInput = {
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ShareContentInput = {
  /** Content ID to share */
  contentId: Scalars['String']['input'];
  /** Type of content being shared */
  contentType: ContentType;
  sharingNotes?: InputMaybe<Scalars['String']['input']>;
  /** Array of target dependency IDs to share content with */
  targetDependencyIds: Array<Scalars['String']['input']>;
};

export type ShareTemplateInput = {
  accessType?: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type SigninInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
  password: Scalars['String']['input'];
  personType?: InputMaybe<PersonTypes>;
  verificationDigit?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonTypes {
  Legal = 'Legal',
  Natural = 'Natural'
}

export type SigninAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  verificationTypes?: InputMaybe<VerificationTypes>;
};

export enum VerificationTypes {
  Email = 'Email',
  Phone = 'Phone'
}

export type GoogleSigninInput = {
  /** Token de identificación de Google obtenido del frontend */
  idToken: Scalars['String']['input'];
};

export type UnshareTemplateInput = {
  templateId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UpdateAuditClientInput = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCabinetDetailInput = {
  cabinetDetailImageId?: InputMaybe<Scalars['ID']['input']>;
  cabinetDetailLink?: InputMaybe<CreatePageLinkInput>;
  cabinetDetailName?: InputMaybe<Scalars['String']['input']>;
  cabinetDetailStatus?: InputMaybe<VersionStates>;
  cabinetItemId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateCarouselSlideInput = {
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeTo?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageFileId?: InputMaybe<Scalars['String']['input']>;
  isAdminEnabled: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CarouselSlideType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentSchemaInput = {
  allowChildren?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<TypeContent>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CreateContentSchemaFieldInput>>;
  hierarchyLabel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  maxNestingLevel?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentSchemaId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentSchemaDependencyInput = {
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContentSchemaFieldInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  fieldLabel?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<FieldType>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  validationRules?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentSharingInput = {
  /** Type of content being shared */
  contentType?: InputMaybe<ContentType>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  eventItemId?: InputMaybe<Scalars['String']['input']>;
  newsItemId?: InputMaybe<Scalars['String']['input']>;
  sharingNotes?: InputMaybe<Scalars['String']['input']>;
  /** ID of the dependency that will receive the shared content */
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDependencyInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DependencyStatus>;
  type?: InputMaybe<DependencyType>;
};

export type UpdateDocumentInput = {
  contentDate?: InputMaybe<Scalars['String']['input']>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  downloadText?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isParentDocument?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<CreateContentMetadataInput>>;
  parentDocumentId?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  /** Metadata SEO para motores de búsqueda (crear o actualizar) */
  seoInput?: InputMaybe<UpdateSeoInput>;
  status?: InputMaybe<ContentStatus>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailImageId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TypeContent>;
};

export type UpdateSeoInput = {
  /** ID del SEO padre. Si no se proporciona, se crea uno nuevo. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Array de metadata SEO. Si tienen id se actualizan, si no, se crean. */
  metadata?: InputMaybe<Array<UpdateSeoMetadataInput>>;
};

export type UpdateSeoMetadataInput = {
  /** ID de la metadata a actualizar. Si no se proporciona, se crea una nueva. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Idioma de la metadata SEO */
  language?: InputMaybe<Language>;
  /** Descripción SEO para motores de búsqueda */
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  /** Título SEO para motores de búsqueda */
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  /** Slug único para la URL (se normalizará automáticamente) */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentMetadataInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  jsonValue?: InputMaybe<Scalars['String']['input']>;
  schemaFieldId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentTypeInput = {
  document?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateDummyInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstField?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  secondField?: InputMaybe<Scalars['DateTime']['input']>;
  thirdField?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEditorInput = {
  /** Custom assignment date (defaults to current date if not provided) */
  assignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The unique identifier of the editor assignment to update */
  id: Scalars['ID']['input'];
  /** Whether this editor assignment should be active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional notes about this editor assignment */
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventsItemInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  descriptionPlace?: InputMaybe<Scalars['String']['input']>;
  dynamicView?: InputMaybe<Scalars['Boolean']['input']>;
  emailEvent?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventItemDescription?: InputMaybe<Scalars['String']['input']>;
  eventItemTags?: InputMaybe<Array<Scalars['String']['input']>>;
  eventItemTitle?: InputMaybe<Scalars['String']['input']>;
  eventStatus?: InputMaybe<EventStates>;
  groupEvent?: InputMaybe<Scalars['String']['input']>;
  hasRecurring?: InputMaybe<PageEventFrequency>;
  hasShare?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  multimediaType?: InputMaybe<MultimediaTypes>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  paymentTypeEvent?: InputMaybe<EventPaymentType>;
  phoneEvent?: InputMaybe<Scalars['String']['input']>;
  seeMore?: InputMaybe<Scalars['String']['input']>;
  /** Metadata SEO para motores de búsqueda (crear o actualizar) */
  seoInput?: InputMaybe<UpdateSeoInput>;
  shareIconId?: InputMaybe<Scalars['ID']['input']>;
  shareLink?: InputMaybe<Scalars['String']['input']>;
  shareText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeEvent?: InputMaybe<EvenType>;
};

export type UpdateEventItemStatus = {
  id: Scalars['ID']['input'];
  newsStatus?: InputMaybe<VersionStates>;
};

export type UpdateFunctionalityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notificationConfigId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateHistoryInput = {
  /** MongoDB ObjectId reference for JSON version data */
  dataId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the history entry to update */
  id: Scalars['ID']['input'];
  /** IP address from which the change was made */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInstitutionalProgramsItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  pageLink?: InputMaybe<CreatePageLinkInput>;
  programsStatus?: InputMaybe<VersionStates>;
  programsType?: InputMaybe<ProgramsTypes>;
  seeMoreAction?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInstitutionalProgramsSliderItemsInput = {
  items: Array<UpdateOrderInstitutionalProgramsSliderItemInput>;
};

export type UpdateOrderInstitutionalProgramsSliderItemInput = {
  id: Scalars['ID']['input'];
  orderIndex: Scalars['Int']['input'];
};

export type UpdateInstitutionalProgramsItemStatus = {
  id: Scalars['ID']['input'];
  programsStatus?: InputMaybe<VersionStates>;
};

export type UpdatePageMapBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Coordenadas del centro en formato JSON: {lat, lng} */
  centerCoordinates?: InputMaybe<Scalars['String']['input']>;
  /** Color de borde por defecto (formato hex) */
  defaultBorderColor?: InputMaybe<Scalars['String']['input']>;
  /** Color de relleno por defecto (formato hex) */
  defaultFillColor?: InputMaybe<Scalars['String']['input']>;
  /** Código DANE del departamento (requerido para mapas municipales) */
  departmentCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Configuración de los elementos del mapa en formato JSON */
  elementsConfig?: InputMaybe<Scalars['String']['input']>;
  /** Datos GeoJSON para mapas personalizados */
  geoJsonData?: InputMaybe<Scalars['String']['input']>;
  /** Altura del mapa en píxeles */
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  /** Nivel de zoom inicial (1-18) */
  initialZoom?: InputMaybe<Scalars['Int']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  /** Tipo de mapa: DEPARTMENTAL, MUNICIPAL o CUSTOM */
  mapType?: InputMaybe<MapType>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMultikeyRegisterInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: MultikeyRegisterIdInput;
};

export type UpdateNavigationItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  signLanguageDescription?: InputMaybe<Scalars['String']['input']>;
  signLanguageGifId?: InputMaybe<Scalars['ID']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  type?: InputMaybe<NavigationItemType>;
};

export type UpdateNavigationItemSignLanguageInput = {
  id: Scalars['ID']['input'];
  signLanguageDescription?: InputMaybe<Scalars['String']['input']>;
  signLanguageGifId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNewsItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  expiredDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica si la noticia tiene fecha de vencimiento. true = vence, false = no vence (permanente) */
  hasExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imageLink?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  multimediaType?: InputMaybe<MultimediaTypes>;
  newsItemTags?: InputMaybe<Array<Scalars['String']['input']>>;
  newsStatus?: InputMaybe<VersionStates>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Fecha de publicación opcional. Si se envía, se sobrescribe la fecha existente. Si no se envía y no hay fecha previa, se usa la fecha actual al publicar. */
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Metadata SEO para motores de búsqueda (crear o actualizar) */
  seoInput?: InputMaybe<UpdateSeoInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsItemStatus = {
  id: Scalars['ID']['input'];
  newsStatus?: InputMaybe<VersionStates>;
};

export type UpdateNotificationInput = {
  emailRecipients?: InputMaybe<Array<EmailRecipient>>;
  hasPersistent?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  notificationGroupId?: InputMaybe<Scalars['ID']['input']>;
  notificationGroupName?: InputMaybe<Scalars['ID']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  smsRecipient?: InputMaybe<SmsRecipient>;
  stateNotification?: InputMaybe<StateNotification>;
  statePersistent?: InputMaybe<StatePersistent>;
  subtypeConfig?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TypeNotification>;
  typeConfig?: InputMaybe<NotificationType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  wssRecipient?: InputMaybe<WssRecipient>;
};

export type UpdateNotificationConfigInput = {
  emailDuplicateCode?: InputMaybe<Scalars['String']['input']>;
  emailPrincipalCode?: InputMaybe<Scalars['String']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasPush?: InputMaybe<Scalars['Boolean']['input']>;
  hasSms?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsPush?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsSms?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoStepsWss?: InputMaybe<Scalars['Boolean']['input']>;
  hasWss?: InputMaybe<Scalars['Boolean']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  smsBody?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  wssCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageBlockInputUnion = {
  accessibilityBar?: InputMaybe<UpdatePageAccessibilityBarInput>;
  accessibilityButton?: InputMaybe<UpdatePageAccessibilityButtonInput>;
  accordionBlock?: InputMaybe<UpdatePageAccordionBlockInput>;
  alertsBlock?: InputMaybe<UpdatePageAlertsBlockInput>;
  attentionLinesBlock?: InputMaybe<UpdatePageAttentionLinesBlockInput>;
  authenticationBar?: InputMaybe<UpdatePageAuthenticationBarInput>;
  cabinetBlock?: InputMaybe<UpdatePageCabinetBlockInput>;
  corporateLogosBlock?: InputMaybe<UpdatePageCorporateLogosBlockInput>;
  customBlock?: InputMaybe<UpdatePageCustomBlockInput>;
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  eventsBlock?: InputMaybe<UpdatePageEventsBlockInput>;
  eventSliderBlock?: InputMaybe<UpdatePageEventSliderBlockInput>;
  footerBar?: InputMaybe<UpdatePageFooterBarInput>;
  headerBar?: InputMaybe<UpdatePageHeaderBarInput>;
  headerOrganizationBar?: InputMaybe<UpdatePageHeaderOrganizationBarInput>;
  institutionalProgramsSliderBlock?: InputMaybe<UpdatePageInstitutionalProgramsSliderBlockInput>;
  institutionalProgramsTypesBlock?: InputMaybe<UpdatePageInstitutionalProgramsTypesBlockInput>;
  mapBlock?: InputMaybe<UpdatePageMapBlockInput>;
  navigationBar?: InputMaybe<UpdatePageNavigationBarInput>;
  newsletterBlock?: InputMaybe<UpdatePageNewsletterBlockInput>;
  participateDownloadBlock?: InputMaybe<UpdatePageParticipateDownloadBlockInput>;
  participateElementBlock?: InputMaybe<UpdatePageParticipateElementBlockInput>;
  participateHeaderBlock?: InputMaybe<UpdatePageParticipateHeaderBlockInput>;
  pqrsdfActionBlock?: InputMaybe<UpdatePagePqrsdfActionBlockInput>;
  pqrsdfConsultBlock?: InputMaybe<UpdatePagePqrsdfConsultBlockInput>;
  pressroomBlock?: InputMaybe<UpdatePagePressroomBlockInput>;
  procedureFeedbackBlock?: InputMaybe<UpdatePageProcedureFeedbackBlockInput>;
  procedureHeaderBlock?: InputMaybe<UpdatePageProcedureHeaderBlockInput>;
  procedureMainBlock?: InputMaybe<UpdatePageProcedureMainBlockInput>;
  proceduresBlock?: InputMaybe<UpdatePageProceduresBlockInput>;
  quickAccessBar?: InputMaybe<UpdatePageQuickAccessBarInput>;
  regulationsBlock?: InputMaybe<UpdatePageRegulationsBlockInput>;
  searchBlock?: InputMaybe<UpdatePageSearchBlockInput>;
  sliderBlock?: InputMaybe<UpdatePageSliderBlockInput>;
  snsBlock?: InputMaybe<UpdatePageSnsBlockInput>;
  socialNetworksBlock?: InputMaybe<UpdatePageSocialNetworkBlockInput>;
  styledTableBlock?: InputMaybe<UpdatePageStyledTableBlockInput>;
  subDownloadBlock?: InputMaybe<UpdatePageSubDownloadBlockInput>;
  subHeaderBlock?: InputMaybe<UpdatePageSubHeaderBlockInput>;
  taxesBlock?: InputMaybe<UpdatePageTaxesBlockInput>;
  transparencyBlock?: InputMaybe<UpdatePageTransparencyBlockInput>;
  transparencyHeaderBlock?: InputMaybe<UpdatePageTransparencyHeaderBlockInput>;
};

export type UpdatePageAccessibilityBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageAccessibilityButtonInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Color del botón */
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Estado de habilitación */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  /** Máximo de items */
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Título del bloque */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Texto del tooltip */
  tooltipText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageAccordionBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  /** IDs de dependencias para filtrar el contenido del acordeón. Si está vacío o null, muestra contenido de todas las dependencias. */
  filterDependencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  /** Número de dígitos por nivel en el índice jerárquico (1-3). Ej: 2 → "01", "0101" */
  indexDigitLength?: InputMaybe<Scalars['Int']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showViewButton?: InputMaybe<Scalars['Boolean']['input']>;
  subtype?: InputMaybe<TypeAccordion>;
};

export type UpdatePageAlertsBlockInput = {
  /** Tipo de acción del botón */
  actionType?: InputMaybe<ActionType>;
  /** Descripción detallada de la alerta */
  alertDescription?: InputMaybe<Scalars['String']['input']>;
  /** Estilo visual de la alerta */
  alertStyle?: InputMaybe<PageBlockStyles>;
  /** Comportamiento del enlace */
  behaviorType?: InputMaybe<BehaviorType>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Texto del botón de redirección */
  buttonTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Frecuencia de visualización */
  displayFrequency?: InputMaybe<DisplayFrequency>;
  /** Plantilla HTML para renderizar la alerta */
  htmlTemplate?: InputMaybe<Scalars['String']['input']>;
  /** ID del bloque de alertas a actualizar */
  id: Scalars['ID']['input'];
  /** ID de la imagen (SVG o PNG) */
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enlace de redirección */
  linkItem?: InputMaybe<CreatePageLinkInput>;
  location?: InputMaybe<BlockLocation>;
  /** Alto del modal (valor numérico) */
  modalHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Unidad de medida del tamaño del modal (px, vh, vw, %) */
  modalSizeUnit?: InputMaybe<ModalSizeUnit>;
  /** Ancho del modal (valor numérico) */
  modalWidth?: InputMaybe<Scalars['Int']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Título de la alerta */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageAttentionLinesBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageAuthenticationBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSignin?: InputMaybe<Scalars['Boolean']['input']>;
  hasSignup?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageCabinetBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  cabinetSeeMoreAction?: InputMaybe<Scalars['String']['input']>;
  cabinetSeeMoreActionLink?: InputMaybe<Scalars['String']['input']>;
  cabinetSubtitle?: InputMaybe<Scalars['String']['input']>;
  cabinetTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCarrousel?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageCorporateLogosBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageCustomBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageEventsBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hasDependencyFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasScheduleInteractive?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeeMore?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  includeSharedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkItemId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  seeMoreText?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageEventSliderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageFooterBarInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  administrationLogoId?: InputMaybe<Scalars['ID']['input']>;
  administrationLogoLink?: InputMaybe<Scalars['String']['input']>;
  adminOtherLogoId?: InputMaybe<Scalars['ID']['input']>;
  adminOtherLogoLink?: InputMaybe<Scalars['String']['input']>;
  antiCorruptionLine?: InputMaybe<Scalars['String']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  campusData?: InputMaybe<Scalars['String']['input']>;
  citizenLine?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  institutionalEmail?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  judicialEmail?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<BlockLocation>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoLink?: InputMaybe<Scalars['String']['input']>;
  nit?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageHeaderBarInput = {
  administrationLogoId?: InputMaybe<Scalars['ID']['input']>;
  administrationLogoLink?: InputMaybe<Scalars['String']['input']>;
  adminOtherLogoId?: InputMaybe<Scalars['ID']['input']>;
  adminOtherLogoLink?: InputMaybe<Scalars['String']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  govcoLink?: InputMaybe<CreatePageLinkInput>;
  hasGovcoLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasLanguageIcon?: InputMaybe<Scalars['Boolean']['input']>;
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSignin?: InputMaybe<Scalars['Boolean']['input']>;
  hasSignup?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoLink?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  signinName?: InputMaybe<Scalars['String']['input']>;
  signupName?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageHeaderOrganizationBarInput = {
  adminAnotherLink?: InputMaybe<CreatePageLinkInput>;
  administrationLogoId?: InputMaybe<Scalars['ID']['input']>;
  adminLogoLink?: InputMaybe<CreatePageLinkInput>;
  adminOtherLogoId?: InputMaybe<Scalars['ID']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoImageLink?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageInstitutionalProgramsSliderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageInstitutionalProgramsTypesBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageNavigationBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageNewsletterBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hasDependencyFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasSearchbarNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  includeSharedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  newsletterDescription?: InputMaybe<Scalars['String']['input']>;
  newsletterTags?: InputMaybe<Array<Scalars['String']['input']>>;
  newsletterTitle?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  tagStyle?: InputMaybe<PageBlockStyles>;
};

export type UpdatePageParticipateDownloadBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageParticipateElementBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageParticipateHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  participateDescription?: InputMaybe<Scalars['String']['input']>;
  participateIntroduction?: InputMaybe<Scalars['String']['input']>;
  participateTitle?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePagePqrsdfActionBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePagePqrsdfConsultBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePagePressroomBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageProcedureFeedbackBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageProcedureHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  procedureDescription?: InputMaybe<Scalars['String']['input']>;
  procedureTitle?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageProcedureMainBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageProceduresBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionProcedures?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreAction?: InputMaybe<Scalars['String']['input']>;
  seeMoreActionLink?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  titleProcedures?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageQuickAccessBarInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCarrousel?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerView?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  seeMoreTitle?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageRegulationsBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionRegulation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreRegulations?: InputMaybe<Scalars['String']['input']>;
  seeMoreRegulationsLink?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subPages?: InputMaybe<Array<SubPages>>;
  titleRegulation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageSearchBlockInput = {
  /** Aplicar filtro automático por dependencia según contexto */
  autoFilterByDependency?: InputMaybe<Scalars['Boolean']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  /** Contexto del bloque */
  contextType?: InputMaybe<SearchContextType>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID del bloque de búsqueda a actualizar */
  id: Scalars['ID']['input'];
  /** Incluir contenido de otras dependencias (solo para header de página principal) */
  includeOtherDependencies?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  /** Número máximo de resultados a mostrar */
  maxResults?: InputMaybe<Scalars['Float']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  /** Texto placeholder del campo de búsqueda */
  placeholder?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  /** Fuentes de búsqueda habilitadas (debe seleccionar al menos una) */
  searchSources?: InputMaybe<Array<SearchSourceType>>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageSliderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageSnsBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageSocialNetworkBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  seeMoreAction?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageStyledTableBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<TableContentType>;
  description?: InputMaybe<Scalars['String']['input']>;
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  externalEndpoint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  tableStyle?: InputMaybe<TableStyleType>;
  title?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePageSubDownloadBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subDownloadDescription?: InputMaybe<Scalars['String']['input']>;
  subDownloadPlaceholder?: InputMaybe<Scalars['String']['input']>;
  subDownloadSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  subDownloadTitle?: InputMaybe<Scalars['String']['input']>;
  subPages?: InputMaybe<Array<SubPages>>;
};

export type UpdatePageSubHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDates?: InputMaybe<Scalars['Boolean']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  subHeaderDescription?: InputMaybe<Scalars['String']['input']>;
  subHeaderIntroduction?: InputMaybe<Scalars['String']['input']>;
  subHeaderPlaceholder?: InputMaybe<Scalars['String']['input']>;
  subHeaderSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  subHeaderTitle?: InputMaybe<Scalars['String']['input']>;
  subPages?: InputMaybe<Array<SubPages>>;
};

export type UpdatePageTaxesBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  taxSectionTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageTransparencyBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasLinkVideo?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkVideo?: InputMaybe<CreatePageLinkInput>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  transparencyContent?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageTransparencyHeaderBlockInput = {
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSearchbar?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<BlockLocation>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  transparencyDescription?: InputMaybe<Scalars['String']['input']>;
  transparencyPlaceholder?: InputMaybe<Scalars['String']['input']>;
  transparencyTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageBlockItemInputUnion = {
  accessibilityButtonItem?: InputMaybe<UpdatePageAccessibilityButtonItemInput>;
  accordionBlockItem?: InputMaybe<UpdatePageAccordionBlockItemInput>;
  attentionLinesBlockItem?: InputMaybe<UpdatePageAttentionLinesBlockItemInput>;
  cabinetBlockItem?: InputMaybe<UpdatePageCabinetBlockItemInput>;
  corporateLogosBlockItem?: InputMaybe<UpdatePageCorporateLogosBlockItemInput>;
  eventSliderBlockItem?: InputMaybe<UpdatePageEventSliderBlockItemInput>;
  footerBarItem?: InputMaybe<UpdatePageFooterBarItemInput>;
  institutionalProgramsSliderBlockItem?: InputMaybe<UpdatePageInstitutionalProgramsSliderBlockItemInput>;
  institutionalProgramsTypesBlockItem?: InputMaybe<UpdatePageInstitutionalProgramsTypesBlockItemInput>;
  participateElementBlockItem?: InputMaybe<UpdatePageParticipateElementBlockItemInput>;
  quickAccessBarItem?: InputMaybe<UpdatePageQuickAccessBarItemInput>;
  regulationBlockItem?: InputMaybe<UpdatePageRegulationsBlockItemInput>;
  snsBlockItem?: InputMaybe<UpdatePageSnsBlockItemInput>;
  socialNetworksBlockLeftItem?: InputMaybe<UpdatePageSocialNetworksBlockLeftItemInput>;
  socialNetworksBlockRightItem?: InputMaybe<UpdatePageSocialNetworksBlockRightItemInput>;
  styledTableBlockItem?: InputMaybe<UpdatePageStyledTableBlockItemInput>;
  styledTableBlockRow?: InputMaybe<UpdatePageStyledTableBlockRowInput>;
  subDownloadBlockItem?: InputMaybe<UpdateSubPageDownloadBlockItemInput>;
  taxesBlockItem?: InputMaybe<UpdatePageTaxesBlockItemInput>;
  transparencyBlockItem?: InputMaybe<UpdatePageTransparencyBlockItemInput>;
};

export type UpdatePageAccessibilityButtonItemInput = {
  /** Texto alternativo para accesibilidad (max 100 caracteres) */
  altText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Orden de visualización (1-8) */
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Tipo de icono */
  iconType?: InputMaybe<AccessibilityIconType>;
  id: Scalars['ID']['input'];
  /** Estado de activación */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuración de enlace */
  linkItem?: InputMaybe<CreatePageLinkInput>;
  /** Nombre del enlace (max 50 caracteres) */
  linkName?: InputMaybe<Scalars['String']['input']>;
  /** URL de respaldo (deprecated) */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageAccordionBlockItemInput = {
  configJson?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['String']['input']>;
  indexTitle?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  subtype?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageAttentionLinesBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['ID']['input']>;
  iconLink?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageCabinetBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  cabinetDescription?: InputMaybe<Scalars['String']['input']>;
  cabinetEmail?: InputMaybe<Scalars['String']['input']>;
  cabinetImageId?: InputMaybe<Scalars['ID']['input']>;
  cabinetImageLink?: InputMaybe<Scalars['String']['input']>;
  cabinetName?: InputMaybe<Scalars['String']['input']>;
  cabinetOrder?: InputMaybe<Scalars['String']['input']>;
  cabinetPhone?: InputMaybe<Scalars['String']['input']>;
  cabinetPositionId?: InputMaybe<Scalars['ID']['input']>;
  cabinetStatus?: InputMaybe<Scalars['String']['input']>;
  curriculumVitaeLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageCorporateLogosBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  corporateLogoId?: InputMaybe<Scalars['ID']['input']>;
  corporateLogoLink?: InputMaybe<Scalars['String']['input']>;
  corporateLogoName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageEventSliderBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  seeMoreAction?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageFooterBarItemInput = {
  anotherCampusData?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerType?: InputMaybe<FooterItemType>;
  hasAnoterCampusData?: InputMaybe<Scalars['Boolean']['input']>;
  hasSocialNetworkIcon?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageDirectory?: InputMaybe<Scalars['String']['input']>;
  pageDirectoryLink?: InputMaybe<CreatePageLinkInput>;
  routeType?: InputMaybe<RouterType>;
  socialNetworkIconId?: InputMaybe<Scalars['ID']['input']>;
  socialNetworkLink?: InputMaybe<Scalars['String']['input']>;
  socialNetworkName?: InputMaybe<Scalars['ID']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageInstitutionalProgramsSliderBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  seeMoreAction?: InputMaybe<Scalars['String']['input']>;
  seeMoreLink?: InputMaybe<Scalars['String']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageInstitutionalProgramsTypesBlockItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  programsType?: InputMaybe<ProgramsTypes>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageParticipateElementBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  participateElementImageId?: InputMaybe<Scalars['ID']['input']>;
  participateElementTitle?: InputMaybe<Scalars['String']['input']>;
  participateLinkAction?: InputMaybe<CreatePageLinkInput>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageQuickAccessBarItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  quickAccessName?: InputMaybe<Scalars['String']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageRegulationsBlockItemInput = {
  /** Configuración JSON para ordenamiento y agrupación */
  configJson?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  itemIconId?: InputMaybe<Scalars['ID']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<RegulationType>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageSnsBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  itemLink?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  snsSocialNetworkType?: InputMaybe<SocialNetworkType>;
  snsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageSocialNetworksBlockLeftItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imageLink?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageSocialNetworksBlockRightItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hasRightItem?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  socialNetworkType?: InputMaybe<SocialNetworkType>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageStyledTableBlockItemInput = {
  allowFilter?: InputMaybe<Scalars['Boolean']['input']>;
  allowSort?: InputMaybe<Scalars['Boolean']['input']>;
  columnName?: InputMaybe<Scalars['String']['input']>;
  columnWidth?: InputMaybe<Scalars['Float']['input']>;
  configJson?: InputMaybe<Scalars['String']['input']>;
  contentSchemaFieldId?: InputMaybe<Scalars['String']['input']>;
  dataType?: InputMaybe<ColumnDataType>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageStyledTableBlockRowInput = {
  cellData?: InputMaybe<Array<UpdatePageStyledTableBlockRowDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageStyledTableBlockRowDataInput = {
  columnId?: InputMaybe<Scalars['String']['input']>;
  extendedValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubPageDownloadBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdatePageTaxesBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
  taxTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageTransparencyBlockItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  itemIconId?: InputMaybe<Scalars['ID']['input']>;
  itemTitle?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Estado de visibilidad: Active (visible) o Inactive (oculto) */
  status?: InputMaybe<ItemStatus>;
};

export type UpdateOrderPageBlockItemInput = {
  id: Scalars['ID']['input'];
  orderIndex: Scalars['Int']['input'];
  parentId: Scalars['ID']['input'];
};

export type UpdateOrderPageBlockInput = {
  id: Scalars['ID']['input'];
  orderIndex: Scalars['Int']['input'];
};

export type UpdatePageDynamicInput = {
  configJson?: InputMaybe<Scalars['String']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata SEO para motores de búsqueda (crear o actualizar) */
  seoInput?: InputMaybe<UpdateSeoInput>;
  status: VersionStates;
  type?: InputMaybe<PageDynamicType>;
  unlinkParent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageVersionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  state?: InputMaybe<VersionStates>;
  theme?: InputMaybe<Theme>;
};

export type UpdateParameterInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  character?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  longCharacter?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TypeParameter>;
};

export type UpdatePasswordInput = {
  password: Scalars['ValidatePassword']['input'];
  passwordConfirm: Scalars['ValidatePassword']['input'];
  token: Scalars['String']['input'];
};

export type UpdatePositionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actionLink?: InputMaybe<Scalars['String']['input']>;
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<CostTypes>;
  date?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<DurationTypes>;
  estimatedDuration?: InputMaybe<Scalars['Int']['input']>;
  gocvoLogoName?: InputMaybe<Scalars['String']['input']>;
  govcoImageId?: InputMaybe<Scalars['ID']['input']>;
  govcoLink?: InputMaybe<CreatePageLinkInput>;
  id: Scalars['ID']['input'];
  linkItem?: InputMaybe<CreatePageLinkInput>;
  linkVideo?: InputMaybe<CreatePageLinkInput>;
  modality?: InputMaybe<ModalityTypes>;
  multimediaType?: InputMaybe<MultimediaTypes>;
  name?: InputMaybe<Scalars['ID']['input']>;
  procedureDescription?: InputMaybe<Scalars['String']['input']>;
  procedureStatus?: InputMaybe<VersionStates>;
  procedureTags?: InputMaybe<Array<Scalars['String']['input']>>;
  procedureTypes?: InputMaybe<ProcedureTypes>;
  processDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Controla la visibilidad del botón de GovCo */
  showGovcoButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controla la visibilidad del botón del trámite */
  showProcedureButton?: InputMaybe<Scalars['Boolean']['input']>;
  tagsProcedure?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProcedureStatusToDraft = {
  id: Scalars['ID']['input'];
  procedureStatus?: InputMaybe<VersionStates>;
};

export type UpdateProfileInput = {
  city?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRegulationInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentDate?: InputMaybe<Scalars['DateTime']['input']>;
  downloadText?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  pageLinkDocument?: InputMaybe<CreatePageLinkInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulationStatus?: InputMaybe<VersionStates>;
  /** Metadata SEO para motores de búsqueda (crear o actualizar) */
  seoInput?: InputMaybe<UpdateSeoInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RegulationType>;
};

export type UpdateRegulationStatus = {
  id: Scalars['ID']['input'];
  regulationStatus?: InputMaybe<VersionStates>;
};

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RoleStatusTypes>;
};

export type UpdateRoleAndPermissionsInput = {
  id: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
  status?: InputMaybe<RoleStatusTypes>;
};

export type UpdateServerInput = {
  app?: InputMaybe<ServerApp>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<ServerEnvironment>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ServerStatus>;
};

export type UpdateSliderItemInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkItem?: InputMaybe<CreatePageLinkInput>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  pageBlockStyle?: InputMaybe<PageBlockStyles>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSliderItemsInput = {
  items: Array<UpdateOrderSliderItemInput>;
};

export type UpdateOrderSliderItemInput = {
  id: Scalars['ID']['input'];
  orderIndex: Scalars['Int']['input'];
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  credentialsExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateIssue?: InputMaybe<Scalars['DateTime']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasRural?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentative?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passwordStatus?: InputMaybe<PasswordStatusTypes>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rolesId?: InputMaybe<Array<Scalars['String']['input']>>;
  secondSurname?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatusTypes>;
  type?: InputMaybe<UserTypes>;
};

export type UpdateUserContentSchemaAssignmentInput = {
  canAssociateAnyDependency?: InputMaybe<Scalars['Boolean']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserDependencyInput = {
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<UserDependencyStatus>;
  /** Field of the user dependency type */
  type?: InputMaybe<UserDependencyType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserInformationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  secondSurname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['ValidatePassword']['input'];
  newPasswordConfirm: Scalars['ValidatePassword']['input'];
};

export type UpdateUserRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  confirmationEmail?: InputMaybe<Scalars['String']['input']>;
  confirmPassword?: InputMaybe<Scalars['ValidatePassword']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateIssue?: InputMaybe<Scalars['DateTime']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasRural?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<UserDocumentTypes>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentative?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['ValidatePassword']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  secondSurname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserTemplateInput = {
  id: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ValidateUserCodeRequestInput = {
  confirmationCode: Scalars['String']['input'];
  userRequestId: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  subcriptionTesting: Scalars['String']['output'];
};


export type SubscriptionSubcriptionTestingArgs = {
  topic: Scalars['String']['input'];
};

export type GroupResultOutput = {
  __typename?: 'GroupResultOutput';
  /** The computed aggregate values as JSON object */
  aggregates: Scalars['JSON']['output'];
  /** The grouped key values as JSON object */
  key: Scalars['JSON']['output'];
};

export type CreatePageBlockItemAccordionMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageBlockItemAccordionMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, orderIndex: number, description?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, subtype?: string | null, configJson?: string | null, lft?: number | null, rgt?: number | null, depth?: number | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdatePageBlockItemAccordionMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemAccordionMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, orderIndex: number, description?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, subtype?: string | null, configJson?: string | null, lft?: number | null, rgt?: number | null, depth?: number | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type RemovePageBlockItemAccordionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemovePageBlockItemAccordionMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type DeleteAccordionBlockItemWithStrategyMutationVariables = Exact<{
  input: DeleteAccordionBlockItemInput;
}>;


export type DeleteAccordionBlockItemWithStrategyMutation = { __typename?: 'Mutation', deleteAccordionBlockItemWithStrategy: { __typename?: 'DeleteAccordionBlockItemResponse', deletedItemsCount: number, deletedItemIds: Array<string>, movedItemsCount: number, movedItemIds: Array<string>, message: string } };

export type MoveAccordionBlockItemMutationVariables = Exact<{
  input: MoveAccordionBlockItemInput;
}>;


export type MoveAccordionBlockItemMutation = { __typename?: 'Mutation', moveAccordionBlockItem: { __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, depth?: number | null, lft?: number | null, rgt?: number | null } };

export type GetAccordionItemDescendantsQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetAccordionItemDescendantsQuery = { __typename?: 'Query', accordionItemDescendants: Array<{ __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, description?: string | null, depth?: number | null, lft?: number | null, rgt?: number | null }> };

export type GetAccordionItemAncestorsQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetAccordionItemAncestorsQuery = { __typename?: 'Query', accordionItemAncestors: Array<{ __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, depth?: number | null }> };

export type RebuildAccordionNestedSetMutationVariables = Exact<{
  accordionBlockId: Scalars['ID']['input'];
}>;


export type RebuildAccordionNestedSetMutation = { __typename?: 'Mutation', rebuildAccordionNestedSet: string };

export type GetAccordionBlockDataQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetAccordionBlockDataQuery = { __typename?: 'Query', pageBlock: { __typename: 'PageAccessibilityBar' } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, indexDigitLength?: number | null, filterDependencyIds?: Array<string> | null, type?: string | null, subtype?: TypeAccordion | null, pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, orderIndex: number, description?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, subtype?: string | null, configJson?: string | null, lft?: number | null, rgt?: number | null, depth?: number | null, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null, schema?: { __typename?: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, allowChildren: boolean, maxNestingLevel: number, hierarchyLabel?: string | null, dependencyCount: number, fields: Array<{ __typename?: 'ContentSchemaField', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fieldName: string, fieldLabel: string, fieldType: FieldType, isRequired: boolean, orderIndex: number, options?: string | null, validationRules?: string | null, defaultValue?: string | null, isActive: boolean, isGroup?: boolean | null }> } | null }> } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageAuthenticationBar' } | { __typename: 'PageCabinetBlock' } | { __typename: 'PageCorporateLogosBlock' } | { __typename: 'PageCustomBlock' } | { __typename: 'PageEventsBlock' } | { __typename: 'PageEventSliderBlock' } | { __typename: 'PageFooterBar' } | { __typename: 'PageHeaderBar' } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock' } | { __typename: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock' } | { __typename: 'PageParticipateDownloadBlock' } | { __typename: 'PageParticipateElementBlock' } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock' } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar' } | { __typename: 'PageRegulationsBlock' } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock' } | { __typename: 'PageSocialNetworksBlock' } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock' } | { __typename: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock' } | { __typename: 'PageTransparencyHeaderBlock' } };

export type AlertBlockDataQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type AlertBlockDataQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title?: string | null, blockTitle?: string | null, description: string, alertDescription?: string | null, alertStyle: PageBlockStyles, showTitle: boolean, showDescription: boolean, buttonTitle?: string | null, actionType?: ActionType | null, displayFrequency: DisplayFrequency, htmlTemplate?: string | null, canBeDisabled: boolean, isDisabled: boolean, type?: string | null, image?: { __typename?: 'FileInfo', id: string, url: string, fileName: string, downloadUrl?: string | null, fileExtension: string } | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null } | null } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PageCabinetBlockItemAllQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
  where?: InputMaybe<FindPageBlockItemsWhere>;
  positions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindPageBlockItemsOrderBy> | FindPageBlockItemsOrderBy>;
  positionOrder?: InputMaybe<OrderTypes>;
}>;


export type PageCabinetBlockItemAllQuery = { __typename?: 'Query', pageBlockItems: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem', id: string, createdAt: any, description?: string | null, orderIndex: number, cabinetName: string, cabinetEmail?: string | null, cabinetPhone?: string | null, alternativeText?: string | null, cabinetPosition?: { __typename?: 'Position', id: string, name: string } | null, cabinetImage?: { __typename?: 'FileInfo', id: string, downloadUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type CreateCabinetDetailInputMutationVariables = Exact<{
  createInput: CreateCabinetDetailInput;
}>;


export type CreateCabinetDetailInputMutation = { __typename?: 'Mutation', createCabinetDetailInput: { __typename?: 'CabinetDetail', id: string, createdAt: any, cabinetDetailName?: string | null, cabinetDetailStatus?: VersionStates | null, cabinetDetailLink?: { __typename?: 'PageLink', routeType?: RouterType | null, url?: string | null, target?: string | null } | null, cabinetDetailImage?: { __typename?: 'FileInfo', id: string } | null, cabinetItem?: { __typename?: 'PageCabinetBlockItem', cabinetName: string, cabinetImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string } | null } | null } };

export type RemovePageBlockItemCabinetMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemovePageBlockItemCabinetMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem', id: string } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UpdatePageBlockItemCabinetMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemCabinetMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem', id: string, description?: string | null, orderIndex: number, cabinetName: string, cabinetEmail?: string | null, curriculumVitaeLink?: string | null, cabinetPhone?: string | null, alternativeText?: string | null, cabinetPosition?: { __typename?: 'Position', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string } | null, cabinetImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, downloadUrl?: string | null, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateCabinetDetailInputMutationVariables = Exact<{
  updateInput: UpdateCabinetDetailInput;
}>;


export type UpdateCabinetDetailInputMutation = { __typename?: 'Mutation', updateCabinetDetailInput: { __typename?: 'CabinetDetail', id: string, cabinetDetailName?: string | null, cabinetDetailImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileExtension: string, fileName: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } };

export type PageCabinetBlockItemByIdQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageCabinetBlockItemByIdQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem', id: string, curriculumVitaeLink?: string | null, cabinetName: string, orderIndex: number, cabinetPhone?: string | null, cabinetDescription?: string | null, cabinetEmail?: string | null, alternativeText?: string | null, description?: string | null, createdAt: any, cabinetPosition?: { __typename?: 'Position', id: string, name: string } | null, cabinetDetails: Array<{ __typename?: 'CabinetDetail', id: string, cabinetDetailStatus?: VersionStates | null, cabinetDetailName?: string | null, cabinetDetailImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, fileName: string, fileMode: FileModes, fileMongoId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, fileExtension: string, url: string } | null, cabinetDetailLink?: { __typename?: 'PageLink', target?: string | null, url?: string | null } | null }>, cabinetImage?: { __typename?: 'FileInfo', id: string, fileName: string, downloadUrl?: string | null, fileMode: FileModes, fileMongoId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, fileExtension: string, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, arguments?: Array<string> | null } | null } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type CargosCabinetQueryVariables = Exact<{ [key: string]: never; }>;


export type CargosCabinetQuery = { __typename?: 'Query', positions: Array<{ __typename?: 'Position', id: string, name: string }> };

export type CabinetDetailQueryVariables = Exact<{
  cabinetDetailId: Scalars['ID']['input'];
}>;


export type CabinetDetailQuery = { __typename?: 'Query', CabinetDetail: { __typename?: 'CabinetDetail', id: string, cabinetDetailName?: string | null, cabinetDetailImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, cabinetDetailLink?: { __typename?: 'PageLink', id: string, url?: string | null, target?: string | null } | null } };

export type CreatePageBlockItemCabinetMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageBlockItemCabinetMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem', id: string, curriculumVitaeLink?: string | null, cabinetDescription?: string | null, cabinetName: string, cabinetPhone?: string | null, alternativeText?: string | null, cabinetPosition?: { __typename?: 'Position', id: string, name: string } | null, cabinetImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type PageCabinetBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageCabinetBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename: 'PageCabinetBlock', id: string, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, cabinetTitle: string, cabinetSubtitle?: string | null, extendedDescription?: string | null, pageBlockStyle?: PageBlockStyles | null, isCarrousel?: boolean | null, items: Array<{ __typename: 'PageCabinetBlockItem', curriculumVitaeLink?: string | null, id: string, orderIndex: number, cabinetDescription?: string | null, createdAt: any, cabinetName: string, cabinetDetails: Array<{ __typename: 'CabinetDetail', id: string, cabinetDetailImage?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, cabinetDetailLink?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, url?: string | null, routeNavigation?: SubPages | null, target?: string | null } | null }>, cabinetImage?: { __typename: 'FileInfo', url: string, updatedAt: any, id: string, fileName: string, downloadUrl?: string | null, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, deletedAt?: any | null, createdAt: any } | null, cabinetPosition?: { __typename: 'Position', name: string } | null }> } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type RemoveCabinetDetailMutationVariables = Exact<{
  removeCabinetDetailId: Scalars['ID']['input'];
}>;


export type RemoveCabinetDetailMutation = { __typename?: 'Mutation', removeCabinetDetail: { __typename?: 'CabinetDetail', id: string } };

export type UpdatePageBlockCabinetMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockCabinetMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock', isCarrousel?: boolean | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null, description: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type ItemsCabinetQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemsCabinetQuery = { __typename?: 'Query', mainPage: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock', isCarrousel?: boolean | null, items: Array<{ __typename?: 'PageCabinetBlockItem', cabinetDescription?: string | null, id: string, orderIndex: number, cabinetName: string, cabinetPosition?: { __typename?: 'Position', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string } | null, cabinetImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, downloadUrl?: string | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, cabinetDetails: Array<{ __typename?: 'CabinetDetail', cabinetDetailName?: string | null, id: string, cabinetDetailLink?: { __typename?: 'PageLink', arguments?: Array<string> | null, id: string, routeNavigation?: SubPages | null, routeType?: RouterType | null, url?: string | null, target?: string | null } | null, cabinetDetailImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }>, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageCabinetBlockItemPublicQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageCabinetBlockItemPublicQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem', id: string, cabinetName: string, description?: string | null, cabinetDescription?: string | null, cabinetPosition?: { __typename?: 'Position', name: string } | null, cabinetImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UpdatePageBlockCustomPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockCustomPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock', id: string } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetCustomPageQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetCustomPageQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock', id: string, blockTitle?: string | null, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, canBeDisabled: boolean, content: string, createdAt: any, deletedAt?: any | null, isDisabled: boolean, description: string, location: BlockLocation, orderIndex: number, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, updatedAt: any } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageEventsBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageEventsBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock', id: string } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageEventsBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageEventsBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock', id: string, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, pageBlockStyle?: PageBlockStyles | null, eventDescription?: string | null, eventTitle?: string | null, global?: boolean | null, hasDependencyFilter?: boolean | null, includeSharedContent?: boolean | null, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PageEventsBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageEventsBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, seeMoreLink?: string | null, subPages?: Array<SubPages> | null, events: Array<{ __typename: 'EventsItem', id: string, multimediaType?: MultimediaTypes | null, createdAt: any, eventItemTitle: string, eventItemDescription?: string | null, descriptionPlace?: string | null, summary?: string | null, startDate: any, endDate: any, latitude?: string | null, longitude?: string | null, address?: string | null, eventStatus?: EventStates | null, link?: string | null, shareLink?: string | null, image?: { __typename: 'FileInfo', id: string, url: string, downloadUrl?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type EventsItemsFilteredQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FilterEventOrderBy> | FilterEventOrderBy>;
  where?: InputMaybe<FilterEventWhere>;
  pagination?: InputMaybe<Pagination>;
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EventsItemsFilteredQuery = { __typename?: 'Query', eventsItemsFiltered: Array<{ __typename?: 'EventsItem', address?: string | null, multimediaType?: MultimediaTypes | null, eventItemTitle: string, createdAt: any, id: string, latitude?: string | null, longitude?: string | null, startDate: any, shareLink?: string | null, seeMore?: string | null, summary?: string | null, descriptionPlace?: string | null, endDate: any, image?: { __typename?: 'FileInfo', id: string } | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null } | null }> };

export type PageHeaderBarQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
}>;


export type PageHeaderBarQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar', signinName?: string | null, signupName?: string | null, hasSignin?: boolean | null, hasSearchbar: boolean, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, description: string, subPages?: Array<SubPages> | null, hasSignup?: boolean | null, govcoLink?: { __typename?: 'PageLink', id: string, url?: string | null, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, updatedAt: any } | null } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageBlockHeaderBarMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockHeaderBarMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar', hasSignup?: boolean | null, id: string, hasSignin?: boolean | null, hasSearchbar: boolean, signinName?: string | null, signupName?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, govcoLink?: { __typename?: 'PageLink', url?: string | null, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, updatedAt: any } | null, version?: { __typename?: 'PageVersion', id: string, description: string, state: VersionStates, theme: Theme } | null } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetOrganizationBarDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetOrganizationBarDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar', id: string, title?: string | null, subtitle?: string | null, logoImage?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, logoImageLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null, adminOtherLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, adminAnotherLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null, administrationLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, adminLogoLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateHeaderOrganizationBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateHeaderOrganizationBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar', id: string } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageMapBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageMapBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock', id: string } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageMapBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageMapBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock', id: string, mapType: MapType, geoJsonData?: string | null, elementsConfig?: string | null, departmentCode?: string | null, height: number, initialZoom: number, centerCoordinates?: string | null, defaultFillColor?: string | null, defaultBorderColor?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, type?: string | null } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageNavigationBarBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageNavigationBarBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar', id: string } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type NavigationItemFieldsFragment = { __typename?: 'NavigationItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description: string, link?: string | null, orderIndex: number, type?: NavigationItemType | null, status: ItemStatus, lft?: number | null, rgt?: number | null, depth?: number | null, linkItem?: { __typename: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null };

export type NavigationBarDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type NavigationBarDetailQuery = { __typename?: 'Query', pageBlock: { __typename: 'PageAccessibilityBar' } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageAuthenticationBar' } | { __typename: 'PageCabinetBlock' } | { __typename: 'PageCorporateLogosBlock' } | { __typename: 'PageCustomBlock' } | { __typename: 'PageEventsBlock' } | { __typename: 'PageEventSliderBlock' } | { __typename: 'PageFooterBar' } | { __typename: 'PageHeaderBar' } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock' } | { __typename: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, location: BlockLocation, description: string, canBeDisabled: boolean, pageBlockStyle?: PageBlockStyles | null, type?: string | null, rootItem?: { __typename?: 'NavigationItem', id: string, name: string, lft?: number | null, rgt?: number | null, depth?: number | null } | null } | { __typename: 'PageNewsletterBlock' } | { __typename: 'PageParticipateDownloadBlock' } | { __typename: 'PageParticipateElementBlock' } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock' } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar' } | { __typename: 'PageRegulationsBlock' } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock' } | { __typename: 'PageSocialNetworksBlock' } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock' } | { __typename: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock' } | { __typename: 'PageTransparencyHeaderBlock' } };

export type CreateNavigationBarItemMutationVariables = Exact<{
  input: CreateNavigationItemInput;
}>;


export type CreateNavigationBarItemMutation = { __typename?: 'Mutation', createNavItem: { __typename?: 'NavigationItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description: string, link?: string | null, orderIndex: number, type?: NavigationItemType | null } };

export type UpdateNavigationBarItemMutationVariables = Exact<{
  updateInput: UpdateNavigationItemInput;
}>;


export type UpdateNavigationBarItemMutation = { __typename?: 'Mutation', updateNavItem: { __typename?: 'NavigationItem', id: string } };

export type GetNavigationBarItemQueryVariables = Exact<{
  navItemId: Scalars['ID']['input'];
}>;


export type GetNavigationBarItemQuery = { __typename?: 'Query', navItem: { __typename?: 'NavigationItem', id: string, name: string, orderIndex: number, parent?: { __typename?: 'NavigationItem', id: string, name: string, orderIndex: number } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, createdAt: any, updatedAt: any, name: string, link?: string | null, orderIndex: number }>, icon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null, signLanguageGif?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null } };

export type RemoveNavigationBarItemMutationVariables = Exact<{
  removeNavItemId: Scalars['ID']['input'];
}>;


export type RemoveNavigationBarItemMutation = { __typename?: 'Mutation', removeNavItem: { __typename?: 'NavigationItem', id: string } };

export type UpdateNavigationItemOrdersMutationVariables = Exact<{
  input: Array<UpdateNavigationItemInput> | UpdateNavigationItemInput;
}>;


export type UpdateNavigationItemOrdersMutation = { __typename?: 'Mutation', updateNavigationItemOrders: Array<{ __typename?: 'NavigationItem', id: string, name: string, orderIndex: number }> };

export type MoveNavigationItemMutationVariables = Exact<{
  input: MoveNavigationItemInput;
}>;


export type MoveNavigationItemMutation = { __typename?: 'Mutation', moveNavigationItem: { __typename?: 'NavigationItem', id: string, name: string, orderIndex: number, depth?: number | null, lft?: number | null, rgt?: number | null, type?: NavigationItemType | null } };

export type RebuildNavigationNestedSetMutationVariables = Exact<{
  navigationBarId: Scalars['ID']['input'];
}>;


export type RebuildNavigationNestedSetMutation = { __typename?: 'Mutation', rebuildNavigationNestedSet: { __typename?: 'RebuildNestedSetResultModel', dryRun: boolean, itemsWithChanges: number, totalItems: number, preview: Array<{ __typename?: 'NestedSetPreviewItemModel', id: string, name: string, hasChanges: boolean, currentLft?: number | null, currentRgt?: number | null, currentDepth?: number | null, newLft: number, newRgt: number, newDepth: number }> } };

export type GetNavigationItemDescendantsQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetNavigationItemDescendantsQuery = { __typename?: 'Query', navigationItemDescendants: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, depth?: number | null, lft?: number | null, rgt?: number | null, orderIndex: number, type?: NavigationItemType | null }> };

export type GetNavigationItemAncestorsQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type GetNavigationItemAncestorsQuery = { __typename?: 'Query', navigationItemAncestors: Array<{ __typename?: 'NavigationItem', id: string, name: string, depth?: number | null, lft?: number | null, rgt?: number | null }> };

export type UpdatePageNewsletterBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageNewsletterBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock', id: string } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageNewsletterBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageNewsletterBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock', id: string, global?: boolean | null, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, pageBlockStyle?: PageBlockStyles | null, newsletterTitle: string, newsletterDescription?: string | null, hasDependencyFilter?: boolean | null, includeSharedContent?: boolean | null, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PageNewsletterBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageNewsletterBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, news: Array<{ __typename: 'NewsItem', id: string, link?: string | null, updatedAt: any, createdAt: any, title: string, summary: string, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type NewsItemsFilteredQueryVariables = Exact<{
  dependencyId?: InputMaybe<Scalars['ID']['input']>;
  contentSchemaId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<FilterNewsWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FilterNewsOrderBy> | FilterNewsOrderBy>;
}>;


export type NewsItemsFilteredQuery = { __typename?: 'Query', newsItemsFiltered: Array<{ __typename?: 'NewsItem', id: string, title: string, summary: string, createdAt: any, updatedAt: any, publicationDate?: any | null, linkItem?: { __typename?: 'PageLink', id: string, target?: string | null } | null, image?: { __typename?: 'FileInfo', id: string } | null, seo?: { __typename?: 'Seo', metadata: Array<{ __typename?: 'SeoMetadata', slug?: string | null }> } | null }> };

export type UpdatePageProceduresBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageProceduresBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock', id: string } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageProceduresBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageProceduresBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock', id: string, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, pageBlockStyle?: PageBlockStyles | null, titleProcedures: string, descriptionProcedures: string } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PageProceduresBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageProceduresBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleProcedures: string, descriptionProcedures: string, seeMoreAction: string, seeMoreActionLink: string, procedures: Array<{ __typename: 'Procedure', procedureTypes?: ProcedureTypes | null, gocvoLogoName?: string | null, createdAt: any, procedureItemTags: Array<string>, id: string, name: string, tagsProcedure?: Array<string> | null, cost: CostTypes, duration?: DurationTypes | null, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, govcoLink?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageQuickAccessBarBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageQuickAccessBarBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar', id: string } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageQuickAccessBarBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageQuickAccessBarBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar', id: string, pageBlockStyle?: PageBlockStyles | null, blockTitle?: string | null } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type QuickAccessBarDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type QuickAccessBarDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar', id: string, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, canBeDisabled: boolean, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, blockTitle?: string | null, isCarrousel?: boolean | null, color?: string | null, itemsPerView?: number | null, allItems: Array<{ __typename?: 'PageQuickAccessBarItem', id: string, status: ItemStatus, orderIndex: number, description?: string | null, quickAccessName?: string | null, createdAt: any, updatedAt: any, image?: { __typename?: 'FileInfo', id: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, fileName: string, url: string } | null, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreateQuickAccessBarItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateQuickAccessBarItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem', id: string } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateQuickAccessBarItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateQuickAccessBarItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem', id: string } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetQuickAccessBarItemQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetQuickAccessBarItemQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem', id: string, description?: string | null, quickAccessName?: string | null, link: string, image?: { __typename?: 'FileInfo', downloadUrl?: string | null, fileExtension: string, fileMode: FileModes, id: string, fileName: string, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveQuickAccessBarItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveQuickAccessBarItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem', id: string } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type PageQuickAccessBarQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageQuickAccessBarQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, isCarrousel?: boolean | null, itemsPerView?: number | null, color?: string | null, allItems: Array<{ __typename: 'PageQuickAccessBarItem', id: string, status: ItemStatus, orderIndex: number, quickAccessName?: string | null, description?: string | null, link: string, image?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageRegulationsBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageRegulationsBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock', id: string } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageRegulationsBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageRegulationsBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock', id: string, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, pageBlockStyle?: PageBlockStyles | null, titleRegulation: string, descriptionRegulation?: string | null } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type SlidersCarouselQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
}>;


export type SlidersCarouselQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock', pageBlockStyle?: PageBlockStyles | null, sliders?: Array<{ __typename?: 'SliderItem', id: string, title: string, link?: string | null, alternativeText?: string | null, tags: Array<string>, orderIndex?: number | null, linkItem?: { __typename?: 'PageLink', url?: string | null, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null } | null, image?: { __typename?: 'FileInfo', id: string, url: string, fileMode: FileModes, fileExtension: string, fileName: string, deletedAt?: any | null, updatedAt: any, fileMongoId?: string | null, createdAt: any } | null }> | null } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type SliderItemByIdQueryVariables = Exact<{
  sliderItemId: Scalars['ID']['input'];
}>;


export type SliderItemByIdQuery = { __typename?: 'Query', sliderItem: { __typename?: 'SliderItem', id: string, title: string, link?: string | null, description?: string | null, alternativeText?: string | null, tags: Array<string>, linkItem?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null, image?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } };

export type PageSliderBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageSliderBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock', id: string, description: string, pageBlockStyle?: PageBlockStyles | null, sliders?: Array<{ __typename?: 'SliderItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, orderIndex?: number | null, alternativeText?: string | null, tags: Array<string>, link?: string | null, description?: string | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> | null } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateSliderItemOrdersMutationVariables = Exact<{
  input: UpdateSliderItemsInput;
}>;


export type UpdateSliderItemOrdersMutation = { __typename?: 'Mutation', updateSliderItemOrders: Array<{ __typename?: 'SliderItem', id: string, orderIndex?: number | null }> };

export type RemoveSliderItemMutationVariables = Exact<{
  removeSliderItemId: Scalars['ID']['input'];
}>;


export type RemoveSliderItemMutation = { __typename?: 'Mutation', removeSliderItem: { __typename?: 'SliderItem', updatedAt: any } };

export type ItemsSliderCarouselMutationVariables = Exact<{
  updateInput: UpdateSliderItemInput;
}>;


export type ItemsSliderCarouselMutation = { __typename?: 'Mutation', updateSliderItemInput: { __typename?: 'SliderItem', id: string, title: string, tags: Array<string>, link?: string | null, description?: string | null, alternativeText?: string | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } };

export type UpdatePageBlockStyleSliderMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockStyleSliderMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock', pageBlockStyle?: PageBlockStyles | null, id: string } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type CloneSliderByStyleMutationVariables = Exact<{
  cloneSliderStyleArg: CloneSliderStyleArg;
}>;


export type CloneSliderByStyleMutation = { __typename?: 'Mutation', cloneSliderByStyle: Array<{ __typename?: 'SliderItem', id: string }> };

export type CreateSliderItemMutationVariables = Exact<{
  createInput: CreateSliderItemInput;
}>;


export type CreateSliderItemMutation = { __typename?: 'Mutation', createSliderItem: { __typename?: 'SliderItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, alternativeText?: string | null, tags: Array<string>, link?: string | null, description?: string | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } };

export type UpdatePressRooomSocialNetworksBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePressRooomSocialNetworksBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock', id: string } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPressRooomSocialNetworksBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPressRooomSocialNetworksBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock', id: string, description: string, blockTitle?: string | null, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename?: 'PageSnsBlockItem', id: string, orderIndex: number, description?: string | null, snsTitle: string, createdAt: any, updatedAt: any, itemLink?: { __typename?: 'PageLink', arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null }> } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreateSocialNetworkPressRoomItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateSocialNetworkPressRoomItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem', id: string } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateSocialNetworkPressRoomItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateSocialNetworkPressRoomItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem', id: string } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetSocialNetworkPressRoomItemQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetSocialNetworkPressRoomItemQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem', id: string, snsTitle: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveSocialNetworkPressRoomItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveSocialNetworkPressRoomItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem', id: string } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type NewsItemsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<FindNewsWhere>;
  orderBy?: InputMaybe<Array<FindNewsOrderBy> | FindNewsOrderBy>;
}>;


export type NewsItemsQuery = { __typename?: 'Query', newsItems: Array<{ __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, expiredDate?: any | null, hasExpirationDate: boolean, newsItemTags: Array<string>, date: any, publicationDate?: any | null, newsStatus?: VersionStates | null, summary: string, image?: { __typename?: 'FileInfo', id: string, fileName: string, url: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null }> };

export type NewsItemQueryVariables = Exact<{
  newsItemId: Scalars['ID']['input'];
}>;


export type NewsItemQuery = { __typename?: 'Query', newsItem: { __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, content: string, date: any, publicationDate?: any | null, expiredDate?: any | null, newsItemTags: Array<string>, image?: { __typename?: 'FileInfo', id: string, fileName: string, url: string, downloadUrl?: string | null, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } };

export type NewsItemBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type NewsItemBySlugQuery = { __typename?: 'Query', newsItemBySlug?: { __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, content: string, date: any, publicationDate?: any | null, expiredDate?: any | null, newsItemTags: Array<string>, image?: { __typename?: 'FileInfo', id: string, fileName: string, url: string, downloadUrl?: string | null, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } | null };

export type NewsTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsTagsQuery = { __typename?: 'Query', newsTags: Array<string> };

export type NewsItemsCountQueryVariables = Exact<{
  where?: InputMaybe<FindNewsWhere>;
  pagination?: InputMaybe<Pagination>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type NewsItemsCountQuery = { __typename?: 'Query', newsItemsCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type PressroomQueryVariables = Exact<{ [key: string]: never; }>;


export type PressroomQuery = { __typename?: 'Query', pressroom: Array<{ __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageCabinetBlock' } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock' } | { __typename: 'PageEventSliderBlock' } | { __typename: 'PageInstitutionalProgramsSliderBlock' } | { __typename: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', pageBlockStyle?: PageBlockStyles | null, tagStyle?: PageBlockStyles | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, global?: boolean | null, news: Array<{ __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, date: any, publicationDate?: any | null, expiredDate?: any | null, summary: string, newsStatus?: VersionStates | null, multimediaType?: MultimediaTypes | null, alternativeText?: string | null, link?: string | null, imageLink?: string | null, dateImages?: any | null, newsItemTags: Array<string>, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }> } | { __typename: 'PageParticipateDownloadBlock' } | { __typename: 'PageParticipateElementBlock' } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, subtitle?: string | null, hasSearchbar?: boolean | null, pagePressroomBlockTitle?: string | null } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar' } | { __typename: 'PageRegulationsBlock' } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock', pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename: 'PageSnsBlockItem', id: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename: 'PageLink', id: string, url?: string | null, target?: string | null } | null }> } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null, leftItems: Array<{ __typename?: 'PageSocialNetworksLeftBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, imageLink?: string | null, alternativeText?: string | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }>, rightItems: Array<{ __typename?: 'PageSocialNetworksRightBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, socialNetworkType?: SocialNetworkType | null, hasRightItem?: boolean | null, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock' } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type PageSocialNetworksBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageSocialNetworksBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, seeMoreLink?: string | null, leftItems: Array<{ __typename: 'PageSocialNetworksLeftBlockItem', id: string, orderIndex: number, image?: { __typename: 'FileInfo', id: string } | null }>, rightItems: Array<{ __typename: 'PageSocialNetworksRightBlockItem', id: string, orderIndex: number, socialNetworkType?: SocialNetworkType | null, link?: string | null, linkItem?: { __typename: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type SocialNetworkDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type SocialNetworkDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock', id: string, canBeDisabled: boolean, location: BlockLocation, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, pageBlockStyle?: PageBlockStyles | null, leftItems: Array<{ __typename?: 'PageSocialNetworksLeftBlockItem', id: string, orderIndex: number, description?: string | null, alternativeText?: string | null, createdAt: any, updatedAt: any, image?: { __typename?: 'FileInfo', id: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, fileName: string, url: string } | null, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null }>, rightItems: Array<{ __typename?: 'PageSocialNetworksRightBlockItem', id: string, orderIndex: number, description?: string | null, createdAt: any, updatedAt: any, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateSocialNetworksBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateSocialNetworksBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock', id: string } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type CreateTabSocialNetworkMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateTabSocialNetworkMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem', id: string } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateTabSocialNetworkMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateTabSocialNetworkMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem', id: string } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetTabSocialNetworkQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetTabSocialNetworkQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem', id: string, description?: string | null, socialNetworkType?: SocialNetworkType | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveTabSocialNetworkMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveTabSocialNetworkMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem', id: string } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type CreateCarouselSocialNetworkMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateCarouselSocialNetworkMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem', id: string } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateCarouselSocialNetworkMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateCarouselSocialNetworkMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem', id: string } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetCarouselSocialNetworkQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetCarouselSocialNetworkQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem', id: string, description?: string | null, alternativeText?: string | null, image?: { __typename?: 'FileInfo', id: string, url: string, fileMode: FileModes, fileExtension: string, fileName: string, deletedAt?: any | null, updatedAt: any, fileMongoId?: string | null, createdAt: any } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveCarouselSocialNetworkMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveCarouselSocialNetworkMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem', id: string } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type GetPageStyledTableBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageStyledTableBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock', id: string, title?: string | null, contentType?: TableContentType | null, description: string, extendedDescription?: string | null, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, itemsPerPage?: number | null, rows: Array<{ __typename?: 'PageStyledTableBlockRow', id: string, orderIndex: number, cellData?: Array<{ __typename?: 'PageStyledTableBlockRowData', id: string, value?: string | null, updatedAt: any, column?: { __typename?: 'PageStyledTableBlockItem', id: string } | null }> | null }>, columns: Array<{ __typename?: 'PageStyledTableBlockItem', id: string, allowFilter?: boolean | null, allowSort?: boolean | null, columnName?: string | null, columnWidth?: number | null, dataType?: ColumnDataType | null, orderIndex: number, description?: string | null, configJson?: string | null, mappedField?: { __typename?: 'ContentSchemaField', id: string, orderIndex: number } | null }>, contentSchema?: { __typename?: 'ContentSchema', id: string, fields: Array<{ __typename?: 'ContentSchemaField', id: string, fieldName: string, fieldType: FieldType, orderIndex: number }> } | null } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageStyledTableBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageStyledTableBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock', id: string } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type CreatePageStyledTableBlockItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageStyledTableBlockItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow', styledTableBlock?: { __typename?: 'PageStyledTableBlock', id: string } | null } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdatePageStyledTableBlockItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageStyledTableBlockItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow', styledTableBlock?: { __typename?: 'PageStyledTableBlock', id: string } | null } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type RemovePageStyledTableBlockItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemovePageStyledTableBlockItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow', id: string } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type StyledTableDocumentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type StyledTableDocumentQuery = { __typename?: 'Query', document: { __typename?: 'DocumentEntity', id: string, fileId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description?: string | null, type: TypeContent, status: ContentStatus, contentDate?: any | null, migrationMetadata?: string | null, publishDate?: any | null, expirationDate?: any | null, downloadText?: string | null, downloadCount?: string | null, fileSize?: string | null, mimeType?: string | null, file?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null } };

export type StyledTableDocumentsQueryVariables = Exact<{
  where?: InputMaybe<FindContentWhere>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindContentOrderBy> | FindContentOrderBy>;
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  metadataFieldFilters?: InputMaybe<Array<MetadataFieldFilter> | MetadataFieldFilter>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy> | MetadataFieldOrderBy>;
}>;


export type StyledTableDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'DocumentEntity', id: string, title: string, createdAt: any, status: ContentStatus, fileId?: string | null, metadata: Array<{ __typename?: 'DocumentMetadata', id: string, value?: string | null, schemaField: { __typename?: 'ContentSchemaField', id: string, fieldName: string } }> }>, documentsCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type PageStyledTableBlockRowsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<PageStyledTableBlockRowWhere>;
  styledTableBlockId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageStyledTableBlockRowsQuery = { __typename?: 'Query', pageStyledTableBlockRows: Array<{ __typename?: 'PageStyledTableBlockRow', id: string, cellData?: Array<{ __typename?: 'PageStyledTableBlockRowData', id: string, value?: string | null, updatedAt: any, column?: { __typename?: 'PageStyledTableBlockItem', id: string } | null }> | null }>, paginationPageStyledTableBlockRows: { __typename?: 'PaginationResult', total: number, count: number, limit?: number | null, page: number, pageCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };

export type PageDownloadBlockItemAllQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
  where?: InputMaybe<FindPageBlockItemsWhere>;
  positions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FindPageBlockItemsOrderBy> | FindPageBlockItemsOrderBy>;
  positionOrder?: InputMaybe<OrderTypes>;
}>;


export type PageDownloadBlockItemAllQuery = { __typename?: 'Query', pageBlockItems: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, name: string, file: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type CreatePageBlockItemDownloadMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageBlockItemDownloadMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, name: string, file: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdatePageBlockItemDownloadMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemDownloadMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem', id: string } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type PageDownloadItemByIdQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageDownloadItemByIdQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, name: string, file: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type PageSubDownloadBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageSubDownloadBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock', id: string, subDownloadTitle?: string | null, subDownloadPlaceholder?: string | null, subDownloadDescription?: string | null, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, subDownloadSearchbar?: boolean | null, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageBlockDownloadMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockDownloadMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock', isCarrousel?: boolean | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null, description: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageTaxesBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageTaxesBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock', id: string } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageTaxesBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageTaxesBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock', id: string, pageBlockStyle?: PageBlockStyles | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, items: Array<{ __typename?: 'PageTaxesBlockItem', id: string, orderIndex: number, taxTitle: string, description?: string | null, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null, image?: { __typename?: 'FileInfo', id: string, fileMongoId?: string | null, fileName: string, fileExtension: string, fileMode: FileModes, url: string } | null }> } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreateTaxAccessBlockItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateTaxAccessBlockItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem', id: string } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateTaxAccessBlockItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateTaxAccessBlockItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem', id: string } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetTaxAccessBlockItemQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetTaxAccessBlockItemQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem', id: string, description?: string | null, taxTitle: string, link: string, image?: { __typename?: 'FileInfo', downloadUrl?: string | null, fileExtension: string, fileMode: FileModes, id: string, fileName: string, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveTaxAccessBlockItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveTaxAccessBlockItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem', id: string } | { __typename?: 'PageTransparencyBlockItem' } };

export type PageTaxAccesButtonBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageTaxAccesButtonBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string, items: Array<{ __typename: 'PageTaxesBlockItem', id: string, orderIndex: number, taxTitle: string, link: string, image?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PageAccessibilityBarQueryVariables = Exact<{ [key: string]: never; }>;


export type PageAccessibilityBarQuery = { __typename?: 'Query', footer: Array<{ __typename?: 'PageAccessibilityBar', pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageFooterBar' }> };

export type GetDocumentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', document: { __typename: 'DocumentEntity', id: string, fileId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description?: string | null, type: TypeContent, status: ContentStatus, contentDate?: any | null, migrationMetadata?: string | null, publishDate?: any | null, expirationDate?: any | null, downloadText?: string | null, downloadCount?: string | null, fileSize?: string | null, mimeType?: string | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, file?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null, metadata: Array<{ __typename?: 'DocumentMetadata', id: string, value?: string | null, schemaField: { __typename?: 'ContentSchemaField', id: string, fieldName: string } }> } };

export type UpdatePasswordMutationVariables = Exact<{
  updatePasswordInput: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', id: string } };

export type ParametersDefaultQueryVariables = Exact<{ [key: string]: never; }>;


export type ParametersDefaultQuery = { __typename?: 'Query', parametersDefault?: Array<{ __typename?: 'Parameter', id: string, code: string, description: string, type: TypeParameter, character?: string | null, number?: number | null, date?: any | null, json?: string | null }> | null };

export type QueryValidateClonseVersionQueryVariables = Exact<{
  createInput: ClonePageVersionInput;
}>;


export type QueryValidateClonseVersionQuery = { __typename?: 'Query', validateClonePageVersion: ActionCloneVersion };

export type LayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type LayoutQuery = { __typename?: 'Query', header: Array<{ __typename?: 'PageAccessibilityButton', id: string, description: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, isFromTemplate: boolean, templateOriginName?: string | null, templateOriginId?: string | null, clonedFromTemplateAt?: any | null, type?: string | null, title?: string | null, isEnabled: boolean, tooltipText?: string | null, buttonColor: string, maxItems: number, items: Array<{ __typename?: 'PageAccessibilityButtonItem', id: string, altText: string, iconType: AccessibilityIconType, isActive: boolean, orderIndex: number, linkUrl?: string | null, linkName: string, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasSearchbar: boolean, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, logoLink?: string | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null, logoImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, administrationLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, adminOtherLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, govcoLink?: { __typename: 'PageLink', id: string, routeNavigation?: SubPages | null, routeType?: RouterType | null, arguments?: Array<string> | null, target?: string | null, updatedAt: any, url?: string | null, createdAt: any, deletedAt?: any | null } | null } | { __typename?: 'PageHeaderOrganizationBar', id: string, title?: string | null, subtitle?: string | null, blockTitle?: string | null, logoImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, logoImageLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null, adminOtherLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, adminAnotherLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null, administrationLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, adminLogoLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null } | { __typename?: 'PageNavigationBar', id: string, orderIndex: number, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageSearchBlock', id: string, orderIndex: number, blockTitle?: string | null, type?: string | null, pageBlockStyle?: PageBlockStyles | null, description: string, isDisabled: boolean, createdAt: any, updatedAt: any, placeholder?: string | null, canBeDisabled: boolean }>, footer: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, items: Array<{ __typename?: 'PageCorporateLogosBlockItem', id: string, corporateLogoLink?: string | null, corporateLogoName?: string | null, orderIndex: number, corporateLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, campusData?: string | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, subtitle?: string | null, nit?: string | null, address?: string | null, postalCode?: string | null, openingHours?: string | null, phone?: string | null, fax?: string | null, citizenLine?: string | null, antiCorruptionLine?: string | null, institutionalEmail?: string | null, judicialEmail?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string, logoImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, administrationLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, adminOtherLogo?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, items: Array<{ __typename?: 'PageFooterBarItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, socialNetworkName?: string | null, socialNetworkLink?: string | null, pageDirectory?: string | null, footerType?: FooterItemType | null, hasSocialNetworkIcon?: boolean | null, routeType?: RouterType | null, pageDirectoryLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, socialNetworkIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null }> }> };

export type PageTaxesBlockQueryVariables = Exact<{ [key: string]: never; }>;


export type PageTaxesBlockQuery = { __typename?: 'Query', mainPage: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string, items: Array<{ __typename?: 'PageTaxesBlockItem', id: string, taxTitle: string, link: string, image?: { __typename?: 'FileInfo', id: string, url: string } | null }> } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PageVersionsQuery = { __typename?: 'Query', pageVersions: Array<{ __typename?: 'PageVersion', id: string, state: VersionStates, description: string, theme: Theme, consecutive?: string | null, user?: { __typename?: 'User', fullName: string } | null }> };

export type NavigationTreeQueryVariables = Exact<{
  navigationBarId: Scalars['ID']['input'];
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NavigationTreeQuery = { __typename?: 'Query', navigationTree: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, signLanguageDescription?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, signLanguageGif?: { __typename?: 'FileInfo', id: string, downloadUrl?: string | null, url: string, fileName: string } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> }> }> }> }> };

export type NavigationTreeAdminQueryVariables = Exact<{
  navigationBarId: Scalars['ID']['input'];
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NavigationTreeAdminQuery = { __typename?: 'Query', navigationTreeAdmin: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, signLanguageDescription?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, signLanguageGif?: { __typename?: 'FileInfo', id: string, downloadUrl?: string | null, url: string, fileName: string } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, description: string, orderIndex: number, depth?: number | null, status: ItemStatus, isVisible: boolean, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> }> }> }> }> };

export type HistoriesQueryVariables = Exact<{
  pageDynamicId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type HistoriesQuery = { __typename?: 'Query', histories: Array<{ __typename?: 'History', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, dataId?: string | null, ipAddress?: string | null, consecutive?: string | null, changedBy?: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null } | null, pageDynamic: { __typename: 'PageDynamic', createdAt: any, id: string, updatedAt: any, deletedAt?: any | null, name: string, type: PageDynamicType, description?: string | null, status: VersionStates, parent?: { __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, status: VersionStates } | null, children: Array<{ __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, status: VersionStates }>, dependency?: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } | null, editors: Array<{ __typename?: 'Editor', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, assignedAt: any, isActive: boolean, notes?: string | null }> }, basedOn?: { __typename?: 'History', id: string } | null }> };

export type RecoverPageDynamicMutationVariables = Exact<{
  historyId: Scalars['String']['input'];
  pageDynamicId: Scalars['String']['input'];
}>;


export type RecoverPageDynamicMutation = { __typename?: 'Mutation', recoverPageDynamic: boolean };

export type GetComparativeJsonFromHistoryQueryVariables = Exact<{
  firstHistoryId: Scalars['String']['input'];
  secondHistoryId: Scalars['String']['input'];
}>;


export type GetComparativeJsonFromHistoryQuery = { __typename?: 'Query', getComparativeJsonFromHistory: Array<string> };

export type GetPageDynamicFromHistoryQueryVariables = Exact<{
  historyId: Scalars['String']['input'];
  pageDynamicId: Scalars['String']['input'];
}>;


export type GetPageDynamicFromHistoryQuery = { __typename?: 'Query', getPageDynamicFromHistory: { __typename?: 'PageDynamic', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, status: VersionStates, type: PageDynamicType, blocks: Array<{ __typename?: 'PageBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, version?: { __typename?: 'PageVersion', id: string } | null }> } };

export type DynamicPagesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindPageDynamicsOrderBy> | FindPageDynamicsOrderBy>;
  where?: InputMaybe<FindPageDynamicsWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type DynamicPagesQuery = { __typename?: 'Query', pageDynamics: Array<{ __typename?: 'PageDynamic', id: string, type: PageDynamicType, title: string, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null }> };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, type: UserTypes, country?: { __typename?: 'Country', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, department?: { __typename?: 'Department', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, city?: { __typename?: 'City', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null }> };

export type SacConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type SacConnectionQuery = { __typename?: 'Query', sacConnection: string };

export type SharedDocumentsQueryVariables = Exact<{
  contentType: ContentType;
  orderBy?: InputMaybe<Array<FindMySharedContentOrderBy> | FindMySharedContentOrderBy>;
  where?: InputMaybe<FindMySharedContentWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type SharedDocumentsQuery = { __typename?: 'Query', mySharedContent: Array<{ __typename?: 'ContentSharing', contentId: string, document?: { __typename?: 'DocumentEntity', id: string, title: string, status: ContentStatus, createdAt: any, publishDate?: any | null, schema?: { __typename?: 'ContentSchema', id: string, name: string } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, file?: { __typename?: 'FileInfo', downloadUrl?: string | null } | null } | null }>, mySharedContentCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type SharedNewsQueryVariables = Exact<{
  contentType: ContentType;
  orderBy?: InputMaybe<Array<FindMySharedContentOrderBy> | FindMySharedContentOrderBy>;
  where?: InputMaybe<FindMySharedContentWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type SharedNewsQuery = { __typename?: 'Query', mySharedContent: Array<{ __typename?: 'ContentSharing', contentId: string, newsItem?: { __typename?: 'NewsItem', title: string, createdAt: any, date: any, expiredDate?: any | null, newsStatus?: VersionStates | null, id: string, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null } | null }>, mySharedContentCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type SharedEventsQueryVariables = Exact<{
  contentType: ContentType;
  orderBy?: InputMaybe<Array<FindMySharedContentOrderBy> | FindMySharedContentOrderBy>;
  where?: InputMaybe<FindMySharedContentWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type SharedEventsQuery = { __typename?: 'Query', mySharedContent: Array<{ __typename?: 'ContentSharing', contentId: string, eventItem?: { __typename?: 'EventsItem', id: string, startDate: any, endDate: any, createdAt: any, eventStatus?: EventStates | null, eventItemTitle: string, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null } | null }>, mySharedContentCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type UpdateNewsStatusToDraftMutationVariables = Exact<{
  updateNewsStatusToDraft: UpdateNewsItemStatus;
}>;


export type UpdateNewsStatusToDraftMutation = { __typename?: 'Mutation', updateNewsStatusToDraft: string };

export type UpdatePageBlockItemOrdersMutationVariables = Exact<{
  input: Array<UpdateOrderPageBlockItemInput> | UpdateOrderPageBlockItemInput;
}>;


export type UpdatePageBlockItemOrdersMutation = { __typename?: 'Mutation', updatePageBlockItemOrders: Array<{ __typename?: 'PageBlockItem', id: string, orderIndex: number }> };

export type UpdatePageAccessibilityBarMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageAccessibilityBarMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar', id: string } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageAccessibilityBarBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageAccessibilityBarBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar', id: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type AccessibilityButtonDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type AccessibilityButtonDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton', id: string, items: Array<{ __typename?: 'PageAccessibilityButtonItem', id: string, linkName: string, iconType: AccessibilityIconType, isActive: boolean, orderIndex: number, linkUrl?: string | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreateAccessibilityButtonMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateAccessibilityButtonMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem', id: string } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateAccessibilityButtonItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateAccessibilityButtonItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem', id: string } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetAccessibilityButtonItemQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetAccessibilityButtonItemQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem', id: string, description?: string | null, linkName: string, iconType: AccessibilityIconType, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveAccessibilityButtonItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveAccessibilityButtonItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem', id: string } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type CreateUserMutationVariables = Exact<{
  createInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, phoneNumber?: string | null, address?: string | null, identificationNumber?: string | null } };

export type RemoveUserMutationVariables = Exact<{
  removeUserId: Scalars['ID']['input'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: { __typename?: 'User', id: string } };

export type UpdateUserMutationVariables = Exact<{
  updateInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type UsersAccountsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindUsersOrderBy> | FindUsersOrderBy>;
  where?: InputMaybe<FindUsersWhere>;
  pagination?: InputMaybe<Pagination>;
  fullName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersAccountsQuery = { __typename?: 'Query', users: Array<{ __typename: 'User', id: string, email: string, name?: string | null, fullName: string, updatedAt: any, status: UserStatusTypes, createdAt: any, type: UserTypes, identificationNumber?: string | null, userRoles?: Array<{ __typename: 'UserRole', id: string }> | null, userDependencies: Array<{ __typename: 'UserDependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, status: UserDependencyStatus, dependency: { __typename: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } }> }>, usersCount: { __typename: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type RolesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindRolesOrderBy> | FindRolesOrderBy>;
  where?: InputMaybe<FindRolesWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, description: string, status: RoleStatusTypes, createdAt: any, updatedAt: any, deletedAt?: any | null, defaultForType?: UserTypes | null, users: Array<{ __typename?: 'User', id: string }>, roleFx: Array<{ __typename?: 'RoleFx', id: string }> }>, rolesCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type ExpireCredentialsMutationVariables = Exact<{
  expireCredentialsInput: ExpireCredentialsInput;
}>;


export type ExpireCredentialsMutation = { __typename?: 'Mutation', expireCredentials: Array<{ __typename?: 'User', id: string }> };

export type ForceRecoverPasswordMutationVariables = Exact<{
  recoverPasswordInput: RecoverPasswordInput;
}>;


export type ForceRecoverPasswordMutation = { __typename?: 'Mutation', forceRecoverPassword: string };

export type PageDynamicByIdNewQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageDynamicByIdNewQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasSignin?: boolean | null, hasSignup?: boolean | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageCustomBlock' } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename?: 'PageEventSliderBlock' } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, subtitle?: string | null, nit?: string | null, address?: string | null, postalCode?: string | null, openingHours?: string | null, phone?: string | null, fax?: string | null, citizenLine?: string | null, antiCorruptionLine?: string | null, institutionalEmail?: string | null, judicialEmail?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename?: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string } | { __typename: 'PageTransparencyBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type CreatePageDynamicMutationVariables = Exact<{
  createInput: CreatePageDynamicInput;
}>;


export type CreatePageDynamicMutation = { __typename?: 'Mutation', createPageDynamic: { __typename?: 'PageDynamic', id: string, createdAt: any, updatedAt: any, name: string } };

export type DuplicatePageDynamicMutationVariables = Exact<{
  input: DuplicatePageDynamicInput;
}>;


export type DuplicatePageDynamicMutation = { __typename?: 'Mutation', duplicatePageDynamic: { __typename?: 'PageDynamic', id: string, name: string } };

export type PageDynamicByIdQueryVariables = Exact<{
  pageDynamicId: Scalars['ID']['input'];
}>;


export type PageDynamicByIdQuery = { __typename?: 'Query', pageDynamic?: { __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, description?: string | null, createdAt: any, updatedAt: any, status: VersionStates, parent?: { __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, description?: string | null, createdAt: any, updatedAt: any, status: VersionStates } | null, children: Array<{ __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, description?: string | null, createdAt: any, updatedAt: any, status: VersionStates, editors: Array<{ __typename: 'Editor', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, assignedAt: any, isActive: boolean, notes?: string | null }> }>, dependency?: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } | null };

export type PageDynamicBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PageDynamicBySlugQuery = { __typename?: 'Query', pageDynamicBySlug?: { __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, description?: string | null, createdAt: any, updatedAt: any, status: VersionStates, parent?: { __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, description?: string | null, createdAt: any, updatedAt: any, status: VersionStates } | null, children: Array<{ __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, description?: string | null, createdAt: any, updatedAt: any, status: VersionStates, editors: Array<{ __typename: 'Editor', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, assignedAt: any, isActive: boolean, notes?: string | null }> }>, dependency?: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } | null };

export type FindPageBlockByDynamicQueryVariables = Exact<{
  dynamicId: Scalars['ID']['input'];
}>;


export type FindPageBlockByDynamicQuery = { __typename?: 'Query', findPageBlockByDynamic: Array<{ __typename: 'PageBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, clonedFromTemplateAt?: any | null, isFromTemplate: boolean, templateOriginId?: string | null, templateOriginName?: string | null, version?: { __typename?: 'PageVersion', id: string } | null }> };

export type PageDynamicsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPageDynamicsWhere>;
  orderBy?: InputMaybe<Array<FindPageDynamicsOrderBy> | FindPageDynamicsOrderBy>;
}>;


export type PageDynamicsQuery = { __typename?: 'Query', pageDynamics: Array<{ __typename: 'PageDynamic', createdAt: any, id: string, updatedAt: any, deletedAt?: any | null, name: string, type: PageDynamicType, description?: string | null, status: VersionStates, parent?: { __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, status: VersionStates } | null, children: Array<{ __typename?: 'PageDynamic', id: string, name: string, type: PageDynamicType, status: VersionStates }>, dependency?: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } | null, editors: Array<{ __typename?: 'Editor', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, assignedAt: any, isActive: boolean, notes?: string | null }>, seo?: { __typename?: 'Seo', metadata: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> } | null }>, pageDynamicsCount: { __typename: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type RemovePageDynamicMutationVariables = Exact<{
  removePageDynamicId: Scalars['ID']['input'];
}>;


export type RemovePageDynamicMutation = { __typename?: 'Mutation', removePageDynamic: { __typename?: 'PageDynamic', id: string, name: string } };

export type UpdatePageDynamicMutationVariables = Exact<{
  updateInput: UpdatePageDynamicInput;
}>;


export type UpdatePageDynamicMutation = { __typename?: 'Mutation', updatePageDynamic: { __typename?: 'PageDynamic', id: string, createdAt: any, name: string } };

export type UpdateEventsItemByIdMutationVariables = Exact<{
  updateInput: UpdateEventsItemInput;
}>;


export type UpdateEventsItemByIdMutation = { __typename?: 'Mutation', updateEventsItem: { __typename?: 'EventsItem', id: string } };

export type EventsItemByIdQueryVariables = Exact<{
  eventsItemId: Scalars['ID']['input'];
}>;


export type EventsItemByIdQuery = { __typename?: 'Query', eventsItem: { __typename?: 'EventsItem', id: string, descriptionPlace?: string | null, latitude?: string | null, longitude?: string | null, eventItemTitle: string, eventItemDescription?: string | null, startDate: any, endDate: any, address?: string | null, alternativeText?: string | null, phoneEvent?: string | null, emailEvent?: string | null, groupEvent?: string | null, paymentTypeEvent?: EventPaymentType | null, dynamicView?: boolean | null, multimediaType?: MultimediaTypes | null, eventItemTags: Array<string>, summary?: string | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } };

export type EventsItemBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type EventsItemBySlugQuery = { __typename?: 'Query', eventsItemBySlug?: { __typename?: 'EventsItem', id: string, descriptionPlace?: string | null, latitude?: string | null, longitude?: string | null, eventItemTitle: string, eventItemDescription?: string | null, startDate: any, endDate: any, address?: string | null, alternativeText?: string | null, phoneEvent?: string | null, emailEvent?: string | null, groupEvent?: string | null, paymentTypeEvent?: EventPaymentType | null, dynamicView?: boolean | null, multimediaType?: MultimediaTypes | null, eventItemTags: Array<string>, summary?: string | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } | null };

export type CreateEventsItemMutationVariables = Exact<{
  createInput: CreateEventsItemInput;
}>;


export type CreateEventsItemMutation = { __typename?: 'Mutation', createEventsItem: { __typename?: 'EventsItem', id: string, eventItemTitle: string, eventItemDescription?: string | null, latitude?: string | null, longitude?: string | null, descriptionPlace?: string | null, eventItemTags: Array<string>, multimediaType?: MultimediaTypes | null, startDate: any, endDate: any, address?: string | null, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, arguments?: Array<string> | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null } | null } };

export type EventsItemsQueryVariables = Exact<{
  where?: InputMaybe<FindEventWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindEventOrderBy> | FindEventOrderBy>;
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsItemsQuery = { __typename?: 'Query', eventsItems: Array<{ __typename?: 'EventsItem', startDate: any, endDate: any, createdAt: any, eventStatus?: EventStates | null, id: string, eventItemTitle: string, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, sharedWith: Array<{ __typename?: 'ContentSharing', targetDependency?: { __typename?: 'Dependency', id: string, name: string } | null }> }>, eventsItemsCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type AllEventsQueryVariables = Exact<{
  where?: InputMaybe<FindEventWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindEventOrderBy> | FindEventOrderBy>;
  targetDependencyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllEventsQuery = { __typename?: 'Query', eventsItems: Array<{ __typename?: 'EventsItem', id: string, endDate: any, startDate: any, createdAt: any, eventStatus?: EventStates | null, eventItemTitle: string, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, sharedWith: Array<{ __typename?: 'ContentSharing', targetDependency?: { __typename?: 'Dependency', id: string, name: string } | null }> }>, eventsItemsCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type UpdateEventsItemMutationVariables = Exact<{
  updateInput: UpdateEventsItemInput;
}>;


export type UpdateEventsItemMutation = { __typename?: 'Mutation', updateEventsItem: { __typename?: 'EventsItem', eventStatus?: EventStates | null, id: string } };

export type UpdateEventStatusToDraftMutationVariables = Exact<{
  updateEventStatusToDraft: UpdateEventItemStatus;
}>;


export type UpdateEventStatusToDraftMutation = { __typename?: 'Mutation', updateEventStatusToDraft: string };

export type RemoveEventsItemMutationVariables = Exact<{
  removeEventsItemId: Scalars['ID']['input'];
}>;


export type RemoveEventsItemMutation = { __typename?: 'Mutation', removeEventsItem: { __typename?: 'EventsItem', id: string } };

export type UpdateInstitutionalProgramsItemNewMutationVariables = Exact<{
  updateInput: UpdateInstitutionalProgramsItemInput;
}>;


export type UpdateInstitutionalProgramsItemNewMutation = { __typename?: 'Mutation', updateInstitutionalProgramsItem: { __typename?: 'InstitutionalProgramsItem', id: string, title: string, description: string, programsType?: ProgramsTypes | null, programsStatus?: VersionStates | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, pageLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } };

export type InstitutionalProgramsItemQueryVariables = Exact<{
  institutionalProgramsItemId: Scalars['ID']['input'];
}>;


export type InstitutionalProgramsItemQuery = { __typename?: 'Query', institutionalProgramsItem: { __typename?: 'InstitutionalProgramsItem', id: string, title: string, description: string, programsType?: ProgramsTypes | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, pageLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } };

export type UpdateInstitutionalProgramsStatusToDraftMutationVariables = Exact<{
  updateInstitutionalProgramsItemStatus: UpdateInstitutionalProgramsItemStatus;
}>;


export type UpdateInstitutionalProgramsStatusToDraftMutation = { __typename?: 'Mutation', updateInstitutionalProgramsStatusToDraft: string };

export type InstitutionalProgramsItemsQueryVariables = Exact<{
  where?: InputMaybe<FindInstitutionalProgramsItemWhere>;
  orderBy?: InputMaybe<Array<FindInstitutionalProgramsOrderBy> | FindInstitutionalProgramsOrderBy>;
  pagination?: InputMaybe<Pagination>;
}>;


export type InstitutionalProgramsItemsQuery = { __typename?: 'Query', institutionalProgramsItems: Array<{ __typename?: 'InstitutionalProgramsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description: string, programsStatus?: VersionStates | null, programsType?: ProgramsTypes | null, pageLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }>, institutionalProgramsItemsCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type CreateInstitutionalProgramsItemMutationVariables = Exact<{
  createInput: CreateInstitutionalProgramsItemInput;
}>;


export type CreateInstitutionalProgramsItemMutation = { __typename?: 'Mutation', createInstitutionalProgramsItem: { __typename?: 'InstitutionalProgramsItem', id: string, title: string, description: string, programsType?: ProgramsTypes | null, programsStatus?: VersionStates | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, pageLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } };

export type UpdateInstitutionalProgramsItemMutationVariables = Exact<{
  updateInput: UpdateInstitutionalProgramsItemInput;
}>;


export type UpdateInstitutionalProgramsItemMutation = { __typename?: 'Mutation', updateInstitutionalProgramsItem: { __typename?: 'InstitutionalProgramsItem', id: string } };

export type RemoveInstitutionalProgramsItemMutationVariables = Exact<{
  removeInstitutionalProgramsItemId: Scalars['ID']['input'];
}>;


export type RemoveInstitutionalProgramsItemMutation = { __typename?: 'Mutation', removeInstitutionalProgramsItem: { __typename?: 'InstitutionalProgramsItem', id: string } };

export type PqrsdActionContentsAdminQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindProceduresOrderBy> | FindProceduresOrderBy>;
  where?: InputMaybe<FindProceduresWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type PqrsdActionContentsAdminQuery = { __typename?: 'Query', procedures: Array<{ __typename?: 'Procedure', id: string, name: string, procedureDescription?: string | null, procedureStatus?: VersionStates | null, createdAt: any, updatedAt: any }>, proceduresCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type PqrsdActionContentAdminQueryVariables = Exact<{
  dynamicPageId: Scalars['ID']['input'];
}>;


export type PqrsdActionContentAdminQuery = { __typename?: 'Query', procedure: { __typename?: 'Procedure', id: string, name: string, procedureDescription?: string | null, processDefinitionId?: string | null, govcoImage?: { __typename?: 'FileInfo', id: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, fileName: string, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null } | null } };

export type CreatePqrsdActionContentAdminMutationVariables = Exact<{
  createInput: CreateProcedureInput;
}>;


export type CreatePqrsdActionContentAdminMutation = { __typename?: 'Mutation', createProcedure: { __typename?: 'Procedure', id: string, name: string } };

export type UpdatePqrsdActionContentAdminMutationVariables = Exact<{
  updateInput: UpdateProcedureInput;
}>;


export type UpdatePqrsdActionContentAdminMutation = { __typename?: 'Mutation', updateProcedure: { __typename?: 'Procedure', id: string, name: string } };

export type RemovePqrsdActionContentAdminMutationVariables = Exact<{
  removeProcedureId: Scalars['ID']['input'];
}>;


export type RemovePqrsdActionContentAdminMutation = { __typename?: 'Mutation', removeProcedure: { __typename?: 'Procedure', id: string } };

export type UpdatePqrsdActionContentStatusToDraftMutationVariables = Exact<{
  updateProcedureStatusToDraft: UpdateProcedureStatusToDraft;
}>;


export type UpdatePqrsdActionContentStatusToDraftMutation = { __typename?: 'Mutation', updateProcedureStatusToDraft: string };

export type CreateNewsItemNewsMutationVariables = Exact<{
  createInput: CreateNewsItemInput;
}>;


export type CreateNewsItemNewsMutation = { __typename?: 'Mutation', createNewsItem: { __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, content: string, expiredDate?: any | null, alternativeText?: string | null } };

export type NewsItemNewQueryVariables = Exact<{
  newsItemId: Scalars['ID']['input'];
}>;


export type NewsItemNewQuery = { __typename?: 'Query', newsItem: { __typename: 'NewsItem', id: string, multimediaType?: MultimediaTypes | null, title: string, summary: string, newsItemTags: Array<string>, createdAt: any, updatedAt: any, deletedAt?: any | null, date: any, content: string, expiredDate?: any | null, hasExpirationDate: boolean, alternativeText?: string | null, newsStatus?: VersionStates | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, downloadUrl?: string | null, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } };

export type CreateNewsItemManagementMutationVariables = Exact<{
  createInput: CreateNewsItemInput;
}>;


export type CreateNewsItemManagementMutation = { __typename?: 'Mutation', createNewsItem: { __typename?: 'NewsItem', title: string, content: string, date: any, expiredDate?: any | null, newsItemTags: Array<string>, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } };

export type UpdateNewsItemNewMutationVariables = Exact<{
  updateInput: UpdateNewsItemInput;
}>;


export type UpdateNewsItemNewMutation = { __typename?: 'Mutation', updateNewsItem: { __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, content: string, date: any, expiredDate?: any | null, summary: string, newsStatus?: VersionStates | null, alternativeText?: string | null, newsItemTags: Array<string>, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } };

export type UpdateNewsItemMutationVariables = Exact<{
  updateInput: UpdateNewsItemInput;
}>;


export type UpdateNewsItemMutation = { __typename?: 'Mutation', updateNewsItem: { __typename?: 'NewsItem', newsStatus?: VersionStates | null } };

export type RemoveNewsItemMutationVariables = Exact<{
  removeNewsItemId: Scalars['ID']['input'];
}>;


export type RemoveNewsItemMutation = { __typename?: 'Mutation', removeNewsItem: { __typename?: 'NewsItem', id: string } };

export type UpdateProcedureMutationVariables = Exact<{
  updateInput: UpdateProcedureInput;
}>;


export type UpdateProcedureMutation = { __typename?: 'Mutation', updateProcedure: { __typename?: 'Procedure', updatedAt: any, publicationDate?: any | null, procedureStatus?: VersionStates | null, procedureItemTags: Array<string>, procedureDescription?: string | null, name: string, multimediaType?: MultimediaTypes | null, modality: ModalityTypes, id: string, gocvoLogoName?: string | null, estimatedDuration?: number | null, duration?: DurationTypes | null, deletedAt?: any | null, date?: string | null, createdAt: any, cost: CostTypes, alternativeText?: string | null, actionLink?: string | null, action?: string | null, showGovcoButton: boolean, showProcedureButton: boolean, linkItem?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, deletedAt?: any | null, createdAt: any, arguments?: Array<string> | null } | null, govcoLink?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, deletedAt?: any | null, createdAt: any, arguments?: Array<string> | null } | null, govcoImage?: { __typename?: 'FileInfo', url: string, updatedAt: any, id: string, fileName: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, deletedAt?: any | null, createdAt: any } | null } };

export type CreateProcedureMutationVariables = Exact<{
  createInput: CreateProcedureInput;
}>;


export type CreateProcedureMutation = { __typename?: 'Mutation', createProcedure: { __typename?: 'Procedure', updatedAt: any, alternativeText?: string | null, publicationDate?: any | null, procedureStatus?: VersionStates | null, procedureItemTags: Array<string>, procedureDescription?: string | null, name: string, multimediaType?: MultimediaTypes | null, modality: ModalityTypes, id: string, gocvoLogoName?: string | null, estimatedDuration?: number | null, duration?: DurationTypes | null, deletedAt?: any | null, date?: string | null, createdAt: any, cost: CostTypes, actionLink?: string | null, showGovcoButton: boolean, showProcedureButton: boolean, linkItem?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, deletedAt?: any | null, createdAt: any, arguments?: Array<string> | null } | null, govcoLink?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, deletedAt?: any | null, createdAt: any, arguments?: Array<string> | null } | null, govcoImage?: { __typename?: 'FileInfo', url: string, updatedAt: any, id: string, fileName: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, deletedAt?: any | null, createdAt: any } | null } };

export type NewsItemsPressRoomQueryVariables = Exact<{
  where?: InputMaybe<FindNewsWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindNewsOrderBy> | FindNewsOrderBy>;
  contentSchemaId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewsItemsPressRoomQuery = { __typename?: 'Query', newsItems: Array<{ __typename?: 'NewsItem', title: string, createdAt: any, updatedAt: any, date: any, expiredDate?: any | null, hasExpirationDate: boolean, publicationDate?: any | null, newsStatus?: VersionStates | null, id: string, contentSchema?: { __typename?: 'ContentSchema', id: string, name: string } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, sharedWith: Array<{ __typename?: 'ContentSharing', targetDependency?: { __typename?: 'Dependency', id: string, name: string } | null }> }>, newsItemsCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type AllNewsQueryVariables = Exact<{
  where?: InputMaybe<FindNewsWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindNewsOrderBy> | FindNewsOrderBy>;
}>;


export type AllNewsQuery = { __typename?: 'Query', newsItems: Array<{ __typename: 'NewsItem', id: string, title: string, date: any, createdAt: any, expiredDate?: any | null, hasExpirationDate: boolean, newsStatus?: VersionStates | null, dependency?: { __typename: 'Dependency', id: string, name: string } | null }>, newsItemsCount: { __typename: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type ProceduresAndServicesAllQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindProceduresWhere>;
  orderBy?: InputMaybe<Array<FindProceduresOrderBy> | FindProceduresOrderBy>;
}>;


export type ProceduresAndServicesAllQuery = { __typename?: 'Query', procedures: Array<{ __typename?: 'Procedure', id: string, processDefinitionId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, tagsProcedure?: Array<string> | null, procedureStatus?: VersionStates | null, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, showGovcoButton: boolean, showProcedureButton: boolean, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, proceduresCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type RemoveProcedureMutationVariables = Exact<{
  removeProcedureId: Scalars['ID']['input'];
}>;


export type RemoveProcedureMutation = { __typename?: 'Mutation', removeProcedure: { __typename?: 'Procedure', id: string } };

export type RegulationsAdminQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindRegulationsOrderBy> | FindRegulationsOrderBy>;
  where?: InputMaybe<FindRegulationsWhere>;
  pagination?: InputMaybe<Pagination>;
  types: Array<RegulationType> | RegulationType;
  dependency?: InputMaybe<StringFilter>;
}>;


export type RegulationsAdminQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, date: any, documentDate: any, createdAt: any, updatedAt: any, downloadText?: string | null, description: string, title: string, regulationStatus?: VersionStates | null, type: RegulationType, dependency?: { __typename?: 'Dependency', name: string, id: string } | null, file?: { __typename?: 'FileInfo', downloadUrl?: string | null } | null }>, regulationsCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type GetRegulationQueryVariables = Exact<{
  regulationId: Scalars['ID']['input'];
}>;


export type GetRegulationQuery = { __typename?: 'Query', regulation: { __typename?: 'Regulation', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description: string, type: RegulationType, publishDate?: any | null, documentDate: any, downloadText?: string | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, file?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null } };

export type RegulationAdminQueryVariables = Exact<{
  regulationId: Scalars['ID']['input'];
}>;


export type RegulationAdminQuery = { __typename?: 'Query', regulation: { __typename?: 'Regulation', id: string, title: string, description: string, date: any, type: RegulationType, downloadText?: string | null, documentDate: any, publishDate?: any | null, pageLinkDocument?: { __typename?: 'PageLink', arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, file?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, seo?: { __typename?: 'Seo', metadata: Array<{ __typename?: 'SeoMetadata', id: string, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } };

export type CreateRegulationAdminMutationVariables = Exact<{
  createInput: CreateRegulationInput;
}>;


export type CreateRegulationAdminMutation = { __typename?: 'Mutation', createRegulation: { __typename?: 'Regulation', id: string, title: string } };

export type UpdateRegulationAdminMutationVariables = Exact<{
  updateInput: UpdateRegulationInput;
}>;


export type UpdateRegulationAdminMutation = { __typename?: 'Mutation', updateRegulation: { __typename?: 'Regulation', id: string, date: any, title: string, regulationStatus?: VersionStates | null } };

export type RemoveRegulationAdminMutationVariables = Exact<{
  removeRegulationId: Scalars['ID']['input'];
}>;


export type RemoveRegulationAdminMutation = { __typename?: 'Mutation', removeRegulation: { __typename?: 'Regulation', id: string } };

export type UpdateRegulationStatusToDraftMutationVariables = Exact<{
  updateRegulationStatusToDraft: UpdateRegulationStatus;
}>;


export type UpdateRegulationStatusToDraftMutation = { __typename?: 'Mutation', updateRegulationStatusToDraft: string };

export type PublishersQueryVariables = Exact<{
  where?: InputMaybe<FindEditorWhere>;
  dependencyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name?: string | null, lastName?: string | null }>, editors: Array<{ __typename?: 'Editor', id: string, user?: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null } | null }> };

export type BulkAssignEditorsMutationVariables = Exact<{
  pageDynamicId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkAssignEditorsMutation = { __typename?: 'Mutation', bulkAssignEditors: Array<{ __typename?: 'Editor', id: string, user?: { __typename?: 'User', id: string, email: string } | null }> };

export type DependenciesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindDependencyOrderBy> | FindDependencyOrderBy>;
  where?: InputMaybe<FindDependencyWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type DependenciesQuery = { __typename?: 'Query', dependencies: Array<{ __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus, countUser: number }>, dependenciesCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type DependencyQueryVariables = Exact<{
  dependencyId: Scalars['ID']['input'];
}>;


export type DependencyQuery = { __typename?: 'Query', dependency: { __typename?: 'Dependency', id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null, type: DependencyType, status: DependencyStatus } };

export type CreateDependencyMutationVariables = Exact<{
  createInput: CreateDependencyInput;
}>;


export type CreateDependencyMutation = { __typename?: 'Mutation', createDependency: { __typename?: 'Dependency', id: string, name: string, createdAt: any, updatedAt: any } };

export type UpdateDependencyMutationVariables = Exact<{
  updateInput: UpdateDependencyInput;
}>;


export type UpdateDependencyMutation = { __typename?: 'Mutation', updateDependency: { __typename?: 'Dependency', id: string, name: string, updatedAt: any } };

export type UpdateUserDependencyMutationVariables = Exact<{
  updateInput: UpdateUserDependencyInput;
}>;


export type UpdateUserDependencyMutation = { __typename?: 'Mutation', updateUserDependency: { __typename?: 'UserDependency', id: string, createdAt: any, updatedAt: any } };

export type CreateUserDependencyMutationVariables = Exact<{
  createInput: CreateUserDependencyInput;
}>;


export type CreateUserDependencyMutation = { __typename?: 'Mutation', createUserDependency: { __typename?: 'UserDependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, status: UserDependencyStatus } };

export type UsersWithDependencyQueryVariables = Exact<{
  dependencyId: Scalars['String']['input'];
}>;


export type UsersWithDependencyQuery = { __typename?: 'Query', getUsersByDependency: { __typename?: 'UsersByDependencyModel', usersWithDependency: Array<{ __typename?: 'UserDependency', id: string, type?: UserDependencyType | null, user?: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email: string, fullName: string } | null }>, usersWithoutDependency: Array<{ __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email: string, fullName: string }> } };

export type CreateMultipleUserDependenciesMutationVariables = Exact<{
  input: CreateMultipleUserDependencyInput;
}>;


export type CreateMultipleUserDependenciesMutation = { __typename?: 'Mutation', createMultipleUserDependencies: { __typename?: 'CreateMultipleUserDependencyResponse', success: boolean } };

export type RemoveDependencyMutationVariables = Exact<{
  removeDependencyId: Scalars['ID']['input'];
}>;


export type RemoveDependencyMutation = { __typename?: 'Mutation', removeDependency: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus, countUser: number } };

export type RemoveUserDependencyMutationVariables = Exact<{
  removeUserDependencyId: Scalars['ID']['input'];
}>;


export type RemoveUserDependencyMutation = { __typename?: 'Mutation', removeUserDependency: { __typename?: 'UserDependency', id: string } };

export type DocumentsQueryVariables = Exact<{
  where?: InputMaybe<FindContentWhere>;
  schemaIdFilter?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindContentOrderBy> | FindContentOrderBy>;
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
  metadataOrderBy?: InputMaybe<Array<MetadataFieldOrderBy> | MetadataFieldOrderBy>;
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'DocumentEntity', id: string, title: string, createdAt: any, updatedAt: any, publishDate?: any | null, status: ContentStatus, file?: { __typename?: 'FileInfo', downloadUrl?: string | null } | null, schema?: { __typename?: 'ContentSchema', id: string, name: string } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, sharedWith: Array<{ __typename?: 'ContentSharing', targetDependency?: { __typename?: 'Dependency', id: string, name: string } | null }>, metadata: Array<{ __typename?: 'DocumentMetadata', id: string, value?: string | null, schemaField: { __typename?: 'ContentSchemaField', fieldLabel: string } }>, children: Array<{ __typename?: 'DocumentEntity', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description?: string | null, type: TypeContent, status: ContentStatus, contentDate?: any | null, migrationMetadata?: string | null, publishDate?: any | null, expirationDate?: any | null, fileId?: string | null, downloadText?: string | null, downloadCount?: string | null, fileSize?: string | null, mimeType?: string | null, isParentDocument?: boolean | null, nestingLevel?: number | null, childrenCount: number }> }>, documentsCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type DocumentByIdQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DocumentByIdQuery = { __typename?: 'Query', document: { __typename?: 'DocumentEntity', id: string, title: string, createdAt: any, description?: string | null, publishDate?: any | null, contentDate?: any | null, status: ContentStatus, schema?: { __typename?: 'ContentSchema', id: string, name: string } | null, file?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, metadata: Array<{ __typename?: 'DocumentMetadata', id: string, value?: string | null, schemaField: { __typename?: 'ContentSchemaField', id: string } }>, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null, children: Array<{ __typename?: 'DocumentEntity', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description?: string | null, type: TypeContent, status: ContentStatus, contentDate?: any | null, migrationMetadata?: string | null, publishDate?: any | null, expirationDate?: any | null, fileId?: string | null, downloadText?: string | null, downloadCount?: string | null, fileSize?: string | null, mimeType?: string | null, isParentDocument?: boolean | null, nestingLevel?: number | null, childrenCount: number, schema?: { __typename?: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, allowChildren: boolean, maxNestingLevel: number, hierarchyLabel?: string | null, dependencyCount: number } | null, dependency?: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus, countUser: number } | null }> } };

export type AllDocumentsQueryVariables = Exact<{
  where?: InputMaybe<FindContentWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindContentOrderBy> | FindContentOrderBy>;
  dependencyIdFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'DocumentEntity', id: string, title: string, createdAt: any, updatedAt: any, status: ContentStatus, file?: { __typename?: 'FileInfo', downloadUrl?: string | null } | null, dependency?: { __typename?: 'Dependency', id: string, name: string } | null, sharedWith: Array<{ __typename?: 'ContentSharing', targetDependency?: { __typename?: 'Dependency', id: string, name: string } | null }>, metadata: Array<{ __typename?: 'DocumentMetadata', id: string, value?: string | null, schemaField: { __typename?: 'ContentSchemaField', fieldLabel: string } }>, schema?: { __typename?: 'ContentSchema', id: string, name: string } | null }>, documentsCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type CreateDocumentMutationVariables = Exact<{
  createInput: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: { __typename?: 'DocumentEntity', id: string, title: string } };

export type UpdateDocumentMutationVariables = Exact<{
  updateInput: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'DocumentEntity', id: string, title: string } };

export type RemoveDocumentMutationVariables = Exact<{
  removeDocumentId: Scalars['ID']['input'];
}>;


export type RemoveDocumentMutation = { __typename?: 'Mutation', removeDocument: { __typename?: 'DocumentEntity', id: string } };

export type CreateDocumentMetadataMutationVariables = Exact<{
  createInput: CreateDocumentMetadataInput;
}>;


export type CreateDocumentMetadataMutation = { __typename?: 'Mutation', createDocumentMetadata: { __typename?: 'DocumentMetadata', id: string, value?: string | null } };

export type UpdateDocumentMetadataMutationVariables = Exact<{
  updateInput: UpdateDocumentMetadataInput;
}>;


export type UpdateDocumentMetadataMutation = { __typename?: 'Mutation', updateDocumentMetadata: { __typename?: 'DocumentMetadata', id: string, value?: string | null } };

export type ShareContentMutationVariables = Exact<{
  input: ShareContentInput;
}>;


export type ShareContentMutation = { __typename?: 'Mutation', shareContent: Array<{ __typename?: 'ContentSharing', id: string, contentId: string }> };

export type GetContentSchemasQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSchemaWhere>;
  orderBy?: InputMaybe<Array<FindContentSchemaOrderBy> | FindContentSchemaOrderBy>;
  dependencyIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetContentSchemasQuery = { __typename?: 'Query', contentSchemas: Array<{ __typename: 'ContentSchema', id: string, name: string, isActive: boolean, createdAt: any, description?: string | null, contentType?: TypeContent | null, dependency?: { __typename: 'Dependency', id: string, name: string } | null, userContentSchemaAssignments?: Array<{ __typename?: 'UserContentSchemaAssignment', user: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, fullName: string } }> | null, fields: Array<{ __typename: 'ContentSchemaField', id: string, fieldName: string, fieldLabel: string, fieldType: FieldType, isGroup?: boolean | null }>, allDependencies: Array<{ __typename: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus, countUser: number }> }>, contentSchemasCount: { __typename: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type ContentSchemaFieldsFragment = { __typename: 'ContentSchema', id: string, name: string, fields: Array<{ __typename: 'ContentSchemaField', id: string, fieldName: string, fieldLabel: string, fieldType: FieldType, isGroup?: boolean | null }> };

export type GetContentSchemaFieldsByIdQueryVariables = Exact<{
  contentSchemaId: Scalars['ID']['input'];
}>;


export type GetContentSchemaFieldsByIdQuery = { __typename?: 'Query', contentSchema: { __typename: 'ContentSchema', id: string, name: string, fields: Array<{ __typename: 'ContentSchemaField', id: string, fieldName: string, fieldLabel: string, fieldType: FieldType, isGroup?: boolean | null }> } };

export type ContentSchemaFieldQueryVariables = Exact<{
  contentSchemaFieldId: Scalars['ID']['input'];
}>;


export type ContentSchemaFieldQuery = { __typename?: 'Query', contentSchemaField: { __typename?: 'ContentSchemaField', id: string, fieldType: FieldType, fieldName: string, fieldLabel: string, isRequired: boolean, options?: string | null } };

export type MetadataValueGroupsQueryVariables = Exact<{
  schemaId: Scalars['String']['input'];
  schemaFieldId: Scalars['String']['input'];
}>;


export type MetadataValueGroupsQuery = { __typename?: 'Query', metadataValueGroups: { __typename?: 'MetadataValueGroupResponse', totalGroups: number, totalDocuments: number, groups: Array<{ __typename?: 'MetadataValueGroup', schemaId: string, schemaFieldId: string, value?: string | null, count: number }> } };

export type BulkUpdateMetadataValuesMutationVariables = Exact<{
  input: BulkUpdateMetadataInput;
}>;


export type BulkUpdateMetadataValuesMutation = { __typename?: 'Mutation', bulkUpdateMetadataValues: { __typename?: 'BulkUpdateMetadataResponse', updatedCount: number, affectedDocumentIds?: Array<string> | null, success: boolean, message?: string | null } };

export type GetContentSchemaByIdQueryVariables = Exact<{
  contentSchemaId: Scalars['ID']['input'];
}>;


export type GetContentSchemaByIdQuery = { __typename?: 'Query', contentSchema: { __typename: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, allowChildren: boolean, fields: Array<{ __typename: 'ContentSchemaField', id: string, orderIndex: number, fieldName: string, fieldLabel: string, fieldType: FieldType, isGroup?: boolean | null, isRequired: boolean, createdAt: any, updatedAt: any, isActive: boolean, options?: string | null, schema: { __typename: 'ContentSchema', id: string } }>, dependency?: { __typename: 'Dependency', id: string, name: string } | null, childrenSchemas: Array<{ __typename?: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, allowChildren: boolean, maxNestingLevel: number, hierarchyLabel?: string | null, dependencyCount: number, fields: Array<{ __typename?: 'ContentSchemaField', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fieldName: string, fieldLabel: string, fieldType: FieldType, isRequired: boolean, orderIndex: number, options?: string | null, validationRules?: string | null, defaultValue?: string | null, isActive: boolean, isGroup?: boolean | null }>, allDependencies: Array<{ __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus, countUser: number }>, dependency?: { __typename?: 'Dependency', id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null, type: DependencyType, status: DependencyStatus, countUser: number } | null }>, userContentSchemaAssignments?: Array<{ __typename?: 'UserContentSchemaAssignment', dependencies?: Array<string> | null, userId: string, canAssociateAnyDependency: boolean }> | null } };

export type GetAllDependenciesBySchemaQueryVariables = Exact<{
  schemaId: Scalars['String']['input'];
}>;


export type GetAllDependenciesBySchemaQuery = { __typename?: 'Query', getAllDependenciesBySchema: Array<{ __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus, countUser: number }> };

export type CreateContentSchemaMutationVariables = Exact<{
  createInput: CreateContentSchemaInput;
}>;


export type CreateContentSchemaMutation = { __typename?: 'Mutation', createContentSchema: { __typename?: 'ContentSchema', id: string, name: string } };

export type CreateContentSchemaFieldMutationVariables = Exact<{
  createInput: CreateContentSchemaFieldInput;
}>;


export type CreateContentSchemaFieldMutation = { __typename?: 'Mutation', createContentSchemaField: { __typename?: 'ContentSchemaField', id: string, fieldName: string } };

export type UpdateContentSchemaMutationVariables = Exact<{
  updateInput: UpdateContentSchemaInput;
}>;


export type UpdateContentSchemaMutation = { __typename?: 'Mutation', updateContentSchema: { __typename?: 'ContentSchema', id: string, name: string } };

export type UpdateContentSchemaFieldMutationVariables = Exact<{
  updateInput: UpdateContentSchemaFieldInput;
}>;


export type UpdateContentSchemaFieldMutation = { __typename?: 'Mutation', updateContentSchemaField: { __typename?: 'ContentSchemaField', id: string, fieldName: string } };

export type RemoveContentSchemaMutationVariables = Exact<{
  removeContentSchemaId: Scalars['ID']['input'];
}>;


export type RemoveContentSchemaMutation = { __typename?: 'Mutation', removeContentSchema: { __typename?: 'ContentSchema', id: string, name: string } };

export type RemoveContentSchemaFieldMutationVariables = Exact<{
  removeContentSchemaFieldId: Scalars['ID']['input'];
}>;


export type RemoveContentSchemaFieldMutation = { __typename?: 'Mutation', removeContentSchemaField: { __typename?: 'ContentSchemaField', id: string, fieldName: string } };

export type AddDependenciesToSchemaMutationVariables = Exact<{
  input: BatchAddDependenciesInput;
}>;


export type AddDependenciesToSchemaMutation = { __typename?: 'Mutation', addDependenciesToSchema: Array<{ __typename?: 'ContentSchemaDependency', id: string, isActive: boolean, isPrimary: boolean }> };

export type RemoveDependenciesFromSchemaMutationVariables = Exact<{
  schemaId: Scalars['String']['input'];
  dependencyIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveDependenciesFromSchemaMutation = { __typename?: 'Mutation', removeDependenciesFromSchema: Array<{ __typename?: 'ContentSchemaDependency', id: string, createdAt: any, isActive: boolean }> };

export type AssignUsersToContentSchemaMutationVariables = Exact<{
  input: AssignUsersToContentSchemaInput;
}>;


export type AssignUsersToContentSchemaMutation = { __typename?: 'Mutation', assignUsersToContentSchema: { __typename?: 'AssignUsersToContentSchemaResponse', errors?: Array<string> | null, totalAssigned: number } };

export type GetAssignmentsByContentSchemaQueryVariables = Exact<{
  contentSchemaId: Scalars['String']['input'];
}>;


export type GetAssignmentsByContentSchemaQuery = { __typename?: 'Query', getAssignmentsByContentSchema: Array<{ __typename?: 'UserContentSchemaAssignment', id: string, dependencies?: Array<string> | null, canAssociateAnyDependency: boolean, user: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, fullName: string } }> };

export type FooterDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type FooterDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar', id: string, description: string, isDisabled: boolean, canBeDisabled: boolean, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, subtitle?: string | null, logoLink?: string | null, adminOtherLogoLink?: string | null, administrationLogoLink?: string | null, campusData?: string | null, logoImage?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, adminOtherLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, administrationLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename?: 'PageFooterBarItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, socialNetworkName?: string | null, hasSocialNetworkIcon?: boolean | null, socialNetworkLink?: string | null, pageDirectory?: string | null, footerType?: FooterItemType | null, hasAnoterCampusData?: boolean | null, anotherCampusData?: string | null, pageDirectoryLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, socialNetworkIcon?: { __typename?: 'FileInfo', fileName: string, downloadUrl?: string | null, fileExtension: string, id: string } | null }> } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateFooterDetailMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateFooterDetailMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar', id: string } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = { __typename?: 'Query', footer: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, subtitle?: string | null, nit?: string | null, address?: string | null, postalCode?: string | null, openingHours?: string | null, phone?: string | null, fax?: string | null, citizenLine?: string | null, antiCorruptionLine?: string | null, institutionalEmail?: string | null, judicialEmail?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string }> };

export type PageBlocksFooterQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageBlocksFooterQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename?: 'PageAccessibilityBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, items: Array<{ __typename?: 'PageCorporateLogosBlockItem', id: string, corporateLogoLink?: string | null, corporateLogoName?: string | null, orderIndex: number, corporateLogo?: { __typename?: 'FileInfo', id: string, url: string, downloadUrl?: string | null } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, subtitle?: string | null, campusData?: string | null, items: Array<{ __typename?: 'PageFooterBarItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, socialNetworkName?: string | null, hasSocialNetworkIcon?: boolean | null, socialNetworkLink?: string | null, pageDirectory?: string | null, footerType?: FooterItemType | null, hasAnoterCampusData?: boolean | null, anotherCampusData?: string | null, pageDirectoryLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, socialNetworkIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null }> } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageBlockFooterMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockFooterMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar', id: string } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type HeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderQuery = { __typename?: 'Query', header: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, subtitle?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageSearchBlock' }> };

export type PageBlockHeaderQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageBlockHeaderQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton', id: string, orderIndex: number, title?: string | null, type?: string | null, description: string, isDisabled: boolean, createdAt: any, updatedAt: any, canBeDisabled: boolean, items: Array<{ __typename?: 'PageAccessibilityButtonItem', id: string, altText: string, iconType: AccessibilityIconType, isActive: boolean, orderIndex: number, linkUrl?: string | null, linkName: string, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasSearchbar: boolean, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null, logoImage?: { __typename?: 'FileInfo', id: string, url: string, downloadUrl?: string | null } | null, administrationLogo?: { __typename?: 'FileInfo', id: string, url: string, downloadUrl?: string | null } | null, adminOtherLogo?: { __typename?: 'FileInfo', id: string, url: string, downloadUrl?: string | null } | null, govcoLink?: { __typename?: 'PageLink', id: string, routeNavigation?: SubPages | null, routeType?: RouterType | null, arguments?: Array<string> | null } | null } | { __typename?: 'PageHeaderOrganizationBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, title?: string | null, subtitle?: string | null, logoImage?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string, downloadUrl?: string | null } | null, logoImageLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null, adminOtherLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string, downloadUrl?: string | null } | null, adminAnotherLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null, administrationLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string, downloadUrl?: string | null } | null, adminLogoLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, target?: string | null, routeNavigation?: SubPages | null, url?: string | null, arguments?: Array<string> | null } | null } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, rootItem?: { __typename?: 'NavigationItem', id: string, name: string, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, orderIndex: number, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null } | null, children: Array<{ __typename?: 'NavigationItem', id: string, name: string, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null } | null }> }> } | null } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock', id: string, orderIndex: number, blockTitle?: string | null, type?: string | null, description: string, isDisabled: boolean, createdAt: any, updatedAt: any, placeholder?: string | null, canBeDisabled: boolean, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageBlockHeaderMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockHeaderMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar', id: string } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type HomePageAdminQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  versionId: Scalars['ID']['input'];
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HomePageAdminQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, alertDescription?: string | null, alertStyle: PageBlockStyles, buttonTitle?: string | null, actionType?: ActionType | null, displayFrequency: DisplayFrequency, orderIndex: number, htmlTemplate?: string | null, canBeDisabled: boolean, isDisabled: boolean, type?: string | null, alertTitle?: string | null, image?: { __typename?: 'FileInfo', id: string, url: string, fileName: string, downloadUrl?: string | null, fileExtension: string } | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null } | null } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename: 'PageCabinetBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null, items: Array<{ __typename: 'PageCabinetBlockItem', id: string, createdAt: any, updatedAt: any, description?: string | null, cabinetName: string, cabinetDescription?: string | null, curriculumVitaeLink?: string | null, pageCabinetBlockTextAlternative?: string | null, cabinetPosition?: { __typename: 'Position', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string } | null, cabinetImage?: { __typename: 'FileInfo', id: string, createdAt: any, downloadUrl?: string | null, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, cabinetDetails: Array<{ __typename: 'CabinetDetail', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, cabinetDetailName?: string | null, cabinetDetailStatus?: VersionStates | null, cabinetDetailLink?: { __typename: 'PageLink', arguments?: Array<string> | null, id: string, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null, cabinetDetailImage?: { __typename: 'FileInfo', id: string, fileMode: FileModes, fileMongoId?: string | null, url: string, downloadUrl?: string | null } | null, cabinetItem?: { __typename: 'PageCabinetBlockItem', alternativeText?: string | null, cabinetDescription?: string | null, cabinetDetails: Array<{ __typename: 'CabinetDetail', cabinetDetailImage?: { __typename: 'FileInfo', id: string, fileMongoId?: string | null, fileName: string, fileMode: FileModes, fileExtension: string, url: string } | null }> } | null }> }> } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock', id: string, blockTitle?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, seeMoreLink?: string | null, subPages?: Array<SubPages> | null, events: Array<{ __typename: 'EventsItem', id: string, eventItemTitle: string, eventItemDescription?: string | null, descriptionPlace?: string | null, summary?: string | null, startDate: any, endDate: any, latitude?: string | null, longitude?: string | null, address?: string | null, link?: string | null, shareLink?: string | null, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock', id: string, isDisabled: boolean, canBeDisabled: boolean, description: string, publicDescription?: string | null, showDescription: boolean, showTitle: boolean, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number } | { __typename?: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, news: Array<{ __typename: 'NewsItem', id: string, updatedAt: any, title: string, summary: string, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleProcedures: string, descriptionProcedures: string, seeMoreAction: string, seeMoreActionLink: string, procedures: Array<{ __typename: 'Procedure', id: string, name: string, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageQuickAccessBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, isCarrousel?: boolean | null, itemsPerView?: number | null, color?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, quickAccessName?: string | null, description?: string | null, link: string, image?: { __typename: 'FileInfo', id: string, url: string, downloadUrl?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageRegulationsBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, regulations: Array<{ __typename: 'Regulation', id: string, date: any, title: string, description: string, file?: { __typename: 'FileInfo', id: string, url: string } | null }> } | { __typename?: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, sliders?: Array<{ __typename: 'SliderItem', id: string, title: string, orderIndex?: number | null, description?: string | null, link?: string | null, tags: Array<string>, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> | null } | { __typename?: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, publicDescription?: string | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename?: 'PageSnsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, snsTitle: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageSocialNetworksBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, seeMoreLink?: string | null, pageSocialNetworkTitle?: string | null, leftItems: Array<{ __typename: 'PageSocialNetworksLeftBlockItem', id: string, orderIndex: number, image?: { __typename: 'FileInfo', id: string } | null }>, rightItems: Array<{ __typename: 'PageSocialNetworksRightBlockItem', id: string, orderIndex: number, socialNetworkType?: SocialNetworkType | null, link?: string | null, linkItem?: { __typename: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string, items: Array<{ __typename: 'PageTaxesBlockItem', id: string, taxTitle: string, link: string, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdateHomePageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateHomePageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock', id: string } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type RemovePageBlockItemInstitutionalMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemovePageBlockItemInstitutionalMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type PageInstitutionalProgramsTypesBlockItemQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
}>;


export type PageInstitutionalProgramsTypesBlockItemQuery = { __typename?: 'Query', pageBlockItems: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string, programsType?: ProgramsTypes | null, createdAt: any, updatedAt: any, description?: string | null, title: string, alternativeText: string, image?: { __typename?: 'FileInfo', id: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdatePageBlockItemInstitutionalTypeBlockItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemInstitutionalTypeBlockItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type PageInstitutionalProgramsTypesBlockItemTypeQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageInstitutionalProgramsTypesBlockItemTypeQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, title: string, alternativeText: string, programsType?: ProgramsTypes | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type PageInstitutionalProgramsSliderBlockItemsQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageInstitutionalProgramsSliderBlockItemsQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string, title: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, tags: Array<string>, alternativeText?: string | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UserInfoByTokenQueryVariables = Exact<{
  validateTokenInput: ValidateTokenInput;
}>;


export type UserInfoByTokenQuery = { __typename?: 'Query', validateUserToken: { __typename?: 'User', name?: string | null, id: string, lastName?: string | null, middleName?: string | null, fullName: string, secondSurname?: string | null, email: string, phoneNumber?: string | null, type: UserTypes, phoneVerification: boolean, emailVerification: boolean, status: UserStatusTypes, temporalPassword?: boolean | null, permissions?: Array<string> | null, userDependencies: Array<{ __typename?: 'UserDependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, status: UserDependencyStatus, dependency: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } }> } };

export type UpdateUserInformationMutationVariables = Exact<{
  updateUserInformationInput: UpdateUserInformationInput;
}>;


export type UpdateUserInformationMutation = { __typename?: 'Mutation', updateUserInformation: { __typename?: 'User', name?: string | null, lastName?: string | null, middleName?: string | null, secondSurname?: string | null, email: string, phoneNumber?: string | null, type: UserTypes, phoneVerification: boolean, emailVerification: boolean } };

export type EnableAndDisableDoubleVerificationMutationVariables = Exact<{
  doubleVerificationInput: DoubleVerificationInput;
}>;


export type EnableAndDisableDoubleVerificationMutation = { __typename?: 'Mutation', enableAndDisableDoubleVerification: string };

export type SendCodeDoubleVerificationMutationVariables = Exact<{
  sendDoubleVerificationInput: SendDoubleVerificationInput;
}>;


export type SendCodeDoubleVerificationMutation = { __typename?: 'Mutation', sendCodeDoubleVerification: string };

export type UpdateUserPasswordMutationVariables = Exact<{
  updateUserPasswordInput: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'User', id: string } };

export type UpdatePageBlockOrdersMutationVariables = Exact<{
  input: Array<UpdateOrderPageBlockInput> | UpdateOrderPageBlockInput;
}>;


export type UpdatePageBlockOrdersMutation = { __typename?: 'Mutation', updatePageBlockOrders: Array<{ __typename?: 'PageBlock', id: string, orderIndex: number }> };

export type CreatePageBlockItemLogoMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageBlockItemLogoMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem', id: string, corporateLogoName?: string | null, corporateLogo?: { __typename?: 'FileInfo', id: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type RemovePageBlockItemCorporateMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemovePageBlockItemCorporateMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem', id: string } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UpdatePageBlockItemLogoMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemLogoMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem', id: string, alternativeText?: string | null, description?: string | null, corporateLogoLink?: string | null, corporateLogoName?: string | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, corporateLogo?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type PageCorporateLogosEntityBlockItemQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
}>;


export type PageCorporateLogosEntityBlockItemQuery = { __typename?: 'Query', pageBlockItems: Array<{ __typename: 'PageAccessibilityButtonItem' } | { __typename: 'PageAccordionBlockItem' } | { __typename: 'PageAttentionLinesBlockItem' } | { __typename: 'PageCabinetBlockItem' } | { __typename: 'PageCorporateLogosBlockItem', id: string, orderIndex: number, corporateLogoName?: string | null, corporateLogoLink?: string | null, description?: string | null, updatedAt: any, deletedAt?: any | null, createdAt: any, alternativeText?: string | null, corporateLogo?: { __typename: 'FileInfo', fileMode: FileModes, id: string, fileName: string, url: string } | null } | { __typename: 'PageEventSliderBlockItem' } | { __typename: 'PageFooterBarItem' } | { __typename: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename: 'PageParticipateElementBlockItem' } | { __typename: 'PageQuickAccessBarItem' } | { __typename: 'PageRegulationsBlockItem' } | { __typename: 'PageSnsBlockItem' } | { __typename: 'PageSocialNetworksLeftBlockItem' } | { __typename: 'PageSocialNetworksRightBlockItem' } | { __typename: 'PageStyledTableBlockItem' } | { __typename: 'PageStyledTableBlockRow' } | { __typename: 'PageSubDownloadBlockItem' } | { __typename: 'PageTaxesBlockItem' } | { __typename: 'PageTransparencyBlockItem' }> };

export type PageCorporateLogosBlockItemUniqueQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageCorporateLogosBlockItemUniqueQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem', id: string, corporateLogoName?: string | null, corporateLogoLink?: string | null, alternativeText?: string | null, description?: string | null, corporateLogo?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UpdatePageBlockSliderDynamicMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockSliderDynamicMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type RemovePageBlockDynamicMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemovePageBlockDynamicMutation = { __typename?: 'Mutation', removePageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar', id: string } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreatePageBlockDefaultMutationVariables = Exact<{
  input: CreateDefaultPageBlockInput;
}>;


export type CreatePageBlockDefaultMutation = { __typename?: 'Mutation', createPageBlockDefault: { __typename?: 'PageBlock', location: BlockLocation, subPages?: Array<SubPages> | null, isDisabled: boolean, updatedAt: any, id: string, dynamic?: { __typename?: 'PageDynamic', id: string } | null } };

export type PageInstitutionalProgramsTypesBlockByBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageInstitutionalProgramsTypesBlockByBlockQuery = { __typename?: 'Query', pageBlock: { __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null } | { __typename: 'PageHeaderOrganizationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, taxSectionTitle: string } | { __typename: 'PageTransparencyBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' } };

export type UpdatePageBlockItemInstitutionalCarouselMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemInstitutionalCarouselMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string, title: string } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type CreatePageBlockItemInstitutionalProgramMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageBlockItemInstitutionalProgramMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, title: string, alternativeText: string, programsType?: ProgramsTypes | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type PageInstitutionalProgramsSliderBlockItemQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
}>;


export type PageInstitutionalProgramsSliderBlockItemQuery = { __typename?: 'Query', pageBlockItems: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string, tags: Array<string>, title: string, description: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, alternativeText?: string | null, image: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string }, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type RemovePageBlockItemInstitutionalCarouselMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemovePageBlockItemInstitutionalCarouselMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type PageInstitutionalProgramsSliderBlockStyleQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageInstitutionalProgramsSliderBlockStyleQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock', description: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateInstitutionalCarouselMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateInstitutionalCarouselMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock', pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageBlockInstitutionalMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockInstitutionalMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock', pageBlockStyle?: PageBlockStyles | null, id: string, description: string } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageInstitutionalProgramsTypesBlockQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageInstitutionalProgramsTypesBlockQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar' } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageAuthenticationBar' } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null, items: Array<{ __typename: 'PageCabinetBlockItem', id: string, createdAt: any, updatedAt: any, cabinetName: string, cabinetDescription?: string | null, alternativeText?: string | null, curriculumVitaeLink?: string | null, cabinetPosition?: { __typename: 'Position', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string } | null, cabinetImage?: { __typename: 'FileInfo', id: string, createdAt: any, downloadUrl?: string | null, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, cabinetDetails: Array<{ __typename: 'CabinetDetail', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, cabinetDetailName?: string | null, cabinetDetailStatus?: VersionStates | null, cabinetDetailLink?: { __typename: 'PageLink', arguments?: Array<string> | null, id: string, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null, cabinetDetailImage?: { __typename: 'FileInfo', id: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, cabinetItem?: { __typename: 'PageCabinetBlockItem', alternativeText?: string | null, cabinetDescription?: string | null, cabinetDetails: Array<{ __typename: 'CabinetDetail', cabinetDetailImage?: { __typename: 'FileInfo', id: string, fileMongoId?: string | null, fileName: string, fileMode: FileModes, fileExtension: string, url: string } | null }> } | null }> }> } | { __typename: 'PageCorporateLogosBlock' } | { __typename: 'PageCustomBlock' } | { __typename: 'PageEventsBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, seeMoreLink?: string | null, subPages?: Array<SubPages> | null, events: Array<{ __typename: 'EventsItem', id: string, eventItemTitle: string, eventItemDescription?: string | null, descriptionPlace?: string | null, summary?: string | null, startDate: any, endDate: any, latitude?: string | null, longitude?: string | null, address?: string | null, link?: string | null, shareLink?: string | null, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageEventSliderBlock', id: string, orderIndex: number, isDisabled: boolean, canBeDisabled: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, type?: string | null, pageEventSliderBlockItems: Array<{ __typename?: 'PageEventSliderBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, orderIndex: number, title: string, seeMoreAction: string, seeMoreLink: string, image: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string }, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageFooterBar' } | { __typename: 'PageHeaderBar' } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, type?: string | null, orderIndex: number, description: string, createdAt: any, updatedAt: any, deletedAt?: any | null, canBeDisabled: boolean, isDisabled: boolean, pageInstitutionalProgramsSliderBlockItems: Array<{ __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, orderIndex: number, title: string, alternativeText?: string | null, tags: Array<string>, seeMoreAction: string, seeMoreLink: string, image: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string }, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, type?: string | null, description: string, orderIndex: number, createdAt: any, updatedAt: any, deletedAt?: any | null, canBeDisabled: boolean, isDisabled: boolean, pageInstitutionalProgramsTypesBlockItems: Array<{ __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, title: string, alternativeText: string, programsType?: ProgramsTypes | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, news: Array<{ __typename: 'NewsItem', id: string, updatedAt: any, title: string, summary: string, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageParticipateDownloadBlock' } | { __typename: 'PageParticipateElementBlock' } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock' } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleProcedures: string, descriptionProcedures: string, seeMoreAction: string, seeMoreActionLink: string, procedures: Array<{ __typename: 'Procedure', id: string, name: string, tagsProcedure?: Array<string> | null, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageQuickAccessBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, pagequickAccessBarItems: Array<{ __typename: 'PageQuickAccessBarItem', id: string, quickAccessName?: string | null, link: string, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageRegulationsBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, regulations: Array<{ __typename: 'Regulation', id: string, date: any, title: string, description: string, file?: { __typename: 'FileInfo', id: string, url: string } | null }> } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, sliders?: Array<{ __typename: 'SliderItem', id: string, title: string, orderIndex?: number | null, description?: string | null, link?: string | null, tags: Array<string>, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> | null } | { __typename: 'PageSnsBlock' } | { __typename: 'PageSocialNetworksBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, seeMoreLink?: string | null, leftItems: Array<{ __typename: 'PageSocialNetworksLeftBlockItem', id: string, orderIndex: number, image?: { __typename: 'FileInfo', id: string } | null }>, rightItems: Array<{ __typename: 'PageSocialNetworksRightBlockItem', id: string, orderIndex: number, socialNetworkType?: SocialNetworkType | null, link?: string | null, linkItem?: { __typename: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null } | null }> } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, orderIndex: number, type?: string | null, createdAt: any, updatedAt: any, canBeDisabled: boolean, isDisabled: boolean, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, pageSubDownloadBlockItems: Array<{ __typename?: 'PageSubDownloadBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, name: string, file: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } }> } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string, pageTaxesBlockItems: Array<{ __typename: 'PageTaxesBlockItem', id: string, taxTitle: string, link: string, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageTransparencyBlock' } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type UpdateInstitucionalPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateInstitucionalPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock', id: string } | { __typename?: 'PageInstitutionalProgramsTypesBlock', id: string } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdateInstitutionalProgramsSliderItemOrdersMutationVariables = Exact<{
  input: UpdateInstitutionalProgramsSliderItemsInput;
}>;


export type UpdateInstitutionalProgramsSliderItemOrdersMutation = { __typename?: 'Mutation', updateInstitutionalProgramsSliderItemOrders: Array<{ __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string, orderIndex: number }> };

export type PageSubHeaderBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageSubHeaderBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string, subHeaderDescription?: string | null, subHeaderTitle?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type ParticipatePageQueryVariables = Exact<{
  subPage?: InputMaybe<SubPages>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations: Array<BlockLocation> | BlockLocation;
  versionId: Scalars['ID']['input'];
}>;


export type ParticipatePageQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtype?: TypeAccordion | null } | { __typename: 'PageAlertsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, orderIndex: number, canBeDisabled: boolean, isDisabled: boolean, type?: string | null } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename?: 'PageParticipateElementBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, participateElementTitle: string, participateElementImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null, participateLinkAction?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, taxSectionTitle: string } | { __typename: 'PageTransparencyBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type UpdateParticipatePageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateParticipatePageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdateParticipateDownloadsPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateParticipateDownloadsPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock', id: string } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetParticipateDownloadsPageBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetParticipateDownloadsPageBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock', id: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateParticipateElementsPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateParticipateElementsPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock', id: string } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetParticipateElementsPageBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetParticipateElementsPageBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock', id: string, pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename?: 'PageParticipateElementBlockItem', id: string, orderIndex: number, participateElementTitle: string, createdAt: any, updatedAt: any }> } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreateParticipateElementBlockItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateParticipateElementBlockItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem', id: string } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateParticipateElementBlockItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateParticipateElementBlockItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem', id: string } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetParticipateElementBlockItemQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetParticipateElementBlockItemQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem', id: string, description?: string | null, participateElementTitle: string, participateElementImage?: { __typename?: 'FileInfo', fileExtension: string, fileMode: FileModes, id: string, fileName: string, fileMongoId?: string | null, url: string } | null, participateLinkAction?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveParticipateElementBlockItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveParticipateElementBlockItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem', id: string } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type PqrsdPageQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PqrsdPageQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock', id: string, type?: string | null, orderIndex: number, pageBlockStyle?: PageBlockStyles | null, createdAt: any, updatedAt: any, isDisabled: boolean, canBeDisabled: boolean } | { __typename?: 'PagePqrsdfConsultBlock', id: string, type?: string | null, orderIndex: number, pageBlockStyle?: PageBlockStyles | null, createdAt: any, updatedAt: any, isDisabled: boolean, canBeDisabled: boolean } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string, type?: string | null, orderIndex: number, pageBlockStyle?: PageBlockStyles | null, createdAt: any, updatedAt: any, isDisabled: boolean, canBeDisabled: boolean, subHeaderTitle?: string | null, subHeaderDescription?: string | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePqrsdPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePqrsdPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type CreatePqrsdPageBlockMutationVariables = Exact<{
  input: CreatePageBlockInputUnion;
}>;


export type CreatePqrsdPageBlockMutation = { __typename?: 'Mutation', createPageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePqrsdActionsPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePqrsdActionsPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock', id: string } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPqrsdActionsPageBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPqrsdActionsPageBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock', id: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePqrsdConsultPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePqrsdConsultPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock', id: string } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPqrsdConsultPageBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPqrsdConsultPageBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock', id: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PressRoomPageQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PressRoomPageQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar' } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename?: 'PageSnsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, snsTitle: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, previousVersion?: { __typename?: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, parent: { __typename?: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } }> } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, taxSectionTitle: string } | { __typename: 'PageTransparencyBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type UpdatePressRoomPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePressRoomPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock', id: string } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePagePressRoomNewsEventsBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePagePressRoomNewsEventsBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock', id: string } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPagePressRoomNewsEventsBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPagePressRoomNewsEventsBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock', id: string, pageBlockStyle?: PageBlockStyles | null, tagStyle?: PageBlockStyles | null, newsletterTitle: string, newsletterDescription?: string | null } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type PageRegulationsBlockQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageRegulationsBlockQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtype?: TypeAccordion | null, items: Array<{ __typename?: 'PageAccordionBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, subtype?: string | null, configJson?: string | null }> } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, taxSectionTitle: string } | { __typename: 'PageTransparencyBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageBlockSubHeaderMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockSubHeaderMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string, subHeaderTitle?: string | null, subHeaderDescription?: string | null, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageRegulationsBlockItemQueryVariables = Exact<{
  parentId: Scalars['ID']['input'];
}>;


export type PageRegulationsBlockItemQuery = { __typename?: 'Query', pageBlockItems: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem', id: string, itemName: string, itemType: RegulationType, itemDescription?: string | null, orderIndex: number, description?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, itemIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type PageRegulationsBlockItemByIdQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type PageRegulationsBlockItemByIdQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem', id: string, itemName: string, description?: string | null, orderIndex: number, itemDescription?: string | null, itemType: RegulationType, itemIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UpdatePageBlockItemRegulationsMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdatePageBlockItemRegulationsMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem', id: string, itemType: RegulationType, itemDescription?: string | null, itemName: string, itemIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateRegulationsPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateRegulationsPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock', id: string } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageRegulationsAccordionBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageRegulationsAccordionBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageBlockAccordionRegulationsMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageBlockAccordionRegulationsMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock', id: string, description: string, pageBlockStyle?: PageBlockStyles | null, orderIndex: number, canBeDisabled: boolean, isDisabled: boolean } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type PageRegulationsBlockDataQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageRegulationsBlockDataQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock', id: string, description: string, createdAt: any, updatedAt: any, deletedAt?: any | null, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, items: Array<{ __typename?: 'PageRegulationsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemName: string, itemDescription?: string | null, itemType: RegulationType, itemIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }> } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type ProceduresPageQueryVariables = Exact<{
  subPage?: InputMaybe<SubPages>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations: Array<BlockLocation> | BlockLocation;
  versionId: Scalars['ID']['input'];
}>;


export type ProceduresPageQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, taxSectionTitle: string } | { __typename: 'PageTransparencyBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type UpdateProceduresPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateProceduresPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageProceduresAreaBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageProceduresAreaBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock', id: string } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageProceduresAreaBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageProceduresAreaBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock', id: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdatePageProceduresCardBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageProceduresCardBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock', id: string } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageProceduresCardBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageProceduresCardBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock', id: string, description: string, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateSubHeaderPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateSubHeaderPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetSubHeaderPageBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetSubHeaderPageBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string, description: string, pageBlockStyle?: PageBlockStyles | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderSearchbar?: boolean | null, subHeaderPlaceholder?: string | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type ParametersAdminQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindParametersOrderBy> | FindParametersOrderBy>;
  where?: InputMaybe<FindParametersWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ParametersAdminQuery = { __typename?: 'Query', parameters: Array<{ __typename?: 'Parameter', id: string, code: string, createdAt: any, updatedAt: any, description: string }>, parametersCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type ParameterAdminQueryVariables = Exact<{
  parameterId: Scalars['ID']['input'];
}>;


export type ParameterAdminQuery = { __typename?: 'Query', parameter: { __typename?: 'Parameter', id: string, code: string, description: string, type: TypeParameter, character?: string | null, number?: number | null, booleanValue?: boolean | null, json?: string | null, date?: any | null, image?: { __typename?: 'FileInfo', id: string, fileExtension: string, fileName: string, fileMode: FileModes, fileMongoId?: string | null, url: string, downloadUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null } };

export type CreateParameterAdminMutationVariables = Exact<{
  createInput: CreateParameterInput;
}>;


export type CreateParameterAdminMutation = { __typename?: 'Mutation', createParameter: { __typename?: 'Parameter', id: string, code: string, type: TypeParameter } };

export type UpdateParameterAdminMutationVariables = Exact<{
  updateInput: UpdateParameterInput;
}>;


export type UpdateParameterAdminMutation = { __typename?: 'Mutation', updateParameter: { __typename?: 'Parameter', id: string, code: string, type: TypeParameter } };

export type RemoveParameterAdminMutationVariables = Exact<{
  removeParameterId: Scalars['ID']['input'];
}>;


export type RemoveParameterAdminMutation = { __typename?: 'Mutation', removeParameter: { __typename?: 'Parameter', id: string } };

export type CreatePositionMutationVariables = Exact<{
  createInput: CreatePositionInput;
}>;


export type CreatePositionMutation = { __typename?: 'Mutation', createPosition: { __typename?: 'Position', id: string, name: string } };

export type UpdatePositionMutationVariables = Exact<{
  updateInput: UpdatePositionInput;
}>;


export type UpdatePositionMutation = { __typename?: 'Mutation', updatePosition: { __typename?: 'Position', id: string, name: string } };

export type RemovePositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemovePositionMutation = { __typename?: 'Mutation', removePosition: { __typename?: 'Position', id: string } };

export type GetPositionsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindPositionWhere>;
  orderBy?: InputMaybe<Array<FindPositionOrderBy> | FindPositionOrderBy>;
}>;


export type GetPositionsQuery = { __typename?: 'Query', positions: Array<{ __typename?: 'Position', id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null }>, positionsCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type UpdateFunctionalityDescriptionMutationVariables = Exact<{
  updateInput: UpdateFunctionalityInput;
}>;


export type UpdateFunctionalityDescriptionMutation = { __typename?: 'Mutation', updateFunctionality: { __typename?: 'Functionality', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, key: string, description: string, url?: string | null } };

export type UpdateFunctionalityMutationVariables = Exact<{
  updateInput: UpdateFunctionalityInput;
}>;


export type UpdateFunctionalityMutation = { __typename?: 'Mutation', updateFunctionality: { __typename?: 'Functionality', id: string, title?: string | null } };

export type UpdateRoleAndPermissionsMutationVariables = Exact<{
  updateRoleAndPermissionsInput: UpdateRoleAndPermissionsInput;
}>;


export type UpdateRoleAndPermissionsMutation = { __typename?: 'Mutation', updateRoleAndPermissions: { __typename?: 'Role', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description: string, defaultForType?: UserTypes | null, status: RoleStatusTypes, permissions?: Array<string> | null } };

export type RolePermissionsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type RolePermissionsQuery = { __typename?: 'Query', role: { __typename?: 'Role', permissions?: Array<string> | null, name: string, description: string } };

export type CreateRoleAndPermissionsMutationVariables = Exact<{
  createRoleAndPermissionsInput: CreateRoleAndPermissionsInput;
}>;


export type CreateRoleAndPermissionsMutation = { __typename?: 'Mutation', createRoleAndPermissions: { __typename?: 'Role', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description: string, defaultForType?: UserTypes | null, status: RoleStatusTypes } };

export type RemoveRoleMutationVariables = Exact<{
  removeRoleId: Scalars['ID']['input'];
}>;


export type RemoveRoleMutation = { __typename?: 'Mutation', removeRole: { __typename?: 'Role', createdAt: any, id: string } };

export type RoleQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type RoleQuery = { __typename?: 'Query', role: { __typename?: 'Role', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description: string, status: RoleStatusTypes, roleFx: Array<{ __typename?: 'RoleFx', id: string }> } };

export type UpdateRoleMutationVariables = Exact<{
  updateInput: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description: string, defaultForType?: UserTypes | null, status: RoleStatusTypes } };

export type RolesFxQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  rolesFxCountPagination2?: InputMaybe<Pagination>;
}>;


export type RolesFxQuery = { __typename?: 'Query', rolesFx: Array<{ __typename?: 'RoleFx', id: string }>, rolesFxCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type SearchFunctionalitiesQueryVariables = Exact<{
  searchInput: SearchFunctionalityInput;
}>;


export type SearchFunctionalitiesQuery = { __typename?: 'Query', searchFunctionalities: Array<{ __typename?: 'FunctionalityModel', name: string, key: string, url?: string | null, icon?: string | null, title?: string | null, description?: string | null, tags?: Array<FunctionalityTag> | null, children?: Array<{ __typename?: 'FunctionalityModel', name: string, key: string, url?: string | null, icon?: string | null, title?: string | null, description?: string | null, tags?: Array<FunctionalityTag> | null, children?: Array<{ __typename?: 'FunctionalityModel', name: string, key: string, url?: string | null, icon?: string | null, title?: string | null, description?: string | null, tags?: Array<FunctionalityTag> | null }> | null }> | null }> };

export type PageEventSliderBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type PageEventSliderBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock', pageBlockStyle?: PageBlockStyles | null, id: string, items: Array<{ __typename?: 'PageEventSliderBlockItem', description: string, title: string, orderIndex: number, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } }> } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreatePageBlockItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreatePageBlockItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem' } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem', id: string, description: string } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename: 'User', id: string, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, phoneNumber?: string | null, address?: string | null, identificationNumber?: string | null, type: UserTypes, status: UserStatusTypes, userRoles?: Array<{ __typename?: 'UserRole', id: string, role?: { __typename?: 'Role', id: string } | null }> | null } };

export type AuditsClientQueryVariables = Exact<{
  where?: InputMaybe<FindAuditClientsWhere>;
  orderBy?: InputMaybe<Array<FindAuditClientsOrderBy> | FindAuditClientsOrderBy>;
  pagination?: InputMaybe<Pagination>;
}>;


export type AuditsClientQuery = { __typename?: 'Query', auditsClient: Array<{ __typename?: 'AuditClientView', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, type: TypeTypeAuditClient, status: StatusTypeAuditClient, ip?: string | null, requestType: RequestType, objectId?: string | null, message: string, actionType: StandardActions, objectType?: string | null, fullName?: string | null, audits?: Array<{ __typename?: 'Audit', valueAfter?: string | null, valueBefore?: string | null }> | null }>, auditsClientCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type ObjectTypesEnabledQueryVariables = Exact<{
  where?: InputMaybe<ObjectTypesEnabledArgsWhere>;
  orderBy?: InputMaybe<ObjectTypesEnabledArgsOrderBy>;
}>;


export type ObjectTypesEnabledQuery = { __typename?: 'Query', objectTypesEnabled: Array<{ __typename?: 'ObjectTypeInfo', name: string, displayName: string }> };

export type AuditClientDataQueryVariables = Exact<{
  auditClientDataInput: AuditClientDataInput;
}>;


export type AuditClientDataQuery = { __typename?: 'Query', auditClientData: { __typename?: 'AuditClientData', request: any, response?: any | null, auditClient: { __typename?: 'AuditClient', audits?: Array<{ __typename?: 'Audit', valueAfter?: string | null, valueBefore?: string | null }> | null } } };

export type UpdateThemePageVersionMutationVariables = Exact<{
  updateInput: UpdatePageVersionInput;
}>;


export type UpdateThemePageVersionMutation = { __typename?: 'Mutation', updatePageVersion: { __typename?: 'PageVersion', id: string, theme: Theme } };

export type TransparencyPageAdminQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  versionId: Scalars['ID']['input'];
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  subPage?: InputMaybe<SubPages>;
}>;


export type TransparencyPageAdminQuery = { __typename?: 'Query', pageBlocks: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtype?: TypeAccordion | null, items: Array<{ __typename?: 'PageAccordionBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, index?: string | null, indexTitle?: string | null, subtype?: string | null, configJson?: string | null, schema?: { __typename?: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, fields: Array<{ __typename?: 'ContentSchemaField', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fieldName: string, fieldLabel: string, fieldType: FieldType, isRequired: boolean, orderIndex: number, options?: string | null, validationRules?: string | null, defaultValue?: string | null, isActive: boolean, isGroup?: boolean | null }> } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null } | { __typename: 'PageHeaderOrganizationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, news: Array<{ __typename: 'NewsItem', id: string, updatedAt: any, title: string, summary: string, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleProcedures: string, descriptionProcedures: string, seeMoreActionLink: string, procedures: Array<{ __typename: 'Procedure', id: string, name: string, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageQuickAccessBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, quickAccessName?: string | null, link: string, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, regulations: Array<{ __typename: 'Regulation', id: string, date: any, title: string, description: string, file?: { __typename: 'FileInfo', id: string, url: string } | null }> } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, sliders?: Array<{ __typename: 'SliderItem', id: string, title: string, orderIndex?: number | null, description?: string | null, link?: string | null, tags: Array<string>, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename: 'PageSnsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, snsTitle: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, taxSectionTitle: string, items: Array<{ __typename: 'PageTaxesBlockItem', id: string, taxTitle: string, link: string, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageTransparencyBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type UpdateTransparencyPageBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateTransparencyPageBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock', id: string } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type UpdatePageTransparencyAccordionBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageTransparencyAccordionBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock', id: string } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type TransparencyAccordionDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type TransparencyAccordionDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock', id: string, pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type CreateTransparencyAccordionItemMutationVariables = Exact<{
  input: CreatePageBlockItemInputUnion;
}>;


export type CreateTransparencyAccordionItemMutation = { __typename?: 'Mutation', createPageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type UpdateTransparencyAccordionItemMutationVariables = Exact<{
  input: UpdatePageBlockItemInputUnion;
}>;


export type UpdateTransparencyAccordionItemMutation = { __typename?: 'Mutation', updatePageBlockItem: Array<{ __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' }> };

export type GetTransparencyAccordionItemQueryVariables = Exact<{
  pageBlockItemId: Scalars['ID']['input'];
}>;


export type GetTransparencyAccordionItemQuery = { __typename?: 'Query', pageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type RemoveTransparencyAccordionItemMutationVariables = Exact<{
  removePageBlockItemId: Scalars['ID']['input'];
}>;


export type RemoveTransparencyAccordionItemMutation = { __typename?: 'Mutation', removePageBlockItem: { __typename?: 'PageAccessibilityButtonItem' } | { __typename?: 'PageAccordionBlockItem', id: string } | { __typename?: 'PageAttentionLinesBlockItem' } | { __typename?: 'PageCabinetBlockItem' } | { __typename?: 'PageCorporateLogosBlockItem' } | { __typename?: 'PageEventSliderBlockItem' } | { __typename?: 'PageFooterBarItem' } | { __typename?: 'PageInstitutionalProgramsSliderBlockItem' } | { __typename?: 'PageInstitutionalProgramsTypesBlockItem' } | { __typename?: 'PageParticipateElementBlockItem' } | { __typename?: 'PageQuickAccessBarItem' } | { __typename?: 'PageRegulationsBlockItem' } | { __typename?: 'PageSnsBlockItem' } | { __typename?: 'PageSocialNetworksLeftBlockItem' } | { __typename?: 'PageSocialNetworksRightBlockItem' } | { __typename?: 'PageStyledTableBlockItem' } | { __typename?: 'PageStyledTableBlockRow' } | { __typename?: 'PageSubDownloadBlockItem' } | { __typename?: 'PageTaxesBlockItem' } | { __typename?: 'PageTransparencyBlockItem' } };

export type UpdatePageTransparencyIntroductionBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdatePageTransparencyIntroductionBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock', id: string } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type GetPageTransparencyIntroductionBlockQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetPageTransparencyIntroductionBlockQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock', id: string, description: string, hasLinkVideo?: boolean | null, transparencyContent?: string | null, linkVideo?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null, image?: { __typename?: 'FileInfo', id: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, fileName: string, url: string } | null, items: Array<{ __typename?: 'PageTransparencyBlockItem', id: string, itemTitle?: string | null, itemDescription?: string | null, itemIcon?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, fileName: string, url: string } | null, linkItem?: { __typename?: 'PageLink', routeType?: RouterType | null, target?: string | null, url?: string | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type ClonePageVersionMutationVariables = Exact<{
  createInput: ClonePageVersionInput;
}>;


export type ClonePageVersionMutation = { __typename?: 'Mutation', clonePageVersion: { __typename?: 'PageVersion', id: string, state: VersionStates, theme: Theme, description: string, consecutive?: string | null } };

export type FindPageVersionsQueryVariables = Exact<{
  where?: InputMaybe<FindPageVersionsWhere>;
}>;


export type FindPageVersionsQuery = { __typename?: 'Query', pageVersions: Array<{ __typename?: 'PageVersion', id: string, state: VersionStates, description: string, theme: Theme, consecutive?: string | null }> };

export type SignInAdminMutationVariables = Exact<{
  signInAdminInput: SigninAdminInput;
}>;


export type SignInAdminMutation = { __typename?: 'Mutation', signInAdmin: { __typename: 'AuthResponse', token: string, user: { __typename: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, temporalPassword?: boolean | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, type: UserTypes, phoneVerification: boolean, emailVerification: boolean, permissions?: Array<string> | null, country?: { __typename: 'Country', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, department?: { __typename: 'Department', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, city?: { __typename: 'City', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, userDependencies: Array<{ __typename?: 'UserDependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, status: UserDependencyStatus, dependency: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } }> } } };

export type ApprovalJwtQueryVariables = Exact<{
  approvalTokenInput: ApprovalTokenInput;
}>;


export type ApprovalJwtQuery = { __typename?: 'Query', approvalJwt: { __typename?: 'AuthResponse', token: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, type: UserTypes, phoneVerification: boolean, emailVerification: boolean, country?: { __typename?: 'Country', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, department?: { __typename?: 'Department', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, city?: { __typename?: 'City', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null } } };

export type SignInWithOAuthMutationVariables = Exact<{
  googleSigninInput: GoogleSigninInput;
}>;


export type SignInWithOAuthMutation = { __typename?: 'Mutation', SignInWithOAuth: { __typename?: 'AuthResponse', token: string, user: { __typename: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, temporalPassword?: boolean | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, type: UserTypes, phoneVerification: boolean, emailVerification: boolean, permissions?: Array<string> | null, country?: { __typename: 'Country', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, department?: { __typename: 'Department', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, city?: { __typename: 'City', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, code: number, name: string } | null, userDependencies: Array<{ __typename?: 'UserDependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, status: UserDependencyStatus, dependency: { __typename?: 'Dependency', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, type: DependencyType, status: DependencyStatus } }> } } };

export type RecoverPasswordMutationVariables = Exact<{
  recoverPasswordInput: RecoverPasswordInput;
}>;


export type RecoverPasswordMutation = { __typename?: 'Mutation', recoverPassword: string };

export type ValidateCodeRecoverPasswordQueryVariables = Exact<{
  codeRecoverPasswordInput: CodeRecoverPasswordInput;
}>;


export type ValidateCodeRecoverPasswordQuery = { __typename?: 'Query', codeRecoverPassword: string };

export type UpdateAndRecoverPasswordMutationVariables = Exact<{
  updatePasswordInput: UpdatePasswordInput;
}>;


export type UpdateAndRecoverPasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', id: string } };

export type AllCarouselSlidesQueryVariables = Exact<{
  where?: InputMaybe<FindCarouselSlideWhere>;
}>;


export type AllCarouselSlidesQuery = { __typename?: 'Query', allCarouselSlides: Array<{ __typename?: 'CarouselSlide', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, slideId: string, type: CarouselSlideType, version: string, title: string, description?: string | null, imageUrl?: string | null, ctaText?: string | null, ctaUrl?: string | null, activeFrom: any, activeTo: any, isAdminEnabled: boolean, displayOrder?: number | null, imageFile?: { __typename?: 'FileInfo', id: string, downloadUrl?: string | null } | null }> };

export type CanEditPageDynamicQueryVariables = Exact<{
  pageDynamicId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CanEditPageDynamicQuery = { __typename?: 'Query', canEditPageDynamic: { __typename?: 'CanEditPageDynamicResult', canEdit: boolean, id: string, slug: string } };

export type ParameterByCodQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ParameterByCodQuery = { __typename?: 'Query', parameterByCod: { __typename?: 'Parameter', id: string, code: string, description: string, type: TypeParameter, character?: string | null, number?: number | null, booleanValue?: boolean | null, date?: any | null, json?: string | null, deletedAt?: any | null, updatedAt: any, createdAt: any, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null } };

export type PqrsdfQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindProceduresOrderBy> | FindProceduresOrderBy>;
  where?: InputMaybe<FindProceduresWhere>;
  pagination?: InputMaybe<Pagination>;
  subPage: SubPages;
}>;


export type PqrsdfQuery = { __typename?: 'Query', procedures: Array<{ __typename?: 'Procedure', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, procedureDescription?: string | null, duration?: DurationTypes | null, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, multimediaType?: MultimediaTypes | null, estimatedDuration?: number | null, actionLink?: string | null, alternativeText?: string | null, procedureStatus?: VersionStates | null, procedureTypes?: ProcedureTypes | null, publicationDate?: any | null, gocvoLogoName?: string | null, processDefinitionId?: string | null, procedureItemTags: Array<string>, govcoImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }>, subPage: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, dynamic?: { __typename?: 'PageDynamic', id: string } | null } | { __typename?: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type ProceduresQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindProceduresOrderBy> | FindProceduresOrderBy>;
  where?: InputMaybe<FindProceduresWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ProceduresQuery = { __typename?: 'Query', procedures: Array<{ __typename?: 'Procedure', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, procedureDescription?: string | null, duration?: DurationTypes | null, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, multimediaType?: MultimediaTypes | null, estimatedDuration?: number | null, actionLink?: string | null, alternativeText?: string | null, procedureStatus?: VersionStates | null, procedureTypes?: ProcedureTypes | null, publicationDate?: any | null, gocvoLogoName?: string | null, processDefinitionId?: string | null, procedureItemTags: Array<string>, showGovcoButton: boolean, showProcedureButton: boolean }>, proceduresCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type ProceduresIdQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindProceduresOrderBy> | FindProceduresOrderBy>;
  where?: InputMaybe<FindProceduresWhere>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ProceduresIdQuery = { __typename?: 'Query', procedures: Array<{ __typename?: 'Procedure', id: string, processDefinitionId?: string | null }> };

export type ProcedureQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
}>;


export type ProcedureQuery = { __typename?: 'Query', procedure: { __typename?: 'Procedure', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, procedureDescription?: string | null, duration?: DurationTypes | null, cost: CostTypes, modality: ModalityTypes, date?: string | null, action?: string | null, multimediaType?: MultimediaTypes | null, estimatedDuration?: number | null, actionLink?: string | null, alternativeText?: string | null, procedureStatus?: VersionStates | null, procedureTypes?: ProcedureTypes | null, publicationDate?: any | null, gocvoLogoName?: string | null, processDefinitionId?: string | null, procedureItemTags: Array<string>, showGovcoButton: boolean, showProcedureButton: boolean, linkVideo?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, govcoLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, govcoImage?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } };

export type CarouselEventsQueryVariables = Exact<{
  where?: InputMaybe<FindEventWhere>;
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindEventOrderBy> | FindEventOrderBy>;
}>;


export type CarouselEventsQuery = { __typename?: 'Query', eventsItems: Array<{ __typename?: 'EventsItem', id: string, eventItemTitle: string, eventItemDescription?: string | null, startDate: any, endDate: any, createdAt: any, multimediaType?: MultimediaTypes | null, image?: { __typename?: 'FileInfo', id: string, downloadUrl?: string | null } | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null }>, eventsItemsCount: { __typename?: 'MetadataPagination', currentPage?: number | null, itemsPerPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type SocialNetworksEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialNetworksEventsQuery = { __typename?: 'Query', mainPage: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock', id: string, pageBlockStyle?: PageBlockStyles | null, rightItems: Array<{ __typename?: 'PageSocialNetworksRightBlockItem', id: string, orderIndex: number, socialNetworkType?: SocialNetworkType | null, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type EventsItemQueryVariables = Exact<{
  eventsItemId: Scalars['ID']['input'];
}>;


export type EventsItemQuery = { __typename?: 'Query', eventsItem: { __typename?: 'EventsItem', id: string, eventItemTitle: string, startDate: any, multimediaType?: MultimediaTypes | null, longitude?: string | null, latitude?: string | null, hasShare?: boolean | null, eventStatus?: EventStates | null, endDate: any, eventItemDescription?: string | null, eventItemTags: Array<string>, address?: string | null, summary?: string | null, phoneEvent?: string | null, emailEvent?: string | null, groupEvent?: string | null, paymentTypeEvent?: EventPaymentType | null, dynamicView?: boolean | null, image?: { __typename?: 'FileInfo', id: string, downloadUrl?: string | null } | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null } | null, seo?: { __typename?: 'Seo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metadata: Array<{ __typename?: 'SeoMetadata', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, metaTitle: string, metaDescription: string, slug?: string | null, language: Language }> } | null } };

export type HomeSkeletonQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeSkeletonQuery = { __typename?: 'Query', mainPage: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageAttentionLinesBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageCabinetBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageCustomBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageEventsBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageEventSliderBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageQuickAccessBar', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null, isCarrousel?: boolean | null, itemsPerView?: number | null, color?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, orderIndex: number }> } | { __typename: 'PageRegulationsBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageSnsBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageSocialNetworksBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock', id: string, isDisabled: boolean, orderIndex: number, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type HomeQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeQuery = { __typename?: 'Query', mainPage: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, alertDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, alertStyle: PageBlockStyles, buttonTitle?: string | null, actionType?: ActionType | null, displayFrequency: DisplayFrequency, orderIndex: number, htmlTemplate?: string | null, modalSizeUnit?: ModalSizeUnit | null, modalWidth?: number | null, modalHeight?: number | null, canBeDisabled: boolean, isDisabled: boolean, type?: string | null, alertTitle?: string | null, image?: { __typename?: 'FileInfo', id: string, url: string, fileName: string, downloadUrl?: string | null, fileExtension: string } | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null } | { __typename?: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null } | { __typename?: 'PageCabinetBlock', id: string, description: string, cabinetTitle: string, cabinetSubtitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename?: 'PageCabinetBlockItem', curriculumVitaeLink?: string | null, id: string, orderIndex: number, cabinetDescription?: string | null, createdAt: any, cabinetName: string, cabinetDetails: Array<{ __typename?: 'CabinetDetail', id: string, cabinetDetailImage?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, cabinetDetailLink?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, url?: string | null, routeNavigation?: SubPages | null, target?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }>, cabinetImage?: { __typename?: 'FileInfo', url: string, updatedAt: any, id: string, fileName: string, downloadUrl?: string | null, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, deletedAt?: any | null, createdAt: any } | null, cabinetPosition?: { __typename?: 'Position', name: string } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, arguments?: Array<string> | null } | null }> } | { __typename?: 'PageCustomBlock', id: string, canBeDisabled: boolean, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, content: string, createdAt: any, deletedAt?: any | null, isDisabled: boolean, description: string, location: BlockLocation, orderIndex: number, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, updatedAt: any } | { __typename?: 'PageEventsBlock', id: string, eventTitle?: string | null, eventDescription?: string | null, showTitle: boolean, showDescription: boolean, pageBlockStyle?: PageBlockStyles | null, isDisabled: boolean } | { __typename: 'PageEventSliderBlock', id: string, orderIndex: number, isDisabled: boolean, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, canBeDisabled: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, type?: string | null, items: Array<{ __typename?: 'PageEventSliderBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, title: string, seeMoreAction: string, seeMoreLink: string, itemDescription: string }> } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock', id: string, mapType: MapType, geoJsonData?: string | null, elementsConfig?: string | null, departmentCode?: string | null, height: number, initialZoom: number, centerCoordinates?: string | null, defaultFillColor?: string | null, defaultBorderColor?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, type?: string | null } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock', id: string, newsletterTitle: string, newsletterDescription?: string | null, showTitle: boolean, showDescription: boolean, pageBlockStyle?: PageBlockStyles | null, isDisabled: boolean } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleProcedures: string, descriptionProcedures: string, seeMoreAction: string, seeMoreActionLink: string, procedures: Array<{ __typename?: 'Procedure', procedureTypes?: ProcedureTypes | null, gocvoLogoName?: string | null, createdAt: any, procedureItemTags: Array<string>, id: string, name: string, tagsProcedure?: Array<string> | null, cost: CostTypes, duration?: DurationTypes | null, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, govcoLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, isCarrousel?: boolean | null, itemsPerView?: number | null, color?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, orderIndex: number, description?: string | null, quickAccessName?: string | null, link: string, image?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageRegulationsBlock', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, regulations: Array<{ __typename?: 'Regulation', id: string, date: any, title: string, description: string, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null, target?: string | null, createdAt: any, routeType?: RouterType | null, routeNavigation?: SubPages | null, arguments?: Array<string> | null, updatedAt: any, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, file?: { __typename?: 'FileInfo', id: string, url: string } | null }> } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, sliders?: Array<{ __typename?: 'SliderItem', id: string, title: string, orderIndex?: number | null, description?: string | null, link?: string | null, tags: Array<string>, image?: { __typename?: 'FileInfo', id: string, url: string, fileName: string, fileMongoId?: string | null } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> | null } | { __typename?: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename?: 'PageSnsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, snsTitle: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, title?: string | null, seeMoreLink?: string | null, leftItems: Array<{ __typename?: 'PageSocialNetworksLeftBlockItem', id: string, orderIndex: number, image?: { __typename?: 'FileInfo', id: string } | null }>, rightItems: Array<{ __typename?: 'PageSocialNetworksRightBlockItem', id: string, orderIndex: number, socialNetworkType?: SocialNetworkType | null, link?: string | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string, items: Array<{ __typename?: 'PageTaxesBlockItem', id: string, orderIndex: number, taxTitle: string, link: string, image?: { __typename?: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type ItemsInstitutionalProgramQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
}>;


export type ItemsInstitutionalProgramQuery = { __typename?: 'Query', subPageBlocks: Array<{ __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageCabinetBlock', isCarrousel?: boolean | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null, global?: boolean | null } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename: 'PageInstitutionalProgramsTypesBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description?: string | null, alternativeText: string, programsType?: ProgramsTypes | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null, global?: boolean | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null, pagePressroomBlockTitle?: string | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar' } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type PageInstitutionalProgramsSliderBlockQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
}>;


export type PageInstitutionalProgramsSliderBlockQuery = { __typename?: 'Query', subPageBlocks: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageInstitutionalProgramsSliderBlock', id: string, pageBlockStyle?: PageBlockStyles | null, items: Array<{ __typename?: 'PageInstitutionalProgramsSliderBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, orderIndex: number, title: string, alternativeText?: string | null, tags: Array<string>, seeMoreAction: string, seeMoreLink: string, previousVersion?: { __typename?: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, image: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string }, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename?: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type SigninMutationVariables = Exact<{
  signinInput: SigninInput;
}>;


export type SigninMutation = { __typename?: 'Mutation', signin: { __typename?: 'AuthResponse', token: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, phoneVerification: boolean, emailVerification: boolean, type: UserTypes, fullName: string, hasExpiredCredentials: boolean, temporalPassword?: boolean | null } } };

export type GetNavigationBarMicroSiteQueryVariables = Exact<{
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNavigationBarMicroSiteQuery = { __typename?: 'Query', getNavigationBarMicroSite: Array<{ __typename: 'PageAccessibilityBar' } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock' } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageAuthenticationBar' } | { __typename: 'PageCabinetBlock' } | { __typename: 'PageCorporateLogosBlock' } | { __typename: 'PageCustomBlock' } | { __typename: 'PageEventsBlock' } | { __typename: 'PageEventSliderBlock' } | { __typename: 'PageFooterBar' } | { __typename: 'PageHeaderBar' } | { __typename: 'PageHeaderOrganizationBar' } | { __typename: 'PageInstitutionalProgramsSliderBlock' } | { __typename: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar', id: string, orderIndex: number, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, rootItem?: { __typename: 'NavigationItem', id: string, name: string, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename: 'NavigationItem', orderIndex: number, id: string, name: string, link?: string | null, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename: 'NavigationItem', id: string, orderIndex: number, name: string, link?: string | null, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename: 'NavigationItem', id: string, orderIndex: number, name: string, link?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, type?: NavigationItemType | null, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, children: Array<{ __typename: 'NavigationItem', id: string, orderIndex: number, name: string, link?: string | null, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, icon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }>, icon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }>, icon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }>, icon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }>, icon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null } | null } | { __typename: 'PageNewsletterBlock' } | { __typename: 'PageParticipateDownloadBlock' } | { __typename: 'PageParticipateElementBlock' } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock' } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar' } | { __typename: 'PageRegulationsBlock' } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock' } | { __typename: 'PageSocialNetworksBlock' } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock' } | { __typename: 'PageSubHeaderBlock' } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock' } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type PageEventsBlockPageDynamicQueryVariables = Exact<{
  dynamicId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageEventsBlockPageDynamicQuery = { __typename?: 'Query', mainPageDynamic: Array<{ __typename: 'PageAccessibilityBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showViewButton?: boolean | null, showDownloadButton?: boolean | null, filterDependencyIds?: Array<string> | null, subtype?: TypeAccordion | null, items: Array<{ __typename: 'PageAccordionBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, index?: string | null, indexTitle?: string | null, configJson?: string | null, subtype?: string | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, schema?: { __typename: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, fields: Array<{ __typename: 'ContentSchemaField', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fieldName: string, fieldLabel: string, fieldType: FieldType, isRequired: boolean, orderIndex: number, options?: string | null, validationRules?: string | null, defaultValue?: string | null, isActive: boolean, isGroup?: boolean | null }> } | null }> } | { __typename: 'PageAlertsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, alertDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, alertStyle: PageBlockStyles, buttonTitle?: string | null, actionType?: ActionType | null, displayFrequency: DisplayFrequency, htmlTemplate?: string | null, canBeDisabled: boolean, isDisabled: boolean, type?: string | null, alertTitle?: string | null, image?: { __typename: 'FileInfo', id: string, url: string, fileName: string, downloadUrl?: string | null, fileExtension: string } | null, linkItem?: { __typename: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null } | null } | { __typename: 'PageAttentionLinesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleAttentionLines?: string | null } | { __typename: 'PageAuthenticationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCabinetBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, extendedDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null, isCarrousel?: boolean | null, type?: string | null, items: Array<{ __typename: 'PageCabinetBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, cabinetName: string, cabinetDescription?: string | null, cabinetPhone?: string | null, cabinetEmail?: string | null, alternativeText?: string | null, curriculumVitaeLink?: string | null, cabinetImage?: { __typename: 'FileInfo', id: string, createdAt: any, downloadUrl?: string | null, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, cabinetPosition?: { __typename: 'Position', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string } | null, cabinetDetails: Array<{ __typename: 'CabinetDetail', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, cabinetDetailName?: string | null, cabinetDetailStatus?: VersionStates | null, cabinetDetailLink?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, cabinetDetailImage?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }> }> } | { __typename: 'PageCorporateLogosBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageCustomBlock', id: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, content: string, isDisabled: boolean, orderIndex: number } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, eventTitle?: string | null, eventDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null, includeSharedContent?: boolean | null, hasDependencyFilter?: boolean | null, contentSchema?: { __typename?: 'ContentSchema', id: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, events: Array<{ __typename: 'EventsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, eventItemTitle: string, eventItemDescription?: string | null, summary?: string | null, seeMore?: string | null, link?: string | null, address?: string | null, latitude?: string | null, longitude?: string | null, descriptionPlace?: string | null, typeEvent?: EvenType | null, hasRecurring?: PageEventFrequency | null, hasShare?: boolean | null, shareLink?: string | null, startDate: any, endDate: any, eventStatus?: EventStates | null, alternativeText?: string | null, multimediaType?: MultimediaTypes | null, eventItemTags: Array<string>, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, shareIcon?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageEventSliderBlock' } | { __typename: 'PageFooterBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, subtitle?: string | null, campusData?: string | null, administrationLogoLink?: string | null, adminOtherLogoLink?: string | null, logoLink?: string | null, html: string } | { __typename: 'PageHeaderBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, placeholder?: string | null, hasLanguageIcon?: boolean | null, hasGovcoLogo?: boolean | null, hasSignin?: boolean | null, hasSignup?: boolean | null, signinName?: string | null, signupName?: string | null, hasSearchbarHeaderBar: boolean } | { __typename: 'PageHeaderOrganizationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleHeaderOrganizationBar?: string | null, subtitleHeaderOrganizationBar?: string | null } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageMapBlock', id: string, mapType: MapType, geoJsonData?: string | null, elementsConfig?: string | null, departmentCode?: string | null, height: number, initialZoom: number, centerCoordinates?: string | null, defaultFillColor?: string | null, defaultBorderColor?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, type?: string | null } | { __typename: 'PageNavigationBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null, includeSharedContent?: boolean | null, hasDependencyFilter?: boolean | null, contentSchema?: { __typename: 'ContentSchema', id: string } | null } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, items: Array<{ __typename: 'PageParticipateElementBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, participateElementTitle: string, participateLinkAction?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, participateElementImage?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }> } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titlePressroom?: string | null, subtitlePressRoom?: string | null, hasSearchbarPressRoom?: boolean | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleProcedures: string, descriptionProcedures: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, seeMoreActionLink: string, seetMoreActionProcedures: string, procedures: Array<{ __typename: 'Procedure', procedureTypes?: ProcedureTypes | null, gocvoLogoName?: string | null, createdAt: any, procedureItemTags: Array<string>, id: string, name: string, cost: CostTypes, duration?: DurationTypes | null, modality: ModalityTypes, date?: string | null, action?: string | null, actionLink?: string | null, govcoLink?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, isCarrousel?: boolean | null, itemsPerView?: number | null, color?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, orderIndex: number, quickAccessName?: string | null, description?: string | null, link: string, image?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, regulations: Array<{ __typename: 'Regulation', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description: string, date: any, downloadText?: string | null, documentDate: any, regulationStatus?: VersionStates | null, pageLinkDocument?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, file?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null }> } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, sliders?: Array<{ __typename: 'SliderItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, orderIndex?: number | null, alternativeText?: string | null, tags: Array<string>, link?: string | null, description?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> | null } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, items: Array<{ __typename: 'PageSnsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, snsTitle: string, snsSocialNetworkType?: SocialNetworkType | null, itemLink?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, seeMoreAction?: string | null, seeMoreLink?: string | null, titleSocialNetworks?: string | null, leftItems: Array<{ __typename: 'PageSocialNetworksLeftBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, description?: string | null, alternativeText?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }>, rightItems: Array<{ __typename: 'PageSocialNetworksRightBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, socialNetworkType?: SocialNetworkType | null, description?: string | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageStyledTableBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, extendedDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, contentType?: TableContentType | null, tableStyle?: TableStyleType | null, itemsPerPage?: number | null, externalEndpoint?: string | null, contentSchema?: { __typename: 'ContentSchema', id: string, fields: Array<{ __typename: 'ContentSchemaField', id: string, fieldName: string, orderIndex: number }> } | null, rows: Array<{ __typename: 'PageStyledTableBlockRow', id: string, orderIndex: number, cellData?: Array<{ __typename: 'PageStyledTableBlockRowData', id: string, value?: string | null, column?: { __typename: 'PageStyledTableBlockItem', id: string } | null }> | null }>, columns: Array<{ __typename: 'PageStyledTableBlockItem', id: string, allowFilter?: boolean | null, allowSort?: boolean | null, columnName?: string | null, columnWidth?: number | null, dataType?: ColumnDataType | null, orderIndex: number, description?: string | null, configJson?: string | null, mappedField?: { __typename: 'ContentSchemaField', id: string, orderIndex: number } | null }> } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null, dynamic?: { __typename: 'PageDynamic', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, status: VersionStates } | null, items: Array<{ __typename: 'PageSubDownloadBlockItem', id: string, createdAt: any, name: string, description?: string | null, orderIndex: number, updatedAt: any, deletedAt?: any | null, file: { __typename: 'FileInfo', url: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, fileName: string, deletedAt?: any | null, updatedAt: any, createdAt: any, id: string } }> } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, taxSectionTitle: string, items: Array<{ __typename: 'PageTaxesBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, link: string, taxTitle: string, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageTransparencyBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type PageParticipateBlockQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
}>;


export type PageParticipateBlockQuery = { __typename?: 'Query', subPageBlocks: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showViewButton?: boolean | null, showDownloadButton?: boolean | null, subtype?: TypeAccordion | null, items: Array<{ __typename: 'PageAccordionBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, index?: string | null, indexTitle?: string | null, configJson?: string | null, subtype?: string | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, schema?: { __typename: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, fields: Array<{ __typename: 'ContentSchemaField', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fieldName: string, fieldLabel: string, fieldType: FieldType, isRequired: boolean, orderIndex: number, options?: string | null, validationRules?: string | null, defaultValue?: string | null, isActive: boolean, isGroup?: boolean | null }> } | null }> } | { __typename?: 'PageAlertsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title?: string | null, blockTitle?: string | null, description: string, alertDescription?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, alertStyle: PageBlockStyles, buttonTitle?: string | null, actionType?: ActionType | null, displayFrequency: DisplayFrequency, orderIndex: number, htmlTemplate?: string | null, modalSizeUnit?: ModalSizeUnit | null, modalWidth?: number | null, modalHeight?: number | null, canBeDisabled: boolean, isDisabled: boolean, type?: string | null, image?: { __typename?: 'FileInfo', id: string, url: string, fileName: string, downloadUrl?: string | null, fileExtension: string } | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock', id: string, orderIndex: number, description: string, isDisabled: boolean, pageBlockStyle?: PageBlockStyles | null } | { __typename?: 'PageParticipateElementBlock', id: string, description: string, pageBlockStyle?: PageBlockStyles | null, orderIndex: number, isDisabled: boolean, items: Array<{ __typename?: 'PageParticipateElementBlockItem', id: string, orderIndex: number, description?: string | null, participateElementTitle: string, participateElementImage?: { __typename?: 'FileInfo', fileExtension: string, fileMode: FileModes, id: string, fileName: string, fileMongoId?: string | null, url: string } | null, participateLinkAction?: { __typename?: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, isCarrousel?: boolean | null, itemsPerView?: number | null, color?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, orderIndex: number, description?: string | null, quickAccessName?: string | null, link: string, image?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type RegulationsParticipateQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindRegulationsOrderBy> | FindRegulationsOrderBy>;
  where?: InputMaybe<FindRegulationsWhere>;
  pagination?: InputMaybe<Pagination>;
  types: Array<RegulationType> | RegulationType;
}>;


export type RegulationsParticipateQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, date: any, documentDate: any, downloadText?: string | null, description: string, title: string, image?: { __typename?: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }>, regulationsCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type SubPageProceduresBlockQueryVariables = Exact<{ [key: string]: never; }>;


export type SubPageProceduresBlockQuery = { __typename?: 'Query', subpageprocedure: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageCabinetBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null } | { __typename?: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename?: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null, global?: boolean | null } | { __typename?: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null, global?: boolean | null } | { __typename?: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null, pagePressroomBlockTitle?: string | null } | { __typename?: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, blockTitle?: string | null, seeMoreTitle?: string | null, seeMoreLink?: string | null } | { __typename?: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null } | { __typename?: 'PageSearchBlock' } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename?: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, title?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null } | { __typename?: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type RegulationGroupedCountsQueryVariables = Exact<{
  args: RegulationAggregationArgs;
}>;


export type RegulationGroupedCountsQuery = { __typename?: 'Query', regulationGroupedCounts: Array<{ __typename?: 'AggregatedCountResult', groupKey: string, groupLabel?: string | null, count: number }> };

export type RegulationsQueryVariables = Exact<{
  types: Array<RegulationType> | RegulationType;
  year?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindRegulationsWhere>;
  orderBy?: InputMaybe<Array<FindRegulationsOrderBy> | FindRegulationsOrderBy>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  dependency?: InputMaybe<StringFilter>;
}>;


export type RegulationsQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, title: string, description: string, publishDate?: any | null, documentDate: any, createdAt: any, regulationStatus?: VersionStates | null, linkItem?: { __typename?: 'PageLink', url?: string | null } | null, file?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null } | null }>, regulationsCount: { __typename?: 'MetadataPagination', totalItems?: number | null, itemsPerPage?: number | null, totalPages?: number | null, currentPage?: number | null } };

export type RegulationMonthsQueryVariables = Exact<{
  args?: InputMaybe<FindRegulationYearsArgs>;
}>;


export type RegulationMonthsQuery = { __typename?: 'Query', regulationMonths: Array<{ __typename?: 'RegulationMonthsModel', month: number, count: number }> };

export type RegulationYearsQueryVariables = Exact<{
  args?: InputMaybe<FindRegulationYearsArgs>;
}>;


export type RegulationYearsQuery = { __typename?: 'Query', regulationYears: Array<{ __typename?: 'RegulationYearsModel', year: string, count: number }> };

export type PageRegulationsRegulationsBlockQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
}>;


export type PageRegulationsRegulationsBlockQuery = { __typename?: 'Query', subPageBlocks: Array<{ __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtype?: TypeAccordion | null, showViewButton?: boolean | null, showDownloadButton?: boolean | null, items: Array<{ __typename?: 'PageAccordionBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, index?: string | null, indexTitle?: string | null, subtype?: string | null, configJson?: string | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageCabinetBlock' } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock' } | { __typename: 'PageEventSliderBlock' } | { __typename: 'PageInstitutionalProgramsSliderBlock' } | { __typename: 'PageInstitutionalProgramsTypesBlock' } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock' } | { __typename: 'PageParticipateDownloadBlock', id: string, orderIndex: number, description: string, isDisabled: boolean, pageBlockStyle?: PageBlockStyles | null } | { __typename: 'PageParticipateElementBlock', id: string, description: string, pageBlockStyle?: PageBlockStyles | null, orderIndex: number, isDisabled: boolean, items: Array<{ __typename: 'PageParticipateElementBlockItem', id: string, orderIndex: number, description?: string | null, participateElementTitle: string, participateElementImage?: { __typename: 'FileInfo', fileExtension: string, fileMode: FileModes, id: string, fileName: string, fileMongoId?: string | null, url: string } | null, participateLinkAction?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null }> } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock' } | { __typename: 'PagePqrsdfConsultBlock' } | { __typename: 'PagePressroomBlock' } | { __typename: 'PageProcedureFeedbackBlock' } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock' } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar' } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, items: Array<{ __typename?: 'PageRegulationsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemName: string, itemDescription?: string | null, itemType: RegulationType, itemIcon?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }>, regulations: Array<{ __typename?: 'Regulation', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description: string, date: any, downloadText?: string | null, documentDate: any, type: RegulationType, regulationStatus?: VersionStates | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, pageLinkDocument?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null, image?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null, file?: { __typename?: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, downloadUrl?: string | null, url: string } | null }> } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock' } | { __typename: 'PageSocialNetworksBlock' } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock' } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock' } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type RegulationsRegulationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FindRegulationsOrderBy> | FindRegulationsOrderBy>;
  where?: InputMaybe<FindRegulationsWhere>;
  pagination?: InputMaybe<Pagination>;
  types: Array<RegulationType> | RegulationType;
}>;


export type RegulationsRegulationsQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, date: any, documentDate: any, downloadText?: string | null, description: string, title: string, image?: { __typename?: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename?: 'PageLink', id: string, url?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null } | null }>, regulationsCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type FileInfoQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type FileInfoQuery = { __typename?: 'Query', file: { __typename?: 'FileInfo', id: string, url: string, fileName: string, downloadUrl?: string | null } };

export type AccordionBlockItemBySubtypeQueryVariables = Exact<{
  blockId: Scalars['ID']['input'];
  subtype: RegulationType;
}>;


export type AccordionBlockItemBySubtypeQuery = { __typename?: 'Query', accordionBlockItemBySubtype?: { __typename?: 'PageAccordionBlockItem', id: string, index?: string | null, indexTitle?: string | null, orderIndex: number, description?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, subtype?: string | null, configJson?: string | null, lft?: number | null, rgt?: number | null, depth?: number | null, linkItem?: { __typename?: 'PageLink', id: string, arguments?: Array<string> | null, routeNavigation?: SubPages | null, routeType?: RouterType | null, target?: string | null, url?: string | null } | null } | null };

export type ValidateUserRequestQueryVariables = Exact<{
  validateUserRequestInput: ValidateUserRequestInput;
}>;


export type ValidateUserRequestQuery = { __typename?: 'Query', validateUserRequest?: { __typename?: 'UserRequest', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserRequestStatusTypes, requestType: UserRequestType } | null };

export type CreateUserRequestMutationVariables = Exact<{
  createUserRequestInput: CreateUserRequestInput;
}>;


export type CreateUserRequestMutation = { __typename?: 'Mutation', createUserRequest: { __typename?: 'UserRequest', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserRequestStatusTypes, requestType: UserRequestType } };

export type CreatePartialUserRequestMutationVariables = Exact<{
  createPartialUserRequestInput: CreatePartialUserRequestInput;
}>;


export type CreatePartialUserRequestMutation = { __typename?: 'Mutation', createPartialUserRequest: { __typename?: 'UserRequest', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserRequestStatusTypes, requestType: UserRequestType } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: string, value: string, text: string }> };

export type CitiesQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
}>;


export type CitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'City', id: string, value: string, text: string }> };

export type DepartmentsQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
}>;


export type DepartmentsQuery = { __typename?: 'Query', departments: Array<{ __typename?: 'Department', id: string, value: string, text: string }> };

export type CodeConfirmationMutationVariables = Exact<{
  createInput: CodeConfirmationInput;
}>;


export type CodeConfirmationMutation = { __typename?: 'Mutation', codeConfirmation: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, phoneVerification: boolean, emailVerification: boolean, type: UserTypes, fullName: string } };

export type TransparencyQueryVariables = Exact<{
  locations: Array<BlockLocation> | BlockLocation;
  subPage?: InputMaybe<SubPages>;
}>;


export type TransparencyQuery = { __typename?: 'Query', subPageBlocks: Array<{ __typename: 'PageAccessibilityButton' } | { __typename: 'PageAccordionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, blockTitle?: string | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtype?: TypeAccordion | null, items: Array<{ __typename?: 'PageAccordionBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, index?: string | null, indexTitle?: string | null, subtype?: string | null, configJson?: string | null, lft?: number | null, rgt?: number | null, depth?: number | null, linkItem?: { __typename?: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null, schema?: { __typename?: 'ContentSchema', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name: string, description?: string | null, contentType?: TypeContent | null, isActive: boolean, fields: Array<{ __typename?: 'ContentSchemaField', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fieldName: string, fieldLabel: string, fieldType: FieldType, isRequired: boolean, orderIndex: number, options?: string | null, validationRules?: string | null, defaultValue?: string | null, isActive: boolean, isGroup?: boolean | null }> } | null }> } | { __typename: 'PageAlertsBlock' } | { __typename: 'PageAttentionLinesBlock' } | { __typename: 'PageCabinetBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, cabinetTitle: string, cabinetSubtitle?: string | null, cabinetSeeMoreAction?: string | null, cabinetSeeMoreActionLink?: string | null, pageCabinetBlockItems: Array<{ __typename?: 'PageCabinetBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, cabinetName: string, cabinetDescription?: string | null, cabinetImageLink?: string | null, cabinetOrder?: number | null, cabinetPhone?: string | null, cabinetEmail?: string | null, cabinetStatus?: number | null, alternativeText?: string | null, curriculumVitaeLink?: string | null, pageCabinetBlockItemDescription?: string | null }> } | { __typename: 'PageCustomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, content: string } | { __typename: 'PageEventsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, eventTitle?: string | null, eventDescription?: string | null, hasScheduleInteractive?: boolean | null, hasSeeMore?: boolean | null, seeMoreLink?: string | null, seeMoreText?: string | null, global?: boolean | null, events: Array<{ __typename?: 'EventsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, eventItemTitle: string, eventItemDescription?: string | null, summary?: string | null, seeMore?: string | null, link?: string | null, address?: string | null, latitude?: string | null, longitude?: string | null, descriptionPlace?: string | null, typeEvent?: EvenType | null, hasRecurring?: PageEventFrequency | null, hasShare?: boolean | null, shareLink?: string | null, startDate: any, endDate: any, phoneEvent?: string | null, emailEvent?: string | null, groupEvent?: string | null, paymentTypeEvent?: EventPaymentType | null, eventStatus?: EventStates | null, alternativeText?: string | null, multimediaType?: MultimediaTypes | null, dynamicView?: boolean | null, eventItemTags: Array<string> }> } | { __typename: 'PageEventSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, pageEventSliderBlockItems: Array<{ __typename?: 'PageEventSliderBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, title: string, seeMoreAction: string, seeMoreLink: string, pageEventSliderBlockItemDescription: string }> } | { __typename: 'PageInstitutionalProgramsSliderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageInstitutionalProgramsTypesBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, pageInstitutionalProgramsTypesBlock: Array<{ __typename?: 'PageInstitutionalProgramsTypesBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, title: string, alternativeText: string, programsType?: ProgramsTypes | null, pageInstitutionalProgramsTypesBlockDescription?: string | null }> } | { __typename: 'PageMapBlock' } | { __typename: 'PageNavigationBar' } | { __typename: 'PageNewsletterBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, newsletterTitle: string, newsletterDescription?: string | null, hasSearchbarNewsletter?: boolean | null, newsletterTags?: Array<string> | null, tagStyle?: PageBlockStyles | null, global?: boolean | null, news: Array<{ __typename?: 'NewsItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, content: string, date: any, expiredDate?: any | null, summary: string, newsStatus?: VersionStates | null, multimediaType?: MultimediaTypes | null, alternativeText?: string | null, imageLink?: string | null, dateImages?: any | null, newsItemTags: Array<string>, pageNewsletterBlockLink?: string | null }> } | { __typename: 'PageParticipateDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, regulations: Array<{ __typename?: 'Regulation', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description: string, date: any, downloadText?: string | null, documentDate: any, type: RegulationType, regulationStatus?: VersionStates | null }> } | { __typename: 'PageParticipateElementBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, pageParticipateElementBlockItems: Array<{ __typename?: 'PageParticipateElementBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, participateElementTitle: string, pageParticipateElementBlockItemDescription?: string | null }> } | { __typename: 'PageParticipateHeaderBlock' } | { __typename: 'PagePqrsdfActionBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePqrsdfConsultBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PagePressroomBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subtitle?: string | null, hasSearchbar?: boolean | null, PagePressroomBlockTitle?: string | null } | { __typename: 'PageProcedureFeedbackBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProcedureHeaderBlock' } | { __typename: 'PageProcedureMainBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageProceduresBlock' } | { __typename: 'PageQuickAccessBar', id: string, type?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, blockTitle?: string | null, color?: string | null, isCarrousel?: boolean | null, itemsPerView?: number | null, seeMoreTitle?: string | null, seeMoreLink?: string | null, items: Array<{ __typename: 'PageQuickAccessBarItem', id: string, quickAccessName?: string | null, link: string, image?: { __typename: 'FileInfo', id: string, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }> } | { __typename: 'PageRegulationsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, titleRegulation: string, descriptionRegulation?: string | null, seeMoreRegulations?: string | null, seeMoreRegulationsLink?: string | null, regulations: Array<{ __typename?: 'Regulation', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, title: string, description: string, date: any, downloadText?: string | null, documentDate: any, type: RegulationType, regulationStatus?: VersionStates | null }>, pageRegulationsBlockItems: Array<{ __typename?: 'PageRegulationsBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemName: string, itemDescription?: string | null, itemType: RegulationType }> } | { __typename: 'PageSearchBlock' } | { __typename: 'PageSliderBlock' } | { __typename: 'PageSnsBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, blockTitle?: string | null, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null } | { __typename: 'PageSocialNetworksBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, publicDescription?: string | null, showTitle: boolean, showDescription: boolean, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, seeMoreAction?: string | null, seeMoreLink?: string | null, pageSocialNetworksBlockTitle?: string | null, leftItems: Array<{ __typename?: 'PageSocialNetworksLeftBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, imageLink?: string | null, alternativeText?: string | null }>, rightItems: Array<{ __typename?: 'PageSocialNetworksRightBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, socialNetworkType?: SocialNetworkType | null, hasRightItem?: boolean | null, link?: string | null }> } | { __typename: 'PageStyledTableBlock' } | { __typename: 'PageSubDownloadBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, subDownloadTitle?: string | null, subDownloadDescription?: string | null, subDownloadPlaceholder?: string | null, subDownloadSearchbar?: boolean | null, pageSubDownloadBlockItems: Array<{ __typename?: 'PageSubDownloadBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, orderIndex: number, name: string, pageSubDownloadBlockItemDescription?: string | null }> } | { __typename: 'PageSubHeaderBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, type?: string | null, showDates?: boolean | null, subHeaderTitle?: string | null, subHeaderDescription?: string | null, subHeaderPlaceholder?: string | null, subHeaderSearchbar?: boolean | null } | { __typename: 'PageTaxesBlock' } | { __typename: 'PageTransparencyBlock', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, isDisabled: boolean, canBeDisabled: boolean, orderIndex: number, location: BlockLocation, pageBlockStyle?: PageBlockStyles | null, subPages?: Array<SubPages> | null, hasLinkVideo?: boolean | null, transparencyContent?: string | null, image?: { __typename: 'FileInfo', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, items: Array<{ __typename: 'PageTransparencyBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number, itemTitle?: string | null, itemDescription?: string | null, previousVersion?: { __typename: 'PageBlockItem', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description?: string | null, orderIndex: number } | null, itemIcon?: { __typename: 'FileInfo', downloadUrl?: string | null, id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, fileName: string, fileExtension: string, fileMode: FileModes, fileMongoId?: string | null, url: string } | null, linkItem?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null, dynamicPageSlugs?: Array<{ __typename?: 'SeoMetadata', id: string, slug?: string | null }> | null } | null }>, linkVideo?: { __typename: 'PageLink', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, target?: string | null, arguments?: Array<string> | null, url?: string | null } | null } | { __typename: 'PageTransparencyHeaderBlock' }> };

export type AllPageBlockEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPageBlockEnumQuery = { __typename?: 'Query', findPageBlockEnum: Array<{ __typename?: 'DefaultPageBlockModel', block: string, title?: string | null }> };

export type FindPageAllBlocksEnumQueryVariables = Exact<{
  blockLocations?: InputMaybe<Array<BlockLocation> | BlockLocation>;
}>;


export type FindPageAllBlocksEnumQuery = { __typename?: 'Query', findPageAllBlocksEnum: Array<{ __typename?: 'DefaultPageBlockModel', block: string, title?: string | null }> };

export type ResendCodeConfirmationMutationVariables = Exact<{
  resendCodeConfirmationInput: ResendCodeConfirmationInput;
}>;


export type ResendCodeConfirmationMutation = { __typename?: 'Mutation', resendCodeConfirmation: string };

export type ValidateCodeUserRequestMutationVariables = Exact<{
  validateUserCodeRequestInput: ValidateUserCodeRequestInput;
}>;


export type ValidateCodeUserRequestMutation = { __typename?: 'Mutation', validateCodeUserRequest: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, legalRepresentativeIdentificationType?: UserDocumentTypes | null, legalRepresentativeIdentificationNumber?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserStatusTypes, phoneVerification: boolean, emailVerification: boolean, type: UserTypes, passwordStatus: PasswordStatusTypes, temporalPassword?: boolean | null, credentialsExpirationDate?: any | null, loginAttempts: number, attemptsCycles: number, lastFailedAttemptDate?: any | null, permissions?: Array<string> | null, fullName: string, hasExpiredCredentials: boolean } };

export type ResendConfirmationCodeMutationVariables = Exact<{
  resendConfirmationCodeInput: ResendConfirmationCodeInput;
}>;


export type ResendConfirmationCodeMutation = { __typename?: 'Mutation', resendConfirmationCode: { __typename?: 'UserRequest', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, name?: string | null, middleName?: string | null, lastName?: string | null, secondSurname?: string | null, email: string, identificationType?: UserDocumentTypes | null, identificationNumber?: string | null, dateIssue?: any | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, hasRural?: boolean | null, status: UserRequestStatusTypes, requestType: UserRequestType } };

export type PageBlockSimpleQueryVariables = Exact<{
  pageBlockSimpleId: Scalars['ID']['input'];
}>;


export type PageBlockSimpleQuery = { __typename?: 'Query', pageBlockSimple: { __typename?: 'PageBlock', blockTitle?: string | null, type?: string | null } };

export type CheckSlugAvailabilityQueryVariables = Exact<{
  input: CheckSlugAvailabilityInput;
}>;


export type CheckSlugAvailabilityQuery = { __typename?: 'Query', checkSlugAvailability: { __typename?: 'SlugAvailabilityResponse', isAvailable: boolean, slug: string, conflict?: { __typename?: 'SlugConflictInfo', contentType: SlugContentType, contentId: string, contentTitle: string, language: Language, createdAt: any, dependency?: string | null } | null } };

export type GetSearchBlockDetailQueryVariables = Exact<{
  pageBlockId: Scalars['ID']['input'];
}>;


export type GetSearchBlockDetailQuery = { __typename?: 'Query', pageBlock: { __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock', id: string, orderIndex: number, blockTitle?: string | null, pageBlockStyle?: PageBlockStyles | null, type?: string | null, description: string, isDisabled: boolean, createdAt: any, updatedAt: any, placeholder?: string | null, canBeDisabled: boolean } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' } };

export type UpdateSearchBlockMutationVariables = Exact<{
  input: UpdatePageBlockInputUnion;
}>;


export type UpdateSearchBlockMutation = { __typename?: 'Mutation', updatePageBlock: Array<{ __typename?: 'PageAccessibilityBar' } | { __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAccordionBlock' } | { __typename?: 'PageAlertsBlock' } | { __typename?: 'PageAttentionLinesBlock' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageCabinetBlock' } | { __typename?: 'PageCorporateLogosBlock' } | { __typename?: 'PageCustomBlock' } | { __typename?: 'PageEventsBlock' } | { __typename?: 'PageEventSliderBlock' } | { __typename?: 'PageFooterBar' } | { __typename?: 'PageHeaderBar' } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageInstitutionalProgramsSliderBlock' } | { __typename?: 'PageInstitutionalProgramsTypesBlock' } | { __typename?: 'PageMapBlock' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageNewsletterBlock' } | { __typename?: 'PageParticipateDownloadBlock' } | { __typename?: 'PageParticipateElementBlock' } | { __typename?: 'PageParticipateHeaderBlock' } | { __typename?: 'PagePqrsdfActionBlock' } | { __typename?: 'PagePqrsdfConsultBlock' } | { __typename?: 'PagePressroomBlock' } | { __typename?: 'PageProcedureFeedbackBlock' } | { __typename?: 'PageProcedureHeaderBlock' } | { __typename?: 'PageProcedureMainBlock' } | { __typename?: 'PageProceduresBlock' } | { __typename?: 'PageQuickAccessBar' } | { __typename?: 'PageRegulationsBlock' } | { __typename?: 'PageSearchBlock', id: string } | { __typename?: 'PageSliderBlock' } | { __typename?: 'PageSnsBlock' } | { __typename?: 'PageSocialNetworksBlock' } | { __typename?: 'PageStyledTableBlock' } | { __typename?: 'PageSubDownloadBlock' } | { __typename?: 'PageSubHeaderBlock' } | { __typename?: 'PageTaxesBlock' } | { __typename?: 'PageTransparencyBlock' } | { __typename?: 'PageTransparencyHeaderBlock' }> };

export type SearchContentsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FindContentSearchWhere>;
  includePagination: Scalars['Boolean']['input'];
}>;


export type SearchContentsQuery = { __typename?: 'Query', contents: Array<{ __typename?: 'ContentSearch', id: string, title: string, description?: string | null, publicationDate?: any | null, type: ContentSearchType, status: string, slug?: string | null, dependency?: { __typename?: 'Dependency', name: string, id: string } | null }>, paginationContents?: { __typename?: 'PaginationResult', total: number, count: number, limit?: number | null, page: number, pageCount: number, hasNextPage: boolean, hasPreviousPage: boolean } };

export type UpdatePageVersionMutationVariables = Exact<{
  updateInput: UpdatePageVersionInput;
}>;


export type UpdatePageVersionMutation = { __typename?: 'Mutation', updatePageVersion: { __typename?: 'PageVersion', state: VersionStates, id: string, description: string } };

export type RemovePageVersionMutationVariables = Exact<{
  removePageVersionId: Scalars['ID']['input'];
}>;


export type RemovePageVersionMutation = { __typename?: 'Mutation', removePageVersion: { __typename?: 'PageVersion', id: string } };

export type PageVersionsAdminQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  orderBy?: InputMaybe<Array<FindPageVersionsOrderBy> | FindPageVersionsOrderBy>;
  where?: InputMaybe<FindPageVersionsWhere>;
}>;


export type PageVersionsAdminQuery = { __typename?: 'Query', pageVersions: Array<{ __typename?: 'PageVersion', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, description: string, state: VersionStates, theme: Theme, consecutive?: string | null, user?: { __typename?: 'User', fullName: string } | null }>, pageVersionsCount: { __typename?: 'MetadataPagination', itemsPerPage?: number | null, currentPage?: number | null, totalItems?: number | null, totalPages?: number | null } };

export type ActiveVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveVersionQuery = { __typename?: 'Query', version: { __typename?: 'PageVersion', id: string, description: string, state: VersionStates, theme: Theme, consecutive?: string | null } };

export type ProcedureByIdQueryVariables = Exact<{
  procedureId: Scalars['ID']['input'];
}>;


export type ProcedureByIdQuery = { __typename?: 'Query', procedure: { __typename?: 'Procedure', action?: string | null, updatedAt: any, publicationDate?: any | null, procedureStatus?: VersionStates | null, procedureItemTags: Array<string>, procedureDescription?: string | null, procedureTypes?: ProcedureTypes | null, name: string, multimediaType?: MultimediaTypes | null, modality: ModalityTypes, id: string, gocvoLogoName?: string | null, estimatedDuration?: number | null, duration?: DurationTypes | null, deletedAt?: any | null, date?: string | null, createdAt: any, cost: CostTypes, alternativeText?: string | null, actionLink?: string | null, processDefinitionId?: string | null, showGovcoButton: boolean, showProcedureButton: boolean, linkItem?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, deletedAt?: any | null, createdAt: any, arguments?: Array<string> | null } | null, govcoLink?: { __typename?: 'PageLink', url?: string | null, updatedAt: any, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, deletedAt?: any | null, createdAt: any, arguments?: Array<string> | null } | null, linkVideo?: { __typename?: 'PageLink', url?: string | null, target?: string | null, routeType?: RouterType | null, routeNavigation?: SubPages | null, id: string, arguments?: Array<string> | null } | null, govcoImage?: { __typename?: 'FileInfo', url: string, updatedAt: any, id: string, fileName: string, fileMongoId?: string | null, fileMode: FileModes, fileExtension: string, deletedAt?: any | null, createdAt: any } | null } };

export type UpdateProcedureStatusMutationMutationVariables = Exact<{
  updateInput: UpdateProcedureInput;
}>;


export type UpdateProcedureStatusMutationMutation = { __typename?: 'Mutation', updateProcedure: { __typename?: 'Procedure', procedureStatus?: VersionStates | null, id: string } };

export type UpdateProcedureStatusToDraftMutationVariables = Exact<{
  updateProcedureStatusToDraft: UpdateProcedureStatusToDraft;
}>;


export type UpdateProcedureStatusToDraftMutation = { __typename?: 'Mutation', updateProcedureStatusToDraft: string };

export type TopBarQueryVariables = Exact<{ [key: string]: never; }>;


export type TopBarQuery = { __typename?: 'Query', header: Array<{ __typename?: 'PageAccessibilityButton' } | { __typename?: 'PageAuthenticationBar' } | { __typename?: 'PageHeaderBar', id: string, description: string, createdAt: any, updatedAt: any, isDisabled: boolean } | { __typename?: 'PageHeaderOrganizationBar' } | { __typename?: 'PageNavigationBar' } | { __typename?: 'PageSearchBlock' }> };

export const NavigationItemFieldsFragmentDoc = gql`
    fragment NavigationItemFields on NavigationItem {
  id
  createdAt
  updatedAt
  deletedAt
  name
  description
  link
  orderIndex
  type
  status
  lft
  rgt
  depth
  linkItem {
    routeType
    target
    url
    routeNavigation
    arguments
    __typename
  }
}
    `;
export const ContentSchemaFieldsFragmentDoc = gql`
    fragment ContentSchemaFields on ContentSchema {
  id
  name
  fields {
    id
    fieldName
    fieldLabel
    fieldType
    isGroup
    __typename
  }
  __typename
}
    `;
export const CreatePageBlockItemAccordionDocument = gql`
    mutation CreatePageBlockItemAccordion($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageAccordionBlockItem {
      id
      index
      indexTitle
      orderIndex
      description
      createdAt
      updatedAt
      deletedAt
      subtype
      configJson
      lft
      rgt
      depth
      linkItem {
        id
        arguments
        routeNavigation
        routeType
        target
        url
      }
    }
  }
}
    `;
export type CreatePageBlockItemAccordionMutationFn = Apollo.MutationFunction<CreatePageBlockItemAccordionMutation, CreatePageBlockItemAccordionMutationVariables>;

/**
 * __useCreatePageBlockItemAccordionMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockItemAccordionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockItemAccordionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockItemAccordionMutation, { data, loading, error }] = useCreatePageBlockItemAccordionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockItemAccordionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockItemAccordionMutation, CreatePageBlockItemAccordionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockItemAccordionMutation, CreatePageBlockItemAccordionMutationVariables>(CreatePageBlockItemAccordionDocument, options);
      }
export type CreatePageBlockItemAccordionMutationHookResult = ReturnType<typeof useCreatePageBlockItemAccordionMutation>;
export type CreatePageBlockItemAccordionMutationResult = Apollo.MutationResult<CreatePageBlockItemAccordionMutation>;
export type CreatePageBlockItemAccordionMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockItemAccordionMutation, CreatePageBlockItemAccordionMutationVariables>;
export const UpdatePageBlockItemAccordionDocument = gql`
    mutation UpdatePageBlockItemAccordion($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageAccordionBlockItem {
      id
      index
      indexTitle
      orderIndex
      description
      createdAt
      updatedAt
      deletedAt
      subtype
      configJson
      lft
      rgt
      depth
      linkItem {
        id
        arguments
        routeNavigation
        routeType
        target
        url
      }
    }
  }
}
    `;
export type UpdatePageBlockItemAccordionMutationFn = Apollo.MutationFunction<UpdatePageBlockItemAccordionMutation, UpdatePageBlockItemAccordionMutationVariables>;

/**
 * __useUpdatePageBlockItemAccordionMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemAccordionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemAccordionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemAccordionMutation, { data, loading, error }] = useUpdatePageBlockItemAccordionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemAccordionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemAccordionMutation, UpdatePageBlockItemAccordionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemAccordionMutation, UpdatePageBlockItemAccordionMutationVariables>(UpdatePageBlockItemAccordionDocument, options);
      }
export type UpdatePageBlockItemAccordionMutationHookResult = ReturnType<typeof useUpdatePageBlockItemAccordionMutation>;
export type UpdatePageBlockItemAccordionMutationResult = Apollo.MutationResult<UpdatePageBlockItemAccordionMutation>;
export type UpdatePageBlockItemAccordionMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemAccordionMutation, UpdatePageBlockItemAccordionMutationVariables>;
export const RemovePageBlockItemAccordionDocument = gql`
    mutation RemovePageBlockItemAccordion($id: ID!) {
  removePageBlockItem(id: $id) {
    ... on PageAccordionBlockItem {
      id
    }
  }
}
    `;
export type RemovePageBlockItemAccordionMutationFn = Apollo.MutationFunction<RemovePageBlockItemAccordionMutation, RemovePageBlockItemAccordionMutationVariables>;

/**
 * __useRemovePageBlockItemAccordionMutation__
 *
 * To run a mutation, you first call `useRemovePageBlockItemAccordionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageBlockItemAccordionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageBlockItemAccordionMutation, { data, loading, error }] = useRemovePageBlockItemAccordionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePageBlockItemAccordionMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageBlockItemAccordionMutation, RemovePageBlockItemAccordionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageBlockItemAccordionMutation, RemovePageBlockItemAccordionMutationVariables>(RemovePageBlockItemAccordionDocument, options);
      }
export type RemovePageBlockItemAccordionMutationHookResult = ReturnType<typeof useRemovePageBlockItemAccordionMutation>;
export type RemovePageBlockItemAccordionMutationResult = Apollo.MutationResult<RemovePageBlockItemAccordionMutation>;
export type RemovePageBlockItemAccordionMutationOptions = Apollo.BaseMutationOptions<RemovePageBlockItemAccordionMutation, RemovePageBlockItemAccordionMutationVariables>;
export const DeleteAccordionBlockItemWithStrategyDocument = gql`
    mutation DeleteAccordionBlockItemWithStrategy($input: DeleteAccordionBlockItemInput!) {
  deleteAccordionBlockItemWithStrategy(input: $input) {
    deletedItemsCount
    deletedItemIds
    movedItemsCount
    movedItemIds
    message
  }
}
    `;
export type DeleteAccordionBlockItemWithStrategyMutationFn = Apollo.MutationFunction<DeleteAccordionBlockItemWithStrategyMutation, DeleteAccordionBlockItemWithStrategyMutationVariables>;

/**
 * __useDeleteAccordionBlockItemWithStrategyMutation__
 *
 * To run a mutation, you first call `useDeleteAccordionBlockItemWithStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccordionBlockItemWithStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccordionBlockItemWithStrategyMutation, { data, loading, error }] = useDeleteAccordionBlockItemWithStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccordionBlockItemWithStrategyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccordionBlockItemWithStrategyMutation, DeleteAccordionBlockItemWithStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccordionBlockItemWithStrategyMutation, DeleteAccordionBlockItemWithStrategyMutationVariables>(DeleteAccordionBlockItemWithStrategyDocument, options);
      }
export type DeleteAccordionBlockItemWithStrategyMutationHookResult = ReturnType<typeof useDeleteAccordionBlockItemWithStrategyMutation>;
export type DeleteAccordionBlockItemWithStrategyMutationResult = Apollo.MutationResult<DeleteAccordionBlockItemWithStrategyMutation>;
export type DeleteAccordionBlockItemWithStrategyMutationOptions = Apollo.BaseMutationOptions<DeleteAccordionBlockItemWithStrategyMutation, DeleteAccordionBlockItemWithStrategyMutationVariables>;
export const MoveAccordionBlockItemDocument = gql`
    mutation MoveAccordionBlockItem($input: MoveAccordionBlockItemInput!) {
  moveAccordionBlockItem(input: $input) {
    id
    index
    indexTitle
    depth
    lft
    rgt
  }
}
    `;
export type MoveAccordionBlockItemMutationFn = Apollo.MutationFunction<MoveAccordionBlockItemMutation, MoveAccordionBlockItemMutationVariables>;

/**
 * __useMoveAccordionBlockItemMutation__
 *
 * To run a mutation, you first call `useMoveAccordionBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAccordionBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAccordionBlockItemMutation, { data, loading, error }] = useMoveAccordionBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveAccordionBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<MoveAccordionBlockItemMutation, MoveAccordionBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveAccordionBlockItemMutation, MoveAccordionBlockItemMutationVariables>(MoveAccordionBlockItemDocument, options);
      }
export type MoveAccordionBlockItemMutationHookResult = ReturnType<typeof useMoveAccordionBlockItemMutation>;
export type MoveAccordionBlockItemMutationResult = Apollo.MutationResult<MoveAccordionBlockItemMutation>;
export type MoveAccordionBlockItemMutationOptions = Apollo.BaseMutationOptions<MoveAccordionBlockItemMutation, MoveAccordionBlockItemMutationVariables>;
export const GetAccordionItemDescendantsDocument = gql`
    query GetAccordionItemDescendants($itemId: ID!) {
  accordionItemDescendants(itemId: $itemId) {
    id
    index
    indexTitle
    description
    depth
    lft
    rgt
  }
}
    `;

/**
 * __useGetAccordionItemDescendantsQuery__
 *
 * To run a query within a React component, call `useGetAccordionItemDescendantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccordionItemDescendantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccordionItemDescendantsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetAccordionItemDescendantsQuery(baseOptions: Apollo.QueryHookOptions<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>(GetAccordionItemDescendantsDocument, options);
      }
export function useGetAccordionItemDescendantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>(GetAccordionItemDescendantsDocument, options);
        }
export function useGetAccordionItemDescendantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>(GetAccordionItemDescendantsDocument, options);
        }
export type GetAccordionItemDescendantsQueryHookResult = ReturnType<typeof useGetAccordionItemDescendantsQuery>;
export type GetAccordionItemDescendantsLazyQueryHookResult = ReturnType<typeof useGetAccordionItemDescendantsLazyQuery>;
export type GetAccordionItemDescendantsSuspenseQueryHookResult = ReturnType<typeof useGetAccordionItemDescendantsSuspenseQuery>;
export type GetAccordionItemDescendantsQueryResult = Apollo.QueryResult<GetAccordionItemDescendantsQuery, GetAccordionItemDescendantsQueryVariables>;
export const GetAccordionItemAncestorsDocument = gql`
    query GetAccordionItemAncestors($itemId: ID!) {
  accordionItemAncestors(itemId: $itemId) {
    id
    index
    indexTitle
    depth
  }
}
    `;

/**
 * __useGetAccordionItemAncestorsQuery__
 *
 * To run a query within a React component, call `useGetAccordionItemAncestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccordionItemAncestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccordionItemAncestorsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetAccordionItemAncestorsQuery(baseOptions: Apollo.QueryHookOptions<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>(GetAccordionItemAncestorsDocument, options);
      }
export function useGetAccordionItemAncestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>(GetAccordionItemAncestorsDocument, options);
        }
export function useGetAccordionItemAncestorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>(GetAccordionItemAncestorsDocument, options);
        }
export type GetAccordionItemAncestorsQueryHookResult = ReturnType<typeof useGetAccordionItemAncestorsQuery>;
export type GetAccordionItemAncestorsLazyQueryHookResult = ReturnType<typeof useGetAccordionItemAncestorsLazyQuery>;
export type GetAccordionItemAncestorsSuspenseQueryHookResult = ReturnType<typeof useGetAccordionItemAncestorsSuspenseQuery>;
export type GetAccordionItemAncestorsQueryResult = Apollo.QueryResult<GetAccordionItemAncestorsQuery, GetAccordionItemAncestorsQueryVariables>;
export const RebuildAccordionNestedSetDocument = gql`
    mutation RebuildAccordionNestedSet($accordionBlockId: ID!) {
  rebuildAccordionNestedSet(accordionBlockId: $accordionBlockId)
}
    `;
export type RebuildAccordionNestedSetMutationFn = Apollo.MutationFunction<RebuildAccordionNestedSetMutation, RebuildAccordionNestedSetMutationVariables>;

/**
 * __useRebuildAccordionNestedSetMutation__
 *
 * To run a mutation, you first call `useRebuildAccordionNestedSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRebuildAccordionNestedSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rebuildAccordionNestedSetMutation, { data, loading, error }] = useRebuildAccordionNestedSetMutation({
 *   variables: {
 *      accordionBlockId: // value for 'accordionBlockId'
 *   },
 * });
 */
export function useRebuildAccordionNestedSetMutation(baseOptions?: Apollo.MutationHookOptions<RebuildAccordionNestedSetMutation, RebuildAccordionNestedSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RebuildAccordionNestedSetMutation, RebuildAccordionNestedSetMutationVariables>(RebuildAccordionNestedSetDocument, options);
      }
export type RebuildAccordionNestedSetMutationHookResult = ReturnType<typeof useRebuildAccordionNestedSetMutation>;
export type RebuildAccordionNestedSetMutationResult = Apollo.MutationResult<RebuildAccordionNestedSetMutation>;
export type RebuildAccordionNestedSetMutationOptions = Apollo.BaseMutationOptions<RebuildAccordionNestedSetMutation, RebuildAccordionNestedSetMutationVariables>;
export const GetAccordionBlockDataDocument = gql`
    query GetAccordionBlockData($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageAccordionBlock {
      id
      description
      publicDescription
      showTitle
      showDescription
      createdAt
      updatedAt
      deletedAt
      blockTitle
      indexDigitLength
      filterDependencyIds
      items {
        id
        index
        indexTitle
        orderIndex
        description
        createdAt
        updatedAt
        deletedAt
        subtype
        configJson
        lft
        rgt
        depth
        linkItem {
          id
          arguments
          routeNavigation
          routeType
          target
          url
          __typename
        }
        __typename
        schema {
          id
          createdAt
          updatedAt
          deletedAt
          name
          description
          contentType
          isActive
          allowChildren
          maxNestingLevel
          hierarchyLabel
          dependencyCount
          fields {
            id
            createdAt
            updatedAt
            deletedAt
            fieldName
            fieldLabel
            fieldType
            isRequired
            orderIndex
            options
            validationRules
            defaultValue
            isActive
            isGroup
          }
        }
      }
      __typename
      type
      subtype
      pageBlockStyle
    }
    __typename
  }
}
    `;

/**
 * __useGetAccordionBlockDataQuery__
 *
 * To run a query within a React component, call `useGetAccordionBlockDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccordionBlockDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccordionBlockDataQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetAccordionBlockDataQuery(baseOptions: Apollo.QueryHookOptions<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>(GetAccordionBlockDataDocument, options);
      }
export function useGetAccordionBlockDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>(GetAccordionBlockDataDocument, options);
        }
export function useGetAccordionBlockDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>(GetAccordionBlockDataDocument, options);
        }
export type GetAccordionBlockDataQueryHookResult = ReturnType<typeof useGetAccordionBlockDataQuery>;
export type GetAccordionBlockDataLazyQueryHookResult = ReturnType<typeof useGetAccordionBlockDataLazyQuery>;
export type GetAccordionBlockDataSuspenseQueryHookResult = ReturnType<typeof useGetAccordionBlockDataSuspenseQuery>;
export type GetAccordionBlockDataQueryResult = Apollo.QueryResult<GetAccordionBlockDataQuery, GetAccordionBlockDataQueryVariables>;
export const AlertBlockDataDocument = gql`
    query AlertBlockData($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageAlertsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      title
      blockTitle
      description
      alertDescription
      alertStyle
      showTitle
      showDescription
      buttonTitle
      actionType
      displayFrequency
      htmlTemplate
      canBeDisabled
      isDisabled
      type
      image {
        id
        url
        fileName
        downloadUrl
        fileExtension
      }
      linkItem {
        id
        arguments
        routeType
        routeNavigation
        target
        url
      }
    }
  }
}
    `;

/**
 * __useAlertBlockDataQuery__
 *
 * To run a query within a React component, call `useAlertBlockDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertBlockDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertBlockDataQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useAlertBlockDataQuery(baseOptions: Apollo.QueryHookOptions<AlertBlockDataQuery, AlertBlockDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertBlockDataQuery, AlertBlockDataQueryVariables>(AlertBlockDataDocument, options);
      }
export function useAlertBlockDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertBlockDataQuery, AlertBlockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertBlockDataQuery, AlertBlockDataQueryVariables>(AlertBlockDataDocument, options);
        }
export function useAlertBlockDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertBlockDataQuery, AlertBlockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertBlockDataQuery, AlertBlockDataQueryVariables>(AlertBlockDataDocument, options);
        }
export type AlertBlockDataQueryHookResult = ReturnType<typeof useAlertBlockDataQuery>;
export type AlertBlockDataLazyQueryHookResult = ReturnType<typeof useAlertBlockDataLazyQuery>;
export type AlertBlockDataSuspenseQueryHookResult = ReturnType<typeof useAlertBlockDataSuspenseQuery>;
export type AlertBlockDataQueryResult = Apollo.QueryResult<AlertBlockDataQuery, AlertBlockDataQueryVariables>;
export const PageCabinetBlockItemAllDocument = gql`
    query PageCabinetBlockItemAll($parentId: ID!, $where: FindPageBlockItemsWhere, $positions: [String!], $orderBy: [FindPageBlockItemsOrderBy!], $positionOrder: OrderTypes) {
  pageBlockItems(parentId: $parentId, where: $where, positions: $positions, orderBy: $orderBy, positionOrder: $positionOrder) {
    ... on PageCabinetBlockItem {
      id
      createdAt
      description
      orderIndex
      cabinetName
      cabinetEmail
      cabinetPosition {
        id
        name
      }
      cabinetImage {
        id
        downloadUrl
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      linkItem {
        id
        createdAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
      cabinetPhone
      alternativeText
    }
  }
}
    `;

/**
 * __usePageCabinetBlockItemAllQuery__
 *
 * To run a query within a React component, call `usePageCabinetBlockItemAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCabinetBlockItemAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCabinetBlockItemAllQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      where: // value for 'where'
 *      positions: // value for 'positions'
 *      orderBy: // value for 'orderBy'
 *      positionOrder: // value for 'positionOrder'
 *   },
 * });
 */
export function usePageCabinetBlockItemAllQuery(baseOptions: Apollo.QueryHookOptions<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>(PageCabinetBlockItemAllDocument, options);
      }
export function usePageCabinetBlockItemAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>(PageCabinetBlockItemAllDocument, options);
        }
export function usePageCabinetBlockItemAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>(PageCabinetBlockItemAllDocument, options);
        }
export type PageCabinetBlockItemAllQueryHookResult = ReturnType<typeof usePageCabinetBlockItemAllQuery>;
export type PageCabinetBlockItemAllLazyQueryHookResult = ReturnType<typeof usePageCabinetBlockItemAllLazyQuery>;
export type PageCabinetBlockItemAllSuspenseQueryHookResult = ReturnType<typeof usePageCabinetBlockItemAllSuspenseQuery>;
export type PageCabinetBlockItemAllQueryResult = Apollo.QueryResult<PageCabinetBlockItemAllQuery, PageCabinetBlockItemAllQueryVariables>;
export const CreateCabinetDetailInputDocument = gql`
    mutation CreateCabinetDetailInput($createInput: CreateCabinetDetailInput!) {
  createCabinetDetailInput(createInput: $createInput) {
    id
    createdAt
    cabinetDetailLink {
      routeType
      url
      target
    }
    cabinetDetailName
    cabinetDetailImage {
      id
    }
    cabinetDetailStatus
    cabinetItem {
      cabinetName
      cabinetImage {
        downloadUrl
        id
      }
    }
  }
}
    `;
export type CreateCabinetDetailInputMutationFn = Apollo.MutationFunction<CreateCabinetDetailInputMutation, CreateCabinetDetailInputMutationVariables>;

/**
 * __useCreateCabinetDetailInputMutation__
 *
 * To run a mutation, you first call `useCreateCabinetDetailInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCabinetDetailInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCabinetDetailInputMutation, { data, loading, error }] = useCreateCabinetDetailInputMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCabinetDetailInputMutation(baseOptions?: Apollo.MutationHookOptions<CreateCabinetDetailInputMutation, CreateCabinetDetailInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCabinetDetailInputMutation, CreateCabinetDetailInputMutationVariables>(CreateCabinetDetailInputDocument, options);
      }
export type CreateCabinetDetailInputMutationHookResult = ReturnType<typeof useCreateCabinetDetailInputMutation>;
export type CreateCabinetDetailInputMutationResult = Apollo.MutationResult<CreateCabinetDetailInputMutation>;
export type CreateCabinetDetailInputMutationOptions = Apollo.BaseMutationOptions<CreateCabinetDetailInputMutation, CreateCabinetDetailInputMutationVariables>;
export const RemovePageBlockItemCabinetDocument = gql`
    mutation RemovePageBlockItemCabinet($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageCabinetBlockItem {
      id
    }
  }
}
    `;
export type RemovePageBlockItemCabinetMutationFn = Apollo.MutationFunction<RemovePageBlockItemCabinetMutation, RemovePageBlockItemCabinetMutationVariables>;

/**
 * __useRemovePageBlockItemCabinetMutation__
 *
 * To run a mutation, you first call `useRemovePageBlockItemCabinetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageBlockItemCabinetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageBlockItemCabinetMutation, { data, loading, error }] = useRemovePageBlockItemCabinetMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemovePageBlockItemCabinetMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageBlockItemCabinetMutation, RemovePageBlockItemCabinetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageBlockItemCabinetMutation, RemovePageBlockItemCabinetMutationVariables>(RemovePageBlockItemCabinetDocument, options);
      }
export type RemovePageBlockItemCabinetMutationHookResult = ReturnType<typeof useRemovePageBlockItemCabinetMutation>;
export type RemovePageBlockItemCabinetMutationResult = Apollo.MutationResult<RemovePageBlockItemCabinetMutation>;
export type RemovePageBlockItemCabinetMutationOptions = Apollo.BaseMutationOptions<RemovePageBlockItemCabinetMutation, RemovePageBlockItemCabinetMutationVariables>;
export const UpdatePageBlockItemCabinetDocument = gql`
    mutation UpdatePageBlockItemCabinet($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageCabinetBlockItem {
      id
      description
      orderIndex
      cabinetName
      cabinetEmail
      curriculumVitaeLink
      cabinetPosition {
        id
        createdAt
        updatedAt
        deletedAt
        name
      }
      cabinetImage {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        downloadUrl
        fileMongoId
        url
      }
      cabinetPhone
      alternativeText
    }
  }
}
    `;
export type UpdatePageBlockItemCabinetMutationFn = Apollo.MutationFunction<UpdatePageBlockItemCabinetMutation, UpdatePageBlockItemCabinetMutationVariables>;

/**
 * __useUpdatePageBlockItemCabinetMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemCabinetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemCabinetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemCabinetMutation, { data, loading, error }] = useUpdatePageBlockItemCabinetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemCabinetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemCabinetMutation, UpdatePageBlockItemCabinetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemCabinetMutation, UpdatePageBlockItemCabinetMutationVariables>(UpdatePageBlockItemCabinetDocument, options);
      }
export type UpdatePageBlockItemCabinetMutationHookResult = ReturnType<typeof useUpdatePageBlockItemCabinetMutation>;
export type UpdatePageBlockItemCabinetMutationResult = Apollo.MutationResult<UpdatePageBlockItemCabinetMutation>;
export type UpdatePageBlockItemCabinetMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemCabinetMutation, UpdatePageBlockItemCabinetMutationVariables>;
export const UpdateCabinetDetailInputDocument = gql`
    mutation UpdateCabinetDetailInput($updateInput: UpdateCabinetDetailInput!) {
  updateCabinetDetailInput(updateInput: $updateInput) {
    id
    cabinetDetailName
    cabinetDetailImage {
      id
      createdAt
      updatedAt
      deletedAt
      fileExtension
      fileName
      fileMode
      fileMongoId
      url
    }
  }
}
    `;
export type UpdateCabinetDetailInputMutationFn = Apollo.MutationFunction<UpdateCabinetDetailInputMutation, UpdateCabinetDetailInputMutationVariables>;

/**
 * __useUpdateCabinetDetailInputMutation__
 *
 * To run a mutation, you first call `useUpdateCabinetDetailInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCabinetDetailInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCabinetDetailInputMutation, { data, loading, error }] = useUpdateCabinetDetailInputMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCabinetDetailInputMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCabinetDetailInputMutation, UpdateCabinetDetailInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCabinetDetailInputMutation, UpdateCabinetDetailInputMutationVariables>(UpdateCabinetDetailInputDocument, options);
      }
export type UpdateCabinetDetailInputMutationHookResult = ReturnType<typeof useUpdateCabinetDetailInputMutation>;
export type UpdateCabinetDetailInputMutationResult = Apollo.MutationResult<UpdateCabinetDetailInputMutation>;
export type UpdateCabinetDetailInputMutationOptions = Apollo.BaseMutationOptions<UpdateCabinetDetailInputMutation, UpdateCabinetDetailInputMutationVariables>;
export const PageCabinetBlockItemByIdDocument = gql`
    query PageCabinetBlockItemById($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageCabinetBlockItem {
      id
      curriculumVitaeLink
      cabinetName
      orderIndex
      cabinetPhone
      cabinetDescription
      cabinetEmail
      alternativeText
      cabinetPosition {
        id
        name
      }
      cabinetDetails {
        id
        cabinetDetailStatus
        cabinetDetailName
        cabinetDetailImage {
          downloadUrl
          id
          fileName
          fileMode
          fileMongoId
          createdAt
          updatedAt
          deletedAt
          fileExtension
          url
        }
        cabinetDetailLink {
          target
          url
        }
        cabinetDetailLink {
          url
        }
      }
      cabinetImage {
        id
        fileName
        downloadUrl
        fileMode
        fileMongoId
        createdAt
        updatedAt
        deletedAt
        fileExtension
        url
      }
      description
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        url
        arguments
      }
      createdAt
    }
  }
}
    `;

/**
 * __usePageCabinetBlockItemByIdQuery__
 *
 * To run a query within a React component, call `usePageCabinetBlockItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCabinetBlockItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCabinetBlockItemByIdQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageCabinetBlockItemByIdQuery(baseOptions: Apollo.QueryHookOptions<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>(PageCabinetBlockItemByIdDocument, options);
      }
export function usePageCabinetBlockItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>(PageCabinetBlockItemByIdDocument, options);
        }
export function usePageCabinetBlockItemByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>(PageCabinetBlockItemByIdDocument, options);
        }
export type PageCabinetBlockItemByIdQueryHookResult = ReturnType<typeof usePageCabinetBlockItemByIdQuery>;
export type PageCabinetBlockItemByIdLazyQueryHookResult = ReturnType<typeof usePageCabinetBlockItemByIdLazyQuery>;
export type PageCabinetBlockItemByIdSuspenseQueryHookResult = ReturnType<typeof usePageCabinetBlockItemByIdSuspenseQuery>;
export type PageCabinetBlockItemByIdQueryResult = Apollo.QueryResult<PageCabinetBlockItemByIdQuery, PageCabinetBlockItemByIdQueryVariables>;
export const CargosCabinetDocument = gql`
    query CargosCabinet {
  positions {
    id
    name
  }
}
    `;

/**
 * __useCargosCabinetQuery__
 *
 * To run a query within a React component, call `useCargosCabinetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCargosCabinetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCargosCabinetQuery({
 *   variables: {
 *   },
 * });
 */
export function useCargosCabinetQuery(baseOptions?: Apollo.QueryHookOptions<CargosCabinetQuery, CargosCabinetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CargosCabinetQuery, CargosCabinetQueryVariables>(CargosCabinetDocument, options);
      }
export function useCargosCabinetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CargosCabinetQuery, CargosCabinetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CargosCabinetQuery, CargosCabinetQueryVariables>(CargosCabinetDocument, options);
        }
export function useCargosCabinetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CargosCabinetQuery, CargosCabinetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CargosCabinetQuery, CargosCabinetQueryVariables>(CargosCabinetDocument, options);
        }
export type CargosCabinetQueryHookResult = ReturnType<typeof useCargosCabinetQuery>;
export type CargosCabinetLazyQueryHookResult = ReturnType<typeof useCargosCabinetLazyQuery>;
export type CargosCabinetSuspenseQueryHookResult = ReturnType<typeof useCargosCabinetSuspenseQuery>;
export type CargosCabinetQueryResult = Apollo.QueryResult<CargosCabinetQuery, CargosCabinetQueryVariables>;
export const CabinetDetailDocument = gql`
    query CabinetDetail($cabinetDetailId: ID!) {
  CabinetDetail(id: $cabinetDetailId) {
    id
    cabinetDetailName
    cabinetDetailImage {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    cabinetDetailLink {
      id
      url
      target
    }
  }
}
    `;

/**
 * __useCabinetDetailQuery__
 *
 * To run a query within a React component, call `useCabinetDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCabinetDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCabinetDetailQuery({
 *   variables: {
 *      cabinetDetailId: // value for 'cabinetDetailId'
 *   },
 * });
 */
export function useCabinetDetailQuery(baseOptions: Apollo.QueryHookOptions<CabinetDetailQuery, CabinetDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CabinetDetailQuery, CabinetDetailQueryVariables>(CabinetDetailDocument, options);
      }
export function useCabinetDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CabinetDetailQuery, CabinetDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CabinetDetailQuery, CabinetDetailQueryVariables>(CabinetDetailDocument, options);
        }
export function useCabinetDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CabinetDetailQuery, CabinetDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CabinetDetailQuery, CabinetDetailQueryVariables>(CabinetDetailDocument, options);
        }
export type CabinetDetailQueryHookResult = ReturnType<typeof useCabinetDetailQuery>;
export type CabinetDetailLazyQueryHookResult = ReturnType<typeof useCabinetDetailLazyQuery>;
export type CabinetDetailSuspenseQueryHookResult = ReturnType<typeof useCabinetDetailSuspenseQuery>;
export type CabinetDetailQueryResult = Apollo.QueryResult<CabinetDetailQuery, CabinetDetailQueryVariables>;
export const CreatePageBlockItemCabinetDocument = gql`
    mutation CreatePageBlockItemCabinet($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageCabinetBlockItem {
      id
      curriculumVitaeLink
      cabinetDescription
      cabinetName
      cabinetPosition {
        id
        name
      }
      cabinetImage {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      cabinetPhone
      alternativeText
    }
  }
}
    `;
export type CreatePageBlockItemCabinetMutationFn = Apollo.MutationFunction<CreatePageBlockItemCabinetMutation, CreatePageBlockItemCabinetMutationVariables>;

/**
 * __useCreatePageBlockItemCabinetMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockItemCabinetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockItemCabinetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockItemCabinetMutation, { data, loading, error }] = useCreatePageBlockItemCabinetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockItemCabinetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockItemCabinetMutation, CreatePageBlockItemCabinetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockItemCabinetMutation, CreatePageBlockItemCabinetMutationVariables>(CreatePageBlockItemCabinetDocument, options);
      }
export type CreatePageBlockItemCabinetMutationHookResult = ReturnType<typeof useCreatePageBlockItemCabinetMutation>;
export type CreatePageBlockItemCabinetMutationResult = Apollo.MutationResult<CreatePageBlockItemCabinetMutation>;
export type CreatePageBlockItemCabinetMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockItemCabinetMutation, CreatePageBlockItemCabinetMutationVariables>;
export const PageCabinetBlockDocument = gql`
    query PageCabinetBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageCabinetBlock {
      id
      description
      publicDescription
      showDescription
      showTitle
      cabinetTitle
      cabinetSubtitle
      extendedDescription
      pageBlockStyle
      isCarrousel
      items {
        curriculumVitaeLink
        id
        orderIndex
        cabinetDescription
        cabinetDetails {
          id
          cabinetDetailImage {
            downloadUrl
            id
            createdAt
            updatedAt
            deletedAt
            fileName
            fileExtension
            fileMode
            fileMongoId
            url
            __typename
          }
          cabinetDetailLink {
            id
            routeType
            url
            routeNavigation
            target
            __typename
          }
          __typename
        }
        cabinetImage {
          url
          updatedAt
          id
          fileName
          downloadUrl
          fileMongoId
          fileMode
          fileExtension
          deletedAt
          createdAt
          __typename
        }
        createdAt
        cabinetName
        cabinetPosition {
          name
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageCabinetBlockQuery__
 *
 * To run a query within a React component, call `usePageCabinetBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCabinetBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCabinetBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageCabinetBlockQuery(baseOptions: Apollo.QueryHookOptions<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>(PageCabinetBlockDocument, options);
      }
export function usePageCabinetBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>(PageCabinetBlockDocument, options);
        }
export function usePageCabinetBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>(PageCabinetBlockDocument, options);
        }
export type PageCabinetBlockQueryHookResult = ReturnType<typeof usePageCabinetBlockQuery>;
export type PageCabinetBlockLazyQueryHookResult = ReturnType<typeof usePageCabinetBlockLazyQuery>;
export type PageCabinetBlockSuspenseQueryHookResult = ReturnType<typeof usePageCabinetBlockSuspenseQuery>;
export type PageCabinetBlockQueryResult = Apollo.QueryResult<PageCabinetBlockQuery, PageCabinetBlockQueryVariables>;
export const RemoveCabinetDetailDocument = gql`
    mutation RemoveCabinetDetail($removeCabinetDetailId: ID!) {
  removeCabinetDetail(id: $removeCabinetDetailId) {
    id
  }
}
    `;
export type RemoveCabinetDetailMutationFn = Apollo.MutationFunction<RemoveCabinetDetailMutation, RemoveCabinetDetailMutationVariables>;

/**
 * __useRemoveCabinetDetailMutation__
 *
 * To run a mutation, you first call `useRemoveCabinetDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCabinetDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCabinetDetailMutation, { data, loading, error }] = useRemoveCabinetDetailMutation({
 *   variables: {
 *      removeCabinetDetailId: // value for 'removeCabinetDetailId'
 *   },
 * });
 */
export function useRemoveCabinetDetailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCabinetDetailMutation, RemoveCabinetDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCabinetDetailMutation, RemoveCabinetDetailMutationVariables>(RemoveCabinetDetailDocument, options);
      }
export type RemoveCabinetDetailMutationHookResult = ReturnType<typeof useRemoveCabinetDetailMutation>;
export type RemoveCabinetDetailMutationResult = Apollo.MutationResult<RemoveCabinetDetailMutation>;
export type RemoveCabinetDetailMutationOptions = Apollo.BaseMutationOptions<RemoveCabinetDetailMutation, RemoveCabinetDetailMutationVariables>;
export const UpdatePageBlockCabinetDocument = gql`
    mutation UpdatePageBlockCabinet($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageCabinetBlock {
      isCarrousel
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      description
      pageBlockStyle
    }
  }
}
    `;
export type UpdatePageBlockCabinetMutationFn = Apollo.MutationFunction<UpdatePageBlockCabinetMutation, UpdatePageBlockCabinetMutationVariables>;

/**
 * __useUpdatePageBlockCabinetMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockCabinetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockCabinetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockCabinetMutation, { data, loading, error }] = useUpdatePageBlockCabinetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockCabinetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockCabinetMutation, UpdatePageBlockCabinetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockCabinetMutation, UpdatePageBlockCabinetMutationVariables>(UpdatePageBlockCabinetDocument, options);
      }
export type UpdatePageBlockCabinetMutationHookResult = ReturnType<typeof useUpdatePageBlockCabinetMutation>;
export type UpdatePageBlockCabinetMutationResult = Apollo.MutationResult<UpdatePageBlockCabinetMutation>;
export type UpdatePageBlockCabinetMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockCabinetMutation, UpdatePageBlockCabinetMutationVariables>;
export const ItemsCabinetDocument = gql`
    query ItemsCabinet {
  mainPage {
    ... on PageCabinetBlock {
      isCarrousel
      items {
        cabinetDescription
        id
        orderIndex
        cabinetPosition {
          id
          createdAt
          updatedAt
          deletedAt
          name
        }
        cabinetImage {
          id
          createdAt
          updatedAt
          deletedAt
          downloadUrl
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
        }
        cabinetName
        cabinetDetails {
          cabinetDetailLink {
            arguments
            id
            routeNavigation
            routeType
            url
            target
          }
          cabinetDetailName
          cabinetDetailImage {
            id
            createdAt
            updatedAt
            deletedAt
            fileName
            fileExtension
            fileMode
            fileMongoId
            url
          }
          id
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          url
          arguments
        }
      }
    }
  }
}
    `;

/**
 * __useItemsCabinetQuery__
 *
 * To run a query within a React component, call `useItemsCabinetQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsCabinetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsCabinetQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemsCabinetQuery(baseOptions?: Apollo.QueryHookOptions<ItemsCabinetQuery, ItemsCabinetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsCabinetQuery, ItemsCabinetQueryVariables>(ItemsCabinetDocument, options);
      }
export function useItemsCabinetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsCabinetQuery, ItemsCabinetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsCabinetQuery, ItemsCabinetQueryVariables>(ItemsCabinetDocument, options);
        }
export function useItemsCabinetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ItemsCabinetQuery, ItemsCabinetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItemsCabinetQuery, ItemsCabinetQueryVariables>(ItemsCabinetDocument, options);
        }
export type ItemsCabinetQueryHookResult = ReturnType<typeof useItemsCabinetQuery>;
export type ItemsCabinetLazyQueryHookResult = ReturnType<typeof useItemsCabinetLazyQuery>;
export type ItemsCabinetSuspenseQueryHookResult = ReturnType<typeof useItemsCabinetSuspenseQuery>;
export type ItemsCabinetQueryResult = Apollo.QueryResult<ItemsCabinetQuery, ItemsCabinetQueryVariables>;
export const PageCabinetBlockItemPublicDocument = gql`
    query PageCabinetBlockItemPublic($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageCabinetBlockItem {
      id
      cabinetName
      cabinetPosition {
        name
      }
      description
      cabinetDescription
      cabinetImage {
        downloadUrl
        id
        createdAt
        updatedAt
        deletedAt
        downloadUrl
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
    }
  }
}
    `;

/**
 * __usePageCabinetBlockItemPublicQuery__
 *
 * To run a query within a React component, call `usePageCabinetBlockItemPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCabinetBlockItemPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCabinetBlockItemPublicQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageCabinetBlockItemPublicQuery(baseOptions: Apollo.QueryHookOptions<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>(PageCabinetBlockItemPublicDocument, options);
      }
export function usePageCabinetBlockItemPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>(PageCabinetBlockItemPublicDocument, options);
        }
export function usePageCabinetBlockItemPublicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>(PageCabinetBlockItemPublicDocument, options);
        }
export type PageCabinetBlockItemPublicQueryHookResult = ReturnType<typeof usePageCabinetBlockItemPublicQuery>;
export type PageCabinetBlockItemPublicLazyQueryHookResult = ReturnType<typeof usePageCabinetBlockItemPublicLazyQuery>;
export type PageCabinetBlockItemPublicSuspenseQueryHookResult = ReturnType<typeof usePageCabinetBlockItemPublicSuspenseQuery>;
export type PageCabinetBlockItemPublicQueryResult = Apollo.QueryResult<PageCabinetBlockItemPublicQuery, PageCabinetBlockItemPublicQueryVariables>;
export const UpdatePageBlockCustomPageBlockDocument = gql`
    mutation UpdatePageBlockCustomPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageCustomBlock {
      id
    }
  }
}
    `;
export type UpdatePageBlockCustomPageBlockMutationFn = Apollo.MutationFunction<UpdatePageBlockCustomPageBlockMutation, UpdatePageBlockCustomPageBlockMutationVariables>;

/**
 * __useUpdatePageBlockCustomPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockCustomPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockCustomPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockCustomPageBlockMutation, { data, loading, error }] = useUpdatePageBlockCustomPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockCustomPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockCustomPageBlockMutation, UpdatePageBlockCustomPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockCustomPageBlockMutation, UpdatePageBlockCustomPageBlockMutationVariables>(UpdatePageBlockCustomPageBlockDocument, options);
      }
export type UpdatePageBlockCustomPageBlockMutationHookResult = ReturnType<typeof useUpdatePageBlockCustomPageBlockMutation>;
export type UpdatePageBlockCustomPageBlockMutationResult = Apollo.MutationResult<UpdatePageBlockCustomPageBlockMutation>;
export type UpdatePageBlockCustomPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockCustomPageBlockMutation, UpdatePageBlockCustomPageBlockMutationVariables>;
export const GetCustomPageDocument = gql`
    query GetCustomPage($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageCustomBlock {
      id
      blockTitle
      publicDescription
      showDescription
      showTitle
      canBeDisabled
      content
      createdAt
      deletedAt
      isDisabled
      description
      location
      orderIndex
      pageBlockStyle
      subPages
      type
      updatedAt
    }
  }
}
    `;

/**
 * __useGetCustomPageQuery__
 *
 * To run a query within a React component, call `useGetCustomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomPageQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetCustomPageQuery(baseOptions: Apollo.QueryHookOptions<GetCustomPageQuery, GetCustomPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomPageQuery, GetCustomPageQueryVariables>(GetCustomPageDocument, options);
      }
export function useGetCustomPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomPageQuery, GetCustomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomPageQuery, GetCustomPageQueryVariables>(GetCustomPageDocument, options);
        }
export function useGetCustomPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomPageQuery, GetCustomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomPageQuery, GetCustomPageQueryVariables>(GetCustomPageDocument, options);
        }
export type GetCustomPageQueryHookResult = ReturnType<typeof useGetCustomPageQuery>;
export type GetCustomPageLazyQueryHookResult = ReturnType<typeof useGetCustomPageLazyQuery>;
export type GetCustomPageSuspenseQueryHookResult = ReturnType<typeof useGetCustomPageSuspenseQuery>;
export type GetCustomPageQueryResult = Apollo.QueryResult<GetCustomPageQuery, GetCustomPageQueryVariables>;
export const UpdatePageEventsBlockDocument = gql`
    mutation UpdatePageEventsBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageEventsBlock {
      id
    }
  }
}
    `;
export type UpdatePageEventsBlockMutationFn = Apollo.MutationFunction<UpdatePageEventsBlockMutation, UpdatePageEventsBlockMutationVariables>;

/**
 * __useUpdatePageEventsBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageEventsBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageEventsBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageEventsBlockMutation, { data, loading, error }] = useUpdatePageEventsBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageEventsBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageEventsBlockMutation, UpdatePageEventsBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageEventsBlockMutation, UpdatePageEventsBlockMutationVariables>(UpdatePageEventsBlockDocument, options);
      }
export type UpdatePageEventsBlockMutationHookResult = ReturnType<typeof useUpdatePageEventsBlockMutation>;
export type UpdatePageEventsBlockMutationResult = Apollo.MutationResult<UpdatePageEventsBlockMutation>;
export type UpdatePageEventsBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageEventsBlockMutation, UpdatePageEventsBlockMutationVariables>;
export const GetPageEventsBlockDocument = gql`
    query GetPageEventsBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageEventsBlock {
      id
      description
      publicDescription
      showDescription
      showTitle
      pageBlockStyle
      eventDescription
      eventTitle
      global
      hasDependencyFilter
      includeSharedContent
      contentSchema {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPageEventsBlockQuery__
 *
 * To run a query within a React component, call `useGetPageEventsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageEventsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageEventsBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageEventsBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>(GetPageEventsBlockDocument, options);
      }
export function useGetPageEventsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>(GetPageEventsBlockDocument, options);
        }
export function useGetPageEventsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>(GetPageEventsBlockDocument, options);
        }
export type GetPageEventsBlockQueryHookResult = ReturnType<typeof useGetPageEventsBlockQuery>;
export type GetPageEventsBlockLazyQueryHookResult = ReturnType<typeof useGetPageEventsBlockLazyQuery>;
export type GetPageEventsBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageEventsBlockSuspenseQuery>;
export type GetPageEventsBlockQueryResult = Apollo.QueryResult<GetPageEventsBlockQuery, GetPageEventsBlockQueryVariables>;
export const PageEventsBlockDocument = gql`
    query pageEventsBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      seeMoreLink
      subPages
      events {
        id
        multimediaType
        createdAt
        eventItemTitle
        eventItemDescription
        descriptionPlace
        summary
        startDate
        endDate
        latitude
        longitude
        address
        eventStatus
        image {
          id
          url
          downloadUrl
          __typename
        }
        link
        shareLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageEventsBlockQuery__
 *
 * To run a query within a React component, call `usePageEventsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageEventsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageEventsBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageEventsBlockQuery(baseOptions: Apollo.QueryHookOptions<PageEventsBlockQuery, PageEventsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageEventsBlockQuery, PageEventsBlockQueryVariables>(PageEventsBlockDocument, options);
      }
export function usePageEventsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageEventsBlockQuery, PageEventsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageEventsBlockQuery, PageEventsBlockQueryVariables>(PageEventsBlockDocument, options);
        }
export function usePageEventsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageEventsBlockQuery, PageEventsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageEventsBlockQuery, PageEventsBlockQueryVariables>(PageEventsBlockDocument, options);
        }
export type PageEventsBlockQueryHookResult = ReturnType<typeof usePageEventsBlockQuery>;
export type PageEventsBlockLazyQueryHookResult = ReturnType<typeof usePageEventsBlockLazyQuery>;
export type PageEventsBlockSuspenseQueryHookResult = ReturnType<typeof usePageEventsBlockSuspenseQuery>;
export type PageEventsBlockQueryResult = Apollo.QueryResult<PageEventsBlockQuery, PageEventsBlockQueryVariables>;
export const EventsItemsFilteredDocument = gql`
    query EventsItemsFiltered($orderBy: [FilterEventOrderBy!], $where: FilterEventWhere, $pagination: Pagination, $dependencyId: ID, $contentSchemaId: ID, $tags: [String!]) {
  eventsItemsFiltered(orderBy: $orderBy, where: $where, pagination: $pagination, dependencyId: $dependencyId, contentSchemaId: $contentSchemaId, tags: $tags) {
    address
    multimediaType
    eventItemTitle
    createdAt
    id
    image {
      id
    }
    latitude
    linkItem {
      id
      url
    }
    longitude
    startDate
    shareLink
    seeMore
    summary
    descriptionPlace
    endDate
  }
}
    `;

/**
 * __useEventsItemsFilteredQuery__
 *
 * To run a query within a React component, call `useEventsItemsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsItemsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsItemsFilteredQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      dependencyId: // value for 'dependencyId'
 *      contentSchemaId: // value for 'contentSchemaId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEventsItemsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>(EventsItemsFilteredDocument, options);
      }
export function useEventsItemsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>(EventsItemsFilteredDocument, options);
        }
export function useEventsItemsFilteredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>(EventsItemsFilteredDocument, options);
        }
export type EventsItemsFilteredQueryHookResult = ReturnType<typeof useEventsItemsFilteredQuery>;
export type EventsItemsFilteredLazyQueryHookResult = ReturnType<typeof useEventsItemsFilteredLazyQuery>;
export type EventsItemsFilteredSuspenseQueryHookResult = ReturnType<typeof useEventsItemsFilteredSuspenseQuery>;
export type EventsItemsFilteredQueryResult = Apollo.QueryResult<EventsItemsFilteredQuery, EventsItemsFilteredQueryVariables>;
export const PageHeaderBarDocument = gql`
    query PageHeaderBar($versionId: ID!, $locations: [BlockLocation!]!) {
  pageBlocks(versionId: $versionId, locations: $locations) {
    ... on PageHeaderBar {
      govcoLink {
        id
        url
        arguments
        routeNavigation
        routeType
        target
        updatedAt
      }
      signinName
      signupName
      hasSignin
      hasSearchbar
      hasLanguageIcon
      hasGovcoLogo
      description
      subPages
      hasSignup
    }
  }
}
    `;

/**
 * __usePageHeaderBarQuery__
 *
 * To run a query within a React component, call `usePageHeaderBarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageHeaderBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageHeaderBarQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function usePageHeaderBarQuery(baseOptions: Apollo.QueryHookOptions<PageHeaderBarQuery, PageHeaderBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageHeaderBarQuery, PageHeaderBarQueryVariables>(PageHeaderBarDocument, options);
      }
export function usePageHeaderBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageHeaderBarQuery, PageHeaderBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageHeaderBarQuery, PageHeaderBarQueryVariables>(PageHeaderBarDocument, options);
        }
export function usePageHeaderBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageHeaderBarQuery, PageHeaderBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageHeaderBarQuery, PageHeaderBarQueryVariables>(PageHeaderBarDocument, options);
        }
export type PageHeaderBarQueryHookResult = ReturnType<typeof usePageHeaderBarQuery>;
export type PageHeaderBarLazyQueryHookResult = ReturnType<typeof usePageHeaderBarLazyQuery>;
export type PageHeaderBarSuspenseQueryHookResult = ReturnType<typeof usePageHeaderBarSuspenseQuery>;
export type PageHeaderBarQueryResult = Apollo.QueryResult<PageHeaderBarQuery, PageHeaderBarQueryVariables>;
export const UpdatePageBlockHeaderBarDocument = gql`
    mutation UpdatePageBlockHeaderBar($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageHeaderBar {
      hasSignup
      id
      hasSignin
      hasSearchbar
      signinName
      signupName
      hasLanguageIcon
      hasGovcoLogo
      govcoLink {
        url
        arguments
        routeNavigation
        routeType
        target
        updatedAt
      }
      version {
        id
        description
        state
        theme
      }
    }
  }
}
    `;
export type UpdatePageBlockHeaderBarMutationFn = Apollo.MutationFunction<UpdatePageBlockHeaderBarMutation, UpdatePageBlockHeaderBarMutationVariables>;

/**
 * __useUpdatePageBlockHeaderBarMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockHeaderBarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockHeaderBarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockHeaderBarMutation, { data, loading, error }] = useUpdatePageBlockHeaderBarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockHeaderBarMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockHeaderBarMutation, UpdatePageBlockHeaderBarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockHeaderBarMutation, UpdatePageBlockHeaderBarMutationVariables>(UpdatePageBlockHeaderBarDocument, options);
      }
export type UpdatePageBlockHeaderBarMutationHookResult = ReturnType<typeof useUpdatePageBlockHeaderBarMutation>;
export type UpdatePageBlockHeaderBarMutationResult = Apollo.MutationResult<UpdatePageBlockHeaderBarMutation>;
export type UpdatePageBlockHeaderBarMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockHeaderBarMutation, UpdatePageBlockHeaderBarMutationVariables>;
export const GetOrganizationBarDetailDocument = gql`
    query GetOrganizationBarDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageHeaderOrganizationBar {
      id
      title
      subtitle
      logoImage {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      logoImageLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
      adminOtherLogo {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      adminAnotherLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
      administrationLogo {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      adminLogoLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationBarDetailQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBarDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBarDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBarDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetOrganizationBarDetailQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>(GetOrganizationBarDetailDocument, options);
      }
export function useGetOrganizationBarDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>(GetOrganizationBarDetailDocument, options);
        }
export function useGetOrganizationBarDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>(GetOrganizationBarDetailDocument, options);
        }
export type GetOrganizationBarDetailQueryHookResult = ReturnType<typeof useGetOrganizationBarDetailQuery>;
export type GetOrganizationBarDetailLazyQueryHookResult = ReturnType<typeof useGetOrganizationBarDetailLazyQuery>;
export type GetOrganizationBarDetailSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationBarDetailSuspenseQuery>;
export type GetOrganizationBarDetailQueryResult = Apollo.QueryResult<GetOrganizationBarDetailQuery, GetOrganizationBarDetailQueryVariables>;
export const UpdateHeaderOrganizationBlockDocument = gql`
    mutation UpdateHeaderOrganizationBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageHeaderOrganizationBar {
      id
    }
  }
}
    `;
export type UpdateHeaderOrganizationBlockMutationFn = Apollo.MutationFunction<UpdateHeaderOrganizationBlockMutation, UpdateHeaderOrganizationBlockMutationVariables>;

/**
 * __useUpdateHeaderOrganizationBlockMutation__
 *
 * To run a mutation, you first call `useUpdateHeaderOrganizationBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeaderOrganizationBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeaderOrganizationBlockMutation, { data, loading, error }] = useUpdateHeaderOrganizationBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHeaderOrganizationBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHeaderOrganizationBlockMutation, UpdateHeaderOrganizationBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHeaderOrganizationBlockMutation, UpdateHeaderOrganizationBlockMutationVariables>(UpdateHeaderOrganizationBlockDocument, options);
      }
export type UpdateHeaderOrganizationBlockMutationHookResult = ReturnType<typeof useUpdateHeaderOrganizationBlockMutation>;
export type UpdateHeaderOrganizationBlockMutationResult = Apollo.MutationResult<UpdateHeaderOrganizationBlockMutation>;
export type UpdateHeaderOrganizationBlockMutationOptions = Apollo.BaseMutationOptions<UpdateHeaderOrganizationBlockMutation, UpdateHeaderOrganizationBlockMutationVariables>;
export const UpdatePageMapBlockDocument = gql`
    mutation UpdatePageMapBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageMapBlock {
      id
    }
  }
}
    `;
export type UpdatePageMapBlockMutationFn = Apollo.MutationFunction<UpdatePageMapBlockMutation, UpdatePageMapBlockMutationVariables>;

/**
 * __useUpdatePageMapBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageMapBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMapBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMapBlockMutation, { data, loading, error }] = useUpdatePageMapBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageMapBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMapBlockMutation, UpdatePageMapBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMapBlockMutation, UpdatePageMapBlockMutationVariables>(UpdatePageMapBlockDocument, options);
      }
export type UpdatePageMapBlockMutationHookResult = ReturnType<typeof useUpdatePageMapBlockMutation>;
export type UpdatePageMapBlockMutationResult = Apollo.MutationResult<UpdatePageMapBlockMutation>;
export type UpdatePageMapBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageMapBlockMutation, UpdatePageMapBlockMutationVariables>;
export const PageMapBlockDocument = gql`
    query PageMapBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageMapBlock {
      id
      mapType
      geoJsonData
      elementsConfig
      departmentCode
      height
      initialZoom
      centerCoordinates
      defaultFillColor
      defaultBorderColor
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showDescription
      showTitle
      isDisabled
      canBeDisabled
      orderIndex
      type
    }
  }
}
    `;

/**
 * __usePageMapBlockQuery__
 *
 * To run a query within a React component, call `usePageMapBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageMapBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageMapBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageMapBlockQuery(baseOptions: Apollo.QueryHookOptions<PageMapBlockQuery, PageMapBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageMapBlockQuery, PageMapBlockQueryVariables>(PageMapBlockDocument, options);
      }
export function usePageMapBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageMapBlockQuery, PageMapBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageMapBlockQuery, PageMapBlockQueryVariables>(PageMapBlockDocument, options);
        }
export function usePageMapBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageMapBlockQuery, PageMapBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageMapBlockQuery, PageMapBlockQueryVariables>(PageMapBlockDocument, options);
        }
export type PageMapBlockQueryHookResult = ReturnType<typeof usePageMapBlockQuery>;
export type PageMapBlockLazyQueryHookResult = ReturnType<typeof usePageMapBlockLazyQuery>;
export type PageMapBlockSuspenseQueryHookResult = ReturnType<typeof usePageMapBlockSuspenseQuery>;
export type PageMapBlockQueryResult = Apollo.QueryResult<PageMapBlockQuery, PageMapBlockQueryVariables>;
export const UpdatePageNavigationBarBlockDocument = gql`
    mutation UpdatePageNavigationBarBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageNavigationBar {
      id
    }
  }
}
    `;
export type UpdatePageNavigationBarBlockMutationFn = Apollo.MutationFunction<UpdatePageNavigationBarBlockMutation, UpdatePageNavigationBarBlockMutationVariables>;

/**
 * __useUpdatePageNavigationBarBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageNavigationBarBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageNavigationBarBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageNavigationBarBlockMutation, { data, loading, error }] = useUpdatePageNavigationBarBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageNavigationBarBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageNavigationBarBlockMutation, UpdatePageNavigationBarBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageNavigationBarBlockMutation, UpdatePageNavigationBarBlockMutationVariables>(UpdatePageNavigationBarBlockDocument, options);
      }
export type UpdatePageNavigationBarBlockMutationHookResult = ReturnType<typeof useUpdatePageNavigationBarBlockMutation>;
export type UpdatePageNavigationBarBlockMutationResult = Apollo.MutationResult<UpdatePageNavigationBarBlockMutation>;
export type UpdatePageNavigationBarBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageNavigationBarBlockMutation, UpdatePageNavigationBarBlockMutationVariables>;
export const NavigationBarDetailDocument = gql`
    query NavigationBarDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageNavigationBar {
      id
      location
      description
      canBeDisabled
      pageBlockStyle
      rootItem {
        id
        name
        lft
        rgt
        depth
      }
      type
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useNavigationBarDetailQuery__
 *
 * To run a query within a React component, call `useNavigationBarDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationBarDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationBarDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useNavigationBarDetailQuery(baseOptions: Apollo.QueryHookOptions<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>(NavigationBarDetailDocument, options);
      }
export function useNavigationBarDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>(NavigationBarDetailDocument, options);
        }
export function useNavigationBarDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>(NavigationBarDetailDocument, options);
        }
export type NavigationBarDetailQueryHookResult = ReturnType<typeof useNavigationBarDetailQuery>;
export type NavigationBarDetailLazyQueryHookResult = ReturnType<typeof useNavigationBarDetailLazyQuery>;
export type NavigationBarDetailSuspenseQueryHookResult = ReturnType<typeof useNavigationBarDetailSuspenseQuery>;
export type NavigationBarDetailQueryResult = Apollo.QueryResult<NavigationBarDetailQuery, NavigationBarDetailQueryVariables>;
export const CreateNavigationBarItemDocument = gql`
    mutation CreateNavigationBarItem($input: CreateNavigationItemInput!) {
  createNavItem(createInput: $input) {
    ... on NavigationItem {
      id
      createdAt
      updatedAt
      deletedAt
      name
      description
      link
      orderIndex
      type
    }
  }
}
    `;
export type CreateNavigationBarItemMutationFn = Apollo.MutationFunction<CreateNavigationBarItemMutation, CreateNavigationBarItemMutationVariables>;

/**
 * __useCreateNavigationBarItemMutation__
 *
 * To run a mutation, you first call `useCreateNavigationBarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNavigationBarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNavigationBarItemMutation, { data, loading, error }] = useCreateNavigationBarItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNavigationBarItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateNavigationBarItemMutation, CreateNavigationBarItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNavigationBarItemMutation, CreateNavigationBarItemMutationVariables>(CreateNavigationBarItemDocument, options);
      }
export type CreateNavigationBarItemMutationHookResult = ReturnType<typeof useCreateNavigationBarItemMutation>;
export type CreateNavigationBarItemMutationResult = Apollo.MutationResult<CreateNavigationBarItemMutation>;
export type CreateNavigationBarItemMutationOptions = Apollo.BaseMutationOptions<CreateNavigationBarItemMutation, CreateNavigationBarItemMutationVariables>;
export const UpdateNavigationBarItemDocument = gql`
    mutation UpdateNavigationBarItem($updateInput: UpdateNavigationItemInput!) {
  updateNavItem(updateInput: $updateInput) {
    id
  }
}
    `;
export type UpdateNavigationBarItemMutationFn = Apollo.MutationFunction<UpdateNavigationBarItemMutation, UpdateNavigationBarItemMutationVariables>;

/**
 * __useUpdateNavigationBarItemMutation__
 *
 * To run a mutation, you first call `useUpdateNavigationBarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavigationBarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavigationBarItemMutation, { data, loading, error }] = useUpdateNavigationBarItemMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateNavigationBarItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNavigationBarItemMutation, UpdateNavigationBarItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNavigationBarItemMutation, UpdateNavigationBarItemMutationVariables>(UpdateNavigationBarItemDocument, options);
      }
export type UpdateNavigationBarItemMutationHookResult = ReturnType<typeof useUpdateNavigationBarItemMutation>;
export type UpdateNavigationBarItemMutationResult = Apollo.MutationResult<UpdateNavigationBarItemMutation>;
export type UpdateNavigationBarItemMutationOptions = Apollo.BaseMutationOptions<UpdateNavigationBarItemMutation, UpdateNavigationBarItemMutationVariables>;
export const GetNavigationBarItemDocument = gql`
    query GetNavigationBarItem($navItemId: ID!) {
  navItem(id: $navItemId) {
    id
    name
    orderIndex
    parent {
      id
      name
      orderIndex
    }
    linkItem {
      id
      routeType
      routeNavigation
      target
      arguments
      url
    }
    children {
      id
      createdAt
      updatedAt
      name
      link
      orderIndex
    }
    icon {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      downloadUrl
      url
    }
    signLanguageGif {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      downloadUrl
      url
    }
  }
}
    `;

/**
 * __useGetNavigationBarItemQuery__
 *
 * To run a query within a React component, call `useGetNavigationBarItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationBarItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationBarItemQuery({
 *   variables: {
 *      navItemId: // value for 'navItemId'
 *   },
 * });
 */
export function useGetNavigationBarItemQuery(baseOptions: Apollo.QueryHookOptions<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>(GetNavigationBarItemDocument, options);
      }
export function useGetNavigationBarItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>(GetNavigationBarItemDocument, options);
        }
export function useGetNavigationBarItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>(GetNavigationBarItemDocument, options);
        }
export type GetNavigationBarItemQueryHookResult = ReturnType<typeof useGetNavigationBarItemQuery>;
export type GetNavigationBarItemLazyQueryHookResult = ReturnType<typeof useGetNavigationBarItemLazyQuery>;
export type GetNavigationBarItemSuspenseQueryHookResult = ReturnType<typeof useGetNavigationBarItemSuspenseQuery>;
export type GetNavigationBarItemQueryResult = Apollo.QueryResult<GetNavigationBarItemQuery, GetNavigationBarItemQueryVariables>;
export const RemoveNavigationBarItemDocument = gql`
    mutation RemoveNavigationBarItem($removeNavItemId: ID!) {
  removeNavItem(id: $removeNavItemId) {
    id
  }
}
    `;
export type RemoveNavigationBarItemMutationFn = Apollo.MutationFunction<RemoveNavigationBarItemMutation, RemoveNavigationBarItemMutationVariables>;

/**
 * __useRemoveNavigationBarItemMutation__
 *
 * To run a mutation, you first call `useRemoveNavigationBarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNavigationBarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNavigationBarItemMutation, { data, loading, error }] = useRemoveNavigationBarItemMutation({
 *   variables: {
 *      removeNavItemId: // value for 'removeNavItemId'
 *   },
 * });
 */
export function useRemoveNavigationBarItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNavigationBarItemMutation, RemoveNavigationBarItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNavigationBarItemMutation, RemoveNavigationBarItemMutationVariables>(RemoveNavigationBarItemDocument, options);
      }
export type RemoveNavigationBarItemMutationHookResult = ReturnType<typeof useRemoveNavigationBarItemMutation>;
export type RemoveNavigationBarItemMutationResult = Apollo.MutationResult<RemoveNavigationBarItemMutation>;
export type RemoveNavigationBarItemMutationOptions = Apollo.BaseMutationOptions<RemoveNavigationBarItemMutation, RemoveNavigationBarItemMutationVariables>;
export const UpdateNavigationItemOrdersDocument = gql`
    mutation UpdateNavigationItemOrders($input: [UpdateNavigationItemInput!]!) {
  updateNavigationItemOrders(input: $input) {
    id
    name
    orderIndex
  }
}
    `;
export type UpdateNavigationItemOrdersMutationFn = Apollo.MutationFunction<UpdateNavigationItemOrdersMutation, UpdateNavigationItemOrdersMutationVariables>;

/**
 * __useUpdateNavigationItemOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateNavigationItemOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavigationItemOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavigationItemOrdersMutation, { data, loading, error }] = useUpdateNavigationItemOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNavigationItemOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNavigationItemOrdersMutation, UpdateNavigationItemOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNavigationItemOrdersMutation, UpdateNavigationItemOrdersMutationVariables>(UpdateNavigationItemOrdersDocument, options);
      }
export type UpdateNavigationItemOrdersMutationHookResult = ReturnType<typeof useUpdateNavigationItemOrdersMutation>;
export type UpdateNavigationItemOrdersMutationResult = Apollo.MutationResult<UpdateNavigationItemOrdersMutation>;
export type UpdateNavigationItemOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateNavigationItemOrdersMutation, UpdateNavigationItemOrdersMutationVariables>;
export const MoveNavigationItemDocument = gql`
    mutation MoveNavigationItem($input: MoveNavigationItemInput!) {
  moveNavigationItem(input: $input) {
    id
    name
    orderIndex
    depth
    lft
    rgt
    type
  }
}
    `;
export type MoveNavigationItemMutationFn = Apollo.MutationFunction<MoveNavigationItemMutation, MoveNavigationItemMutationVariables>;

/**
 * __useMoveNavigationItemMutation__
 *
 * To run a mutation, you first call `useMoveNavigationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveNavigationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveNavigationItemMutation, { data, loading, error }] = useMoveNavigationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveNavigationItemMutation(baseOptions?: Apollo.MutationHookOptions<MoveNavigationItemMutation, MoveNavigationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveNavigationItemMutation, MoveNavigationItemMutationVariables>(MoveNavigationItemDocument, options);
      }
export type MoveNavigationItemMutationHookResult = ReturnType<typeof useMoveNavigationItemMutation>;
export type MoveNavigationItemMutationResult = Apollo.MutationResult<MoveNavigationItemMutation>;
export type MoveNavigationItemMutationOptions = Apollo.BaseMutationOptions<MoveNavigationItemMutation, MoveNavigationItemMutationVariables>;
export const RebuildNavigationNestedSetDocument = gql`
    mutation RebuildNavigationNestedSet($navigationBarId: ID!) {
  rebuildNavigationNestedSet(navigationBarId: $navigationBarId) {
    dryRun
    itemsWithChanges
    totalItems
    preview {
      id
      name
      hasChanges
      currentLft
      currentRgt
      currentDepth
      newLft
      newRgt
      newDepth
    }
  }
}
    `;
export type RebuildNavigationNestedSetMutationFn = Apollo.MutationFunction<RebuildNavigationNestedSetMutation, RebuildNavigationNestedSetMutationVariables>;

/**
 * __useRebuildNavigationNestedSetMutation__
 *
 * To run a mutation, you first call `useRebuildNavigationNestedSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRebuildNavigationNestedSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rebuildNavigationNestedSetMutation, { data, loading, error }] = useRebuildNavigationNestedSetMutation({
 *   variables: {
 *      navigationBarId: // value for 'navigationBarId'
 *   },
 * });
 */
export function useRebuildNavigationNestedSetMutation(baseOptions?: Apollo.MutationHookOptions<RebuildNavigationNestedSetMutation, RebuildNavigationNestedSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RebuildNavigationNestedSetMutation, RebuildNavigationNestedSetMutationVariables>(RebuildNavigationNestedSetDocument, options);
      }
export type RebuildNavigationNestedSetMutationHookResult = ReturnType<typeof useRebuildNavigationNestedSetMutation>;
export type RebuildNavigationNestedSetMutationResult = Apollo.MutationResult<RebuildNavigationNestedSetMutation>;
export type RebuildNavigationNestedSetMutationOptions = Apollo.BaseMutationOptions<RebuildNavigationNestedSetMutation, RebuildNavigationNestedSetMutationVariables>;
export const GetNavigationItemDescendantsDocument = gql`
    query GetNavigationItemDescendants($itemId: ID!) {
  navigationItemDescendants(itemId: $itemId) {
    id
    name
    description
    depth
    lft
    rgt
    orderIndex
    type
  }
}
    `;

/**
 * __useGetNavigationItemDescendantsQuery__
 *
 * To run a query within a React component, call `useGetNavigationItemDescendantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationItemDescendantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationItemDescendantsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetNavigationItemDescendantsQuery(baseOptions: Apollo.QueryHookOptions<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>(GetNavigationItemDescendantsDocument, options);
      }
export function useGetNavigationItemDescendantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>(GetNavigationItemDescendantsDocument, options);
        }
export function useGetNavigationItemDescendantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>(GetNavigationItemDescendantsDocument, options);
        }
export type GetNavigationItemDescendantsQueryHookResult = ReturnType<typeof useGetNavigationItemDescendantsQuery>;
export type GetNavigationItemDescendantsLazyQueryHookResult = ReturnType<typeof useGetNavigationItemDescendantsLazyQuery>;
export type GetNavigationItemDescendantsSuspenseQueryHookResult = ReturnType<typeof useGetNavigationItemDescendantsSuspenseQuery>;
export type GetNavigationItemDescendantsQueryResult = Apollo.QueryResult<GetNavigationItemDescendantsQuery, GetNavigationItemDescendantsQueryVariables>;
export const GetNavigationItemAncestorsDocument = gql`
    query GetNavigationItemAncestors($itemId: ID!) {
  navigationItemAncestors(itemId: $itemId) {
    id
    name
    depth
    lft
    rgt
  }
}
    `;

/**
 * __useGetNavigationItemAncestorsQuery__
 *
 * To run a query within a React component, call `useGetNavigationItemAncestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationItemAncestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationItemAncestorsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetNavigationItemAncestorsQuery(baseOptions: Apollo.QueryHookOptions<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>(GetNavigationItemAncestorsDocument, options);
      }
export function useGetNavigationItemAncestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>(GetNavigationItemAncestorsDocument, options);
        }
export function useGetNavigationItemAncestorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>(GetNavigationItemAncestorsDocument, options);
        }
export type GetNavigationItemAncestorsQueryHookResult = ReturnType<typeof useGetNavigationItemAncestorsQuery>;
export type GetNavigationItemAncestorsLazyQueryHookResult = ReturnType<typeof useGetNavigationItemAncestorsLazyQuery>;
export type GetNavigationItemAncestorsSuspenseQueryHookResult = ReturnType<typeof useGetNavigationItemAncestorsSuspenseQuery>;
export type GetNavigationItemAncestorsQueryResult = Apollo.QueryResult<GetNavigationItemAncestorsQuery, GetNavigationItemAncestorsQueryVariables>;
export const UpdatePageNewsletterBlockDocument = gql`
    mutation UpdatePageNewsletterBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageNewsletterBlock {
      id
    }
  }
}
    `;
export type UpdatePageNewsletterBlockMutationFn = Apollo.MutationFunction<UpdatePageNewsletterBlockMutation, UpdatePageNewsletterBlockMutationVariables>;

/**
 * __useUpdatePageNewsletterBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageNewsletterBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageNewsletterBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageNewsletterBlockMutation, { data, loading, error }] = useUpdatePageNewsletterBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageNewsletterBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageNewsletterBlockMutation, UpdatePageNewsletterBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageNewsletterBlockMutation, UpdatePageNewsletterBlockMutationVariables>(UpdatePageNewsletterBlockDocument, options);
      }
export type UpdatePageNewsletterBlockMutationHookResult = ReturnType<typeof useUpdatePageNewsletterBlockMutation>;
export type UpdatePageNewsletterBlockMutationResult = Apollo.MutationResult<UpdatePageNewsletterBlockMutation>;
export type UpdatePageNewsletterBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageNewsletterBlockMutation, UpdatePageNewsletterBlockMutationVariables>;
export const GetPageNewsletterBlockDocument = gql`
    query GetPageNewsletterBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageNewsletterBlock {
      id
      global
      description
      publicDescription
      showDescription
      showTitle
      pageBlockStyle
      newsletterTitle
      newsletterDescription
      hasDependencyFilter
      includeSharedContent
      contentSchema {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPageNewsletterBlockQuery__
 *
 * To run a query within a React component, call `useGetPageNewsletterBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageNewsletterBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageNewsletterBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageNewsletterBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>(GetPageNewsletterBlockDocument, options);
      }
export function useGetPageNewsletterBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>(GetPageNewsletterBlockDocument, options);
        }
export function useGetPageNewsletterBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>(GetPageNewsletterBlockDocument, options);
        }
export type GetPageNewsletterBlockQueryHookResult = ReturnType<typeof useGetPageNewsletterBlockQuery>;
export type GetPageNewsletterBlockLazyQueryHookResult = ReturnType<typeof useGetPageNewsletterBlockLazyQuery>;
export type GetPageNewsletterBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageNewsletterBlockSuspenseQuery>;
export type GetPageNewsletterBlockQueryResult = Apollo.QueryResult<GetPageNewsletterBlockQuery, GetPageNewsletterBlockQueryVariables>;
export const PageNewsletterBlockDocument = gql`
    query pageNewsletterBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      news {
        id
        link
        updatedAt
        createdAt
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        title
        summary
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageNewsletterBlockQuery__
 *
 * To run a query within a React component, call `usePageNewsletterBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageNewsletterBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageNewsletterBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageNewsletterBlockQuery(baseOptions: Apollo.QueryHookOptions<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>(PageNewsletterBlockDocument, options);
      }
export function usePageNewsletterBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>(PageNewsletterBlockDocument, options);
        }
export function usePageNewsletterBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>(PageNewsletterBlockDocument, options);
        }
export type PageNewsletterBlockQueryHookResult = ReturnType<typeof usePageNewsletterBlockQuery>;
export type PageNewsletterBlockLazyQueryHookResult = ReturnType<typeof usePageNewsletterBlockLazyQuery>;
export type PageNewsletterBlockSuspenseQueryHookResult = ReturnType<typeof usePageNewsletterBlockSuspenseQuery>;
export type PageNewsletterBlockQueryResult = Apollo.QueryResult<PageNewsletterBlockQuery, PageNewsletterBlockQueryVariables>;
export const NewsItemsFilteredDocument = gql`
    query NewsItemsFiltered($dependencyId: ID, $contentSchemaId: ID, $where: FilterNewsWhere, $pagination: Pagination, $orderBy: [FilterNewsOrderBy!]) {
  newsItemsFiltered(dependencyId: $dependencyId, contentSchemaId: $contentSchemaId, where: $where, pagination: $pagination, orderBy: $orderBy) {
    id
    linkItem {
      id
      target
    }
    title
    summary
    createdAt
    updatedAt
    publicationDate
    image {
      id
    }
    seo {
      metadata {
        slug
      }
    }
  }
}
    `;

/**
 * __useNewsItemsFilteredQuery__
 *
 * To run a query within a React component, call `useNewsItemsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemsFilteredQuery({
 *   variables: {
 *      dependencyId: // value for 'dependencyId'
 *      contentSchemaId: // value for 'contentSchemaId'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNewsItemsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>(NewsItemsFilteredDocument, options);
      }
export function useNewsItemsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>(NewsItemsFilteredDocument, options);
        }
export function useNewsItemsFilteredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>(NewsItemsFilteredDocument, options);
        }
export type NewsItemsFilteredQueryHookResult = ReturnType<typeof useNewsItemsFilteredQuery>;
export type NewsItemsFilteredLazyQueryHookResult = ReturnType<typeof useNewsItemsFilteredLazyQuery>;
export type NewsItemsFilteredSuspenseQueryHookResult = ReturnType<typeof useNewsItemsFilteredSuspenseQuery>;
export type NewsItemsFilteredQueryResult = Apollo.QueryResult<NewsItemsFilteredQuery, NewsItemsFilteredQueryVariables>;
export const UpdatePageProceduresBlockDocument = gql`
    mutation UpdatePageProceduresBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageProceduresBlock {
      id
    }
  }
}
    `;
export type UpdatePageProceduresBlockMutationFn = Apollo.MutationFunction<UpdatePageProceduresBlockMutation, UpdatePageProceduresBlockMutationVariables>;

/**
 * __useUpdatePageProceduresBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageProceduresBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageProceduresBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageProceduresBlockMutation, { data, loading, error }] = useUpdatePageProceduresBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageProceduresBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageProceduresBlockMutation, UpdatePageProceduresBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageProceduresBlockMutation, UpdatePageProceduresBlockMutationVariables>(UpdatePageProceduresBlockDocument, options);
      }
export type UpdatePageProceduresBlockMutationHookResult = ReturnType<typeof useUpdatePageProceduresBlockMutation>;
export type UpdatePageProceduresBlockMutationResult = Apollo.MutationResult<UpdatePageProceduresBlockMutation>;
export type UpdatePageProceduresBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageProceduresBlockMutation, UpdatePageProceduresBlockMutationVariables>;
export const GetPageProceduresBlockDocument = gql`
    query GetPageProceduresBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageProceduresBlock {
      id
      description
      publicDescription
      showDescription
      showTitle
      pageBlockStyle
      titleProcedures
      descriptionProcedures
    }
  }
}
    `;

/**
 * __useGetPageProceduresBlockQuery__
 *
 * To run a query within a React component, call `useGetPageProceduresBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageProceduresBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageProceduresBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageProceduresBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>(GetPageProceduresBlockDocument, options);
      }
export function useGetPageProceduresBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>(GetPageProceduresBlockDocument, options);
        }
export function useGetPageProceduresBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>(GetPageProceduresBlockDocument, options);
        }
export type GetPageProceduresBlockQueryHookResult = ReturnType<typeof useGetPageProceduresBlockQuery>;
export type GetPageProceduresBlockLazyQueryHookResult = ReturnType<typeof useGetPageProceduresBlockLazyQuery>;
export type GetPageProceduresBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageProceduresBlockSuspenseQuery>;
export type GetPageProceduresBlockQueryResult = Apollo.QueryResult<GetPageProceduresBlockQuery, GetPageProceduresBlockQueryVariables>;
export const PageProceduresBlockDocument = gql`
    query PageProceduresBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleProcedures
      descriptionProcedures
      seeMoreAction
      seeMoreActionLink
      procedures {
        govcoLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        procedureTypes
        gocvoLogoName
        createdAt
        procedureItemTags
        id
        name
        tagsProcedure
        cost
        duration
        modality
        date
        action
        actionLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageProceduresBlockQuery__
 *
 * To run a query within a React component, call `usePageProceduresBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageProceduresBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageProceduresBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageProceduresBlockQuery(baseOptions: Apollo.QueryHookOptions<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>(PageProceduresBlockDocument, options);
      }
export function usePageProceduresBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>(PageProceduresBlockDocument, options);
        }
export function usePageProceduresBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>(PageProceduresBlockDocument, options);
        }
export type PageProceduresBlockQueryHookResult = ReturnType<typeof usePageProceduresBlockQuery>;
export type PageProceduresBlockLazyQueryHookResult = ReturnType<typeof usePageProceduresBlockLazyQuery>;
export type PageProceduresBlockSuspenseQueryHookResult = ReturnType<typeof usePageProceduresBlockSuspenseQuery>;
export type PageProceduresBlockQueryResult = Apollo.QueryResult<PageProceduresBlockQuery, PageProceduresBlockQueryVariables>;
export const UpdatePageQuickAccessBarBlockDocument = gql`
    mutation UpdatePageQuickAccessBarBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageQuickAccessBar {
      id
    }
  }
}
    `;
export type UpdatePageQuickAccessBarBlockMutationFn = Apollo.MutationFunction<UpdatePageQuickAccessBarBlockMutation, UpdatePageQuickAccessBarBlockMutationVariables>;

/**
 * __useUpdatePageQuickAccessBarBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageQuickAccessBarBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageQuickAccessBarBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageQuickAccessBarBlockMutation, { data, loading, error }] = useUpdatePageQuickAccessBarBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageQuickAccessBarBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageQuickAccessBarBlockMutation, UpdatePageQuickAccessBarBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageQuickAccessBarBlockMutation, UpdatePageQuickAccessBarBlockMutationVariables>(UpdatePageQuickAccessBarBlockDocument, options);
      }
export type UpdatePageQuickAccessBarBlockMutationHookResult = ReturnType<typeof useUpdatePageQuickAccessBarBlockMutation>;
export type UpdatePageQuickAccessBarBlockMutationResult = Apollo.MutationResult<UpdatePageQuickAccessBarBlockMutation>;
export type UpdatePageQuickAccessBarBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageQuickAccessBarBlockMutation, UpdatePageQuickAccessBarBlockMutationVariables>;
export const GetPageQuickAccessBarBlockDocument = gql`
    query GetPageQuickAccessBarBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageQuickAccessBar {
      id
      pageBlockStyle
      blockTitle
    }
  }
}
    `;

/**
 * __useGetPageQuickAccessBarBlockQuery__
 *
 * To run a query within a React component, call `useGetPageQuickAccessBarBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuickAccessBarBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuickAccessBarBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageQuickAccessBarBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>(GetPageQuickAccessBarBlockDocument, options);
      }
export function useGetPageQuickAccessBarBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>(GetPageQuickAccessBarBlockDocument, options);
        }
export function useGetPageQuickAccessBarBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>(GetPageQuickAccessBarBlockDocument, options);
        }
export type GetPageQuickAccessBarBlockQueryHookResult = ReturnType<typeof useGetPageQuickAccessBarBlockQuery>;
export type GetPageQuickAccessBarBlockLazyQueryHookResult = ReturnType<typeof useGetPageQuickAccessBarBlockLazyQuery>;
export type GetPageQuickAccessBarBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageQuickAccessBarBlockSuspenseQuery>;
export type GetPageQuickAccessBarBlockQueryResult = Apollo.QueryResult<GetPageQuickAccessBarBlockQuery, GetPageQuickAccessBarBlockQueryVariables>;
export const QuickAccessBarDetailDocument = gql`
    query QuickAccessBarDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageQuickAccessBar {
      id
      description
      publicDescription
      showDescription
      showTitle
      canBeDisabled
      location
      pageBlockStyle
      blockTitle
      isCarrousel
      color
      itemsPerView
      allItems {
        id
        status
        orderIndex
        description
        quickAccessName
        createdAt
        updatedAt
        image {
          id
          fileMongoId
          fileMode
          fileExtension
          fileName
          url
        }
        linkItem {
          routeType
          target
          url
          routeNavigation
          arguments
        }
      }
    }
  }
}
    `;

/**
 * __useQuickAccessBarDetailQuery__
 *
 * To run a query within a React component, call `useQuickAccessBarDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickAccessBarDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickAccessBarDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useQuickAccessBarDetailQuery(baseOptions: Apollo.QueryHookOptions<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>(QuickAccessBarDetailDocument, options);
      }
export function useQuickAccessBarDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>(QuickAccessBarDetailDocument, options);
        }
export function useQuickAccessBarDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>(QuickAccessBarDetailDocument, options);
        }
export type QuickAccessBarDetailQueryHookResult = ReturnType<typeof useQuickAccessBarDetailQuery>;
export type QuickAccessBarDetailLazyQueryHookResult = ReturnType<typeof useQuickAccessBarDetailLazyQuery>;
export type QuickAccessBarDetailSuspenseQueryHookResult = ReturnType<typeof useQuickAccessBarDetailSuspenseQuery>;
export type QuickAccessBarDetailQueryResult = Apollo.QueryResult<QuickAccessBarDetailQuery, QuickAccessBarDetailQueryVariables>;
export const CreateQuickAccessBarItemDocument = gql`
    mutation CreateQuickAccessBarItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageQuickAccessBarItem {
      id
    }
  }
}
    `;
export type CreateQuickAccessBarItemMutationFn = Apollo.MutationFunction<CreateQuickAccessBarItemMutation, CreateQuickAccessBarItemMutationVariables>;

/**
 * __useCreateQuickAccessBarItemMutation__
 *
 * To run a mutation, you first call `useCreateQuickAccessBarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuickAccessBarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuickAccessBarItemMutation, { data, loading, error }] = useCreateQuickAccessBarItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuickAccessBarItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuickAccessBarItemMutation, CreateQuickAccessBarItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuickAccessBarItemMutation, CreateQuickAccessBarItemMutationVariables>(CreateQuickAccessBarItemDocument, options);
      }
export type CreateQuickAccessBarItemMutationHookResult = ReturnType<typeof useCreateQuickAccessBarItemMutation>;
export type CreateQuickAccessBarItemMutationResult = Apollo.MutationResult<CreateQuickAccessBarItemMutation>;
export type CreateQuickAccessBarItemMutationOptions = Apollo.BaseMutationOptions<CreateQuickAccessBarItemMutation, CreateQuickAccessBarItemMutationVariables>;
export const UpdateQuickAccessBarItemDocument = gql`
    mutation UpdateQuickAccessBarItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageQuickAccessBarItem {
      id
    }
  }
}
    `;
export type UpdateQuickAccessBarItemMutationFn = Apollo.MutationFunction<UpdateQuickAccessBarItemMutation, UpdateQuickAccessBarItemMutationVariables>;

/**
 * __useUpdateQuickAccessBarItemMutation__
 *
 * To run a mutation, you first call `useUpdateQuickAccessBarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickAccessBarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickAccessBarItemMutation, { data, loading, error }] = useUpdateQuickAccessBarItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuickAccessBarItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuickAccessBarItemMutation, UpdateQuickAccessBarItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuickAccessBarItemMutation, UpdateQuickAccessBarItemMutationVariables>(UpdateQuickAccessBarItemDocument, options);
      }
export type UpdateQuickAccessBarItemMutationHookResult = ReturnType<typeof useUpdateQuickAccessBarItemMutation>;
export type UpdateQuickAccessBarItemMutationResult = Apollo.MutationResult<UpdateQuickAccessBarItemMutation>;
export type UpdateQuickAccessBarItemMutationOptions = Apollo.BaseMutationOptions<UpdateQuickAccessBarItemMutation, UpdateQuickAccessBarItemMutationVariables>;
export const GetQuickAccessBarItemDocument = gql`
    query GetQuickAccessBarItem($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageQuickAccessBarItem {
      id
      description
      quickAccessName
      link
      image {
        downloadUrl
        fileExtension
        fileMode
        id
        fileName
        fileMongoId
        url
      }
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetQuickAccessBarItemQuery__
 *
 * To run a query within a React component, call `useGetQuickAccessBarItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickAccessBarItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickAccessBarItemQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetQuickAccessBarItemQuery(baseOptions: Apollo.QueryHookOptions<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>(GetQuickAccessBarItemDocument, options);
      }
export function useGetQuickAccessBarItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>(GetQuickAccessBarItemDocument, options);
        }
export function useGetQuickAccessBarItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>(GetQuickAccessBarItemDocument, options);
        }
export type GetQuickAccessBarItemQueryHookResult = ReturnType<typeof useGetQuickAccessBarItemQuery>;
export type GetQuickAccessBarItemLazyQueryHookResult = ReturnType<typeof useGetQuickAccessBarItemLazyQuery>;
export type GetQuickAccessBarItemSuspenseQueryHookResult = ReturnType<typeof useGetQuickAccessBarItemSuspenseQuery>;
export type GetQuickAccessBarItemQueryResult = Apollo.QueryResult<GetQuickAccessBarItemQuery, GetQuickAccessBarItemQueryVariables>;
export const RemoveQuickAccessBarItemDocument = gql`
    mutation RemoveQuickAccessBarItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageQuickAccessBarItem {
      id
    }
  }
}
    `;
export type RemoveQuickAccessBarItemMutationFn = Apollo.MutationFunction<RemoveQuickAccessBarItemMutation, RemoveQuickAccessBarItemMutationVariables>;

/**
 * __useRemoveQuickAccessBarItemMutation__
 *
 * To run a mutation, you first call `useRemoveQuickAccessBarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuickAccessBarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuickAccessBarItemMutation, { data, loading, error }] = useRemoveQuickAccessBarItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveQuickAccessBarItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQuickAccessBarItemMutation, RemoveQuickAccessBarItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQuickAccessBarItemMutation, RemoveQuickAccessBarItemMutationVariables>(RemoveQuickAccessBarItemDocument, options);
      }
export type RemoveQuickAccessBarItemMutationHookResult = ReturnType<typeof useRemoveQuickAccessBarItemMutation>;
export type RemoveQuickAccessBarItemMutationResult = Apollo.MutationResult<RemoveQuickAccessBarItemMutation>;
export type RemoveQuickAccessBarItemMutationOptions = Apollo.BaseMutationOptions<RemoveQuickAccessBarItemMutation, RemoveQuickAccessBarItemMutationVariables>;
export const PageQuickAccessBarDocument = gql`
    query PageQuickAccessBar($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      isCarrousel
      itemsPerView
      color
      allItems {
        id
        status
        orderIndex
        image {
          downloadUrl
          id
          url
          __typename
        }
        quickAccessName
        description
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageQuickAccessBarQuery__
 *
 * To run a query within a React component, call `usePageQuickAccessBarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuickAccessBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuickAccessBarQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageQuickAccessBarQuery(baseOptions: Apollo.QueryHookOptions<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>(PageQuickAccessBarDocument, options);
      }
export function usePageQuickAccessBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>(PageQuickAccessBarDocument, options);
        }
export function usePageQuickAccessBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>(PageQuickAccessBarDocument, options);
        }
export type PageQuickAccessBarQueryHookResult = ReturnType<typeof usePageQuickAccessBarQuery>;
export type PageQuickAccessBarLazyQueryHookResult = ReturnType<typeof usePageQuickAccessBarLazyQuery>;
export type PageQuickAccessBarSuspenseQueryHookResult = ReturnType<typeof usePageQuickAccessBarSuspenseQuery>;
export type PageQuickAccessBarQueryResult = Apollo.QueryResult<PageQuickAccessBarQuery, PageQuickAccessBarQueryVariables>;
export const UpdatePageRegulationsBlockDocument = gql`
    mutation UpdatePageRegulationsBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageRegulationsBlock {
      id
    }
  }
}
    `;
export type UpdatePageRegulationsBlockMutationFn = Apollo.MutationFunction<UpdatePageRegulationsBlockMutation, UpdatePageRegulationsBlockMutationVariables>;

/**
 * __useUpdatePageRegulationsBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageRegulationsBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageRegulationsBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageRegulationsBlockMutation, { data, loading, error }] = useUpdatePageRegulationsBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageRegulationsBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageRegulationsBlockMutation, UpdatePageRegulationsBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageRegulationsBlockMutation, UpdatePageRegulationsBlockMutationVariables>(UpdatePageRegulationsBlockDocument, options);
      }
export type UpdatePageRegulationsBlockMutationHookResult = ReturnType<typeof useUpdatePageRegulationsBlockMutation>;
export type UpdatePageRegulationsBlockMutationResult = Apollo.MutationResult<UpdatePageRegulationsBlockMutation>;
export type UpdatePageRegulationsBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageRegulationsBlockMutation, UpdatePageRegulationsBlockMutationVariables>;
export const GetPageRegulationsBlockDocument = gql`
    query GetPageRegulationsBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageRegulationsBlock {
      id
      description
      publicDescription
      showDescription
      showTitle
      pageBlockStyle
      titleRegulation
      descriptionRegulation
    }
  }
}
    `;

/**
 * __useGetPageRegulationsBlockQuery__
 *
 * To run a query within a React component, call `useGetPageRegulationsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageRegulationsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageRegulationsBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageRegulationsBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>(GetPageRegulationsBlockDocument, options);
      }
export function useGetPageRegulationsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>(GetPageRegulationsBlockDocument, options);
        }
export function useGetPageRegulationsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>(GetPageRegulationsBlockDocument, options);
        }
export type GetPageRegulationsBlockQueryHookResult = ReturnType<typeof useGetPageRegulationsBlockQuery>;
export type GetPageRegulationsBlockLazyQueryHookResult = ReturnType<typeof useGetPageRegulationsBlockLazyQuery>;
export type GetPageRegulationsBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageRegulationsBlockSuspenseQuery>;
export type GetPageRegulationsBlockQueryResult = Apollo.QueryResult<GetPageRegulationsBlockQuery, GetPageRegulationsBlockQueryVariables>;
export const SlidersCarouselDocument = gql`
    query SlidersCarousel($versionId: ID!, $locations: [BlockLocation!]!) {
  pageBlocks(versionId: $versionId, locations: $locations) {
    ... on PageSliderBlock {
      pageBlockStyle
      sliders {
        id
        title
        link
        alternativeText
        tags
        orderIndex
        linkItem {
          url
          target
          routeType
          routeNavigation
        }
        image {
          id
          url
          fileMode
          fileExtension
          fileName
          deletedAt
          updatedAt
          fileMongoId
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useSlidersCarouselQuery__
 *
 * To run a query within a React component, call `useSlidersCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlidersCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlidersCarouselQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useSlidersCarouselQuery(baseOptions: Apollo.QueryHookOptions<SlidersCarouselQuery, SlidersCarouselQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlidersCarouselQuery, SlidersCarouselQueryVariables>(SlidersCarouselDocument, options);
      }
export function useSlidersCarouselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlidersCarouselQuery, SlidersCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlidersCarouselQuery, SlidersCarouselQueryVariables>(SlidersCarouselDocument, options);
        }
export function useSlidersCarouselSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlidersCarouselQuery, SlidersCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlidersCarouselQuery, SlidersCarouselQueryVariables>(SlidersCarouselDocument, options);
        }
export type SlidersCarouselQueryHookResult = ReturnType<typeof useSlidersCarouselQuery>;
export type SlidersCarouselLazyQueryHookResult = ReturnType<typeof useSlidersCarouselLazyQuery>;
export type SlidersCarouselSuspenseQueryHookResult = ReturnType<typeof useSlidersCarouselSuspenseQuery>;
export type SlidersCarouselQueryResult = Apollo.QueryResult<SlidersCarouselQuery, SlidersCarouselQueryVariables>;
export const SliderItemByIdDocument = gql`
    query SliderItemById($sliderItemId: ID!) {
  sliderItem(id: $sliderItemId) {
    id
    title
    link
    description
    alternativeText
    tags
    linkItem {
      url
      updatedAt
      target
      routeType
      routeNavigation
      arguments
    }
    image {
      id
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
  }
}
    `;

/**
 * __useSliderItemByIdQuery__
 *
 * To run a query within a React component, call `useSliderItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSliderItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSliderItemByIdQuery({
 *   variables: {
 *      sliderItemId: // value for 'sliderItemId'
 *   },
 * });
 */
export function useSliderItemByIdQuery(baseOptions: Apollo.QueryHookOptions<SliderItemByIdQuery, SliderItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SliderItemByIdQuery, SliderItemByIdQueryVariables>(SliderItemByIdDocument, options);
      }
export function useSliderItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SliderItemByIdQuery, SliderItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SliderItemByIdQuery, SliderItemByIdQueryVariables>(SliderItemByIdDocument, options);
        }
export function useSliderItemByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SliderItemByIdQuery, SliderItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SliderItemByIdQuery, SliderItemByIdQueryVariables>(SliderItemByIdDocument, options);
        }
export type SliderItemByIdQueryHookResult = ReturnType<typeof useSliderItemByIdQuery>;
export type SliderItemByIdLazyQueryHookResult = ReturnType<typeof useSliderItemByIdLazyQuery>;
export type SliderItemByIdSuspenseQueryHookResult = ReturnType<typeof useSliderItemByIdSuspenseQuery>;
export type SliderItemByIdQueryResult = Apollo.QueryResult<SliderItemByIdQuery, SliderItemByIdQueryVariables>;
export const PageSliderBlockDocument = gql`
    query PageSliderBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSliderBlock {
      id
      description
      pageBlockStyle
      sliders {
        id
        createdAt
        updatedAt
        deletedAt
        title
        orderIndex
        alternativeText
        tags
        link
        description
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
  }
}
    `;

/**
 * __usePageSliderBlockQuery__
 *
 * To run a query within a React component, call `usePageSliderBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageSliderBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageSliderBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageSliderBlockQuery(baseOptions: Apollo.QueryHookOptions<PageSliderBlockQuery, PageSliderBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageSliderBlockQuery, PageSliderBlockQueryVariables>(PageSliderBlockDocument, options);
      }
export function usePageSliderBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageSliderBlockQuery, PageSliderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageSliderBlockQuery, PageSliderBlockQueryVariables>(PageSliderBlockDocument, options);
        }
export function usePageSliderBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageSliderBlockQuery, PageSliderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageSliderBlockQuery, PageSliderBlockQueryVariables>(PageSliderBlockDocument, options);
        }
export type PageSliderBlockQueryHookResult = ReturnType<typeof usePageSliderBlockQuery>;
export type PageSliderBlockLazyQueryHookResult = ReturnType<typeof usePageSliderBlockLazyQuery>;
export type PageSliderBlockSuspenseQueryHookResult = ReturnType<typeof usePageSliderBlockSuspenseQuery>;
export type PageSliderBlockQueryResult = Apollo.QueryResult<PageSliderBlockQuery, PageSliderBlockQueryVariables>;
export const UpdateSliderItemOrdersDocument = gql`
    mutation UpdateSliderItemOrders($input: UpdateSliderItemsInput!) {
  updateSliderItemOrders(input: $input) {
    id
    orderIndex
  }
}
    `;
export type UpdateSliderItemOrdersMutationFn = Apollo.MutationFunction<UpdateSliderItemOrdersMutation, UpdateSliderItemOrdersMutationVariables>;

/**
 * __useUpdateSliderItemOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateSliderItemOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSliderItemOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSliderItemOrdersMutation, { data, loading, error }] = useUpdateSliderItemOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSliderItemOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSliderItemOrdersMutation, UpdateSliderItemOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSliderItemOrdersMutation, UpdateSliderItemOrdersMutationVariables>(UpdateSliderItemOrdersDocument, options);
      }
export type UpdateSliderItemOrdersMutationHookResult = ReturnType<typeof useUpdateSliderItemOrdersMutation>;
export type UpdateSliderItemOrdersMutationResult = Apollo.MutationResult<UpdateSliderItemOrdersMutation>;
export type UpdateSliderItemOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateSliderItemOrdersMutation, UpdateSliderItemOrdersMutationVariables>;
export const RemoveSliderItemDocument = gql`
    mutation RemoveSliderItem($removeSliderItemId: ID!) {
  removeSliderItem(id: $removeSliderItemId) {
    updatedAt
  }
}
    `;
export type RemoveSliderItemMutationFn = Apollo.MutationFunction<RemoveSliderItemMutation, RemoveSliderItemMutationVariables>;

/**
 * __useRemoveSliderItemMutation__
 *
 * To run a mutation, you first call `useRemoveSliderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSliderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSliderItemMutation, { data, loading, error }] = useRemoveSliderItemMutation({
 *   variables: {
 *      removeSliderItemId: // value for 'removeSliderItemId'
 *   },
 * });
 */
export function useRemoveSliderItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSliderItemMutation, RemoveSliderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSliderItemMutation, RemoveSliderItemMutationVariables>(RemoveSliderItemDocument, options);
      }
export type RemoveSliderItemMutationHookResult = ReturnType<typeof useRemoveSliderItemMutation>;
export type RemoveSliderItemMutationResult = Apollo.MutationResult<RemoveSliderItemMutation>;
export type RemoveSliderItemMutationOptions = Apollo.BaseMutationOptions<RemoveSliderItemMutation, RemoveSliderItemMutationVariables>;
export const ItemsSliderCarouselDocument = gql`
    mutation ItemsSliderCarousel($updateInput: UpdateSliderItemInput!) {
  updateSliderItemInput(updateInput: $updateInput) {
    id
    title
    tags
    link
    description
    alternativeText
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
  }
}
    `;
export type ItemsSliderCarouselMutationFn = Apollo.MutationFunction<ItemsSliderCarouselMutation, ItemsSliderCarouselMutationVariables>;

/**
 * __useItemsSliderCarouselMutation__
 *
 * To run a mutation, you first call `useItemsSliderCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItemsSliderCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itemsSliderCarouselMutation, { data, loading, error }] = useItemsSliderCarouselMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useItemsSliderCarouselMutation(baseOptions?: Apollo.MutationHookOptions<ItemsSliderCarouselMutation, ItemsSliderCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItemsSliderCarouselMutation, ItemsSliderCarouselMutationVariables>(ItemsSliderCarouselDocument, options);
      }
export type ItemsSliderCarouselMutationHookResult = ReturnType<typeof useItemsSliderCarouselMutation>;
export type ItemsSliderCarouselMutationResult = Apollo.MutationResult<ItemsSliderCarouselMutation>;
export type ItemsSliderCarouselMutationOptions = Apollo.BaseMutationOptions<ItemsSliderCarouselMutation, ItemsSliderCarouselMutationVariables>;
export const UpdatePageBlockStyleSliderDocument = gql`
    mutation UpdatePageBlockStyleSlider($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSliderBlock {
      pageBlockStyle
      id
    }
  }
}
    `;
export type UpdatePageBlockStyleSliderMutationFn = Apollo.MutationFunction<UpdatePageBlockStyleSliderMutation, UpdatePageBlockStyleSliderMutationVariables>;

/**
 * __useUpdatePageBlockStyleSliderMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockStyleSliderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockStyleSliderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockStyleSliderMutation, { data, loading, error }] = useUpdatePageBlockStyleSliderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockStyleSliderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockStyleSliderMutation, UpdatePageBlockStyleSliderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockStyleSliderMutation, UpdatePageBlockStyleSliderMutationVariables>(UpdatePageBlockStyleSliderDocument, options);
      }
export type UpdatePageBlockStyleSliderMutationHookResult = ReturnType<typeof useUpdatePageBlockStyleSliderMutation>;
export type UpdatePageBlockStyleSliderMutationResult = Apollo.MutationResult<UpdatePageBlockStyleSliderMutation>;
export type UpdatePageBlockStyleSliderMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockStyleSliderMutation, UpdatePageBlockStyleSliderMutationVariables>;
export const CloneSliderByStyleDocument = gql`
    mutation CloneSliderByStyle($cloneSliderStyleArg: CloneSliderStyleArg!) {
  cloneSliderByStyle(cloneSliderStyleArg: $cloneSliderStyleArg) {
    id
  }
}
    `;
export type CloneSliderByStyleMutationFn = Apollo.MutationFunction<CloneSliderByStyleMutation, CloneSliderByStyleMutationVariables>;

/**
 * __useCloneSliderByStyleMutation__
 *
 * To run a mutation, you first call `useCloneSliderByStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSliderByStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSliderByStyleMutation, { data, loading, error }] = useCloneSliderByStyleMutation({
 *   variables: {
 *      cloneSliderStyleArg: // value for 'cloneSliderStyleArg'
 *   },
 * });
 */
export function useCloneSliderByStyleMutation(baseOptions?: Apollo.MutationHookOptions<CloneSliderByStyleMutation, CloneSliderByStyleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSliderByStyleMutation, CloneSliderByStyleMutationVariables>(CloneSliderByStyleDocument, options);
      }
export type CloneSliderByStyleMutationHookResult = ReturnType<typeof useCloneSliderByStyleMutation>;
export type CloneSliderByStyleMutationResult = Apollo.MutationResult<CloneSliderByStyleMutation>;
export type CloneSliderByStyleMutationOptions = Apollo.BaseMutationOptions<CloneSliderByStyleMutation, CloneSliderByStyleMutationVariables>;
export const CreateSliderItemDocument = gql`
    mutation CreateSliderItem($createInput: CreateSliderItemInput!) {
  createSliderItem(createInput: $createInput) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    alternativeText
    tags
    link
    description
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
  }
}
    `;
export type CreateSliderItemMutationFn = Apollo.MutationFunction<CreateSliderItemMutation, CreateSliderItemMutationVariables>;

/**
 * __useCreateSliderItemMutation__
 *
 * To run a mutation, you first call `useCreateSliderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSliderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSliderItemMutation, { data, loading, error }] = useCreateSliderItemMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateSliderItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateSliderItemMutation, CreateSliderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSliderItemMutation, CreateSliderItemMutationVariables>(CreateSliderItemDocument, options);
      }
export type CreateSliderItemMutationHookResult = ReturnType<typeof useCreateSliderItemMutation>;
export type CreateSliderItemMutationResult = Apollo.MutationResult<CreateSliderItemMutation>;
export type CreateSliderItemMutationOptions = Apollo.BaseMutationOptions<CreateSliderItemMutation, CreateSliderItemMutationVariables>;
export const UpdatePressRooomSocialNetworksBlockDocument = gql`
    mutation UpdatePressRooomSocialNetworksBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSnsBlock {
      id
    }
  }
}
    `;
export type UpdatePressRooomSocialNetworksBlockMutationFn = Apollo.MutationFunction<UpdatePressRooomSocialNetworksBlockMutation, UpdatePressRooomSocialNetworksBlockMutationVariables>;

/**
 * __useUpdatePressRooomSocialNetworksBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePressRooomSocialNetworksBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePressRooomSocialNetworksBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePressRooomSocialNetworksBlockMutation, { data, loading, error }] = useUpdatePressRooomSocialNetworksBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePressRooomSocialNetworksBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePressRooomSocialNetworksBlockMutation, UpdatePressRooomSocialNetworksBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePressRooomSocialNetworksBlockMutation, UpdatePressRooomSocialNetworksBlockMutationVariables>(UpdatePressRooomSocialNetworksBlockDocument, options);
      }
export type UpdatePressRooomSocialNetworksBlockMutationHookResult = ReturnType<typeof useUpdatePressRooomSocialNetworksBlockMutation>;
export type UpdatePressRooomSocialNetworksBlockMutationResult = Apollo.MutationResult<UpdatePressRooomSocialNetworksBlockMutation>;
export type UpdatePressRooomSocialNetworksBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePressRooomSocialNetworksBlockMutation, UpdatePressRooomSocialNetworksBlockMutationVariables>;
export const GetPressRooomSocialNetworksBlockDocument = gql`
    query GetPressRooomSocialNetworksBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSnsBlock {
      id
      description
      blockTitle
      publicDescription
      showDescription
      showTitle
      pageBlockStyle
      items {
        id
        orderIndex
        description
        snsTitle
        createdAt
        updatedAt
        itemLink {
          arguments
          routeNavigation
          routeType
          target
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetPressRooomSocialNetworksBlockQuery__
 *
 * To run a query within a React component, call `useGetPressRooomSocialNetworksBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressRooomSocialNetworksBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressRooomSocialNetworksBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPressRooomSocialNetworksBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>(GetPressRooomSocialNetworksBlockDocument, options);
      }
export function useGetPressRooomSocialNetworksBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>(GetPressRooomSocialNetworksBlockDocument, options);
        }
export function useGetPressRooomSocialNetworksBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>(GetPressRooomSocialNetworksBlockDocument, options);
        }
export type GetPressRooomSocialNetworksBlockQueryHookResult = ReturnType<typeof useGetPressRooomSocialNetworksBlockQuery>;
export type GetPressRooomSocialNetworksBlockLazyQueryHookResult = ReturnType<typeof useGetPressRooomSocialNetworksBlockLazyQuery>;
export type GetPressRooomSocialNetworksBlockSuspenseQueryHookResult = ReturnType<typeof useGetPressRooomSocialNetworksBlockSuspenseQuery>;
export type GetPressRooomSocialNetworksBlockQueryResult = Apollo.QueryResult<GetPressRooomSocialNetworksBlockQuery, GetPressRooomSocialNetworksBlockQueryVariables>;
export const CreateSocialNetworkPressRoomItemDocument = gql`
    mutation CreateSocialNetworkPressRoomItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageSnsBlockItem {
      id
    }
  }
}
    `;
export type CreateSocialNetworkPressRoomItemMutationFn = Apollo.MutationFunction<CreateSocialNetworkPressRoomItemMutation, CreateSocialNetworkPressRoomItemMutationVariables>;

/**
 * __useCreateSocialNetworkPressRoomItemMutation__
 *
 * To run a mutation, you first call `useCreateSocialNetworkPressRoomItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialNetworkPressRoomItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocialNetworkPressRoomItemMutation, { data, loading, error }] = useCreateSocialNetworkPressRoomItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSocialNetworkPressRoomItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocialNetworkPressRoomItemMutation, CreateSocialNetworkPressRoomItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocialNetworkPressRoomItemMutation, CreateSocialNetworkPressRoomItemMutationVariables>(CreateSocialNetworkPressRoomItemDocument, options);
      }
export type CreateSocialNetworkPressRoomItemMutationHookResult = ReturnType<typeof useCreateSocialNetworkPressRoomItemMutation>;
export type CreateSocialNetworkPressRoomItemMutationResult = Apollo.MutationResult<CreateSocialNetworkPressRoomItemMutation>;
export type CreateSocialNetworkPressRoomItemMutationOptions = Apollo.BaseMutationOptions<CreateSocialNetworkPressRoomItemMutation, CreateSocialNetworkPressRoomItemMutationVariables>;
export const UpdateSocialNetworkPressRoomItemDocument = gql`
    mutation UpdateSocialNetworkPressRoomItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageSnsBlockItem {
      id
    }
  }
}
    `;
export type UpdateSocialNetworkPressRoomItemMutationFn = Apollo.MutationFunction<UpdateSocialNetworkPressRoomItemMutation, UpdateSocialNetworkPressRoomItemMutationVariables>;

/**
 * __useUpdateSocialNetworkPressRoomItemMutation__
 *
 * To run a mutation, you first call `useUpdateSocialNetworkPressRoomItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialNetworkPressRoomItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialNetworkPressRoomItemMutation, { data, loading, error }] = useUpdateSocialNetworkPressRoomItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialNetworkPressRoomItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialNetworkPressRoomItemMutation, UpdateSocialNetworkPressRoomItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialNetworkPressRoomItemMutation, UpdateSocialNetworkPressRoomItemMutationVariables>(UpdateSocialNetworkPressRoomItemDocument, options);
      }
export type UpdateSocialNetworkPressRoomItemMutationHookResult = ReturnType<typeof useUpdateSocialNetworkPressRoomItemMutation>;
export type UpdateSocialNetworkPressRoomItemMutationResult = Apollo.MutationResult<UpdateSocialNetworkPressRoomItemMutation>;
export type UpdateSocialNetworkPressRoomItemMutationOptions = Apollo.BaseMutationOptions<UpdateSocialNetworkPressRoomItemMutation, UpdateSocialNetworkPressRoomItemMutationVariables>;
export const GetSocialNetworkPressRoomItemDocument = gql`
    query GetSocialNetworkPressRoomItem($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageSnsBlockItem {
      id
      snsTitle
      snsSocialNetworkType
      itemLink {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetSocialNetworkPressRoomItemQuery__
 *
 * To run a query within a React component, call `useGetSocialNetworkPressRoomItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialNetworkPressRoomItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialNetworkPressRoomItemQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetSocialNetworkPressRoomItemQuery(baseOptions: Apollo.QueryHookOptions<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>(GetSocialNetworkPressRoomItemDocument, options);
      }
export function useGetSocialNetworkPressRoomItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>(GetSocialNetworkPressRoomItemDocument, options);
        }
export function useGetSocialNetworkPressRoomItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>(GetSocialNetworkPressRoomItemDocument, options);
        }
export type GetSocialNetworkPressRoomItemQueryHookResult = ReturnType<typeof useGetSocialNetworkPressRoomItemQuery>;
export type GetSocialNetworkPressRoomItemLazyQueryHookResult = ReturnType<typeof useGetSocialNetworkPressRoomItemLazyQuery>;
export type GetSocialNetworkPressRoomItemSuspenseQueryHookResult = ReturnType<typeof useGetSocialNetworkPressRoomItemSuspenseQuery>;
export type GetSocialNetworkPressRoomItemQueryResult = Apollo.QueryResult<GetSocialNetworkPressRoomItemQuery, GetSocialNetworkPressRoomItemQueryVariables>;
export const RemoveSocialNetworkPressRoomItemDocument = gql`
    mutation RemoveSocialNetworkPressRoomItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageSnsBlockItem {
      id
    }
  }
}
    `;
export type RemoveSocialNetworkPressRoomItemMutationFn = Apollo.MutationFunction<RemoveSocialNetworkPressRoomItemMutation, RemoveSocialNetworkPressRoomItemMutationVariables>;

/**
 * __useRemoveSocialNetworkPressRoomItemMutation__
 *
 * To run a mutation, you first call `useRemoveSocialNetworkPressRoomItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialNetworkPressRoomItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialNetworkPressRoomItemMutation, { data, loading, error }] = useRemoveSocialNetworkPressRoomItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveSocialNetworkPressRoomItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSocialNetworkPressRoomItemMutation, RemoveSocialNetworkPressRoomItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSocialNetworkPressRoomItemMutation, RemoveSocialNetworkPressRoomItemMutationVariables>(RemoveSocialNetworkPressRoomItemDocument, options);
      }
export type RemoveSocialNetworkPressRoomItemMutationHookResult = ReturnType<typeof useRemoveSocialNetworkPressRoomItemMutation>;
export type RemoveSocialNetworkPressRoomItemMutationResult = Apollo.MutationResult<RemoveSocialNetworkPressRoomItemMutation>;
export type RemoveSocialNetworkPressRoomItemMutationOptions = Apollo.BaseMutationOptions<RemoveSocialNetworkPressRoomItemMutation, RemoveSocialNetworkPressRoomItemMutationVariables>;
export const NewsItemsDocument = gql`
    query NewsItems($pagination: Pagination, $tags: [String!], $where: FindNewsWhere, $orderBy: [FindNewsOrderBy!]) {
  newsItems(pagination: $pagination, tags: $tags, where: $where, orderBy: $orderBy) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    expiredDate
    hasExpirationDate
    image {
      id
      fileName
      url
      fileExtension
      fileMode
      fileMongoId
    }
    newsItemTags
    expiredDate
    date
    publicationDate
    newsStatus
    summary
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useNewsItemsQuery__
 *
 * To run a query within a React component, call `useNewsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      tags: // value for 'tags'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNewsItemsQuery(baseOptions?: Apollo.QueryHookOptions<NewsItemsQuery, NewsItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemsQuery, NewsItemsQueryVariables>(NewsItemsDocument, options);
      }
export function useNewsItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemsQuery, NewsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemsQuery, NewsItemsQueryVariables>(NewsItemsDocument, options);
        }
export function useNewsItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemsQuery, NewsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemsQuery, NewsItemsQueryVariables>(NewsItemsDocument, options);
        }
export type NewsItemsQueryHookResult = ReturnType<typeof useNewsItemsQuery>;
export type NewsItemsLazyQueryHookResult = ReturnType<typeof useNewsItemsLazyQuery>;
export type NewsItemsSuspenseQueryHookResult = ReturnType<typeof useNewsItemsSuspenseQuery>;
export type NewsItemsQueryResult = Apollo.QueryResult<NewsItemsQuery, NewsItemsQueryVariables>;
export const NewsItemDocument = gql`
    query NewsItem($newsItemId: ID!) {
  newsItem(id: $newsItemId) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    content
    date
    publicationDate
    expiredDate
    newsItemTags
    image {
      id
      fileName
      url
      downloadUrl
      fileExtension
      fileMode
      fileMongoId
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useNewsItemQuery__
 *
 * To run a query within a React component, call `useNewsItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemQuery({
 *   variables: {
 *      newsItemId: // value for 'newsItemId'
 *   },
 * });
 */
export function useNewsItemQuery(baseOptions: Apollo.QueryHookOptions<NewsItemQuery, NewsItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, options);
      }
export function useNewsItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemQuery, NewsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, options);
        }
export function useNewsItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemQuery, NewsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, options);
        }
export type NewsItemQueryHookResult = ReturnType<typeof useNewsItemQuery>;
export type NewsItemLazyQueryHookResult = ReturnType<typeof useNewsItemLazyQuery>;
export type NewsItemSuspenseQueryHookResult = ReturnType<typeof useNewsItemSuspenseQuery>;
export type NewsItemQueryResult = Apollo.QueryResult<NewsItemQuery, NewsItemQueryVariables>;
export const NewsItemBySlugDocument = gql`
    query NewsItemBySlug($slug: String!) {
  newsItemBySlug(slug: $slug) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    content
    date
    publicationDate
    expiredDate
    newsItemTags
    image {
      id
      fileName
      url
      downloadUrl
      fileExtension
      fileMode
      fileMongoId
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useNewsItemBySlugQuery__
 *
 * To run a query within a React component, call `useNewsItemBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useNewsItemBySlugQuery(baseOptions: Apollo.QueryHookOptions<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>(NewsItemBySlugDocument, options);
      }
export function useNewsItemBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>(NewsItemBySlugDocument, options);
        }
export function useNewsItemBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>(NewsItemBySlugDocument, options);
        }
export type NewsItemBySlugQueryHookResult = ReturnType<typeof useNewsItemBySlugQuery>;
export type NewsItemBySlugLazyQueryHookResult = ReturnType<typeof useNewsItemBySlugLazyQuery>;
export type NewsItemBySlugSuspenseQueryHookResult = ReturnType<typeof useNewsItemBySlugSuspenseQuery>;
export type NewsItemBySlugQueryResult = Apollo.QueryResult<NewsItemBySlugQuery, NewsItemBySlugQueryVariables>;
export const NewsTagsDocument = gql`
    query NewsTags {
  newsTags
}
    `;

/**
 * __useNewsTagsQuery__
 *
 * To run a query within a React component, call `useNewsTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewsTagsQuery(baseOptions?: Apollo.QueryHookOptions<NewsTagsQuery, NewsTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsTagsQuery, NewsTagsQueryVariables>(NewsTagsDocument, options);
      }
export function useNewsTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsTagsQuery, NewsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsTagsQuery, NewsTagsQueryVariables>(NewsTagsDocument, options);
        }
export function useNewsTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsTagsQuery, NewsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsTagsQuery, NewsTagsQueryVariables>(NewsTagsDocument, options);
        }
export type NewsTagsQueryHookResult = ReturnType<typeof useNewsTagsQuery>;
export type NewsTagsLazyQueryHookResult = ReturnType<typeof useNewsTagsLazyQuery>;
export type NewsTagsSuspenseQueryHookResult = ReturnType<typeof useNewsTagsSuspenseQuery>;
export type NewsTagsQueryResult = Apollo.QueryResult<NewsTagsQuery, NewsTagsQueryVariables>;
export const NewsItemsCountDocument = gql`
    query NewsItemsCount($where: FindNewsWhere, $pagination: Pagination, $tags: [String!]) {
  newsItemsCount(where: $where, pagination: $pagination, tags: $tags) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useNewsItemsCountQuery__
 *
 * To run a query within a React component, call `useNewsItemsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useNewsItemsCountQuery(baseOptions?: Apollo.QueryHookOptions<NewsItemsCountQuery, NewsItemsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemsCountQuery, NewsItemsCountQueryVariables>(NewsItemsCountDocument, options);
      }
export function useNewsItemsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemsCountQuery, NewsItemsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemsCountQuery, NewsItemsCountQueryVariables>(NewsItemsCountDocument, options);
        }
export function useNewsItemsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemsCountQuery, NewsItemsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemsCountQuery, NewsItemsCountQueryVariables>(NewsItemsCountDocument, options);
        }
export type NewsItemsCountQueryHookResult = ReturnType<typeof useNewsItemsCountQuery>;
export type NewsItemsCountLazyQueryHookResult = ReturnType<typeof useNewsItemsCountLazyQuery>;
export type NewsItemsCountSuspenseQueryHookResult = ReturnType<typeof useNewsItemsCountSuspenseQuery>;
export type NewsItemsCountQueryResult = Apollo.QueryResult<NewsItemsCountQuery, NewsItemsCountQueryVariables>;
export const PressroomDocument = gql`
    query Pressroom {
  pressroom {
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      pagePressroomBlockTitle: title
      subtitle
      hasSearchbar
      __typename
    }
    ... on PageSnsBlock {
      items {
        id
        itemLink {
          id
          url
          target
          __typename
        }
        snsSocialNetworkType
        __typename
      }
      pageBlockStyle
      __typename
    }
    ... on PageNewsletterBlock {
      pageBlockStyle
      tagStyle
      __typename
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      global
      news {
        id
        createdAt
        updatedAt
        deletedAt
        title
        date
        publicationDate
        expiredDate
        summary
        newsStatus
        multimediaType
        alternativeText
        link
        imageLink
        dateImages
        newsItemTags
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
    }
    __typename
    ... on PageTransparencyBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      hasLinkVideo
      transparencyContent
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      seeMoreAction
      seeMoreLink
      leftItems {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        imageLink
        alternativeText
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
      rightItems {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        socialNetworkType
        hasRightItem
        link
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
  }
}
    `;

/**
 * __usePressroomQuery__
 *
 * To run a query within a React component, call `usePressroomQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressroomQuery({
 *   variables: {
 *   },
 * });
 */
export function usePressroomQuery(baseOptions?: Apollo.QueryHookOptions<PressroomQuery, PressroomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PressroomQuery, PressroomQueryVariables>(PressroomDocument, options);
      }
export function usePressroomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PressroomQuery, PressroomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PressroomQuery, PressroomQueryVariables>(PressroomDocument, options);
        }
export function usePressroomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PressroomQuery, PressroomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PressroomQuery, PressroomQueryVariables>(PressroomDocument, options);
        }
export type PressroomQueryHookResult = ReturnType<typeof usePressroomQuery>;
export type PressroomLazyQueryHookResult = ReturnType<typeof usePressroomLazyQuery>;
export type PressroomSuspenseQueryHookResult = ReturnType<typeof usePressroomSuspenseQuery>;
export type PressroomQueryResult = Apollo.QueryResult<PressroomQuery, PressroomQueryVariables>;
export const PageSocialNetworksBlockDocument = gql`
    query PageSocialNetworksBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      seeMoreLink
      leftItems {
        id
        orderIndex
        image {
          id
          __typename
        }
        __typename
      }
      rightItems {
        id
        orderIndex
        socialNetworkType
        link
        linkItem {
          id
          url
          routeType
          routeNavigation
          target
          arguments
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageSocialNetworksBlockQuery__
 *
 * To run a query within a React component, call `usePageSocialNetworksBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageSocialNetworksBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageSocialNetworksBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageSocialNetworksBlockQuery(baseOptions: Apollo.QueryHookOptions<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>(PageSocialNetworksBlockDocument, options);
      }
export function usePageSocialNetworksBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>(PageSocialNetworksBlockDocument, options);
        }
export function usePageSocialNetworksBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>(PageSocialNetworksBlockDocument, options);
        }
export type PageSocialNetworksBlockQueryHookResult = ReturnType<typeof usePageSocialNetworksBlockQuery>;
export type PageSocialNetworksBlockLazyQueryHookResult = ReturnType<typeof usePageSocialNetworksBlockLazyQuery>;
export type PageSocialNetworksBlockSuspenseQueryHookResult = ReturnType<typeof usePageSocialNetworksBlockSuspenseQuery>;
export type PageSocialNetworksBlockQueryResult = Apollo.QueryResult<PageSocialNetworksBlockQuery, PageSocialNetworksBlockQueryVariables>;
export const SocialNetworkDetailDocument = gql`
    query SocialNetworkDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSocialNetworksBlock {
      id
      canBeDisabled
      location
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      pageBlockStyle
      leftItems {
        id
        orderIndex
        description
        alternativeText
        createdAt
        updatedAt
        image {
          id
          fileMongoId
          fileMode
          fileExtension
          fileName
          url
        }
        linkItem {
          routeType
          target
          url
          routeNavigation
          arguments
        }
      }
      rightItems {
        id
        orderIndex
        description
        createdAt
        updatedAt
        linkItem {
          routeType
          target
          url
          routeNavigation
          arguments
        }
      }
    }
  }
}
    `;

/**
 * __useSocialNetworkDetailQuery__
 *
 * To run a query within a React component, call `useSocialNetworkDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialNetworkDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialNetworkDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useSocialNetworkDetailQuery(baseOptions: Apollo.QueryHookOptions<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>(SocialNetworkDetailDocument, options);
      }
export function useSocialNetworkDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>(SocialNetworkDetailDocument, options);
        }
export function useSocialNetworkDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>(SocialNetworkDetailDocument, options);
        }
export type SocialNetworkDetailQueryHookResult = ReturnType<typeof useSocialNetworkDetailQuery>;
export type SocialNetworkDetailLazyQueryHookResult = ReturnType<typeof useSocialNetworkDetailLazyQuery>;
export type SocialNetworkDetailSuspenseQueryHookResult = ReturnType<typeof useSocialNetworkDetailSuspenseQuery>;
export type SocialNetworkDetailQueryResult = Apollo.QueryResult<SocialNetworkDetailQuery, SocialNetworkDetailQueryVariables>;
export const UpdateSocialNetworksBlockDocument = gql`
    mutation UpdateSocialNetworksBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSocialNetworksBlock {
      id
    }
  }
}
    `;
export type UpdateSocialNetworksBlockMutationFn = Apollo.MutationFunction<UpdateSocialNetworksBlockMutation, UpdateSocialNetworksBlockMutationVariables>;

/**
 * __useUpdateSocialNetworksBlockMutation__
 *
 * To run a mutation, you first call `useUpdateSocialNetworksBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialNetworksBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialNetworksBlockMutation, { data, loading, error }] = useUpdateSocialNetworksBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialNetworksBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialNetworksBlockMutation, UpdateSocialNetworksBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialNetworksBlockMutation, UpdateSocialNetworksBlockMutationVariables>(UpdateSocialNetworksBlockDocument, options);
      }
export type UpdateSocialNetworksBlockMutationHookResult = ReturnType<typeof useUpdateSocialNetworksBlockMutation>;
export type UpdateSocialNetworksBlockMutationResult = Apollo.MutationResult<UpdateSocialNetworksBlockMutation>;
export type UpdateSocialNetworksBlockMutationOptions = Apollo.BaseMutationOptions<UpdateSocialNetworksBlockMutation, UpdateSocialNetworksBlockMutationVariables>;
export const CreateTabSocialNetworkDocument = gql`
    mutation CreateTabSocialNetwork($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageSocialNetworksRightBlockItem {
      id
    }
  }
}
    `;
export type CreateTabSocialNetworkMutationFn = Apollo.MutationFunction<CreateTabSocialNetworkMutation, CreateTabSocialNetworkMutationVariables>;

/**
 * __useCreateTabSocialNetworkMutation__
 *
 * To run a mutation, you first call `useCreateTabSocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTabSocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTabSocialNetworkMutation, { data, loading, error }] = useCreateTabSocialNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTabSocialNetworkMutation(baseOptions?: Apollo.MutationHookOptions<CreateTabSocialNetworkMutation, CreateTabSocialNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTabSocialNetworkMutation, CreateTabSocialNetworkMutationVariables>(CreateTabSocialNetworkDocument, options);
      }
export type CreateTabSocialNetworkMutationHookResult = ReturnType<typeof useCreateTabSocialNetworkMutation>;
export type CreateTabSocialNetworkMutationResult = Apollo.MutationResult<CreateTabSocialNetworkMutation>;
export type CreateTabSocialNetworkMutationOptions = Apollo.BaseMutationOptions<CreateTabSocialNetworkMutation, CreateTabSocialNetworkMutationVariables>;
export const UpdateTabSocialNetworkDocument = gql`
    mutation UpdateTabSocialNetwork($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageSocialNetworksRightBlockItem {
      id
    }
  }
}
    `;
export type UpdateTabSocialNetworkMutationFn = Apollo.MutationFunction<UpdateTabSocialNetworkMutation, UpdateTabSocialNetworkMutationVariables>;

/**
 * __useUpdateTabSocialNetworkMutation__
 *
 * To run a mutation, you first call `useUpdateTabSocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTabSocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTabSocialNetworkMutation, { data, loading, error }] = useUpdateTabSocialNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTabSocialNetworkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTabSocialNetworkMutation, UpdateTabSocialNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTabSocialNetworkMutation, UpdateTabSocialNetworkMutationVariables>(UpdateTabSocialNetworkDocument, options);
      }
export type UpdateTabSocialNetworkMutationHookResult = ReturnType<typeof useUpdateTabSocialNetworkMutation>;
export type UpdateTabSocialNetworkMutationResult = Apollo.MutationResult<UpdateTabSocialNetworkMutation>;
export type UpdateTabSocialNetworkMutationOptions = Apollo.BaseMutationOptions<UpdateTabSocialNetworkMutation, UpdateTabSocialNetworkMutationVariables>;
export const GetTabSocialNetworkDocument = gql`
    query GetTabSocialNetwork($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageSocialNetworksRightBlockItem {
      id
      description
      socialNetworkType
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetTabSocialNetworkQuery__
 *
 * To run a query within a React component, call `useGetTabSocialNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTabSocialNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTabSocialNetworkQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetTabSocialNetworkQuery(baseOptions: Apollo.QueryHookOptions<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>(GetTabSocialNetworkDocument, options);
      }
export function useGetTabSocialNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>(GetTabSocialNetworkDocument, options);
        }
export function useGetTabSocialNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>(GetTabSocialNetworkDocument, options);
        }
export type GetTabSocialNetworkQueryHookResult = ReturnType<typeof useGetTabSocialNetworkQuery>;
export type GetTabSocialNetworkLazyQueryHookResult = ReturnType<typeof useGetTabSocialNetworkLazyQuery>;
export type GetTabSocialNetworkSuspenseQueryHookResult = ReturnType<typeof useGetTabSocialNetworkSuspenseQuery>;
export type GetTabSocialNetworkQueryResult = Apollo.QueryResult<GetTabSocialNetworkQuery, GetTabSocialNetworkQueryVariables>;
export const RemoveTabSocialNetworkDocument = gql`
    mutation RemoveTabSocialNetwork($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageSocialNetworksRightBlockItem {
      id
    }
  }
}
    `;
export type RemoveTabSocialNetworkMutationFn = Apollo.MutationFunction<RemoveTabSocialNetworkMutation, RemoveTabSocialNetworkMutationVariables>;

/**
 * __useRemoveTabSocialNetworkMutation__
 *
 * To run a mutation, you first call `useRemoveTabSocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTabSocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTabSocialNetworkMutation, { data, loading, error }] = useRemoveTabSocialNetworkMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveTabSocialNetworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTabSocialNetworkMutation, RemoveTabSocialNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTabSocialNetworkMutation, RemoveTabSocialNetworkMutationVariables>(RemoveTabSocialNetworkDocument, options);
      }
export type RemoveTabSocialNetworkMutationHookResult = ReturnType<typeof useRemoveTabSocialNetworkMutation>;
export type RemoveTabSocialNetworkMutationResult = Apollo.MutationResult<RemoveTabSocialNetworkMutation>;
export type RemoveTabSocialNetworkMutationOptions = Apollo.BaseMutationOptions<RemoveTabSocialNetworkMutation, RemoveTabSocialNetworkMutationVariables>;
export const CreateCarouselSocialNetworkDocument = gql`
    mutation CreateCarouselSocialNetwork($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageSocialNetworksLeftBlockItem {
      id
    }
  }
}
    `;
export type CreateCarouselSocialNetworkMutationFn = Apollo.MutationFunction<CreateCarouselSocialNetworkMutation, CreateCarouselSocialNetworkMutationVariables>;

/**
 * __useCreateCarouselSocialNetworkMutation__
 *
 * To run a mutation, you first call `useCreateCarouselSocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarouselSocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarouselSocialNetworkMutation, { data, loading, error }] = useCreateCarouselSocialNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarouselSocialNetworkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarouselSocialNetworkMutation, CreateCarouselSocialNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarouselSocialNetworkMutation, CreateCarouselSocialNetworkMutationVariables>(CreateCarouselSocialNetworkDocument, options);
      }
export type CreateCarouselSocialNetworkMutationHookResult = ReturnType<typeof useCreateCarouselSocialNetworkMutation>;
export type CreateCarouselSocialNetworkMutationResult = Apollo.MutationResult<CreateCarouselSocialNetworkMutation>;
export type CreateCarouselSocialNetworkMutationOptions = Apollo.BaseMutationOptions<CreateCarouselSocialNetworkMutation, CreateCarouselSocialNetworkMutationVariables>;
export const UpdateCarouselSocialNetworkDocument = gql`
    mutation UpdateCarouselSocialNetwork($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageSocialNetworksLeftBlockItem {
      id
    }
  }
}
    `;
export type UpdateCarouselSocialNetworkMutationFn = Apollo.MutationFunction<UpdateCarouselSocialNetworkMutation, UpdateCarouselSocialNetworkMutationVariables>;

/**
 * __useUpdateCarouselSocialNetworkMutation__
 *
 * To run a mutation, you first call `useUpdateCarouselSocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarouselSocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarouselSocialNetworkMutation, { data, loading, error }] = useUpdateCarouselSocialNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarouselSocialNetworkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarouselSocialNetworkMutation, UpdateCarouselSocialNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarouselSocialNetworkMutation, UpdateCarouselSocialNetworkMutationVariables>(UpdateCarouselSocialNetworkDocument, options);
      }
export type UpdateCarouselSocialNetworkMutationHookResult = ReturnType<typeof useUpdateCarouselSocialNetworkMutation>;
export type UpdateCarouselSocialNetworkMutationResult = Apollo.MutationResult<UpdateCarouselSocialNetworkMutation>;
export type UpdateCarouselSocialNetworkMutationOptions = Apollo.BaseMutationOptions<UpdateCarouselSocialNetworkMutation, UpdateCarouselSocialNetworkMutationVariables>;
export const GetCarouselSocialNetworkDocument = gql`
    query GetCarouselSocialNetwork($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageSocialNetworksLeftBlockItem {
      id
      description
      alternativeText
      image {
        id
        url
        fileMode
        fileExtension
        fileName
        deletedAt
        updatedAt
        fileMongoId
        createdAt
      }
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetCarouselSocialNetworkQuery__
 *
 * To run a query within a React component, call `useGetCarouselSocialNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarouselSocialNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarouselSocialNetworkQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetCarouselSocialNetworkQuery(baseOptions: Apollo.QueryHookOptions<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>(GetCarouselSocialNetworkDocument, options);
      }
export function useGetCarouselSocialNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>(GetCarouselSocialNetworkDocument, options);
        }
export function useGetCarouselSocialNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>(GetCarouselSocialNetworkDocument, options);
        }
export type GetCarouselSocialNetworkQueryHookResult = ReturnType<typeof useGetCarouselSocialNetworkQuery>;
export type GetCarouselSocialNetworkLazyQueryHookResult = ReturnType<typeof useGetCarouselSocialNetworkLazyQuery>;
export type GetCarouselSocialNetworkSuspenseQueryHookResult = ReturnType<typeof useGetCarouselSocialNetworkSuspenseQuery>;
export type GetCarouselSocialNetworkQueryResult = Apollo.QueryResult<GetCarouselSocialNetworkQuery, GetCarouselSocialNetworkQueryVariables>;
export const RemoveCarouselSocialNetworkDocument = gql`
    mutation RemoveCarouselSocialNetwork($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageSocialNetworksLeftBlockItem {
      id
    }
  }
}
    `;
export type RemoveCarouselSocialNetworkMutationFn = Apollo.MutationFunction<RemoveCarouselSocialNetworkMutation, RemoveCarouselSocialNetworkMutationVariables>;

/**
 * __useRemoveCarouselSocialNetworkMutation__
 *
 * To run a mutation, you first call `useRemoveCarouselSocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCarouselSocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCarouselSocialNetworkMutation, { data, loading, error }] = useRemoveCarouselSocialNetworkMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveCarouselSocialNetworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCarouselSocialNetworkMutation, RemoveCarouselSocialNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCarouselSocialNetworkMutation, RemoveCarouselSocialNetworkMutationVariables>(RemoveCarouselSocialNetworkDocument, options);
      }
export type RemoveCarouselSocialNetworkMutationHookResult = ReturnType<typeof useRemoveCarouselSocialNetworkMutation>;
export type RemoveCarouselSocialNetworkMutationResult = Apollo.MutationResult<RemoveCarouselSocialNetworkMutation>;
export type RemoveCarouselSocialNetworkMutationOptions = Apollo.BaseMutationOptions<RemoveCarouselSocialNetworkMutation, RemoveCarouselSocialNetworkMutationVariables>;
export const GetPageStyledTableBlockDocument = gql`
    query GetPageStyledTableBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageStyledTableBlock {
      id
      title
      contentType
      description
      extendedDescription
      publicDescription
      showDescription
      showTitle
      itemsPerPage
      rows {
        id
        orderIndex
        cellData {
          id
          value
          updatedAt
          column {
            id
          }
        }
      }
      columns {
        id
        allowFilter
        allowSort
        columnName
        columnWidth
        dataType
        orderIndex
        description
        configJson
        mappedField {
          id
          orderIndex
        }
      }
      contentSchema {
        id
        fields {
          id
          fieldName
          fieldType
          orderIndex
        }
      }
    }
  }
}
    `;

/**
 * __useGetPageStyledTableBlockQuery__
 *
 * To run a query within a React component, call `useGetPageStyledTableBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageStyledTableBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageStyledTableBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageStyledTableBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>(GetPageStyledTableBlockDocument, options);
      }
export function useGetPageStyledTableBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>(GetPageStyledTableBlockDocument, options);
        }
export function useGetPageStyledTableBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>(GetPageStyledTableBlockDocument, options);
        }
export type GetPageStyledTableBlockQueryHookResult = ReturnType<typeof useGetPageStyledTableBlockQuery>;
export type GetPageStyledTableBlockLazyQueryHookResult = ReturnType<typeof useGetPageStyledTableBlockLazyQuery>;
export type GetPageStyledTableBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageStyledTableBlockSuspenseQuery>;
export type GetPageStyledTableBlockQueryResult = Apollo.QueryResult<GetPageStyledTableBlockQuery, GetPageStyledTableBlockQueryVariables>;
export const UpdatePageStyledTableBlockDocument = gql`
    mutation UpdatePageStyledTableBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageStyledTableBlock {
      id
    }
  }
}
    `;
export type UpdatePageStyledTableBlockMutationFn = Apollo.MutationFunction<UpdatePageStyledTableBlockMutation, UpdatePageStyledTableBlockMutationVariables>;

/**
 * __useUpdatePageStyledTableBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageStyledTableBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageStyledTableBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageStyledTableBlockMutation, { data, loading, error }] = useUpdatePageStyledTableBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageStyledTableBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageStyledTableBlockMutation, UpdatePageStyledTableBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageStyledTableBlockMutation, UpdatePageStyledTableBlockMutationVariables>(UpdatePageStyledTableBlockDocument, options);
      }
export type UpdatePageStyledTableBlockMutationHookResult = ReturnType<typeof useUpdatePageStyledTableBlockMutation>;
export type UpdatePageStyledTableBlockMutationResult = Apollo.MutationResult<UpdatePageStyledTableBlockMutation>;
export type UpdatePageStyledTableBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageStyledTableBlockMutation, UpdatePageStyledTableBlockMutationVariables>;
export const CreatePageStyledTableBlockItemDocument = gql`
    mutation CreatePageStyledTableBlockItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageStyledTableBlockRow {
      styledTableBlock {
        id
      }
    }
  }
}
    `;
export type CreatePageStyledTableBlockItemMutationFn = Apollo.MutationFunction<CreatePageStyledTableBlockItemMutation, CreatePageStyledTableBlockItemMutationVariables>;

/**
 * __useCreatePageStyledTableBlockItemMutation__
 *
 * To run a mutation, you first call `useCreatePageStyledTableBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageStyledTableBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageStyledTableBlockItemMutation, { data, loading, error }] = useCreatePageStyledTableBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageStyledTableBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageStyledTableBlockItemMutation, CreatePageStyledTableBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageStyledTableBlockItemMutation, CreatePageStyledTableBlockItemMutationVariables>(CreatePageStyledTableBlockItemDocument, options);
      }
export type CreatePageStyledTableBlockItemMutationHookResult = ReturnType<typeof useCreatePageStyledTableBlockItemMutation>;
export type CreatePageStyledTableBlockItemMutationResult = Apollo.MutationResult<CreatePageStyledTableBlockItemMutation>;
export type CreatePageStyledTableBlockItemMutationOptions = Apollo.BaseMutationOptions<CreatePageStyledTableBlockItemMutation, CreatePageStyledTableBlockItemMutationVariables>;
export const UpdatePageStyledTableBlockItemDocument = gql`
    mutation UpdatePageStyledTableBlockItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageStyledTableBlockRow {
      styledTableBlock {
        id
      }
    }
  }
}
    `;
export type UpdatePageStyledTableBlockItemMutationFn = Apollo.MutationFunction<UpdatePageStyledTableBlockItemMutation, UpdatePageStyledTableBlockItemMutationVariables>;

/**
 * __useUpdatePageStyledTableBlockItemMutation__
 *
 * To run a mutation, you first call `useUpdatePageStyledTableBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageStyledTableBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageStyledTableBlockItemMutation, { data, loading, error }] = useUpdatePageStyledTableBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageStyledTableBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageStyledTableBlockItemMutation, UpdatePageStyledTableBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageStyledTableBlockItemMutation, UpdatePageStyledTableBlockItemMutationVariables>(UpdatePageStyledTableBlockItemDocument, options);
      }
export type UpdatePageStyledTableBlockItemMutationHookResult = ReturnType<typeof useUpdatePageStyledTableBlockItemMutation>;
export type UpdatePageStyledTableBlockItemMutationResult = Apollo.MutationResult<UpdatePageStyledTableBlockItemMutation>;
export type UpdatePageStyledTableBlockItemMutationOptions = Apollo.BaseMutationOptions<UpdatePageStyledTableBlockItemMutation, UpdatePageStyledTableBlockItemMutationVariables>;
export const RemovePageStyledTableBlockItemDocument = gql`
    mutation RemovePageStyledTableBlockItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageStyledTableBlockRow {
      id
    }
  }
}
    `;
export type RemovePageStyledTableBlockItemMutationFn = Apollo.MutationFunction<RemovePageStyledTableBlockItemMutation, RemovePageStyledTableBlockItemMutationVariables>;

/**
 * __useRemovePageStyledTableBlockItemMutation__
 *
 * To run a mutation, you first call `useRemovePageStyledTableBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageStyledTableBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageStyledTableBlockItemMutation, { data, loading, error }] = useRemovePageStyledTableBlockItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemovePageStyledTableBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageStyledTableBlockItemMutation, RemovePageStyledTableBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageStyledTableBlockItemMutation, RemovePageStyledTableBlockItemMutationVariables>(RemovePageStyledTableBlockItemDocument, options);
      }
export type RemovePageStyledTableBlockItemMutationHookResult = ReturnType<typeof useRemovePageStyledTableBlockItemMutation>;
export type RemovePageStyledTableBlockItemMutationResult = Apollo.MutationResult<RemovePageStyledTableBlockItemMutation>;
export type RemovePageStyledTableBlockItemMutationOptions = Apollo.BaseMutationOptions<RemovePageStyledTableBlockItemMutation, RemovePageStyledTableBlockItemMutationVariables>;
export const StyledTableDocumentDocument = gql`
    query StyledTableDocument($documentId: ID!) {
  document(id: $documentId) {
    id
    fileId
    createdAt
    updatedAt
    deletedAt
    title
    description
    type
    status
    contentDate
    migrationMetadata
    publishDate
    expirationDate
    downloadText
    downloadCount
    fileSize
    mimeType
    file {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      downloadUrl
      url
    }
  }
}
    `;

/**
 * __useStyledTableDocumentQuery__
 *
 * To run a query within a React component, call `useStyledTableDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyledTableDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyledTableDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useStyledTableDocumentQuery(baseOptions: Apollo.QueryHookOptions<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>(StyledTableDocumentDocument, options);
      }
export function useStyledTableDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>(StyledTableDocumentDocument, options);
        }
export function useStyledTableDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>(StyledTableDocumentDocument, options);
        }
export type StyledTableDocumentQueryHookResult = ReturnType<typeof useStyledTableDocumentQuery>;
export type StyledTableDocumentLazyQueryHookResult = ReturnType<typeof useStyledTableDocumentLazyQuery>;
export type StyledTableDocumentSuspenseQueryHookResult = ReturnType<typeof useStyledTableDocumentSuspenseQuery>;
export type StyledTableDocumentQueryResult = Apollo.QueryResult<StyledTableDocumentQuery, StyledTableDocumentQueryVariables>;
export const StyledTableDocumentsDocument = gql`
    query StyledTableDocuments($where: FindContentWhere, $schemaIdFilter: String, $pagination: Pagination, $orderBy: [FindContentOrderBy!], $dependencyIdFilter: String, $metadataFieldFilters: [MetadataFieldFilter!], $metadataOrderBy: [MetadataFieldOrderBy!]) {
  documents(where: $where, schemaIdFilter: $schemaIdFilter, pagination: $pagination, orderBy: $orderBy, dependencyIdFilter: $dependencyIdFilter, metadataFieldFilters: $metadataFieldFilters, metadataOrderBy: $metadataOrderBy) {
    id
    title
    createdAt
    status
    fileId
    metadata {
      id
      value
      schemaField {
        id
        fieldName
      }
    }
  }
  documentsCount(where: $where, schemaIdFilter: $schemaIdFilter, pagination: $pagination, orderBy: $orderBy, dependencyIdFilter: $dependencyIdFilter, metadataFieldFilters: $metadataFieldFilters, metadataOrderBy: $metadataOrderBy) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useStyledTableDocumentsQuery__
 *
 * To run a query within a React component, call `useStyledTableDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyledTableDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyledTableDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      schemaIdFilter: // value for 'schemaIdFilter'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      dependencyIdFilter: // value for 'dependencyIdFilter'
 *      metadataFieldFilters: // value for 'metadataFieldFilters'
 *      metadataOrderBy: // value for 'metadataOrderBy'
 *   },
 * });
 */
export function useStyledTableDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>(StyledTableDocumentsDocument, options);
      }
export function useStyledTableDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>(StyledTableDocumentsDocument, options);
        }
export function useStyledTableDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>(StyledTableDocumentsDocument, options);
        }
export type StyledTableDocumentsQueryHookResult = ReturnType<typeof useStyledTableDocumentsQuery>;
export type StyledTableDocumentsLazyQueryHookResult = ReturnType<typeof useStyledTableDocumentsLazyQuery>;
export type StyledTableDocumentsSuspenseQueryHookResult = ReturnType<typeof useStyledTableDocumentsSuspenseQuery>;
export type StyledTableDocumentsQueryResult = Apollo.QueryResult<StyledTableDocumentsQuery, StyledTableDocumentsQueryVariables>;
export const PageStyledTableBlockRowsDocument = gql`
    query PageStyledTableBlockRows($pagination: Pagination, $where: PageStyledTableBlockRowWhere, $styledTableBlockId: String) {
  pageStyledTableBlockRows(pagination: $pagination, where: $where, styledTableBlockId: $styledTableBlockId) {
    id
    cellData {
      id
      value
      updatedAt
      column {
        id
      }
    }
  }
  paginationPageStyledTableBlockRows(styledTableBlockId: $styledTableBlockId, pagination: $pagination) {
    total
    count
    limit
    page
    pageCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __usePageStyledTableBlockRowsQuery__
 *
 * To run a query within a React component, call `usePageStyledTableBlockRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageStyledTableBlockRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageStyledTableBlockRowsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      styledTableBlockId: // value for 'styledTableBlockId'
 *   },
 * });
 */
export function usePageStyledTableBlockRowsQuery(baseOptions?: Apollo.QueryHookOptions<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>(PageStyledTableBlockRowsDocument, options);
      }
export function usePageStyledTableBlockRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>(PageStyledTableBlockRowsDocument, options);
        }
export function usePageStyledTableBlockRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>(PageStyledTableBlockRowsDocument, options);
        }
export type PageStyledTableBlockRowsQueryHookResult = ReturnType<typeof usePageStyledTableBlockRowsQuery>;
export type PageStyledTableBlockRowsLazyQueryHookResult = ReturnType<typeof usePageStyledTableBlockRowsLazyQuery>;
export type PageStyledTableBlockRowsSuspenseQueryHookResult = ReturnType<typeof usePageStyledTableBlockRowsSuspenseQuery>;
export type PageStyledTableBlockRowsQueryResult = Apollo.QueryResult<PageStyledTableBlockRowsQuery, PageStyledTableBlockRowsQueryVariables>;
export const PageDownloadBlockItemAllDocument = gql`
    query PageDownloadBlockItemAll($parentId: ID!, $where: FindPageBlockItemsWhere, $positions: [String!], $orderBy: [FindPageBlockItemsOrderBy!], $positionOrder: OrderTypes) {
  pageBlockItems(parentId: $parentId, where: $where, positions: $positions, orderBy: $orderBy, positionOrder: $positionOrder) {
    ... on PageSubDownloadBlockItem {
      id
      createdAt
      updatedAt
      deletedAt
      description
      orderIndex
      name
      file {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
    }
  }
}
    `;

/**
 * __usePageDownloadBlockItemAllQuery__
 *
 * To run a query within a React component, call `usePageDownloadBlockItemAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDownloadBlockItemAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDownloadBlockItemAllQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      where: // value for 'where'
 *      positions: // value for 'positions'
 *      orderBy: // value for 'orderBy'
 *      positionOrder: // value for 'positionOrder'
 *   },
 * });
 */
export function usePageDownloadBlockItemAllQuery(baseOptions: Apollo.QueryHookOptions<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>(PageDownloadBlockItemAllDocument, options);
      }
export function usePageDownloadBlockItemAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>(PageDownloadBlockItemAllDocument, options);
        }
export function usePageDownloadBlockItemAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>(PageDownloadBlockItemAllDocument, options);
        }
export type PageDownloadBlockItemAllQueryHookResult = ReturnType<typeof usePageDownloadBlockItemAllQuery>;
export type PageDownloadBlockItemAllLazyQueryHookResult = ReturnType<typeof usePageDownloadBlockItemAllLazyQuery>;
export type PageDownloadBlockItemAllSuspenseQueryHookResult = ReturnType<typeof usePageDownloadBlockItemAllSuspenseQuery>;
export type PageDownloadBlockItemAllQueryResult = Apollo.QueryResult<PageDownloadBlockItemAllQuery, PageDownloadBlockItemAllQueryVariables>;
export const CreatePageBlockItemDownloadDocument = gql`
    mutation CreatePageBlockItemDownload($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageSubDownloadBlockItem {
      id
      createdAt
      updatedAt
      deletedAt
      description
      orderIndex
      name
      file {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
    }
  }
}
    `;
export type CreatePageBlockItemDownloadMutationFn = Apollo.MutationFunction<CreatePageBlockItemDownloadMutation, CreatePageBlockItemDownloadMutationVariables>;

/**
 * __useCreatePageBlockItemDownloadMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockItemDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockItemDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockItemDownloadMutation, { data, loading, error }] = useCreatePageBlockItemDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockItemDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockItemDownloadMutation, CreatePageBlockItemDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockItemDownloadMutation, CreatePageBlockItemDownloadMutationVariables>(CreatePageBlockItemDownloadDocument, options);
      }
export type CreatePageBlockItemDownloadMutationHookResult = ReturnType<typeof useCreatePageBlockItemDownloadMutation>;
export type CreatePageBlockItemDownloadMutationResult = Apollo.MutationResult<CreatePageBlockItemDownloadMutation>;
export type CreatePageBlockItemDownloadMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockItemDownloadMutation, CreatePageBlockItemDownloadMutationVariables>;
export const UpdatePageBlockItemDownloadDocument = gql`
    mutation UpdatePageBlockItemDownload($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageSubDownloadBlockItem {
      id
    }
  }
}
    `;
export type UpdatePageBlockItemDownloadMutationFn = Apollo.MutationFunction<UpdatePageBlockItemDownloadMutation, UpdatePageBlockItemDownloadMutationVariables>;

/**
 * __useUpdatePageBlockItemDownloadMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemDownloadMutation, { data, loading, error }] = useUpdatePageBlockItemDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemDownloadMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemDownloadMutation, UpdatePageBlockItemDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemDownloadMutation, UpdatePageBlockItemDownloadMutationVariables>(UpdatePageBlockItemDownloadDocument, options);
      }
export type UpdatePageBlockItemDownloadMutationHookResult = ReturnType<typeof useUpdatePageBlockItemDownloadMutation>;
export type UpdatePageBlockItemDownloadMutationResult = Apollo.MutationResult<UpdatePageBlockItemDownloadMutation>;
export type UpdatePageBlockItemDownloadMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemDownloadMutation, UpdatePageBlockItemDownloadMutationVariables>;
export const PageDownloadItemByIdDocument = gql`
    query PageDownloadItemById($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageSubDownloadBlockItem {
      id
      createdAt
      updatedAt
      deletedAt
      description
      orderIndex
      name
      file {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
    }
  }
}
    `;

/**
 * __usePageDownloadItemByIdQuery__
 *
 * To run a query within a React component, call `usePageDownloadItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDownloadItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDownloadItemByIdQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageDownloadItemByIdQuery(baseOptions: Apollo.QueryHookOptions<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>(PageDownloadItemByIdDocument, options);
      }
export function usePageDownloadItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>(PageDownloadItemByIdDocument, options);
        }
export function usePageDownloadItemByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>(PageDownloadItemByIdDocument, options);
        }
export type PageDownloadItemByIdQueryHookResult = ReturnType<typeof usePageDownloadItemByIdQuery>;
export type PageDownloadItemByIdLazyQueryHookResult = ReturnType<typeof usePageDownloadItemByIdLazyQuery>;
export type PageDownloadItemByIdSuspenseQueryHookResult = ReturnType<typeof usePageDownloadItemByIdSuspenseQuery>;
export type PageDownloadItemByIdQueryResult = Apollo.QueryResult<PageDownloadItemByIdQuery, PageDownloadItemByIdQueryVariables>;
export const PageSubDownloadBlockDocument = gql`
    query PageSubDownloadBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSubDownloadBlock {
      id
      subDownloadTitle
      subDownloadPlaceholder
      subDownloadDescription
      publicDescription
      showDescription
      showTitle
      subDownloadSearchbar
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
    }
  }
}
    `;

/**
 * __usePageSubDownloadBlockQuery__
 *
 * To run a query within a React component, call `usePageSubDownloadBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageSubDownloadBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageSubDownloadBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageSubDownloadBlockQuery(baseOptions: Apollo.QueryHookOptions<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>(PageSubDownloadBlockDocument, options);
      }
export function usePageSubDownloadBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>(PageSubDownloadBlockDocument, options);
        }
export function usePageSubDownloadBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>(PageSubDownloadBlockDocument, options);
        }
export type PageSubDownloadBlockQueryHookResult = ReturnType<typeof usePageSubDownloadBlockQuery>;
export type PageSubDownloadBlockLazyQueryHookResult = ReturnType<typeof usePageSubDownloadBlockLazyQuery>;
export type PageSubDownloadBlockSuspenseQueryHookResult = ReturnType<typeof usePageSubDownloadBlockSuspenseQuery>;
export type PageSubDownloadBlockQueryResult = Apollo.QueryResult<PageSubDownloadBlockQuery, PageSubDownloadBlockQueryVariables>;
export const UpdatePageBlockDownloadDocument = gql`
    mutation UpdatePageBlockDownload($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageCabinetBlock {
      isCarrousel
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      description
      pageBlockStyle
    }
  }
}
    `;
export type UpdatePageBlockDownloadMutationFn = Apollo.MutationFunction<UpdatePageBlockDownloadMutation, UpdatePageBlockDownloadMutationVariables>;

/**
 * __useUpdatePageBlockDownloadMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockDownloadMutation, { data, loading, error }] = useUpdatePageBlockDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockDownloadMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockDownloadMutation, UpdatePageBlockDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockDownloadMutation, UpdatePageBlockDownloadMutationVariables>(UpdatePageBlockDownloadDocument, options);
      }
export type UpdatePageBlockDownloadMutationHookResult = ReturnType<typeof useUpdatePageBlockDownloadMutation>;
export type UpdatePageBlockDownloadMutationResult = Apollo.MutationResult<UpdatePageBlockDownloadMutation>;
export type UpdatePageBlockDownloadMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockDownloadMutation, UpdatePageBlockDownloadMutationVariables>;
export const UpdatePageTaxesBlockDocument = gql`
    mutation UpdatePageTaxesBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageTaxesBlock {
      id
    }
  }
}
    `;
export type UpdatePageTaxesBlockMutationFn = Apollo.MutationFunction<UpdatePageTaxesBlockMutation, UpdatePageTaxesBlockMutationVariables>;

/**
 * __useUpdatePageTaxesBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageTaxesBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageTaxesBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageTaxesBlockMutation, { data, loading, error }] = useUpdatePageTaxesBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageTaxesBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageTaxesBlockMutation, UpdatePageTaxesBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageTaxesBlockMutation, UpdatePageTaxesBlockMutationVariables>(UpdatePageTaxesBlockDocument, options);
      }
export type UpdatePageTaxesBlockMutationHookResult = ReturnType<typeof useUpdatePageTaxesBlockMutation>;
export type UpdatePageTaxesBlockMutationResult = Apollo.MutationResult<UpdatePageTaxesBlockMutation>;
export type UpdatePageTaxesBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageTaxesBlockMutation, UpdatePageTaxesBlockMutationVariables>;
export const GetPageTaxesBlockDocument = gql`
    query GetPageTaxesBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageTaxesBlock {
      id
      pageBlockStyle
      blockTitle
      description
      publicDescription
      showDescription
      showTitle
      items {
        id
        orderIndex
        taxTitle
        description
        linkItem {
          routeType
          target
          url
          routeNavigation
          arguments
        }
        image {
          id
          fileMongoId
          fileName
          fileExtension
          fileMode
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetPageTaxesBlockQuery__
 *
 * To run a query within a React component, call `useGetPageTaxesBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageTaxesBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageTaxesBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageTaxesBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>(GetPageTaxesBlockDocument, options);
      }
export function useGetPageTaxesBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>(GetPageTaxesBlockDocument, options);
        }
export function useGetPageTaxesBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>(GetPageTaxesBlockDocument, options);
        }
export type GetPageTaxesBlockQueryHookResult = ReturnType<typeof useGetPageTaxesBlockQuery>;
export type GetPageTaxesBlockLazyQueryHookResult = ReturnType<typeof useGetPageTaxesBlockLazyQuery>;
export type GetPageTaxesBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageTaxesBlockSuspenseQuery>;
export type GetPageTaxesBlockQueryResult = Apollo.QueryResult<GetPageTaxesBlockQuery, GetPageTaxesBlockQueryVariables>;
export const CreateTaxAccessBlockItemDocument = gql`
    mutation CreateTaxAccessBlockItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageTaxesBlockItem {
      id
    }
  }
}
    `;
export type CreateTaxAccessBlockItemMutationFn = Apollo.MutationFunction<CreateTaxAccessBlockItemMutation, CreateTaxAccessBlockItemMutationVariables>;

/**
 * __useCreateTaxAccessBlockItemMutation__
 *
 * To run a mutation, you first call `useCreateTaxAccessBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxAccessBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxAccessBlockItemMutation, { data, loading, error }] = useCreateTaxAccessBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaxAccessBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxAccessBlockItemMutation, CreateTaxAccessBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxAccessBlockItemMutation, CreateTaxAccessBlockItemMutationVariables>(CreateTaxAccessBlockItemDocument, options);
      }
export type CreateTaxAccessBlockItemMutationHookResult = ReturnType<typeof useCreateTaxAccessBlockItemMutation>;
export type CreateTaxAccessBlockItemMutationResult = Apollo.MutationResult<CreateTaxAccessBlockItemMutation>;
export type CreateTaxAccessBlockItemMutationOptions = Apollo.BaseMutationOptions<CreateTaxAccessBlockItemMutation, CreateTaxAccessBlockItemMutationVariables>;
export const UpdateTaxAccessBlockItemDocument = gql`
    mutation UpdateTaxAccessBlockItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageTaxesBlockItem {
      id
    }
  }
}
    `;
export type UpdateTaxAccessBlockItemMutationFn = Apollo.MutationFunction<UpdateTaxAccessBlockItemMutation, UpdateTaxAccessBlockItemMutationVariables>;

/**
 * __useUpdateTaxAccessBlockItemMutation__
 *
 * To run a mutation, you first call `useUpdateTaxAccessBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxAccessBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxAccessBlockItemMutation, { data, loading, error }] = useUpdateTaxAccessBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaxAccessBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxAccessBlockItemMutation, UpdateTaxAccessBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxAccessBlockItemMutation, UpdateTaxAccessBlockItemMutationVariables>(UpdateTaxAccessBlockItemDocument, options);
      }
export type UpdateTaxAccessBlockItemMutationHookResult = ReturnType<typeof useUpdateTaxAccessBlockItemMutation>;
export type UpdateTaxAccessBlockItemMutationResult = Apollo.MutationResult<UpdateTaxAccessBlockItemMutation>;
export type UpdateTaxAccessBlockItemMutationOptions = Apollo.BaseMutationOptions<UpdateTaxAccessBlockItemMutation, UpdateTaxAccessBlockItemMutationVariables>;
export const GetTaxAccessBlockItemDocument = gql`
    query GetTaxAccessBlockItem($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageTaxesBlockItem {
      id
      description
      taxTitle
      link
      image {
        downloadUrl
        fileExtension
        fileMode
        id
        fileName
        fileMongoId
        url
      }
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetTaxAccessBlockItemQuery__
 *
 * To run a query within a React component, call `useGetTaxAccessBlockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxAccessBlockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxAccessBlockItemQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetTaxAccessBlockItemQuery(baseOptions: Apollo.QueryHookOptions<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>(GetTaxAccessBlockItemDocument, options);
      }
export function useGetTaxAccessBlockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>(GetTaxAccessBlockItemDocument, options);
        }
export function useGetTaxAccessBlockItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>(GetTaxAccessBlockItemDocument, options);
        }
export type GetTaxAccessBlockItemQueryHookResult = ReturnType<typeof useGetTaxAccessBlockItemQuery>;
export type GetTaxAccessBlockItemLazyQueryHookResult = ReturnType<typeof useGetTaxAccessBlockItemLazyQuery>;
export type GetTaxAccessBlockItemSuspenseQueryHookResult = ReturnType<typeof useGetTaxAccessBlockItemSuspenseQuery>;
export type GetTaxAccessBlockItemQueryResult = Apollo.QueryResult<GetTaxAccessBlockItemQuery, GetTaxAccessBlockItemQueryVariables>;
export const RemoveTaxAccessBlockItemDocument = gql`
    mutation RemoveTaxAccessBlockItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageTaxesBlockItem {
      id
    }
  }
}
    `;
export type RemoveTaxAccessBlockItemMutationFn = Apollo.MutationFunction<RemoveTaxAccessBlockItemMutation, RemoveTaxAccessBlockItemMutationVariables>;

/**
 * __useRemoveTaxAccessBlockItemMutation__
 *
 * To run a mutation, you first call `useRemoveTaxAccessBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaxAccessBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaxAccessBlockItemMutation, { data, loading, error }] = useRemoveTaxAccessBlockItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveTaxAccessBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaxAccessBlockItemMutation, RemoveTaxAccessBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaxAccessBlockItemMutation, RemoveTaxAccessBlockItemMutationVariables>(RemoveTaxAccessBlockItemDocument, options);
      }
export type RemoveTaxAccessBlockItemMutationHookResult = ReturnType<typeof useRemoveTaxAccessBlockItemMutation>;
export type RemoveTaxAccessBlockItemMutationResult = Apollo.MutationResult<RemoveTaxAccessBlockItemMutation>;
export type RemoveTaxAccessBlockItemMutationOptions = Apollo.BaseMutationOptions<RemoveTaxAccessBlockItemMutation, RemoveTaxAccessBlockItemMutationVariables>;
export const PageTaxAccesButtonBlockDocument = gql`
    query pageTaxAccesButtonBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      taxSectionTitle
      items {
        id
        orderIndex
        taxTitle
        image {
          downloadUrl
          id
          url
          __typename
        }
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __usePageTaxAccesButtonBlockQuery__
 *
 * To run a query within a React component, call `usePageTaxAccesButtonBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageTaxAccesButtonBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageTaxAccesButtonBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageTaxAccesButtonBlockQuery(baseOptions: Apollo.QueryHookOptions<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>(PageTaxAccesButtonBlockDocument, options);
      }
export function usePageTaxAccesButtonBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>(PageTaxAccesButtonBlockDocument, options);
        }
export function usePageTaxAccesButtonBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>(PageTaxAccesButtonBlockDocument, options);
        }
export type PageTaxAccesButtonBlockQueryHookResult = ReturnType<typeof usePageTaxAccesButtonBlockQuery>;
export type PageTaxAccesButtonBlockLazyQueryHookResult = ReturnType<typeof usePageTaxAccesButtonBlockLazyQuery>;
export type PageTaxAccesButtonBlockSuspenseQueryHookResult = ReturnType<typeof usePageTaxAccesButtonBlockSuspenseQuery>;
export type PageTaxAccesButtonBlockQueryResult = Apollo.QueryResult<PageTaxAccesButtonBlockQuery, PageTaxAccesButtonBlockQueryVariables>;
export const PageAccessibilityBarDocument = gql`
    query PageAccessibilityBar {
  footer {
    ... on PageAccessibilityBar {
      pageBlockStyle
    }
  }
}
    `;

/**
 * __usePageAccessibilityBarQuery__
 *
 * To run a query within a React component, call `usePageAccessibilityBarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageAccessibilityBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageAccessibilityBarQuery({
 *   variables: {
 *   },
 * });
 */
export function usePageAccessibilityBarQuery(baseOptions?: Apollo.QueryHookOptions<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>(PageAccessibilityBarDocument, options);
      }
export function usePageAccessibilityBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>(PageAccessibilityBarDocument, options);
        }
export function usePageAccessibilityBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>(PageAccessibilityBarDocument, options);
        }
export type PageAccessibilityBarQueryHookResult = ReturnType<typeof usePageAccessibilityBarQuery>;
export type PageAccessibilityBarLazyQueryHookResult = ReturnType<typeof usePageAccessibilityBarLazyQuery>;
export type PageAccessibilityBarSuspenseQueryHookResult = ReturnType<typeof usePageAccessibilityBarSuspenseQuery>;
export type PageAccessibilityBarQueryResult = Apollo.QueryResult<PageAccessibilityBarQuery, PageAccessibilityBarQueryVariables>;
export const GetDocumentDocument = gql`
    query GetDocument($documentId: ID!) {
  document(id: $documentId) {
    id
    fileId
    createdAt
    updatedAt
    deletedAt
    title
    description
    type
    status
    contentDate
    migrationMetadata
    publishDate
    expirationDate
    downloadText
    downloadCount
    fileSize
    dependency {
      id
      name
    }
    mimeType
    file {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      downloadUrl
      url
      __typename
    }
    __typename
    metadata {
      id
      value
      schemaField {
        id
        fieldName
      }
    }
  }
}
    `;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSuspenseQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($updatePasswordInput: UpdatePasswordInput!) {
  updatePassword(updatePasswordInput: $updatePasswordInput) {
    id
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      updatePasswordInput: // value for 'updatePasswordInput'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const ParametersDefaultDocument = gql`
    query ParametersDefault {
  parametersDefault {
    id
    code
    description
    type
    character
    number
    date
    json
  }
}
    `;

/**
 * __useParametersDefaultQuery__
 *
 * To run a query within a React component, call `useParametersDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useParametersDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParametersDefaultQuery({
 *   variables: {
 *   },
 * });
 */
export function useParametersDefaultQuery(baseOptions?: Apollo.QueryHookOptions<ParametersDefaultQuery, ParametersDefaultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParametersDefaultQuery, ParametersDefaultQueryVariables>(ParametersDefaultDocument, options);
      }
export function useParametersDefaultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParametersDefaultQuery, ParametersDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParametersDefaultQuery, ParametersDefaultQueryVariables>(ParametersDefaultDocument, options);
        }
export function useParametersDefaultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParametersDefaultQuery, ParametersDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParametersDefaultQuery, ParametersDefaultQueryVariables>(ParametersDefaultDocument, options);
        }
export type ParametersDefaultQueryHookResult = ReturnType<typeof useParametersDefaultQuery>;
export type ParametersDefaultLazyQueryHookResult = ReturnType<typeof useParametersDefaultLazyQuery>;
export type ParametersDefaultSuspenseQueryHookResult = ReturnType<typeof useParametersDefaultSuspenseQuery>;
export type ParametersDefaultQueryResult = Apollo.QueryResult<ParametersDefaultQuery, ParametersDefaultQueryVariables>;
export const QueryValidateClonseVersionDocument = gql`
    query QueryValidateClonseVersion($createInput: ClonePageVersionInput!) {
  validateClonePageVersion(createInput: $createInput)
}
    `;

/**
 * __useQueryValidateClonseVersionQuery__
 *
 * To run a query within a React component, call `useQueryValidateClonseVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryValidateClonseVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryValidateClonseVersionQuery({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useQueryValidateClonseVersionQuery(baseOptions: Apollo.QueryHookOptions<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>(QueryValidateClonseVersionDocument, options);
      }
export function useQueryValidateClonseVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>(QueryValidateClonseVersionDocument, options);
        }
export function useQueryValidateClonseVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>(QueryValidateClonseVersionDocument, options);
        }
export type QueryValidateClonseVersionQueryHookResult = ReturnType<typeof useQueryValidateClonseVersionQuery>;
export type QueryValidateClonseVersionLazyQueryHookResult = ReturnType<typeof useQueryValidateClonseVersionLazyQuery>;
export type QueryValidateClonseVersionSuspenseQueryHookResult = ReturnType<typeof useQueryValidateClonseVersionSuspenseQuery>;
export type QueryValidateClonseVersionQueryResult = Apollo.QueryResult<QueryValidateClonseVersionQuery, QueryValidateClonseVersionQueryVariables>;
export const LayoutDocument = gql`
    query Layout {
  header {
    ... on PageSearchBlock {
      id
      orderIndex
      blockTitle
      type
      pageBlockStyle
      description
      isDisabled
      createdAt
      updatedAt
      placeholder
      canBeDisabled
    }
    ... on PageAccessibilityButton {
      id
      description
      items {
        id
        altText
        iconType
        isActive
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        orderIndex
        linkUrl
        linkName
      }
      createdAt
      updatedAt
      deletedAt
      blockTitle
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      isFromTemplate
      templateOriginName
      templateOriginId
      clonedFromTemplateAt
      type
      title
      isEnabled
      tooltipText
      buttonColor
      maxItems
    }
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasSearchbar
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      logoLink
      hasSignin
      hasSignup
      signinName
      signupName
      logoImage {
        downloadUrl
        id
        url
      }
      administrationLogo {
        downloadUrl
        id
        url
      }
      adminOtherLogo {
        downloadUrl
        id
        url
      }
      govcoLink {
        id
        routeNavigation
        routeType
        arguments
        __typename
        target
        updatedAt
        url
        createdAt
        deletedAt
      }
    }
    ... on PageHeaderOrganizationBar {
      id
      title
      subtitle
      blockTitle
      logoImage {
        downloadUrl
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      logoImageLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
      adminOtherLogo {
        downloadUrl
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      adminAnotherLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
      administrationLogo {
        downloadUrl
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      adminLogoLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
    }
    ... on PageNavigationBar {
      id
      orderIndex
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      location
      pageBlockStyle
      subPages
    }
  }
  footer {
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      campusData
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      subtitle
      nit
      address
      postalCode
      openingHours
      phone
      fax
      citizenLine
      antiCorruptionLine
      institutionalEmail
      judicialEmail
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      logoImage {
        downloadUrl
        id
        url
      }
      administrationLogo {
        downloadUrl
        id
        url
      }
      adminOtherLogo {
        downloadUrl
        id
        url
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        socialNetworkName
        socialNetworkLink
        pageDirectory
        pageDirectoryLink {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
        footerType
        hasSocialNetworkIcon
        socialNetworkIcon {
          downloadUrl
          id
          url
        }
        routeType
      }
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      items {
        id
        corporateLogo {
          downloadUrl
          id
          url
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
        }
        corporateLogoLink
        corporateLogoName
        orderIndex
      }
    }
  }
}
    `;

/**
 * __useLayoutQuery__
 *
 * To run a query within a React component, call `useLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useLayoutQuery(baseOptions?: Apollo.QueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
      }
export function useLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
        }
export function useLayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
        }
export type LayoutQueryHookResult = ReturnType<typeof useLayoutQuery>;
export type LayoutLazyQueryHookResult = ReturnType<typeof useLayoutLazyQuery>;
export type LayoutSuspenseQueryHookResult = ReturnType<typeof useLayoutSuspenseQuery>;
export type LayoutQueryResult = Apollo.QueryResult<LayoutQuery, LayoutQueryVariables>;
export const PageTaxesBlockDocument = gql`
    query PageTaxesBlock {
  mainPage {
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      taxSectionTitle
      items {
        id
        taxTitle
        image {
          id
          url
        }
        link
      }
    }
  }
}
    `;

/**
 * __usePageTaxesBlockQuery__
 *
 * To run a query within a React component, call `usePageTaxesBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageTaxesBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageTaxesBlockQuery({
 *   variables: {
 *   },
 * });
 */
export function usePageTaxesBlockQuery(baseOptions?: Apollo.QueryHookOptions<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>(PageTaxesBlockDocument, options);
      }
export function usePageTaxesBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>(PageTaxesBlockDocument, options);
        }
export function usePageTaxesBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>(PageTaxesBlockDocument, options);
        }
export type PageTaxesBlockQueryHookResult = ReturnType<typeof usePageTaxesBlockQuery>;
export type PageTaxesBlockLazyQueryHookResult = ReturnType<typeof usePageTaxesBlockLazyQuery>;
export type PageTaxesBlockSuspenseQueryHookResult = ReturnType<typeof usePageTaxesBlockSuspenseQuery>;
export type PageTaxesBlockQueryResult = Apollo.QueryResult<PageTaxesBlockQuery, PageTaxesBlockQueryVariables>;
export const PageVersionsDocument = gql`
    query PageVersions {
  pageVersions {
    id
    state
    description
    theme
    consecutive
    user {
      fullName
    }
  }
}
    `;

/**
 * __usePageVersionsQuery__
 *
 * To run a query within a React component, call `usePageVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePageVersionsQuery(baseOptions?: Apollo.QueryHookOptions<PageVersionsQuery, PageVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageVersionsQuery, PageVersionsQueryVariables>(PageVersionsDocument, options);
      }
export function usePageVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageVersionsQuery, PageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageVersionsQuery, PageVersionsQueryVariables>(PageVersionsDocument, options);
        }
export function usePageVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageVersionsQuery, PageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageVersionsQuery, PageVersionsQueryVariables>(PageVersionsDocument, options);
        }
export type PageVersionsQueryHookResult = ReturnType<typeof usePageVersionsQuery>;
export type PageVersionsLazyQueryHookResult = ReturnType<typeof usePageVersionsLazyQuery>;
export type PageVersionsSuspenseQueryHookResult = ReturnType<typeof usePageVersionsSuspenseQuery>;
export type PageVersionsQueryResult = Apollo.QueryResult<PageVersionsQuery, PageVersionsQueryVariables>;
export const NavigationTreeDocument = gql`
    query NavigationTree($navigationBarId: ID!, $maxDepth: Int) {
  navigationTree(navigationBarId: $navigationBarId, maxDepth: $maxDepth) {
    id
    name
    description
    orderIndex
    depth
    status
    isVisible
    link
    linkItem {
      id
      routeType
      routeNavigation
      target
      arguments
      url
      dynamicPageSlugs {
        id
        slug
      }
    }
    signLanguageGif {
      id
      downloadUrl
      url
      fileName
    }
    signLanguageDescription
    children {
      id
      name
      description
      orderIndex
      depth
      status
      isVisible
      link
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
        dynamicPageSlugs {
          id
          slug
        }
      }
      children {
        id
        name
        description
        orderIndex
        depth
        status
        isVisible
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
        children {
          id
          name
          description
          orderIndex
          depth
          status
          isVisible
          link
          linkItem {
            id
            routeType
            routeNavigation
            target
            arguments
            url
            dynamicPageSlugs {
              id
              slug
            }
          }
          children {
            id
            name
            description
            orderIndex
            depth
            status
            isVisible
            link
            linkItem {
              id
              routeType
              routeNavigation
              target
              arguments
              url
              dynamicPageSlugs {
                id
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNavigationTreeQuery__
 *
 * To run a query within a React component, call `useNavigationTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationTreeQuery({
 *   variables: {
 *      navigationBarId: // value for 'navigationBarId'
 *      maxDepth: // value for 'maxDepth'
 *   },
 * });
 */
export function useNavigationTreeQuery(baseOptions: Apollo.QueryHookOptions<NavigationTreeQuery, NavigationTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationTreeQuery, NavigationTreeQueryVariables>(NavigationTreeDocument, options);
      }
export function useNavigationTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationTreeQuery, NavigationTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationTreeQuery, NavigationTreeQueryVariables>(NavigationTreeDocument, options);
        }
export function useNavigationTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavigationTreeQuery, NavigationTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationTreeQuery, NavigationTreeQueryVariables>(NavigationTreeDocument, options);
        }
export type NavigationTreeQueryHookResult = ReturnType<typeof useNavigationTreeQuery>;
export type NavigationTreeLazyQueryHookResult = ReturnType<typeof useNavigationTreeLazyQuery>;
export type NavigationTreeSuspenseQueryHookResult = ReturnType<typeof useNavigationTreeSuspenseQuery>;
export type NavigationTreeQueryResult = Apollo.QueryResult<NavigationTreeQuery, NavigationTreeQueryVariables>;
export const NavigationTreeAdminDocument = gql`
    query NavigationTreeAdmin($navigationBarId: ID!, $maxDepth: Int) {
  navigationTreeAdmin(navigationBarId: $navigationBarId, maxDepth: $maxDepth) {
    id
    name
    description
    orderIndex
    depth
    status
    isVisible
    link
    linkItem {
      id
      routeType
      routeNavigation
      target
      arguments
      url
      dynamicPageSlugs {
        id
        slug
      }
    }
    signLanguageGif {
      id
      downloadUrl
      url
      fileName
    }
    signLanguageDescription
    children {
      id
      name
      description
      orderIndex
      depth
      status
      isVisible
      link
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
        dynamicPageSlugs {
          id
          slug
        }
      }
      children {
        id
        name
        description
        orderIndex
        depth
        status
        isVisible
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
        children {
          id
          name
          description
          orderIndex
          depth
          status
          isVisible
          link
          linkItem {
            id
            routeType
            routeNavigation
            target
            arguments
            url
            dynamicPageSlugs {
              id
              slug
            }
          }
          children {
            id
            name
            description
            orderIndex
            depth
            status
            isVisible
            link
            linkItem {
              id
              routeType
              routeNavigation
              target
              arguments
              url
              dynamicPageSlugs {
                id
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNavigationTreeAdminQuery__
 *
 * To run a query within a React component, call `useNavigationTreeAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationTreeAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationTreeAdminQuery({
 *   variables: {
 *      navigationBarId: // value for 'navigationBarId'
 *      maxDepth: // value for 'maxDepth'
 *   },
 * });
 */
export function useNavigationTreeAdminQuery(baseOptions: Apollo.QueryHookOptions<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>(NavigationTreeAdminDocument, options);
      }
export function useNavigationTreeAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>(NavigationTreeAdminDocument, options);
        }
export function useNavigationTreeAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>(NavigationTreeAdminDocument, options);
        }
export type NavigationTreeAdminQueryHookResult = ReturnType<typeof useNavigationTreeAdminQuery>;
export type NavigationTreeAdminLazyQueryHookResult = ReturnType<typeof useNavigationTreeAdminLazyQuery>;
export type NavigationTreeAdminSuspenseQueryHookResult = ReturnType<typeof useNavigationTreeAdminSuspenseQuery>;
export type NavigationTreeAdminQueryResult = Apollo.QueryResult<NavigationTreeAdminQuery, NavigationTreeAdminQueryVariables>;
export const HistoriesDocument = gql`
    query Histories($pageDynamicId: ID, $pagination: Pagination) {
  histories(pageDynamicId: $pageDynamicId, orderBy: {createdAt: DESC}, pagination: $pagination) {
    id
    createdAt
    updatedAt
    deletedAt
    dataId
    ipAddress
    changedBy {
      id
      name
      lastName
    }
    pageDynamic {
      createdAt
      id
      updatedAt
      deletedAt
      name
      type
      description
      status
      __typename
      parent {
        id
        name
        type
        status
      }
      children {
        id
        name
        type
        status
      }
      dependency {
        id
        createdAt
        updatedAt
        deletedAt
        name
        type
        status
      }
      editors {
        id
        createdAt
        updatedAt
        deletedAt
        assignedAt
        isActive
        notes
      }
    }
    consecutive
    basedOn {
      id
    }
  }
}
    `;

/**
 * __useHistoriesQuery__
 *
 * To run a query within a React component, call `useHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoriesQuery({
 *   variables: {
 *      pageDynamicId: // value for 'pageDynamicId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<HistoriesQuery, HistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoriesQuery, HistoriesQueryVariables>(HistoriesDocument, options);
      }
export function useHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoriesQuery, HistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoriesQuery, HistoriesQueryVariables>(HistoriesDocument, options);
        }
export function useHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HistoriesQuery, HistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HistoriesQuery, HistoriesQueryVariables>(HistoriesDocument, options);
        }
export type HistoriesQueryHookResult = ReturnType<typeof useHistoriesQuery>;
export type HistoriesLazyQueryHookResult = ReturnType<typeof useHistoriesLazyQuery>;
export type HistoriesSuspenseQueryHookResult = ReturnType<typeof useHistoriesSuspenseQuery>;
export type HistoriesQueryResult = Apollo.QueryResult<HistoriesQuery, HistoriesQueryVariables>;
export const RecoverPageDynamicDocument = gql`
    mutation RecoverPageDynamic($historyId: String!, $pageDynamicId: String!) {
  recoverPageDynamic(historyId: $historyId, pageDynamicId: $pageDynamicId)
}
    `;
export type RecoverPageDynamicMutationFn = Apollo.MutationFunction<RecoverPageDynamicMutation, RecoverPageDynamicMutationVariables>;

/**
 * __useRecoverPageDynamicMutation__
 *
 * To run a mutation, you first call `useRecoverPageDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverPageDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverPageDynamicMutation, { data, loading, error }] = useRecoverPageDynamicMutation({
 *   variables: {
 *      historyId: // value for 'historyId'
 *      pageDynamicId: // value for 'pageDynamicId'
 *   },
 * });
 */
export function useRecoverPageDynamicMutation(baseOptions?: Apollo.MutationHookOptions<RecoverPageDynamicMutation, RecoverPageDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverPageDynamicMutation, RecoverPageDynamicMutationVariables>(RecoverPageDynamicDocument, options);
      }
export type RecoverPageDynamicMutationHookResult = ReturnType<typeof useRecoverPageDynamicMutation>;
export type RecoverPageDynamicMutationResult = Apollo.MutationResult<RecoverPageDynamicMutation>;
export type RecoverPageDynamicMutationOptions = Apollo.BaseMutationOptions<RecoverPageDynamicMutation, RecoverPageDynamicMutationVariables>;
export const GetComparativeJsonFromHistoryDocument = gql`
    query getComparativeJsonFromHistory($firstHistoryId: String!, $secondHistoryId: String!) {
  getComparativeJsonFromHistory(firstHistoryId: $firstHistoryId, secondHistoryId: $secondHistoryId)
}
    `;

/**
 * __useGetComparativeJsonFromHistoryQuery__
 *
 * To run a query within a React component, call `useGetComparativeJsonFromHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComparativeJsonFromHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComparativeJsonFromHistoryQuery({
 *   variables: {
 *      firstHistoryId: // value for 'firstHistoryId'
 *      secondHistoryId: // value for 'secondHistoryId'
 *   },
 * });
 */
export function useGetComparativeJsonFromHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>(GetComparativeJsonFromHistoryDocument, options);
      }
export function useGetComparativeJsonFromHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>(GetComparativeJsonFromHistoryDocument, options);
        }
export function useGetComparativeJsonFromHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>(GetComparativeJsonFromHistoryDocument, options);
        }
export type GetComparativeJsonFromHistoryQueryHookResult = ReturnType<typeof useGetComparativeJsonFromHistoryQuery>;
export type GetComparativeJsonFromHistoryLazyQueryHookResult = ReturnType<typeof useGetComparativeJsonFromHistoryLazyQuery>;
export type GetComparativeJsonFromHistorySuspenseQueryHookResult = ReturnType<typeof useGetComparativeJsonFromHistorySuspenseQuery>;
export type GetComparativeJsonFromHistoryQueryResult = Apollo.QueryResult<GetComparativeJsonFromHistoryQuery, GetComparativeJsonFromHistoryQueryVariables>;
export const GetPageDynamicFromHistoryDocument = gql`
    query getPageDynamicFromHistory($historyId: String!, $pageDynamicId: String!) {
  getPageDynamicFromHistory(historyId: $historyId, pageDynamicId: $pageDynamicId) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    status
    type
    blocks {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      version {
        id
      }
    }
  }
}
    `;

/**
 * __useGetPageDynamicFromHistoryQuery__
 *
 * To run a query within a React component, call `useGetPageDynamicFromHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageDynamicFromHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageDynamicFromHistoryQuery({
 *   variables: {
 *      historyId: // value for 'historyId'
 *      pageDynamicId: // value for 'pageDynamicId'
 *   },
 * });
 */
export function useGetPageDynamicFromHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>(GetPageDynamicFromHistoryDocument, options);
      }
export function useGetPageDynamicFromHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>(GetPageDynamicFromHistoryDocument, options);
        }
export function useGetPageDynamicFromHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>(GetPageDynamicFromHistoryDocument, options);
        }
export type GetPageDynamicFromHistoryQueryHookResult = ReturnType<typeof useGetPageDynamicFromHistoryQuery>;
export type GetPageDynamicFromHistoryLazyQueryHookResult = ReturnType<typeof useGetPageDynamicFromHistoryLazyQuery>;
export type GetPageDynamicFromHistorySuspenseQueryHookResult = ReturnType<typeof useGetPageDynamicFromHistorySuspenseQuery>;
export type GetPageDynamicFromHistoryQueryResult = Apollo.QueryResult<GetPageDynamicFromHistoryQuery, GetPageDynamicFromHistoryQueryVariables>;
export const DynamicPagesDocument = gql`
    query DynamicPages($orderBy: [FindPageDynamicsOrderBy!], $where: FindPageDynamicsWhere, $pagination: Pagination) {
  pageDynamics(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    type
    title: name
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useDynamicPagesQuery__
 *
 * To run a query within a React component, call `useDynamicPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicPagesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDynamicPagesQuery(baseOptions?: Apollo.QueryHookOptions<DynamicPagesQuery, DynamicPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicPagesQuery, DynamicPagesQueryVariables>(DynamicPagesDocument, options);
      }
export function useDynamicPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicPagesQuery, DynamicPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicPagesQuery, DynamicPagesQueryVariables>(DynamicPagesDocument, options);
        }
export function useDynamicPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DynamicPagesQuery, DynamicPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicPagesQuery, DynamicPagesQueryVariables>(DynamicPagesDocument, options);
        }
export type DynamicPagesQueryHookResult = ReturnType<typeof useDynamicPagesQuery>;
export type DynamicPagesLazyQueryHookResult = ReturnType<typeof useDynamicPagesLazyQuery>;
export type DynamicPagesSuspenseQueryHookResult = ReturnType<typeof useDynamicPagesSuspenseQuery>;
export type DynamicPagesQueryResult = Apollo.QueryResult<DynamicPagesQuery, DynamicPagesQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    legalRepresentativeIdentificationType
    legalRepresentativeIdentificationNumber
    phoneCountryCode
    phoneNumber
    country {
      id
      createdAt
      updatedAt
      deletedAt
      code
      name
    }
    department {
      id
      createdAt
      updatedAt
      deletedAt
      code
      name
    }
    city {
      id
      createdAt
      updatedAt
      deletedAt
      code
      name
    }
    address
    hasRural
    status
    type
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const SacConnectionDocument = gql`
    query sacConnection {
  sacConnection
}
    `;

/**
 * __useSacConnectionQuery__
 *
 * To run a query within a React component, call `useSacConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSacConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSacConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSacConnectionQuery(baseOptions?: Apollo.QueryHookOptions<SacConnectionQuery, SacConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SacConnectionQuery, SacConnectionQueryVariables>(SacConnectionDocument, options);
      }
export function useSacConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SacConnectionQuery, SacConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SacConnectionQuery, SacConnectionQueryVariables>(SacConnectionDocument, options);
        }
export function useSacConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SacConnectionQuery, SacConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SacConnectionQuery, SacConnectionQueryVariables>(SacConnectionDocument, options);
        }
export type SacConnectionQueryHookResult = ReturnType<typeof useSacConnectionQuery>;
export type SacConnectionLazyQueryHookResult = ReturnType<typeof useSacConnectionLazyQuery>;
export type SacConnectionSuspenseQueryHookResult = ReturnType<typeof useSacConnectionSuspenseQuery>;
export type SacConnectionQueryResult = Apollo.QueryResult<SacConnectionQuery, SacConnectionQueryVariables>;
export const SharedDocumentsDocument = gql`
    query SharedDocuments($contentType: ContentType!, $orderBy: [FindMySharedContentOrderBy!], $where: FindMySharedContentWhere, $pagination: Pagination) {
  mySharedContent(contentType: $contentType, orderBy: $orderBy, where: $where, pagination: $pagination) {
    contentId
    document {
      id
      title
      status
      createdAt
      publishDate
      schema {
        id
        name
      }
      dependency {
        id
        name
      }
      file {
        downloadUrl
      }
    }
  }
  mySharedContentCount(contentType: $contentType, orderBy: $orderBy, where: $where, pagination: $pagination) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useSharedDocumentsQuery__
 *
 * To run a query within a React component, call `useSharedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedDocumentsQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSharedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<SharedDocumentsQuery, SharedDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedDocumentsQuery, SharedDocumentsQueryVariables>(SharedDocumentsDocument, options);
      }
export function useSharedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedDocumentsQuery, SharedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedDocumentsQuery, SharedDocumentsQueryVariables>(SharedDocumentsDocument, options);
        }
export function useSharedDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedDocumentsQuery, SharedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedDocumentsQuery, SharedDocumentsQueryVariables>(SharedDocumentsDocument, options);
        }
export type SharedDocumentsQueryHookResult = ReturnType<typeof useSharedDocumentsQuery>;
export type SharedDocumentsLazyQueryHookResult = ReturnType<typeof useSharedDocumentsLazyQuery>;
export type SharedDocumentsSuspenseQueryHookResult = ReturnType<typeof useSharedDocumentsSuspenseQuery>;
export type SharedDocumentsQueryResult = Apollo.QueryResult<SharedDocumentsQuery, SharedDocumentsQueryVariables>;
export const SharedNewsDocument = gql`
    query SharedNews($contentType: ContentType!, $orderBy: [FindMySharedContentOrderBy!], $where: FindMySharedContentWhere, $pagination: Pagination) {
  mySharedContent(contentType: $contentType, orderBy: $orderBy, where: $where, pagination: $pagination) {
    contentId
    newsItem {
      title
      createdAt
      date
      expiredDate
      newsStatus
      id
      dependency {
        id
        name
      }
      contentSchema {
        id
        name
      }
    }
  }
  mySharedContentCount(contentType: $contentType, orderBy: $orderBy, where: $where, pagination: $pagination) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useSharedNewsQuery__
 *
 * To run a query within a React component, call `useSharedNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedNewsQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSharedNewsQuery(baseOptions: Apollo.QueryHookOptions<SharedNewsQuery, SharedNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedNewsQuery, SharedNewsQueryVariables>(SharedNewsDocument, options);
      }
export function useSharedNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedNewsQuery, SharedNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedNewsQuery, SharedNewsQueryVariables>(SharedNewsDocument, options);
        }
export function useSharedNewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedNewsQuery, SharedNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedNewsQuery, SharedNewsQueryVariables>(SharedNewsDocument, options);
        }
export type SharedNewsQueryHookResult = ReturnType<typeof useSharedNewsQuery>;
export type SharedNewsLazyQueryHookResult = ReturnType<typeof useSharedNewsLazyQuery>;
export type SharedNewsSuspenseQueryHookResult = ReturnType<typeof useSharedNewsSuspenseQuery>;
export type SharedNewsQueryResult = Apollo.QueryResult<SharedNewsQuery, SharedNewsQueryVariables>;
export const SharedEventsDocument = gql`
    query SharedEvents($contentType: ContentType!, $orderBy: [FindMySharedContentOrderBy!], $where: FindMySharedContentWhere, $pagination: Pagination) {
  mySharedContent(contentType: $contentType, orderBy: $orderBy, where: $where, pagination: $pagination) {
    contentId
    eventItem {
      id
      startDate
      endDate
      createdAt
      eventStatus
      eventItemTitle
      dependency {
        id
        name
      }
      contentSchema {
        id
        name
      }
    }
  }
  mySharedContentCount(contentType: $contentType, orderBy: $orderBy, where: $where, pagination: $pagination) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useSharedEventsQuery__
 *
 * To run a query within a React component, call `useSharedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedEventsQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSharedEventsQuery(baseOptions: Apollo.QueryHookOptions<SharedEventsQuery, SharedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedEventsQuery, SharedEventsQueryVariables>(SharedEventsDocument, options);
      }
export function useSharedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedEventsQuery, SharedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedEventsQuery, SharedEventsQueryVariables>(SharedEventsDocument, options);
        }
export function useSharedEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedEventsQuery, SharedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedEventsQuery, SharedEventsQueryVariables>(SharedEventsDocument, options);
        }
export type SharedEventsQueryHookResult = ReturnType<typeof useSharedEventsQuery>;
export type SharedEventsLazyQueryHookResult = ReturnType<typeof useSharedEventsLazyQuery>;
export type SharedEventsSuspenseQueryHookResult = ReturnType<typeof useSharedEventsSuspenseQuery>;
export type SharedEventsQueryResult = Apollo.QueryResult<SharedEventsQuery, SharedEventsQueryVariables>;
export const UpdateNewsStatusToDraftDocument = gql`
    mutation UpdateNewsStatusToDraft($updateNewsStatusToDraft: UpdateNewsItemStatus!) {
  updateNewsStatusToDraft(updateNewsStatusToDraft: $updateNewsStatusToDraft)
}
    `;
export type UpdateNewsStatusToDraftMutationFn = Apollo.MutationFunction<UpdateNewsStatusToDraftMutation, UpdateNewsStatusToDraftMutationVariables>;

/**
 * __useUpdateNewsStatusToDraftMutation__
 *
 * To run a mutation, you first call `useUpdateNewsStatusToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsStatusToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsStatusToDraftMutation, { data, loading, error }] = useUpdateNewsStatusToDraftMutation({
 *   variables: {
 *      updateNewsStatusToDraft: // value for 'updateNewsStatusToDraft'
 *   },
 * });
 */
export function useUpdateNewsStatusToDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsStatusToDraftMutation, UpdateNewsStatusToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsStatusToDraftMutation, UpdateNewsStatusToDraftMutationVariables>(UpdateNewsStatusToDraftDocument, options);
      }
export type UpdateNewsStatusToDraftMutationHookResult = ReturnType<typeof useUpdateNewsStatusToDraftMutation>;
export type UpdateNewsStatusToDraftMutationResult = Apollo.MutationResult<UpdateNewsStatusToDraftMutation>;
export type UpdateNewsStatusToDraftMutationOptions = Apollo.BaseMutationOptions<UpdateNewsStatusToDraftMutation, UpdateNewsStatusToDraftMutationVariables>;
export const UpdatePageBlockItemOrdersDocument = gql`
    mutation UpdatePageBlockItemOrders($input: [UpdateOrderPageBlockItemInput!]!) {
  updatePageBlockItemOrders(input: $input) {
    id
    orderIndex
  }
}
    `;
export type UpdatePageBlockItemOrdersMutationFn = Apollo.MutationFunction<UpdatePageBlockItemOrdersMutation, UpdatePageBlockItemOrdersMutationVariables>;

/**
 * __useUpdatePageBlockItemOrdersMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemOrdersMutation, { data, loading, error }] = useUpdatePageBlockItemOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemOrdersMutation, UpdatePageBlockItemOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemOrdersMutation, UpdatePageBlockItemOrdersMutationVariables>(UpdatePageBlockItemOrdersDocument, options);
      }
export type UpdatePageBlockItemOrdersMutationHookResult = ReturnType<typeof useUpdatePageBlockItemOrdersMutation>;
export type UpdatePageBlockItemOrdersMutationResult = Apollo.MutationResult<UpdatePageBlockItemOrdersMutation>;
export type UpdatePageBlockItemOrdersMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemOrdersMutation, UpdatePageBlockItemOrdersMutationVariables>;
export const UpdatePageAccessibilityBarDocument = gql`
    mutation UpdatePageAccessibilityBar($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageAccessibilityBar {
      id
    }
  }
}
    `;
export type UpdatePageAccessibilityBarMutationFn = Apollo.MutationFunction<UpdatePageAccessibilityBarMutation, UpdatePageAccessibilityBarMutationVariables>;

/**
 * __useUpdatePageAccessibilityBarMutation__
 *
 * To run a mutation, you first call `useUpdatePageAccessibilityBarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageAccessibilityBarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageAccessibilityBarMutation, { data, loading, error }] = useUpdatePageAccessibilityBarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageAccessibilityBarMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageAccessibilityBarMutation, UpdatePageAccessibilityBarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageAccessibilityBarMutation, UpdatePageAccessibilityBarMutationVariables>(UpdatePageAccessibilityBarDocument, options);
      }
export type UpdatePageAccessibilityBarMutationHookResult = ReturnType<typeof useUpdatePageAccessibilityBarMutation>;
export type UpdatePageAccessibilityBarMutationResult = Apollo.MutationResult<UpdatePageAccessibilityBarMutation>;
export type UpdatePageAccessibilityBarMutationOptions = Apollo.BaseMutationOptions<UpdatePageAccessibilityBarMutation, UpdatePageAccessibilityBarMutationVariables>;
export const GetPageAccessibilityBarBlockDocument = gql`
    query GetPageAccessibilityBarBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageAccessibilityBar {
      id
      pageBlockStyle
    }
  }
}
    `;

/**
 * __useGetPageAccessibilityBarBlockQuery__
 *
 * To run a query within a React component, call `useGetPageAccessibilityBarBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageAccessibilityBarBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageAccessibilityBarBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageAccessibilityBarBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>(GetPageAccessibilityBarBlockDocument, options);
      }
export function useGetPageAccessibilityBarBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>(GetPageAccessibilityBarBlockDocument, options);
        }
export function useGetPageAccessibilityBarBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>(GetPageAccessibilityBarBlockDocument, options);
        }
export type GetPageAccessibilityBarBlockQueryHookResult = ReturnType<typeof useGetPageAccessibilityBarBlockQuery>;
export type GetPageAccessibilityBarBlockLazyQueryHookResult = ReturnType<typeof useGetPageAccessibilityBarBlockLazyQuery>;
export type GetPageAccessibilityBarBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageAccessibilityBarBlockSuspenseQuery>;
export type GetPageAccessibilityBarBlockQueryResult = Apollo.QueryResult<GetPageAccessibilityBarBlockQuery, GetPageAccessibilityBarBlockQueryVariables>;
export const AccessibilityButtonDetailDocument = gql`
    query AccessibilityButtonDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageAccessibilityButton {
      id
      items {
        id
        linkName
        iconType
        linkItem {
          id
          createdAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        isActive
        orderIndex
        linkUrl
      }
    }
  }
}
    `;

/**
 * __useAccessibilityButtonDetailQuery__
 *
 * To run a query within a React component, call `useAccessibilityButtonDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessibilityButtonDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessibilityButtonDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useAccessibilityButtonDetailQuery(baseOptions: Apollo.QueryHookOptions<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>(AccessibilityButtonDetailDocument, options);
      }
export function useAccessibilityButtonDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>(AccessibilityButtonDetailDocument, options);
        }
export function useAccessibilityButtonDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>(AccessibilityButtonDetailDocument, options);
        }
export type AccessibilityButtonDetailQueryHookResult = ReturnType<typeof useAccessibilityButtonDetailQuery>;
export type AccessibilityButtonDetailLazyQueryHookResult = ReturnType<typeof useAccessibilityButtonDetailLazyQuery>;
export type AccessibilityButtonDetailSuspenseQueryHookResult = ReturnType<typeof useAccessibilityButtonDetailSuspenseQuery>;
export type AccessibilityButtonDetailQueryResult = Apollo.QueryResult<AccessibilityButtonDetailQuery, AccessibilityButtonDetailQueryVariables>;
export const CreateAccessibilityButtonDocument = gql`
    mutation CreateAccessibilityButton($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageAccessibilityButtonItem {
      id
    }
  }
}
    `;
export type CreateAccessibilityButtonMutationFn = Apollo.MutationFunction<CreateAccessibilityButtonMutation, CreateAccessibilityButtonMutationVariables>;

/**
 * __useCreateAccessibilityButtonMutation__
 *
 * To run a mutation, you first call `useCreateAccessibilityButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessibilityButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessibilityButtonMutation, { data, loading, error }] = useCreateAccessibilityButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccessibilityButtonMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccessibilityButtonMutation, CreateAccessibilityButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccessibilityButtonMutation, CreateAccessibilityButtonMutationVariables>(CreateAccessibilityButtonDocument, options);
      }
export type CreateAccessibilityButtonMutationHookResult = ReturnType<typeof useCreateAccessibilityButtonMutation>;
export type CreateAccessibilityButtonMutationResult = Apollo.MutationResult<CreateAccessibilityButtonMutation>;
export type CreateAccessibilityButtonMutationOptions = Apollo.BaseMutationOptions<CreateAccessibilityButtonMutation, CreateAccessibilityButtonMutationVariables>;
export const UpdateAccessibilityButtonItemDocument = gql`
    mutation UpdateAccessibilityButtonItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageAccessibilityButtonItem {
      id
    }
  }
}
    `;
export type UpdateAccessibilityButtonItemMutationFn = Apollo.MutationFunction<UpdateAccessibilityButtonItemMutation, UpdateAccessibilityButtonItemMutationVariables>;

/**
 * __useUpdateAccessibilityButtonItemMutation__
 *
 * To run a mutation, you first call `useUpdateAccessibilityButtonItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessibilityButtonItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessibilityButtonItemMutation, { data, loading, error }] = useUpdateAccessibilityButtonItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccessibilityButtonItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessibilityButtonItemMutation, UpdateAccessibilityButtonItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessibilityButtonItemMutation, UpdateAccessibilityButtonItemMutationVariables>(UpdateAccessibilityButtonItemDocument, options);
      }
export type UpdateAccessibilityButtonItemMutationHookResult = ReturnType<typeof useUpdateAccessibilityButtonItemMutation>;
export type UpdateAccessibilityButtonItemMutationResult = Apollo.MutationResult<UpdateAccessibilityButtonItemMutation>;
export type UpdateAccessibilityButtonItemMutationOptions = Apollo.BaseMutationOptions<UpdateAccessibilityButtonItemMutation, UpdateAccessibilityButtonItemMutationVariables>;
export const GetAccessibilityButtonItemDocument = gql`
    query GetAccessibilityButtonItem($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageAccessibilityButtonItem {
      id
      description
      linkName
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
      iconType
    }
  }
}
    `;

/**
 * __useGetAccessibilityButtonItemQuery__
 *
 * To run a query within a React component, call `useGetAccessibilityButtonItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessibilityButtonItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessibilityButtonItemQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetAccessibilityButtonItemQuery(baseOptions: Apollo.QueryHookOptions<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>(GetAccessibilityButtonItemDocument, options);
      }
export function useGetAccessibilityButtonItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>(GetAccessibilityButtonItemDocument, options);
        }
export function useGetAccessibilityButtonItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>(GetAccessibilityButtonItemDocument, options);
        }
export type GetAccessibilityButtonItemQueryHookResult = ReturnType<typeof useGetAccessibilityButtonItemQuery>;
export type GetAccessibilityButtonItemLazyQueryHookResult = ReturnType<typeof useGetAccessibilityButtonItemLazyQuery>;
export type GetAccessibilityButtonItemSuspenseQueryHookResult = ReturnType<typeof useGetAccessibilityButtonItemSuspenseQuery>;
export type GetAccessibilityButtonItemQueryResult = Apollo.QueryResult<GetAccessibilityButtonItemQuery, GetAccessibilityButtonItemQueryVariables>;
export const RemoveAccessibilityButtonItemDocument = gql`
    mutation RemoveAccessibilityButtonItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageAccessibilityButtonItem {
      id
    }
  }
}
    `;
export type RemoveAccessibilityButtonItemMutationFn = Apollo.MutationFunction<RemoveAccessibilityButtonItemMutation, RemoveAccessibilityButtonItemMutationVariables>;

/**
 * __useRemoveAccessibilityButtonItemMutation__
 *
 * To run a mutation, you first call `useRemoveAccessibilityButtonItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessibilityButtonItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessibilityButtonItemMutation, { data, loading, error }] = useRemoveAccessibilityButtonItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveAccessibilityButtonItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccessibilityButtonItemMutation, RemoveAccessibilityButtonItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccessibilityButtonItemMutation, RemoveAccessibilityButtonItemMutationVariables>(RemoveAccessibilityButtonItemDocument, options);
      }
export type RemoveAccessibilityButtonItemMutationHookResult = ReturnType<typeof useRemoveAccessibilityButtonItemMutation>;
export type RemoveAccessibilityButtonItemMutationResult = Apollo.MutationResult<RemoveAccessibilityButtonItemMutation>;
export type RemoveAccessibilityButtonItemMutationOptions = Apollo.BaseMutationOptions<RemoveAccessibilityButtonItemMutation, RemoveAccessibilityButtonItemMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($createInput: CreateUserInput!) {
  createUser(createInput: $createInput) {
    id
    name
    middleName
    lastName
    secondSurname
    email
    phoneNumber
    address
    identificationNumber
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const RemoveUserDocument = gql`
    mutation RemoveUser($removeUserId: ID!) {
  removeUser(id: $removeUserId) {
    id
  }
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      removeUserId: // value for 'removeUserId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateInput: UpdateUserInput!) {
  updateUser(updateInput: $updateInput) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UsersAccountsDocument = gql`
    query UsersAccounts($orderBy: [FindUsersOrderBy!], $where: FindUsersWhere, $pagination: Pagination, $fullName: String) {
  users(orderBy: $orderBy, where: $where, pagination: $pagination, fullName: $fullName) {
    id
    email
    name
    fullName
    updatedAt
    status
    createdAt
    type
    identificationNumber
    updatedAt
    userRoles {
      id
      __typename
    }
    userDependencies {
      id
      createdAt
      updatedAt
      deletedAt
      status
      dependency {
        id
        createdAt
        updatedAt
        deletedAt
        name
        type
        status
        __typename
      }
      __typename
    }
    __typename
  }
  usersCount(orderBy: $orderBy, where: $where, pagination: $pagination, fullName: $fullName) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
    __typename
  }
}
    `;

/**
 * __useUsersAccountsQuery__
 *
 * To run a query within a React component, call `useUsersAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersAccountsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useUsersAccountsQuery(baseOptions?: Apollo.QueryHookOptions<UsersAccountsQuery, UsersAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersAccountsQuery, UsersAccountsQueryVariables>(UsersAccountsDocument, options);
      }
export function useUsersAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersAccountsQuery, UsersAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersAccountsQuery, UsersAccountsQueryVariables>(UsersAccountsDocument, options);
        }
export function useUsersAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersAccountsQuery, UsersAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersAccountsQuery, UsersAccountsQueryVariables>(UsersAccountsDocument, options);
        }
export type UsersAccountsQueryHookResult = ReturnType<typeof useUsersAccountsQuery>;
export type UsersAccountsLazyQueryHookResult = ReturnType<typeof useUsersAccountsLazyQuery>;
export type UsersAccountsSuspenseQueryHookResult = ReturnType<typeof useUsersAccountsSuspenseQuery>;
export type UsersAccountsQueryResult = Apollo.QueryResult<UsersAccountsQuery, UsersAccountsQueryVariables>;
export const RolesDocument = gql`
    query Roles($orderBy: [FindRolesOrderBy!], $where: FindRolesWhere, $pagination: Pagination) {
  roles(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    name
    description
    status
    users {
      id
    }
    roleFx {
      id
    }
    createdAt
    updatedAt
    deletedAt
    defaultForType
  }
  rolesCount(orderBy: $orderBy, where: $where, pagination: $pagination) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export function useRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesSuspenseQueryHookResult = ReturnType<typeof useRolesSuspenseQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const ExpireCredentialsDocument = gql`
    mutation ExpireCredentials($expireCredentialsInput: ExpireCredentialsInput!) {
  expireCredentials(expireCredentialsInput: $expireCredentialsInput) {
    id
  }
}
    `;
export type ExpireCredentialsMutationFn = Apollo.MutationFunction<ExpireCredentialsMutation, ExpireCredentialsMutationVariables>;

/**
 * __useExpireCredentialsMutation__
 *
 * To run a mutation, you first call `useExpireCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireCredentialsMutation, { data, loading, error }] = useExpireCredentialsMutation({
 *   variables: {
 *      expireCredentialsInput: // value for 'expireCredentialsInput'
 *   },
 * });
 */
export function useExpireCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<ExpireCredentialsMutation, ExpireCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireCredentialsMutation, ExpireCredentialsMutationVariables>(ExpireCredentialsDocument, options);
      }
export type ExpireCredentialsMutationHookResult = ReturnType<typeof useExpireCredentialsMutation>;
export type ExpireCredentialsMutationResult = Apollo.MutationResult<ExpireCredentialsMutation>;
export type ExpireCredentialsMutationOptions = Apollo.BaseMutationOptions<ExpireCredentialsMutation, ExpireCredentialsMutationVariables>;
export const ForceRecoverPasswordDocument = gql`
    mutation ForceRecoverPassword($recoverPasswordInput: RecoverPasswordInput!) {
  forceRecoverPassword(recoverPasswordInput: $recoverPasswordInput)
}
    `;
export type ForceRecoverPasswordMutationFn = Apollo.MutationFunction<ForceRecoverPasswordMutation, ForceRecoverPasswordMutationVariables>;

/**
 * __useForceRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useForceRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceRecoverPasswordMutation, { data, loading, error }] = useForceRecoverPasswordMutation({
 *   variables: {
 *      recoverPasswordInput: // value for 'recoverPasswordInput'
 *   },
 * });
 */
export function useForceRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForceRecoverPasswordMutation, ForceRecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceRecoverPasswordMutation, ForceRecoverPasswordMutationVariables>(ForceRecoverPasswordDocument, options);
      }
export type ForceRecoverPasswordMutationHookResult = ReturnType<typeof useForceRecoverPasswordMutation>;
export type ForceRecoverPasswordMutationResult = Apollo.MutationResult<ForceRecoverPasswordMutation>;
export type ForceRecoverPasswordMutationOptions = Apollo.BaseMutationOptions<ForceRecoverPasswordMutation, ForceRecoverPasswordMutationVariables>;
export const PageDynamicByIdNewDocument = gql`
    query PageDynamicByIdNew($versionId: ID!, $locations: [BlockLocation!]!, $dynamicId: ID, $showDisabled: Boolean) {
  pageBlocks(versionId: $versionId, locations: $locations, dynamicId: $dynamicId, showDisabled: $showDisabled) {
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      hasSignin
      hasSignup
      signinName
      signupName
      __typename
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasSignin
      hasSignup
      __typename
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      __typename
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      __typename
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
      __typename
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      taxSectionTitle
      __typename
    }
    ... on PageTransparencyBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      __typename
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      seeMoreAction
      seeMoreLink
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasSearchbar
      __typename
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      __typename
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      subtitle
      nit
      address
      postalCode
      openingHours
      phone
      fax
      citizenLine
      antiCorruptionLine
      institutionalEmail
      judicialEmail
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      __typename
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      __typename
    }
  }
}
    `;

/**
 * __usePageDynamicByIdNewQuery__
 *
 * To run a query within a React component, call `usePageDynamicByIdNewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDynamicByIdNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDynamicByIdNewQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      dynamicId: // value for 'dynamicId'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function usePageDynamicByIdNewQuery(baseOptions: Apollo.QueryHookOptions<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>(PageDynamicByIdNewDocument, options);
      }
export function usePageDynamicByIdNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>(PageDynamicByIdNewDocument, options);
        }
export function usePageDynamicByIdNewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>(PageDynamicByIdNewDocument, options);
        }
export type PageDynamicByIdNewQueryHookResult = ReturnType<typeof usePageDynamicByIdNewQuery>;
export type PageDynamicByIdNewLazyQueryHookResult = ReturnType<typeof usePageDynamicByIdNewLazyQuery>;
export type PageDynamicByIdNewSuspenseQueryHookResult = ReturnType<typeof usePageDynamicByIdNewSuspenseQuery>;
export type PageDynamicByIdNewQueryResult = Apollo.QueryResult<PageDynamicByIdNewQuery, PageDynamicByIdNewQueryVariables>;
export const CreatePageDynamicDocument = gql`
    mutation CreatePageDynamic($createInput: CreatePageDynamicInput!) {
  createPageDynamic(createInput: $createInput) {
    id
    createdAt
    updatedAt
    name
  }
}
    `;
export type CreatePageDynamicMutationFn = Apollo.MutationFunction<CreatePageDynamicMutation, CreatePageDynamicMutationVariables>;

/**
 * __useCreatePageDynamicMutation__
 *
 * To run a mutation, you first call `useCreatePageDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageDynamicMutation, { data, loading, error }] = useCreatePageDynamicMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreatePageDynamicMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageDynamicMutation, CreatePageDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageDynamicMutation, CreatePageDynamicMutationVariables>(CreatePageDynamicDocument, options);
      }
export type CreatePageDynamicMutationHookResult = ReturnType<typeof useCreatePageDynamicMutation>;
export type CreatePageDynamicMutationResult = Apollo.MutationResult<CreatePageDynamicMutation>;
export type CreatePageDynamicMutationOptions = Apollo.BaseMutationOptions<CreatePageDynamicMutation, CreatePageDynamicMutationVariables>;
export const DuplicatePageDynamicDocument = gql`
    mutation DuplicatePageDynamic($input: DuplicatePageDynamicInput!) {
  duplicatePageDynamic(input: $input) {
    id
    name
  }
}
    `;
export type DuplicatePageDynamicMutationFn = Apollo.MutationFunction<DuplicatePageDynamicMutation, DuplicatePageDynamicMutationVariables>;

/**
 * __useDuplicatePageDynamicMutation__
 *
 * To run a mutation, you first call `useDuplicatePageDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePageDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePageDynamicMutation, { data, loading, error }] = useDuplicatePageDynamicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicatePageDynamicMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePageDynamicMutation, DuplicatePageDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePageDynamicMutation, DuplicatePageDynamicMutationVariables>(DuplicatePageDynamicDocument, options);
      }
export type DuplicatePageDynamicMutationHookResult = ReturnType<typeof useDuplicatePageDynamicMutation>;
export type DuplicatePageDynamicMutationResult = Apollo.MutationResult<DuplicatePageDynamicMutation>;
export type DuplicatePageDynamicMutationOptions = Apollo.BaseMutationOptions<DuplicatePageDynamicMutation, DuplicatePageDynamicMutationVariables>;
export const PageDynamicByIdDocument = gql`
    query PageDynamicById($pageDynamicId: ID!) {
  pageDynamic(id: $pageDynamicId) {
    id
    name
    type
    description
    createdAt
    updatedAt
    status
    parent {
      id
      name
      type
      description
      createdAt
      updatedAt
      status
    }
    children {
      id
      name
      type
      description
      createdAt
      updatedAt
      status
      editors {
        id
        createdAt
        updatedAt
        deletedAt
        assignedAt
        isActive
        notes
        __typename
      }
    }
    dependency {
      id
      createdAt
      updatedAt
      deletedAt
      name
      type
      status
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __usePageDynamicByIdQuery__
 *
 * To run a query within a React component, call `usePageDynamicByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDynamicByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDynamicByIdQuery({
 *   variables: {
 *      pageDynamicId: // value for 'pageDynamicId'
 *   },
 * });
 */
export function usePageDynamicByIdQuery(baseOptions: Apollo.QueryHookOptions<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>(PageDynamicByIdDocument, options);
      }
export function usePageDynamicByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>(PageDynamicByIdDocument, options);
        }
export function usePageDynamicByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>(PageDynamicByIdDocument, options);
        }
export type PageDynamicByIdQueryHookResult = ReturnType<typeof usePageDynamicByIdQuery>;
export type PageDynamicByIdLazyQueryHookResult = ReturnType<typeof usePageDynamicByIdLazyQuery>;
export type PageDynamicByIdSuspenseQueryHookResult = ReturnType<typeof usePageDynamicByIdSuspenseQuery>;
export type PageDynamicByIdQueryResult = Apollo.QueryResult<PageDynamicByIdQuery, PageDynamicByIdQueryVariables>;
export const PageDynamicBySlugDocument = gql`
    query PageDynamicBySlug($slug: String!) {
  pageDynamicBySlug(slug: $slug) {
    id
    name
    type
    description
    createdAt
    updatedAt
    status
    parent {
      id
      name
      type
      description
      createdAt
      updatedAt
      status
    }
    children {
      id
      name
      type
      description
      createdAt
      updatedAt
      status
      editors {
        id
        createdAt
        updatedAt
        deletedAt
        assignedAt
        isActive
        notes
        __typename
      }
    }
    dependency {
      id
      createdAt
      updatedAt
      deletedAt
      name
      type
      status
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __usePageDynamicBySlugQuery__
 *
 * To run a query within a React component, call `usePageDynamicBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDynamicBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDynamicBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePageDynamicBySlugQuery(baseOptions: Apollo.QueryHookOptions<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>(PageDynamicBySlugDocument, options);
      }
export function usePageDynamicBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>(PageDynamicBySlugDocument, options);
        }
export function usePageDynamicBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>(PageDynamicBySlugDocument, options);
        }
export type PageDynamicBySlugQueryHookResult = ReturnType<typeof usePageDynamicBySlugQuery>;
export type PageDynamicBySlugLazyQueryHookResult = ReturnType<typeof usePageDynamicBySlugLazyQuery>;
export type PageDynamicBySlugSuspenseQueryHookResult = ReturnType<typeof usePageDynamicBySlugSuspenseQuery>;
export type PageDynamicBySlugQueryResult = Apollo.QueryResult<PageDynamicBySlugQuery, PageDynamicBySlugQueryVariables>;
export const FindPageBlockByDynamicDocument = gql`
    query FindPageBlockByDynamic($dynamicId: ID!) {
  findPageBlockByDynamic(dynamicId: $dynamicId) {
    id
    createdAt
    updatedAt
    deletedAt
    description
    isDisabled
    canBeDisabled
    orderIndex
    location
    pageBlockStyle
    subPages
    type
    version {
      id
    }
    __typename
    clonedFromTemplateAt
    isFromTemplate
    templateOriginId
    templateOriginName
  }
}
    `;

/**
 * __useFindPageBlockByDynamicQuery__
 *
 * To run a query within a React component, call `useFindPageBlockByDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPageBlockByDynamicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPageBlockByDynamicQuery({
 *   variables: {
 *      dynamicId: // value for 'dynamicId'
 *   },
 * });
 */
export function useFindPageBlockByDynamicQuery(baseOptions: Apollo.QueryHookOptions<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>(FindPageBlockByDynamicDocument, options);
      }
export function useFindPageBlockByDynamicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>(FindPageBlockByDynamicDocument, options);
        }
export function useFindPageBlockByDynamicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>(FindPageBlockByDynamicDocument, options);
        }
export type FindPageBlockByDynamicQueryHookResult = ReturnType<typeof useFindPageBlockByDynamicQuery>;
export type FindPageBlockByDynamicLazyQueryHookResult = ReturnType<typeof useFindPageBlockByDynamicLazyQuery>;
export type FindPageBlockByDynamicSuspenseQueryHookResult = ReturnType<typeof useFindPageBlockByDynamicSuspenseQuery>;
export type FindPageBlockByDynamicQueryResult = Apollo.QueryResult<FindPageBlockByDynamicQuery, FindPageBlockByDynamicQueryVariables>;
export const PageDynamicsDocument = gql`
    query PageDynamics($pagination: Pagination, $where: FindPageDynamicsWhere, $orderBy: [FindPageDynamicsOrderBy!]) {
  pageDynamics(pagination: $pagination, where: $where, orderBy: $orderBy) {
    createdAt
    id
    updatedAt
    deletedAt
    name
    type
    description
    status
    __typename
    parent {
      id
      name
      type
      status
    }
    children {
      id
      name
      type
      status
    }
    dependency {
      id
      createdAt
      updatedAt
      deletedAt
      name
      type
      status
    }
    editors {
      id
      createdAt
      updatedAt
      deletedAt
      assignedAt
      isActive
      notes
    }
    seo {
      metadata {
        id
        slug
      }
    }
  }
  pageDynamicsCount(pagination: $pagination, where: $where, orderBy: $orderBy) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
    __typename
  }
}
    `;

/**
 * __usePageDynamicsQuery__
 *
 * To run a query within a React component, call `usePageDynamicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDynamicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDynamicsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePageDynamicsQuery(baseOptions?: Apollo.QueryHookOptions<PageDynamicsQuery, PageDynamicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDynamicsQuery, PageDynamicsQueryVariables>(PageDynamicsDocument, options);
      }
export function usePageDynamicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDynamicsQuery, PageDynamicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDynamicsQuery, PageDynamicsQueryVariables>(PageDynamicsDocument, options);
        }
export function usePageDynamicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageDynamicsQuery, PageDynamicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageDynamicsQuery, PageDynamicsQueryVariables>(PageDynamicsDocument, options);
        }
export type PageDynamicsQueryHookResult = ReturnType<typeof usePageDynamicsQuery>;
export type PageDynamicsLazyQueryHookResult = ReturnType<typeof usePageDynamicsLazyQuery>;
export type PageDynamicsSuspenseQueryHookResult = ReturnType<typeof usePageDynamicsSuspenseQuery>;
export type PageDynamicsQueryResult = Apollo.QueryResult<PageDynamicsQuery, PageDynamicsQueryVariables>;
export const RemovePageDynamicDocument = gql`
    mutation RemovePageDynamic($removePageDynamicId: ID!) {
  removePageDynamic(id: $removePageDynamicId) {
    id
    name
  }
}
    `;
export type RemovePageDynamicMutationFn = Apollo.MutationFunction<RemovePageDynamicMutation, RemovePageDynamicMutationVariables>;

/**
 * __useRemovePageDynamicMutation__
 *
 * To run a mutation, you first call `useRemovePageDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageDynamicMutation, { data, loading, error }] = useRemovePageDynamicMutation({
 *   variables: {
 *      removePageDynamicId: // value for 'removePageDynamicId'
 *   },
 * });
 */
export function useRemovePageDynamicMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageDynamicMutation, RemovePageDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageDynamicMutation, RemovePageDynamicMutationVariables>(RemovePageDynamicDocument, options);
      }
export type RemovePageDynamicMutationHookResult = ReturnType<typeof useRemovePageDynamicMutation>;
export type RemovePageDynamicMutationResult = Apollo.MutationResult<RemovePageDynamicMutation>;
export type RemovePageDynamicMutationOptions = Apollo.BaseMutationOptions<RemovePageDynamicMutation, RemovePageDynamicMutationVariables>;
export const UpdatePageDynamicDocument = gql`
    mutation UpdatePageDynamic($updateInput: UpdatePageDynamicInput!) {
  updatePageDynamic(updateInput: $updateInput) {
    id
    createdAt
    name
  }
}
    `;
export type UpdatePageDynamicMutationFn = Apollo.MutationFunction<UpdatePageDynamicMutation, UpdatePageDynamicMutationVariables>;

/**
 * __useUpdatePageDynamicMutation__
 *
 * To run a mutation, you first call `useUpdatePageDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageDynamicMutation, { data, loading, error }] = useUpdatePageDynamicMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdatePageDynamicMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageDynamicMutation, UpdatePageDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageDynamicMutation, UpdatePageDynamicMutationVariables>(UpdatePageDynamicDocument, options);
      }
export type UpdatePageDynamicMutationHookResult = ReturnType<typeof useUpdatePageDynamicMutation>;
export type UpdatePageDynamicMutationResult = Apollo.MutationResult<UpdatePageDynamicMutation>;
export type UpdatePageDynamicMutationOptions = Apollo.BaseMutationOptions<UpdatePageDynamicMutation, UpdatePageDynamicMutationVariables>;
export const UpdateEventsItemByIdDocument = gql`
    mutation UpdateEventsItemById($updateInput: UpdateEventsItemInput!) {
  updateEventsItem(updateInput: $updateInput) {
    id
  }
}
    `;
export type UpdateEventsItemByIdMutationFn = Apollo.MutationFunction<UpdateEventsItemByIdMutation, UpdateEventsItemByIdMutationVariables>;

/**
 * __useUpdateEventsItemByIdMutation__
 *
 * To run a mutation, you first call `useUpdateEventsItemByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventsItemByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventsItemByIdMutation, { data, loading, error }] = useUpdateEventsItemByIdMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateEventsItemByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventsItemByIdMutation, UpdateEventsItemByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventsItemByIdMutation, UpdateEventsItemByIdMutationVariables>(UpdateEventsItemByIdDocument, options);
      }
export type UpdateEventsItemByIdMutationHookResult = ReturnType<typeof useUpdateEventsItemByIdMutation>;
export type UpdateEventsItemByIdMutationResult = Apollo.MutationResult<UpdateEventsItemByIdMutation>;
export type UpdateEventsItemByIdMutationOptions = Apollo.BaseMutationOptions<UpdateEventsItemByIdMutation, UpdateEventsItemByIdMutationVariables>;
export const EventsItemByIdDocument = gql`
    query EventsItemById($eventsItemId: ID!) {
  eventsItem(id: $eventsItemId) {
    id
    descriptionPlace
    latitude
    longitude
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    eventItemTitle
    eventItemDescription
    startDate
    endDate
    address
    alternativeText
    phoneEvent
    emailEvent
    groupEvent
    paymentTypeEvent
    dynamicView
    multimediaType
    eventItemTags
    summary
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useEventsItemByIdQuery__
 *
 * To run a query within a React component, call `useEventsItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsItemByIdQuery({
 *   variables: {
 *      eventsItemId: // value for 'eventsItemId'
 *   },
 * });
 */
export function useEventsItemByIdQuery(baseOptions: Apollo.QueryHookOptions<EventsItemByIdQuery, EventsItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsItemByIdQuery, EventsItemByIdQueryVariables>(EventsItemByIdDocument, options);
      }
export function useEventsItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsItemByIdQuery, EventsItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsItemByIdQuery, EventsItemByIdQueryVariables>(EventsItemByIdDocument, options);
        }
export function useEventsItemByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsItemByIdQuery, EventsItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsItemByIdQuery, EventsItemByIdQueryVariables>(EventsItemByIdDocument, options);
        }
export type EventsItemByIdQueryHookResult = ReturnType<typeof useEventsItemByIdQuery>;
export type EventsItemByIdLazyQueryHookResult = ReturnType<typeof useEventsItemByIdLazyQuery>;
export type EventsItemByIdSuspenseQueryHookResult = ReturnType<typeof useEventsItemByIdSuspenseQuery>;
export type EventsItemByIdQueryResult = Apollo.QueryResult<EventsItemByIdQuery, EventsItemByIdQueryVariables>;
export const EventsItemBySlugDocument = gql`
    query EventsItemBySlug($slug: String!) {
  eventsItemBySlug(slug: $slug) {
    id
    descriptionPlace
    latitude
    longitude
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    eventItemTitle
    eventItemDescription
    startDate
    endDate
    address
    alternativeText
    phoneEvent
    emailEvent
    groupEvent
    paymentTypeEvent
    dynamicView
    multimediaType
    eventItemTags
    summary
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useEventsItemBySlugQuery__
 *
 * To run a query within a React component, call `useEventsItemBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsItemBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsItemBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useEventsItemBySlugQuery(baseOptions: Apollo.QueryHookOptions<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>(EventsItemBySlugDocument, options);
      }
export function useEventsItemBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>(EventsItemBySlugDocument, options);
        }
export function useEventsItemBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>(EventsItemBySlugDocument, options);
        }
export type EventsItemBySlugQueryHookResult = ReturnType<typeof useEventsItemBySlugQuery>;
export type EventsItemBySlugLazyQueryHookResult = ReturnType<typeof useEventsItemBySlugLazyQuery>;
export type EventsItemBySlugSuspenseQueryHookResult = ReturnType<typeof useEventsItemBySlugSuspenseQuery>;
export type EventsItemBySlugQueryResult = Apollo.QueryResult<EventsItemBySlugQuery, EventsItemBySlugQueryVariables>;
export const CreateEventsItemDocument = gql`
    mutation CreateEventsItem($createInput: CreateEventsItemInput!) {
  createEventsItem(createInput: $createInput) {
    id
    eventItemTitle
    eventItemDescription
    linkItem {
      routeType
      arguments
      target
      routeNavigation
      url
    }
    latitude
    longitude
    descriptionPlace
    eventItemTags
    multimediaType
    startDate
    endDate
    address
  }
}
    `;
export type CreateEventsItemMutationFn = Apollo.MutationFunction<CreateEventsItemMutation, CreateEventsItemMutationVariables>;

/**
 * __useCreateEventsItemMutation__
 *
 * To run a mutation, you first call `useCreateEventsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventsItemMutation, { data, loading, error }] = useCreateEventsItemMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateEventsItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventsItemMutation, CreateEventsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventsItemMutation, CreateEventsItemMutationVariables>(CreateEventsItemDocument, options);
      }
export type CreateEventsItemMutationHookResult = ReturnType<typeof useCreateEventsItemMutation>;
export type CreateEventsItemMutationResult = Apollo.MutationResult<CreateEventsItemMutation>;
export type CreateEventsItemMutationOptions = Apollo.BaseMutationOptions<CreateEventsItemMutation, CreateEventsItemMutationVariables>;
export const EventsItemsDocument = gql`
    query EventsItems($where: FindEventWhere, $pagination: Pagination, $orderBy: [FindEventOrderBy!], $contentSchemaId: String, $targetDependencyId: String) {
  eventsItems(where: $where, orderBy: $orderBy, pagination: $pagination, contentSchemaId: $contentSchemaId, targetDependencyId: $targetDependencyId) {
    startDate
    endDate
    createdAt
    eventStatus
    id
    eventItemTitle
    contentSchema {
      id
      name
    }
    dependency {
      id
      name
    }
    sharedWith {
      targetDependency {
        id
        name
      }
    }
  }
  eventsItemsCount(pagination: $pagination, where: $where, contentSchemaId: $contentSchemaId) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useEventsItemsQuery__
 *
 * To run a query within a React component, call `useEventsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      contentSchemaId: // value for 'contentSchemaId'
 *      targetDependencyId: // value for 'targetDependencyId'
 *   },
 * });
 */
export function useEventsItemsQuery(baseOptions?: Apollo.QueryHookOptions<EventsItemsQuery, EventsItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsItemsQuery, EventsItemsQueryVariables>(EventsItemsDocument, options);
      }
export function useEventsItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsItemsQuery, EventsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsItemsQuery, EventsItemsQueryVariables>(EventsItemsDocument, options);
        }
export function useEventsItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsItemsQuery, EventsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsItemsQuery, EventsItemsQueryVariables>(EventsItemsDocument, options);
        }
export type EventsItemsQueryHookResult = ReturnType<typeof useEventsItemsQuery>;
export type EventsItemsLazyQueryHookResult = ReturnType<typeof useEventsItemsLazyQuery>;
export type EventsItemsSuspenseQueryHookResult = ReturnType<typeof useEventsItemsSuspenseQuery>;
export type EventsItemsQueryResult = Apollo.QueryResult<EventsItemsQuery, EventsItemsQueryVariables>;
export const AllEventsDocument = gql`
    query AllEvents($where: FindEventWhere, $pagination: Pagination, $orderBy: [FindEventOrderBy!], $targetDependencyId: String) {
  eventsItems(where: $where, orderBy: $orderBy, pagination: $pagination, targetDependencyId: $targetDependencyId) {
    id
    endDate
    startDate
    createdAt
    eventStatus
    eventItemTitle
    contentSchema {
      id
      name
    }
    dependency {
      id
      name
    }
    sharedWith {
      targetDependency {
        id
        name
      }
    }
  }
  eventsItemsCount(pagination: $pagination, where: $where) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useAllEventsQuery__
 *
 * To run a query within a React component, call `useAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEventsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      targetDependencyId: // value for 'targetDependencyId'
 *   },
 * });
 */
export function useAllEventsQuery(baseOptions?: Apollo.QueryHookOptions<AllEventsQuery, AllEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, options);
      }
export function useAllEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEventsQuery, AllEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, options);
        }
export function useAllEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllEventsQuery, AllEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, options);
        }
export type AllEventsQueryHookResult = ReturnType<typeof useAllEventsQuery>;
export type AllEventsLazyQueryHookResult = ReturnType<typeof useAllEventsLazyQuery>;
export type AllEventsSuspenseQueryHookResult = ReturnType<typeof useAllEventsSuspenseQuery>;
export type AllEventsQueryResult = Apollo.QueryResult<AllEventsQuery, AllEventsQueryVariables>;
export const UpdateEventsItemDocument = gql`
    mutation UpdateEventsItem($updateInput: UpdateEventsItemInput!) {
  updateEventsItem(updateInput: $updateInput) {
    eventStatus
    id
  }
}
    `;
export type UpdateEventsItemMutationFn = Apollo.MutationFunction<UpdateEventsItemMutation, UpdateEventsItemMutationVariables>;

/**
 * __useUpdateEventsItemMutation__
 *
 * To run a mutation, you first call `useUpdateEventsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventsItemMutation, { data, loading, error }] = useUpdateEventsItemMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateEventsItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventsItemMutation, UpdateEventsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventsItemMutation, UpdateEventsItemMutationVariables>(UpdateEventsItemDocument, options);
      }
export type UpdateEventsItemMutationHookResult = ReturnType<typeof useUpdateEventsItemMutation>;
export type UpdateEventsItemMutationResult = Apollo.MutationResult<UpdateEventsItemMutation>;
export type UpdateEventsItemMutationOptions = Apollo.BaseMutationOptions<UpdateEventsItemMutation, UpdateEventsItemMutationVariables>;
export const UpdateEventStatusToDraftDocument = gql`
    mutation UpdateEventStatusToDraft($updateEventStatusToDraft: UpdateEventItemStatus!) {
  updateEventStatusToDraft(updateEventStatusToDraft: $updateEventStatusToDraft)
}
    `;
export type UpdateEventStatusToDraftMutationFn = Apollo.MutationFunction<UpdateEventStatusToDraftMutation, UpdateEventStatusToDraftMutationVariables>;

/**
 * __useUpdateEventStatusToDraftMutation__
 *
 * To run a mutation, you first call `useUpdateEventStatusToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventStatusToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventStatusToDraftMutation, { data, loading, error }] = useUpdateEventStatusToDraftMutation({
 *   variables: {
 *      updateEventStatusToDraft: // value for 'updateEventStatusToDraft'
 *   },
 * });
 */
export function useUpdateEventStatusToDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventStatusToDraftMutation, UpdateEventStatusToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventStatusToDraftMutation, UpdateEventStatusToDraftMutationVariables>(UpdateEventStatusToDraftDocument, options);
      }
export type UpdateEventStatusToDraftMutationHookResult = ReturnType<typeof useUpdateEventStatusToDraftMutation>;
export type UpdateEventStatusToDraftMutationResult = Apollo.MutationResult<UpdateEventStatusToDraftMutation>;
export type UpdateEventStatusToDraftMutationOptions = Apollo.BaseMutationOptions<UpdateEventStatusToDraftMutation, UpdateEventStatusToDraftMutationVariables>;
export const RemoveEventsItemDocument = gql`
    mutation RemoveEventsItem($removeEventsItemId: ID!) {
  removeEventsItem(id: $removeEventsItemId) {
    id
  }
}
    `;
export type RemoveEventsItemMutationFn = Apollo.MutationFunction<RemoveEventsItemMutation, RemoveEventsItemMutationVariables>;

/**
 * __useRemoveEventsItemMutation__
 *
 * To run a mutation, you first call `useRemoveEventsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventsItemMutation, { data, loading, error }] = useRemoveEventsItemMutation({
 *   variables: {
 *      removeEventsItemId: // value for 'removeEventsItemId'
 *   },
 * });
 */
export function useRemoveEventsItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventsItemMutation, RemoveEventsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventsItemMutation, RemoveEventsItemMutationVariables>(RemoveEventsItemDocument, options);
      }
export type RemoveEventsItemMutationHookResult = ReturnType<typeof useRemoveEventsItemMutation>;
export type RemoveEventsItemMutationResult = Apollo.MutationResult<RemoveEventsItemMutation>;
export type RemoveEventsItemMutationOptions = Apollo.BaseMutationOptions<RemoveEventsItemMutation, RemoveEventsItemMutationVariables>;
export const UpdateInstitutionalProgramsItemNewDocument = gql`
    mutation UpdateInstitutionalProgramsItemNew($updateInput: UpdateInstitutionalProgramsItemInput!) {
  updateInstitutionalProgramsItem(updateInput: $updateInput) {
    id
    title
    description
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    pageLink {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    programsType
    programsStatus
  }
}
    `;
export type UpdateInstitutionalProgramsItemNewMutationFn = Apollo.MutationFunction<UpdateInstitutionalProgramsItemNewMutation, UpdateInstitutionalProgramsItemNewMutationVariables>;

/**
 * __useUpdateInstitutionalProgramsItemNewMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionalProgramsItemNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionalProgramsItemNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionalProgramsItemNewMutation, { data, loading, error }] = useUpdateInstitutionalProgramsItemNewMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateInstitutionalProgramsItemNewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionalProgramsItemNewMutation, UpdateInstitutionalProgramsItemNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionalProgramsItemNewMutation, UpdateInstitutionalProgramsItemNewMutationVariables>(UpdateInstitutionalProgramsItemNewDocument, options);
      }
export type UpdateInstitutionalProgramsItemNewMutationHookResult = ReturnType<typeof useUpdateInstitutionalProgramsItemNewMutation>;
export type UpdateInstitutionalProgramsItemNewMutationResult = Apollo.MutationResult<UpdateInstitutionalProgramsItemNewMutation>;
export type UpdateInstitutionalProgramsItemNewMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionalProgramsItemNewMutation, UpdateInstitutionalProgramsItemNewMutationVariables>;
export const InstitutionalProgramsItemDocument = gql`
    query InstitutionalProgramsItem($institutionalProgramsItemId: ID!) {
  institutionalProgramsItem(id: $institutionalProgramsItemId) {
    id
    title
    description
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    pageLink {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    programsType
  }
}
    `;

/**
 * __useInstitutionalProgramsItemQuery__
 *
 * To run a query within a React component, call `useInstitutionalProgramsItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstitutionalProgramsItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstitutionalProgramsItemQuery({
 *   variables: {
 *      institutionalProgramsItemId: // value for 'institutionalProgramsItemId'
 *   },
 * });
 */
export function useInstitutionalProgramsItemQuery(baseOptions: Apollo.QueryHookOptions<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>(InstitutionalProgramsItemDocument, options);
      }
export function useInstitutionalProgramsItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>(InstitutionalProgramsItemDocument, options);
        }
export function useInstitutionalProgramsItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>(InstitutionalProgramsItemDocument, options);
        }
export type InstitutionalProgramsItemQueryHookResult = ReturnType<typeof useInstitutionalProgramsItemQuery>;
export type InstitutionalProgramsItemLazyQueryHookResult = ReturnType<typeof useInstitutionalProgramsItemLazyQuery>;
export type InstitutionalProgramsItemSuspenseQueryHookResult = ReturnType<typeof useInstitutionalProgramsItemSuspenseQuery>;
export type InstitutionalProgramsItemQueryResult = Apollo.QueryResult<InstitutionalProgramsItemQuery, InstitutionalProgramsItemQueryVariables>;
export const UpdateInstitutionalProgramsStatusToDraftDocument = gql`
    mutation UpdateInstitutionalProgramsStatusToDraft($updateInstitutionalProgramsItemStatus: UpdateInstitutionalProgramsItemStatus!) {
  updateInstitutionalProgramsStatusToDraft(updateInstitutionalProgramsItemStatus: $updateInstitutionalProgramsItemStatus)
}
    `;
export type UpdateInstitutionalProgramsStatusToDraftMutationFn = Apollo.MutationFunction<UpdateInstitutionalProgramsStatusToDraftMutation, UpdateInstitutionalProgramsStatusToDraftMutationVariables>;

/**
 * __useUpdateInstitutionalProgramsStatusToDraftMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionalProgramsStatusToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionalProgramsStatusToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionalProgramsStatusToDraftMutation, { data, loading, error }] = useUpdateInstitutionalProgramsStatusToDraftMutation({
 *   variables: {
 *      updateInstitutionalProgramsItemStatus: // value for 'updateInstitutionalProgramsItemStatus'
 *   },
 * });
 */
export function useUpdateInstitutionalProgramsStatusToDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionalProgramsStatusToDraftMutation, UpdateInstitutionalProgramsStatusToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionalProgramsStatusToDraftMutation, UpdateInstitutionalProgramsStatusToDraftMutationVariables>(UpdateInstitutionalProgramsStatusToDraftDocument, options);
      }
export type UpdateInstitutionalProgramsStatusToDraftMutationHookResult = ReturnType<typeof useUpdateInstitutionalProgramsStatusToDraftMutation>;
export type UpdateInstitutionalProgramsStatusToDraftMutationResult = Apollo.MutationResult<UpdateInstitutionalProgramsStatusToDraftMutation>;
export type UpdateInstitutionalProgramsStatusToDraftMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionalProgramsStatusToDraftMutation, UpdateInstitutionalProgramsStatusToDraftMutationVariables>;
export const InstitutionalProgramsItemsDocument = gql`
    query InstitutionalProgramsItems($where: FindInstitutionalProgramsItemWhere, $orderBy: [FindInstitutionalProgramsOrderBy!], $pagination: Pagination) {
  institutionalProgramsItems(where: $where, orderBy: $orderBy, pagination: $pagination) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    description
    pageLink {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    programsStatus
    programsType
  }
  institutionalProgramsItemsCount(pagination: $pagination) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useInstitutionalProgramsItemsQuery__
 *
 * To run a query within a React component, call `useInstitutionalProgramsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstitutionalProgramsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstitutionalProgramsItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useInstitutionalProgramsItemsQuery(baseOptions?: Apollo.QueryHookOptions<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>(InstitutionalProgramsItemsDocument, options);
      }
export function useInstitutionalProgramsItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>(InstitutionalProgramsItemsDocument, options);
        }
export function useInstitutionalProgramsItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>(InstitutionalProgramsItemsDocument, options);
        }
export type InstitutionalProgramsItemsQueryHookResult = ReturnType<typeof useInstitutionalProgramsItemsQuery>;
export type InstitutionalProgramsItemsLazyQueryHookResult = ReturnType<typeof useInstitutionalProgramsItemsLazyQuery>;
export type InstitutionalProgramsItemsSuspenseQueryHookResult = ReturnType<typeof useInstitutionalProgramsItemsSuspenseQuery>;
export type InstitutionalProgramsItemsQueryResult = Apollo.QueryResult<InstitutionalProgramsItemsQuery, InstitutionalProgramsItemsQueryVariables>;
export const CreateInstitutionalProgramsItemDocument = gql`
    mutation CreateInstitutionalProgramsItem($createInput: CreateInstitutionalProgramsItemInput!) {
  createInstitutionalProgramsItem(createInput: $createInput) {
    id
    title
    description
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    programsType
    pageLink {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    programsStatus
  }
}
    `;
export type CreateInstitutionalProgramsItemMutationFn = Apollo.MutationFunction<CreateInstitutionalProgramsItemMutation, CreateInstitutionalProgramsItemMutationVariables>;

/**
 * __useCreateInstitutionalProgramsItemMutation__
 *
 * To run a mutation, you first call `useCreateInstitutionalProgramsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstitutionalProgramsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstitutionalProgramsItemMutation, { data, loading, error }] = useCreateInstitutionalProgramsItemMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateInstitutionalProgramsItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstitutionalProgramsItemMutation, CreateInstitutionalProgramsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstitutionalProgramsItemMutation, CreateInstitutionalProgramsItemMutationVariables>(CreateInstitutionalProgramsItemDocument, options);
      }
export type CreateInstitutionalProgramsItemMutationHookResult = ReturnType<typeof useCreateInstitutionalProgramsItemMutation>;
export type CreateInstitutionalProgramsItemMutationResult = Apollo.MutationResult<CreateInstitutionalProgramsItemMutation>;
export type CreateInstitutionalProgramsItemMutationOptions = Apollo.BaseMutationOptions<CreateInstitutionalProgramsItemMutation, CreateInstitutionalProgramsItemMutationVariables>;
export const UpdateInstitutionalProgramsItemDocument = gql`
    mutation UpdateInstitutionalProgramsItem($updateInput: UpdateInstitutionalProgramsItemInput!) {
  updateInstitutionalProgramsItem(updateInput: $updateInput) {
    id
  }
}
    `;
export type UpdateInstitutionalProgramsItemMutationFn = Apollo.MutationFunction<UpdateInstitutionalProgramsItemMutation, UpdateInstitutionalProgramsItemMutationVariables>;

/**
 * __useUpdateInstitutionalProgramsItemMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionalProgramsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionalProgramsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionalProgramsItemMutation, { data, loading, error }] = useUpdateInstitutionalProgramsItemMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateInstitutionalProgramsItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionalProgramsItemMutation, UpdateInstitutionalProgramsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionalProgramsItemMutation, UpdateInstitutionalProgramsItemMutationVariables>(UpdateInstitutionalProgramsItemDocument, options);
      }
export type UpdateInstitutionalProgramsItemMutationHookResult = ReturnType<typeof useUpdateInstitutionalProgramsItemMutation>;
export type UpdateInstitutionalProgramsItemMutationResult = Apollo.MutationResult<UpdateInstitutionalProgramsItemMutation>;
export type UpdateInstitutionalProgramsItemMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionalProgramsItemMutation, UpdateInstitutionalProgramsItemMutationVariables>;
export const RemoveInstitutionalProgramsItemDocument = gql`
    mutation RemoveInstitutionalProgramsItem($removeInstitutionalProgramsItemId: ID!) {
  removeInstitutionalProgramsItem(id: $removeInstitutionalProgramsItemId) {
    id
  }
}
    `;
export type RemoveInstitutionalProgramsItemMutationFn = Apollo.MutationFunction<RemoveInstitutionalProgramsItemMutation, RemoveInstitutionalProgramsItemMutationVariables>;

/**
 * __useRemoveInstitutionalProgramsItemMutation__
 *
 * To run a mutation, you first call `useRemoveInstitutionalProgramsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInstitutionalProgramsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInstitutionalProgramsItemMutation, { data, loading, error }] = useRemoveInstitutionalProgramsItemMutation({
 *   variables: {
 *      removeInstitutionalProgramsItemId: // value for 'removeInstitutionalProgramsItemId'
 *   },
 * });
 */
export function useRemoveInstitutionalProgramsItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInstitutionalProgramsItemMutation, RemoveInstitutionalProgramsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInstitutionalProgramsItemMutation, RemoveInstitutionalProgramsItemMutationVariables>(RemoveInstitutionalProgramsItemDocument, options);
      }
export type RemoveInstitutionalProgramsItemMutationHookResult = ReturnType<typeof useRemoveInstitutionalProgramsItemMutation>;
export type RemoveInstitutionalProgramsItemMutationResult = Apollo.MutationResult<RemoveInstitutionalProgramsItemMutation>;
export type RemoveInstitutionalProgramsItemMutationOptions = Apollo.BaseMutationOptions<RemoveInstitutionalProgramsItemMutation, RemoveInstitutionalProgramsItemMutationVariables>;
export const PqrsdActionContentsAdminDocument = gql`
    query PqrsdActionContentsAdmin($orderBy: [FindProceduresOrderBy!], $where: FindProceduresWhere, $pagination: Pagination) {
  procedures(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    name
    procedureDescription
    procedureStatus
    createdAt
    updatedAt
    createdAt
  }
  proceduresCount(orderBy: $orderBy, where: $where, pagination: $pagination) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __usePqrsdActionContentsAdminQuery__
 *
 * To run a query within a React component, call `usePqrsdActionContentsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePqrsdActionContentsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePqrsdActionContentsAdminQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePqrsdActionContentsAdminQuery(baseOptions?: Apollo.QueryHookOptions<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>(PqrsdActionContentsAdminDocument, options);
      }
export function usePqrsdActionContentsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>(PqrsdActionContentsAdminDocument, options);
        }
export function usePqrsdActionContentsAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>(PqrsdActionContentsAdminDocument, options);
        }
export type PqrsdActionContentsAdminQueryHookResult = ReturnType<typeof usePqrsdActionContentsAdminQuery>;
export type PqrsdActionContentsAdminLazyQueryHookResult = ReturnType<typeof usePqrsdActionContentsAdminLazyQuery>;
export type PqrsdActionContentsAdminSuspenseQueryHookResult = ReturnType<typeof usePqrsdActionContentsAdminSuspenseQuery>;
export type PqrsdActionContentsAdminQueryResult = Apollo.QueryResult<PqrsdActionContentsAdminQuery, PqrsdActionContentsAdminQueryVariables>;
export const PqrsdActionContentAdminDocument = gql`
    query PqrsdActionContentAdmin($dynamicPageId: ID!) {
  procedure(id: $dynamicPageId) {
    id
    name
    procedureDescription
    processDefinitionId
    govcoImage {
      id
      fileExtension
      fileMode
      fileMongoId
      fileName
      url
    }
    linkItem {
      id
      url
      arguments
      routeNavigation
      routeType
      target
    }
  }
}
    `;

/**
 * __usePqrsdActionContentAdminQuery__
 *
 * To run a query within a React component, call `usePqrsdActionContentAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePqrsdActionContentAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePqrsdActionContentAdminQuery({
 *   variables: {
 *      dynamicPageId: // value for 'dynamicPageId'
 *   },
 * });
 */
export function usePqrsdActionContentAdminQuery(baseOptions: Apollo.QueryHookOptions<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>(PqrsdActionContentAdminDocument, options);
      }
export function usePqrsdActionContentAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>(PqrsdActionContentAdminDocument, options);
        }
export function usePqrsdActionContentAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>(PqrsdActionContentAdminDocument, options);
        }
export type PqrsdActionContentAdminQueryHookResult = ReturnType<typeof usePqrsdActionContentAdminQuery>;
export type PqrsdActionContentAdminLazyQueryHookResult = ReturnType<typeof usePqrsdActionContentAdminLazyQuery>;
export type PqrsdActionContentAdminSuspenseQueryHookResult = ReturnType<typeof usePqrsdActionContentAdminSuspenseQuery>;
export type PqrsdActionContentAdminQueryResult = Apollo.QueryResult<PqrsdActionContentAdminQuery, PqrsdActionContentAdminQueryVariables>;
export const CreatePqrsdActionContentAdminDocument = gql`
    mutation CreatePqrsdActionContentAdmin($createInput: CreateProcedureInput!) {
  createProcedure(createInput: $createInput) {
    id
    name
  }
}
    `;
export type CreatePqrsdActionContentAdminMutationFn = Apollo.MutationFunction<CreatePqrsdActionContentAdminMutation, CreatePqrsdActionContentAdminMutationVariables>;

/**
 * __useCreatePqrsdActionContentAdminMutation__
 *
 * To run a mutation, you first call `useCreatePqrsdActionContentAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePqrsdActionContentAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPqrsdActionContentAdminMutation, { data, loading, error }] = useCreatePqrsdActionContentAdminMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreatePqrsdActionContentAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreatePqrsdActionContentAdminMutation, CreatePqrsdActionContentAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePqrsdActionContentAdminMutation, CreatePqrsdActionContentAdminMutationVariables>(CreatePqrsdActionContentAdminDocument, options);
      }
export type CreatePqrsdActionContentAdminMutationHookResult = ReturnType<typeof useCreatePqrsdActionContentAdminMutation>;
export type CreatePqrsdActionContentAdminMutationResult = Apollo.MutationResult<CreatePqrsdActionContentAdminMutation>;
export type CreatePqrsdActionContentAdminMutationOptions = Apollo.BaseMutationOptions<CreatePqrsdActionContentAdminMutation, CreatePqrsdActionContentAdminMutationVariables>;
export const UpdatePqrsdActionContentAdminDocument = gql`
    mutation UpdatePqrsdActionContentAdmin($updateInput: UpdateProcedureInput!) {
  updateProcedure(updateInput: $updateInput) {
    id
    name
  }
}
    `;
export type UpdatePqrsdActionContentAdminMutationFn = Apollo.MutationFunction<UpdatePqrsdActionContentAdminMutation, UpdatePqrsdActionContentAdminMutationVariables>;

/**
 * __useUpdatePqrsdActionContentAdminMutation__
 *
 * To run a mutation, you first call `useUpdatePqrsdActionContentAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePqrsdActionContentAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePqrsdActionContentAdminMutation, { data, loading, error }] = useUpdatePqrsdActionContentAdminMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdatePqrsdActionContentAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePqrsdActionContentAdminMutation, UpdatePqrsdActionContentAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePqrsdActionContentAdminMutation, UpdatePqrsdActionContentAdminMutationVariables>(UpdatePqrsdActionContentAdminDocument, options);
      }
export type UpdatePqrsdActionContentAdminMutationHookResult = ReturnType<typeof useUpdatePqrsdActionContentAdminMutation>;
export type UpdatePqrsdActionContentAdminMutationResult = Apollo.MutationResult<UpdatePqrsdActionContentAdminMutation>;
export type UpdatePqrsdActionContentAdminMutationOptions = Apollo.BaseMutationOptions<UpdatePqrsdActionContentAdminMutation, UpdatePqrsdActionContentAdminMutationVariables>;
export const RemovePqrsdActionContentAdminDocument = gql`
    mutation RemovePqrsdActionContentAdmin($removeProcedureId: ID!) {
  removeProcedure(id: $removeProcedureId) {
    id
  }
}
    `;
export type RemovePqrsdActionContentAdminMutationFn = Apollo.MutationFunction<RemovePqrsdActionContentAdminMutation, RemovePqrsdActionContentAdminMutationVariables>;

/**
 * __useRemovePqrsdActionContentAdminMutation__
 *
 * To run a mutation, you first call `useRemovePqrsdActionContentAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePqrsdActionContentAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePqrsdActionContentAdminMutation, { data, loading, error }] = useRemovePqrsdActionContentAdminMutation({
 *   variables: {
 *      removeProcedureId: // value for 'removeProcedureId'
 *   },
 * });
 */
export function useRemovePqrsdActionContentAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemovePqrsdActionContentAdminMutation, RemovePqrsdActionContentAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePqrsdActionContentAdminMutation, RemovePqrsdActionContentAdminMutationVariables>(RemovePqrsdActionContentAdminDocument, options);
      }
export type RemovePqrsdActionContentAdminMutationHookResult = ReturnType<typeof useRemovePqrsdActionContentAdminMutation>;
export type RemovePqrsdActionContentAdminMutationResult = Apollo.MutationResult<RemovePqrsdActionContentAdminMutation>;
export type RemovePqrsdActionContentAdminMutationOptions = Apollo.BaseMutationOptions<RemovePqrsdActionContentAdminMutation, RemovePqrsdActionContentAdminMutationVariables>;
export const UpdatePqrsdActionContentStatusToDraftDocument = gql`
    mutation UpdatePqrsdActionContentStatusToDraft($updateProcedureStatusToDraft: UpdateProcedureStatusToDraft!) {
  updateProcedureStatusToDraft(updateProcedureStatusToDraft: $updateProcedureStatusToDraft)
}
    `;
export type UpdatePqrsdActionContentStatusToDraftMutationFn = Apollo.MutationFunction<UpdatePqrsdActionContentStatusToDraftMutation, UpdatePqrsdActionContentStatusToDraftMutationVariables>;

/**
 * __useUpdatePqrsdActionContentStatusToDraftMutation__
 *
 * To run a mutation, you first call `useUpdatePqrsdActionContentStatusToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePqrsdActionContentStatusToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePqrsdActionContentStatusToDraftMutation, { data, loading, error }] = useUpdatePqrsdActionContentStatusToDraftMutation({
 *   variables: {
 *      updateProcedureStatusToDraft: // value for 'updateProcedureStatusToDraft'
 *   },
 * });
 */
export function useUpdatePqrsdActionContentStatusToDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePqrsdActionContentStatusToDraftMutation, UpdatePqrsdActionContentStatusToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePqrsdActionContentStatusToDraftMutation, UpdatePqrsdActionContentStatusToDraftMutationVariables>(UpdatePqrsdActionContentStatusToDraftDocument, options);
      }
export type UpdatePqrsdActionContentStatusToDraftMutationHookResult = ReturnType<typeof useUpdatePqrsdActionContentStatusToDraftMutation>;
export type UpdatePqrsdActionContentStatusToDraftMutationResult = Apollo.MutationResult<UpdatePqrsdActionContentStatusToDraftMutation>;
export type UpdatePqrsdActionContentStatusToDraftMutationOptions = Apollo.BaseMutationOptions<UpdatePqrsdActionContentStatusToDraftMutation, UpdatePqrsdActionContentStatusToDraftMutationVariables>;
export const CreateNewsItemNewsDocument = gql`
    mutation CreateNewsItemNews($createInput: CreateNewsItemInput!) {
  createNewsItem(createInput: $createInput) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    content
    expiredDate
    alternativeText
  }
}
    `;
export type CreateNewsItemNewsMutationFn = Apollo.MutationFunction<CreateNewsItemNewsMutation, CreateNewsItemNewsMutationVariables>;

/**
 * __useCreateNewsItemNewsMutation__
 *
 * To run a mutation, you first call `useCreateNewsItemNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsItemNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsItemNewsMutation, { data, loading, error }] = useCreateNewsItemNewsMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateNewsItemNewsMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsItemNewsMutation, CreateNewsItemNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsItemNewsMutation, CreateNewsItemNewsMutationVariables>(CreateNewsItemNewsDocument, options);
      }
export type CreateNewsItemNewsMutationHookResult = ReturnType<typeof useCreateNewsItemNewsMutation>;
export type CreateNewsItemNewsMutationResult = Apollo.MutationResult<CreateNewsItemNewsMutation>;
export type CreateNewsItemNewsMutationOptions = Apollo.BaseMutationOptions<CreateNewsItemNewsMutation, CreateNewsItemNewsMutationVariables>;
export const NewsItemNewDocument = gql`
    query NewsItemNew($newsItemId: ID!) {
  newsItem(id: $newsItemId) {
    id
    multimediaType
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
      __typename
    }
    title
    summary
    newsItemTags
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      downloadUrl
      fileExtension
      fileMode
      fileMongoId
      url
      __typename
    }
    createdAt
    updatedAt
    deletedAt
    date
    content
    expiredDate
    hasExpirationDate
    alternativeText
    newsStatus
    __typename
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useNewsItemNewQuery__
 *
 * To run a query within a React component, call `useNewsItemNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemNewQuery({
 *   variables: {
 *      newsItemId: // value for 'newsItemId'
 *   },
 * });
 */
export function useNewsItemNewQuery(baseOptions: Apollo.QueryHookOptions<NewsItemNewQuery, NewsItemNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemNewQuery, NewsItemNewQueryVariables>(NewsItemNewDocument, options);
      }
export function useNewsItemNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemNewQuery, NewsItemNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemNewQuery, NewsItemNewQueryVariables>(NewsItemNewDocument, options);
        }
export function useNewsItemNewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemNewQuery, NewsItemNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemNewQuery, NewsItemNewQueryVariables>(NewsItemNewDocument, options);
        }
export type NewsItemNewQueryHookResult = ReturnType<typeof useNewsItemNewQuery>;
export type NewsItemNewLazyQueryHookResult = ReturnType<typeof useNewsItemNewLazyQuery>;
export type NewsItemNewSuspenseQueryHookResult = ReturnType<typeof useNewsItemNewSuspenseQuery>;
export type NewsItemNewQueryResult = Apollo.QueryResult<NewsItemNewQuery, NewsItemNewQueryVariables>;
export const CreateNewsItemManagementDocument = gql`
    mutation CreateNewsItemManagement($createInput: CreateNewsItemInput!) {
  createNewsItem(createInput: $createInput) {
    title
    content
    date
    expiredDate
    newsItemTags
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
  }
}
    `;
export type CreateNewsItemManagementMutationFn = Apollo.MutationFunction<CreateNewsItemManagementMutation, CreateNewsItemManagementMutationVariables>;

/**
 * __useCreateNewsItemManagementMutation__
 *
 * To run a mutation, you first call `useCreateNewsItemManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsItemManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsItemManagementMutation, { data, loading, error }] = useCreateNewsItemManagementMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateNewsItemManagementMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsItemManagementMutation, CreateNewsItemManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsItemManagementMutation, CreateNewsItemManagementMutationVariables>(CreateNewsItemManagementDocument, options);
      }
export type CreateNewsItemManagementMutationHookResult = ReturnType<typeof useCreateNewsItemManagementMutation>;
export type CreateNewsItemManagementMutationResult = Apollo.MutationResult<CreateNewsItemManagementMutation>;
export type CreateNewsItemManagementMutationOptions = Apollo.BaseMutationOptions<CreateNewsItemManagementMutation, CreateNewsItemManagementMutationVariables>;
export const UpdateNewsItemNewDocument = gql`
    mutation UpdateNewsItemNew($updateInput: UpdateNewsItemInput!) {
  updateNewsItem(updateInput: $updateInput) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    content
    date
    expiredDate
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    summary
    newsStatus
    alternativeText
    newsItemTags
  }
}
    `;
export type UpdateNewsItemNewMutationFn = Apollo.MutationFunction<UpdateNewsItemNewMutation, UpdateNewsItemNewMutationVariables>;

/**
 * __useUpdateNewsItemNewMutation__
 *
 * To run a mutation, you first call `useUpdateNewsItemNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsItemNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsItemNewMutation, { data, loading, error }] = useUpdateNewsItemNewMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateNewsItemNewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsItemNewMutation, UpdateNewsItemNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsItemNewMutation, UpdateNewsItemNewMutationVariables>(UpdateNewsItemNewDocument, options);
      }
export type UpdateNewsItemNewMutationHookResult = ReturnType<typeof useUpdateNewsItemNewMutation>;
export type UpdateNewsItemNewMutationResult = Apollo.MutationResult<UpdateNewsItemNewMutation>;
export type UpdateNewsItemNewMutationOptions = Apollo.BaseMutationOptions<UpdateNewsItemNewMutation, UpdateNewsItemNewMutationVariables>;
export const UpdateNewsItemDocument = gql`
    mutation UpdateNewsItem($updateInput: UpdateNewsItemInput!) {
  updateNewsItem(updateInput: $updateInput) {
    newsStatus
  }
}
    `;
export type UpdateNewsItemMutationFn = Apollo.MutationFunction<UpdateNewsItemMutation, UpdateNewsItemMutationVariables>;

/**
 * __useUpdateNewsItemMutation__
 *
 * To run a mutation, you first call `useUpdateNewsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsItemMutation, { data, loading, error }] = useUpdateNewsItemMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateNewsItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsItemMutation, UpdateNewsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsItemMutation, UpdateNewsItemMutationVariables>(UpdateNewsItemDocument, options);
      }
export type UpdateNewsItemMutationHookResult = ReturnType<typeof useUpdateNewsItemMutation>;
export type UpdateNewsItemMutationResult = Apollo.MutationResult<UpdateNewsItemMutation>;
export type UpdateNewsItemMutationOptions = Apollo.BaseMutationOptions<UpdateNewsItemMutation, UpdateNewsItemMutationVariables>;
export const RemoveNewsItemDocument = gql`
    mutation RemoveNewsItem($removeNewsItemId: ID!) {
  removeNewsItem(id: $removeNewsItemId) {
    id
  }
}
    `;
export type RemoveNewsItemMutationFn = Apollo.MutationFunction<RemoveNewsItemMutation, RemoveNewsItemMutationVariables>;

/**
 * __useRemoveNewsItemMutation__
 *
 * To run a mutation, you first call `useRemoveNewsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNewsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNewsItemMutation, { data, loading, error }] = useRemoveNewsItemMutation({
 *   variables: {
 *      removeNewsItemId: // value for 'removeNewsItemId'
 *   },
 * });
 */
export function useRemoveNewsItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNewsItemMutation, RemoveNewsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNewsItemMutation, RemoveNewsItemMutationVariables>(RemoveNewsItemDocument, options);
      }
export type RemoveNewsItemMutationHookResult = ReturnType<typeof useRemoveNewsItemMutation>;
export type RemoveNewsItemMutationResult = Apollo.MutationResult<RemoveNewsItemMutation>;
export type RemoveNewsItemMutationOptions = Apollo.BaseMutationOptions<RemoveNewsItemMutation, RemoveNewsItemMutationVariables>;
export const UpdateProcedureDocument = gql`
    mutation UpdateProcedure($updateInput: UpdateProcedureInput!) {
  updateProcedure(updateInput: $updateInput) {
    updatedAt
    publicationDate
    procedureStatus
    procedureItemTags
    procedureDescription
    procedureStatus
    name
    multimediaType
    modality
    linkItem {
      url
      updatedAt
      target
      routeType
      routeNavigation
      id
      deletedAt
      createdAt
      arguments
    }
    id
    govcoLink {
      url
      updatedAt
      target
      routeType
      routeNavigation
      id
      deletedAt
      createdAt
      arguments
    }
    govcoImage {
      url
      updatedAt
      id
      fileName
      fileMongoId
      fileMode
      fileExtension
      deletedAt
      createdAt
    }
    gocvoLogoName
    estimatedDuration
    duration
    deletedAt
    date
    createdAt
    cost
    alternativeText
    actionLink
    action
    showGovcoButton
    showProcedureButton
  }
}
    `;
export type UpdateProcedureMutationFn = Apollo.MutationFunction<UpdateProcedureMutation, UpdateProcedureMutationVariables>;

/**
 * __useUpdateProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureMutation, { data, loading, error }] = useUpdateProcedureMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureMutation, UpdateProcedureMutationVariables>(UpdateProcedureDocument, options);
      }
export type UpdateProcedureMutationHookResult = ReturnType<typeof useUpdateProcedureMutation>;
export type UpdateProcedureMutationResult = Apollo.MutationResult<UpdateProcedureMutation>;
export type UpdateProcedureMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>;
export const CreateProcedureDocument = gql`
    mutation CreateProcedure($createInput: CreateProcedureInput!) {
  createProcedure(createInput: $createInput) {
    updatedAt
    alternativeText
    publicationDate
    procedureStatus
    procedureItemTags
    procedureDescription
    name
    multimediaType
    modality
    linkItem {
      url
      updatedAt
      target
      routeType
      routeNavigation
      id
      deletedAt
      createdAt
      arguments
    }
    id
    govcoLink {
      url
      updatedAt
      target
      routeType
      routeNavigation
      id
      deletedAt
      createdAt
      arguments
    }
    govcoImage {
      url
      updatedAt
      id
      fileName
      fileMongoId
      fileMode
      fileExtension
      deletedAt
      createdAt
    }
    gocvoLogoName
    estimatedDuration
    duration
    deletedAt
    date
    createdAt
    cost
    alternativeText
    actionLink
    showGovcoButton
    showProcedureButton
  }
}
    `;
export type CreateProcedureMutationFn = Apollo.MutationFunction<CreateProcedureMutation, CreateProcedureMutationVariables>;

/**
 * __useCreateProcedureMutation__
 *
 * To run a mutation, you first call `useCreateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureMutation, { data, loading, error }] = useCreateProcedureMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureMutation, CreateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureMutation, CreateProcedureMutationVariables>(CreateProcedureDocument, options);
      }
export type CreateProcedureMutationHookResult = ReturnType<typeof useCreateProcedureMutation>;
export type CreateProcedureMutationResult = Apollo.MutationResult<CreateProcedureMutation>;
export type CreateProcedureMutationOptions = Apollo.BaseMutationOptions<CreateProcedureMutation, CreateProcedureMutationVariables>;
export const NewsItemsPressRoomDocument = gql`
    query NewsItemsPressRoom($where: FindNewsWhere, $pagination: Pagination, $orderBy: [FindNewsOrderBy!], $contentSchemaId: String) {
  newsItems(where: $where, orderBy: $orderBy, pagination: $pagination, contentSchemaId: $contentSchemaId) {
    title
    createdAt
    updatedAt
    date
    expiredDate
    hasExpirationDate
    publicationDate
    newsStatus
    id
    contentSchema {
      id
      name
    }
    dependency {
      id
      name
    }
    sharedWith {
      targetDependency {
        id
        name
      }
    }
  }
  newsItemsCount(pagination: $pagination, where: $where, contentSchemaId: $contentSchemaId) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useNewsItemsPressRoomQuery__
 *
 * To run a query within a React component, call `useNewsItemsPressRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemsPressRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemsPressRoomQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      contentSchemaId: // value for 'contentSchemaId'
 *   },
 * });
 */
export function useNewsItemsPressRoomQuery(baseOptions?: Apollo.QueryHookOptions<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>(NewsItemsPressRoomDocument, options);
      }
export function useNewsItemsPressRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>(NewsItemsPressRoomDocument, options);
        }
export function useNewsItemsPressRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>(NewsItemsPressRoomDocument, options);
        }
export type NewsItemsPressRoomQueryHookResult = ReturnType<typeof useNewsItemsPressRoomQuery>;
export type NewsItemsPressRoomLazyQueryHookResult = ReturnType<typeof useNewsItemsPressRoomLazyQuery>;
export type NewsItemsPressRoomSuspenseQueryHookResult = ReturnType<typeof useNewsItemsPressRoomSuspenseQuery>;
export type NewsItemsPressRoomQueryResult = Apollo.QueryResult<NewsItemsPressRoomQuery, NewsItemsPressRoomQueryVariables>;
export const AllNewsDocument = gql`
    query AllNews($where: FindNewsWhere, $pagination: Pagination, $orderBy: [FindNewsOrderBy!]) {
  newsItems(where: $where, orderBy: $orderBy, pagination: $pagination) {
    id
    title
    date
    createdAt
    expiredDate
    hasExpirationDate
    newsStatus
    dependency {
      id
      name
      __typename
    }
    __typename
  }
  newsItemsCount(pagination: $pagination, where: $where) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
    __typename
  }
}
    `;

/**
 * __useAllNewsQuery__
 *
 * To run a query within a React component, call `useAllNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllNewsQuery(baseOptions?: Apollo.QueryHookOptions<AllNewsQuery, AllNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllNewsQuery, AllNewsQueryVariables>(AllNewsDocument, options);
      }
export function useAllNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllNewsQuery, AllNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllNewsQuery, AllNewsQueryVariables>(AllNewsDocument, options);
        }
export function useAllNewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllNewsQuery, AllNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllNewsQuery, AllNewsQueryVariables>(AllNewsDocument, options);
        }
export type AllNewsQueryHookResult = ReturnType<typeof useAllNewsQuery>;
export type AllNewsLazyQueryHookResult = ReturnType<typeof useAllNewsLazyQuery>;
export type AllNewsSuspenseQueryHookResult = ReturnType<typeof useAllNewsSuspenseQuery>;
export type AllNewsQueryResult = Apollo.QueryResult<AllNewsQuery, AllNewsQueryVariables>;
export const ProceduresAndServicesAllDocument = gql`
    query ProceduresAndServicesAll($pagination: Pagination, $where: FindProceduresWhere, $orderBy: [FindProceduresOrderBy!]) {
  procedures(pagination: $pagination, where: $where, orderBy: $orderBy) {
    id
    processDefinitionId
    createdAt
    updatedAt
    deletedAt
    name
    tagsProcedure
    procedureStatus
    cost
    modality
    date
    action
    actionLink
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    showGovcoButton
    showProcedureButton
  }
  proceduresCount(pagination: $pagination, where: $where) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useProceduresAndServicesAllQuery__
 *
 * To run a query within a React component, call `useProceduresAndServicesAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useProceduresAndServicesAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProceduresAndServicesAllQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useProceduresAndServicesAllQuery(baseOptions?: Apollo.QueryHookOptions<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>(ProceduresAndServicesAllDocument, options);
      }
export function useProceduresAndServicesAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>(ProceduresAndServicesAllDocument, options);
        }
export function useProceduresAndServicesAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>(ProceduresAndServicesAllDocument, options);
        }
export type ProceduresAndServicesAllQueryHookResult = ReturnType<typeof useProceduresAndServicesAllQuery>;
export type ProceduresAndServicesAllLazyQueryHookResult = ReturnType<typeof useProceduresAndServicesAllLazyQuery>;
export type ProceduresAndServicesAllSuspenseQueryHookResult = ReturnType<typeof useProceduresAndServicesAllSuspenseQuery>;
export type ProceduresAndServicesAllQueryResult = Apollo.QueryResult<ProceduresAndServicesAllQuery, ProceduresAndServicesAllQueryVariables>;
export const RemoveProcedureDocument = gql`
    mutation RemoveProcedure($removeProcedureId: ID!) {
  removeProcedure(id: $removeProcedureId) {
    id
  }
}
    `;
export type RemoveProcedureMutationFn = Apollo.MutationFunction<RemoveProcedureMutation, RemoveProcedureMutationVariables>;

/**
 * __useRemoveProcedureMutation__
 *
 * To run a mutation, you first call `useRemoveProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProcedureMutation, { data, loading, error }] = useRemoveProcedureMutation({
 *   variables: {
 *      removeProcedureId: // value for 'removeProcedureId'
 *   },
 * });
 */
export function useRemoveProcedureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProcedureMutation, RemoveProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProcedureMutation, RemoveProcedureMutationVariables>(RemoveProcedureDocument, options);
      }
export type RemoveProcedureMutationHookResult = ReturnType<typeof useRemoveProcedureMutation>;
export type RemoveProcedureMutationResult = Apollo.MutationResult<RemoveProcedureMutation>;
export type RemoveProcedureMutationOptions = Apollo.BaseMutationOptions<RemoveProcedureMutation, RemoveProcedureMutationVariables>;
export const RegulationsAdminDocument = gql`
    query RegulationsAdmin($orderBy: [FindRegulationsOrderBy!], $where: FindRegulationsWhere, $pagination: Pagination, $types: [RegulationType!]!, $dependency: StringFilter) {
  regulations(orderBy: $orderBy, where: $where, pagination: $pagination, types: $types, dependency: $dependency) {
    id
    date
    documentDate
    createdAt
    updatedAt
    downloadText
    description
    title
    regulationStatus
    dependency {
      name
      id
    }
    file {
      downloadUrl
    }
    type
  }
  regulationsCount(pagination: $pagination, orderBy: $orderBy, where: $where, types: $types, dependency: $dependency) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useRegulationsAdminQuery__
 *
 * To run a query within a React component, call `useRegulationsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationsAdminQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      types: // value for 'types'
 *      dependency: // value for 'dependency'
 *   },
 * });
 */
export function useRegulationsAdminQuery(baseOptions: Apollo.QueryHookOptions<RegulationsAdminQuery, RegulationsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationsAdminQuery, RegulationsAdminQueryVariables>(RegulationsAdminDocument, options);
      }
export function useRegulationsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationsAdminQuery, RegulationsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationsAdminQuery, RegulationsAdminQueryVariables>(RegulationsAdminDocument, options);
        }
export function useRegulationsAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationsAdminQuery, RegulationsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationsAdminQuery, RegulationsAdminQueryVariables>(RegulationsAdminDocument, options);
        }
export type RegulationsAdminQueryHookResult = ReturnType<typeof useRegulationsAdminQuery>;
export type RegulationsAdminLazyQueryHookResult = ReturnType<typeof useRegulationsAdminLazyQuery>;
export type RegulationsAdminSuspenseQueryHookResult = ReturnType<typeof useRegulationsAdminSuspenseQuery>;
export type RegulationsAdminQueryResult = Apollo.QueryResult<RegulationsAdminQuery, RegulationsAdminQueryVariables>;
export const GetRegulationDocument = gql`
    query GetRegulation($regulationId: ID!) {
  regulation(id: $regulationId) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    description
    type
    publishDate
    documentDate
    downloadText
    dependency {
      id
      name
    }
    file {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      downloadUrl
      url
    }
  }
}
    `;

/**
 * __useGetRegulationQuery__
 *
 * To run a query within a React component, call `useGetRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useGetRegulationQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
      }
export function useGetRegulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
        }
export function useGetRegulationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
        }
export type GetRegulationQueryHookResult = ReturnType<typeof useGetRegulationQuery>;
export type GetRegulationLazyQueryHookResult = ReturnType<typeof useGetRegulationLazyQuery>;
export type GetRegulationSuspenseQueryHookResult = ReturnType<typeof useGetRegulationSuspenseQuery>;
export type GetRegulationQueryResult = Apollo.QueryResult<GetRegulationQuery, GetRegulationQueryVariables>;
export const RegulationAdminDocument = gql`
    query RegulationAdmin($regulationId: ID!) {
  regulation(id: $regulationId) {
    id
    title
    description
    date
    type
    pageLinkDocument {
      arguments
      routeNavigation
      routeType
      target
      url
    }
    downloadText
    documentDate
    publishDate
    dependency {
      id
      name
    }
    file {
      id
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    linkItem {
      arguments
      routeNavigation
      routeType
      target
      url
    }
    image {
      id
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    seo {
      metadata {
        id
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useRegulationAdminQuery__
 *
 * To run a query within a React component, call `useRegulationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationAdminQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useRegulationAdminQuery(baseOptions: Apollo.QueryHookOptions<RegulationAdminQuery, RegulationAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationAdminQuery, RegulationAdminQueryVariables>(RegulationAdminDocument, options);
      }
export function useRegulationAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationAdminQuery, RegulationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationAdminQuery, RegulationAdminQueryVariables>(RegulationAdminDocument, options);
        }
export function useRegulationAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationAdminQuery, RegulationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationAdminQuery, RegulationAdminQueryVariables>(RegulationAdminDocument, options);
        }
export type RegulationAdminQueryHookResult = ReturnType<typeof useRegulationAdminQuery>;
export type RegulationAdminLazyQueryHookResult = ReturnType<typeof useRegulationAdminLazyQuery>;
export type RegulationAdminSuspenseQueryHookResult = ReturnType<typeof useRegulationAdminSuspenseQuery>;
export type RegulationAdminQueryResult = Apollo.QueryResult<RegulationAdminQuery, RegulationAdminQueryVariables>;
export const CreateRegulationAdminDocument = gql`
    mutation CreateRegulationAdmin($createInput: CreateRegulationInput!) {
  createRegulation(createInput: $createInput) {
    id
    title
  }
}
    `;
export type CreateRegulationAdminMutationFn = Apollo.MutationFunction<CreateRegulationAdminMutation, CreateRegulationAdminMutationVariables>;

/**
 * __useCreateRegulationAdminMutation__
 *
 * To run a mutation, you first call `useCreateRegulationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegulationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegulationAdminMutation, { data, loading, error }] = useCreateRegulationAdminMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateRegulationAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegulationAdminMutation, CreateRegulationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegulationAdminMutation, CreateRegulationAdminMutationVariables>(CreateRegulationAdminDocument, options);
      }
export type CreateRegulationAdminMutationHookResult = ReturnType<typeof useCreateRegulationAdminMutation>;
export type CreateRegulationAdminMutationResult = Apollo.MutationResult<CreateRegulationAdminMutation>;
export type CreateRegulationAdminMutationOptions = Apollo.BaseMutationOptions<CreateRegulationAdminMutation, CreateRegulationAdminMutationVariables>;
export const UpdateRegulationAdminDocument = gql`
    mutation UpdateRegulationAdmin($updateInput: UpdateRegulationInput!) {
  updateRegulation(updateInput: $updateInput) {
    id
    date
    title
    regulationStatus
  }
}
    `;
export type UpdateRegulationAdminMutationFn = Apollo.MutationFunction<UpdateRegulationAdminMutation, UpdateRegulationAdminMutationVariables>;

/**
 * __useUpdateRegulationAdminMutation__
 *
 * To run a mutation, you first call `useUpdateRegulationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulationAdminMutation, { data, loading, error }] = useUpdateRegulationAdminMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRegulationAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulationAdminMutation, UpdateRegulationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulationAdminMutation, UpdateRegulationAdminMutationVariables>(UpdateRegulationAdminDocument, options);
      }
export type UpdateRegulationAdminMutationHookResult = ReturnType<typeof useUpdateRegulationAdminMutation>;
export type UpdateRegulationAdminMutationResult = Apollo.MutationResult<UpdateRegulationAdminMutation>;
export type UpdateRegulationAdminMutationOptions = Apollo.BaseMutationOptions<UpdateRegulationAdminMutation, UpdateRegulationAdminMutationVariables>;
export const RemoveRegulationAdminDocument = gql`
    mutation RemoveRegulationAdmin($removeRegulationId: ID!) {
  removeRegulation(id: $removeRegulationId) {
    id
  }
}
    `;
export type RemoveRegulationAdminMutationFn = Apollo.MutationFunction<RemoveRegulationAdminMutation, RemoveRegulationAdminMutationVariables>;

/**
 * __useRemoveRegulationAdminMutation__
 *
 * To run a mutation, you first call `useRemoveRegulationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRegulationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRegulationAdminMutation, { data, loading, error }] = useRemoveRegulationAdminMutation({
 *   variables: {
 *      removeRegulationId: // value for 'removeRegulationId'
 *   },
 * });
 */
export function useRemoveRegulationAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRegulationAdminMutation, RemoveRegulationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRegulationAdminMutation, RemoveRegulationAdminMutationVariables>(RemoveRegulationAdminDocument, options);
      }
export type RemoveRegulationAdminMutationHookResult = ReturnType<typeof useRemoveRegulationAdminMutation>;
export type RemoveRegulationAdminMutationResult = Apollo.MutationResult<RemoveRegulationAdminMutation>;
export type RemoveRegulationAdminMutationOptions = Apollo.BaseMutationOptions<RemoveRegulationAdminMutation, RemoveRegulationAdminMutationVariables>;
export const UpdateRegulationStatusToDraftDocument = gql`
    mutation UpdateRegulationStatusToDraft($updateRegulationStatusToDraft: UpdateRegulationStatus!) {
  updateRegulationStatusToDraft(updateRegulationStatusToDraft: $updateRegulationStatusToDraft)
}
    `;
export type UpdateRegulationStatusToDraftMutationFn = Apollo.MutationFunction<UpdateRegulationStatusToDraftMutation, UpdateRegulationStatusToDraftMutationVariables>;

/**
 * __useUpdateRegulationStatusToDraftMutation__
 *
 * To run a mutation, you first call `useUpdateRegulationStatusToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulationStatusToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulationStatusToDraftMutation, { data, loading, error }] = useUpdateRegulationStatusToDraftMutation({
 *   variables: {
 *      updateRegulationStatusToDraft: // value for 'updateRegulationStatusToDraft'
 *   },
 * });
 */
export function useUpdateRegulationStatusToDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulationStatusToDraftMutation, UpdateRegulationStatusToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulationStatusToDraftMutation, UpdateRegulationStatusToDraftMutationVariables>(UpdateRegulationStatusToDraftDocument, options);
      }
export type UpdateRegulationStatusToDraftMutationHookResult = ReturnType<typeof useUpdateRegulationStatusToDraftMutation>;
export type UpdateRegulationStatusToDraftMutationResult = Apollo.MutationResult<UpdateRegulationStatusToDraftMutation>;
export type UpdateRegulationStatusToDraftMutationOptions = Apollo.BaseMutationOptions<UpdateRegulationStatusToDraftMutation, UpdateRegulationStatusToDraftMutationVariables>;
export const PublishersDocument = gql`
    query Publishers($where: FindEditorWhere, $dependencyId: String) {
  users(where: {type: Admin}, dependencyId: $dependencyId) {
    id
    name
    lastName
  }
  editors(where: $where) {
    id
    user {
      id
      name
      lastName
    }
  }
}
    `;

/**
 * __usePublishersQuery__
 *
 * To run a query within a React component, call `usePublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      dependencyId: // value for 'dependencyId'
 *   },
 * });
 */
export function usePublishersQuery(baseOptions?: Apollo.QueryHookOptions<PublishersQuery, PublishersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishersQuery, PublishersQueryVariables>(PublishersDocument, options);
      }
export function usePublishersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishersQuery, PublishersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishersQuery, PublishersQueryVariables>(PublishersDocument, options);
        }
export function usePublishersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishersQuery, PublishersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishersQuery, PublishersQueryVariables>(PublishersDocument, options);
        }
export type PublishersQueryHookResult = ReturnType<typeof usePublishersQuery>;
export type PublishersLazyQueryHookResult = ReturnType<typeof usePublishersLazyQuery>;
export type PublishersSuspenseQueryHookResult = ReturnType<typeof usePublishersSuspenseQuery>;
export type PublishersQueryResult = Apollo.QueryResult<PublishersQuery, PublishersQueryVariables>;
export const BulkAssignEditorsDocument = gql`
    mutation BulkAssignEditors($pageDynamicId: String!, $userIds: [String!]!) {
  bulkAssignEditors(pageDynamicId: $pageDynamicId, userIds: $userIds) {
    id
    user {
      id
      email
    }
  }
}
    `;
export type BulkAssignEditorsMutationFn = Apollo.MutationFunction<BulkAssignEditorsMutation, BulkAssignEditorsMutationVariables>;

/**
 * __useBulkAssignEditorsMutation__
 *
 * To run a mutation, you first call `useBulkAssignEditorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignEditorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignEditorsMutation, { data, loading, error }] = useBulkAssignEditorsMutation({
 *   variables: {
 *      pageDynamicId: // value for 'pageDynamicId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useBulkAssignEditorsMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignEditorsMutation, BulkAssignEditorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignEditorsMutation, BulkAssignEditorsMutationVariables>(BulkAssignEditorsDocument, options);
      }
export type BulkAssignEditorsMutationHookResult = ReturnType<typeof useBulkAssignEditorsMutation>;
export type BulkAssignEditorsMutationResult = Apollo.MutationResult<BulkAssignEditorsMutation>;
export type BulkAssignEditorsMutationOptions = Apollo.BaseMutationOptions<BulkAssignEditorsMutation, BulkAssignEditorsMutationVariables>;
export const DependenciesDocument = gql`
    query Dependencies($orderBy: [FindDependencyOrderBy!], $where: FindDependencyWhere, $pagination: Pagination) {
  dependencies(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    type
    status
    countUser
  }
  dependenciesCount(orderBy: $orderBy, where: $where, pagination: $pagination) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useDependenciesQuery__
 *
 * To run a query within a React component, call `useDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDependenciesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDependenciesQuery(baseOptions?: Apollo.QueryHookOptions<DependenciesQuery, DependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DependenciesQuery, DependenciesQueryVariables>(DependenciesDocument, options);
      }
export function useDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DependenciesQuery, DependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DependenciesQuery, DependenciesQueryVariables>(DependenciesDocument, options);
        }
export function useDependenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DependenciesQuery, DependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DependenciesQuery, DependenciesQueryVariables>(DependenciesDocument, options);
        }
export type DependenciesQueryHookResult = ReturnType<typeof useDependenciesQuery>;
export type DependenciesLazyQueryHookResult = ReturnType<typeof useDependenciesLazyQuery>;
export type DependenciesSuspenseQueryHookResult = ReturnType<typeof useDependenciesSuspenseQuery>;
export type DependenciesQueryResult = Apollo.QueryResult<DependenciesQuery, DependenciesQueryVariables>;
export const DependencyDocument = gql`
    query Dependency($dependencyId: ID!) {
  dependency(id: $dependencyId) {
    id
    name
    createdAt
    updatedAt
    deletedAt
    type
    status
  }
}
    `;

/**
 * __useDependencyQuery__
 *
 * To run a query within a React component, call `useDependencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDependencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDependencyQuery({
 *   variables: {
 *      dependencyId: // value for 'dependencyId'
 *   },
 * });
 */
export function useDependencyQuery(baseOptions: Apollo.QueryHookOptions<DependencyQuery, DependencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DependencyQuery, DependencyQueryVariables>(DependencyDocument, options);
      }
export function useDependencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DependencyQuery, DependencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DependencyQuery, DependencyQueryVariables>(DependencyDocument, options);
        }
export function useDependencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DependencyQuery, DependencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DependencyQuery, DependencyQueryVariables>(DependencyDocument, options);
        }
export type DependencyQueryHookResult = ReturnType<typeof useDependencyQuery>;
export type DependencyLazyQueryHookResult = ReturnType<typeof useDependencyLazyQuery>;
export type DependencySuspenseQueryHookResult = ReturnType<typeof useDependencySuspenseQuery>;
export type DependencyQueryResult = Apollo.QueryResult<DependencyQuery, DependencyQueryVariables>;
export const CreateDependencyDocument = gql`
    mutation CreateDependency($createInput: CreateDependencyInput!) {
  createDependency(createInput: $createInput) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export type CreateDependencyMutationFn = Apollo.MutationFunction<CreateDependencyMutation, CreateDependencyMutationVariables>;

/**
 * __useCreateDependencyMutation__
 *
 * To run a mutation, you first call `useCreateDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDependencyMutation, { data, loading, error }] = useCreateDependencyMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateDependencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateDependencyMutation, CreateDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDependencyMutation, CreateDependencyMutationVariables>(CreateDependencyDocument, options);
      }
export type CreateDependencyMutationHookResult = ReturnType<typeof useCreateDependencyMutation>;
export type CreateDependencyMutationResult = Apollo.MutationResult<CreateDependencyMutation>;
export type CreateDependencyMutationOptions = Apollo.BaseMutationOptions<CreateDependencyMutation, CreateDependencyMutationVariables>;
export const UpdateDependencyDocument = gql`
    mutation UpdateDependency($updateInput: UpdateDependencyInput!) {
  updateDependency(updateInput: $updateInput) {
    id
    name
    updatedAt
  }
}
    `;
export type UpdateDependencyMutationFn = Apollo.MutationFunction<UpdateDependencyMutation, UpdateDependencyMutationVariables>;

/**
 * __useUpdateDependencyMutation__
 *
 * To run a mutation, you first call `useUpdateDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDependencyMutation, { data, loading, error }] = useUpdateDependencyMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDependencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDependencyMutation, UpdateDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDependencyMutation, UpdateDependencyMutationVariables>(UpdateDependencyDocument, options);
      }
export type UpdateDependencyMutationHookResult = ReturnType<typeof useUpdateDependencyMutation>;
export type UpdateDependencyMutationResult = Apollo.MutationResult<UpdateDependencyMutation>;
export type UpdateDependencyMutationOptions = Apollo.BaseMutationOptions<UpdateDependencyMutation, UpdateDependencyMutationVariables>;
export const UpdateUserDependencyDocument = gql`
    mutation UpdateUserDependency($updateInput: UpdateUserDependencyInput!) {
  updateUserDependency(updateInput: $updateInput) {
    id
    createdAt
    updatedAt
  }
}
    `;
export type UpdateUserDependencyMutationFn = Apollo.MutationFunction<UpdateUserDependencyMutation, UpdateUserDependencyMutationVariables>;

/**
 * __useUpdateUserDependencyMutation__
 *
 * To run a mutation, you first call `useUpdateUserDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDependencyMutation, { data, loading, error }] = useUpdateUserDependencyMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateUserDependencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDependencyMutation, UpdateUserDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDependencyMutation, UpdateUserDependencyMutationVariables>(UpdateUserDependencyDocument, options);
      }
export type UpdateUserDependencyMutationHookResult = ReturnType<typeof useUpdateUserDependencyMutation>;
export type UpdateUserDependencyMutationResult = Apollo.MutationResult<UpdateUserDependencyMutation>;
export type UpdateUserDependencyMutationOptions = Apollo.BaseMutationOptions<UpdateUserDependencyMutation, UpdateUserDependencyMutationVariables>;
export const CreateUserDependencyDocument = gql`
    mutation CreateUserDependency($createInput: CreateUserDependencyInput!) {
  createUserDependency(createInput: $createInput) {
    id
    createdAt
    updatedAt
    deletedAt
    status
  }
}
    `;
export type CreateUserDependencyMutationFn = Apollo.MutationFunction<CreateUserDependencyMutation, CreateUserDependencyMutationVariables>;

/**
 * __useCreateUserDependencyMutation__
 *
 * To run a mutation, you first call `useCreateUserDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDependencyMutation, { data, loading, error }] = useCreateUserDependencyMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateUserDependencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDependencyMutation, CreateUserDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDependencyMutation, CreateUserDependencyMutationVariables>(CreateUserDependencyDocument, options);
      }
export type CreateUserDependencyMutationHookResult = ReturnType<typeof useCreateUserDependencyMutation>;
export type CreateUserDependencyMutationResult = Apollo.MutationResult<CreateUserDependencyMutation>;
export type CreateUserDependencyMutationOptions = Apollo.BaseMutationOptions<CreateUserDependencyMutation, CreateUserDependencyMutationVariables>;
export const UsersWithDependencyDocument = gql`
    query UsersWithDependency($dependencyId: String!) {
  getUsersByDependency(dependencyId: $dependencyId) {
    usersWithDependency {
      id
      type
      user {
        id
        name
        lastName
        email
        fullName
      }
    }
    usersWithoutDependency {
      id
      name
      lastName
      email
      fullName
    }
  }
}
    `;

/**
 * __useUsersWithDependencyQuery__
 *
 * To run a query within a React component, call `useUsersWithDependencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithDependencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithDependencyQuery({
 *   variables: {
 *      dependencyId: // value for 'dependencyId'
 *   },
 * });
 */
export function useUsersWithDependencyQuery(baseOptions: Apollo.QueryHookOptions<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>(UsersWithDependencyDocument, options);
      }
export function useUsersWithDependencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>(UsersWithDependencyDocument, options);
        }
export function useUsersWithDependencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>(UsersWithDependencyDocument, options);
        }
export type UsersWithDependencyQueryHookResult = ReturnType<typeof useUsersWithDependencyQuery>;
export type UsersWithDependencyLazyQueryHookResult = ReturnType<typeof useUsersWithDependencyLazyQuery>;
export type UsersWithDependencySuspenseQueryHookResult = ReturnType<typeof useUsersWithDependencySuspenseQuery>;
export type UsersWithDependencyQueryResult = Apollo.QueryResult<UsersWithDependencyQuery, UsersWithDependencyQueryVariables>;
export const CreateMultipleUserDependenciesDocument = gql`
    mutation CreateMultipleUserDependencies($input: CreateMultipleUserDependencyInput!) {
  createMultipleUserDependencies(input: $input) {
    success
  }
}
    `;
export type CreateMultipleUserDependenciesMutationFn = Apollo.MutationFunction<CreateMultipleUserDependenciesMutation, CreateMultipleUserDependenciesMutationVariables>;

/**
 * __useCreateMultipleUserDependenciesMutation__
 *
 * To run a mutation, you first call `useCreateMultipleUserDependenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultipleUserDependenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultipleUserDependenciesMutation, { data, loading, error }] = useCreateMultipleUserDependenciesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMultipleUserDependenciesMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultipleUserDependenciesMutation, CreateMultipleUserDependenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultipleUserDependenciesMutation, CreateMultipleUserDependenciesMutationVariables>(CreateMultipleUserDependenciesDocument, options);
      }
export type CreateMultipleUserDependenciesMutationHookResult = ReturnType<typeof useCreateMultipleUserDependenciesMutation>;
export type CreateMultipleUserDependenciesMutationResult = Apollo.MutationResult<CreateMultipleUserDependenciesMutation>;
export type CreateMultipleUserDependenciesMutationOptions = Apollo.BaseMutationOptions<CreateMultipleUserDependenciesMutation, CreateMultipleUserDependenciesMutationVariables>;
export const RemoveDependencyDocument = gql`
    mutation RemoveDependency($removeDependencyId: ID!) {
  removeDependency(id: $removeDependencyId) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    type
    status
    countUser
  }
}
    `;
export type RemoveDependencyMutationFn = Apollo.MutationFunction<RemoveDependencyMutation, RemoveDependencyMutationVariables>;

/**
 * __useRemoveDependencyMutation__
 *
 * To run a mutation, you first call `useRemoveDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDependencyMutation, { data, loading, error }] = useRemoveDependencyMutation({
 *   variables: {
 *      removeDependencyId: // value for 'removeDependencyId'
 *   },
 * });
 */
export function useRemoveDependencyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDependencyMutation, RemoveDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDependencyMutation, RemoveDependencyMutationVariables>(RemoveDependencyDocument, options);
      }
export type RemoveDependencyMutationHookResult = ReturnType<typeof useRemoveDependencyMutation>;
export type RemoveDependencyMutationResult = Apollo.MutationResult<RemoveDependencyMutation>;
export type RemoveDependencyMutationOptions = Apollo.BaseMutationOptions<RemoveDependencyMutation, RemoveDependencyMutationVariables>;
export const RemoveUserDependencyDocument = gql`
    mutation RemoveUserDependency($removeUserDependencyId: ID!) {
  removeUserDependency(id: $removeUserDependencyId) {
    id
  }
}
    `;
export type RemoveUserDependencyMutationFn = Apollo.MutationFunction<RemoveUserDependencyMutation, RemoveUserDependencyMutationVariables>;

/**
 * __useRemoveUserDependencyMutation__
 *
 * To run a mutation, you first call `useRemoveUserDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserDependencyMutation, { data, loading, error }] = useRemoveUserDependencyMutation({
 *   variables: {
 *      removeUserDependencyId: // value for 'removeUserDependencyId'
 *   },
 * });
 */
export function useRemoveUserDependencyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserDependencyMutation, RemoveUserDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserDependencyMutation, RemoveUserDependencyMutationVariables>(RemoveUserDependencyDocument, options);
      }
export type RemoveUserDependencyMutationHookResult = ReturnType<typeof useRemoveUserDependencyMutation>;
export type RemoveUserDependencyMutationResult = Apollo.MutationResult<RemoveUserDependencyMutation>;
export type RemoveUserDependencyMutationOptions = Apollo.BaseMutationOptions<RemoveUserDependencyMutation, RemoveUserDependencyMutationVariables>;
export const DocumentsDocument = gql`
    query Documents($where: FindContentWhere, $schemaIdFilter: String, $pagination: Pagination, $orderBy: [FindContentOrderBy!], $dependencyIdFilter: String, $metadataOrderBy: [MetadataFieldOrderBy!]) {
  documents(where: $where, schemaIdFilter: $schemaIdFilter, pagination: $pagination, orderBy: $orderBy, dependencyIdFilter: $dependencyIdFilter, metadataOrderBy: $metadataOrderBy) {
    id
    title
    createdAt
    updatedAt
    file {
      downloadUrl
    }
    schema {
      id
      name
    }
    dependency {
      id
      name
    }
    sharedWith {
      targetDependency {
        id
        name
      }
    }
    metadata {
      id
      value
      schemaField {
        fieldLabel
      }
    }
    publishDate
    status
    children {
      id
      createdAt
      updatedAt
      deletedAt
      title
      description
      type
      status
      contentDate
      migrationMetadata
      publishDate
      expirationDate
      fileId
      downloadText
      downloadCount
      fileSize
      mimeType
      isParentDocument
      nestingLevel
      childrenCount
    }
  }
  documentsCount(where: $where, schemaIdFilter: $schemaIdFilter, pagination: $pagination, orderBy: $orderBy, dependencyIdFilter: $dependencyIdFilter) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      schemaIdFilter: // value for 'schemaIdFilter'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      dependencyIdFilter: // value for 'dependencyIdFilter'
 *      metadataOrderBy: // value for 'metadataOrderBy'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export function useDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsSuspenseQueryHookResult = ReturnType<typeof useDocumentsSuspenseQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const DocumentByIdDocument = gql`
    query DocumentById($documentId: ID!) {
  document(id: $documentId) {
    id
    title
    createdAt
    description
    schema {
      id
      name
    }
    file {
      id
      fileName
      fileExtension
    }
    dependency {
      id
      name
    }
    publishDate
    contentDate
    status
    metadata {
      id
      value
      schemaField {
        id
      }
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
    children {
      id
      createdAt
      updatedAt
      deletedAt
      title
      description
      type
      status
      contentDate
      migrationMetadata
      publishDate
      expirationDate
      fileId
      downloadText
      downloadCount
      fileSize
      mimeType
      isParentDocument
      nestingLevel
      childrenCount
      schema {
        id
        createdAt
        updatedAt
        deletedAt
        name
        description
        contentType
        isActive
        allowChildren
        maxNestingLevel
        hierarchyLabel
        dependencyCount
      }
      dependency {
        id
        createdAt
        updatedAt
        deletedAt
        name
        type
        status
        countUser
      }
    }
  }
}
    `;

/**
 * __useDocumentByIdQuery__
 *
 * To run a query within a React component, call `useDocumentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentByIdQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentByIdQuery(baseOptions: Apollo.QueryHookOptions<DocumentByIdQuery, DocumentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentByIdQuery, DocumentByIdQueryVariables>(DocumentByIdDocument, options);
      }
export function useDocumentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentByIdQuery, DocumentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentByIdQuery, DocumentByIdQueryVariables>(DocumentByIdDocument, options);
        }
export function useDocumentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentByIdQuery, DocumentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentByIdQuery, DocumentByIdQueryVariables>(DocumentByIdDocument, options);
        }
export type DocumentByIdQueryHookResult = ReturnType<typeof useDocumentByIdQuery>;
export type DocumentByIdLazyQueryHookResult = ReturnType<typeof useDocumentByIdLazyQuery>;
export type DocumentByIdSuspenseQueryHookResult = ReturnType<typeof useDocumentByIdSuspenseQuery>;
export type DocumentByIdQueryResult = Apollo.QueryResult<DocumentByIdQuery, DocumentByIdQueryVariables>;
export const AllDocumentsDocument = gql`
    query AllDocuments($where: FindContentWhere, $pagination: Pagination, $orderBy: [FindContentOrderBy!], $dependencyIdFilter: String) {
  documents(where: $where, pagination: $pagination, orderBy: $orderBy, dependencyIdFilter: $dependencyIdFilter) {
    id
    title
    createdAt
    updatedAt
    status
    file {
      downloadUrl
    }
    dependency {
      id
      name
    }
    sharedWith {
      targetDependency {
        id
        name
      }
    }
    metadata {
      id
      value
      schemaField {
        fieldLabel
      }
    }
    schema {
      id
      name
    }
  }
  documentsCount(where: $where, pagination: $pagination, orderBy: $orderBy, dependencyIdFilter: $dependencyIdFilter) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useAllDocumentsQuery__
 *
 * To run a query within a React component, call `useAllDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      dependencyIdFilter: // value for 'dependencyIdFilter'
 *   },
 * });
 */
export function useAllDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<AllDocumentsQuery, AllDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDocumentsQuery, AllDocumentsQueryVariables>(AllDocumentsDocument, options);
      }
export function useAllDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDocumentsQuery, AllDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDocumentsQuery, AllDocumentsQueryVariables>(AllDocumentsDocument, options);
        }
export function useAllDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllDocumentsQuery, AllDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDocumentsQuery, AllDocumentsQueryVariables>(AllDocumentsDocument, options);
        }
export type AllDocumentsQueryHookResult = ReturnType<typeof useAllDocumentsQuery>;
export type AllDocumentsLazyQueryHookResult = ReturnType<typeof useAllDocumentsLazyQuery>;
export type AllDocumentsSuspenseQueryHookResult = ReturnType<typeof useAllDocumentsSuspenseQuery>;
export type AllDocumentsQueryResult = Apollo.QueryResult<AllDocumentsQuery, AllDocumentsQueryVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($createInput: CreateDocumentInput!) {
  createDocument(createInput: $createInput) {
    id
    title
  }
}
    `;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($updateInput: UpdateDocumentInput!) {
  updateDocument(updateInput: $updateInput) {
    id
    title
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const RemoveDocumentDocument = gql`
    mutation RemoveDocument($removeDocumentId: ID!) {
  removeDocument(id: $removeDocumentId) {
    id
  }
}
    `;
export type RemoveDocumentMutationFn = Apollo.MutationFunction<RemoveDocumentMutation, RemoveDocumentMutationVariables>;

/**
 * __useRemoveDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentMutation, { data, loading, error }] = useRemoveDocumentMutation({
 *   variables: {
 *      removeDocumentId: // value for 'removeDocumentId'
 *   },
 * });
 */
export function useRemoveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDocumentMutation, RemoveDocumentMutationVariables>(RemoveDocumentDocument, options);
      }
export type RemoveDocumentMutationHookResult = ReturnType<typeof useRemoveDocumentMutation>;
export type RemoveDocumentMutationResult = Apollo.MutationResult<RemoveDocumentMutation>;
export type RemoveDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>;
export const CreateDocumentMetadataDocument = gql`
    mutation CreateDocumentMetadata($createInput: CreateDocumentMetadataInput!) {
  createDocumentMetadata(createInput: $createInput) {
    id
    value
  }
}
    `;
export type CreateDocumentMetadataMutationFn = Apollo.MutationFunction<CreateDocumentMetadataMutation, CreateDocumentMetadataMutationVariables>;

/**
 * __useCreateDocumentMetadataMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMetadataMutation, { data, loading, error }] = useCreateDocumentMetadataMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateDocumentMetadataMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMetadataMutation, CreateDocumentMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMetadataMutation, CreateDocumentMetadataMutationVariables>(CreateDocumentMetadataDocument, options);
      }
export type CreateDocumentMetadataMutationHookResult = ReturnType<typeof useCreateDocumentMetadataMutation>;
export type CreateDocumentMetadataMutationResult = Apollo.MutationResult<CreateDocumentMetadataMutation>;
export type CreateDocumentMetadataMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMetadataMutation, CreateDocumentMetadataMutationVariables>;
export const UpdateDocumentMetadataDocument = gql`
    mutation UpdateDocumentMetadata($updateInput: UpdateDocumentMetadataInput!) {
  updateDocumentMetadata(updateInput: $updateInput) {
    id
    value
  }
}
    `;
export type UpdateDocumentMetadataMutationFn = Apollo.MutationFunction<UpdateDocumentMetadataMutation, UpdateDocumentMetadataMutationVariables>;

/**
 * __useUpdateDocumentMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMetadataMutation, { data, loading, error }] = useUpdateDocumentMetadataMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDocumentMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMetadataMutation, UpdateDocumentMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMetadataMutation, UpdateDocumentMetadataMutationVariables>(UpdateDocumentMetadataDocument, options);
      }
export type UpdateDocumentMetadataMutationHookResult = ReturnType<typeof useUpdateDocumentMetadataMutation>;
export type UpdateDocumentMetadataMutationResult = Apollo.MutationResult<UpdateDocumentMetadataMutation>;
export type UpdateDocumentMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMetadataMutation, UpdateDocumentMetadataMutationVariables>;
export const ShareContentDocument = gql`
    mutation ShareContent($input: ShareContentInput!) {
  shareContent(input: $input) {
    id
    contentId
  }
}
    `;
export type ShareContentMutationFn = Apollo.MutationFunction<ShareContentMutation, ShareContentMutationVariables>;

/**
 * __useShareContentMutation__
 *
 * To run a mutation, you first call `useShareContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareContentMutation, { data, loading, error }] = useShareContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareContentMutation(baseOptions?: Apollo.MutationHookOptions<ShareContentMutation, ShareContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareContentMutation, ShareContentMutationVariables>(ShareContentDocument, options);
      }
export type ShareContentMutationHookResult = ReturnType<typeof useShareContentMutation>;
export type ShareContentMutationResult = Apollo.MutationResult<ShareContentMutation>;
export type ShareContentMutationOptions = Apollo.BaseMutationOptions<ShareContentMutation, ShareContentMutationVariables>;
export const GetContentSchemasDocument = gql`
    query GetContentSchemas($pagination: Pagination, $where: FindContentSchemaWhere, $orderBy: [FindContentSchemaOrderBy!], $dependencyIds: [String!]) {
  contentSchemas(pagination: $pagination, where: $where, orderBy: $orderBy, dependencyIds: $dependencyIds) {
    id
    name
    isActive
    createdAt
    description
    contentType
    dependency {
      id
      name
      __typename
    }
    userContentSchemaAssignments {
      user {
        id
        name
        lastName
        fullName
      }
    }
    fields {
      id
      fieldName
      fieldLabel
      fieldType
      isGroup
      __typename
    }
    __typename
    allDependencies {
      id
      createdAt
      updatedAt
      deletedAt
      name
      type
      status
      countUser
      __typename
    }
  }
  contentSchemasCount(pagination: $pagination, where: $where, orderBy: $orderBy, dependencyIds: $dependencyIds) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
    __typename
  }
}
    `;

/**
 * __useGetContentSchemasQuery__
 *
 * To run a query within a React component, call `useGetContentSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentSchemasQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      dependencyIds: // value for 'dependencyIds'
 *   },
 * });
 */
export function useGetContentSchemasQuery(baseOptions?: Apollo.QueryHookOptions<GetContentSchemasQuery, GetContentSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentSchemasQuery, GetContentSchemasQueryVariables>(GetContentSchemasDocument, options);
      }
export function useGetContentSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentSchemasQuery, GetContentSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentSchemasQuery, GetContentSchemasQueryVariables>(GetContentSchemasDocument, options);
        }
export function useGetContentSchemasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentSchemasQuery, GetContentSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentSchemasQuery, GetContentSchemasQueryVariables>(GetContentSchemasDocument, options);
        }
export type GetContentSchemasQueryHookResult = ReturnType<typeof useGetContentSchemasQuery>;
export type GetContentSchemasLazyQueryHookResult = ReturnType<typeof useGetContentSchemasLazyQuery>;
export type GetContentSchemasSuspenseQueryHookResult = ReturnType<typeof useGetContentSchemasSuspenseQuery>;
export type GetContentSchemasQueryResult = Apollo.QueryResult<GetContentSchemasQuery, GetContentSchemasQueryVariables>;
export const GetContentSchemaFieldsByIdDocument = gql`
    query GetContentSchemaFieldsById($contentSchemaId: ID!) {
  contentSchema(id: $contentSchemaId) {
    ...ContentSchemaFields
  }
}
    ${ContentSchemaFieldsFragmentDoc}`;

/**
 * __useGetContentSchemaFieldsByIdQuery__
 *
 * To run a query within a React component, call `useGetContentSchemaFieldsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentSchemaFieldsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentSchemaFieldsByIdQuery({
 *   variables: {
 *      contentSchemaId: // value for 'contentSchemaId'
 *   },
 * });
 */
export function useGetContentSchemaFieldsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>(GetContentSchemaFieldsByIdDocument, options);
      }
export function useGetContentSchemaFieldsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>(GetContentSchemaFieldsByIdDocument, options);
        }
export function useGetContentSchemaFieldsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>(GetContentSchemaFieldsByIdDocument, options);
        }
export type GetContentSchemaFieldsByIdQueryHookResult = ReturnType<typeof useGetContentSchemaFieldsByIdQuery>;
export type GetContentSchemaFieldsByIdLazyQueryHookResult = ReturnType<typeof useGetContentSchemaFieldsByIdLazyQuery>;
export type GetContentSchemaFieldsByIdSuspenseQueryHookResult = ReturnType<typeof useGetContentSchemaFieldsByIdSuspenseQuery>;
export type GetContentSchemaFieldsByIdQueryResult = Apollo.QueryResult<GetContentSchemaFieldsByIdQuery, GetContentSchemaFieldsByIdQueryVariables>;
export const ContentSchemaFieldDocument = gql`
    query ContentSchemaField($contentSchemaFieldId: ID!) {
  contentSchemaField(id: $contentSchemaFieldId) {
    id
    fieldType
    fieldName
    fieldLabel
    isRequired
    options
  }
}
    `;

/**
 * __useContentSchemaFieldQuery__
 *
 * To run a query within a React component, call `useContentSchemaFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSchemaFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSchemaFieldQuery({
 *   variables: {
 *      contentSchemaFieldId: // value for 'contentSchemaFieldId'
 *   },
 * });
 */
export function useContentSchemaFieldQuery(baseOptions: Apollo.QueryHookOptions<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>(ContentSchemaFieldDocument, options);
      }
export function useContentSchemaFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>(ContentSchemaFieldDocument, options);
        }
export function useContentSchemaFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>(ContentSchemaFieldDocument, options);
        }
export type ContentSchemaFieldQueryHookResult = ReturnType<typeof useContentSchemaFieldQuery>;
export type ContentSchemaFieldLazyQueryHookResult = ReturnType<typeof useContentSchemaFieldLazyQuery>;
export type ContentSchemaFieldSuspenseQueryHookResult = ReturnType<typeof useContentSchemaFieldSuspenseQuery>;
export type ContentSchemaFieldQueryResult = Apollo.QueryResult<ContentSchemaFieldQuery, ContentSchemaFieldQueryVariables>;
export const MetadataValueGroupsDocument = gql`
    query MetadataValueGroups($schemaId: String!, $schemaFieldId: String!) {
  metadataValueGroups(schemaId: $schemaId, schemaFieldId: $schemaFieldId) {
    groups {
      schemaId
      schemaFieldId
      value
      count
    }
    totalGroups
    totalDocuments
  }
}
    `;

/**
 * __useMetadataValueGroupsQuery__
 *
 * To run a query within a React component, call `useMetadataValueGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataValueGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetadataValueGroupsQuery({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *      schemaFieldId: // value for 'schemaFieldId'
 *   },
 * });
 */
export function useMetadataValueGroupsQuery(baseOptions: Apollo.QueryHookOptions<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>(MetadataValueGroupsDocument, options);
      }
export function useMetadataValueGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>(MetadataValueGroupsDocument, options);
        }
export function useMetadataValueGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>(MetadataValueGroupsDocument, options);
        }
export type MetadataValueGroupsQueryHookResult = ReturnType<typeof useMetadataValueGroupsQuery>;
export type MetadataValueGroupsLazyQueryHookResult = ReturnType<typeof useMetadataValueGroupsLazyQuery>;
export type MetadataValueGroupsSuspenseQueryHookResult = ReturnType<typeof useMetadataValueGroupsSuspenseQuery>;
export type MetadataValueGroupsQueryResult = Apollo.QueryResult<MetadataValueGroupsQuery, MetadataValueGroupsQueryVariables>;
export const BulkUpdateMetadataValuesDocument = gql`
    mutation BulkUpdateMetadataValues($input: BulkUpdateMetadataInput!) {
  bulkUpdateMetadataValues(input: $input) {
    updatedCount
    affectedDocumentIds
    success
    message
  }
}
    `;
export type BulkUpdateMetadataValuesMutationFn = Apollo.MutationFunction<BulkUpdateMetadataValuesMutation, BulkUpdateMetadataValuesMutationVariables>;

/**
 * __useBulkUpdateMetadataValuesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateMetadataValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateMetadataValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateMetadataValuesMutation, { data, loading, error }] = useBulkUpdateMetadataValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateMetadataValuesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateMetadataValuesMutation, BulkUpdateMetadataValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateMetadataValuesMutation, BulkUpdateMetadataValuesMutationVariables>(BulkUpdateMetadataValuesDocument, options);
      }
export type BulkUpdateMetadataValuesMutationHookResult = ReturnType<typeof useBulkUpdateMetadataValuesMutation>;
export type BulkUpdateMetadataValuesMutationResult = Apollo.MutationResult<BulkUpdateMetadataValuesMutation>;
export type BulkUpdateMetadataValuesMutationOptions = Apollo.BaseMutationOptions<BulkUpdateMetadataValuesMutation, BulkUpdateMetadataValuesMutationVariables>;
export const GetContentSchemaByIdDocument = gql`
    query GetContentSchemaById($contentSchemaId: ID!) {
  contentSchema(id: $contentSchemaId) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    contentType
    isActive
    fields {
      id
      orderIndex
      fieldName
      fieldLabel
      fieldType
      isGroup
      isRequired
      createdAt
      updatedAt
      isActive
      schema {
        id
        __typename
      }
      __typename
      options
    }
    dependency {
      id
      name
      __typename
    }
    __typename
    allowChildren
    childrenSchemas {
      id
      createdAt
      updatedAt
      deletedAt
      name
      description
      contentType
      isActive
      allowChildren
      maxNestingLevel
      hierarchyLabel
      dependencyCount
      fields {
        id
        createdAt
        updatedAt
        deletedAt
        fieldName
        fieldLabel
        fieldType
        isRequired
        orderIndex
        options
        validationRules
        defaultValue
        isActive
        isGroup
      }
      allDependencies {
        id
        createdAt
        updatedAt
        deletedAt
        name
        type
        status
        countUser
      }
      dependency {
        id
        name
        createdAt
        updatedAt
        deletedAt
        type
        status
        countUser
      }
    }
    userContentSchemaAssignments {
      dependencies
      userId
      canAssociateAnyDependency
    }
  }
}
    `;

/**
 * __useGetContentSchemaByIdQuery__
 *
 * To run a query within a React component, call `useGetContentSchemaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentSchemaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentSchemaByIdQuery({
 *   variables: {
 *      contentSchemaId: // value for 'contentSchemaId'
 *   },
 * });
 */
export function useGetContentSchemaByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>(GetContentSchemaByIdDocument, options);
      }
export function useGetContentSchemaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>(GetContentSchemaByIdDocument, options);
        }
export function useGetContentSchemaByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>(GetContentSchemaByIdDocument, options);
        }
export type GetContentSchemaByIdQueryHookResult = ReturnType<typeof useGetContentSchemaByIdQuery>;
export type GetContentSchemaByIdLazyQueryHookResult = ReturnType<typeof useGetContentSchemaByIdLazyQuery>;
export type GetContentSchemaByIdSuspenseQueryHookResult = ReturnType<typeof useGetContentSchemaByIdSuspenseQuery>;
export type GetContentSchemaByIdQueryResult = Apollo.QueryResult<GetContentSchemaByIdQuery, GetContentSchemaByIdQueryVariables>;
export const GetAllDependenciesBySchemaDocument = gql`
    query GetAllDependenciesBySchema($schemaId: String!) {
  getAllDependenciesBySchema(schemaId: $schemaId) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    type
    status
    countUser
  }
}
    `;

/**
 * __useGetAllDependenciesBySchemaQuery__
 *
 * To run a query within a React component, call `useGetAllDependenciesBySchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDependenciesBySchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDependenciesBySchemaQuery({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *   },
 * });
 */
export function useGetAllDependenciesBySchemaQuery(baseOptions: Apollo.QueryHookOptions<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>(GetAllDependenciesBySchemaDocument, options);
      }
export function useGetAllDependenciesBySchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>(GetAllDependenciesBySchemaDocument, options);
        }
export function useGetAllDependenciesBySchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>(GetAllDependenciesBySchemaDocument, options);
        }
export type GetAllDependenciesBySchemaQueryHookResult = ReturnType<typeof useGetAllDependenciesBySchemaQuery>;
export type GetAllDependenciesBySchemaLazyQueryHookResult = ReturnType<typeof useGetAllDependenciesBySchemaLazyQuery>;
export type GetAllDependenciesBySchemaSuspenseQueryHookResult = ReturnType<typeof useGetAllDependenciesBySchemaSuspenseQuery>;
export type GetAllDependenciesBySchemaQueryResult = Apollo.QueryResult<GetAllDependenciesBySchemaQuery, GetAllDependenciesBySchemaQueryVariables>;
export const CreateContentSchemaDocument = gql`
    mutation CreateContentSchema($createInput: CreateContentSchemaInput!) {
  createContentSchema(createInput: $createInput) {
    id
    name
  }
}
    `;
export type CreateContentSchemaMutationFn = Apollo.MutationFunction<CreateContentSchemaMutation, CreateContentSchemaMutationVariables>;

/**
 * __useCreateContentSchemaMutation__
 *
 * To run a mutation, you first call `useCreateContentSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentSchemaMutation, { data, loading, error }] = useCreateContentSchemaMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateContentSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentSchemaMutation, CreateContentSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentSchemaMutation, CreateContentSchemaMutationVariables>(CreateContentSchemaDocument, options);
      }
export type CreateContentSchemaMutationHookResult = ReturnType<typeof useCreateContentSchemaMutation>;
export type CreateContentSchemaMutationResult = Apollo.MutationResult<CreateContentSchemaMutation>;
export type CreateContentSchemaMutationOptions = Apollo.BaseMutationOptions<CreateContentSchemaMutation, CreateContentSchemaMutationVariables>;
export const CreateContentSchemaFieldDocument = gql`
    mutation CreateContentSchemaField($createInput: CreateContentSchemaFieldInput!) {
  createContentSchemaField(createInput: $createInput) {
    id
    fieldName
  }
}
    `;
export type CreateContentSchemaFieldMutationFn = Apollo.MutationFunction<CreateContentSchemaFieldMutation, CreateContentSchemaFieldMutationVariables>;

/**
 * __useCreateContentSchemaFieldMutation__
 *
 * To run a mutation, you first call `useCreateContentSchemaFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentSchemaFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentSchemaFieldMutation, { data, loading, error }] = useCreateContentSchemaFieldMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateContentSchemaFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentSchemaFieldMutation, CreateContentSchemaFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentSchemaFieldMutation, CreateContentSchemaFieldMutationVariables>(CreateContentSchemaFieldDocument, options);
      }
export type CreateContentSchemaFieldMutationHookResult = ReturnType<typeof useCreateContentSchemaFieldMutation>;
export type CreateContentSchemaFieldMutationResult = Apollo.MutationResult<CreateContentSchemaFieldMutation>;
export type CreateContentSchemaFieldMutationOptions = Apollo.BaseMutationOptions<CreateContentSchemaFieldMutation, CreateContentSchemaFieldMutationVariables>;
export const UpdateContentSchemaDocument = gql`
    mutation UpdateContentSchema($updateInput: UpdateContentSchemaInput!) {
  updateContentSchema(updateInput: $updateInput) {
    id
    name
  }
}
    `;
export type UpdateContentSchemaMutationFn = Apollo.MutationFunction<UpdateContentSchemaMutation, UpdateContentSchemaMutationVariables>;

/**
 * __useUpdateContentSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateContentSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSchemaMutation, { data, loading, error }] = useUpdateContentSchemaMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateContentSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentSchemaMutation, UpdateContentSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentSchemaMutation, UpdateContentSchemaMutationVariables>(UpdateContentSchemaDocument, options);
      }
export type UpdateContentSchemaMutationHookResult = ReturnType<typeof useUpdateContentSchemaMutation>;
export type UpdateContentSchemaMutationResult = Apollo.MutationResult<UpdateContentSchemaMutation>;
export type UpdateContentSchemaMutationOptions = Apollo.BaseMutationOptions<UpdateContentSchemaMutation, UpdateContentSchemaMutationVariables>;
export const UpdateContentSchemaFieldDocument = gql`
    mutation UpdateContentSchemaField($updateInput: UpdateContentSchemaFieldInput!) {
  updateContentSchemaField(updateInput: $updateInput) {
    id
    fieldName
  }
}
    `;
export type UpdateContentSchemaFieldMutationFn = Apollo.MutationFunction<UpdateContentSchemaFieldMutation, UpdateContentSchemaFieldMutationVariables>;

/**
 * __useUpdateContentSchemaFieldMutation__
 *
 * To run a mutation, you first call `useUpdateContentSchemaFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSchemaFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSchemaFieldMutation, { data, loading, error }] = useUpdateContentSchemaFieldMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateContentSchemaFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentSchemaFieldMutation, UpdateContentSchemaFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentSchemaFieldMutation, UpdateContentSchemaFieldMutationVariables>(UpdateContentSchemaFieldDocument, options);
      }
export type UpdateContentSchemaFieldMutationHookResult = ReturnType<typeof useUpdateContentSchemaFieldMutation>;
export type UpdateContentSchemaFieldMutationResult = Apollo.MutationResult<UpdateContentSchemaFieldMutation>;
export type UpdateContentSchemaFieldMutationOptions = Apollo.BaseMutationOptions<UpdateContentSchemaFieldMutation, UpdateContentSchemaFieldMutationVariables>;
export const RemoveContentSchemaDocument = gql`
    mutation RemoveContentSchema($removeContentSchemaId: ID!) {
  removeContentSchema(id: $removeContentSchemaId) {
    id
    name
  }
}
    `;
export type RemoveContentSchemaMutationFn = Apollo.MutationFunction<RemoveContentSchemaMutation, RemoveContentSchemaMutationVariables>;

/**
 * __useRemoveContentSchemaMutation__
 *
 * To run a mutation, you first call `useRemoveContentSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentSchemaMutation, { data, loading, error }] = useRemoveContentSchemaMutation({
 *   variables: {
 *      removeContentSchemaId: // value for 'removeContentSchemaId'
 *   },
 * });
 */
export function useRemoveContentSchemaMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentSchemaMutation, RemoveContentSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentSchemaMutation, RemoveContentSchemaMutationVariables>(RemoveContentSchemaDocument, options);
      }
export type RemoveContentSchemaMutationHookResult = ReturnType<typeof useRemoveContentSchemaMutation>;
export type RemoveContentSchemaMutationResult = Apollo.MutationResult<RemoveContentSchemaMutation>;
export type RemoveContentSchemaMutationOptions = Apollo.BaseMutationOptions<RemoveContentSchemaMutation, RemoveContentSchemaMutationVariables>;
export const RemoveContentSchemaFieldDocument = gql`
    mutation RemoveContentSchemaField($removeContentSchemaFieldId: ID!) {
  removeContentSchemaField(id: $removeContentSchemaFieldId) {
    id
    fieldName
  }
}
    `;
export type RemoveContentSchemaFieldMutationFn = Apollo.MutationFunction<RemoveContentSchemaFieldMutation, RemoveContentSchemaFieldMutationVariables>;

/**
 * __useRemoveContentSchemaFieldMutation__
 *
 * To run a mutation, you first call `useRemoveContentSchemaFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentSchemaFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentSchemaFieldMutation, { data, loading, error }] = useRemoveContentSchemaFieldMutation({
 *   variables: {
 *      removeContentSchemaFieldId: // value for 'removeContentSchemaFieldId'
 *   },
 * });
 */
export function useRemoveContentSchemaFieldMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentSchemaFieldMutation, RemoveContentSchemaFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentSchemaFieldMutation, RemoveContentSchemaFieldMutationVariables>(RemoveContentSchemaFieldDocument, options);
      }
export type RemoveContentSchemaFieldMutationHookResult = ReturnType<typeof useRemoveContentSchemaFieldMutation>;
export type RemoveContentSchemaFieldMutationResult = Apollo.MutationResult<RemoveContentSchemaFieldMutation>;
export type RemoveContentSchemaFieldMutationOptions = Apollo.BaseMutationOptions<RemoveContentSchemaFieldMutation, RemoveContentSchemaFieldMutationVariables>;
export const AddDependenciesToSchemaDocument = gql`
    mutation AddDependenciesToSchema($input: BatchAddDependenciesInput!) {
  addDependenciesToSchema(input: $input) {
    id
    isActive
    isPrimary
  }
}
    `;
export type AddDependenciesToSchemaMutationFn = Apollo.MutationFunction<AddDependenciesToSchemaMutation, AddDependenciesToSchemaMutationVariables>;

/**
 * __useAddDependenciesToSchemaMutation__
 *
 * To run a mutation, you first call `useAddDependenciesToSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDependenciesToSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDependenciesToSchemaMutation, { data, loading, error }] = useAddDependenciesToSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDependenciesToSchemaMutation(baseOptions?: Apollo.MutationHookOptions<AddDependenciesToSchemaMutation, AddDependenciesToSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDependenciesToSchemaMutation, AddDependenciesToSchemaMutationVariables>(AddDependenciesToSchemaDocument, options);
      }
export type AddDependenciesToSchemaMutationHookResult = ReturnType<typeof useAddDependenciesToSchemaMutation>;
export type AddDependenciesToSchemaMutationResult = Apollo.MutationResult<AddDependenciesToSchemaMutation>;
export type AddDependenciesToSchemaMutationOptions = Apollo.BaseMutationOptions<AddDependenciesToSchemaMutation, AddDependenciesToSchemaMutationVariables>;
export const RemoveDependenciesFromSchemaDocument = gql`
    mutation RemoveDependenciesFromSchema($schemaId: String!, $dependencyIds: [String!]!) {
  removeDependenciesFromSchema(schemaId: $schemaId, dependencyIds: $dependencyIds) {
    id
    createdAt
    isActive
  }
}
    `;
export type RemoveDependenciesFromSchemaMutationFn = Apollo.MutationFunction<RemoveDependenciesFromSchemaMutation, RemoveDependenciesFromSchemaMutationVariables>;

/**
 * __useRemoveDependenciesFromSchemaMutation__
 *
 * To run a mutation, you first call `useRemoveDependenciesFromSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDependenciesFromSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDependenciesFromSchemaMutation, { data, loading, error }] = useRemoveDependenciesFromSchemaMutation({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *      dependencyIds: // value for 'dependencyIds'
 *   },
 * });
 */
export function useRemoveDependenciesFromSchemaMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDependenciesFromSchemaMutation, RemoveDependenciesFromSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDependenciesFromSchemaMutation, RemoveDependenciesFromSchemaMutationVariables>(RemoveDependenciesFromSchemaDocument, options);
      }
export type RemoveDependenciesFromSchemaMutationHookResult = ReturnType<typeof useRemoveDependenciesFromSchemaMutation>;
export type RemoveDependenciesFromSchemaMutationResult = Apollo.MutationResult<RemoveDependenciesFromSchemaMutation>;
export type RemoveDependenciesFromSchemaMutationOptions = Apollo.BaseMutationOptions<RemoveDependenciesFromSchemaMutation, RemoveDependenciesFromSchemaMutationVariables>;
export const AssignUsersToContentSchemaDocument = gql`
    mutation AssignUsersToContentSchema($input: AssignUsersToContentSchemaInput!) {
  assignUsersToContentSchema(input: $input) {
    errors
    totalAssigned
  }
}
    `;
export type AssignUsersToContentSchemaMutationFn = Apollo.MutationFunction<AssignUsersToContentSchemaMutation, AssignUsersToContentSchemaMutationVariables>;

/**
 * __useAssignUsersToContentSchemaMutation__
 *
 * To run a mutation, you first call `useAssignUsersToContentSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersToContentSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUsersToContentSchemaMutation, { data, loading, error }] = useAssignUsersToContentSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignUsersToContentSchemaMutation(baseOptions?: Apollo.MutationHookOptions<AssignUsersToContentSchemaMutation, AssignUsersToContentSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUsersToContentSchemaMutation, AssignUsersToContentSchemaMutationVariables>(AssignUsersToContentSchemaDocument, options);
      }
export type AssignUsersToContentSchemaMutationHookResult = ReturnType<typeof useAssignUsersToContentSchemaMutation>;
export type AssignUsersToContentSchemaMutationResult = Apollo.MutationResult<AssignUsersToContentSchemaMutation>;
export type AssignUsersToContentSchemaMutationOptions = Apollo.BaseMutationOptions<AssignUsersToContentSchemaMutation, AssignUsersToContentSchemaMutationVariables>;
export const GetAssignmentsByContentSchemaDocument = gql`
    query GetAssignmentsByContentSchema($contentSchemaId: String!) {
  getAssignmentsByContentSchema(contentSchemaId: $contentSchemaId) {
    id
    dependencies
    canAssociateAnyDependency
    user {
      id
      name
      lastName
      fullName
    }
  }
}
    `;

/**
 * __useGetAssignmentsByContentSchemaQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsByContentSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsByContentSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsByContentSchemaQuery({
 *   variables: {
 *      contentSchemaId: // value for 'contentSchemaId'
 *   },
 * });
 */
export function useGetAssignmentsByContentSchemaQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>(GetAssignmentsByContentSchemaDocument, options);
      }
export function useGetAssignmentsByContentSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>(GetAssignmentsByContentSchemaDocument, options);
        }
export function useGetAssignmentsByContentSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>(GetAssignmentsByContentSchemaDocument, options);
        }
export type GetAssignmentsByContentSchemaQueryHookResult = ReturnType<typeof useGetAssignmentsByContentSchemaQuery>;
export type GetAssignmentsByContentSchemaLazyQueryHookResult = ReturnType<typeof useGetAssignmentsByContentSchemaLazyQuery>;
export type GetAssignmentsByContentSchemaSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentsByContentSchemaSuspenseQuery>;
export type GetAssignmentsByContentSchemaQueryResult = Apollo.QueryResult<GetAssignmentsByContentSchemaQuery, GetAssignmentsByContentSchemaQueryVariables>;
export const FooterDetailDocument = gql`
    query FooterDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageFooterBar {
      id
      description
      isDisabled
      canBeDisabled
      location
      pageBlockStyle
      subPages
      title
      subtitle
      logoImage {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      logoLink
      adminOtherLogo {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      adminOtherLogoLink
      administrationLogo {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      administrationLogoLink
      campusData
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        socialNetworkName
        hasSocialNetworkIcon
        socialNetworkLink
        pageDirectory
        pageDirectoryLink {
          id
          routeType
          routeNavigation
          target
          arguments
          url
        }
        footerType
        hasAnoterCampusData
        anotherCampusData
        socialNetworkIcon {
          fileName
          downloadUrl
          fileExtension
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFooterDetailQuery__
 *
 * To run a query within a React component, call `useFooterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useFooterDetailQuery(baseOptions: Apollo.QueryHookOptions<FooterDetailQuery, FooterDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterDetailQuery, FooterDetailQueryVariables>(FooterDetailDocument, options);
      }
export function useFooterDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterDetailQuery, FooterDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterDetailQuery, FooterDetailQueryVariables>(FooterDetailDocument, options);
        }
export function useFooterDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FooterDetailQuery, FooterDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FooterDetailQuery, FooterDetailQueryVariables>(FooterDetailDocument, options);
        }
export type FooterDetailQueryHookResult = ReturnType<typeof useFooterDetailQuery>;
export type FooterDetailLazyQueryHookResult = ReturnType<typeof useFooterDetailLazyQuery>;
export type FooterDetailSuspenseQueryHookResult = ReturnType<typeof useFooterDetailSuspenseQuery>;
export type FooterDetailQueryResult = Apollo.QueryResult<FooterDetailQuery, FooterDetailQueryVariables>;
export const UpdateFooterDetailDocument = gql`
    mutation UpdateFooterDetail($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageFooterBar {
      id
    }
  }
}
    `;
export type UpdateFooterDetailMutationFn = Apollo.MutationFunction<UpdateFooterDetailMutation, UpdateFooterDetailMutationVariables>;

/**
 * __useUpdateFooterDetailMutation__
 *
 * To run a mutation, you first call `useUpdateFooterDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFooterDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFooterDetailMutation, { data, loading, error }] = useUpdateFooterDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFooterDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFooterDetailMutation, UpdateFooterDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFooterDetailMutation, UpdateFooterDetailMutationVariables>(UpdateFooterDetailDocument, options);
      }
export type UpdateFooterDetailMutationHookResult = ReturnType<typeof useUpdateFooterDetailMutation>;
export type UpdateFooterDetailMutationResult = Apollo.MutationResult<UpdateFooterDetailMutation>;
export type UpdateFooterDetailMutationOptions = Apollo.BaseMutationOptions<UpdateFooterDetailMutation, UpdateFooterDetailMutationVariables>;
export const FooterDocument = gql`
    query Footer {
  footer {
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      subtitle
      nit
      address
      postalCode
      openingHours
      phone
      fax
      citizenLine
      antiCorruptionLine
      institutionalEmail
      judicialEmail
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
    }
  }
}
    `;

/**
 * __useFooterQuery__
 *
 * To run a query within a React component, call `useFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useFooterQuery(baseOptions?: Apollo.QueryHookOptions<FooterQuery, FooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
      }
export function useFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterQuery, FooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
        }
export function useFooterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FooterQuery, FooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
        }
export type FooterQueryHookResult = ReturnType<typeof useFooterQuery>;
export type FooterLazyQueryHookResult = ReturnType<typeof useFooterLazyQuery>;
export type FooterSuspenseQueryHookResult = ReturnType<typeof useFooterSuspenseQuery>;
export type FooterQueryResult = Apollo.QueryResult<FooterQuery, FooterQueryVariables>;
export const PageBlocksFooterDocument = gql`
    query PageBlocksFooter($versionId: ID!, $locations: [BlockLocation!]!, $showDisabled: Boolean) {
  pageBlocks(versionId: $versionId, locations: $locations, showDisabled: $showDisabled) {
    ... on PageFooterBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      subtitle
      campusData
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        socialNetworkName
        hasSocialNetworkIcon
        socialNetworkLink
        pageDirectory
        pageDirectoryLink {
          id
          routeType
          routeNavigation
          target
          arguments
          url
        }
        footerType
        hasAnoterCampusData
        anotherCampusData
        socialNetworkIcon {
          downloadUrl
          id
          url
        }
      }
    }
    ... on PageQuickAccessBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
    }
    ... on PageAccessibilityBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      pageBlockStyle
    }
    ... on PageCorporateLogosBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      items {
        id
        corporateLogo {
          id
          url
          downloadUrl
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
        }
        corporateLogoLink
        corporateLogoName
        orderIndex
      }
    }
  }
}
    `;

/**
 * __usePageBlocksFooterQuery__
 *
 * To run a query within a React component, call `usePageBlocksFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBlocksFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBlocksFooterQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function usePageBlocksFooterQuery(baseOptions: Apollo.QueryHookOptions<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>(PageBlocksFooterDocument, options);
      }
export function usePageBlocksFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>(PageBlocksFooterDocument, options);
        }
export function usePageBlocksFooterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>(PageBlocksFooterDocument, options);
        }
export type PageBlocksFooterQueryHookResult = ReturnType<typeof usePageBlocksFooterQuery>;
export type PageBlocksFooterLazyQueryHookResult = ReturnType<typeof usePageBlocksFooterLazyQuery>;
export type PageBlocksFooterSuspenseQueryHookResult = ReturnType<typeof usePageBlocksFooterSuspenseQuery>;
export type PageBlocksFooterQueryResult = Apollo.QueryResult<PageBlocksFooterQuery, PageBlocksFooterQueryVariables>;
export const UpdatePageBlockFooterDocument = gql`
    mutation UpdatePageBlockFooter($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageFooterBar {
      id
    }
  }
}
    `;
export type UpdatePageBlockFooterMutationFn = Apollo.MutationFunction<UpdatePageBlockFooterMutation, UpdatePageBlockFooterMutationVariables>;

/**
 * __useUpdatePageBlockFooterMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockFooterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockFooterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockFooterMutation, { data, loading, error }] = useUpdatePageBlockFooterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockFooterMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockFooterMutation, UpdatePageBlockFooterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockFooterMutation, UpdatePageBlockFooterMutationVariables>(UpdatePageBlockFooterDocument, options);
      }
export type UpdatePageBlockFooterMutationHookResult = ReturnType<typeof useUpdatePageBlockFooterMutation>;
export type UpdatePageBlockFooterMutationResult = Apollo.MutationResult<UpdatePageBlockFooterMutation>;
export type UpdatePageBlockFooterMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockFooterMutation, UpdatePageBlockFooterMutationVariables>;
export const HeaderDocument = gql`
    query Header {
  header {
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      subtitle
      administrationLogoLink
      adminOtherLogoLink
      logoLink
    }
  }
}
    `;

/**
 * __useHeaderQuery__
 *
 * To run a query within a React component, call `useHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaderQuery(baseOptions?: Apollo.QueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
      }
export function useHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
        }
export function useHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
        }
export type HeaderQueryHookResult = ReturnType<typeof useHeaderQuery>;
export type HeaderLazyQueryHookResult = ReturnType<typeof useHeaderLazyQuery>;
export type HeaderSuspenseQueryHookResult = ReturnType<typeof useHeaderSuspenseQuery>;
export type HeaderQueryResult = Apollo.QueryResult<HeaderQuery, HeaderQueryVariables>;
export const PageBlockHeaderDocument = gql`
    query PageBlockHeader($versionId: ID!, $locations: [BlockLocation!]!, $showDisabled: Boolean) {
  pageBlocks(versionId: $versionId, locations: $locations, showDisabled: $showDisabled) {
    ... on PageSearchBlock {
      id
      orderIndex
      blockTitle
      type
      description
      isDisabled
      createdAt
      updatedAt
      placeholder
      canBeDisabled
      pageBlockStyle
    }
    ... on PageAccessibilityButton {
      id
      orderIndex
      title
      type
      description
      isDisabled
      createdAt
      updatedAt
      canBeDisabled
      items {
        id
        altText
        iconType
        isActive
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
        }
        orderIndex
        linkUrl
        linkName
      }
    }
    ... on PageHeaderBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasSearchbar
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
      logoImage {
        id
        url
        downloadUrl
      }
      administrationLogo {
        id
        url
        downloadUrl
      }
      adminOtherLogo {
        id
        url
        downloadUrl
      }
      govcoLink {
        id
        routeNavigation
        routeType
        arguments
      }
    }
    ... on PageNavigationBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      rootItem {
        id
        name
        linkItem {
          id
          arguments
          routeType
          routeNavigation
          target
          url
        }
        children {
          id
          name
          orderIndex
          link
          linkItem {
            id
            arguments
            routeType
            routeNavigation
            target
            url
          }
          children {
            id
            name
            link
            linkItem {
              id
              arguments
              routeType
              routeNavigation
              target
              url
            }
          }
        }
      }
    }
    ... on PageHeaderOrganizationBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      title
      subtitle
      logoImage {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        downloadUrl
      }
      logoImageLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
      adminOtherLogo {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        downloadUrl
      }
      adminAnotherLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
      administrationLogo {
        id
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        downloadUrl
      }
      adminLogoLink {
        id
        routeType
        target
        routeNavigation
        url
        arguments
      }
    }
  }
}
    `;

/**
 * __usePageBlockHeaderQuery__
 *
 * To run a query within a React component, call `usePageBlockHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBlockHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBlockHeaderQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function usePageBlockHeaderQuery(baseOptions: Apollo.QueryHookOptions<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>(PageBlockHeaderDocument, options);
      }
export function usePageBlockHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>(PageBlockHeaderDocument, options);
        }
export function usePageBlockHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>(PageBlockHeaderDocument, options);
        }
export type PageBlockHeaderQueryHookResult = ReturnType<typeof usePageBlockHeaderQuery>;
export type PageBlockHeaderLazyQueryHookResult = ReturnType<typeof usePageBlockHeaderLazyQuery>;
export type PageBlockHeaderSuspenseQueryHookResult = ReturnType<typeof usePageBlockHeaderSuspenseQuery>;
export type PageBlockHeaderQueryResult = Apollo.QueryResult<PageBlockHeaderQuery, PageBlockHeaderQueryVariables>;
export const UpdatePageBlockHeaderDocument = gql`
    mutation UpdatePageBlockHeader($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageHeaderBar {
      id
    }
  }
}
    `;
export type UpdatePageBlockHeaderMutationFn = Apollo.MutationFunction<UpdatePageBlockHeaderMutation, UpdatePageBlockHeaderMutationVariables>;

/**
 * __useUpdatePageBlockHeaderMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockHeaderMutation, { data, loading, error }] = useUpdatePageBlockHeaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockHeaderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockHeaderMutation, UpdatePageBlockHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockHeaderMutation, UpdatePageBlockHeaderMutationVariables>(UpdatePageBlockHeaderDocument, options);
      }
export type UpdatePageBlockHeaderMutationHookResult = ReturnType<typeof useUpdatePageBlockHeaderMutation>;
export type UpdatePageBlockHeaderMutationResult = Apollo.MutationResult<UpdatePageBlockHeaderMutation>;
export type UpdatePageBlockHeaderMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockHeaderMutation, UpdatePageBlockHeaderMutationVariables>;
export const HomePageAdminDocument = gql`
    query HomePageAdmin($locations: [BlockLocation!]!, $versionId: ID!, $showDisabled: Boolean) {
  pageBlocks(locations: $locations, versionId: $versionId, showDisabled: $showDisabled) {
    ... on PageMapBlock {
      id
      isDisabled
      canBeDisabled
      description
      publicDescription
      showDescription
      showTitle
      type
      createdAt
      updatedAt
      deletedAt
      orderIndex
      __typename
    }
    ... on PageSliderBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      sliders {
        id
        title
        orderIndex
        description
        link
        tags
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageCabinetBlock {
      items {
        id
        createdAt
        updatedAt
        description
        cabinetName
        cabinetDescription
        cabinetPosition {
          id
          createdAt
          updatedAt
          deletedAt
          name
          __typename
        }
        cabinetImage {
          id
          createdAt
          downloadUrl
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        pageCabinetBlockTextAlternative: alternativeText
        curriculumVitaeLink
        cabinetDetails {
          id
          createdAt
          updatedAt
          deletedAt
          cabinetDetailLink {
            arguments
            id
            routeNavigation
            routeType
            target
            url
            __typename
          }
          cabinetDetailName
          cabinetDetailImage {
            id
            fileMode
            fileMongoId
            id
            url
            downloadUrl
            __typename
          }
          cabinetDetailStatus
          cabinetItem {
            alternativeText
            cabinetDescription
            cabinetDetails {
              cabinetDetailImage {
                id
                fileMongoId
                fileName
                fileMode
                fileExtension
                url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageTaxesBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      taxSectionTitle
      items {
        id
        taxTitle
        image {
          id
          url
          __typename
        }
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageNewsletterBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      news {
        id
        updatedAt
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        title
        summary
        __typename
      }
      __typename
    }
    ... on PageEventsBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      seeMoreLink
      subPages
      events {
        id
        eventItemTitle
        eventItemDescription
        descriptionPlace
        summary
        startDate
        endDate
        latitude
        longitude
        address
        image {
          id
          url
          __typename
        }
        link
        shareLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageProceduresBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleProcedures
      descriptionProcedures
      seeMoreAction
      seeMoreActionLink
      procedures {
        id
        name
        cost
        modality
        date
        action
        actionLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageRegulationsBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      regulations {
        id
        date
        title
        description
        file {
          id
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      publicDescription
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        snsTitle
        snsSocialNetworkType
        itemLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageCustomBlock {
      id
      blockTitle
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
    ... on PageCabinetBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      pageSocialNetworkTitle: title
      seeMoreLink
      leftItems {
        id
        orderIndex
        image {
          id
          __typename
        }
        __typename
      }
      rightItems {
        id
        orderIndex
        socialNetworkType
        link
        linkItem {
          id
          url
          routeType
          routeNavigation
          target
          arguments
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageQuickAccessBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      isCarrousel
      itemsPerView
      color
      items {
        id
        image {
          id
          url
          downloadUrl
          __typename
        }
        quickAccessName
        description
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageAlertsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      alertTitle: title
      blockTitle
      description
      alertDescription
      alertStyle
      buttonTitle
      actionType
      displayFrequency
      orderIndex
      htmlTemplate
      canBeDisabled
      isDisabled
      type
      image {
        id
        url
        fileName
        downloadUrl
        fileExtension
      }
      linkItem {
        id
        arguments
        routeType
        routeNavigation
        target
        url
      }
    }
  }
}
    `;

/**
 * __useHomePageAdminQuery__
 *
 * To run a query within a React component, call `useHomePageAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageAdminQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      versionId: // value for 'versionId'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function useHomePageAdminQuery(baseOptions: Apollo.QueryHookOptions<HomePageAdminQuery, HomePageAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageAdminQuery, HomePageAdminQueryVariables>(HomePageAdminDocument, options);
      }
export function useHomePageAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageAdminQuery, HomePageAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageAdminQuery, HomePageAdminQueryVariables>(HomePageAdminDocument, options);
        }
export function useHomePageAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomePageAdminQuery, HomePageAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePageAdminQuery, HomePageAdminQueryVariables>(HomePageAdminDocument, options);
        }
export type HomePageAdminQueryHookResult = ReturnType<typeof useHomePageAdminQuery>;
export type HomePageAdminLazyQueryHookResult = ReturnType<typeof useHomePageAdminLazyQuery>;
export type HomePageAdminSuspenseQueryHookResult = ReturnType<typeof useHomePageAdminSuspenseQuery>;
export type HomePageAdminQueryResult = Apollo.QueryResult<HomePageAdminQuery, HomePageAdminQueryVariables>;
export const UpdateHomePageBlockDocument = gql`
    mutation UpdateHomePageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSliderBlock {
      id
    }
  }
}
    `;
export type UpdateHomePageBlockMutationFn = Apollo.MutationFunction<UpdateHomePageBlockMutation, UpdateHomePageBlockMutationVariables>;

/**
 * __useUpdateHomePageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateHomePageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHomePageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHomePageBlockMutation, { data, loading, error }] = useUpdateHomePageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHomePageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHomePageBlockMutation, UpdateHomePageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHomePageBlockMutation, UpdateHomePageBlockMutationVariables>(UpdateHomePageBlockDocument, options);
      }
export type UpdateHomePageBlockMutationHookResult = ReturnType<typeof useUpdateHomePageBlockMutation>;
export type UpdateHomePageBlockMutationResult = Apollo.MutationResult<UpdateHomePageBlockMutation>;
export type UpdateHomePageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateHomePageBlockMutation, UpdateHomePageBlockMutationVariables>;
export const RemovePageBlockItemInstitutionalDocument = gql`
    mutation RemovePageBlockItemInstitutional($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageInstitutionalProgramsTypesBlockItem {
      id
    }
  }
}
    `;
export type RemovePageBlockItemInstitutionalMutationFn = Apollo.MutationFunction<RemovePageBlockItemInstitutionalMutation, RemovePageBlockItemInstitutionalMutationVariables>;

/**
 * __useRemovePageBlockItemInstitutionalMutation__
 *
 * To run a mutation, you first call `useRemovePageBlockItemInstitutionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageBlockItemInstitutionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageBlockItemInstitutionalMutation, { data, loading, error }] = useRemovePageBlockItemInstitutionalMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemovePageBlockItemInstitutionalMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageBlockItemInstitutionalMutation, RemovePageBlockItemInstitutionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageBlockItemInstitutionalMutation, RemovePageBlockItemInstitutionalMutationVariables>(RemovePageBlockItemInstitutionalDocument, options);
      }
export type RemovePageBlockItemInstitutionalMutationHookResult = ReturnType<typeof useRemovePageBlockItemInstitutionalMutation>;
export type RemovePageBlockItemInstitutionalMutationResult = Apollo.MutationResult<RemovePageBlockItemInstitutionalMutation>;
export type RemovePageBlockItemInstitutionalMutationOptions = Apollo.BaseMutationOptions<RemovePageBlockItemInstitutionalMutation, RemovePageBlockItemInstitutionalMutationVariables>;
export const PageInstitutionalProgramsTypesBlockItemDocument = gql`
    query PageInstitutionalProgramsTypesBlockItem($parentId: ID!) {
  pageBlockItems(parentId: $parentId) {
    ... on PageInstitutionalProgramsTypesBlockItem {
      id
      programsType
      image {
        id
      }
      createdAt
      updatedAt
      description
      title
      alternativeText
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsTypesBlockItemQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsTypesBlockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsTypesBlockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsTypesBlockItemQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function usePageInstitutionalProgramsTypesBlockItemQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>(PageInstitutionalProgramsTypesBlockItemDocument, options);
      }
export function usePageInstitutionalProgramsTypesBlockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>(PageInstitutionalProgramsTypesBlockItemDocument, options);
        }
export function usePageInstitutionalProgramsTypesBlockItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>(PageInstitutionalProgramsTypesBlockItemDocument, options);
        }
export type PageInstitutionalProgramsTypesBlockItemQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockItemQuery>;
export type PageInstitutionalProgramsTypesBlockItemLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockItemLazyQuery>;
export type PageInstitutionalProgramsTypesBlockItemSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockItemSuspenseQuery>;
export type PageInstitutionalProgramsTypesBlockItemQueryResult = Apollo.QueryResult<PageInstitutionalProgramsTypesBlockItemQuery, PageInstitutionalProgramsTypesBlockItemQueryVariables>;
export const UpdatePageBlockItemInstitutionalTypeBlockItemDocument = gql`
    mutation UpdatePageBlockItemInstitutionalTypeBlockItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageInstitutionalProgramsTypesBlockItem {
      id
    }
  }
}
    `;
export type UpdatePageBlockItemInstitutionalTypeBlockItemMutationFn = Apollo.MutationFunction<UpdatePageBlockItemInstitutionalTypeBlockItemMutation, UpdatePageBlockItemInstitutionalTypeBlockItemMutationVariables>;

/**
 * __useUpdatePageBlockItemInstitutionalTypeBlockItemMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemInstitutionalTypeBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemInstitutionalTypeBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemInstitutionalTypeBlockItemMutation, { data, loading, error }] = useUpdatePageBlockItemInstitutionalTypeBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemInstitutionalTypeBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemInstitutionalTypeBlockItemMutation, UpdatePageBlockItemInstitutionalTypeBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemInstitutionalTypeBlockItemMutation, UpdatePageBlockItemInstitutionalTypeBlockItemMutationVariables>(UpdatePageBlockItemInstitutionalTypeBlockItemDocument, options);
      }
export type UpdatePageBlockItemInstitutionalTypeBlockItemMutationHookResult = ReturnType<typeof useUpdatePageBlockItemInstitutionalTypeBlockItemMutation>;
export type UpdatePageBlockItemInstitutionalTypeBlockItemMutationResult = Apollo.MutationResult<UpdatePageBlockItemInstitutionalTypeBlockItemMutation>;
export type UpdatePageBlockItemInstitutionalTypeBlockItemMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemInstitutionalTypeBlockItemMutation, UpdatePageBlockItemInstitutionalTypeBlockItemMutationVariables>;
export const PageInstitutionalProgramsTypesBlockItemTypeDocument = gql`
    query PageInstitutionalProgramsTypesBlockItemType($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageInstitutionalProgramsTypesBlockItem {
      id
      createdAt
      updatedAt
      deletedAt
      description
      title
      alternativeText
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      programsType
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsTypesBlockItemTypeQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsTypesBlockItemTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsTypesBlockItemTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsTypesBlockItemTypeQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageInstitutionalProgramsTypesBlockItemTypeQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>(PageInstitutionalProgramsTypesBlockItemTypeDocument, options);
      }
export function usePageInstitutionalProgramsTypesBlockItemTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>(PageInstitutionalProgramsTypesBlockItemTypeDocument, options);
        }
export function usePageInstitutionalProgramsTypesBlockItemTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>(PageInstitutionalProgramsTypesBlockItemTypeDocument, options);
        }
export type PageInstitutionalProgramsTypesBlockItemTypeQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockItemTypeQuery>;
export type PageInstitutionalProgramsTypesBlockItemTypeLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockItemTypeLazyQuery>;
export type PageInstitutionalProgramsTypesBlockItemTypeSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockItemTypeSuspenseQuery>;
export type PageInstitutionalProgramsTypesBlockItemTypeQueryResult = Apollo.QueryResult<PageInstitutionalProgramsTypesBlockItemTypeQuery, PageInstitutionalProgramsTypesBlockItemTypeQueryVariables>;
export const PageInstitutionalProgramsSliderBlockItemsDocument = gql`
    query PageInstitutionalProgramsSliderBlockItems($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageInstitutionalProgramsSliderBlockItem {
      id
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
      title
      createdAt
      updatedAt
      deletedAt
      description
      tags
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      alternativeText
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsSliderBlockItemsQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsSliderBlockItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsSliderBlockItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsSliderBlockItemsQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageInstitutionalProgramsSliderBlockItemsQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>(PageInstitutionalProgramsSliderBlockItemsDocument, options);
      }
export function usePageInstitutionalProgramsSliderBlockItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>(PageInstitutionalProgramsSliderBlockItemsDocument, options);
        }
export function usePageInstitutionalProgramsSliderBlockItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>(PageInstitutionalProgramsSliderBlockItemsDocument, options);
        }
export type PageInstitutionalProgramsSliderBlockItemsQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockItemsQuery>;
export type PageInstitutionalProgramsSliderBlockItemsLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockItemsLazyQuery>;
export type PageInstitutionalProgramsSliderBlockItemsSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockItemsSuspenseQuery>;
export type PageInstitutionalProgramsSliderBlockItemsQueryResult = Apollo.QueryResult<PageInstitutionalProgramsSliderBlockItemsQuery, PageInstitutionalProgramsSliderBlockItemsQueryVariables>;
export const UserInfoByTokenDocument = gql`
    query userInfoByToken($validateTokenInput: ValidateTokenInput!) {
  validateUserToken(validateTokenInput: $validateTokenInput) {
    name
    id
    lastName
    middleName
    fullName
    secondSurname
    email
    phoneNumber
    type
    phoneVerification
    emailVerification
    status
    temporalPassword
    permissions
    userDependencies {
      id
      createdAt
      updatedAt
      deletedAt
      status
      dependency {
        id
        createdAt
        updatedAt
        deletedAt
        name
        type
        status
      }
    }
  }
}
    `;

/**
 * __useUserInfoByTokenQuery__
 *
 * To run a query within a React component, call `useUserInfoByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoByTokenQuery({
 *   variables: {
 *      validateTokenInput: // value for 'validateTokenInput'
 *   },
 * });
 */
export function useUserInfoByTokenQuery(baseOptions: Apollo.QueryHookOptions<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>(UserInfoByTokenDocument, options);
      }
export function useUserInfoByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>(UserInfoByTokenDocument, options);
        }
export function useUserInfoByTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>(UserInfoByTokenDocument, options);
        }
export type UserInfoByTokenQueryHookResult = ReturnType<typeof useUserInfoByTokenQuery>;
export type UserInfoByTokenLazyQueryHookResult = ReturnType<typeof useUserInfoByTokenLazyQuery>;
export type UserInfoByTokenSuspenseQueryHookResult = ReturnType<typeof useUserInfoByTokenSuspenseQuery>;
export type UserInfoByTokenQueryResult = Apollo.QueryResult<UserInfoByTokenQuery, UserInfoByTokenQueryVariables>;
export const UpdateUserInformationDocument = gql`
    mutation UpdateUserInformation($updateUserInformationInput: UpdateUserInformationInput!) {
  updateUserInformation(updateUserInformationInput: $updateUserInformationInput) {
    name
    lastName
    middleName
    secondSurname
    email
    phoneNumber
    type
    phoneVerification
    emailVerification
  }
}
    `;
export type UpdateUserInformationMutationFn = Apollo.MutationFunction<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;

/**
 * __useUpdateUserInformationMutation__
 *
 * To run a mutation, you first call `useUpdateUserInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInformationMutation, { data, loading, error }] = useUpdateUserInformationMutation({
 *   variables: {
 *      updateUserInformationInput: // value for 'updateUserInformationInput'
 *   },
 * });
 */
export function useUpdateUserInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>(UpdateUserInformationDocument, options);
      }
export type UpdateUserInformationMutationHookResult = ReturnType<typeof useUpdateUserInformationMutation>;
export type UpdateUserInformationMutationResult = Apollo.MutationResult<UpdateUserInformationMutation>;
export type UpdateUserInformationMutationOptions = Apollo.BaseMutationOptions<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;
export const EnableAndDisableDoubleVerificationDocument = gql`
    mutation EnableAndDisableDoubleVerification($doubleVerificationInput: DoubleVerificationInput!) {
  enableAndDisableDoubleVerification(doubleVerificationInput: $doubleVerificationInput)
}
    `;
export type EnableAndDisableDoubleVerificationMutationFn = Apollo.MutationFunction<EnableAndDisableDoubleVerificationMutation, EnableAndDisableDoubleVerificationMutationVariables>;

/**
 * __useEnableAndDisableDoubleVerificationMutation__
 *
 * To run a mutation, you first call `useEnableAndDisableDoubleVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAndDisableDoubleVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAndDisableDoubleVerificationMutation, { data, loading, error }] = useEnableAndDisableDoubleVerificationMutation({
 *   variables: {
 *      doubleVerificationInput: // value for 'doubleVerificationInput'
 *   },
 * });
 */
export function useEnableAndDisableDoubleVerificationMutation(baseOptions?: Apollo.MutationHookOptions<EnableAndDisableDoubleVerificationMutation, EnableAndDisableDoubleVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableAndDisableDoubleVerificationMutation, EnableAndDisableDoubleVerificationMutationVariables>(EnableAndDisableDoubleVerificationDocument, options);
      }
export type EnableAndDisableDoubleVerificationMutationHookResult = ReturnType<typeof useEnableAndDisableDoubleVerificationMutation>;
export type EnableAndDisableDoubleVerificationMutationResult = Apollo.MutationResult<EnableAndDisableDoubleVerificationMutation>;
export type EnableAndDisableDoubleVerificationMutationOptions = Apollo.BaseMutationOptions<EnableAndDisableDoubleVerificationMutation, EnableAndDisableDoubleVerificationMutationVariables>;
export const SendCodeDoubleVerificationDocument = gql`
    mutation SendCodeDoubleVerification($sendDoubleVerificationInput: SendDoubleVerificationInput!) {
  sendCodeDoubleVerification(sendDoubleVerificationInput: $sendDoubleVerificationInput)
}
    `;
export type SendCodeDoubleVerificationMutationFn = Apollo.MutationFunction<SendCodeDoubleVerificationMutation, SendCodeDoubleVerificationMutationVariables>;

/**
 * __useSendCodeDoubleVerificationMutation__
 *
 * To run a mutation, you first call `useSendCodeDoubleVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCodeDoubleVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCodeDoubleVerificationMutation, { data, loading, error }] = useSendCodeDoubleVerificationMutation({
 *   variables: {
 *      sendDoubleVerificationInput: // value for 'sendDoubleVerificationInput'
 *   },
 * });
 */
export function useSendCodeDoubleVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendCodeDoubleVerificationMutation, SendCodeDoubleVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCodeDoubleVerificationMutation, SendCodeDoubleVerificationMutationVariables>(SendCodeDoubleVerificationDocument, options);
      }
export type SendCodeDoubleVerificationMutationHookResult = ReturnType<typeof useSendCodeDoubleVerificationMutation>;
export type SendCodeDoubleVerificationMutationResult = Apollo.MutationResult<SendCodeDoubleVerificationMutation>;
export type SendCodeDoubleVerificationMutationOptions = Apollo.BaseMutationOptions<SendCodeDoubleVerificationMutation, SendCodeDoubleVerificationMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($updateUserPasswordInput: UpdateUserPasswordInput!) {
  updateUserPassword(updateUserPasswordInput: $updateUserPasswordInput) {
    id
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      updateUserPasswordInput: // value for 'updateUserPasswordInput'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdatePageBlockOrdersDocument = gql`
    mutation UpdatePageBlockOrders($input: [UpdateOrderPageBlockInput!]!) {
  updatePageBlockOrders(input: $input) {
    id
    orderIndex
  }
}
    `;
export type UpdatePageBlockOrdersMutationFn = Apollo.MutationFunction<UpdatePageBlockOrdersMutation, UpdatePageBlockOrdersMutationVariables>;

/**
 * __useUpdatePageBlockOrdersMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockOrdersMutation, { data, loading, error }] = useUpdatePageBlockOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockOrdersMutation, UpdatePageBlockOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockOrdersMutation, UpdatePageBlockOrdersMutationVariables>(UpdatePageBlockOrdersDocument, options);
      }
export type UpdatePageBlockOrdersMutationHookResult = ReturnType<typeof useUpdatePageBlockOrdersMutation>;
export type UpdatePageBlockOrdersMutationResult = Apollo.MutationResult<UpdatePageBlockOrdersMutation>;
export type UpdatePageBlockOrdersMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockOrdersMutation, UpdatePageBlockOrdersMutationVariables>;
export const CreatePageBlockItemLogoDocument = gql`
    mutation CreatePageBlockItemLogo($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageCorporateLogosBlockItem {
      id
      corporateLogoName
      corporateLogo {
        id
      }
      linkItem {
        url
        updatedAt
        target
        routeType
        routeNavigation
        arguments
      }
      corporateLogo {
        id
        fileName
        fileMongoId
      }
    }
  }
}
    `;
export type CreatePageBlockItemLogoMutationFn = Apollo.MutationFunction<CreatePageBlockItemLogoMutation, CreatePageBlockItemLogoMutationVariables>;

/**
 * __useCreatePageBlockItemLogoMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockItemLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockItemLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockItemLogoMutation, { data, loading, error }] = useCreatePageBlockItemLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockItemLogoMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockItemLogoMutation, CreatePageBlockItemLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockItemLogoMutation, CreatePageBlockItemLogoMutationVariables>(CreatePageBlockItemLogoDocument, options);
      }
export type CreatePageBlockItemLogoMutationHookResult = ReturnType<typeof useCreatePageBlockItemLogoMutation>;
export type CreatePageBlockItemLogoMutationResult = Apollo.MutationResult<CreatePageBlockItemLogoMutation>;
export type CreatePageBlockItemLogoMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockItemLogoMutation, CreatePageBlockItemLogoMutationVariables>;
export const RemovePageBlockItemCorporateDocument = gql`
    mutation RemovePageBlockItemCorporate($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageCorporateLogosBlockItem {
      id
    }
  }
}
    `;
export type RemovePageBlockItemCorporateMutationFn = Apollo.MutationFunction<RemovePageBlockItemCorporateMutation, RemovePageBlockItemCorporateMutationVariables>;

/**
 * __useRemovePageBlockItemCorporateMutation__
 *
 * To run a mutation, you first call `useRemovePageBlockItemCorporateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageBlockItemCorporateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageBlockItemCorporateMutation, { data, loading, error }] = useRemovePageBlockItemCorporateMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemovePageBlockItemCorporateMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageBlockItemCorporateMutation, RemovePageBlockItemCorporateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageBlockItemCorporateMutation, RemovePageBlockItemCorporateMutationVariables>(RemovePageBlockItemCorporateDocument, options);
      }
export type RemovePageBlockItemCorporateMutationHookResult = ReturnType<typeof useRemovePageBlockItemCorporateMutation>;
export type RemovePageBlockItemCorporateMutationResult = Apollo.MutationResult<RemovePageBlockItemCorporateMutation>;
export type RemovePageBlockItemCorporateMutationOptions = Apollo.BaseMutationOptions<RemovePageBlockItemCorporateMutation, RemovePageBlockItemCorporateMutationVariables>;
export const UpdatePageBlockItemLogoDocument = gql`
    mutation UpdatePageBlockItemLogo($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageCorporateLogosBlockItem {
      id
      alternativeText
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
      description
      corporateLogoLink
      corporateLogoName
      corporateLogo {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
    }
  }
}
    `;
export type UpdatePageBlockItemLogoMutationFn = Apollo.MutationFunction<UpdatePageBlockItemLogoMutation, UpdatePageBlockItemLogoMutationVariables>;

/**
 * __useUpdatePageBlockItemLogoMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemLogoMutation, { data, loading, error }] = useUpdatePageBlockItemLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemLogoMutation, UpdatePageBlockItemLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemLogoMutation, UpdatePageBlockItemLogoMutationVariables>(UpdatePageBlockItemLogoDocument, options);
      }
export type UpdatePageBlockItemLogoMutationHookResult = ReturnType<typeof useUpdatePageBlockItemLogoMutation>;
export type UpdatePageBlockItemLogoMutationResult = Apollo.MutationResult<UpdatePageBlockItemLogoMutation>;
export type UpdatePageBlockItemLogoMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemLogoMutation, UpdatePageBlockItemLogoMutationVariables>;
export const PageCorporateLogosEntityBlockItemDocument = gql`
    query PageCorporateLogosEntityBlockItem($parentId: ID!) {
  pageBlockItems(parentId: $parentId) {
    ... on PageCorporateLogosBlockItem {
      id
      orderIndex
      corporateLogoName
      corporateLogoLink
      description
      updatedAt
      deletedAt
      createdAt
      alternativeText
      corporateLogo {
        fileMode
        id
        fileName
        url
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __usePageCorporateLogosEntityBlockItemQuery__
 *
 * To run a query within a React component, call `usePageCorporateLogosEntityBlockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCorporateLogosEntityBlockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCorporateLogosEntityBlockItemQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function usePageCorporateLogosEntityBlockItemQuery(baseOptions: Apollo.QueryHookOptions<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>(PageCorporateLogosEntityBlockItemDocument, options);
      }
export function usePageCorporateLogosEntityBlockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>(PageCorporateLogosEntityBlockItemDocument, options);
        }
export function usePageCorporateLogosEntityBlockItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>(PageCorporateLogosEntityBlockItemDocument, options);
        }
export type PageCorporateLogosEntityBlockItemQueryHookResult = ReturnType<typeof usePageCorporateLogosEntityBlockItemQuery>;
export type PageCorporateLogosEntityBlockItemLazyQueryHookResult = ReturnType<typeof usePageCorporateLogosEntityBlockItemLazyQuery>;
export type PageCorporateLogosEntityBlockItemSuspenseQueryHookResult = ReturnType<typeof usePageCorporateLogosEntityBlockItemSuspenseQuery>;
export type PageCorporateLogosEntityBlockItemQueryResult = Apollo.QueryResult<PageCorporateLogosEntityBlockItemQuery, PageCorporateLogosEntityBlockItemQueryVariables>;
export const PageCorporateLogosBlockItemUniqueDocument = gql`
    query PageCorporateLogosBlockItemUnique($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageCorporateLogosBlockItem {
      id
      corporateLogoName
      corporateLogoLink
      alternativeText
      corporateLogo {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      description
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __usePageCorporateLogosBlockItemUniqueQuery__
 *
 * To run a query within a React component, call `usePageCorporateLogosBlockItemUniqueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCorporateLogosBlockItemUniqueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCorporateLogosBlockItemUniqueQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageCorporateLogosBlockItemUniqueQuery(baseOptions: Apollo.QueryHookOptions<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>(PageCorporateLogosBlockItemUniqueDocument, options);
      }
export function usePageCorporateLogosBlockItemUniqueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>(PageCorporateLogosBlockItemUniqueDocument, options);
        }
export function usePageCorporateLogosBlockItemUniqueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>(PageCorporateLogosBlockItemUniqueDocument, options);
        }
export type PageCorporateLogosBlockItemUniqueQueryHookResult = ReturnType<typeof usePageCorporateLogosBlockItemUniqueQuery>;
export type PageCorporateLogosBlockItemUniqueLazyQueryHookResult = ReturnType<typeof usePageCorporateLogosBlockItemUniqueLazyQuery>;
export type PageCorporateLogosBlockItemUniqueSuspenseQueryHookResult = ReturnType<typeof usePageCorporateLogosBlockItemUniqueSuspenseQuery>;
export type PageCorporateLogosBlockItemUniqueQueryResult = Apollo.QueryResult<PageCorporateLogosBlockItemUniqueQuery, PageCorporateLogosBlockItemUniqueQueryVariables>;
export const UpdatePageBlockSliderDynamicDocument = gql`
    mutation UpdatePageBlockSliderDynamic($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageCabinetBlock {
      isCarrousel
      id
    }
  }
}
    `;
export type UpdatePageBlockSliderDynamicMutationFn = Apollo.MutationFunction<UpdatePageBlockSliderDynamicMutation, UpdatePageBlockSliderDynamicMutationVariables>;

/**
 * __useUpdatePageBlockSliderDynamicMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockSliderDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockSliderDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockSliderDynamicMutation, { data, loading, error }] = useUpdatePageBlockSliderDynamicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockSliderDynamicMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockSliderDynamicMutation, UpdatePageBlockSliderDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockSliderDynamicMutation, UpdatePageBlockSliderDynamicMutationVariables>(UpdatePageBlockSliderDynamicDocument, options);
      }
export type UpdatePageBlockSliderDynamicMutationHookResult = ReturnType<typeof useUpdatePageBlockSliderDynamicMutation>;
export type UpdatePageBlockSliderDynamicMutationResult = Apollo.MutationResult<UpdatePageBlockSliderDynamicMutation>;
export type UpdatePageBlockSliderDynamicMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockSliderDynamicMutation, UpdatePageBlockSliderDynamicMutationVariables>;
export const RemovePageBlockDynamicDocument = gql`
    mutation RemovePageBlockDynamic($removePageBlockItemId: ID!) {
  removePageBlock(id: $removePageBlockItemId) {
    ... on PageHeaderBar {
      id
    }
  }
}
    `;
export type RemovePageBlockDynamicMutationFn = Apollo.MutationFunction<RemovePageBlockDynamicMutation, RemovePageBlockDynamicMutationVariables>;

/**
 * __useRemovePageBlockDynamicMutation__
 *
 * To run a mutation, you first call `useRemovePageBlockDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageBlockDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageBlockDynamicMutation, { data, loading, error }] = useRemovePageBlockDynamicMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemovePageBlockDynamicMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageBlockDynamicMutation, RemovePageBlockDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageBlockDynamicMutation, RemovePageBlockDynamicMutationVariables>(RemovePageBlockDynamicDocument, options);
      }
export type RemovePageBlockDynamicMutationHookResult = ReturnType<typeof useRemovePageBlockDynamicMutation>;
export type RemovePageBlockDynamicMutationResult = Apollo.MutationResult<RemovePageBlockDynamicMutation>;
export type RemovePageBlockDynamicMutationOptions = Apollo.BaseMutationOptions<RemovePageBlockDynamicMutation, RemovePageBlockDynamicMutationVariables>;
export const CreatePageBlockDefaultDocument = gql`
    mutation CreatePageBlockDefault($input: CreateDefaultPageBlockInput!) {
  createPageBlockDefault(input: $input) {
    dynamic {
      id
    }
    location
    subPages
    isDisabled
    updatedAt
    id
  }
}
    `;
export type CreatePageBlockDefaultMutationFn = Apollo.MutationFunction<CreatePageBlockDefaultMutation, CreatePageBlockDefaultMutationVariables>;

/**
 * __useCreatePageBlockDefaultMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockDefaultMutation, { data, loading, error }] = useCreatePageBlockDefaultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockDefaultMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockDefaultMutation, CreatePageBlockDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockDefaultMutation, CreatePageBlockDefaultMutationVariables>(CreatePageBlockDefaultDocument, options);
      }
export type CreatePageBlockDefaultMutationHookResult = ReturnType<typeof useCreatePageBlockDefaultMutation>;
export type CreatePageBlockDefaultMutationResult = Apollo.MutationResult<CreatePageBlockDefaultMutation>;
export type CreatePageBlockDefaultMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockDefaultMutation, CreatePageBlockDefaultMutationVariables>;
export const PageInstitutionalProgramsTypesBlockByBlockDocument = gql`
    query PageInstitutionalProgramsTypesBlockByBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageTransparencyBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    __typename
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageHeaderOrganizationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      taxSectionTitle
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      seeMoreAction
      seeMoreLink
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtitle
      hasSearchbar
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      blockTitle
      seeMoreTitle
      seeMoreLink
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsTypesBlockByBlockQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsTypesBlockByBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsTypesBlockByBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsTypesBlockByBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageInstitutionalProgramsTypesBlockByBlockQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>(PageInstitutionalProgramsTypesBlockByBlockDocument, options);
      }
export function usePageInstitutionalProgramsTypesBlockByBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>(PageInstitutionalProgramsTypesBlockByBlockDocument, options);
        }
export function usePageInstitutionalProgramsTypesBlockByBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>(PageInstitutionalProgramsTypesBlockByBlockDocument, options);
        }
export type PageInstitutionalProgramsTypesBlockByBlockQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockByBlockQuery>;
export type PageInstitutionalProgramsTypesBlockByBlockLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockByBlockLazyQuery>;
export type PageInstitutionalProgramsTypesBlockByBlockSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockByBlockSuspenseQuery>;
export type PageInstitutionalProgramsTypesBlockByBlockQueryResult = Apollo.QueryResult<PageInstitutionalProgramsTypesBlockByBlockQuery, PageInstitutionalProgramsTypesBlockByBlockQueryVariables>;
export const UpdatePageBlockItemInstitutionalCarouselDocument = gql`
    mutation UpdatePageBlockItemInstitutionalCarousel($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageInstitutionalProgramsSliderBlockItem {
      id
      title
    }
  }
}
    `;
export type UpdatePageBlockItemInstitutionalCarouselMutationFn = Apollo.MutationFunction<UpdatePageBlockItemInstitutionalCarouselMutation, UpdatePageBlockItemInstitutionalCarouselMutationVariables>;

/**
 * __useUpdatePageBlockItemInstitutionalCarouselMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemInstitutionalCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemInstitutionalCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemInstitutionalCarouselMutation, { data, loading, error }] = useUpdatePageBlockItemInstitutionalCarouselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemInstitutionalCarouselMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemInstitutionalCarouselMutation, UpdatePageBlockItemInstitutionalCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemInstitutionalCarouselMutation, UpdatePageBlockItemInstitutionalCarouselMutationVariables>(UpdatePageBlockItemInstitutionalCarouselDocument, options);
      }
export type UpdatePageBlockItemInstitutionalCarouselMutationHookResult = ReturnType<typeof useUpdatePageBlockItemInstitutionalCarouselMutation>;
export type UpdatePageBlockItemInstitutionalCarouselMutationResult = Apollo.MutationResult<UpdatePageBlockItemInstitutionalCarouselMutation>;
export type UpdatePageBlockItemInstitutionalCarouselMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemInstitutionalCarouselMutation, UpdatePageBlockItemInstitutionalCarouselMutationVariables>;
export const CreatePageBlockItemInstitutionalProgramDocument = gql`
    mutation CreatePageBlockItemInstitutionalProgram($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageInstitutionalProgramsTypesBlockItem {
      id
      createdAt
      updatedAt
      deletedAt
      description
      orderIndex
      title
      alternativeText
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      programsType
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;
export type CreatePageBlockItemInstitutionalProgramMutationFn = Apollo.MutationFunction<CreatePageBlockItemInstitutionalProgramMutation, CreatePageBlockItemInstitutionalProgramMutationVariables>;

/**
 * __useCreatePageBlockItemInstitutionalProgramMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockItemInstitutionalProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockItemInstitutionalProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockItemInstitutionalProgramMutation, { data, loading, error }] = useCreatePageBlockItemInstitutionalProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockItemInstitutionalProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockItemInstitutionalProgramMutation, CreatePageBlockItemInstitutionalProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockItemInstitutionalProgramMutation, CreatePageBlockItemInstitutionalProgramMutationVariables>(CreatePageBlockItemInstitutionalProgramDocument, options);
      }
export type CreatePageBlockItemInstitutionalProgramMutationHookResult = ReturnType<typeof useCreatePageBlockItemInstitutionalProgramMutation>;
export type CreatePageBlockItemInstitutionalProgramMutationResult = Apollo.MutationResult<CreatePageBlockItemInstitutionalProgramMutation>;
export type CreatePageBlockItemInstitutionalProgramMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockItemInstitutionalProgramMutation, CreatePageBlockItemInstitutionalProgramMutationVariables>;
export const PageInstitutionalProgramsSliderBlockItemDocument = gql`
    query PageInstitutionalProgramsSliderBlockItem($parentId: ID!) {
  pageBlockItems(parentId: $parentId) {
    ... on PageInstitutionalProgramsSliderBlockItem {
      id
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        arguments
        url
      }
      tags
      title
      description
      createdAt
      updatedAt
      deletedAt
      orderIndex
      alternativeText
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsSliderBlockItemQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsSliderBlockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsSliderBlockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsSliderBlockItemQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function usePageInstitutionalProgramsSliderBlockItemQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>(PageInstitutionalProgramsSliderBlockItemDocument, options);
      }
export function usePageInstitutionalProgramsSliderBlockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>(PageInstitutionalProgramsSliderBlockItemDocument, options);
        }
export function usePageInstitutionalProgramsSliderBlockItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>(PageInstitutionalProgramsSliderBlockItemDocument, options);
        }
export type PageInstitutionalProgramsSliderBlockItemQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockItemQuery>;
export type PageInstitutionalProgramsSliderBlockItemLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockItemLazyQuery>;
export type PageInstitutionalProgramsSliderBlockItemSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockItemSuspenseQuery>;
export type PageInstitutionalProgramsSliderBlockItemQueryResult = Apollo.QueryResult<PageInstitutionalProgramsSliderBlockItemQuery, PageInstitutionalProgramsSliderBlockItemQueryVariables>;
export const RemovePageBlockItemInstitutionalCarouselDocument = gql`
    mutation RemovePageBlockItemInstitutionalCarousel($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageInstitutionalProgramsSliderBlockItem {
      id
    }
  }
}
    `;
export type RemovePageBlockItemInstitutionalCarouselMutationFn = Apollo.MutationFunction<RemovePageBlockItemInstitutionalCarouselMutation, RemovePageBlockItemInstitutionalCarouselMutationVariables>;

/**
 * __useRemovePageBlockItemInstitutionalCarouselMutation__
 *
 * To run a mutation, you first call `useRemovePageBlockItemInstitutionalCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageBlockItemInstitutionalCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageBlockItemInstitutionalCarouselMutation, { data, loading, error }] = useRemovePageBlockItemInstitutionalCarouselMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemovePageBlockItemInstitutionalCarouselMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageBlockItemInstitutionalCarouselMutation, RemovePageBlockItemInstitutionalCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageBlockItemInstitutionalCarouselMutation, RemovePageBlockItemInstitutionalCarouselMutationVariables>(RemovePageBlockItemInstitutionalCarouselDocument, options);
      }
export type RemovePageBlockItemInstitutionalCarouselMutationHookResult = ReturnType<typeof useRemovePageBlockItemInstitutionalCarouselMutation>;
export type RemovePageBlockItemInstitutionalCarouselMutationResult = Apollo.MutationResult<RemovePageBlockItemInstitutionalCarouselMutation>;
export type RemovePageBlockItemInstitutionalCarouselMutationOptions = Apollo.BaseMutationOptions<RemovePageBlockItemInstitutionalCarouselMutation, RemovePageBlockItemInstitutionalCarouselMutationVariables>;
export const PageInstitutionalProgramsSliderBlockStyleDocument = gql`
    query PageInstitutionalProgramsSliderBlockStyle($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageInstitutionalProgramsSliderBlock {
      description
      pageBlockStyle
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsSliderBlockStyleQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsSliderBlockStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsSliderBlockStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsSliderBlockStyleQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageInstitutionalProgramsSliderBlockStyleQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>(PageInstitutionalProgramsSliderBlockStyleDocument, options);
      }
export function usePageInstitutionalProgramsSliderBlockStyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>(PageInstitutionalProgramsSliderBlockStyleDocument, options);
        }
export function usePageInstitutionalProgramsSliderBlockStyleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>(PageInstitutionalProgramsSliderBlockStyleDocument, options);
        }
export type PageInstitutionalProgramsSliderBlockStyleQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockStyleQuery>;
export type PageInstitutionalProgramsSliderBlockStyleLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockStyleLazyQuery>;
export type PageInstitutionalProgramsSliderBlockStyleSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockStyleSuspenseQuery>;
export type PageInstitutionalProgramsSliderBlockStyleQueryResult = Apollo.QueryResult<PageInstitutionalProgramsSliderBlockStyleQuery, PageInstitutionalProgramsSliderBlockStyleQueryVariables>;
export const UpdateInstitutionalCarouselDocument = gql`
    mutation UpdateInstitutionalCarousel($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageInstitutionalProgramsSliderBlock {
      pageBlockStyle
    }
  }
}
    `;
export type UpdateInstitutionalCarouselMutationFn = Apollo.MutationFunction<UpdateInstitutionalCarouselMutation, UpdateInstitutionalCarouselMutationVariables>;

/**
 * __useUpdateInstitutionalCarouselMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionalCarouselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionalCarouselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionalCarouselMutation, { data, loading, error }] = useUpdateInstitutionalCarouselMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInstitutionalCarouselMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionalCarouselMutation, UpdateInstitutionalCarouselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionalCarouselMutation, UpdateInstitutionalCarouselMutationVariables>(UpdateInstitutionalCarouselDocument, options);
      }
export type UpdateInstitutionalCarouselMutationHookResult = ReturnType<typeof useUpdateInstitutionalCarouselMutation>;
export type UpdateInstitutionalCarouselMutationResult = Apollo.MutationResult<UpdateInstitutionalCarouselMutation>;
export type UpdateInstitutionalCarouselMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionalCarouselMutation, UpdateInstitutionalCarouselMutationVariables>;
export const UpdatePageBlockInstitutionalDocument = gql`
    mutation UpdatePageBlockInstitutional($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageInstitutionalProgramsTypesBlock {
      pageBlockStyle
      id
      description
    }
  }
}
    `;
export type UpdatePageBlockInstitutionalMutationFn = Apollo.MutationFunction<UpdatePageBlockInstitutionalMutation, UpdatePageBlockInstitutionalMutationVariables>;

/**
 * __useUpdatePageBlockInstitutionalMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockInstitutionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockInstitutionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockInstitutionalMutation, { data, loading, error }] = useUpdatePageBlockInstitutionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockInstitutionalMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockInstitutionalMutation, UpdatePageBlockInstitutionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockInstitutionalMutation, UpdatePageBlockInstitutionalMutationVariables>(UpdatePageBlockInstitutionalDocument, options);
      }
export type UpdatePageBlockInstitutionalMutationHookResult = ReturnType<typeof useUpdatePageBlockInstitutionalMutation>;
export type UpdatePageBlockInstitutionalMutationResult = Apollo.MutationResult<UpdatePageBlockInstitutionalMutation>;
export type UpdatePageBlockInstitutionalMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockInstitutionalMutation, UpdatePageBlockInstitutionalMutationVariables>;
export const PageInstitutionalProgramsTypesBlockDocument = gql`
    query PageInstitutionalProgramsTypesBlock($versionId: ID!, $locations: [BlockLocation!]!, $subPage: SubPages, $showDisabled: Boolean) {
  pageBlocks(versionId: $versionId, locations: $locations, subPage: $subPage, showDisabled: $showDisabled) {
    ... on PageInstitutionalProgramsTypesBlock {
      id
      type
      description
      orderIndex
      createdAt
      updatedAt
      deletedAt
      canBeDisabled
      isDisabled
      __typename
      pageInstitutionalProgramsTypesBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        title
        alternativeText
        programsType
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageSubDownloadBlock {
      id
      orderIndex
      type
      createdAt
      updatedAt
      canBeDisabled
      isDisabled
      description
      publicDescription
      showTitle
      showDescription
      __typename
      pageSubDownloadBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        name
        file {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      type
      orderIndex
      description
      createdAt
      updatedAt
      deletedAt
      canBeDisabled
      isDisabled
      __typename
      pageInstitutionalProgramsSliderBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        title
        alternativeText
        tags
        seeMoreAction
        seeMoreLink
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageEventSliderBlock {
      id
      orderIndex
      isDisabled
      canBeDisabled
      createdAt
      updatedAt
      deletedAt
      type
      __typename
      pageEventSliderBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        title
        seeMoreAction
        seeMoreLink
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageSliderBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      sliders {
        id
        title
        orderIndex
        description
        link
        tags
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageCabinetBlock {
      isCarrousel
      items {
        id
        createdAt
        updatedAt
        cabinetName
        cabinetDescription
        cabinetPosition {
          id
          createdAt
          updatedAt
          deletedAt
          name
          __typename
        }
        cabinetImage {
          id
          createdAt
          downloadUrl
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        alternativeText
        curriculumVitaeLink
        cabinetDetails {
          id
          createdAt
          updatedAt
          deletedAt
          cabinetDetailLink {
            arguments
            id
            routeNavigation
            routeType
            target
            url
            __typename
          }
          cabinetDetailName
          cabinetDetailImage {
            id
            fileMode
            fileMongoId
            id
            url
            __typename
          }
          cabinetDetailStatus
          cabinetItem {
            alternativeText
            cabinetDescription
            cabinetDetails {
              cabinetDetailImage {
                id
                fileMongoId
                fileName
                fileMode
                fileExtension
                url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageTaxesBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      taxSectionTitle
      pageTaxesBlockItems: items {
        id
        taxTitle
        image {
          id
          url
          __typename
        }
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageNewsletterBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      news {
        id
        updatedAt
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        title
        summary
        __typename
      }
      __typename
    }
    ... on PageEventsBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      seeMoreLink
      subPages
      events {
        id
        eventItemTitle
        eventItemDescription
        descriptionPlace
        summary
        startDate
        endDate
        latitude
        longitude
        address
        image {
          id
          url
          __typename
        }
        link
        shareLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageProceduresBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleProcedures
      descriptionProcedures
      seeMoreAction
      seeMoreActionLink
      procedures {
        id
        name
        tagsProcedure
        cost
        modality
        date
        action
        actionLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageRegulationsBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      regulations {
        id
        date
        title
        description
        file {
          id
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageSocialNetworksBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      seeMoreLink
      leftItems {
        id
        orderIndex
        image {
          id
          __typename
        }
        __typename
      }
      rightItems {
        id
        orderIndex
        socialNetworkType
        link
        linkItem {
          id
          url
          routeType
          routeNavigation
          target
          arguments
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageQuickAccessBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      pagequickAccessBarItems: items {
        id
        image {
          id
          url
          __typename
        }
        quickAccessName
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __usePageInstitutionalProgramsTypesBlockQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsTypesBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsTypesBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsTypesBlockQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function usePageInstitutionalProgramsTypesBlockQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>(PageInstitutionalProgramsTypesBlockDocument, options);
      }
export function usePageInstitutionalProgramsTypesBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>(PageInstitutionalProgramsTypesBlockDocument, options);
        }
export function usePageInstitutionalProgramsTypesBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>(PageInstitutionalProgramsTypesBlockDocument, options);
        }
export type PageInstitutionalProgramsTypesBlockQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockQuery>;
export type PageInstitutionalProgramsTypesBlockLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockLazyQuery>;
export type PageInstitutionalProgramsTypesBlockSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsTypesBlockSuspenseQuery>;
export type PageInstitutionalProgramsTypesBlockQueryResult = Apollo.QueryResult<PageInstitutionalProgramsTypesBlockQuery, PageInstitutionalProgramsTypesBlockQueryVariables>;
export const UpdateInstitucionalPageBlockDocument = gql`
    mutation UpdateInstitucionalPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageInstitutionalProgramsSliderBlock {
      id
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
    }
  }
}
    `;
export type UpdateInstitucionalPageBlockMutationFn = Apollo.MutationFunction<UpdateInstitucionalPageBlockMutation, UpdateInstitucionalPageBlockMutationVariables>;

/**
 * __useUpdateInstitucionalPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateInstitucionalPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitucionalPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitucionalPageBlockMutation, { data, loading, error }] = useUpdateInstitucionalPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInstitucionalPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitucionalPageBlockMutation, UpdateInstitucionalPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitucionalPageBlockMutation, UpdateInstitucionalPageBlockMutationVariables>(UpdateInstitucionalPageBlockDocument, options);
      }
export type UpdateInstitucionalPageBlockMutationHookResult = ReturnType<typeof useUpdateInstitucionalPageBlockMutation>;
export type UpdateInstitucionalPageBlockMutationResult = Apollo.MutationResult<UpdateInstitucionalPageBlockMutation>;
export type UpdateInstitucionalPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateInstitucionalPageBlockMutation, UpdateInstitucionalPageBlockMutationVariables>;
export const UpdateInstitutionalProgramsSliderItemOrdersDocument = gql`
    mutation UpdateInstitutionalProgramsSliderItemOrders($input: UpdateInstitutionalProgramsSliderItemsInput!) {
  updateInstitutionalProgramsSliderItemOrders(input: $input) {
    id
    orderIndex
  }
}
    `;
export type UpdateInstitutionalProgramsSliderItemOrdersMutationFn = Apollo.MutationFunction<UpdateInstitutionalProgramsSliderItemOrdersMutation, UpdateInstitutionalProgramsSliderItemOrdersMutationVariables>;

/**
 * __useUpdateInstitutionalProgramsSliderItemOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionalProgramsSliderItemOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionalProgramsSliderItemOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionalProgramsSliderItemOrdersMutation, { data, loading, error }] = useUpdateInstitutionalProgramsSliderItemOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInstitutionalProgramsSliderItemOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionalProgramsSliderItemOrdersMutation, UpdateInstitutionalProgramsSliderItemOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionalProgramsSliderItemOrdersMutation, UpdateInstitutionalProgramsSliderItemOrdersMutationVariables>(UpdateInstitutionalProgramsSliderItemOrdersDocument, options);
      }
export type UpdateInstitutionalProgramsSliderItemOrdersMutationHookResult = ReturnType<typeof useUpdateInstitutionalProgramsSliderItemOrdersMutation>;
export type UpdateInstitutionalProgramsSliderItemOrdersMutationResult = Apollo.MutationResult<UpdateInstitutionalProgramsSliderItemOrdersMutation>;
export type UpdateInstitutionalProgramsSliderItemOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionalProgramsSliderItemOrdersMutation, UpdateInstitutionalProgramsSliderItemOrdersMutationVariables>;
export const PageSubHeaderBlockDocument = gql`
    query PageSubHeaderBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSubHeaderBlock {
      id
      subHeaderDescription
      subHeaderTitle
      subHeaderPlaceholder
      subHeaderSearchbar
      pageBlockStyle
    }
  }
}
    `;

/**
 * __usePageSubHeaderBlockQuery__
 *
 * To run a query within a React component, call `usePageSubHeaderBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageSubHeaderBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageSubHeaderBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageSubHeaderBlockQuery(baseOptions: Apollo.QueryHookOptions<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>(PageSubHeaderBlockDocument, options);
      }
export function usePageSubHeaderBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>(PageSubHeaderBlockDocument, options);
        }
export function usePageSubHeaderBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>(PageSubHeaderBlockDocument, options);
        }
export type PageSubHeaderBlockQueryHookResult = ReturnType<typeof usePageSubHeaderBlockQuery>;
export type PageSubHeaderBlockLazyQueryHookResult = ReturnType<typeof usePageSubHeaderBlockLazyQuery>;
export type PageSubHeaderBlockSuspenseQueryHookResult = ReturnType<typeof usePageSubHeaderBlockSuspenseQuery>;
export type PageSubHeaderBlockQueryResult = Apollo.QueryResult<PageSubHeaderBlockQuery, PageSubHeaderBlockQueryVariables>;
export const ParticipatePageDocument = gql`
    query ParticipatePage($subPage: SubPages, $showDisabled: Boolean, $locations: [BlockLocation!]!, $versionId: ID!) {
  pageBlocks(subPage: $subPage, showDisabled: $showDisabled, locations: $locations, versionId: $versionId) {
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtype
    }
    ... on PageAlertsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      orderIndex
      canBeDisabled
      isDisabled
      type
    }
    ... on PageTransparencyBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
      __typename
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      __typename
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      __typename
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
      __typename
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      taxSectionTitle
      __typename
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      seeMoreAction
      seeMoreLink
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtitle
      hasSearchbar
      __typename
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      blockTitle
      seeMoreTitle
      seeMoreLink
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      __typename
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        participateElementTitle
        participateElementImage {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
        participateLinkAction {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      __typename
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
      __typename
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      __typename
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useParticipatePageQuery__
 *
 * To run a query within a React component, call `useParticipatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipatePageQuery({
 *   variables: {
 *      subPage: // value for 'subPage'
 *      showDisabled: // value for 'showDisabled'
 *      locations: // value for 'locations'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useParticipatePageQuery(baseOptions: Apollo.QueryHookOptions<ParticipatePageQuery, ParticipatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipatePageQuery, ParticipatePageQueryVariables>(ParticipatePageDocument, options);
      }
export function useParticipatePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipatePageQuery, ParticipatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipatePageQuery, ParticipatePageQueryVariables>(ParticipatePageDocument, options);
        }
export function useParticipatePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParticipatePageQuery, ParticipatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParticipatePageQuery, ParticipatePageQueryVariables>(ParticipatePageDocument, options);
        }
export type ParticipatePageQueryHookResult = ReturnType<typeof useParticipatePageQuery>;
export type ParticipatePageLazyQueryHookResult = ReturnType<typeof useParticipatePageLazyQuery>;
export type ParticipatePageSuspenseQueryHookResult = ReturnType<typeof useParticipatePageSuspenseQuery>;
export type ParticipatePageQueryResult = Apollo.QueryResult<ParticipatePageQuery, ParticipatePageQueryVariables>;
export const UpdateParticipatePageBlockDocument = gql`
    mutation UpdateParticipatePageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSubHeaderBlock {
      id
    }
  }
}
    `;
export type UpdateParticipatePageBlockMutationFn = Apollo.MutationFunction<UpdateParticipatePageBlockMutation, UpdateParticipatePageBlockMutationVariables>;

/**
 * __useUpdateParticipatePageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateParticipatePageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipatePageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipatePageBlockMutation, { data, loading, error }] = useUpdateParticipatePageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParticipatePageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipatePageBlockMutation, UpdateParticipatePageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipatePageBlockMutation, UpdateParticipatePageBlockMutationVariables>(UpdateParticipatePageBlockDocument, options);
      }
export type UpdateParticipatePageBlockMutationHookResult = ReturnType<typeof useUpdateParticipatePageBlockMutation>;
export type UpdateParticipatePageBlockMutationResult = Apollo.MutationResult<UpdateParticipatePageBlockMutation>;
export type UpdateParticipatePageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateParticipatePageBlockMutation, UpdateParticipatePageBlockMutationVariables>;
export const UpdateParticipateDownloadsPageBlockDocument = gql`
    mutation UpdateParticipateDownloadsPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageParticipateDownloadBlock {
      id
    }
  }
}
    `;
export type UpdateParticipateDownloadsPageBlockMutationFn = Apollo.MutationFunction<UpdateParticipateDownloadsPageBlockMutation, UpdateParticipateDownloadsPageBlockMutationVariables>;

/**
 * __useUpdateParticipateDownloadsPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateParticipateDownloadsPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipateDownloadsPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipateDownloadsPageBlockMutation, { data, loading, error }] = useUpdateParticipateDownloadsPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParticipateDownloadsPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipateDownloadsPageBlockMutation, UpdateParticipateDownloadsPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipateDownloadsPageBlockMutation, UpdateParticipateDownloadsPageBlockMutationVariables>(UpdateParticipateDownloadsPageBlockDocument, options);
      }
export type UpdateParticipateDownloadsPageBlockMutationHookResult = ReturnType<typeof useUpdateParticipateDownloadsPageBlockMutation>;
export type UpdateParticipateDownloadsPageBlockMutationResult = Apollo.MutationResult<UpdateParticipateDownloadsPageBlockMutation>;
export type UpdateParticipateDownloadsPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateParticipateDownloadsPageBlockMutation, UpdateParticipateDownloadsPageBlockMutationVariables>;
export const GetParticipateDownloadsPageBlockDocument = gql`
    query GetParticipateDownloadsPageBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageParticipateDownloadBlock {
      id
      pageBlockStyle
    }
  }
}
    `;

/**
 * __useGetParticipateDownloadsPageBlockQuery__
 *
 * To run a query within a React component, call `useGetParticipateDownloadsPageBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipateDownloadsPageBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipateDownloadsPageBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetParticipateDownloadsPageBlockQuery(baseOptions: Apollo.QueryHookOptions<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>(GetParticipateDownloadsPageBlockDocument, options);
      }
export function useGetParticipateDownloadsPageBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>(GetParticipateDownloadsPageBlockDocument, options);
        }
export function useGetParticipateDownloadsPageBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>(GetParticipateDownloadsPageBlockDocument, options);
        }
export type GetParticipateDownloadsPageBlockQueryHookResult = ReturnType<typeof useGetParticipateDownloadsPageBlockQuery>;
export type GetParticipateDownloadsPageBlockLazyQueryHookResult = ReturnType<typeof useGetParticipateDownloadsPageBlockLazyQuery>;
export type GetParticipateDownloadsPageBlockSuspenseQueryHookResult = ReturnType<typeof useGetParticipateDownloadsPageBlockSuspenseQuery>;
export type GetParticipateDownloadsPageBlockQueryResult = Apollo.QueryResult<GetParticipateDownloadsPageBlockQuery, GetParticipateDownloadsPageBlockQueryVariables>;
export const UpdateParticipateElementsPageBlockDocument = gql`
    mutation UpdateParticipateElementsPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageParticipateElementBlock {
      id
    }
  }
}
    `;
export type UpdateParticipateElementsPageBlockMutationFn = Apollo.MutationFunction<UpdateParticipateElementsPageBlockMutation, UpdateParticipateElementsPageBlockMutationVariables>;

/**
 * __useUpdateParticipateElementsPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateParticipateElementsPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipateElementsPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipateElementsPageBlockMutation, { data, loading, error }] = useUpdateParticipateElementsPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParticipateElementsPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipateElementsPageBlockMutation, UpdateParticipateElementsPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipateElementsPageBlockMutation, UpdateParticipateElementsPageBlockMutationVariables>(UpdateParticipateElementsPageBlockDocument, options);
      }
export type UpdateParticipateElementsPageBlockMutationHookResult = ReturnType<typeof useUpdateParticipateElementsPageBlockMutation>;
export type UpdateParticipateElementsPageBlockMutationResult = Apollo.MutationResult<UpdateParticipateElementsPageBlockMutation>;
export type UpdateParticipateElementsPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateParticipateElementsPageBlockMutation, UpdateParticipateElementsPageBlockMutationVariables>;
export const GetParticipateElementsPageBlockDocument = gql`
    query GetParticipateElementsPageBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageParticipateElementBlock {
      id
      pageBlockStyle
      items {
        id
        orderIndex
        participateElementTitle
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetParticipateElementsPageBlockQuery__
 *
 * To run a query within a React component, call `useGetParticipateElementsPageBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipateElementsPageBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipateElementsPageBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetParticipateElementsPageBlockQuery(baseOptions: Apollo.QueryHookOptions<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>(GetParticipateElementsPageBlockDocument, options);
      }
export function useGetParticipateElementsPageBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>(GetParticipateElementsPageBlockDocument, options);
        }
export function useGetParticipateElementsPageBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>(GetParticipateElementsPageBlockDocument, options);
        }
export type GetParticipateElementsPageBlockQueryHookResult = ReturnType<typeof useGetParticipateElementsPageBlockQuery>;
export type GetParticipateElementsPageBlockLazyQueryHookResult = ReturnType<typeof useGetParticipateElementsPageBlockLazyQuery>;
export type GetParticipateElementsPageBlockSuspenseQueryHookResult = ReturnType<typeof useGetParticipateElementsPageBlockSuspenseQuery>;
export type GetParticipateElementsPageBlockQueryResult = Apollo.QueryResult<GetParticipateElementsPageBlockQuery, GetParticipateElementsPageBlockQueryVariables>;
export const CreateParticipateElementBlockItemDocument = gql`
    mutation CreateParticipateElementBlockItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageParticipateElementBlockItem {
      id
    }
  }
}
    `;
export type CreateParticipateElementBlockItemMutationFn = Apollo.MutationFunction<CreateParticipateElementBlockItemMutation, CreateParticipateElementBlockItemMutationVariables>;

/**
 * __useCreateParticipateElementBlockItemMutation__
 *
 * To run a mutation, you first call `useCreateParticipateElementBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParticipateElementBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParticipateElementBlockItemMutation, { data, loading, error }] = useCreateParticipateElementBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateParticipateElementBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateParticipateElementBlockItemMutation, CreateParticipateElementBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParticipateElementBlockItemMutation, CreateParticipateElementBlockItemMutationVariables>(CreateParticipateElementBlockItemDocument, options);
      }
export type CreateParticipateElementBlockItemMutationHookResult = ReturnType<typeof useCreateParticipateElementBlockItemMutation>;
export type CreateParticipateElementBlockItemMutationResult = Apollo.MutationResult<CreateParticipateElementBlockItemMutation>;
export type CreateParticipateElementBlockItemMutationOptions = Apollo.BaseMutationOptions<CreateParticipateElementBlockItemMutation, CreateParticipateElementBlockItemMutationVariables>;
export const UpdateParticipateElementBlockItemDocument = gql`
    mutation UpdateParticipateElementBlockItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageParticipateElementBlockItem {
      id
    }
  }
}
    `;
export type UpdateParticipateElementBlockItemMutationFn = Apollo.MutationFunction<UpdateParticipateElementBlockItemMutation, UpdateParticipateElementBlockItemMutationVariables>;

/**
 * __useUpdateParticipateElementBlockItemMutation__
 *
 * To run a mutation, you first call `useUpdateParticipateElementBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipateElementBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipateElementBlockItemMutation, { data, loading, error }] = useUpdateParticipateElementBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParticipateElementBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipateElementBlockItemMutation, UpdateParticipateElementBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipateElementBlockItemMutation, UpdateParticipateElementBlockItemMutationVariables>(UpdateParticipateElementBlockItemDocument, options);
      }
export type UpdateParticipateElementBlockItemMutationHookResult = ReturnType<typeof useUpdateParticipateElementBlockItemMutation>;
export type UpdateParticipateElementBlockItemMutationResult = Apollo.MutationResult<UpdateParticipateElementBlockItemMutation>;
export type UpdateParticipateElementBlockItemMutationOptions = Apollo.BaseMutationOptions<UpdateParticipateElementBlockItemMutation, UpdateParticipateElementBlockItemMutationVariables>;
export const GetParticipateElementBlockItemDocument = gql`
    query GetParticipateElementBlockItem($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageParticipateElementBlockItem {
      id
      description
      participateElementTitle
      participateElementImage {
        fileExtension
        fileMode
        id
        fileName
        fileMongoId
        url
      }
      participateLinkAction {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetParticipateElementBlockItemQuery__
 *
 * To run a query within a React component, call `useGetParticipateElementBlockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipateElementBlockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipateElementBlockItemQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetParticipateElementBlockItemQuery(baseOptions: Apollo.QueryHookOptions<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>(GetParticipateElementBlockItemDocument, options);
      }
export function useGetParticipateElementBlockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>(GetParticipateElementBlockItemDocument, options);
        }
export function useGetParticipateElementBlockItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>(GetParticipateElementBlockItemDocument, options);
        }
export type GetParticipateElementBlockItemQueryHookResult = ReturnType<typeof useGetParticipateElementBlockItemQuery>;
export type GetParticipateElementBlockItemLazyQueryHookResult = ReturnType<typeof useGetParticipateElementBlockItemLazyQuery>;
export type GetParticipateElementBlockItemSuspenseQueryHookResult = ReturnType<typeof useGetParticipateElementBlockItemSuspenseQuery>;
export type GetParticipateElementBlockItemQueryResult = Apollo.QueryResult<GetParticipateElementBlockItemQuery, GetParticipateElementBlockItemQueryVariables>;
export const RemoveParticipateElementBlockItemDocument = gql`
    mutation RemoveParticipateElementBlockItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageParticipateElementBlockItem {
      id
    }
  }
}
    `;
export type RemoveParticipateElementBlockItemMutationFn = Apollo.MutationFunction<RemoveParticipateElementBlockItemMutation, RemoveParticipateElementBlockItemMutationVariables>;

/**
 * __useRemoveParticipateElementBlockItemMutation__
 *
 * To run a mutation, you first call `useRemoveParticipateElementBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveParticipateElementBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeParticipateElementBlockItemMutation, { data, loading, error }] = useRemoveParticipateElementBlockItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveParticipateElementBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveParticipateElementBlockItemMutation, RemoveParticipateElementBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveParticipateElementBlockItemMutation, RemoveParticipateElementBlockItemMutationVariables>(RemoveParticipateElementBlockItemDocument, options);
      }
export type RemoveParticipateElementBlockItemMutationHookResult = ReturnType<typeof useRemoveParticipateElementBlockItemMutation>;
export type RemoveParticipateElementBlockItemMutationResult = Apollo.MutationResult<RemoveParticipateElementBlockItemMutation>;
export type RemoveParticipateElementBlockItemMutationOptions = Apollo.BaseMutationOptions<RemoveParticipateElementBlockItemMutation, RemoveParticipateElementBlockItemMutationVariables>;
export const PqrsdPageDocument = gql`
    query PqrsdPage($versionId: ID!, $locations: [BlockLocation!]!, $subPage: SubPages, $showDisabled: Boolean, $dynamicId: ID) {
  pageBlocks(versionId: $versionId, locations: $locations, subPage: $subPage, showDisabled: $showDisabled, dynamicId: $dynamicId) {
    ... on PageSubHeaderBlock {
      id
      type
      orderIndex
      pageBlockStyle
      createdAt
      updatedAt
      isDisabled
      canBeDisabled
      subHeaderTitle
      subHeaderDescription
    }
    ... on PagePqrsdfActionBlock {
      id
      type
      orderIndex
      pageBlockStyle
      createdAt
      updatedAt
      isDisabled
      canBeDisabled
    }
    ... on PagePqrsdfConsultBlock {
      id
      type
      orderIndex
      pageBlockStyle
      createdAt
      updatedAt
      isDisabled
      canBeDisabled
    }
  }
}
    `;

/**
 * __usePqrsdPageQuery__
 *
 * To run a query within a React component, call `usePqrsdPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePqrsdPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePqrsdPageQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *      showDisabled: // value for 'showDisabled'
 *      dynamicId: // value for 'dynamicId'
 *   },
 * });
 */
export function usePqrsdPageQuery(baseOptions: Apollo.QueryHookOptions<PqrsdPageQuery, PqrsdPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PqrsdPageQuery, PqrsdPageQueryVariables>(PqrsdPageDocument, options);
      }
export function usePqrsdPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PqrsdPageQuery, PqrsdPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PqrsdPageQuery, PqrsdPageQueryVariables>(PqrsdPageDocument, options);
        }
export function usePqrsdPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PqrsdPageQuery, PqrsdPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PqrsdPageQuery, PqrsdPageQueryVariables>(PqrsdPageDocument, options);
        }
export type PqrsdPageQueryHookResult = ReturnType<typeof usePqrsdPageQuery>;
export type PqrsdPageLazyQueryHookResult = ReturnType<typeof usePqrsdPageLazyQuery>;
export type PqrsdPageSuspenseQueryHookResult = ReturnType<typeof usePqrsdPageSuspenseQuery>;
export type PqrsdPageQueryResult = Apollo.QueryResult<PqrsdPageQuery, PqrsdPageQueryVariables>;
export const UpdatePqrsdPageBlockDocument = gql`
    mutation UpdatePqrsdPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSubHeaderBlock {
      id
    }
  }
}
    `;
export type UpdatePqrsdPageBlockMutationFn = Apollo.MutationFunction<UpdatePqrsdPageBlockMutation, UpdatePqrsdPageBlockMutationVariables>;

/**
 * __useUpdatePqrsdPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePqrsdPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePqrsdPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePqrsdPageBlockMutation, { data, loading, error }] = useUpdatePqrsdPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePqrsdPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePqrsdPageBlockMutation, UpdatePqrsdPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePqrsdPageBlockMutation, UpdatePqrsdPageBlockMutationVariables>(UpdatePqrsdPageBlockDocument, options);
      }
export type UpdatePqrsdPageBlockMutationHookResult = ReturnType<typeof useUpdatePqrsdPageBlockMutation>;
export type UpdatePqrsdPageBlockMutationResult = Apollo.MutationResult<UpdatePqrsdPageBlockMutation>;
export type UpdatePqrsdPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePqrsdPageBlockMutation, UpdatePqrsdPageBlockMutationVariables>;
export const CreatePqrsdPageBlockDocument = gql`
    mutation CreatePqrsdPageBlock($input: CreatePageBlockInputUnion!) {
  createPageBlock(input: $input) {
    ... on PageSubHeaderBlock {
      id
    }
  }
}
    `;
export type CreatePqrsdPageBlockMutationFn = Apollo.MutationFunction<CreatePqrsdPageBlockMutation, CreatePqrsdPageBlockMutationVariables>;

/**
 * __useCreatePqrsdPageBlockMutation__
 *
 * To run a mutation, you first call `useCreatePqrsdPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePqrsdPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPqrsdPageBlockMutation, { data, loading, error }] = useCreatePqrsdPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePqrsdPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreatePqrsdPageBlockMutation, CreatePqrsdPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePqrsdPageBlockMutation, CreatePqrsdPageBlockMutationVariables>(CreatePqrsdPageBlockDocument, options);
      }
export type CreatePqrsdPageBlockMutationHookResult = ReturnType<typeof useCreatePqrsdPageBlockMutation>;
export type CreatePqrsdPageBlockMutationResult = Apollo.MutationResult<CreatePqrsdPageBlockMutation>;
export type CreatePqrsdPageBlockMutationOptions = Apollo.BaseMutationOptions<CreatePqrsdPageBlockMutation, CreatePqrsdPageBlockMutationVariables>;
export const UpdatePqrsdActionsPageBlockDocument = gql`
    mutation UpdatePqrsdActionsPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PagePqrsdfActionBlock {
      id
    }
  }
}
    `;
export type UpdatePqrsdActionsPageBlockMutationFn = Apollo.MutationFunction<UpdatePqrsdActionsPageBlockMutation, UpdatePqrsdActionsPageBlockMutationVariables>;

/**
 * __useUpdatePqrsdActionsPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePqrsdActionsPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePqrsdActionsPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePqrsdActionsPageBlockMutation, { data, loading, error }] = useUpdatePqrsdActionsPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePqrsdActionsPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePqrsdActionsPageBlockMutation, UpdatePqrsdActionsPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePqrsdActionsPageBlockMutation, UpdatePqrsdActionsPageBlockMutationVariables>(UpdatePqrsdActionsPageBlockDocument, options);
      }
export type UpdatePqrsdActionsPageBlockMutationHookResult = ReturnType<typeof useUpdatePqrsdActionsPageBlockMutation>;
export type UpdatePqrsdActionsPageBlockMutationResult = Apollo.MutationResult<UpdatePqrsdActionsPageBlockMutation>;
export type UpdatePqrsdActionsPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePqrsdActionsPageBlockMutation, UpdatePqrsdActionsPageBlockMutationVariables>;
export const GetPqrsdActionsPageBlockDocument = gql`
    query GetPqrsdActionsPageBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PagePqrsdfActionBlock {
      id
      pageBlockStyle
    }
  }
}
    `;

/**
 * __useGetPqrsdActionsPageBlockQuery__
 *
 * To run a query within a React component, call `useGetPqrsdActionsPageBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPqrsdActionsPageBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPqrsdActionsPageBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPqrsdActionsPageBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>(GetPqrsdActionsPageBlockDocument, options);
      }
export function useGetPqrsdActionsPageBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>(GetPqrsdActionsPageBlockDocument, options);
        }
export function useGetPqrsdActionsPageBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>(GetPqrsdActionsPageBlockDocument, options);
        }
export type GetPqrsdActionsPageBlockQueryHookResult = ReturnType<typeof useGetPqrsdActionsPageBlockQuery>;
export type GetPqrsdActionsPageBlockLazyQueryHookResult = ReturnType<typeof useGetPqrsdActionsPageBlockLazyQuery>;
export type GetPqrsdActionsPageBlockSuspenseQueryHookResult = ReturnType<typeof useGetPqrsdActionsPageBlockSuspenseQuery>;
export type GetPqrsdActionsPageBlockQueryResult = Apollo.QueryResult<GetPqrsdActionsPageBlockQuery, GetPqrsdActionsPageBlockQueryVariables>;
export const UpdatePqrsdConsultPageBlockDocument = gql`
    mutation UpdatePqrsdConsultPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PagePqrsdfConsultBlock {
      id
    }
  }
}
    `;
export type UpdatePqrsdConsultPageBlockMutationFn = Apollo.MutationFunction<UpdatePqrsdConsultPageBlockMutation, UpdatePqrsdConsultPageBlockMutationVariables>;

/**
 * __useUpdatePqrsdConsultPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePqrsdConsultPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePqrsdConsultPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePqrsdConsultPageBlockMutation, { data, loading, error }] = useUpdatePqrsdConsultPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePqrsdConsultPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePqrsdConsultPageBlockMutation, UpdatePqrsdConsultPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePqrsdConsultPageBlockMutation, UpdatePqrsdConsultPageBlockMutationVariables>(UpdatePqrsdConsultPageBlockDocument, options);
      }
export type UpdatePqrsdConsultPageBlockMutationHookResult = ReturnType<typeof useUpdatePqrsdConsultPageBlockMutation>;
export type UpdatePqrsdConsultPageBlockMutationResult = Apollo.MutationResult<UpdatePqrsdConsultPageBlockMutation>;
export type UpdatePqrsdConsultPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePqrsdConsultPageBlockMutation, UpdatePqrsdConsultPageBlockMutationVariables>;
export const GetPqrsdConsultPageBlockDocument = gql`
    query GetPqrsdConsultPageBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PagePqrsdfConsultBlock {
      id
      pageBlockStyle
    }
  }
}
    `;

/**
 * __useGetPqrsdConsultPageBlockQuery__
 *
 * To run a query within a React component, call `useGetPqrsdConsultPageBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPqrsdConsultPageBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPqrsdConsultPageBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPqrsdConsultPageBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>(GetPqrsdConsultPageBlockDocument, options);
      }
export function useGetPqrsdConsultPageBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>(GetPqrsdConsultPageBlockDocument, options);
        }
export function useGetPqrsdConsultPageBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>(GetPqrsdConsultPageBlockDocument, options);
        }
export type GetPqrsdConsultPageBlockQueryHookResult = ReturnType<typeof useGetPqrsdConsultPageBlockQuery>;
export type GetPqrsdConsultPageBlockLazyQueryHookResult = ReturnType<typeof useGetPqrsdConsultPageBlockLazyQuery>;
export type GetPqrsdConsultPageBlockSuspenseQueryHookResult = ReturnType<typeof useGetPqrsdConsultPageBlockSuspenseQuery>;
export type GetPqrsdConsultPageBlockQueryResult = Apollo.QueryResult<GetPqrsdConsultPageBlockQuery, GetPqrsdConsultPageBlockQueryVariables>;
export const PressRoomPageDocument = gql`
    query PressRoomPage($versionId: ID!, $locations: [BlockLocation!]!, $subPage: SubPages, $showDisabled: Boolean) {
  pageBlocks(versionId: $versionId, locations: $locations, subPage: $subPage, showDisabled: $showDisabled) {
    ... on PageTransparencyBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    __typename
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      __typename
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      __typename
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
      __typename
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        snsTitle
        snsSocialNetworkType
        itemLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
        }
        parent {
          id
          createdAt
          updatedAt
          deletedAt
          description
          isDisabled
          canBeDisabled
          orderIndex
          location
          pageBlockStyle
          subPages
          type
        }
      }
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      taxSectionTitle
      __typename
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      seeMoreAction
      seeMoreLink
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtitle
      hasSearchbar
      __typename
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      blockTitle
      seeMoreTitle
      seeMoreLink
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      __typename
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      __typename
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
      __typename
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      __typename
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
  }
}
    `;

/**
 * __usePressRoomPageQuery__
 *
 * To run a query within a React component, call `usePressRoomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressRoomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressRoomPageQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function usePressRoomPageQuery(baseOptions: Apollo.QueryHookOptions<PressRoomPageQuery, PressRoomPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PressRoomPageQuery, PressRoomPageQueryVariables>(PressRoomPageDocument, options);
      }
export function usePressRoomPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PressRoomPageQuery, PressRoomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PressRoomPageQuery, PressRoomPageQueryVariables>(PressRoomPageDocument, options);
        }
export function usePressRoomPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PressRoomPageQuery, PressRoomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PressRoomPageQuery, PressRoomPageQueryVariables>(PressRoomPageDocument, options);
        }
export type PressRoomPageQueryHookResult = ReturnType<typeof usePressRoomPageQuery>;
export type PressRoomPageLazyQueryHookResult = ReturnType<typeof usePressRoomPageLazyQuery>;
export type PressRoomPageSuspenseQueryHookResult = ReturnType<typeof usePressRoomPageSuspenseQuery>;
export type PressRoomPageQueryResult = Apollo.QueryResult<PressRoomPageQuery, PressRoomPageQueryVariables>;
export const UpdatePressRoomPageBlockDocument = gql`
    mutation UpdatePressRoomPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PagePressroomBlock {
      id
    }
  }
}
    `;
export type UpdatePressRoomPageBlockMutationFn = Apollo.MutationFunction<UpdatePressRoomPageBlockMutation, UpdatePressRoomPageBlockMutationVariables>;

/**
 * __useUpdatePressRoomPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePressRoomPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePressRoomPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePressRoomPageBlockMutation, { data, loading, error }] = useUpdatePressRoomPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePressRoomPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePressRoomPageBlockMutation, UpdatePressRoomPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePressRoomPageBlockMutation, UpdatePressRoomPageBlockMutationVariables>(UpdatePressRoomPageBlockDocument, options);
      }
export type UpdatePressRoomPageBlockMutationHookResult = ReturnType<typeof useUpdatePressRoomPageBlockMutation>;
export type UpdatePressRoomPageBlockMutationResult = Apollo.MutationResult<UpdatePressRoomPageBlockMutation>;
export type UpdatePressRoomPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePressRoomPageBlockMutation, UpdatePressRoomPageBlockMutationVariables>;
export const UpdatePagePressRoomNewsEventsBlockDocument = gql`
    mutation UpdatePagePressRoomNewsEventsBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageNewsletterBlock {
      id
    }
  }
}
    `;
export type UpdatePagePressRoomNewsEventsBlockMutationFn = Apollo.MutationFunction<UpdatePagePressRoomNewsEventsBlockMutation, UpdatePagePressRoomNewsEventsBlockMutationVariables>;

/**
 * __useUpdatePagePressRoomNewsEventsBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePagePressRoomNewsEventsBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePagePressRoomNewsEventsBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePagePressRoomNewsEventsBlockMutation, { data, loading, error }] = useUpdatePagePressRoomNewsEventsBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePagePressRoomNewsEventsBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePagePressRoomNewsEventsBlockMutation, UpdatePagePressRoomNewsEventsBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePagePressRoomNewsEventsBlockMutation, UpdatePagePressRoomNewsEventsBlockMutationVariables>(UpdatePagePressRoomNewsEventsBlockDocument, options);
      }
export type UpdatePagePressRoomNewsEventsBlockMutationHookResult = ReturnType<typeof useUpdatePagePressRoomNewsEventsBlockMutation>;
export type UpdatePagePressRoomNewsEventsBlockMutationResult = Apollo.MutationResult<UpdatePagePressRoomNewsEventsBlockMutation>;
export type UpdatePagePressRoomNewsEventsBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePagePressRoomNewsEventsBlockMutation, UpdatePagePressRoomNewsEventsBlockMutationVariables>;
export const GetPagePressRoomNewsEventsBlockDocument = gql`
    query GetPagePressRoomNewsEventsBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageNewsletterBlock {
      id
      pageBlockStyle
      tagStyle
      newsletterTitle
      newsletterDescription
    }
  }
}
    `;

/**
 * __useGetPagePressRoomNewsEventsBlockQuery__
 *
 * To run a query within a React component, call `useGetPagePressRoomNewsEventsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagePressRoomNewsEventsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagePressRoomNewsEventsBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPagePressRoomNewsEventsBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>(GetPagePressRoomNewsEventsBlockDocument, options);
      }
export function useGetPagePressRoomNewsEventsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>(GetPagePressRoomNewsEventsBlockDocument, options);
        }
export function useGetPagePressRoomNewsEventsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>(GetPagePressRoomNewsEventsBlockDocument, options);
        }
export type GetPagePressRoomNewsEventsBlockQueryHookResult = ReturnType<typeof useGetPagePressRoomNewsEventsBlockQuery>;
export type GetPagePressRoomNewsEventsBlockLazyQueryHookResult = ReturnType<typeof useGetPagePressRoomNewsEventsBlockLazyQuery>;
export type GetPagePressRoomNewsEventsBlockSuspenseQueryHookResult = ReturnType<typeof useGetPagePressRoomNewsEventsBlockSuspenseQuery>;
export type GetPagePressRoomNewsEventsBlockQueryResult = Apollo.QueryResult<GetPagePressRoomNewsEventsBlockQuery, GetPagePressRoomNewsEventsBlockQueryVariables>;
export const PageRegulationsBlockDocument = gql`
    query PageRegulationsBlock($versionId: ID!, $locations: [BlockLocation!]!, $subPage: SubPages, $showDisabled: Boolean) {
  pageBlocks(versionId: $versionId, locations: $locations, subPage: $subPage, showDisabled: $showDisabled) {
    ... on PageTransparencyBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    __typename
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
      __typename
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      __typename
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      __typename
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
      __typename
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      taxSectionTitle
      __typename
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      seeMoreAction
      seeMoreLink
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtitle
      hasSearchbar
      __typename
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      blockTitle
      seeMoreTitle
      seeMoreLink
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      __typename
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      __typename
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
      __typename
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      __typename
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        subtype
        configJson
      }
      subtype
    }
  }
}
    `;

/**
 * __usePageRegulationsBlockQuery__
 *
 * To run a query within a React component, call `usePageRegulationsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageRegulationsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageRegulationsBlockQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function usePageRegulationsBlockQuery(baseOptions: Apollo.QueryHookOptions<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>(PageRegulationsBlockDocument, options);
      }
export function usePageRegulationsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>(PageRegulationsBlockDocument, options);
        }
export function usePageRegulationsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>(PageRegulationsBlockDocument, options);
        }
export type PageRegulationsBlockQueryHookResult = ReturnType<typeof usePageRegulationsBlockQuery>;
export type PageRegulationsBlockLazyQueryHookResult = ReturnType<typeof usePageRegulationsBlockLazyQuery>;
export type PageRegulationsBlockSuspenseQueryHookResult = ReturnType<typeof usePageRegulationsBlockSuspenseQuery>;
export type PageRegulationsBlockQueryResult = Apollo.QueryResult<PageRegulationsBlockQuery, PageRegulationsBlockQueryVariables>;
export const UpdatePageBlockSubHeaderDocument = gql`
    mutation UpdatePageBlockSubHeader($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSubHeaderBlock {
      id
      subHeaderTitle
      subHeaderDescription
      pageBlockStyle
    }
  }
}
    `;
export type UpdatePageBlockSubHeaderMutationFn = Apollo.MutationFunction<UpdatePageBlockSubHeaderMutation, UpdatePageBlockSubHeaderMutationVariables>;

/**
 * __useUpdatePageBlockSubHeaderMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockSubHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockSubHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockSubHeaderMutation, { data, loading, error }] = useUpdatePageBlockSubHeaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockSubHeaderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockSubHeaderMutation, UpdatePageBlockSubHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockSubHeaderMutation, UpdatePageBlockSubHeaderMutationVariables>(UpdatePageBlockSubHeaderDocument, options);
      }
export type UpdatePageBlockSubHeaderMutationHookResult = ReturnType<typeof useUpdatePageBlockSubHeaderMutation>;
export type UpdatePageBlockSubHeaderMutationResult = Apollo.MutationResult<UpdatePageBlockSubHeaderMutation>;
export type UpdatePageBlockSubHeaderMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockSubHeaderMutation, UpdatePageBlockSubHeaderMutationVariables>;
export const PageRegulationsBlockItemDocument = gql`
    query PageRegulationsBlockItem($parentId: ID!) {
  pageBlockItems(parentId: $parentId) {
    ... on PageRegulationsBlockItem {
      id
      itemName
      itemType
      itemDescription
      itemIcon {
        downloadUrl
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      orderIndex
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __usePageRegulationsBlockItemQuery__
 *
 * To run a query within a React component, call `usePageRegulationsBlockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageRegulationsBlockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageRegulationsBlockItemQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function usePageRegulationsBlockItemQuery(baseOptions: Apollo.QueryHookOptions<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>(PageRegulationsBlockItemDocument, options);
      }
export function usePageRegulationsBlockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>(PageRegulationsBlockItemDocument, options);
        }
export function usePageRegulationsBlockItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>(PageRegulationsBlockItemDocument, options);
        }
export type PageRegulationsBlockItemQueryHookResult = ReturnType<typeof usePageRegulationsBlockItemQuery>;
export type PageRegulationsBlockItemLazyQueryHookResult = ReturnType<typeof usePageRegulationsBlockItemLazyQuery>;
export type PageRegulationsBlockItemSuspenseQueryHookResult = ReturnType<typeof usePageRegulationsBlockItemSuspenseQuery>;
export type PageRegulationsBlockItemQueryResult = Apollo.QueryResult<PageRegulationsBlockItemQuery, PageRegulationsBlockItemQueryVariables>;
export const PageRegulationsBlockItemByIdDocument = gql`
    query PageRegulationsBlockItemById($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageRegulationsBlockItem {
      id
      itemName
      description
      orderIndex
      itemDescription
      itemIcon {
        downloadUrl
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      itemType
    }
  }
}
    `;

/**
 * __usePageRegulationsBlockItemByIdQuery__
 *
 * To run a query within a React component, call `usePageRegulationsBlockItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageRegulationsBlockItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageRegulationsBlockItemByIdQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function usePageRegulationsBlockItemByIdQuery(baseOptions: Apollo.QueryHookOptions<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>(PageRegulationsBlockItemByIdDocument, options);
      }
export function usePageRegulationsBlockItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>(PageRegulationsBlockItemByIdDocument, options);
        }
export function usePageRegulationsBlockItemByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>(PageRegulationsBlockItemByIdDocument, options);
        }
export type PageRegulationsBlockItemByIdQueryHookResult = ReturnType<typeof usePageRegulationsBlockItemByIdQuery>;
export type PageRegulationsBlockItemByIdLazyQueryHookResult = ReturnType<typeof usePageRegulationsBlockItemByIdLazyQuery>;
export type PageRegulationsBlockItemByIdSuspenseQueryHookResult = ReturnType<typeof usePageRegulationsBlockItemByIdSuspenseQuery>;
export type PageRegulationsBlockItemByIdQueryResult = Apollo.QueryResult<PageRegulationsBlockItemByIdQuery, PageRegulationsBlockItemByIdQueryVariables>;
export const UpdatePageBlockItemRegulationsDocument = gql`
    mutation UpdatePageBlockItemRegulations($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageRegulationsBlockItem {
      id
      itemType
      itemIcon {
        downloadUrl
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
      }
      itemDescription
      itemName
    }
  }
}
    `;
export type UpdatePageBlockItemRegulationsMutationFn = Apollo.MutationFunction<UpdatePageBlockItemRegulationsMutation, UpdatePageBlockItemRegulationsMutationVariables>;

/**
 * __useUpdatePageBlockItemRegulationsMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockItemRegulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockItemRegulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockItemRegulationsMutation, { data, loading, error }] = useUpdatePageBlockItemRegulationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockItemRegulationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockItemRegulationsMutation, UpdatePageBlockItemRegulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockItemRegulationsMutation, UpdatePageBlockItemRegulationsMutationVariables>(UpdatePageBlockItemRegulationsDocument, options);
      }
export type UpdatePageBlockItemRegulationsMutationHookResult = ReturnType<typeof useUpdatePageBlockItemRegulationsMutation>;
export type UpdatePageBlockItemRegulationsMutationResult = Apollo.MutationResult<UpdatePageBlockItemRegulationsMutation>;
export type UpdatePageBlockItemRegulationsMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockItemRegulationsMutation, UpdatePageBlockItemRegulationsMutationVariables>;
export const UpdateRegulationsPageBlockDocument = gql`
    mutation UpdateRegulationsPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageRegulationsBlock {
      id
    }
  }
}
    `;
export type UpdateRegulationsPageBlockMutationFn = Apollo.MutationFunction<UpdateRegulationsPageBlockMutation, UpdateRegulationsPageBlockMutationVariables>;

/**
 * __useUpdateRegulationsPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateRegulationsPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulationsPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulationsPageBlockMutation, { data, loading, error }] = useUpdateRegulationsPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegulationsPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulationsPageBlockMutation, UpdateRegulationsPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulationsPageBlockMutation, UpdateRegulationsPageBlockMutationVariables>(UpdateRegulationsPageBlockDocument, options);
      }
export type UpdateRegulationsPageBlockMutationHookResult = ReturnType<typeof useUpdateRegulationsPageBlockMutation>;
export type UpdateRegulationsPageBlockMutationResult = Apollo.MutationResult<UpdateRegulationsPageBlockMutation>;
export type UpdateRegulationsPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateRegulationsPageBlockMutation, UpdateRegulationsPageBlockMutationVariables>;
export const PageRegulationsAccordionBlockDocument = gql`
    query PageRegulationsAccordionBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      pageBlockStyle
    }
  }
}
    `;

/**
 * __usePageRegulationsAccordionBlockQuery__
 *
 * To run a query within a React component, call `usePageRegulationsAccordionBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageRegulationsAccordionBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageRegulationsAccordionBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageRegulationsAccordionBlockQuery(baseOptions: Apollo.QueryHookOptions<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>(PageRegulationsAccordionBlockDocument, options);
      }
export function usePageRegulationsAccordionBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>(PageRegulationsAccordionBlockDocument, options);
        }
export function usePageRegulationsAccordionBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>(PageRegulationsAccordionBlockDocument, options);
        }
export type PageRegulationsAccordionBlockQueryHookResult = ReturnType<typeof usePageRegulationsAccordionBlockQuery>;
export type PageRegulationsAccordionBlockLazyQueryHookResult = ReturnType<typeof usePageRegulationsAccordionBlockLazyQuery>;
export type PageRegulationsAccordionBlockSuspenseQueryHookResult = ReturnType<typeof usePageRegulationsAccordionBlockSuspenseQuery>;
export type PageRegulationsAccordionBlockQueryResult = Apollo.QueryResult<PageRegulationsAccordionBlockQuery, PageRegulationsAccordionBlockQueryVariables>;
export const UpdatePageBlockAccordionRegulationsDocument = gql`
    mutation UpdatePageBlockAccordionRegulations($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageAccordionBlock {
      id
      description
      pageBlockStyle
      orderIndex
      canBeDisabled
      isDisabled
    }
  }
}
    `;
export type UpdatePageBlockAccordionRegulationsMutationFn = Apollo.MutationFunction<UpdatePageBlockAccordionRegulationsMutation, UpdatePageBlockAccordionRegulationsMutationVariables>;

/**
 * __useUpdatePageBlockAccordionRegulationsMutation__
 *
 * To run a mutation, you first call `useUpdatePageBlockAccordionRegulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageBlockAccordionRegulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageBlockAccordionRegulationsMutation, { data, loading, error }] = useUpdatePageBlockAccordionRegulationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageBlockAccordionRegulationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageBlockAccordionRegulationsMutation, UpdatePageBlockAccordionRegulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageBlockAccordionRegulationsMutation, UpdatePageBlockAccordionRegulationsMutationVariables>(UpdatePageBlockAccordionRegulationsDocument, options);
      }
export type UpdatePageBlockAccordionRegulationsMutationHookResult = ReturnType<typeof useUpdatePageBlockAccordionRegulationsMutation>;
export type UpdatePageBlockAccordionRegulationsMutationResult = Apollo.MutationResult<UpdatePageBlockAccordionRegulationsMutation>;
export type UpdatePageBlockAccordionRegulationsMutationOptions = Apollo.BaseMutationOptions<UpdatePageBlockAccordionRegulationsMutation, UpdatePageBlockAccordionRegulationsMutationVariables>;
export const PageRegulationsBlockDataDocument = gql`
    query PageRegulationsBlockData($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageRegulationsBlock {
      id
      description
      createdAt
      updatedAt
      deletedAt
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        itemName
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
        }
        itemType
      }
    }
  }
}
    `;

/**
 * __usePageRegulationsBlockDataQuery__
 *
 * To run a query within a React component, call `usePageRegulationsBlockDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageRegulationsBlockDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageRegulationsBlockDataQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageRegulationsBlockDataQuery(baseOptions: Apollo.QueryHookOptions<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>(PageRegulationsBlockDataDocument, options);
      }
export function usePageRegulationsBlockDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>(PageRegulationsBlockDataDocument, options);
        }
export function usePageRegulationsBlockDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>(PageRegulationsBlockDataDocument, options);
        }
export type PageRegulationsBlockDataQueryHookResult = ReturnType<typeof usePageRegulationsBlockDataQuery>;
export type PageRegulationsBlockDataLazyQueryHookResult = ReturnType<typeof usePageRegulationsBlockDataLazyQuery>;
export type PageRegulationsBlockDataSuspenseQueryHookResult = ReturnType<typeof usePageRegulationsBlockDataSuspenseQuery>;
export type PageRegulationsBlockDataQueryResult = Apollo.QueryResult<PageRegulationsBlockDataQuery, PageRegulationsBlockDataQueryVariables>;
export const ProceduresPageDocument = gql`
    query ProceduresPage($subPage: SubPages, $showDisabled: Boolean, $locations: [BlockLocation!]!, $versionId: ID!) {
  pageBlocks(subPage: $subPage, showDisabled: $showDisabled, locations: $locations, versionId: $versionId) {
    ... on PageTransparencyBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    __typename
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      publicDescription
      showTitle
      showDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      publicDescription
      showTitle
      showDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      taxSectionTitle
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      seeMoreAction
      seeMoreLink
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtitle
      hasSearchbar
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      blockTitle
      seeMoreTitle
      seeMoreLink
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
  }
}
    `;

/**
 * __useProceduresPageQuery__
 *
 * To run a query within a React component, call `useProceduresPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProceduresPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProceduresPageQuery({
 *   variables: {
 *      subPage: // value for 'subPage'
 *      showDisabled: // value for 'showDisabled'
 *      locations: // value for 'locations'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProceduresPageQuery(baseOptions: Apollo.QueryHookOptions<ProceduresPageQuery, ProceduresPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProceduresPageQuery, ProceduresPageQueryVariables>(ProceduresPageDocument, options);
      }
export function useProceduresPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProceduresPageQuery, ProceduresPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProceduresPageQuery, ProceduresPageQueryVariables>(ProceduresPageDocument, options);
        }
export function useProceduresPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProceduresPageQuery, ProceduresPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProceduresPageQuery, ProceduresPageQueryVariables>(ProceduresPageDocument, options);
        }
export type ProceduresPageQueryHookResult = ReturnType<typeof useProceduresPageQuery>;
export type ProceduresPageLazyQueryHookResult = ReturnType<typeof useProceduresPageLazyQuery>;
export type ProceduresPageSuspenseQueryHookResult = ReturnType<typeof useProceduresPageSuspenseQuery>;
export type ProceduresPageQueryResult = Apollo.QueryResult<ProceduresPageQuery, ProceduresPageQueryVariables>;
export const UpdateProceduresPageBlockDocument = gql`
    mutation UpdateProceduresPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSubHeaderBlock {
      id
    }
  }
}
    `;
export type UpdateProceduresPageBlockMutationFn = Apollo.MutationFunction<UpdateProceduresPageBlockMutation, UpdateProceduresPageBlockMutationVariables>;

/**
 * __useUpdateProceduresPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateProceduresPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProceduresPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProceduresPageBlockMutation, { data, loading, error }] = useUpdateProceduresPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProceduresPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProceduresPageBlockMutation, UpdateProceduresPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProceduresPageBlockMutation, UpdateProceduresPageBlockMutationVariables>(UpdateProceduresPageBlockDocument, options);
      }
export type UpdateProceduresPageBlockMutationHookResult = ReturnType<typeof useUpdateProceduresPageBlockMutation>;
export type UpdateProceduresPageBlockMutationResult = Apollo.MutationResult<UpdateProceduresPageBlockMutation>;
export type UpdateProceduresPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateProceduresPageBlockMutation, UpdateProceduresPageBlockMutationVariables>;
export const UpdatePageProceduresAreaBlockDocument = gql`
    mutation UpdatePageProceduresAreaBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageProcedureFeedbackBlock {
      id
    }
  }
}
    `;
export type UpdatePageProceduresAreaBlockMutationFn = Apollo.MutationFunction<UpdatePageProceduresAreaBlockMutation, UpdatePageProceduresAreaBlockMutationVariables>;

/**
 * __useUpdatePageProceduresAreaBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageProceduresAreaBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageProceduresAreaBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageProceduresAreaBlockMutation, { data, loading, error }] = useUpdatePageProceduresAreaBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageProceduresAreaBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageProceduresAreaBlockMutation, UpdatePageProceduresAreaBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageProceduresAreaBlockMutation, UpdatePageProceduresAreaBlockMutationVariables>(UpdatePageProceduresAreaBlockDocument, options);
      }
export type UpdatePageProceduresAreaBlockMutationHookResult = ReturnType<typeof useUpdatePageProceduresAreaBlockMutation>;
export type UpdatePageProceduresAreaBlockMutationResult = Apollo.MutationResult<UpdatePageProceduresAreaBlockMutation>;
export type UpdatePageProceduresAreaBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageProceduresAreaBlockMutation, UpdatePageProceduresAreaBlockMutationVariables>;
export const GetPageProceduresAreaBlockDocument = gql`
    query GetPageProceduresAreaBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageProcedureFeedbackBlock {
      id
      pageBlockStyle
    }
  }
}
    `;

/**
 * __useGetPageProceduresAreaBlockQuery__
 *
 * To run a query within a React component, call `useGetPageProceduresAreaBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageProceduresAreaBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageProceduresAreaBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageProceduresAreaBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>(GetPageProceduresAreaBlockDocument, options);
      }
export function useGetPageProceduresAreaBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>(GetPageProceduresAreaBlockDocument, options);
        }
export function useGetPageProceduresAreaBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>(GetPageProceduresAreaBlockDocument, options);
        }
export type GetPageProceduresAreaBlockQueryHookResult = ReturnType<typeof useGetPageProceduresAreaBlockQuery>;
export type GetPageProceduresAreaBlockLazyQueryHookResult = ReturnType<typeof useGetPageProceduresAreaBlockLazyQuery>;
export type GetPageProceduresAreaBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageProceduresAreaBlockSuspenseQuery>;
export type GetPageProceduresAreaBlockQueryResult = Apollo.QueryResult<GetPageProceduresAreaBlockQuery, GetPageProceduresAreaBlockQueryVariables>;
export const UpdatePageProceduresCardBlockDocument = gql`
    mutation UpdatePageProceduresCardBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageProcedureMainBlock {
      id
    }
  }
}
    `;
export type UpdatePageProceduresCardBlockMutationFn = Apollo.MutationFunction<UpdatePageProceduresCardBlockMutation, UpdatePageProceduresCardBlockMutationVariables>;

/**
 * __useUpdatePageProceduresCardBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageProceduresCardBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageProceduresCardBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageProceduresCardBlockMutation, { data, loading, error }] = useUpdatePageProceduresCardBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageProceduresCardBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageProceduresCardBlockMutation, UpdatePageProceduresCardBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageProceduresCardBlockMutation, UpdatePageProceduresCardBlockMutationVariables>(UpdatePageProceduresCardBlockDocument, options);
      }
export type UpdatePageProceduresCardBlockMutationHookResult = ReturnType<typeof useUpdatePageProceduresCardBlockMutation>;
export type UpdatePageProceduresCardBlockMutationResult = Apollo.MutationResult<UpdatePageProceduresCardBlockMutation>;
export type UpdatePageProceduresCardBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageProceduresCardBlockMutation, UpdatePageProceduresCardBlockMutationVariables>;
export const GetPageProceduresCardBlockDocument = gql`
    query GetPageProceduresCardBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageProcedureMainBlock {
      id
      description
      pageBlockStyle
    }
  }
}
    `;

/**
 * __useGetPageProceduresCardBlockQuery__
 *
 * To run a query within a React component, call `useGetPageProceduresCardBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageProceduresCardBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageProceduresCardBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageProceduresCardBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>(GetPageProceduresCardBlockDocument, options);
      }
export function useGetPageProceduresCardBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>(GetPageProceduresCardBlockDocument, options);
        }
export function useGetPageProceduresCardBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>(GetPageProceduresCardBlockDocument, options);
        }
export type GetPageProceduresCardBlockQueryHookResult = ReturnType<typeof useGetPageProceduresCardBlockQuery>;
export type GetPageProceduresCardBlockLazyQueryHookResult = ReturnType<typeof useGetPageProceduresCardBlockLazyQuery>;
export type GetPageProceduresCardBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageProceduresCardBlockSuspenseQuery>;
export type GetPageProceduresCardBlockQueryResult = Apollo.QueryResult<GetPageProceduresCardBlockQuery, GetPageProceduresCardBlockQueryVariables>;
export const UpdateSubHeaderPageBlockDocument = gql`
    mutation UpdateSubHeaderPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSubHeaderBlock {
      id
    }
  }
}
    `;
export type UpdateSubHeaderPageBlockMutationFn = Apollo.MutationFunction<UpdateSubHeaderPageBlockMutation, UpdateSubHeaderPageBlockMutationVariables>;

/**
 * __useUpdateSubHeaderPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateSubHeaderPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubHeaderPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubHeaderPageBlockMutation, { data, loading, error }] = useUpdateSubHeaderPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubHeaderPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubHeaderPageBlockMutation, UpdateSubHeaderPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubHeaderPageBlockMutation, UpdateSubHeaderPageBlockMutationVariables>(UpdateSubHeaderPageBlockDocument, options);
      }
export type UpdateSubHeaderPageBlockMutationHookResult = ReturnType<typeof useUpdateSubHeaderPageBlockMutation>;
export type UpdateSubHeaderPageBlockMutationResult = Apollo.MutationResult<UpdateSubHeaderPageBlockMutation>;
export type UpdateSubHeaderPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateSubHeaderPageBlockMutation, UpdateSubHeaderPageBlockMutationVariables>;
export const GetSubHeaderPageBlockDocument = gql`
    query GetSubHeaderPageBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSubHeaderBlock {
      id
      description
      pageBlockStyle
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderSearchbar
      subHeaderPlaceholder
    }
  }
}
    `;

/**
 * __useGetSubHeaderPageBlockQuery__
 *
 * To run a query within a React component, call `useGetSubHeaderPageBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubHeaderPageBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubHeaderPageBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetSubHeaderPageBlockQuery(baseOptions: Apollo.QueryHookOptions<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>(GetSubHeaderPageBlockDocument, options);
      }
export function useGetSubHeaderPageBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>(GetSubHeaderPageBlockDocument, options);
        }
export function useGetSubHeaderPageBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>(GetSubHeaderPageBlockDocument, options);
        }
export type GetSubHeaderPageBlockQueryHookResult = ReturnType<typeof useGetSubHeaderPageBlockQuery>;
export type GetSubHeaderPageBlockLazyQueryHookResult = ReturnType<typeof useGetSubHeaderPageBlockLazyQuery>;
export type GetSubHeaderPageBlockSuspenseQueryHookResult = ReturnType<typeof useGetSubHeaderPageBlockSuspenseQuery>;
export type GetSubHeaderPageBlockQueryResult = Apollo.QueryResult<GetSubHeaderPageBlockQuery, GetSubHeaderPageBlockQueryVariables>;
export const ParametersAdminDocument = gql`
    query ParametersAdmin($orderBy: [FindParametersOrderBy!], $where: FindParametersWhere, $pagination: Pagination) {
  parameters(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    code
    createdAt
    updatedAt
    description
  }
  parametersCount(orderBy: $orderBy, where: $where, pagination: $pagination) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useParametersAdminQuery__
 *
 * To run a query within a React component, call `useParametersAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useParametersAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParametersAdminQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useParametersAdminQuery(baseOptions?: Apollo.QueryHookOptions<ParametersAdminQuery, ParametersAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParametersAdminQuery, ParametersAdminQueryVariables>(ParametersAdminDocument, options);
      }
export function useParametersAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParametersAdminQuery, ParametersAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParametersAdminQuery, ParametersAdminQueryVariables>(ParametersAdminDocument, options);
        }
export function useParametersAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParametersAdminQuery, ParametersAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParametersAdminQuery, ParametersAdminQueryVariables>(ParametersAdminDocument, options);
        }
export type ParametersAdminQueryHookResult = ReturnType<typeof useParametersAdminQuery>;
export type ParametersAdminLazyQueryHookResult = ReturnType<typeof useParametersAdminLazyQuery>;
export type ParametersAdminSuspenseQueryHookResult = ReturnType<typeof useParametersAdminSuspenseQuery>;
export type ParametersAdminQueryResult = Apollo.QueryResult<ParametersAdminQuery, ParametersAdminQueryVariables>;
export const ParameterAdminDocument = gql`
    query ParameterAdmin($parameterId: ID!) {
  parameter(id: $parameterId) {
    id
    code
    description
    type
    character
    number
    booleanValue
    json
    date
    image {
      id
      fileExtension
      fileName
      fileMode
      fileMongoId
      url
      downloadUrl
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useParameterAdminQuery__
 *
 * To run a query within a React component, call `useParameterAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterAdminQuery({
 *   variables: {
 *      parameterId: // value for 'parameterId'
 *   },
 * });
 */
export function useParameterAdminQuery(baseOptions: Apollo.QueryHookOptions<ParameterAdminQuery, ParameterAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParameterAdminQuery, ParameterAdminQueryVariables>(ParameterAdminDocument, options);
      }
export function useParameterAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParameterAdminQuery, ParameterAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParameterAdminQuery, ParameterAdminQueryVariables>(ParameterAdminDocument, options);
        }
export function useParameterAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParameterAdminQuery, ParameterAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParameterAdminQuery, ParameterAdminQueryVariables>(ParameterAdminDocument, options);
        }
export type ParameterAdminQueryHookResult = ReturnType<typeof useParameterAdminQuery>;
export type ParameterAdminLazyQueryHookResult = ReturnType<typeof useParameterAdminLazyQuery>;
export type ParameterAdminSuspenseQueryHookResult = ReturnType<typeof useParameterAdminSuspenseQuery>;
export type ParameterAdminQueryResult = Apollo.QueryResult<ParameterAdminQuery, ParameterAdminQueryVariables>;
export const CreateParameterAdminDocument = gql`
    mutation CreateParameterAdmin($createInput: CreateParameterInput!) {
  createParameter(createInput: $createInput) {
    id
    code
    type
  }
}
    `;
export type CreateParameterAdminMutationFn = Apollo.MutationFunction<CreateParameterAdminMutation, CreateParameterAdminMutationVariables>;

/**
 * __useCreateParameterAdminMutation__
 *
 * To run a mutation, you first call `useCreateParameterAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParameterAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParameterAdminMutation, { data, loading, error }] = useCreateParameterAdminMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateParameterAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateParameterAdminMutation, CreateParameterAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParameterAdminMutation, CreateParameterAdminMutationVariables>(CreateParameterAdminDocument, options);
      }
export type CreateParameterAdminMutationHookResult = ReturnType<typeof useCreateParameterAdminMutation>;
export type CreateParameterAdminMutationResult = Apollo.MutationResult<CreateParameterAdminMutation>;
export type CreateParameterAdminMutationOptions = Apollo.BaseMutationOptions<CreateParameterAdminMutation, CreateParameterAdminMutationVariables>;
export const UpdateParameterAdminDocument = gql`
    mutation UpdateParameterAdmin($updateInput: UpdateParameterInput!) {
  updateParameter(updateInput: $updateInput) {
    id
    code
    type
  }
}
    `;
export type UpdateParameterAdminMutationFn = Apollo.MutationFunction<UpdateParameterAdminMutation, UpdateParameterAdminMutationVariables>;

/**
 * __useUpdateParameterAdminMutation__
 *
 * To run a mutation, you first call `useUpdateParameterAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParameterAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParameterAdminMutation, { data, loading, error }] = useUpdateParameterAdminMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateParameterAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParameterAdminMutation, UpdateParameterAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParameterAdminMutation, UpdateParameterAdminMutationVariables>(UpdateParameterAdminDocument, options);
      }
export type UpdateParameterAdminMutationHookResult = ReturnType<typeof useUpdateParameterAdminMutation>;
export type UpdateParameterAdminMutationResult = Apollo.MutationResult<UpdateParameterAdminMutation>;
export type UpdateParameterAdminMutationOptions = Apollo.BaseMutationOptions<UpdateParameterAdminMutation, UpdateParameterAdminMutationVariables>;
export const RemoveParameterAdminDocument = gql`
    mutation RemoveParameterAdmin($removeParameterId: ID!) {
  removeParameter(id: $removeParameterId) {
    id
  }
}
    `;
export type RemoveParameterAdminMutationFn = Apollo.MutationFunction<RemoveParameterAdminMutation, RemoveParameterAdminMutationVariables>;

/**
 * __useRemoveParameterAdminMutation__
 *
 * To run a mutation, you first call `useRemoveParameterAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveParameterAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeParameterAdminMutation, { data, loading, error }] = useRemoveParameterAdminMutation({
 *   variables: {
 *      removeParameterId: // value for 'removeParameterId'
 *   },
 * });
 */
export function useRemoveParameterAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemoveParameterAdminMutation, RemoveParameterAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveParameterAdminMutation, RemoveParameterAdminMutationVariables>(RemoveParameterAdminDocument, options);
      }
export type RemoveParameterAdminMutationHookResult = ReturnType<typeof useRemoveParameterAdminMutation>;
export type RemoveParameterAdminMutationResult = Apollo.MutationResult<RemoveParameterAdminMutation>;
export type RemoveParameterAdminMutationOptions = Apollo.BaseMutationOptions<RemoveParameterAdminMutation, RemoveParameterAdminMutationVariables>;
export const CreatePositionDocument = gql`
    mutation CreatePosition($createInput: CreatePositionInput!) {
  createPosition(createInput: $createInput) {
    id
    name
  }
}
    `;
export type CreatePositionMutationFn = Apollo.MutationFunction<CreatePositionMutation, CreatePositionMutationVariables>;

/**
 * __useCreatePositionMutation__
 *
 * To run a mutation, you first call `useCreatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPositionMutation, { data, loading, error }] = useCreatePositionMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreatePositionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePositionMutation, CreatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePositionMutation, CreatePositionMutationVariables>(CreatePositionDocument, options);
      }
export type CreatePositionMutationHookResult = ReturnType<typeof useCreatePositionMutation>;
export type CreatePositionMutationResult = Apollo.MutationResult<CreatePositionMutation>;
export type CreatePositionMutationOptions = Apollo.BaseMutationOptions<CreatePositionMutation, CreatePositionMutationVariables>;
export const UpdatePositionDocument = gql`
    mutation UpdatePosition($updateInput: UpdatePositionInput!) {
  updatePosition(updateInput: $updateInput) {
    id
    name
  }
}
    `;
export type UpdatePositionMutationFn = Apollo.MutationFunction<UpdatePositionMutation, UpdatePositionMutationVariables>;

/**
 * __useUpdatePositionMutation__
 *
 * To run a mutation, you first call `useUpdatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionMutation, { data, loading, error }] = useUpdatePositionMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdatePositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionMutation, UpdatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionMutation, UpdatePositionMutationVariables>(UpdatePositionDocument, options);
      }
export type UpdatePositionMutationHookResult = ReturnType<typeof useUpdatePositionMutation>;
export type UpdatePositionMutationResult = Apollo.MutationResult<UpdatePositionMutation>;
export type UpdatePositionMutationOptions = Apollo.BaseMutationOptions<UpdatePositionMutation, UpdatePositionMutationVariables>;
export const RemovePositionDocument = gql`
    mutation RemovePosition($id: ID!) {
  removePosition(id: $id) {
    id
  }
}
    `;
export type RemovePositionMutationFn = Apollo.MutationFunction<RemovePositionMutation, RemovePositionMutationVariables>;

/**
 * __useRemovePositionMutation__
 *
 * To run a mutation, you first call `useRemovePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePositionMutation, { data, loading, error }] = useRemovePositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePositionMutation(baseOptions?: Apollo.MutationHookOptions<RemovePositionMutation, RemovePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePositionMutation, RemovePositionMutationVariables>(RemovePositionDocument, options);
      }
export type RemovePositionMutationHookResult = ReturnType<typeof useRemovePositionMutation>;
export type RemovePositionMutationResult = Apollo.MutationResult<RemovePositionMutation>;
export type RemovePositionMutationOptions = Apollo.BaseMutationOptions<RemovePositionMutation, RemovePositionMutationVariables>;
export const GetPositionsDocument = gql`
    query GetPositions($pagination: Pagination, $where: FindPositionWhere, $orderBy: [FindPositionOrderBy!]) {
  positions(pagination: $pagination, where: $where, orderBy: $orderBy) {
    id
    name
    createdAt
    updatedAt
    deletedAt
  }
  positionsCount(pagination: $pagination, where: $where, orderBy: $orderBy) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useGetPositionsQuery__
 *
 * To run a query within a React component, call `useGetPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPositionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPositionsQuery, GetPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPositionsQuery, GetPositionsQueryVariables>(GetPositionsDocument, options);
      }
export function useGetPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPositionsQuery, GetPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPositionsQuery, GetPositionsQueryVariables>(GetPositionsDocument, options);
        }
export function useGetPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPositionsQuery, GetPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPositionsQuery, GetPositionsQueryVariables>(GetPositionsDocument, options);
        }
export type GetPositionsQueryHookResult = ReturnType<typeof useGetPositionsQuery>;
export type GetPositionsLazyQueryHookResult = ReturnType<typeof useGetPositionsLazyQuery>;
export type GetPositionsSuspenseQueryHookResult = ReturnType<typeof useGetPositionsSuspenseQuery>;
export type GetPositionsQueryResult = Apollo.QueryResult<GetPositionsQuery, GetPositionsQueryVariables>;
export const UpdateFunctionalityDescriptionDocument = gql`
    mutation UpdateFunctionalityDescription($updateInput: UpdateFunctionalityInput!) {
  updateFunctionality(updateInput: $updateInput) {
    id
    createdAt
    updatedAt
    deletedAt
    key
    description
    url
  }
}
    `;
export type UpdateFunctionalityDescriptionMutationFn = Apollo.MutationFunction<UpdateFunctionalityDescriptionMutation, UpdateFunctionalityDescriptionMutationVariables>;

/**
 * __useUpdateFunctionalityDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateFunctionalityDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFunctionalityDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFunctionalityDescriptionMutation, { data, loading, error }] = useUpdateFunctionalityDescriptionMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateFunctionalityDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFunctionalityDescriptionMutation, UpdateFunctionalityDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFunctionalityDescriptionMutation, UpdateFunctionalityDescriptionMutationVariables>(UpdateFunctionalityDescriptionDocument, options);
      }
export type UpdateFunctionalityDescriptionMutationHookResult = ReturnType<typeof useUpdateFunctionalityDescriptionMutation>;
export type UpdateFunctionalityDescriptionMutationResult = Apollo.MutationResult<UpdateFunctionalityDescriptionMutation>;
export type UpdateFunctionalityDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateFunctionalityDescriptionMutation, UpdateFunctionalityDescriptionMutationVariables>;
export const UpdateFunctionalityDocument = gql`
    mutation UpdateFunctionality($updateInput: UpdateFunctionalityInput!) {
  updateFunctionality(updateInput: $updateInput) {
    id
    title
  }
}
    `;
export type UpdateFunctionalityMutationFn = Apollo.MutationFunction<UpdateFunctionalityMutation, UpdateFunctionalityMutationVariables>;

/**
 * __useUpdateFunctionalityMutation__
 *
 * To run a mutation, you first call `useUpdateFunctionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFunctionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFunctionalityMutation, { data, loading, error }] = useUpdateFunctionalityMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateFunctionalityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFunctionalityMutation, UpdateFunctionalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFunctionalityMutation, UpdateFunctionalityMutationVariables>(UpdateFunctionalityDocument, options);
      }
export type UpdateFunctionalityMutationHookResult = ReturnType<typeof useUpdateFunctionalityMutation>;
export type UpdateFunctionalityMutationResult = Apollo.MutationResult<UpdateFunctionalityMutation>;
export type UpdateFunctionalityMutationOptions = Apollo.BaseMutationOptions<UpdateFunctionalityMutation, UpdateFunctionalityMutationVariables>;
export const UpdateRoleAndPermissionsDocument = gql`
    mutation UpdateRoleAndPermissions($updateRoleAndPermissionsInput: UpdateRoleAndPermissionsInput!) {
  updateRoleAndPermissions(updateRoleAndPermissionsInput: $updateRoleAndPermissionsInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    defaultForType
    status
    permissions
  }
}
    `;
export type UpdateRoleAndPermissionsMutationFn = Apollo.MutationFunction<UpdateRoleAndPermissionsMutation, UpdateRoleAndPermissionsMutationVariables>;

/**
 * __useUpdateRoleAndPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateRoleAndPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleAndPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleAndPermissionsMutation, { data, loading, error }] = useUpdateRoleAndPermissionsMutation({
 *   variables: {
 *      updateRoleAndPermissionsInput: // value for 'updateRoleAndPermissionsInput'
 *   },
 * });
 */
export function useUpdateRoleAndPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleAndPermissionsMutation, UpdateRoleAndPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleAndPermissionsMutation, UpdateRoleAndPermissionsMutationVariables>(UpdateRoleAndPermissionsDocument, options);
      }
export type UpdateRoleAndPermissionsMutationHookResult = ReturnType<typeof useUpdateRoleAndPermissionsMutation>;
export type UpdateRoleAndPermissionsMutationResult = Apollo.MutationResult<UpdateRoleAndPermissionsMutation>;
export type UpdateRoleAndPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateRoleAndPermissionsMutation, UpdateRoleAndPermissionsMutationVariables>;
export const RolePermissionsDocument = gql`
    query RolePermissions($roleId: ID!) {
  role(id: $roleId) {
    permissions
    name
    description
  }
}
    `;

/**
 * __useRolePermissionsQuery__
 *
 * To run a query within a React component, call `useRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolePermissionsQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRolePermissionsQuery(baseOptions: Apollo.QueryHookOptions<RolePermissionsQuery, RolePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolePermissionsQuery, RolePermissionsQueryVariables>(RolePermissionsDocument, options);
      }
export function useRolePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolePermissionsQuery, RolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolePermissionsQuery, RolePermissionsQueryVariables>(RolePermissionsDocument, options);
        }
export function useRolePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolePermissionsQuery, RolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolePermissionsQuery, RolePermissionsQueryVariables>(RolePermissionsDocument, options);
        }
export type RolePermissionsQueryHookResult = ReturnType<typeof useRolePermissionsQuery>;
export type RolePermissionsLazyQueryHookResult = ReturnType<typeof useRolePermissionsLazyQuery>;
export type RolePermissionsSuspenseQueryHookResult = ReturnType<typeof useRolePermissionsSuspenseQuery>;
export type RolePermissionsQueryResult = Apollo.QueryResult<RolePermissionsQuery, RolePermissionsQueryVariables>;
export const CreateRoleAndPermissionsDocument = gql`
    mutation CreateRoleAndPermissions($createRoleAndPermissionsInput: CreateRoleAndPermissionsInput!) {
  createRoleAndPermissions(createRoleAndPermissionsInput: $createRoleAndPermissionsInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    defaultForType
    status
  }
}
    `;
export type CreateRoleAndPermissionsMutationFn = Apollo.MutationFunction<CreateRoleAndPermissionsMutation, CreateRoleAndPermissionsMutationVariables>;

/**
 * __useCreateRoleAndPermissionsMutation__
 *
 * To run a mutation, you first call `useCreateRoleAndPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleAndPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleAndPermissionsMutation, { data, loading, error }] = useCreateRoleAndPermissionsMutation({
 *   variables: {
 *      createRoleAndPermissionsInput: // value for 'createRoleAndPermissionsInput'
 *   },
 * });
 */
export function useCreateRoleAndPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleAndPermissionsMutation, CreateRoleAndPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleAndPermissionsMutation, CreateRoleAndPermissionsMutationVariables>(CreateRoleAndPermissionsDocument, options);
      }
export type CreateRoleAndPermissionsMutationHookResult = ReturnType<typeof useCreateRoleAndPermissionsMutation>;
export type CreateRoleAndPermissionsMutationResult = Apollo.MutationResult<CreateRoleAndPermissionsMutation>;
export type CreateRoleAndPermissionsMutationOptions = Apollo.BaseMutationOptions<CreateRoleAndPermissionsMutation, CreateRoleAndPermissionsMutationVariables>;
export const RemoveRoleDocument = gql`
    mutation RemoveRole($removeRoleId: ID!) {
  removeRole(id: $removeRoleId) {
    createdAt
    id
  }
}
    `;
export type RemoveRoleMutationFn = Apollo.MutationFunction<RemoveRoleMutation, RemoveRoleMutationVariables>;

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      removeRoleId: // value for 'removeRoleId'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleMutation, RemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(RemoveRoleDocument, options);
      }
export type RemoveRoleMutationHookResult = ReturnType<typeof useRemoveRoleMutation>;
export type RemoveRoleMutationResult = Apollo.MutationResult<RemoveRoleMutation>;
export type RemoveRoleMutationOptions = Apollo.BaseMutationOptions<RemoveRoleMutation, RemoveRoleMutationVariables>;
export const RoleDocument = gql`
    query Role($roleId: ID!) {
  role(id: $roleId) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    status
    roleFx {
      id
    }
  }
}
    `;

/**
 * __useRoleQuery__
 *
 * To run a query within a React component, call `useRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRoleQuery(baseOptions: Apollo.QueryHookOptions<RoleQuery, RoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
      }
export function useRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
export function useRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
export type RoleQueryHookResult = ReturnType<typeof useRoleQuery>;
export type RoleLazyQueryHookResult = ReturnType<typeof useRoleLazyQuery>;
export type RoleSuspenseQueryHookResult = ReturnType<typeof useRoleSuspenseQuery>;
export type RoleQueryResult = Apollo.QueryResult<RoleQuery, RoleQueryVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($updateInput: UpdateRoleInput!) {
  updateRole(updateInput: $updateInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    defaultForType
    status
  }
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const RolesFxDocument = gql`
    query RolesFx($pagination: Pagination, $rolesFxCountPagination2: Pagination) {
  rolesFx(pagination: $pagination) {
    id
  }
  rolesFxCount(pagination: $rolesFxCountPagination2) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useRolesFxQuery__
 *
 * To run a query within a React component, call `useRolesFxQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesFxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesFxQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      rolesFxCountPagination2: // value for 'rolesFxCountPagination2'
 *   },
 * });
 */
export function useRolesFxQuery(baseOptions?: Apollo.QueryHookOptions<RolesFxQuery, RolesFxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesFxQuery, RolesFxQueryVariables>(RolesFxDocument, options);
      }
export function useRolesFxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesFxQuery, RolesFxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesFxQuery, RolesFxQueryVariables>(RolesFxDocument, options);
        }
export function useRolesFxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesFxQuery, RolesFxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesFxQuery, RolesFxQueryVariables>(RolesFxDocument, options);
        }
export type RolesFxQueryHookResult = ReturnType<typeof useRolesFxQuery>;
export type RolesFxLazyQueryHookResult = ReturnType<typeof useRolesFxLazyQuery>;
export type RolesFxSuspenseQueryHookResult = ReturnType<typeof useRolesFxSuspenseQuery>;
export type RolesFxQueryResult = Apollo.QueryResult<RolesFxQuery, RolesFxQueryVariables>;
export const SearchFunctionalitiesDocument = gql`
    query SearchFunctionalities($searchInput: SearchFunctionalityInput!) {
  searchFunctionalities(searchInput: $searchInput) {
    name
    key
    url
    icon
    title
    description
    tags
    children {
      name
      key
      url
      icon
      title
      description
      tags
      children {
        name
        key
        url
        icon
        title
        description
        tags
      }
    }
  }
}
    `;

/**
 * __useSearchFunctionalitiesQuery__
 *
 * To run a query within a React component, call `useSearchFunctionalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFunctionalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFunctionalitiesQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchFunctionalitiesQuery(baseOptions: Apollo.QueryHookOptions<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>(SearchFunctionalitiesDocument, options);
      }
export function useSearchFunctionalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>(SearchFunctionalitiesDocument, options);
        }
export function useSearchFunctionalitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>(SearchFunctionalitiesDocument, options);
        }
export type SearchFunctionalitiesQueryHookResult = ReturnType<typeof useSearchFunctionalitiesQuery>;
export type SearchFunctionalitiesLazyQueryHookResult = ReturnType<typeof useSearchFunctionalitiesLazyQuery>;
export type SearchFunctionalitiesSuspenseQueryHookResult = ReturnType<typeof useSearchFunctionalitiesSuspenseQuery>;
export type SearchFunctionalitiesQueryResult = Apollo.QueryResult<SearchFunctionalitiesQuery, SearchFunctionalitiesQueryVariables>;
export const PageEventSliderBlockDocument = gql`
    query PageEventSliderBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageEventSliderBlock {
      pageBlockStyle
      id
      items {
        description
        title
        orderIndex
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
    }
  }
}
    `;

/**
 * __usePageEventSliderBlockQuery__
 *
 * To run a query within a React component, call `usePageEventSliderBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageEventSliderBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageEventSliderBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function usePageEventSliderBlockQuery(baseOptions: Apollo.QueryHookOptions<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>(PageEventSliderBlockDocument, options);
      }
export function usePageEventSliderBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>(PageEventSliderBlockDocument, options);
        }
export function usePageEventSliderBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>(PageEventSliderBlockDocument, options);
        }
export type PageEventSliderBlockQueryHookResult = ReturnType<typeof usePageEventSliderBlockQuery>;
export type PageEventSliderBlockLazyQueryHookResult = ReturnType<typeof usePageEventSliderBlockLazyQuery>;
export type PageEventSliderBlockSuspenseQueryHookResult = ReturnType<typeof usePageEventSliderBlockSuspenseQuery>;
export type PageEventSliderBlockQueryResult = Apollo.QueryResult<PageEventSliderBlockQuery, PageEventSliderBlockQueryVariables>;
export const CreatePageBlockItemDocument = gql`
    mutation CreatePageBlockItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageEventSliderBlockItem {
      id
      description
    }
  }
}
    `;
export type CreatePageBlockItemMutationFn = Apollo.MutationFunction<CreatePageBlockItemMutation, CreatePageBlockItemMutationVariables>;

/**
 * __useCreatePageBlockItemMutation__
 *
 * To run a mutation, you first call `useCreatePageBlockItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageBlockItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageBlockItemMutation, { data, loading, error }] = useCreatePageBlockItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageBlockItemMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageBlockItemMutation, CreatePageBlockItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageBlockItemMutation, CreatePageBlockItemMutationVariables>(CreatePageBlockItemDocument, options);
      }
export type CreatePageBlockItemMutationHookResult = ReturnType<typeof useCreatePageBlockItemMutation>;
export type CreatePageBlockItemMutationResult = Apollo.MutationResult<CreatePageBlockItemMutation>;
export type CreatePageBlockItemMutationOptions = Apollo.BaseMutationOptions<CreatePageBlockItemMutation, CreatePageBlockItemMutationVariables>;
export const UserDocument = gql`
    query User($userId: ID!) {
  user(id: $userId) {
    id
    name
    middleName
    lastName
    secondSurname
    email
    phoneNumber
    address
    identificationNumber
    type
    status
    userRoles {
      id
      role {
        id
      }
    }
    __typename
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const AuditsClientDocument = gql`
    query AuditsClient($where: FindAuditClientsWhere, $orderBy: [FindAuditClientsOrderBy!], $pagination: Pagination) {
  auditsClient(where: $where, orderBy: $orderBy, pagination: $pagination) {
    id
    createdAt
    updatedAt
    deletedAt
    type
    status
    ip
    requestType
    objectId
    message
    actionType
    objectType
    audits {
      valueAfter
      valueBefore
    }
    fullName
  }
  auditsClientCount(where: $where, orderBy: $orderBy, pagination: $pagination) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useAuditsClientQuery__
 *
 * To run a query within a React component, call `useAuditsClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditsClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditsClientQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAuditsClientQuery(baseOptions?: Apollo.QueryHookOptions<AuditsClientQuery, AuditsClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditsClientQuery, AuditsClientQueryVariables>(AuditsClientDocument, options);
      }
export function useAuditsClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditsClientQuery, AuditsClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditsClientQuery, AuditsClientQueryVariables>(AuditsClientDocument, options);
        }
export function useAuditsClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditsClientQuery, AuditsClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditsClientQuery, AuditsClientQueryVariables>(AuditsClientDocument, options);
        }
export type AuditsClientQueryHookResult = ReturnType<typeof useAuditsClientQuery>;
export type AuditsClientLazyQueryHookResult = ReturnType<typeof useAuditsClientLazyQuery>;
export type AuditsClientSuspenseQueryHookResult = ReturnType<typeof useAuditsClientSuspenseQuery>;
export type AuditsClientQueryResult = Apollo.QueryResult<AuditsClientQuery, AuditsClientQueryVariables>;
export const ObjectTypesEnabledDocument = gql`
    query ObjectTypesEnabled($where: ObjectTypesEnabledArgsWhere, $orderBy: ObjectTypesEnabledArgsOrderBy) {
  objectTypesEnabled(where: $where, orderBy: $orderBy) {
    name
    displayName
  }
}
    `;

/**
 * __useObjectTypesEnabledQuery__
 *
 * To run a query within a React component, call `useObjectTypesEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectTypesEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectTypesEnabledQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useObjectTypesEnabledQuery(baseOptions?: Apollo.QueryHookOptions<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>(ObjectTypesEnabledDocument, options);
      }
export function useObjectTypesEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>(ObjectTypesEnabledDocument, options);
        }
export function useObjectTypesEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>(ObjectTypesEnabledDocument, options);
        }
export type ObjectTypesEnabledQueryHookResult = ReturnType<typeof useObjectTypesEnabledQuery>;
export type ObjectTypesEnabledLazyQueryHookResult = ReturnType<typeof useObjectTypesEnabledLazyQuery>;
export type ObjectTypesEnabledSuspenseQueryHookResult = ReturnType<typeof useObjectTypesEnabledSuspenseQuery>;
export type ObjectTypesEnabledQueryResult = Apollo.QueryResult<ObjectTypesEnabledQuery, ObjectTypesEnabledQueryVariables>;
export const AuditClientDataDocument = gql`
    query AuditClientData($auditClientDataInput: AuditClientDataInput!) {
  auditClientData(auditClientDataInput: $auditClientDataInput) {
    request
    response
    auditClient {
      audits {
        valueAfter
        valueBefore
      }
    }
  }
}
    `;

/**
 * __useAuditClientDataQuery__
 *
 * To run a query within a React component, call `useAuditClientDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditClientDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditClientDataQuery({
 *   variables: {
 *      auditClientDataInput: // value for 'auditClientDataInput'
 *   },
 * });
 */
export function useAuditClientDataQuery(baseOptions: Apollo.QueryHookOptions<AuditClientDataQuery, AuditClientDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditClientDataQuery, AuditClientDataQueryVariables>(AuditClientDataDocument, options);
      }
export function useAuditClientDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditClientDataQuery, AuditClientDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditClientDataQuery, AuditClientDataQueryVariables>(AuditClientDataDocument, options);
        }
export function useAuditClientDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditClientDataQuery, AuditClientDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditClientDataQuery, AuditClientDataQueryVariables>(AuditClientDataDocument, options);
        }
export type AuditClientDataQueryHookResult = ReturnType<typeof useAuditClientDataQuery>;
export type AuditClientDataLazyQueryHookResult = ReturnType<typeof useAuditClientDataLazyQuery>;
export type AuditClientDataSuspenseQueryHookResult = ReturnType<typeof useAuditClientDataSuspenseQuery>;
export type AuditClientDataQueryResult = Apollo.QueryResult<AuditClientDataQuery, AuditClientDataQueryVariables>;
export const UpdateThemePageVersionDocument = gql`
    mutation UpdateThemePageVersion($updateInput: UpdatePageVersionInput!) {
  updatePageVersion(updateInput: $updateInput) {
    id
    theme
  }
}
    `;
export type UpdateThemePageVersionMutationFn = Apollo.MutationFunction<UpdateThemePageVersionMutation, UpdateThemePageVersionMutationVariables>;

/**
 * __useUpdateThemePageVersionMutation__
 *
 * To run a mutation, you first call `useUpdateThemePageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemePageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemePageVersionMutation, { data, loading, error }] = useUpdateThemePageVersionMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateThemePageVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemePageVersionMutation, UpdateThemePageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemePageVersionMutation, UpdateThemePageVersionMutationVariables>(UpdateThemePageVersionDocument, options);
      }
export type UpdateThemePageVersionMutationHookResult = ReturnType<typeof useUpdateThemePageVersionMutation>;
export type UpdateThemePageVersionMutationResult = Apollo.MutationResult<UpdateThemePageVersionMutation>;
export type UpdateThemePageVersionMutationOptions = Apollo.BaseMutationOptions<UpdateThemePageVersionMutation, UpdateThemePageVersionMutationVariables>;
export const TransparencyPageAdminDocument = gql`
    query TransparencyPageAdmin($locations: [BlockLocation!]!, $versionId: ID!, $showDisabled: Boolean, $subPage: SubPages) {
  pageBlocks(locations: $locations, versionId: $versionId, showDisabled: $showDisabled, subPage: $subPage) {
    ... on PageTransparencyBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    __typename
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
      __typename
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageHeaderOrganizationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      __typename
    }
    ... on PageNewsletterBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      news {
        id
        updatedAt
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        title
        summary
        __typename
      }
      __typename
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleProcedures
      descriptionProcedures
      seeMoreActionLink
      procedures {
        id
        name
        cost
        modality
        date
        action
        actionLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSliderBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      sliders {
        id
        title
        orderIndex
        description
        link
        tags
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSliderBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      sliders {
        id
        title
        orderIndex
        description
        link
        tags
        image {
          id
          url
          fileName
          fileMongoId
          __typename
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        snsTitle
        snsSocialNetworkType
        itemLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      taxSectionTitle
      items {
        id
        taxTitle
        image {
          id
          url
          __typename
        }
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      seeMoreAction
      seeMoreLink
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtitle
      hasSearchbar
      __typename
    }
    ... on PageQuickAccessBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      items {
        id
        image {
          id
          url
          __typename
        }
        quickAccessName
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      regulations {
        id
        date
        title
        description
        file {
          id
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      __typename
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
      publicDescription
      showTitle
      showDescription
      __typename
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      __typename
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtype
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        index
        indexTitle
        subtype
        configJson
        schema {
          id
          createdAt
          updatedAt
          deletedAt
          name
          description
          contentType
          isActive
          fields {
            id
            createdAt
            updatedAt
            deletedAt
            fieldName
            fieldLabel
            fieldType
            isRequired
            orderIndex
            options
            validationRules
            defaultValue
            isActive
            isGroup
          }
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
  }
}
    `;

/**
 * __useTransparencyPageAdminQuery__
 *
 * To run a query within a React component, call `useTransparencyPageAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransparencyPageAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransparencyPageAdminQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      versionId: // value for 'versionId'
 *      showDisabled: // value for 'showDisabled'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function useTransparencyPageAdminQuery(baseOptions: Apollo.QueryHookOptions<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>(TransparencyPageAdminDocument, options);
      }
export function useTransparencyPageAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>(TransparencyPageAdminDocument, options);
        }
export function useTransparencyPageAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>(TransparencyPageAdminDocument, options);
        }
export type TransparencyPageAdminQueryHookResult = ReturnType<typeof useTransparencyPageAdminQuery>;
export type TransparencyPageAdminLazyQueryHookResult = ReturnType<typeof useTransparencyPageAdminLazyQuery>;
export type TransparencyPageAdminSuspenseQueryHookResult = ReturnType<typeof useTransparencyPageAdminSuspenseQuery>;
export type TransparencyPageAdminQueryResult = Apollo.QueryResult<TransparencyPageAdminQuery, TransparencyPageAdminQueryVariables>;
export const UpdateTransparencyPageBlockDocument = gql`
    mutation UpdateTransparencyPageBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageTransparencyBlock {
      id
    }
  }
}
    `;
export type UpdateTransparencyPageBlockMutationFn = Apollo.MutationFunction<UpdateTransparencyPageBlockMutation, UpdateTransparencyPageBlockMutationVariables>;

/**
 * __useUpdateTransparencyPageBlockMutation__
 *
 * To run a mutation, you first call `useUpdateTransparencyPageBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransparencyPageBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransparencyPageBlockMutation, { data, loading, error }] = useUpdateTransparencyPageBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransparencyPageBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransparencyPageBlockMutation, UpdateTransparencyPageBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransparencyPageBlockMutation, UpdateTransparencyPageBlockMutationVariables>(UpdateTransparencyPageBlockDocument, options);
      }
export type UpdateTransparencyPageBlockMutationHookResult = ReturnType<typeof useUpdateTransparencyPageBlockMutation>;
export type UpdateTransparencyPageBlockMutationResult = Apollo.MutationResult<UpdateTransparencyPageBlockMutation>;
export type UpdateTransparencyPageBlockMutationOptions = Apollo.BaseMutationOptions<UpdateTransparencyPageBlockMutation, UpdateTransparencyPageBlockMutationVariables>;
export const UpdatePageTransparencyAccordionBlockDocument = gql`
    mutation UpdatePageTransparencyAccordionBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageAccordionBlock {
      id
    }
  }
}
    `;
export type UpdatePageTransparencyAccordionBlockMutationFn = Apollo.MutationFunction<UpdatePageTransparencyAccordionBlockMutation, UpdatePageTransparencyAccordionBlockMutationVariables>;

/**
 * __useUpdatePageTransparencyAccordionBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageTransparencyAccordionBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageTransparencyAccordionBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageTransparencyAccordionBlockMutation, { data, loading, error }] = useUpdatePageTransparencyAccordionBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageTransparencyAccordionBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageTransparencyAccordionBlockMutation, UpdatePageTransparencyAccordionBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageTransparencyAccordionBlockMutation, UpdatePageTransparencyAccordionBlockMutationVariables>(UpdatePageTransparencyAccordionBlockDocument, options);
      }
export type UpdatePageTransparencyAccordionBlockMutationHookResult = ReturnType<typeof useUpdatePageTransparencyAccordionBlockMutation>;
export type UpdatePageTransparencyAccordionBlockMutationResult = Apollo.MutationResult<UpdatePageTransparencyAccordionBlockMutation>;
export type UpdatePageTransparencyAccordionBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageTransparencyAccordionBlockMutation, UpdatePageTransparencyAccordionBlockMutationVariables>;
export const TransparencyAccordionDetailDocument = gql`
    query TransparencyAccordionDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageAccordionBlock {
      id
      pageBlockStyle
      items {
        id
        index
        indexTitle
        linkItem {
          routeType
          target
          url
          routeNavigation
          arguments
        }
      }
    }
  }
}
    `;

/**
 * __useTransparencyAccordionDetailQuery__
 *
 * To run a query within a React component, call `useTransparencyAccordionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransparencyAccordionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransparencyAccordionDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useTransparencyAccordionDetailQuery(baseOptions: Apollo.QueryHookOptions<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>(TransparencyAccordionDetailDocument, options);
      }
export function useTransparencyAccordionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>(TransparencyAccordionDetailDocument, options);
        }
export function useTransparencyAccordionDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>(TransparencyAccordionDetailDocument, options);
        }
export type TransparencyAccordionDetailQueryHookResult = ReturnType<typeof useTransparencyAccordionDetailQuery>;
export type TransparencyAccordionDetailLazyQueryHookResult = ReturnType<typeof useTransparencyAccordionDetailLazyQuery>;
export type TransparencyAccordionDetailSuspenseQueryHookResult = ReturnType<typeof useTransparencyAccordionDetailSuspenseQuery>;
export type TransparencyAccordionDetailQueryResult = Apollo.QueryResult<TransparencyAccordionDetailQuery, TransparencyAccordionDetailQueryVariables>;
export const CreateTransparencyAccordionItemDocument = gql`
    mutation CreateTransparencyAccordionItem($input: CreatePageBlockItemInputUnion!) {
  createPageBlockItem(input: $input) {
    ... on PageAccordionBlockItem {
      id
    }
  }
}
    `;
export type CreateTransparencyAccordionItemMutationFn = Apollo.MutationFunction<CreateTransparencyAccordionItemMutation, CreateTransparencyAccordionItemMutationVariables>;

/**
 * __useCreateTransparencyAccordionItemMutation__
 *
 * To run a mutation, you first call `useCreateTransparencyAccordionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransparencyAccordionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransparencyAccordionItemMutation, { data, loading, error }] = useCreateTransparencyAccordionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransparencyAccordionItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransparencyAccordionItemMutation, CreateTransparencyAccordionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransparencyAccordionItemMutation, CreateTransparencyAccordionItemMutationVariables>(CreateTransparencyAccordionItemDocument, options);
      }
export type CreateTransparencyAccordionItemMutationHookResult = ReturnType<typeof useCreateTransparencyAccordionItemMutation>;
export type CreateTransparencyAccordionItemMutationResult = Apollo.MutationResult<CreateTransparencyAccordionItemMutation>;
export type CreateTransparencyAccordionItemMutationOptions = Apollo.BaseMutationOptions<CreateTransparencyAccordionItemMutation, CreateTransparencyAccordionItemMutationVariables>;
export const UpdateTransparencyAccordionItemDocument = gql`
    mutation UpdateTransparencyAccordionItem($input: UpdatePageBlockItemInputUnion!) {
  updatePageBlockItem(input: $input) {
    ... on PageAccordionBlockItem {
      id
    }
  }
}
    `;
export type UpdateTransparencyAccordionItemMutationFn = Apollo.MutationFunction<UpdateTransparencyAccordionItemMutation, UpdateTransparencyAccordionItemMutationVariables>;

/**
 * __useUpdateTransparencyAccordionItemMutation__
 *
 * To run a mutation, you first call `useUpdateTransparencyAccordionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransparencyAccordionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransparencyAccordionItemMutation, { data, loading, error }] = useUpdateTransparencyAccordionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransparencyAccordionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransparencyAccordionItemMutation, UpdateTransparencyAccordionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransparencyAccordionItemMutation, UpdateTransparencyAccordionItemMutationVariables>(UpdateTransparencyAccordionItemDocument, options);
      }
export type UpdateTransparencyAccordionItemMutationHookResult = ReturnType<typeof useUpdateTransparencyAccordionItemMutation>;
export type UpdateTransparencyAccordionItemMutationResult = Apollo.MutationResult<UpdateTransparencyAccordionItemMutation>;
export type UpdateTransparencyAccordionItemMutationOptions = Apollo.BaseMutationOptions<UpdateTransparencyAccordionItemMutation, UpdateTransparencyAccordionItemMutationVariables>;
export const GetTransparencyAccordionItemDocument = gql`
    query GetTransparencyAccordionItem($pageBlockItemId: ID!) {
  pageBlockItem(id: $pageBlockItemId) {
    ... on PageAccordionBlockItem {
      id
      index
      indexTitle
      linkItem {
        id
        routeType
        routeNavigation
        target
        arguments
        url
      }
    }
  }
}
    `;

/**
 * __useGetTransparencyAccordionItemQuery__
 *
 * To run a query within a React component, call `useGetTransparencyAccordionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransparencyAccordionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransparencyAccordionItemQuery({
 *   variables: {
 *      pageBlockItemId: // value for 'pageBlockItemId'
 *   },
 * });
 */
export function useGetTransparencyAccordionItemQuery(baseOptions: Apollo.QueryHookOptions<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>(GetTransparencyAccordionItemDocument, options);
      }
export function useGetTransparencyAccordionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>(GetTransparencyAccordionItemDocument, options);
        }
export function useGetTransparencyAccordionItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>(GetTransparencyAccordionItemDocument, options);
        }
export type GetTransparencyAccordionItemQueryHookResult = ReturnType<typeof useGetTransparencyAccordionItemQuery>;
export type GetTransparencyAccordionItemLazyQueryHookResult = ReturnType<typeof useGetTransparencyAccordionItemLazyQuery>;
export type GetTransparencyAccordionItemSuspenseQueryHookResult = ReturnType<typeof useGetTransparencyAccordionItemSuspenseQuery>;
export type GetTransparencyAccordionItemQueryResult = Apollo.QueryResult<GetTransparencyAccordionItemQuery, GetTransparencyAccordionItemQueryVariables>;
export const RemoveTransparencyAccordionItemDocument = gql`
    mutation RemoveTransparencyAccordionItem($removePageBlockItemId: ID!) {
  removePageBlockItem(id: $removePageBlockItemId) {
    ... on PageAccordionBlockItem {
      id
    }
  }
}
    `;
export type RemoveTransparencyAccordionItemMutationFn = Apollo.MutationFunction<RemoveTransparencyAccordionItemMutation, RemoveTransparencyAccordionItemMutationVariables>;

/**
 * __useRemoveTransparencyAccordionItemMutation__
 *
 * To run a mutation, you first call `useRemoveTransparencyAccordionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTransparencyAccordionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTransparencyAccordionItemMutation, { data, loading, error }] = useRemoveTransparencyAccordionItemMutation({
 *   variables: {
 *      removePageBlockItemId: // value for 'removePageBlockItemId'
 *   },
 * });
 */
export function useRemoveTransparencyAccordionItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTransparencyAccordionItemMutation, RemoveTransparencyAccordionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTransparencyAccordionItemMutation, RemoveTransparencyAccordionItemMutationVariables>(RemoveTransparencyAccordionItemDocument, options);
      }
export type RemoveTransparencyAccordionItemMutationHookResult = ReturnType<typeof useRemoveTransparencyAccordionItemMutation>;
export type RemoveTransparencyAccordionItemMutationResult = Apollo.MutationResult<RemoveTransparencyAccordionItemMutation>;
export type RemoveTransparencyAccordionItemMutationOptions = Apollo.BaseMutationOptions<RemoveTransparencyAccordionItemMutation, RemoveTransparencyAccordionItemMutationVariables>;
export const UpdatePageTransparencyIntroductionBlockDocument = gql`
    mutation UpdatePageTransparencyIntroductionBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageTransparencyBlock {
      id
    }
  }
}
    `;
export type UpdatePageTransparencyIntroductionBlockMutationFn = Apollo.MutationFunction<UpdatePageTransparencyIntroductionBlockMutation, UpdatePageTransparencyIntroductionBlockMutationVariables>;

/**
 * __useUpdatePageTransparencyIntroductionBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePageTransparencyIntroductionBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageTransparencyIntroductionBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageTransparencyIntroductionBlockMutation, { data, loading, error }] = useUpdatePageTransparencyIntroductionBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageTransparencyIntroductionBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageTransparencyIntroductionBlockMutation, UpdatePageTransparencyIntroductionBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageTransparencyIntroductionBlockMutation, UpdatePageTransparencyIntroductionBlockMutationVariables>(UpdatePageTransparencyIntroductionBlockDocument, options);
      }
export type UpdatePageTransparencyIntroductionBlockMutationHookResult = ReturnType<typeof useUpdatePageTransparencyIntroductionBlockMutation>;
export type UpdatePageTransparencyIntroductionBlockMutationResult = Apollo.MutationResult<UpdatePageTransparencyIntroductionBlockMutation>;
export type UpdatePageTransparencyIntroductionBlockMutationOptions = Apollo.BaseMutationOptions<UpdatePageTransparencyIntroductionBlockMutation, UpdatePageTransparencyIntroductionBlockMutationVariables>;
export const GetPageTransparencyIntroductionBlockDocument = gql`
    query GetPageTransparencyIntroductionBlock($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageTransparencyBlock {
      id
      description
      hasLinkVideo
      linkVideo {
        routeType
        target
        url
        routeNavigation
        arguments
      }
      image {
        id
        fileMongoId
        fileMode
        fileExtension
        fileName
        url
      }
      transparencyContent
      items {
        id
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          fileMongoId
          fileMode
          fileExtension
          fileName
          url
        }
        linkItem {
          routeType
          target
          url
          routeNavigation
          arguments
        }
      }
    }
  }
}
    `;

/**
 * __useGetPageTransparencyIntroductionBlockQuery__
 *
 * To run a query within a React component, call `useGetPageTransparencyIntroductionBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageTransparencyIntroductionBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageTransparencyIntroductionBlockQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetPageTransparencyIntroductionBlockQuery(baseOptions: Apollo.QueryHookOptions<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>(GetPageTransparencyIntroductionBlockDocument, options);
      }
export function useGetPageTransparencyIntroductionBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>(GetPageTransparencyIntroductionBlockDocument, options);
        }
export function useGetPageTransparencyIntroductionBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>(GetPageTransparencyIntroductionBlockDocument, options);
        }
export type GetPageTransparencyIntroductionBlockQueryHookResult = ReturnType<typeof useGetPageTransparencyIntroductionBlockQuery>;
export type GetPageTransparencyIntroductionBlockLazyQueryHookResult = ReturnType<typeof useGetPageTransparencyIntroductionBlockLazyQuery>;
export type GetPageTransparencyIntroductionBlockSuspenseQueryHookResult = ReturnType<typeof useGetPageTransparencyIntroductionBlockSuspenseQuery>;
export type GetPageTransparencyIntroductionBlockQueryResult = Apollo.QueryResult<GetPageTransparencyIntroductionBlockQuery, GetPageTransparencyIntroductionBlockQueryVariables>;
export const ClonePageVersionDocument = gql`
    mutation ClonePageVersion($createInput: ClonePageVersionInput!) {
  clonePageVersion(createInput: $createInput) {
    id
    state
    theme
    description
    consecutive
  }
}
    `;
export type ClonePageVersionMutationFn = Apollo.MutationFunction<ClonePageVersionMutation, ClonePageVersionMutationVariables>;

/**
 * __useClonePageVersionMutation__
 *
 * To run a mutation, you first call `useClonePageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePageVersionMutation, { data, loading, error }] = useClonePageVersionMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useClonePageVersionMutation(baseOptions?: Apollo.MutationHookOptions<ClonePageVersionMutation, ClonePageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePageVersionMutation, ClonePageVersionMutationVariables>(ClonePageVersionDocument, options);
      }
export type ClonePageVersionMutationHookResult = ReturnType<typeof useClonePageVersionMutation>;
export type ClonePageVersionMutationResult = Apollo.MutationResult<ClonePageVersionMutation>;
export type ClonePageVersionMutationOptions = Apollo.BaseMutationOptions<ClonePageVersionMutation, ClonePageVersionMutationVariables>;
export const FindPageVersionsDocument = gql`
    query FindPageVersions($where: FindPageVersionsWhere) {
  pageVersions(where: $where) {
    id
    state
    description
    theme
    consecutive
  }
}
    `;

/**
 * __useFindPageVersionsQuery__
 *
 * To run a query within a React component, call `useFindPageVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPageVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPageVersionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindPageVersionsQuery(baseOptions?: Apollo.QueryHookOptions<FindPageVersionsQuery, FindPageVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPageVersionsQuery, FindPageVersionsQueryVariables>(FindPageVersionsDocument, options);
      }
export function useFindPageVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPageVersionsQuery, FindPageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPageVersionsQuery, FindPageVersionsQueryVariables>(FindPageVersionsDocument, options);
        }
export function useFindPageVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindPageVersionsQuery, FindPageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindPageVersionsQuery, FindPageVersionsQueryVariables>(FindPageVersionsDocument, options);
        }
export type FindPageVersionsQueryHookResult = ReturnType<typeof useFindPageVersionsQuery>;
export type FindPageVersionsLazyQueryHookResult = ReturnType<typeof useFindPageVersionsLazyQuery>;
export type FindPageVersionsSuspenseQueryHookResult = ReturnType<typeof useFindPageVersionsSuspenseQuery>;
export type FindPageVersionsQueryResult = Apollo.QueryResult<FindPageVersionsQuery, FindPageVersionsQueryVariables>;
export const SignInAdminDocument = gql`
    mutation SignInAdmin($signInAdminInput: SigninAdminInput!) {
  signInAdmin(signInAdminInput: $signInAdminInput) {
    token
    user {
      id
      createdAt
      updatedAt
      deletedAt
      name
      middleName
      lastName
      secondSurname
      email
      identificationType
      identificationNumber
      dateIssue
      legalRepresentativeIdentificationType
      legalRepresentativeIdentificationNumber
      phoneCountryCode
      temporalPassword
      phoneNumber
      country {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
        __typename
      }
      department {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
        __typename
      }
      city {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
        __typename
      }
      address
      hasRural
      status
      type
      phoneVerification
      emailVerification
      permissions
      __typename
      userDependencies {
        id
        createdAt
        updatedAt
        deletedAt
        status
        dependency {
          id
          createdAt
          updatedAt
          deletedAt
          name
          type
          status
        }
      }
    }
    __typename
  }
}
    `;
export type SignInAdminMutationFn = Apollo.MutationFunction<SignInAdminMutation, SignInAdminMutationVariables>;

/**
 * __useSignInAdminMutation__
 *
 * To run a mutation, you first call `useSignInAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInAdminMutation, { data, loading, error }] = useSignInAdminMutation({
 *   variables: {
 *      signInAdminInput: // value for 'signInAdminInput'
 *   },
 * });
 */
export function useSignInAdminMutation(baseOptions?: Apollo.MutationHookOptions<SignInAdminMutation, SignInAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInAdminMutation, SignInAdminMutationVariables>(SignInAdminDocument, options);
      }
export type SignInAdminMutationHookResult = ReturnType<typeof useSignInAdminMutation>;
export type SignInAdminMutationResult = Apollo.MutationResult<SignInAdminMutation>;
export type SignInAdminMutationOptions = Apollo.BaseMutationOptions<SignInAdminMutation, SignInAdminMutationVariables>;
export const ApprovalJwtDocument = gql`
    query ApprovalJwt($approvalTokenInput: ApprovalTokenInput!) {
  approvalJwt(approvalTokenInput: $approvalTokenInput) {
    token
    user {
      id
      createdAt
      updatedAt
      deletedAt
      name
      middleName
      lastName
      secondSurname
      email
      identificationType
      identificationNumber
      dateIssue
      legalRepresentativeIdentificationType
      legalRepresentativeIdentificationNumber
      phoneCountryCode
      phoneNumber
      country {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
      }
      department {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
      }
      city {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
      }
      address
      hasRural
      status
      type
      phoneVerification
      emailVerification
    }
  }
}
    `;

/**
 * __useApprovalJwtQuery__
 *
 * To run a query within a React component, call `useApprovalJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalJwtQuery({
 *   variables: {
 *      approvalTokenInput: // value for 'approvalTokenInput'
 *   },
 * });
 */
export function useApprovalJwtQuery(baseOptions: Apollo.QueryHookOptions<ApprovalJwtQuery, ApprovalJwtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalJwtQuery, ApprovalJwtQueryVariables>(ApprovalJwtDocument, options);
      }
export function useApprovalJwtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalJwtQuery, ApprovalJwtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalJwtQuery, ApprovalJwtQueryVariables>(ApprovalJwtDocument, options);
        }
export function useApprovalJwtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApprovalJwtQuery, ApprovalJwtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApprovalJwtQuery, ApprovalJwtQueryVariables>(ApprovalJwtDocument, options);
        }
export type ApprovalJwtQueryHookResult = ReturnType<typeof useApprovalJwtQuery>;
export type ApprovalJwtLazyQueryHookResult = ReturnType<typeof useApprovalJwtLazyQuery>;
export type ApprovalJwtSuspenseQueryHookResult = ReturnType<typeof useApprovalJwtSuspenseQuery>;
export type ApprovalJwtQueryResult = Apollo.QueryResult<ApprovalJwtQuery, ApprovalJwtQueryVariables>;
export const SignInWithOAuthDocument = gql`
    mutation SignInWithOAuth($googleSigninInput: GoogleSigninInput!) {
  SignInWithOAuth(googleSigninInput: $googleSigninInput) {
    token
    user {
      id
      createdAt
      updatedAt
      deletedAt
      name
      middleName
      lastName
      secondSurname
      email
      identificationType
      identificationNumber
      dateIssue
      legalRepresentativeIdentificationType
      legalRepresentativeIdentificationNumber
      phoneCountryCode
      temporalPassword
      phoneNumber
      country {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
        __typename
      }
      department {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
        __typename
      }
      city {
        id
        createdAt
        updatedAt
        deletedAt
        code
        name
        __typename
      }
      address
      hasRural
      status
      type
      phoneVerification
      emailVerification
      permissions
      __typename
      userDependencies {
        id
        createdAt
        updatedAt
        deletedAt
        status
        dependency {
          id
          createdAt
          updatedAt
          deletedAt
          name
          type
          status
        }
      }
    }
  }
}
    `;
export type SignInWithOAuthMutationFn = Apollo.MutationFunction<SignInWithOAuthMutation, SignInWithOAuthMutationVariables>;

/**
 * __useSignInWithOAuthMutation__
 *
 * To run a mutation, you first call `useSignInWithOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithOAuthMutation, { data, loading, error }] = useSignInWithOAuthMutation({
 *   variables: {
 *      googleSigninInput: // value for 'googleSigninInput'
 *   },
 * });
 */
export function useSignInWithOAuthMutation(baseOptions?: Apollo.MutationHookOptions<SignInWithOAuthMutation, SignInWithOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInWithOAuthMutation, SignInWithOAuthMutationVariables>(SignInWithOAuthDocument, options);
      }
export type SignInWithOAuthMutationHookResult = ReturnType<typeof useSignInWithOAuthMutation>;
export type SignInWithOAuthMutationResult = Apollo.MutationResult<SignInWithOAuthMutation>;
export type SignInWithOAuthMutationOptions = Apollo.BaseMutationOptions<SignInWithOAuthMutation, SignInWithOAuthMutationVariables>;
export const RecoverPasswordDocument = gql`
    mutation RecoverPassword($recoverPasswordInput: RecoverPasswordInput!) {
  recoverPassword(recoverPasswordInput: $recoverPasswordInput)
}
    `;
export type RecoverPasswordMutationFn = Apollo.MutationFunction<RecoverPasswordMutation, RecoverPasswordMutationVariables>;

/**
 * __useRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverPasswordMutation, { data, loading, error }] = useRecoverPasswordMutation({
 *   variables: {
 *      recoverPasswordInput: // value for 'recoverPasswordInput'
 *   },
 * });
 */
export function useRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RecoverPasswordMutation, RecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverPasswordMutation, RecoverPasswordMutationVariables>(RecoverPasswordDocument, options);
      }
export type RecoverPasswordMutationHookResult = ReturnType<typeof useRecoverPasswordMutation>;
export type RecoverPasswordMutationResult = Apollo.MutationResult<RecoverPasswordMutation>;
export type RecoverPasswordMutationOptions = Apollo.BaseMutationOptions<RecoverPasswordMutation, RecoverPasswordMutationVariables>;
export const ValidateCodeRecoverPasswordDocument = gql`
    query ValidateCodeRecoverPassword($codeRecoverPasswordInput: CodeRecoverPasswordInput!) {
  codeRecoverPassword(codeRecoverPasswordInput: $codeRecoverPasswordInput)
}
    `;

/**
 * __useValidateCodeRecoverPasswordQuery__
 *
 * To run a query within a React component, call `useValidateCodeRecoverPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCodeRecoverPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCodeRecoverPasswordQuery({
 *   variables: {
 *      codeRecoverPasswordInput: // value for 'codeRecoverPasswordInput'
 *   },
 * });
 */
export function useValidateCodeRecoverPasswordQuery(baseOptions: Apollo.QueryHookOptions<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>(ValidateCodeRecoverPasswordDocument, options);
      }
export function useValidateCodeRecoverPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>(ValidateCodeRecoverPasswordDocument, options);
        }
export function useValidateCodeRecoverPasswordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>(ValidateCodeRecoverPasswordDocument, options);
        }
export type ValidateCodeRecoverPasswordQueryHookResult = ReturnType<typeof useValidateCodeRecoverPasswordQuery>;
export type ValidateCodeRecoverPasswordLazyQueryHookResult = ReturnType<typeof useValidateCodeRecoverPasswordLazyQuery>;
export type ValidateCodeRecoverPasswordSuspenseQueryHookResult = ReturnType<typeof useValidateCodeRecoverPasswordSuspenseQuery>;
export type ValidateCodeRecoverPasswordQueryResult = Apollo.QueryResult<ValidateCodeRecoverPasswordQuery, ValidateCodeRecoverPasswordQueryVariables>;
export const UpdateAndRecoverPasswordDocument = gql`
    mutation UpdateAndRecoverPassword($updatePasswordInput: UpdatePasswordInput!) {
  updatePassword(updatePasswordInput: $updatePasswordInput) {
    id
  }
}
    `;
export type UpdateAndRecoverPasswordMutationFn = Apollo.MutationFunction<UpdateAndRecoverPasswordMutation, UpdateAndRecoverPasswordMutationVariables>;

/**
 * __useUpdateAndRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateAndRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndRecoverPasswordMutation, { data, loading, error }] = useUpdateAndRecoverPasswordMutation({
 *   variables: {
 *      updatePasswordInput: // value for 'updatePasswordInput'
 *   },
 * });
 */
export function useUpdateAndRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndRecoverPasswordMutation, UpdateAndRecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndRecoverPasswordMutation, UpdateAndRecoverPasswordMutationVariables>(UpdateAndRecoverPasswordDocument, options);
      }
export type UpdateAndRecoverPasswordMutationHookResult = ReturnType<typeof useUpdateAndRecoverPasswordMutation>;
export type UpdateAndRecoverPasswordMutationResult = Apollo.MutationResult<UpdateAndRecoverPasswordMutation>;
export type UpdateAndRecoverPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateAndRecoverPasswordMutation, UpdateAndRecoverPasswordMutationVariables>;
export const AllCarouselSlidesDocument = gql`
    query AllCarouselSlides($where: FindCarouselSlideWhere) {
  allCarouselSlides(where: $where) {
    id
    createdAt
    updatedAt
    deletedAt
    slideId
    type
    version
    title
    description
    imageUrl
    ctaText
    ctaUrl
    activeFrom
    activeTo
    isAdminEnabled
    displayOrder
    imageFile {
      id
      downloadUrl
    }
  }
}
    `;

/**
 * __useAllCarouselSlidesQuery__
 *
 * To run a query within a React component, call `useAllCarouselSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarouselSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarouselSlidesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAllCarouselSlidesQuery(baseOptions?: Apollo.QueryHookOptions<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>(AllCarouselSlidesDocument, options);
      }
export function useAllCarouselSlidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>(AllCarouselSlidesDocument, options);
        }
export function useAllCarouselSlidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>(AllCarouselSlidesDocument, options);
        }
export type AllCarouselSlidesQueryHookResult = ReturnType<typeof useAllCarouselSlidesQuery>;
export type AllCarouselSlidesLazyQueryHookResult = ReturnType<typeof useAllCarouselSlidesLazyQuery>;
export type AllCarouselSlidesSuspenseQueryHookResult = ReturnType<typeof useAllCarouselSlidesSuspenseQuery>;
export type AllCarouselSlidesQueryResult = Apollo.QueryResult<AllCarouselSlidesQuery, AllCarouselSlidesQueryVariables>;
export const CanEditPageDynamicDocument = gql`
    query CanEditPageDynamic($pageDynamicId: ID, $slug: String) {
  canEditPageDynamic(pageDynamicId: $pageDynamicId, slug: $slug) {
    canEdit
    id
    slug
  }
}
    `;

/**
 * __useCanEditPageDynamicQuery__
 *
 * To run a query within a React component, call `useCanEditPageDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanEditPageDynamicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanEditPageDynamicQuery({
 *   variables: {
 *      pageDynamicId: // value for 'pageDynamicId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCanEditPageDynamicQuery(baseOptions?: Apollo.QueryHookOptions<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>(CanEditPageDynamicDocument, options);
      }
export function useCanEditPageDynamicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>(CanEditPageDynamicDocument, options);
        }
export function useCanEditPageDynamicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>(CanEditPageDynamicDocument, options);
        }
export type CanEditPageDynamicQueryHookResult = ReturnType<typeof useCanEditPageDynamicQuery>;
export type CanEditPageDynamicLazyQueryHookResult = ReturnType<typeof useCanEditPageDynamicLazyQuery>;
export type CanEditPageDynamicSuspenseQueryHookResult = ReturnType<typeof useCanEditPageDynamicSuspenseQuery>;
export type CanEditPageDynamicQueryResult = Apollo.QueryResult<CanEditPageDynamicQuery, CanEditPageDynamicQueryVariables>;
export const ParameterByCodDocument = gql`
    query ParameterByCod($code: String!) {
  parameterByCod(code: $code) {
    id
    code
    description
    type
    character
    number
    booleanValue
    date
    json
    image {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      downloadUrl
      url
    }
    deletedAt
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useParameterByCodQuery__
 *
 * To run a query within a React component, call `useParameterByCodQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterByCodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterByCodQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useParameterByCodQuery(baseOptions: Apollo.QueryHookOptions<ParameterByCodQuery, ParameterByCodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParameterByCodQuery, ParameterByCodQueryVariables>(ParameterByCodDocument, options);
      }
export function useParameterByCodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParameterByCodQuery, ParameterByCodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParameterByCodQuery, ParameterByCodQueryVariables>(ParameterByCodDocument, options);
        }
export function useParameterByCodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParameterByCodQuery, ParameterByCodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParameterByCodQuery, ParameterByCodQueryVariables>(ParameterByCodDocument, options);
        }
export type ParameterByCodQueryHookResult = ReturnType<typeof useParameterByCodQuery>;
export type ParameterByCodLazyQueryHookResult = ReturnType<typeof useParameterByCodLazyQuery>;
export type ParameterByCodSuspenseQueryHookResult = ReturnType<typeof useParameterByCodSuspenseQuery>;
export type ParameterByCodQueryResult = Apollo.QueryResult<ParameterByCodQuery, ParameterByCodQueryVariables>;
export const PqrsdfDocument = gql`
    query pqrsdf($orderBy: [FindProceduresOrderBy!], $where: FindProceduresWhere, $pagination: Pagination, $subPage: SubPages!) {
  procedures(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    procedureDescription
    duration
    cost
    modality
    date
    action
    multimediaType
    estimatedDuration
    actionLink
    alternativeText
    procedureStatus
    procedureTypes
    publicationDate
    gocvoLogoName
    processDefinitionId
    procedureItemTags
    govcoImage {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
  }
  subPage(subPage: $subPage) {
    ... on PageSubHeaderBlock {
      id
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      isDisabled
      orderIndex
      pageBlockStyle
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      dynamic {
        id
      }
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
  }
}
    `;

/**
 * __usePqrsdfQuery__
 *
 * To run a query within a React component, call `usePqrsdfQuery` and pass it any options that fit your needs.
 * When your component renders, `usePqrsdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePqrsdfQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function usePqrsdfQuery(baseOptions: Apollo.QueryHookOptions<PqrsdfQuery, PqrsdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PqrsdfQuery, PqrsdfQueryVariables>(PqrsdfDocument, options);
      }
export function usePqrsdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PqrsdfQuery, PqrsdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PqrsdfQuery, PqrsdfQueryVariables>(PqrsdfDocument, options);
        }
export function usePqrsdfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PqrsdfQuery, PqrsdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PqrsdfQuery, PqrsdfQueryVariables>(PqrsdfDocument, options);
        }
export type PqrsdfQueryHookResult = ReturnType<typeof usePqrsdfQuery>;
export type PqrsdfLazyQueryHookResult = ReturnType<typeof usePqrsdfLazyQuery>;
export type PqrsdfSuspenseQueryHookResult = ReturnType<typeof usePqrsdfSuspenseQuery>;
export type PqrsdfQueryResult = Apollo.QueryResult<PqrsdfQuery, PqrsdfQueryVariables>;
export const ProceduresDocument = gql`
    query Procedures($orderBy: [FindProceduresOrderBy!], $where: FindProceduresWhere, $pagination: Pagination) {
  procedures(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    procedureDescription
    duration
    cost
    modality
    date
    action
    multimediaType
    estimatedDuration
    actionLink
    alternativeText
    procedureStatus
    procedureTypes
    publicationDate
    gocvoLogoName
    processDefinitionId
    procedureItemTags
    showGovcoButton
    showProcedureButton
  }
  proceduresCount(orderBy: $orderBy, where: $where, pagination: $pagination) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useProceduresQuery__
 *
 * To run a query within a React component, call `useProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProceduresQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProceduresQuery(baseOptions?: Apollo.QueryHookOptions<ProceduresQuery, ProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProceduresQuery, ProceduresQueryVariables>(ProceduresDocument, options);
      }
export function useProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProceduresQuery, ProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProceduresQuery, ProceduresQueryVariables>(ProceduresDocument, options);
        }
export function useProceduresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProceduresQuery, ProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProceduresQuery, ProceduresQueryVariables>(ProceduresDocument, options);
        }
export type ProceduresQueryHookResult = ReturnType<typeof useProceduresQuery>;
export type ProceduresLazyQueryHookResult = ReturnType<typeof useProceduresLazyQuery>;
export type ProceduresSuspenseQueryHookResult = ReturnType<typeof useProceduresSuspenseQuery>;
export type ProceduresQueryResult = Apollo.QueryResult<ProceduresQuery, ProceduresQueryVariables>;
export const ProceduresIdDocument = gql`
    query ProceduresId($orderBy: [FindProceduresOrderBy!], $where: FindProceduresWhere, $pagination: Pagination) {
  procedures(orderBy: $orderBy, where: $where, pagination: $pagination) {
    id
    processDefinitionId
  }
}
    `;

/**
 * __useProceduresIdQuery__
 *
 * To run a query within a React component, call `useProceduresIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProceduresIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProceduresIdQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProceduresIdQuery(baseOptions?: Apollo.QueryHookOptions<ProceduresIdQuery, ProceduresIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProceduresIdQuery, ProceduresIdQueryVariables>(ProceduresIdDocument, options);
      }
export function useProceduresIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProceduresIdQuery, ProceduresIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProceduresIdQuery, ProceduresIdQueryVariables>(ProceduresIdDocument, options);
        }
export function useProceduresIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProceduresIdQuery, ProceduresIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProceduresIdQuery, ProceduresIdQueryVariables>(ProceduresIdDocument, options);
        }
export type ProceduresIdQueryHookResult = ReturnType<typeof useProceduresIdQuery>;
export type ProceduresIdLazyQueryHookResult = ReturnType<typeof useProceduresIdLazyQuery>;
export type ProceduresIdSuspenseQueryHookResult = ReturnType<typeof useProceduresIdSuspenseQuery>;
export type ProceduresIdQueryResult = Apollo.QueryResult<ProceduresIdQuery, ProceduresIdQueryVariables>;
export const ProcedureDocument = gql`
    query Procedure($procedureId: ID!) {
  procedure(id: $procedureId) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    procedureDescription
    duration
    cost
    modality
    date
    action
    multimediaType
    estimatedDuration
    actionLink
    alternativeText
    procedureStatus
    procedureTypes
    publicationDate
    gocvoLogoName
    processDefinitionId
    procedureItemTags
    linkVideo {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    govcoLink {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    govcoImage {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
      url
    }
    linkItem {
      id
      createdAt
      updatedAt
      deletedAt
      routeType
      routeNavigation
      target
      arguments
      url
    }
    showGovcoButton
    showProcedureButton
  }
}
    `;

/**
 * __useProcedureQuery__
 *
 * To run a query within a React component, call `useProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedureQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useProcedureQuery(baseOptions: Apollo.QueryHookOptions<ProcedureQuery, ProcedureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcedureQuery, ProcedureQueryVariables>(ProcedureDocument, options);
      }
export function useProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcedureQuery, ProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcedureQuery, ProcedureQueryVariables>(ProcedureDocument, options);
        }
export function useProcedureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcedureQuery, ProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcedureQuery, ProcedureQueryVariables>(ProcedureDocument, options);
        }
export type ProcedureQueryHookResult = ReturnType<typeof useProcedureQuery>;
export type ProcedureLazyQueryHookResult = ReturnType<typeof useProcedureLazyQuery>;
export type ProcedureSuspenseQueryHookResult = ReturnType<typeof useProcedureSuspenseQuery>;
export type ProcedureQueryResult = Apollo.QueryResult<ProcedureQuery, ProcedureQueryVariables>;
export const CarouselEventsDocument = gql`
    query CarouselEvents($where: FindEventWhere, $pagination: Pagination, $orderBy: [FindEventOrderBy!]) {
  eventsItems(where: $where, orderBy: $orderBy, pagination: $pagination) {
    id
    eventItemTitle
    eventItemDescription
    image {
      id
      downloadUrl
    }
    startDate
    endDate
    createdAt
    multimediaType
    linkItem {
      id
      url
    }
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
  eventsItemsCount(where: $where, orderBy: $orderBy, pagination: $pagination) {
    currentPage
    itemsPerPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useCarouselEventsQuery__
 *
 * To run a query within a React component, call `useCarouselEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarouselEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarouselEventsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCarouselEventsQuery(baseOptions?: Apollo.QueryHookOptions<CarouselEventsQuery, CarouselEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarouselEventsQuery, CarouselEventsQueryVariables>(CarouselEventsDocument, options);
      }
export function useCarouselEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarouselEventsQuery, CarouselEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarouselEventsQuery, CarouselEventsQueryVariables>(CarouselEventsDocument, options);
        }
export function useCarouselEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CarouselEventsQuery, CarouselEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarouselEventsQuery, CarouselEventsQueryVariables>(CarouselEventsDocument, options);
        }
export type CarouselEventsQueryHookResult = ReturnType<typeof useCarouselEventsQuery>;
export type CarouselEventsLazyQueryHookResult = ReturnType<typeof useCarouselEventsLazyQuery>;
export type CarouselEventsSuspenseQueryHookResult = ReturnType<typeof useCarouselEventsSuspenseQuery>;
export type CarouselEventsQueryResult = Apollo.QueryResult<CarouselEventsQuery, CarouselEventsQueryVariables>;
export const SocialNetworksEventsDocument = gql`
    query SocialNetworksEvents {
  mainPage {
    ... on PageSocialNetworksBlock {
      id
      pageBlockStyle
      rightItems {
        id
        orderIndex
        socialNetworkType
        link
        linkItem {
          id
          url
          routeType
          routeNavigation
          target
          arguments
        }
      }
    }
  }
}
    `;

/**
 * __useSocialNetworksEventsQuery__
 *
 * To run a query within a React component, call `useSocialNetworksEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialNetworksEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialNetworksEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSocialNetworksEventsQuery(baseOptions?: Apollo.QueryHookOptions<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>(SocialNetworksEventsDocument, options);
      }
export function useSocialNetworksEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>(SocialNetworksEventsDocument, options);
        }
export function useSocialNetworksEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>(SocialNetworksEventsDocument, options);
        }
export type SocialNetworksEventsQueryHookResult = ReturnType<typeof useSocialNetworksEventsQuery>;
export type SocialNetworksEventsLazyQueryHookResult = ReturnType<typeof useSocialNetworksEventsLazyQuery>;
export type SocialNetworksEventsSuspenseQueryHookResult = ReturnType<typeof useSocialNetworksEventsSuspenseQuery>;
export type SocialNetworksEventsQueryResult = Apollo.QueryResult<SocialNetworksEventsQuery, SocialNetworksEventsQueryVariables>;
export const EventsItemDocument = gql`
    query EventsItem($eventsItemId: ID!) {
  eventsItem(id: $eventsItemId) {
    id
    eventItemTitle
    startDate
    multimediaType
    longitude
    latitude
    image {
      id
      downloadUrl
    }
    hasShare
    eventStatus
    endDate
    eventItemDescription
    eventItemTags
    address
    summary
    linkItem {
      id
      url
    }
    phoneEvent
    emailEvent
    groupEvent
    paymentTypeEvent
    dynamicView
    seo {
      id
      createdAt
      updatedAt
      deletedAt
      metadata {
        id
        createdAt
        updatedAt
        deletedAt
        metaTitle
        metaDescription
        slug
        language
      }
    }
  }
}
    `;

/**
 * __useEventsItemQuery__
 *
 * To run a query within a React component, call `useEventsItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsItemQuery({
 *   variables: {
 *      eventsItemId: // value for 'eventsItemId'
 *   },
 * });
 */
export function useEventsItemQuery(baseOptions: Apollo.QueryHookOptions<EventsItemQuery, EventsItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsItemQuery, EventsItemQueryVariables>(EventsItemDocument, options);
      }
export function useEventsItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsItemQuery, EventsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsItemQuery, EventsItemQueryVariables>(EventsItemDocument, options);
        }
export function useEventsItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsItemQuery, EventsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsItemQuery, EventsItemQueryVariables>(EventsItemDocument, options);
        }
export type EventsItemQueryHookResult = ReturnType<typeof useEventsItemQuery>;
export type EventsItemLazyQueryHookResult = ReturnType<typeof useEventsItemLazyQuery>;
export type EventsItemSuspenseQueryHookResult = ReturnType<typeof useEventsItemSuspenseQuery>;
export type EventsItemQueryResult = Apollo.QueryResult<EventsItemQuery, EventsItemQueryVariables>;
export const HomeSkeletonDocument = gql`
    query HomeSkeleton {
  mainPage {
    ... on PageMapBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageEventSliderBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageEventsBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageNewsletterBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageRegulationsBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageProceduresBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageSliderBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageSnsBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageTaxesBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageCabinetBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageQuickAccessBar {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      isCarrousel
      itemsPerView
      color
      items {
        id
        orderIndex
        __typename
      }
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageCustomBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
    ... on PageAlertsBlock {
      id
      isDisabled
      orderIndex
      pageBlockStyle
      __typename
    }
  }
}
    `;

/**
 * __useHomeSkeletonQuery__
 *
 * To run a query within a React component, call `useHomeSkeletonQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeSkeletonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeSkeletonQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeSkeletonQuery(baseOptions?: Apollo.QueryHookOptions<HomeSkeletonQuery, HomeSkeletonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeSkeletonQuery, HomeSkeletonQueryVariables>(HomeSkeletonDocument, options);
      }
export function useHomeSkeletonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeSkeletonQuery, HomeSkeletonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeSkeletonQuery, HomeSkeletonQueryVariables>(HomeSkeletonDocument, options);
        }
export function useHomeSkeletonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeSkeletonQuery, HomeSkeletonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeSkeletonQuery, HomeSkeletonQueryVariables>(HomeSkeletonDocument, options);
        }
export type HomeSkeletonQueryHookResult = ReturnType<typeof useHomeSkeletonQuery>;
export type HomeSkeletonLazyQueryHookResult = ReturnType<typeof useHomeSkeletonLazyQuery>;
export type HomeSkeletonSuspenseQueryHookResult = ReturnType<typeof useHomeSkeletonSuspenseQuery>;
export type HomeSkeletonQueryResult = Apollo.QueryResult<HomeSkeletonQuery, HomeSkeletonQueryVariables>;
export const HomeDocument = gql`
    query Home {
  mainPage {
    ... on PageMapBlock {
      id
      mapType
      geoJsonData
      elementsConfig
      departmentCode
      height
      initialZoom
      centerCoordinates
      defaultFillColor
      defaultBorderColor
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      type
      __typename
    }
    ... on PageEventSliderBlock {
      id
      orderIndex
      isDisabled
      description
      publicDescription
      showTitle
      showDescription
      canBeDisabled
      createdAt
      updatedAt
      deletedAt
      type
      __typename
      items {
        id
        createdAt
        updatedAt
        deletedAt
        itemDescription: description
        orderIndex
        title
        seeMoreAction
        seeMoreLink
      }
    }
    ... on PageEventsBlock {
      id
      eventTitle
      eventDescription
      showTitle
      showDescription
      pageBlockStyle
      isDisabled
    }
    ... on PageNewsletterBlock {
      id
      newsletterTitle
      newsletterDescription
      showTitle
      showDescription
      pageBlockStyle
      isDisabled
    }
    ... on PageRegulationsBlock {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      regulations {
        linkItem {
          id
          url
          target
          createdAt
          createdAt
          routeType
          routeNavigation
          arguments
          updatedAt
          dynamicPageSlugs {
            id
            slug
          }
        }
        id
        date
        title
        description
        file {
          id
          url
        }
      }
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleProcedures
      descriptionProcedures
      seeMoreAction
      seeMoreActionLink
      procedures {
        govcoLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
        procedureTypes
        gocvoLogoName
        createdAt
        procedureItemTags
        id
        name
        tagsProcedure
        cost
        duration
        modality
        date
        action
        actionLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
      }
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      sliders {
        id
        title
        orderIndex
        description
        link
        tags
        image {
          id
          url
          fileName
          fileMongoId
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
      }
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        snsTitle
        snsSocialNetworkType
        itemLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
      }
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      taxSectionTitle
      items {
        id
        orderIndex
        taxTitle
        image {
          downloadUrl
          id
          url
        }
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
      }
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
    }
    ... on PageCabinetBlock {
      id
      description
      cabinetTitle
      cabinetSubtitle
      description
      publicDescription
      showTitle
      showDescription
      pageBlockStyle
      items {
        curriculumVitaeLink
        id
        orderIndex
        cabinetDescription
        cabinetDetails {
          id
          cabinetDetailImage {
            downloadUrl
            id
            createdAt
            updatedAt
            deletedAt
            fileName
            fileExtension
            fileMode
            fileMongoId
            url
          }
          cabinetDetailLink {
            id
            routeType
            url
            routeNavigation
            target
            dynamicPageSlugs {
              id
              slug
            }
          }
        }
        cabinetImage {
          url
          updatedAt
          id
          fileName
          downloadUrl
          fileMongoId
          fileMode
          fileExtension
          deletedAt
          createdAt
        }
        createdAt
        cabinetName
        cabinetPosition {
          name
        }
        linkItem {
          id
          routeType
          routeNavigation
          target
          url
          arguments
        }
      }
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      isCarrousel
      itemsPerView
      color
      items {
        id
        orderIndex
        description
        image {
          downloadUrl
          id
          url
          __typename
        }
        quickAccessName
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
      }
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      title
      seeMoreLink
      leftItems {
        id
        orderIndex
        image {
          id
        }
      }
      rightItems {
        id
        orderIndex
        socialNetworkType
        link
        linkItem {
          id
          url
          routeType
          routeNavigation
          target
          arguments
          dynamicPageSlugs {
            id
            slug
          }
        }
      }
    }
    ... on PageCustomBlock {
      id
      canBeDisabled
      blockTitle
      publicDescription
      showTitle
      showDescription
      content
      createdAt
      deletedAt
      isDisabled
      description
      location
      orderIndex
      pageBlockStyle
      subPages
      type
      updatedAt
    }
    ... on PageAlertsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      alertTitle: title
      blockTitle
      description
      alertDescription
      publicDescription
      showTitle
      showDescription
      alertStyle
      buttonTitle
      actionType
      displayFrequency
      orderIndex
      htmlTemplate
      modalSizeUnit
      modalWidth
      modalHeight
      canBeDisabled
      isDisabled
      type
      image {
        id
        url
        fileName
        downloadUrl
        fileExtension
      }
      linkItem {
        id
        arguments
        routeType
        routeNavigation
        target
        url
        dynamicPageSlugs {
          id
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeQuery(baseOptions?: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
      }
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export function useHomeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeSuspenseQueryHookResult = ReturnType<typeof useHomeSuspenseQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
export const ItemsInstitutionalProgramDocument = gql`
    query ItemsInstitutionalProgram($locations: [BlockLocation!]!, $subPage: SubPages) {
  subPageBlocks(locations: $locations, subPage: $subPage) {
    ... on PageInstitutionalProgramsTypesBlock {
      id
      items {
        id
        createdAt
        updatedAt
        deletedAt
        title
        description
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        alternativeText
        programsType
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    __typename
    ... on PageTransparencyBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      hasLinkVideo
      transparencyContent
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      global
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCabinetBlock {
      isCarrousel
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      pagePressroomBlockTitle: title
      subtitle
      hasSearchbar
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      global
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      seeMoreAction
      seeMoreLink
    }
  }
}
    `;

/**
 * __useItemsInstitutionalProgramQuery__
 *
 * To run a query within a React component, call `useItemsInstitutionalProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsInstitutionalProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsInstitutionalProgramQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function useItemsInstitutionalProgramQuery(baseOptions: Apollo.QueryHookOptions<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>(ItemsInstitutionalProgramDocument, options);
      }
export function useItemsInstitutionalProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>(ItemsInstitutionalProgramDocument, options);
        }
export function useItemsInstitutionalProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>(ItemsInstitutionalProgramDocument, options);
        }
export type ItemsInstitutionalProgramQueryHookResult = ReturnType<typeof useItemsInstitutionalProgramQuery>;
export type ItemsInstitutionalProgramLazyQueryHookResult = ReturnType<typeof useItemsInstitutionalProgramLazyQuery>;
export type ItemsInstitutionalProgramSuspenseQueryHookResult = ReturnType<typeof useItemsInstitutionalProgramSuspenseQuery>;
export type ItemsInstitutionalProgramQueryResult = Apollo.QueryResult<ItemsInstitutionalProgramQuery, ItemsInstitutionalProgramQueryVariables>;
export const PageInstitutionalProgramsSliderBlockDocument = gql`
    query PageInstitutionalProgramsSliderBlock($locations: [BlockLocation!]!, $subPage: SubPages) {
  subPageBlocks(locations: $locations, subPage: $subPage) {
    ... on PageInstitutionalProgramsSliderBlock {
      id
      pageBlockStyle
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
        }
        title
        alternativeText
        tags
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        seeMoreAction
        seeMoreLink
      }
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
  }
}
    `;

/**
 * __usePageInstitutionalProgramsSliderBlockQuery__
 *
 * To run a query within a React component, call `usePageInstitutionalProgramsSliderBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInstitutionalProgramsSliderBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInstitutionalProgramsSliderBlockQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function usePageInstitutionalProgramsSliderBlockQuery(baseOptions: Apollo.QueryHookOptions<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>(PageInstitutionalProgramsSliderBlockDocument, options);
      }
export function usePageInstitutionalProgramsSliderBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>(PageInstitutionalProgramsSliderBlockDocument, options);
        }
export function usePageInstitutionalProgramsSliderBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>(PageInstitutionalProgramsSliderBlockDocument, options);
        }
export type PageInstitutionalProgramsSliderBlockQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockQuery>;
export type PageInstitutionalProgramsSliderBlockLazyQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockLazyQuery>;
export type PageInstitutionalProgramsSliderBlockSuspenseQueryHookResult = ReturnType<typeof usePageInstitutionalProgramsSliderBlockSuspenseQuery>;
export type PageInstitutionalProgramsSliderBlockQueryResult = Apollo.QueryResult<PageInstitutionalProgramsSliderBlockQuery, PageInstitutionalProgramsSliderBlockQueryVariables>;
export const SigninDocument = gql`
    mutation Signin($signinInput: SigninInput!) {
  signin(signinInput: $signinInput) {
    token
    user {
      id
      createdAt
      updatedAt
      deletedAt
      name
      middleName
      lastName
      secondSurname
      email
      identificationType
      identificationNumber
      dateIssue
      legalRepresentativeIdentificationType
      legalRepresentativeIdentificationNumber
      phoneCountryCode
      phoneNumber
      address
      hasRural
      status
      phoneVerification
      emailVerification
      type
      fullName
      hasExpiredCredentials
      temporalPassword
    }
  }
}
    `;
export type SigninMutationFn = Apollo.MutationFunction<SigninMutation, SigninMutationVariables>;

/**
 * __useSigninMutation__
 *
 * To run a mutation, you first call `useSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinMutation, { data, loading, error }] = useSigninMutation({
 *   variables: {
 *      signinInput: // value for 'signinInput'
 *   },
 * });
 */
export function useSigninMutation(baseOptions?: Apollo.MutationHookOptions<SigninMutation, SigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument, options);
      }
export type SigninMutationHookResult = ReturnType<typeof useSigninMutation>;
export type SigninMutationResult = Apollo.MutationResult<SigninMutation>;
export type SigninMutationOptions = Apollo.BaseMutationOptions<SigninMutation, SigninMutationVariables>;
export const GetNavigationBarMicroSiteDocument = gql`
    query GetNavigationBarMicroSite($dynamicId: ID, $slug: String) {
  getNavigationBarMicroSite: mainPageDynamic(dynamicId: $dynamicId, slug: $slug) {
    ... on PageNavigationBar {
      id
      orderIndex
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      location
      pageBlockStyle
      subPages
      rootItem {
        id
        name
        linkItem {
          id
          arguments
          routeType
          routeNavigation
          target
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        children {
          orderIndex
          id
          name
          link
          linkItem {
            id
            arguments
            routeType
            routeNavigation
            target
            url
            dynamicPageSlugs {
              id
              slug
            }
            __typename
          }
          children {
            id
            orderIndex
            name
            link
            linkItem {
              id
              arguments
              routeType
              routeNavigation
              target
              url
              dynamicPageSlugs {
                id
                slug
              }
              __typename
            }
            children {
              id
              orderIndex
              name
              link
              linkItem {
                id
                arguments
                routeType
                routeNavigation
                target
                url
                dynamicPageSlugs {
                  id
                  slug
                }
                __typename
              }
              children {
                id
                orderIndex
                name
                link
                linkItem {
                  id
                  arguments
                  routeType
                  routeNavigation
                  target
                  url
                  dynamicPageSlugs {
                    id
                    slug
                  }
                  __typename
                }
                __typename
                icon {
                  id
                  createdAt
                  updatedAt
                  deletedAt
                  fileName
                  fileExtension
                  fileMode
                  fileMongoId
                  downloadUrl
                  url
                }
              }
              __typename
              createdAt
              updatedAt
              deletedAt
              description
              type
              icon {
                id
                createdAt
                updatedAt
                deletedAt
                fileName
                fileExtension
                fileMode
                fileMongoId
                downloadUrl
                url
              }
            }
            __typename
            icon {
              id
              createdAt
              updatedAt
              deletedAt
              fileName
              fileExtension
              fileMode
              fileMongoId
              downloadUrl
              url
            }
          }
          __typename
          icon {
            id
            createdAt
            updatedAt
            deletedAt
            fileName
            fileExtension
            fileMode
            fileMongoId
            downloadUrl
            url
          }
        }
        __typename
        icon {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetNavigationBarMicroSiteQuery__
 *
 * To run a query within a React component, call `useGetNavigationBarMicroSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationBarMicroSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationBarMicroSiteQuery({
 *   variables: {
 *      dynamicId: // value for 'dynamicId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetNavigationBarMicroSiteQuery(baseOptions?: Apollo.QueryHookOptions<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>(GetNavigationBarMicroSiteDocument, options);
      }
export function useGetNavigationBarMicroSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>(GetNavigationBarMicroSiteDocument, options);
        }
export function useGetNavigationBarMicroSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>(GetNavigationBarMicroSiteDocument, options);
        }
export type GetNavigationBarMicroSiteQueryHookResult = ReturnType<typeof useGetNavigationBarMicroSiteQuery>;
export type GetNavigationBarMicroSiteLazyQueryHookResult = ReturnType<typeof useGetNavigationBarMicroSiteLazyQuery>;
export type GetNavigationBarMicroSiteSuspenseQueryHookResult = ReturnType<typeof useGetNavigationBarMicroSiteSuspenseQuery>;
export type GetNavigationBarMicroSiteQueryResult = Apollo.QueryResult<GetNavigationBarMicroSiteQuery, GetNavigationBarMicroSiteQueryVariables>;
export const PageEventsBlockPageDynamicDocument = gql`
    query PageEventsBlockPageDynamic($dynamicId: ID, $slug: String) {
  mainPageDynamic(dynamicId: $dynamicId, slug: $slug) {
    ... on PageMapBlock {
      id
      mapType
      geoJsonData
      elementsConfig
      departmentCode
      height
      initialZoom
      centerCoordinates
      defaultFillColor
      defaultBorderColor
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      type
      __typename
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      eventTitle
      eventDescription
      publicDescription
      showTitle
      showDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      includeSharedContent
      hasDependencyFilter
      contentSchema {
        id
      }
      linkItem {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      events {
        id
        createdAt
        updatedAt
        deletedAt
        eventItemTitle
        eventItemDescription
        summary
        seeMore
        link
        address
        latitude
        longitude
        descriptionPlace
        typeEvent
        hasRecurring
        hasShare
        shareLink
        startDate
        endDate
        eventStatus
        alternativeText
        multimediaType
        eventItemTags
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        shareIcon {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      includeSharedContent
      hasDependencyFilter
      contentSchema {
        id
        __typename
      }
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      regulations {
        id
        createdAt
        updatedAt
        deletedAt
        title
        description
        date
        downloadText
        documentDate
        regulationStatus
        pageLinkDocument {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        file {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageProceduresBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleProcedures
      descriptionProcedures
      publicDescription
      showTitle
      showDescription
      seetMoreActionProcedures: seeMoreAction
      seeMoreActionLink
      procedures {
        govcoLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        procedureTypes
        gocvoLogoName
        createdAt
        procedureItemTags
        id
        name
        cost
        duration
        modality
        date
        action
        actionLink
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      sliders {
        id
        createdAt
        updatedAt
        deletedAt
        title
        orderIndex
        alternativeText
        tags
        link
        description
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        snsTitle
        snsSocialNetworkType
        itemLink {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageTaxesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      taxSectionTitle
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        link
        taxTitle
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageTransparencyBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageCabinetBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      extendedDescription
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      isCarrousel
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        cabinetName
        cabinetDescription
        cabinetPhone
        cabinetEmail
        alternativeText
        curriculumVitaeLink
        cabinetImage {
          id
          createdAt
          downloadUrl
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        cabinetPosition {
          id
          createdAt
          updatedAt
          deletedAt
          name
          __typename
        }
        cabinetDetails {
          id
          createdAt
          updatedAt
          deletedAt
          cabinetDetailName
          cabinetDetailStatus
          cabinetDetailLink {
            id
            createdAt
            updatedAt
            deletedAt
            routeType
            routeNavigation
            target
            arguments
            url
            __typename
          }
          cabinetDetailImage {
            id
            createdAt
            updatedAt
            deletedAt
            fileName
            fileExtension
            fileMode
            fileMongoId
            url
            __typename
          }
          __typename
        }
        __typename
      }
      type
      __typename
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleSocialNetworks: title
      seeMoreAction
      seeMoreLink
      leftItems {
        id
        createdAt
        updatedAt
        deletedAt
        orderIndex
        description
        alternativeText
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      rightItems {
        id
        createdAt
        updatedAt
        deletedAt
        orderIndex
        socialNetworkType
        description
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageAttentionLinesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titleAttentionLines: title
      __typename
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      titlePressroom: title
      subtitlePressRoom: subtitle
      hasSearchbarPressRoom: hasSearchbar
      __typename
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      isCarrousel
      itemsPerView
      color
      items {
        id
        orderIndex
        image {
          downloadUrl
          id
          url
          __typename
        }
        quickAccessName
        description
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageHeaderBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      hasSearchbarHeaderBar: hasSearchbar
      placeholder
      hasLanguageIcon
      hasGovcoLogo
      hasSignin
      hasSignup
      signinName
      signupName
      __typename
    }
    ... on PageAuthenticationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageNavigationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageHeaderOrganizationBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleHeaderOrganizationBar: title
      subtitleHeaderOrganizationBar: subtitle
      __typename
    }
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showViewButton
      showDownloadButton
      filterDependencyIds
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        index
        indexTitle
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
        configJson
        schema {
          id
          createdAt
          updatedAt
          deletedAt
          name
          description
          contentType
          isActive
          fields {
            id
            createdAt
            updatedAt
            deletedAt
            fieldName
            fieldLabel
            fieldType
            isRequired
            orderIndex
            options
            validationRules
            defaultValue
            isActive
            isGroup
            __typename
          }
          __typename
        }
        subtype
      }
      __typename
      subtype
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        participateElementTitle
        participateLinkAction {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        participateElementImage {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      dynamic {
        id
        createdAt
        updatedAt
        deletedAt
        name
        status
        __typename
      }
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      publicDescription
      showTitle
      showDescription
      subDownloadPlaceholder
      subDownloadSearchbar
      items {
        id
        createdAt
        file {
          url
          fileMongoId
          fileMode
          fileExtension
          fileName
          deletedAt
          updatedAt
          createdAt
          id
          __typename
        }
        name
        description
        orderIndex
        updatedAt
        deletedAt
        __typename
      }
      __typename
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageFooterBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      subtitle
      campusData
      administrationLogoLink
      adminOtherLogoLink
      logoLink
      html
      __typename
    }
    ... on PageCorporateLogosBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageAccessibilityBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      __typename
    }
    ... on PageCustomBlock {
      id
      blockTitle
      publicDescription
      showTitle
      showDescription
      content
      isDisabled
      orderIndex
      __typename
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      __typename
    }
    ... on PageAlertsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      alertTitle: title
      blockTitle
      description
      alertDescription
      publicDescription
      showTitle
      showDescription
      alertStyle
      buttonTitle
      actionType
      displayFrequency
      htmlTemplate
      canBeDisabled
      isDisabled
      type
      image {
        id
        url
        fileName
        downloadUrl
        fileExtension
        __typename
      }
      linkItem {
        id
        arguments
        routeType
        routeNavigation
        target
        url
        __typename
      }
      __typename
    }
    ... on PageStyledTableBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      extendedDescription
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      contentType
      tableStyle
      itemsPerPage
      externalEndpoint
      contentSchema {
        id
        fields {
          id
          fieldName
          orderIndex
          __typename
        }
        __typename
      }
      rows {
        id
        orderIndex
        cellData {
          id
          value
          column {
            id
            __typename
          }
          __typename
        }
        __typename
      }
      columns {
        id
        allowFilter
        allowSort
        columnName
        columnWidth
        dataType
        orderIndex
        description
        configJson
        mappedField {
          id
          orderIndex
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __usePageEventsBlockPageDynamicQuery__
 *
 * To run a query within a React component, call `usePageEventsBlockPageDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageEventsBlockPageDynamicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageEventsBlockPageDynamicQuery({
 *   variables: {
 *      dynamicId: // value for 'dynamicId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePageEventsBlockPageDynamicQuery(baseOptions?: Apollo.QueryHookOptions<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>(PageEventsBlockPageDynamicDocument, options);
      }
export function usePageEventsBlockPageDynamicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>(PageEventsBlockPageDynamicDocument, options);
        }
export function usePageEventsBlockPageDynamicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>(PageEventsBlockPageDynamicDocument, options);
        }
export type PageEventsBlockPageDynamicQueryHookResult = ReturnType<typeof usePageEventsBlockPageDynamicQuery>;
export type PageEventsBlockPageDynamicLazyQueryHookResult = ReturnType<typeof usePageEventsBlockPageDynamicLazyQuery>;
export type PageEventsBlockPageDynamicSuspenseQueryHookResult = ReturnType<typeof usePageEventsBlockPageDynamicSuspenseQuery>;
export type PageEventsBlockPageDynamicQueryResult = Apollo.QueryResult<PageEventsBlockPageDynamicQuery, PageEventsBlockPageDynamicQueryVariables>;
export const PageParticipateBlockDocument = gql`
    query PageParticipateBlock($locations: [BlockLocation!]!, $subPage: SubPages) {
  subPageBlocks(locations: $locations, subPage: $subPage) {
    ... on PageAlertsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      title
      blockTitle
      description
      alertDescription
      publicDescription
      showTitle
      showDescription
      alertStyle
      buttonTitle
      actionType
      displayFrequency
      orderIndex
      htmlTemplate
      modalSizeUnit
      modalWidth
      modalHeight
      canBeDisabled
      isDisabled
      type
      image {
        id
        url
        fileName
        downloadUrl
        fileExtension
      }
      linkItem {
        id
        arguments
        routeType
        routeNavigation
        target
        url
        dynamicPageSlugs {
          id
          slug
        }
      }
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      seeMoreTitle
      seeMoreLink
      isCarrousel
      itemsPerView
      color
      items {
        id
        orderIndex
        description
        image {
          downloadUrl
          id
          url
          __typename
        }
        quickAccessName
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
      }
    }
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showViewButton
      showDownloadButton
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        index
        indexTitle
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
        configJson
        schema {
          id
          createdAt
          updatedAt
          deletedAt
          name
          description
          contentType
          isActive
          fields {
            id
            createdAt
            updatedAt
            deletedAt
            fieldName
            fieldLabel
            fieldType
            isRequired
            orderIndex
            options
            validationRules
            defaultValue
            isActive
            isGroup
            __typename
          }
          __typename
        }
        subtype
      }
      __typename
      subtype
    }
    ... on PageParticipateElementBlock {
      id
      description
      pageBlockStyle
      orderIndex
      isDisabled
      items {
        id
        orderIndex
        description
        participateElementTitle
        participateElementImage {
          fileExtension
          fileMode
          id
          fileName
          fileMongoId
          url
        }
        participateLinkAction {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
      }
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageParticipateDownloadBlock {
      id
      orderIndex
      description
      isDisabled
      pageBlockStyle
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
  }
}
    `;

/**
 * __usePageParticipateBlockQuery__
 *
 * To run a query within a React component, call `usePageParticipateBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageParticipateBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageParticipateBlockQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function usePageParticipateBlockQuery(baseOptions: Apollo.QueryHookOptions<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>(PageParticipateBlockDocument, options);
      }
export function usePageParticipateBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>(PageParticipateBlockDocument, options);
        }
export function usePageParticipateBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>(PageParticipateBlockDocument, options);
        }
export type PageParticipateBlockQueryHookResult = ReturnType<typeof usePageParticipateBlockQuery>;
export type PageParticipateBlockLazyQueryHookResult = ReturnType<typeof usePageParticipateBlockLazyQuery>;
export type PageParticipateBlockSuspenseQueryHookResult = ReturnType<typeof usePageParticipateBlockSuspenseQuery>;
export type PageParticipateBlockQueryResult = Apollo.QueryResult<PageParticipateBlockQuery, PageParticipateBlockQueryVariables>;
export const RegulationsParticipateDocument = gql`
    query RegulationsParticipate($orderBy: [FindRegulationsOrderBy!], $where: FindRegulationsWhere, $pagination: Pagination, $types: [RegulationType!]!) {
  regulations(orderBy: $orderBy, where: $where, pagination: $pagination, types: $types) {
    id
    date
    documentDate
    downloadText
    description
    title
    image {
      id
      url
    }
    linkItem {
      id
      url
      routeType
      routeNavigation
      target
      dynamicPageSlugs {
        id
        slug
      }
    }
  }
  regulationsCount(pagination: $pagination, orderBy: $orderBy, where: $where, types: $types) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useRegulationsParticipateQuery__
 *
 * To run a query within a React component, call `useRegulationsParticipateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationsParticipateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationsParticipateQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useRegulationsParticipateQuery(baseOptions: Apollo.QueryHookOptions<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>(RegulationsParticipateDocument, options);
      }
export function useRegulationsParticipateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>(RegulationsParticipateDocument, options);
        }
export function useRegulationsParticipateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>(RegulationsParticipateDocument, options);
        }
export type RegulationsParticipateQueryHookResult = ReturnType<typeof useRegulationsParticipateQuery>;
export type RegulationsParticipateLazyQueryHookResult = ReturnType<typeof useRegulationsParticipateLazyQuery>;
export type RegulationsParticipateSuspenseQueryHookResult = ReturnType<typeof useRegulationsParticipateSuspenseQuery>;
export type RegulationsParticipateQueryResult = Apollo.QueryResult<RegulationsParticipateQuery, RegulationsParticipateQueryVariables>;
export const SubPageProceduresBlockDocument = gql`
    query SubPageProceduresBlock {
  subpageprocedure {
    ... on PageTransparencyBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      hasLinkVideo
      transparencyContent
    }
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      global
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCabinetBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      publicDescription
      showTitle
      showDescription
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      pagePressroomBlockTitle: title
      subtitle
      hasSearchbar
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      global
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      title
      seeMoreAction
      seeMoreLink
    }
    ... on PageQuickAccessBar {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      blockTitle
      seeMoreTitle
      seeMoreLink
    }
  }
}
    `;

/**
 * __useSubPageProceduresBlockQuery__
 *
 * To run a query within a React component, call `useSubPageProceduresBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubPageProceduresBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubPageProceduresBlockQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubPageProceduresBlockQuery(baseOptions?: Apollo.QueryHookOptions<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>(SubPageProceduresBlockDocument, options);
      }
export function useSubPageProceduresBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>(SubPageProceduresBlockDocument, options);
        }
export function useSubPageProceduresBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>(SubPageProceduresBlockDocument, options);
        }
export type SubPageProceduresBlockQueryHookResult = ReturnType<typeof useSubPageProceduresBlockQuery>;
export type SubPageProceduresBlockLazyQueryHookResult = ReturnType<typeof useSubPageProceduresBlockLazyQuery>;
export type SubPageProceduresBlockSuspenseQueryHookResult = ReturnType<typeof useSubPageProceduresBlockSuspenseQuery>;
export type SubPageProceduresBlockQueryResult = Apollo.QueryResult<SubPageProceduresBlockQuery, SubPageProceduresBlockQueryVariables>;
export const RegulationGroupedCountsDocument = gql`
    query RegulationGroupedCounts($args: RegulationAggregationArgs!) {
  regulationGroupedCounts(args: $args) {
    groupKey
    groupLabel
    count
  }
}
    `;

/**
 * __useRegulationGroupedCountsQuery__
 *
 * To run a query within a React component, call `useRegulationGroupedCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationGroupedCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationGroupedCountsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useRegulationGroupedCountsQuery(baseOptions: Apollo.QueryHookOptions<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>(RegulationGroupedCountsDocument, options);
      }
export function useRegulationGroupedCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>(RegulationGroupedCountsDocument, options);
        }
export function useRegulationGroupedCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>(RegulationGroupedCountsDocument, options);
        }
export type RegulationGroupedCountsQueryHookResult = ReturnType<typeof useRegulationGroupedCountsQuery>;
export type RegulationGroupedCountsLazyQueryHookResult = ReturnType<typeof useRegulationGroupedCountsLazyQuery>;
export type RegulationGroupedCountsSuspenseQueryHookResult = ReturnType<typeof useRegulationGroupedCountsSuspenseQuery>;
export type RegulationGroupedCountsQueryResult = Apollo.QueryResult<RegulationGroupedCountsQuery, RegulationGroupedCountsQueryVariables>;
export const RegulationsDocument = gql`
    query Regulations($types: [RegulationType!]!, $year: Int, $month: Int, $pagination: Pagination, $where: FindRegulationsWhere, $orderBy: [FindRegulationsOrderBy!], $parentId: ID, $dependency: StringFilter) {
  regulations(types: $types, year: $year, month: $month, pagination: $pagination, where: $where, orderBy: $orderBy, parentId: $parentId, dependency: $dependency) {
    id
    title
    description
    publishDate
    documentDate
    createdAt
    regulationStatus
    linkItem {
      url
    }
    file {
      id
      createdAt
      updatedAt
      deletedAt
      fileName
      fileExtension
      fileMode
      fileMongoId
    }
  }
  regulationsCount(types: $types, year: $year, month: $month, pagination: $pagination, where: $where, orderBy: $orderBy, parentId: $parentId, dependency: $dependency) {
    totalItems
    itemsPerPage
    totalPages
    currentPage
  }
}
    `;

/**
 * __useRegulationsQuery__
 *
 * To run a query within a React component, call `useRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationsQuery({
 *   variables: {
 *      types: // value for 'types'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      parentId: // value for 'parentId'
 *      dependency: // value for 'dependency'
 *   },
 * });
 */
export function useRegulationsQuery(baseOptions: Apollo.QueryHookOptions<RegulationsQuery, RegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationsQuery, RegulationsQueryVariables>(RegulationsDocument, options);
      }
export function useRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationsQuery, RegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationsQuery, RegulationsQueryVariables>(RegulationsDocument, options);
        }
export function useRegulationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationsQuery, RegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationsQuery, RegulationsQueryVariables>(RegulationsDocument, options);
        }
export type RegulationsQueryHookResult = ReturnType<typeof useRegulationsQuery>;
export type RegulationsLazyQueryHookResult = ReturnType<typeof useRegulationsLazyQuery>;
export type RegulationsSuspenseQueryHookResult = ReturnType<typeof useRegulationsSuspenseQuery>;
export type RegulationsQueryResult = Apollo.QueryResult<RegulationsQuery, RegulationsQueryVariables>;
export const RegulationMonthsDocument = gql`
    query RegulationMonths($args: FindRegulationYearsArgs) {
  regulationMonths(args: $args) {
    month
    count
  }
}
    `;

/**
 * __useRegulationMonthsQuery__
 *
 * To run a query within a React component, call `useRegulationMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationMonthsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useRegulationMonthsQuery(baseOptions?: Apollo.QueryHookOptions<RegulationMonthsQuery, RegulationMonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationMonthsQuery, RegulationMonthsQueryVariables>(RegulationMonthsDocument, options);
      }
export function useRegulationMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationMonthsQuery, RegulationMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationMonthsQuery, RegulationMonthsQueryVariables>(RegulationMonthsDocument, options);
        }
export function useRegulationMonthsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationMonthsQuery, RegulationMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationMonthsQuery, RegulationMonthsQueryVariables>(RegulationMonthsDocument, options);
        }
export type RegulationMonthsQueryHookResult = ReturnType<typeof useRegulationMonthsQuery>;
export type RegulationMonthsLazyQueryHookResult = ReturnType<typeof useRegulationMonthsLazyQuery>;
export type RegulationMonthsSuspenseQueryHookResult = ReturnType<typeof useRegulationMonthsSuspenseQuery>;
export type RegulationMonthsQueryResult = Apollo.QueryResult<RegulationMonthsQuery, RegulationMonthsQueryVariables>;
export const RegulationYearsDocument = gql`
    query RegulationYears($args: FindRegulationYearsArgs) {
  regulationYears(args: $args) {
    year
    count
  }
}
    `;

/**
 * __useRegulationYearsQuery__
 *
 * To run a query within a React component, call `useRegulationYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationYearsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useRegulationYearsQuery(baseOptions?: Apollo.QueryHookOptions<RegulationYearsQuery, RegulationYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationYearsQuery, RegulationYearsQueryVariables>(RegulationYearsDocument, options);
      }
export function useRegulationYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationYearsQuery, RegulationYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationYearsQuery, RegulationYearsQueryVariables>(RegulationYearsDocument, options);
        }
export function useRegulationYearsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationYearsQuery, RegulationYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationYearsQuery, RegulationYearsQueryVariables>(RegulationYearsDocument, options);
        }
export type RegulationYearsQueryHookResult = ReturnType<typeof useRegulationYearsQuery>;
export type RegulationYearsLazyQueryHookResult = ReturnType<typeof useRegulationYearsLazyQuery>;
export type RegulationYearsSuspenseQueryHookResult = ReturnType<typeof useRegulationYearsSuspenseQuery>;
export type RegulationYearsQueryResult = Apollo.QueryResult<RegulationYearsQuery, RegulationYearsQueryVariables>;
export const PageRegulationsRegulationsBlockDocument = gql`
    query PageRegulationsRegulationsBlock($locations: [BlockLocation!]!, $subPage: SubPages) {
  subPageBlocks(locations: $locations, subPage: $subPage) {
    ... on PageParticipateElementBlock {
      id
      description
      pageBlockStyle
      orderIndex
      isDisabled
      items {
        id
        orderIndex
        description
        participateElementTitle
        participateElementImage {
          fileExtension
          fileMode
          id
          fileName
          fileMongoId
          url
          __typename
        }
        participateLinkAction {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageParticipateDownloadBlock {
      id
      orderIndex
      description
      isDisabled
      pageBlockStyle
      __typename
    }
    __typename
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
      __typename
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        itemName
        itemDescription
        itemType
        itemIcon {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
      regulations {
        id
        createdAt
        updatedAt
        deletedAt
        title
        description
        date
        downloadText
        documentDate
        type
        regulationStatus
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        pageLinkDocument {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
        image {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
        file {
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          downloadUrl
          url
        }
      }
    }
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtype
      showViewButton
      showDownloadButton
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        index
        indexTitle
        subtype
        configJson
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
        }
      }
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
  }
}
    `;

/**
 * __usePageRegulationsRegulationsBlockQuery__
 *
 * To run a query within a React component, call `usePageRegulationsRegulationsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageRegulationsRegulationsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageRegulationsRegulationsBlockQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function usePageRegulationsRegulationsBlockQuery(baseOptions: Apollo.QueryHookOptions<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>(PageRegulationsRegulationsBlockDocument, options);
      }
export function usePageRegulationsRegulationsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>(PageRegulationsRegulationsBlockDocument, options);
        }
export function usePageRegulationsRegulationsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>(PageRegulationsRegulationsBlockDocument, options);
        }
export type PageRegulationsRegulationsBlockQueryHookResult = ReturnType<typeof usePageRegulationsRegulationsBlockQuery>;
export type PageRegulationsRegulationsBlockLazyQueryHookResult = ReturnType<typeof usePageRegulationsRegulationsBlockLazyQuery>;
export type PageRegulationsRegulationsBlockSuspenseQueryHookResult = ReturnType<typeof usePageRegulationsRegulationsBlockSuspenseQuery>;
export type PageRegulationsRegulationsBlockQueryResult = Apollo.QueryResult<PageRegulationsRegulationsBlockQuery, PageRegulationsRegulationsBlockQueryVariables>;
export const RegulationsRegulationsDocument = gql`
    query RegulationsRegulations($orderBy: [FindRegulationsOrderBy!], $where: FindRegulationsWhere, $pagination: Pagination, $types: [RegulationType!]!) {
  regulations(orderBy: $orderBy, where: $where, pagination: $pagination, types: $types) {
    id
    date
    documentDate
    downloadText
    description
    title
    image {
      id
      url
    }
    linkItem {
      id
      url
      routeType
      routeNavigation
      target
    }
  }
  regulationsCount(pagination: $pagination, orderBy: $orderBy, where: $where, types: $types) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __useRegulationsRegulationsQuery__
 *
 * To run a query within a React component, call `useRegulationsRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationsRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationsRegulationsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *      pagination: // value for 'pagination'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useRegulationsRegulationsQuery(baseOptions: Apollo.QueryHookOptions<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>(RegulationsRegulationsDocument, options);
      }
export function useRegulationsRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>(RegulationsRegulationsDocument, options);
        }
export function useRegulationsRegulationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>(RegulationsRegulationsDocument, options);
        }
export type RegulationsRegulationsQueryHookResult = ReturnType<typeof useRegulationsRegulationsQuery>;
export type RegulationsRegulationsLazyQueryHookResult = ReturnType<typeof useRegulationsRegulationsLazyQuery>;
export type RegulationsRegulationsSuspenseQueryHookResult = ReturnType<typeof useRegulationsRegulationsSuspenseQuery>;
export type RegulationsRegulationsQueryResult = Apollo.QueryResult<RegulationsRegulationsQuery, RegulationsRegulationsQueryVariables>;
export const FileInfoDocument = gql`
    query FileInfo($fileId: ID!) {
  file(id: $fileId) {
    id
    url
    fileName
    downloadUrl
  }
}
    `;

/**
 * __useFileInfoQuery__
 *
 * To run a query within a React component, call `useFileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileInfoQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useFileInfoQuery(baseOptions: Apollo.QueryHookOptions<FileInfoQuery, FileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileInfoQuery, FileInfoQueryVariables>(FileInfoDocument, options);
      }
export function useFileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileInfoQuery, FileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileInfoQuery, FileInfoQueryVariables>(FileInfoDocument, options);
        }
export function useFileInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileInfoQuery, FileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileInfoQuery, FileInfoQueryVariables>(FileInfoDocument, options);
        }
export type FileInfoQueryHookResult = ReturnType<typeof useFileInfoQuery>;
export type FileInfoLazyQueryHookResult = ReturnType<typeof useFileInfoLazyQuery>;
export type FileInfoSuspenseQueryHookResult = ReturnType<typeof useFileInfoSuspenseQuery>;
export type FileInfoQueryResult = Apollo.QueryResult<FileInfoQuery, FileInfoQueryVariables>;
export const AccordionBlockItemBySubtypeDocument = gql`
    query AccordionBlockItemBySubtype($blockId: ID!, $subtype: RegulationType!) {
  accordionBlockItemBySubtype(blockId: $blockId, subtype: $subtype) {
    id
    index
    indexTitle
    orderIndex
    description
    createdAt
    updatedAt
    deletedAt
    subtype
    configJson
    lft
    rgt
    depth
    linkItem {
      id
      arguments
      routeNavigation
      routeType
      target
      url
    }
  }
}
    `;

/**
 * __useAccordionBlockItemBySubtypeQuery__
 *
 * To run a query within a React component, call `useAccordionBlockItemBySubtypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccordionBlockItemBySubtypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccordionBlockItemBySubtypeQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      subtype: // value for 'subtype'
 *   },
 * });
 */
export function useAccordionBlockItemBySubtypeQuery(baseOptions: Apollo.QueryHookOptions<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>(AccordionBlockItemBySubtypeDocument, options);
      }
export function useAccordionBlockItemBySubtypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>(AccordionBlockItemBySubtypeDocument, options);
        }
export function useAccordionBlockItemBySubtypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>(AccordionBlockItemBySubtypeDocument, options);
        }
export type AccordionBlockItemBySubtypeQueryHookResult = ReturnType<typeof useAccordionBlockItemBySubtypeQuery>;
export type AccordionBlockItemBySubtypeLazyQueryHookResult = ReturnType<typeof useAccordionBlockItemBySubtypeLazyQuery>;
export type AccordionBlockItemBySubtypeSuspenseQueryHookResult = ReturnType<typeof useAccordionBlockItemBySubtypeSuspenseQuery>;
export type AccordionBlockItemBySubtypeQueryResult = Apollo.QueryResult<AccordionBlockItemBySubtypeQuery, AccordionBlockItemBySubtypeQueryVariables>;
export const ValidateUserRequestDocument = gql`
    query ValidateUserRequest($validateUserRequestInput: ValidateUserRequestInput!) {
  validateUserRequest(validateUserRequestInput: $validateUserRequestInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    phoneCountryCode
    phoneNumber
    address
    hasRural
    status
    requestType
  }
}
    `;

/**
 * __useValidateUserRequestQuery__
 *
 * To run a query within a React component, call `useValidateUserRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateUserRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateUserRequestQuery({
 *   variables: {
 *      validateUserRequestInput: // value for 'validateUserRequestInput'
 *   },
 * });
 */
export function useValidateUserRequestQuery(baseOptions: Apollo.QueryHookOptions<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>(ValidateUserRequestDocument, options);
      }
export function useValidateUserRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>(ValidateUserRequestDocument, options);
        }
export function useValidateUserRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>(ValidateUserRequestDocument, options);
        }
export type ValidateUserRequestQueryHookResult = ReturnType<typeof useValidateUserRequestQuery>;
export type ValidateUserRequestLazyQueryHookResult = ReturnType<typeof useValidateUserRequestLazyQuery>;
export type ValidateUserRequestSuspenseQueryHookResult = ReturnType<typeof useValidateUserRequestSuspenseQuery>;
export type ValidateUserRequestQueryResult = Apollo.QueryResult<ValidateUserRequestQuery, ValidateUserRequestQueryVariables>;
export const CreateUserRequestDocument = gql`
    mutation CreateUserRequest($createUserRequestInput: CreateUserRequestInput!) {
  createUserRequest(createUserRequestInput: $createUserRequestInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    phoneCountryCode
    phoneNumber
    address
    hasRural
    status
    requestType
  }
}
    `;
export type CreateUserRequestMutationFn = Apollo.MutationFunction<CreateUserRequestMutation, CreateUserRequestMutationVariables>;

/**
 * __useCreateUserRequestMutation__
 *
 * To run a mutation, you first call `useCreateUserRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRequestMutation, { data, loading, error }] = useCreateUserRequestMutation({
 *   variables: {
 *      createUserRequestInput: // value for 'createUserRequestInput'
 *   },
 * });
 */
export function useCreateUserRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserRequestMutation, CreateUserRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserRequestMutation, CreateUserRequestMutationVariables>(CreateUserRequestDocument, options);
      }
export type CreateUserRequestMutationHookResult = ReturnType<typeof useCreateUserRequestMutation>;
export type CreateUserRequestMutationResult = Apollo.MutationResult<CreateUserRequestMutation>;
export type CreateUserRequestMutationOptions = Apollo.BaseMutationOptions<CreateUserRequestMutation, CreateUserRequestMutationVariables>;
export const CreatePartialUserRequestDocument = gql`
    mutation CreatePartialUserRequest($createPartialUserRequestInput: CreatePartialUserRequestInput!) {
  createPartialUserRequest(createPartialUserRequestInput: $createPartialUserRequestInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    phoneCountryCode
    phoneNumber
    address
    hasRural
    status
    requestType
  }
}
    `;
export type CreatePartialUserRequestMutationFn = Apollo.MutationFunction<CreatePartialUserRequestMutation, CreatePartialUserRequestMutationVariables>;

/**
 * __useCreatePartialUserRequestMutation__
 *
 * To run a mutation, you first call `useCreatePartialUserRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartialUserRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartialUserRequestMutation, { data, loading, error }] = useCreatePartialUserRequestMutation({
 *   variables: {
 *      createPartialUserRequestInput: // value for 'createPartialUserRequestInput'
 *   },
 * });
 */
export function useCreatePartialUserRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartialUserRequestMutation, CreatePartialUserRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartialUserRequestMutation, CreatePartialUserRequestMutationVariables>(CreatePartialUserRequestDocument, options);
      }
export type CreatePartialUserRequestMutationHookResult = ReturnType<typeof useCreatePartialUserRequestMutation>;
export type CreatePartialUserRequestMutationResult = Apollo.MutationResult<CreatePartialUserRequestMutation>;
export type CreatePartialUserRequestMutationOptions = Apollo.BaseMutationOptions<CreatePartialUserRequestMutation, CreatePartialUserRequestMutationVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries(orderBy: ASC) {
    id
    value: id
    text: name
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CitiesDocument = gql`
    query Cities($departmentId: ID!) {
  cities(departmentId: $departmentId, orderBy: ASC) {
    id
    value: id
    text: name
  }
}
    `;

/**
 * __useCitiesQuery__
 *
 * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useCitiesQuery(baseOptions: Apollo.QueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
      }
export function useCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
        }
export function useCitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
        }
export type CitiesQueryHookResult = ReturnType<typeof useCitiesQuery>;
export type CitiesLazyQueryHookResult = ReturnType<typeof useCitiesLazyQuery>;
export type CitiesSuspenseQueryHookResult = ReturnType<typeof useCitiesSuspenseQuery>;
export type CitiesQueryResult = Apollo.QueryResult<CitiesQuery, CitiesQueryVariables>;
export const DepartmentsDocument = gql`
    query Departments($countryId: ID!) {
  departments(countryId: $countryId, orderBy: ASC) {
    id
    value: id
    text: name
  }
}
    `;

/**
 * __useDepartmentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
      }
export function useDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
export function useDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
export type DepartmentsQueryHookResult = ReturnType<typeof useDepartmentsQuery>;
export type DepartmentsLazyQueryHookResult = ReturnType<typeof useDepartmentsLazyQuery>;
export type DepartmentsSuspenseQueryHookResult = ReturnType<typeof useDepartmentsSuspenseQuery>;
export type DepartmentsQueryResult = Apollo.QueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
export const CodeConfirmationDocument = gql`
    mutation CodeConfirmation($createInput: CodeConfirmationInput!) {
  codeConfirmation(createInput: $createInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    legalRepresentativeIdentificationType
    legalRepresentativeIdentificationNumber
    phoneCountryCode
    phoneNumber
    address
    hasRural
    status
    phoneVerification
    emailVerification
    type
    fullName
  }
}
    `;
export type CodeConfirmationMutationFn = Apollo.MutationFunction<CodeConfirmationMutation, CodeConfirmationMutationVariables>;

/**
 * __useCodeConfirmationMutation__
 *
 * To run a mutation, you first call `useCodeConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeConfirmationMutation, { data, loading, error }] = useCodeConfirmationMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCodeConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<CodeConfirmationMutation, CodeConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CodeConfirmationMutation, CodeConfirmationMutationVariables>(CodeConfirmationDocument, options);
      }
export type CodeConfirmationMutationHookResult = ReturnType<typeof useCodeConfirmationMutation>;
export type CodeConfirmationMutationResult = Apollo.MutationResult<CodeConfirmationMutation>;
export type CodeConfirmationMutationOptions = Apollo.BaseMutationOptions<CodeConfirmationMutation, CodeConfirmationMutationVariables>;
export const TransparencyDocument = gql`
    query Transparency($locations: [BlockLocation!]!, $subPage: SubPages) {
  subPageBlocks(locations: $locations, subPage: $subPage) {
    ... on PageTransparencyBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      hasLinkVideo
      transparencyContent
      image {
        id
        createdAt
        updatedAt
        deletedAt
        fileName
        fileExtension
        fileMode
        fileMongoId
        url
        __typename
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        previousVersion {
          id
          createdAt
          updatedAt
          deletedAt
          description
          orderIndex
          __typename
        }
        itemTitle
        itemDescription
        itemIcon {
          downloadUrl
          id
          createdAt
          updatedAt
          deletedAt
          fileName
          fileExtension
          fileMode
          fileMongoId
          url
          __typename
        }
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
      }
      linkVideo {
        id
        createdAt
        updatedAt
        deletedAt
        routeType
        routeNavigation
        target
        arguments
        url
        __typename
      }
      __typename
    }
    __typename
    ... on PageNewsletterBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      newsletterTitle
      newsletterDescription
      hasSearchbarNewsletter
      newsletterTags
      tagStyle
      global
      news {
        id
        createdAt
        updatedAt
        deletedAt
        title
        content
        date
        expiredDate
        summary
        newsStatus
        multimediaType
        alternativeText
        pageNewsletterBlockLink: link
        imageLink
        dateImages
        newsItemTags
      }
    }
    ... on PageSnsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      blockTitle
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageCabinetBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      cabinetTitle
      cabinetSubtitle
      cabinetSeeMoreAction
      cabinetSeeMoreActionLink
      pageCabinetBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        pageCabinetBlockItemDescription: description
        orderIndex
        cabinetName
        cabinetDescription
        cabinetImageLink
        cabinetOrder
        cabinetPhone
        cabinetEmail
        cabinetStatus
        alternativeText
        curriculumVitaeLink
      }
    }
    ... on PagePressroomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      PagePressroomBlockTitle: title
      subtitle
      hasSearchbar
    }
    ... on PageParticipateElementBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      pageParticipateElementBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        pageParticipateElementBlockItemDescription: description
        orderIndex
        participateElementTitle
      }
    }
    ... on PageParticipateDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      regulations {
        id
        createdAt
        updatedAt
        deletedAt
        title
        description
        date
        downloadText
        documentDate
        type
        regulationStatus
      }
    }
    ... on PageProcedureMainBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageProcedureFeedbackBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageInstitutionalProgramsTypesBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      pageInstitutionalProgramsTypesBlock: items {
        id
        createdAt
        updatedAt
        deletedAt
        pageInstitutionalProgramsTypesBlockDescription: description
        orderIndex
        title
        alternativeText
        programsType
      }
    }
    ... on PageCustomBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      content
    }
    ... on PageSubHeaderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      showDates
      subHeaderTitle
      subHeaderDescription
      subHeaderPlaceholder
      subHeaderSearchbar
    }
    ... on PageEventSliderBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      pageEventSliderBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        pageEventSliderBlockItemDescription: description
        orderIndex
        title
        seeMoreAction
        seeMoreLink
      }
    }
    ... on PagePqrsdfActionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PagePqrsdfConsultBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
    }
    ... on PageSubDownloadBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subDownloadTitle
      subDownloadDescription
      subDownloadPlaceholder
      subDownloadSearchbar
      pageSubDownloadBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        pageSubDownloadBlockItemDescription: description
        orderIndex
        name
      }
    }
    ... on PageRegulationsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      titleRegulation
      descriptionRegulation
      seeMoreRegulations
      seeMoreRegulationsLink
      regulations {
        id
        createdAt
        updatedAt
        deletedAt
        title
        description
        date
        downloadText
        documentDate
        type
        regulationStatus
      }
      pageRegulationsBlockItems: items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        itemName
        itemDescription
        itemType
      }
    }
    ... on PageEventsBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      eventTitle
      eventDescription
      hasScheduleInteractive
      hasSeeMore
      seeMoreLink
      seeMoreText
      global
      events {
        id
        createdAt
        updatedAt
        deletedAt
        eventItemTitle
        eventItemDescription
        summary
        seeMore
        link
        address
        latitude
        longitude
        descriptionPlace
        typeEvent
        hasRecurring
        hasShare
        shareLink
        startDate
        endDate
        phoneEvent
        emailEvent
        groupEvent
        paymentTypeEvent
        eventStatus
        alternativeText
        multimediaType
        dynamicView
        eventItemTags
      }
    }
    ... on PageSocialNetworksBlock {
      id
      createdAt
      updatedAt
      deletedAt
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      pageSocialNetworksBlockTitle: title
      seeMoreAction
      seeMoreLink
      leftItems {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        imageLink
        alternativeText
      }
      rightItems {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        socialNetworkType
        hasRightItem
        link
      }
    }
    ... on PageQuickAccessBar {
      id
      type
      createdAt
      updatedAt
      deletedAt
      description
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      blockTitle
      description
      color
      isCarrousel
      itemsPerView
      seeMoreTitle
      seeMoreLink
      items {
        id
        image {
          id
          url
          __typename
        }
        quickAccessName
        link
        linkItem {
          id
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
          __typename
        }
        __typename
      }
      __typename
    }
    ... on PageAccordionBlock {
      id
      createdAt
      updatedAt
      deletedAt
      blockTitle
      description
      publicDescription
      showTitle
      showDescription
      isDisabled
      canBeDisabled
      orderIndex
      location
      pageBlockStyle
      subPages
      type
      subtype
      items {
        id
        createdAt
        updatedAt
        deletedAt
        description
        orderIndex
        index
        indexTitle
        subtype
        configJson
        lft
        rgt
        depth
        linkItem {
          id
          createdAt
          updatedAt
          deletedAt
          routeType
          routeNavigation
          target
          arguments
          url
          dynamicPageSlugs {
            id
            slug
          }
        }
        schema {
          id
          createdAt
          updatedAt
          deletedAt
          name
          description
          contentType
          isActive
          fields {
            id
            createdAt
            updatedAt
            deletedAt
            fieldName
            fieldLabel
            fieldType
            isRequired
            orderIndex
            options
            validationRules
            defaultValue
            isActive
            isGroup
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTransparencyQuery__
 *
 * To run a query within a React component, call `useTransparencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransparencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransparencyQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      subPage: // value for 'subPage'
 *   },
 * });
 */
export function useTransparencyQuery(baseOptions: Apollo.QueryHookOptions<TransparencyQuery, TransparencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransparencyQuery, TransparencyQueryVariables>(TransparencyDocument, options);
      }
export function useTransparencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransparencyQuery, TransparencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransparencyQuery, TransparencyQueryVariables>(TransparencyDocument, options);
        }
export function useTransparencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransparencyQuery, TransparencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransparencyQuery, TransparencyQueryVariables>(TransparencyDocument, options);
        }
export type TransparencyQueryHookResult = ReturnType<typeof useTransparencyQuery>;
export type TransparencyLazyQueryHookResult = ReturnType<typeof useTransparencyLazyQuery>;
export type TransparencySuspenseQueryHookResult = ReturnType<typeof useTransparencySuspenseQuery>;
export type TransparencyQueryResult = Apollo.QueryResult<TransparencyQuery, TransparencyQueryVariables>;
export const AllPageBlockEnumDocument = gql`
    query AllPageBlockEnum {
  findPageBlockEnum {
    block
    title
  }
}
    `;

/**
 * __useAllPageBlockEnumQuery__
 *
 * To run a query within a React component, call `useAllPageBlockEnumQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPageBlockEnumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPageBlockEnumQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPageBlockEnumQuery(baseOptions?: Apollo.QueryHookOptions<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>(AllPageBlockEnumDocument, options);
      }
export function useAllPageBlockEnumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>(AllPageBlockEnumDocument, options);
        }
export function useAllPageBlockEnumSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>(AllPageBlockEnumDocument, options);
        }
export type AllPageBlockEnumQueryHookResult = ReturnType<typeof useAllPageBlockEnumQuery>;
export type AllPageBlockEnumLazyQueryHookResult = ReturnType<typeof useAllPageBlockEnumLazyQuery>;
export type AllPageBlockEnumSuspenseQueryHookResult = ReturnType<typeof useAllPageBlockEnumSuspenseQuery>;
export type AllPageBlockEnumQueryResult = Apollo.QueryResult<AllPageBlockEnumQuery, AllPageBlockEnumQueryVariables>;
export const FindPageAllBlocksEnumDocument = gql`
    query FindPageAllBlocksEnum($blockLocations: [BlockLocation!]) {
  findPageAllBlocksEnum(blockLocations: $blockLocations) {
    block
    title
  }
}
    `;

/**
 * __useFindPageAllBlocksEnumQuery__
 *
 * To run a query within a React component, call `useFindPageAllBlocksEnumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPageAllBlocksEnumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPageAllBlocksEnumQuery({
 *   variables: {
 *      blockLocations: // value for 'blockLocations'
 *   },
 * });
 */
export function useFindPageAllBlocksEnumQuery(baseOptions?: Apollo.QueryHookOptions<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>(FindPageAllBlocksEnumDocument, options);
      }
export function useFindPageAllBlocksEnumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>(FindPageAllBlocksEnumDocument, options);
        }
export function useFindPageAllBlocksEnumSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>(FindPageAllBlocksEnumDocument, options);
        }
export type FindPageAllBlocksEnumQueryHookResult = ReturnType<typeof useFindPageAllBlocksEnumQuery>;
export type FindPageAllBlocksEnumLazyQueryHookResult = ReturnType<typeof useFindPageAllBlocksEnumLazyQuery>;
export type FindPageAllBlocksEnumSuspenseQueryHookResult = ReturnType<typeof useFindPageAllBlocksEnumSuspenseQuery>;
export type FindPageAllBlocksEnumQueryResult = Apollo.QueryResult<FindPageAllBlocksEnumQuery, FindPageAllBlocksEnumQueryVariables>;
export const ResendCodeConfirmationDocument = gql`
    mutation ResendCodeConfirmation($resendCodeConfirmationInput: ResendCodeConfirmationInput!) {
  resendCodeConfirmation(resendCodeConfirmationInput: $resendCodeConfirmationInput)
}
    `;
export type ResendCodeConfirmationMutationFn = Apollo.MutationFunction<ResendCodeConfirmationMutation, ResendCodeConfirmationMutationVariables>;

/**
 * __useResendCodeConfirmationMutation__
 *
 * To run a mutation, you first call `useResendCodeConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCodeConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCodeConfirmationMutation, { data, loading, error }] = useResendCodeConfirmationMutation({
 *   variables: {
 *      resendCodeConfirmationInput: // value for 'resendCodeConfirmationInput'
 *   },
 * });
 */
export function useResendCodeConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<ResendCodeConfirmationMutation, ResendCodeConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendCodeConfirmationMutation, ResendCodeConfirmationMutationVariables>(ResendCodeConfirmationDocument, options);
      }
export type ResendCodeConfirmationMutationHookResult = ReturnType<typeof useResendCodeConfirmationMutation>;
export type ResendCodeConfirmationMutationResult = Apollo.MutationResult<ResendCodeConfirmationMutation>;
export type ResendCodeConfirmationMutationOptions = Apollo.BaseMutationOptions<ResendCodeConfirmationMutation, ResendCodeConfirmationMutationVariables>;
export const ValidateCodeUserRequestDocument = gql`
    mutation ValidateCodeUserRequest($validateUserCodeRequestInput: ValidateUserCodeRequestInput!) {
  validateCodeUserRequest(validateUserCodeRequestInput: $validateUserCodeRequestInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    legalRepresentativeIdentificationType
    legalRepresentativeIdentificationNumber
    phoneCountryCode
    phoneNumber
    address
    hasRural
    status
    phoneVerification
    emailVerification
    type
    passwordStatus
    temporalPassword
    credentialsExpirationDate
    loginAttempts
    attemptsCycles
    lastFailedAttemptDate
    permissions
    fullName
    hasExpiredCredentials
  }
}
    `;
export type ValidateCodeUserRequestMutationFn = Apollo.MutationFunction<ValidateCodeUserRequestMutation, ValidateCodeUserRequestMutationVariables>;

/**
 * __useValidateCodeUserRequestMutation__
 *
 * To run a mutation, you first call `useValidateCodeUserRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCodeUserRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCodeUserRequestMutation, { data, loading, error }] = useValidateCodeUserRequestMutation({
 *   variables: {
 *      validateUserCodeRequestInput: // value for 'validateUserCodeRequestInput'
 *   },
 * });
 */
export function useValidateCodeUserRequestMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCodeUserRequestMutation, ValidateCodeUserRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCodeUserRequestMutation, ValidateCodeUserRequestMutationVariables>(ValidateCodeUserRequestDocument, options);
      }
export type ValidateCodeUserRequestMutationHookResult = ReturnType<typeof useValidateCodeUserRequestMutation>;
export type ValidateCodeUserRequestMutationResult = Apollo.MutationResult<ValidateCodeUserRequestMutation>;
export type ValidateCodeUserRequestMutationOptions = Apollo.BaseMutationOptions<ValidateCodeUserRequestMutation, ValidateCodeUserRequestMutationVariables>;
export const ResendConfirmationCodeDocument = gql`
    mutation ResendConfirmationCode($resendConfirmationCodeInput: ResendConfirmationCodeInput!) {
  resendConfirmationCode(resendConfirmationCodeInput: $resendConfirmationCodeInput) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    middleName
    lastName
    secondSurname
    email
    identificationType
    identificationNumber
    dateIssue
    phoneCountryCode
    phoneNumber
    address
    hasRural
    status
    requestType
  }
}
    `;
export type ResendConfirmationCodeMutationFn = Apollo.MutationFunction<ResendConfirmationCodeMutation, ResendConfirmationCodeMutationVariables>;

/**
 * __useResendConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useResendConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmationCodeMutation, { data, loading, error }] = useResendConfirmationCodeMutation({
 *   variables: {
 *      resendConfirmationCodeInput: // value for 'resendConfirmationCodeInput'
 *   },
 * });
 */
export function useResendConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResendConfirmationCodeMutation, ResendConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendConfirmationCodeMutation, ResendConfirmationCodeMutationVariables>(ResendConfirmationCodeDocument, options);
      }
export type ResendConfirmationCodeMutationHookResult = ReturnType<typeof useResendConfirmationCodeMutation>;
export type ResendConfirmationCodeMutationResult = Apollo.MutationResult<ResendConfirmationCodeMutation>;
export type ResendConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<ResendConfirmationCodeMutation, ResendConfirmationCodeMutationVariables>;
export const PageBlockSimpleDocument = gql`
    query PageBlockSimple($pageBlockSimpleId: ID!) {
  pageBlockSimple(id: $pageBlockSimpleId) {
    blockTitle
    type
  }
}
    `;

/**
 * __usePageBlockSimpleQuery__
 *
 * To run a query within a React component, call `usePageBlockSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBlockSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBlockSimpleQuery({
 *   variables: {
 *      pageBlockSimpleId: // value for 'pageBlockSimpleId'
 *   },
 * });
 */
export function usePageBlockSimpleQuery(baseOptions: Apollo.QueryHookOptions<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>(PageBlockSimpleDocument, options);
      }
export function usePageBlockSimpleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>(PageBlockSimpleDocument, options);
        }
export function usePageBlockSimpleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>(PageBlockSimpleDocument, options);
        }
export type PageBlockSimpleQueryHookResult = ReturnType<typeof usePageBlockSimpleQuery>;
export type PageBlockSimpleLazyQueryHookResult = ReturnType<typeof usePageBlockSimpleLazyQuery>;
export type PageBlockSimpleSuspenseQueryHookResult = ReturnType<typeof usePageBlockSimpleSuspenseQuery>;
export type PageBlockSimpleQueryResult = Apollo.QueryResult<PageBlockSimpleQuery, PageBlockSimpleQueryVariables>;
export const CheckSlugAvailabilityDocument = gql`
    query CheckSlugAvailability($input: CheckSlugAvailabilityInput!) {
  checkSlugAvailability(input: $input) {
    isAvailable
    slug
    conflict {
      contentType
      contentId
      contentTitle
      language
      createdAt
      dependency
    }
  }
}
    `;

/**
 * __useCheckSlugAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckSlugAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSlugAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSlugAvailabilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSlugAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>(CheckSlugAvailabilityDocument, options);
      }
export function useCheckSlugAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>(CheckSlugAvailabilityDocument, options);
        }
export function useCheckSlugAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>(CheckSlugAvailabilityDocument, options);
        }
export type CheckSlugAvailabilityQueryHookResult = ReturnType<typeof useCheckSlugAvailabilityQuery>;
export type CheckSlugAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckSlugAvailabilityLazyQuery>;
export type CheckSlugAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCheckSlugAvailabilitySuspenseQuery>;
export type CheckSlugAvailabilityQueryResult = Apollo.QueryResult<CheckSlugAvailabilityQuery, CheckSlugAvailabilityQueryVariables>;
export const GetSearchBlockDetailDocument = gql`
    query GetSearchBlockDetail($pageBlockId: ID!) {
  pageBlock(id: $pageBlockId) {
    ... on PageSearchBlock {
      id
      orderIndex
      blockTitle
      pageBlockStyle
      type
      description
      isDisabled
      createdAt
      updatedAt
      placeholder
      canBeDisabled
    }
  }
}
    `;

/**
 * __useGetSearchBlockDetailQuery__
 *
 * To run a query within a React component, call `useGetSearchBlockDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchBlockDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchBlockDetailQuery({
 *   variables: {
 *      pageBlockId: // value for 'pageBlockId'
 *   },
 * });
 */
export function useGetSearchBlockDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>(GetSearchBlockDetailDocument, options);
      }
export function useGetSearchBlockDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>(GetSearchBlockDetailDocument, options);
        }
export function useGetSearchBlockDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>(GetSearchBlockDetailDocument, options);
        }
export type GetSearchBlockDetailQueryHookResult = ReturnType<typeof useGetSearchBlockDetailQuery>;
export type GetSearchBlockDetailLazyQueryHookResult = ReturnType<typeof useGetSearchBlockDetailLazyQuery>;
export type GetSearchBlockDetailSuspenseQueryHookResult = ReturnType<typeof useGetSearchBlockDetailSuspenseQuery>;
export type GetSearchBlockDetailQueryResult = Apollo.QueryResult<GetSearchBlockDetailQuery, GetSearchBlockDetailQueryVariables>;
export const UpdateSearchBlockDocument = gql`
    mutation UpdateSearchBlock($input: UpdatePageBlockInputUnion!) {
  updatePageBlock(input: $input) {
    ... on PageSearchBlock {
      id
    }
  }
}
    `;
export type UpdateSearchBlockMutationFn = Apollo.MutationFunction<UpdateSearchBlockMutation, UpdateSearchBlockMutationVariables>;

/**
 * __useUpdateSearchBlockMutation__
 *
 * To run a mutation, you first call `useUpdateSearchBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchBlockMutation, { data, loading, error }] = useUpdateSearchBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSearchBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSearchBlockMutation, UpdateSearchBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSearchBlockMutation, UpdateSearchBlockMutationVariables>(UpdateSearchBlockDocument, options);
      }
export type UpdateSearchBlockMutationHookResult = ReturnType<typeof useUpdateSearchBlockMutation>;
export type UpdateSearchBlockMutationResult = Apollo.MutationResult<UpdateSearchBlockMutation>;
export type UpdateSearchBlockMutationOptions = Apollo.BaseMutationOptions<UpdateSearchBlockMutation, UpdateSearchBlockMutationVariables>;
export const SearchContentsDocument = gql`
    query SearchContents($pagination: Pagination, $where: FindContentSearchWhere, $includePagination: Boolean!) {
  contents(pagination: $pagination, where: $where) {
    id
    title
    description
    publicationDate @include(if: $includePagination)
    dependency @include(if: $includePagination) {
      name
      id
    }
    type
    status
    slug
  }
  paginationContents(pagination: $pagination, where: $where) @include(if: $includePagination) {
    total
    count
    limit
    page
    pageCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useSearchContentsQuery__
 *
 * To run a query within a React component, call `useSearchContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      includePagination: // value for 'includePagination'
 *   },
 * });
 */
export function useSearchContentsQuery(baseOptions: Apollo.QueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, options);
      }
export function useSearchContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, options);
        }
export function useSearchContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, options);
        }
export type SearchContentsQueryHookResult = ReturnType<typeof useSearchContentsQuery>;
export type SearchContentsLazyQueryHookResult = ReturnType<typeof useSearchContentsLazyQuery>;
export type SearchContentsSuspenseQueryHookResult = ReturnType<typeof useSearchContentsSuspenseQuery>;
export type SearchContentsQueryResult = Apollo.QueryResult<SearchContentsQuery, SearchContentsQueryVariables>;
export const UpdatePageVersionDocument = gql`
    mutation UpdatePageVersion($updateInput: UpdatePageVersionInput!) {
  updatePageVersion(updateInput: $updateInput) {
    state
    id
    description
  }
}
    `;
export type UpdatePageVersionMutationFn = Apollo.MutationFunction<UpdatePageVersionMutation, UpdatePageVersionMutationVariables>;

/**
 * __useUpdatePageVersionMutation__
 *
 * To run a mutation, you first call `useUpdatePageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageVersionMutation, { data, loading, error }] = useUpdatePageVersionMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdatePageVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageVersionMutation, UpdatePageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageVersionMutation, UpdatePageVersionMutationVariables>(UpdatePageVersionDocument, options);
      }
export type UpdatePageVersionMutationHookResult = ReturnType<typeof useUpdatePageVersionMutation>;
export type UpdatePageVersionMutationResult = Apollo.MutationResult<UpdatePageVersionMutation>;
export type UpdatePageVersionMutationOptions = Apollo.BaseMutationOptions<UpdatePageVersionMutation, UpdatePageVersionMutationVariables>;
export const RemovePageVersionDocument = gql`
    mutation RemovePageVersion($removePageVersionId: ID!) {
  removePageVersion(id: $removePageVersionId) {
    id
  }
}
    `;
export type RemovePageVersionMutationFn = Apollo.MutationFunction<RemovePageVersionMutation, RemovePageVersionMutationVariables>;

/**
 * __useRemovePageVersionMutation__
 *
 * To run a mutation, you first call `useRemovePageVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageVersionMutation, { data, loading, error }] = useRemovePageVersionMutation({
 *   variables: {
 *      removePageVersionId: // value for 'removePageVersionId'
 *   },
 * });
 */
export function useRemovePageVersionMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageVersionMutation, RemovePageVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageVersionMutation, RemovePageVersionMutationVariables>(RemovePageVersionDocument, options);
      }
export type RemovePageVersionMutationHookResult = ReturnType<typeof useRemovePageVersionMutation>;
export type RemovePageVersionMutationResult = Apollo.MutationResult<RemovePageVersionMutation>;
export type RemovePageVersionMutationOptions = Apollo.BaseMutationOptions<RemovePageVersionMutation, RemovePageVersionMutationVariables>;
export const PageVersionsAdminDocument = gql`
    query PageVersionsAdmin($pagination: Pagination, $orderBy: [FindPageVersionsOrderBy!], $where: FindPageVersionsWhere) {
  pageVersions(pagination: $pagination, orderBy: $orderBy, where: $where) {
    id
    createdAt
    updatedAt
    deletedAt
    description
    state
    theme
    consecutive
    user {
      fullName
    }
  }
  pageVersionsCount(pagination: $pagination, orderBy: $orderBy, where: $where) {
    itemsPerPage
    currentPage
    totalItems
    totalPages
  }
}
    `;

/**
 * __usePageVersionsAdminQuery__
 *
 * To run a query within a React component, call `usePageVersionsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageVersionsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageVersionsAdminQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePageVersionsAdminQuery(baseOptions?: Apollo.QueryHookOptions<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>(PageVersionsAdminDocument, options);
      }
export function usePageVersionsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>(PageVersionsAdminDocument, options);
        }
export function usePageVersionsAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>(PageVersionsAdminDocument, options);
        }
export type PageVersionsAdminQueryHookResult = ReturnType<typeof usePageVersionsAdminQuery>;
export type PageVersionsAdminLazyQueryHookResult = ReturnType<typeof usePageVersionsAdminLazyQuery>;
export type PageVersionsAdminSuspenseQueryHookResult = ReturnType<typeof usePageVersionsAdminSuspenseQuery>;
export type PageVersionsAdminQueryResult = Apollo.QueryResult<PageVersionsAdminQuery, PageVersionsAdminQueryVariables>;
export const ActiveVersionDocument = gql`
    query ActiveVersion {
  version {
    id
    description
    state
    theme
    consecutive
  }
}
    `;

/**
 * __useActiveVersionQuery__
 *
 * To run a query within a React component, call `useActiveVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveVersionQuery(baseOptions?: Apollo.QueryHookOptions<ActiveVersionQuery, ActiveVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveVersionQuery, ActiveVersionQueryVariables>(ActiveVersionDocument, options);
      }
export function useActiveVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveVersionQuery, ActiveVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveVersionQuery, ActiveVersionQueryVariables>(ActiveVersionDocument, options);
        }
export function useActiveVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveVersionQuery, ActiveVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveVersionQuery, ActiveVersionQueryVariables>(ActiveVersionDocument, options);
        }
export type ActiveVersionQueryHookResult = ReturnType<typeof useActiveVersionQuery>;
export type ActiveVersionLazyQueryHookResult = ReturnType<typeof useActiveVersionLazyQuery>;
export type ActiveVersionSuspenseQueryHookResult = ReturnType<typeof useActiveVersionSuspenseQuery>;
export type ActiveVersionQueryResult = Apollo.QueryResult<ActiveVersionQuery, ActiveVersionQueryVariables>;
export const ProcedureByIdDocument = gql`
    query ProcedureById($procedureId: ID!) {
  procedure(id: $procedureId) {
    action
    updatedAt
    publicationDate
    procedureStatus
    procedureItemTags
    procedureDescription
    procedureTypes
    name
    multimediaType
    modality
    linkItem {
      url
      updatedAt
      target
      routeType
      routeNavigation
      id
      deletedAt
      createdAt
      arguments
    }
    id
    govcoLink {
      url
      updatedAt
      target
      routeType
      routeNavigation
      id
      deletedAt
      createdAt
      arguments
    }
    linkVideo {
      url
      target
      routeType
      routeNavigation
      id
      arguments
    }
    govcoImage {
      url
      updatedAt
      id
      fileName
      fileMongoId
      fileMode
      fileExtension
      deletedAt
      createdAt
    }
    gocvoLogoName
    estimatedDuration
    duration
    deletedAt
    date
    createdAt
    cost
    alternativeText
    actionLink
    processDefinitionId
    showGovcoButton
    showProcedureButton
  }
}
    `;

/**
 * __useProcedureByIdQuery__
 *
 * To run a query within a React component, call `useProcedureByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedureByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedureByIdQuery({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useProcedureByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcedureByIdQuery, ProcedureByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcedureByIdQuery, ProcedureByIdQueryVariables>(ProcedureByIdDocument, options);
      }
export function useProcedureByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcedureByIdQuery, ProcedureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcedureByIdQuery, ProcedureByIdQueryVariables>(ProcedureByIdDocument, options);
        }
export function useProcedureByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcedureByIdQuery, ProcedureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcedureByIdQuery, ProcedureByIdQueryVariables>(ProcedureByIdDocument, options);
        }
export type ProcedureByIdQueryHookResult = ReturnType<typeof useProcedureByIdQuery>;
export type ProcedureByIdLazyQueryHookResult = ReturnType<typeof useProcedureByIdLazyQuery>;
export type ProcedureByIdSuspenseQueryHookResult = ReturnType<typeof useProcedureByIdSuspenseQuery>;
export type ProcedureByIdQueryResult = Apollo.QueryResult<ProcedureByIdQuery, ProcedureByIdQueryVariables>;
export const UpdateProcedureStatusMutationDocument = gql`
    mutation UpdateProcedureStatusMutation($updateInput: UpdateProcedureInput!) {
  updateProcedure(updateInput: $updateInput) {
    procedureStatus
    id
  }
}
    `;
export type UpdateProcedureStatusMutationMutationFn = Apollo.MutationFunction<UpdateProcedureStatusMutationMutation, UpdateProcedureStatusMutationMutationVariables>;

/**
 * __useUpdateProcedureStatusMutationMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureStatusMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureStatusMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureStatusMutationMutation, { data, loading, error }] = useUpdateProcedureStatusMutationMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateProcedureStatusMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureStatusMutationMutation, UpdateProcedureStatusMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureStatusMutationMutation, UpdateProcedureStatusMutationMutationVariables>(UpdateProcedureStatusMutationDocument, options);
      }
export type UpdateProcedureStatusMutationMutationHookResult = ReturnType<typeof useUpdateProcedureStatusMutationMutation>;
export type UpdateProcedureStatusMutationMutationResult = Apollo.MutationResult<UpdateProcedureStatusMutationMutation>;
export type UpdateProcedureStatusMutationMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureStatusMutationMutation, UpdateProcedureStatusMutationMutationVariables>;
export const UpdateProcedureStatusToDraftDocument = gql`
    mutation UpdateProcedureStatusToDraft($updateProcedureStatusToDraft: UpdateProcedureStatusToDraft!) {
  updateProcedureStatusToDraft(updateProcedureStatusToDraft: $updateProcedureStatusToDraft)
}
    `;
export type UpdateProcedureStatusToDraftMutationFn = Apollo.MutationFunction<UpdateProcedureStatusToDraftMutation, UpdateProcedureStatusToDraftMutationVariables>;

/**
 * __useUpdateProcedureStatusToDraftMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureStatusToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureStatusToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureStatusToDraftMutation, { data, loading, error }] = useUpdateProcedureStatusToDraftMutation({
 *   variables: {
 *      updateProcedureStatusToDraft: // value for 'updateProcedureStatusToDraft'
 *   },
 * });
 */
export function useUpdateProcedureStatusToDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureStatusToDraftMutation, UpdateProcedureStatusToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureStatusToDraftMutation, UpdateProcedureStatusToDraftMutationVariables>(UpdateProcedureStatusToDraftDocument, options);
      }
export type UpdateProcedureStatusToDraftMutationHookResult = ReturnType<typeof useUpdateProcedureStatusToDraftMutation>;
export type UpdateProcedureStatusToDraftMutationResult = Apollo.MutationResult<UpdateProcedureStatusToDraftMutation>;
export type UpdateProcedureStatusToDraftMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureStatusToDraftMutation, UpdateProcedureStatusToDraftMutationVariables>;
export const TopBarDocument = gql`
    query TopBar {
  header {
    ... on PageHeaderBar {
      id
      description
      createdAt
      updatedAt
      isDisabled
    }
  }
}
    `;

/**
 * __useTopBarQuery__
 *
 * To run a query within a React component, call `useTopBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopBarQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopBarQuery(baseOptions?: Apollo.QueryHookOptions<TopBarQuery, TopBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopBarQuery, TopBarQueryVariables>(TopBarDocument, options);
      }
export function useTopBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopBarQuery, TopBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopBarQuery, TopBarQueryVariables>(TopBarDocument, options);
        }
export function useTopBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopBarQuery, TopBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopBarQuery, TopBarQueryVariables>(TopBarDocument, options);
        }
export type TopBarQueryHookResult = ReturnType<typeof useTopBarQuery>;
export type TopBarLazyQueryHookResult = ReturnType<typeof useTopBarLazyQuery>;
export type TopBarSuspenseQueryHookResult = ReturnType<typeof useTopBarSuspenseQuery>;
export type TopBarQueryResult = Apollo.QueryResult<TopBarQuery, TopBarQueryVariables>;